
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fq00b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3f1d6626b9f8bcf0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $5BRby = parcelRequire("5BRby");

var $4PFBO = parcelRequire("4PFBO");

var $dUam2 = parcelRequire("dUam2");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");
const $3f1d6626b9f8bcf0$var$JiraBusinessFormApp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-form-submit-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "business"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dUam2.FormSubmissionContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PFBO.FormSubmissionRoot), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "core"
    }))));
var $3f1d6626b9f8bcf0$export$2e2bcd8739ae039 = $3f1d6626b9f8bcf0$var$JiraBusinessFormApp;

});
parcelRegister("4PFBO", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionRoot", () => $23aab1d16b07d563$export$4ae1a0970466e244);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7e8pf = parcelRequire("7e8pf");

var $hJYsP = parcelRequire("hJYsP");

var $4G5xU = parcelRequire("4G5xU");

var $bcWyL = parcelRequire("bcWyL");

var $6HWvN = parcelRequire("6HWvN");

var $eRpjy = parcelRequire("eRpjy");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $lB25E = parcelRequire("lB25E");

var $aeIT6 = parcelRequire("aeIT6");

var $jK1pm = parcelRequire("jK1pm");

var $apShl = parcelRequire("apShl");

var $hRKQW = parcelRequire("hRKQW");

var $33ieR = parcelRequire("33ieR");

var $mQI4u = parcelRequire("mQI4u");

var $k8UPO = parcelRequire("k8UPO");

var $9jk0K = parcelRequire("9jk0K");

var $i3wcx = parcelRequire("i3wcx");

var $82V0G = parcelRequire("82V0G");

var $43p7l = parcelRequire("43p7l");


var $aFKy5 = parcelRequire("aFKy5");

var $fSjXT = parcelRequire("fSjXT");

var $4G6m0 = parcelRequire("4G6m0");
const $23aab1d16b07d563$var$FormContent = /*#__PURE__*/ (0, $eUqFw.memo)(// TODO remove eslint disable as part of FF FD-41661 cleanup
// eslint-disable-next-line complexity
({ formSubmissionLoading: formSubmissionLoading, formSubmissionData: formSubmissionData, formSubmissionError: formSubmissionError })=>{
    const { data: project } = (0, $aeIT6.useProject)();
    const canCreateIssues = Boolean(project?.permissions.createIssues) || formSubmissionData?.formWithFieldData?.accessLevel === (0, $33ieR.FormAccessLevelTypes).OPEN;
    const hasError = formSubmissionError !== undefined; // if form's issue type has been deleted
    if (!formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData?.formWithFieldData?.issueType && !hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.IssueTypeDeletedView), null);
     // if form's issue type has been disassociated from the project
    if (!formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData.fieldMetaData && canCreateIssues && formSubmissionData?.formWithFieldData?.issueType && !hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.IssueTypeNotAssociatedView), {
        issueTypeName: formSubmissionData?.formWithFieldData?.issueType?.name ?? ''
    });
     // if user has no permission to create issues
    if (!canCreateIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.NoPermissionView), null);
     // if issue cannot be created because there are missing supported required fields
    if (formSubmissionData?.formSubmissionValidationData?.hasMissingSupportedRequiredFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.FormMissingSupportedRequiredFieldsView), null);
     // if issue cannot be created because there are missing unsupported required fields
    if (formSubmissionData?.formSubmissionValidationData?.hasUnsupportedRequiredFields) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.FormContainsUnsupportedRequiredFieldsView), null);
     // generic screen for any other kind of error
    if (hasError || formSubmissionData == null || formSubmissionData.formWithFieldData == null || formSubmissionData.fieldMetaData == null || formSubmissionData?.formWithFieldData?.enabled === false || formSubmissionData?.formSubmissionValidationData?.isFormSubmissionValid === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.FormUnavailableView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43p7l.MediaPermissionsPreloader), {
        projectId: String(formSubmissionData.formWithFieldData.projectId),
        formId: formSubmissionData.formWithFieldData.formId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fSjXT.FillInView), null));
});
const $23aab1d16b07d563$export$2f8578dc462e47a9 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { featureView: featureView } = (0, $i3wcx.useJWMFormsFeatures)();
    const pageHeading = formatMessage((0, $4G6m0.default).pageHeading);
    const { data: formSubmissionData, loading: formSubmissionLoading, error: formSubmissionError } = (0, $82V0G.useFormSubmission)();
    const hasError = formSubmissionError !== undefined;
    const loading = formSubmissionLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "form-submission"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "form-submission",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jk0K.FormBackground), {
        bannerColor: formSubmissionData?.formWithFieldData?.bannerColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mQI4u.Card), {
        minHeight: (0, $0cdd2a7b0e5b40c4$export$aa78f5e84beba3ce)
    }, !hasError && loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23aab1d16b07d563$var$Placeholder, {
        id: "form-content",
        "data-testid": "business-form.ui.form-submission.place-holder"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23aab1d16b07d563$var$FormContent, {
        formSubmissionLoading: formSubmissionLoading,
        formSubmissionData: formSubmissionData,
        formSubmissionError: formSubmissionError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hRKQW.VIEW_FORM_SUBMISSION_EXPERIENCE)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcWyL.PerformanceAnalytics), {
        view: featureView,
        loading: loading
    }), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRpjy.JWMSpaStatePageReady), null));
});
const $23aab1d16b07d563$export$4ae1a0970466e244 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { data: project } = (0, $aeIT6.useProject)();
    const canCreateOrModifyForm = Boolean(project?.permissions.administerProject);
    const [{ query: query }] = (0, $lB25E.useRouter)();
    const shouldShowContactAdminBanner = !canCreateOrModifyForm && query[(0, $hRKQW.URL_PARAMS).FROM] === (0, $hRKQW.URL_PARAMS).DIRECTORY;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "form-submission-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormSubmission",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, shouldShowContactAdminBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFKy5.ContactAdminBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        shouldAddPadding: false,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23aab1d16b07d563$export$2f8578dc462e47a9, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23aab1d16b07d563$var$Placeholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ip3fh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kar7l = parcelRequire("kar7l");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$export$b16f75f2e0c3c029 = 360;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$b16f75f2e0c3c029);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $kEDjj.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$b16f75f2e0c3c029,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $1yZQx.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            (0, $1ybV0.ff)('jwm-sidebar-resizer-limit_4m1km') ? $b41642a7c0ef06fe$var$sidebarStyles : $b41642a7c0ef06fe$var$oldSidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$oldSidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card'
});
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});


parcelRegister("bcWyL", function(module, exports) {

$parcel$export(module.exports, "PerformanceAnalytics", () => $44db5e6179f04fcc$export$ec3c3b39c046a620);

var $eUqFw = parcelRequire("eUqFw");


var $axxSm = parcelRequire("axxSm");

var $apShl = parcelRequire("apShl");

var $bDGTl = parcelRequire("bDGTl");

var $6HWvN = parcelRequire("6HWvN");
const $44db5e6179f04fcc$export$ec3c3b39c046a620 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
    const loadingRef = (0, $eUqFw.useRef)(loading);
    loadingRef.current = loading;
    if (loading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "performance-analytics-loading"
    });
    const scrollElement = false ? null : document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597));
    const product = view.startsWith('software') ? 'jsw' : 'jwm';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.PageLoadMetrics), {
        view: view,
        attributes: attributes,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDGTl.FirstInteractionMetric), {
        view: view,
        product: product
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axxSm.default), {
        viewId: `${product}.${view}`,
        scrollElement: scrollElement,
        itemsCount: itemsCount,
        attributes: attributes
    }));
});

});
parcelRegister("axxSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed3b6e522e859da6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

const $ed3b6e522e859da6$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $083bae7fff0f430d$export$9d3e6d8a99023567));
const $ed3b6e522e859da6$export$46962be62755f053 = /*#__PURE__*/ (0, $eUqFw.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $083bae7fff0f430d$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const samplingCount = (0, $eUqFw.useRef)(0);
    const frames = (0, $eUqFw.useRef)(0);
    const rafId = (0, $eUqFw.useRef)(null);
    const start = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const container = scrollElement ?? document;
        const hasScrollCapture = true;
        const tick = ()=>{
            if (frames.current < (0, $083bae7fff0f430d$export$299249b1dad3b14a)) {
                frames.current += 1;
                rafId.current = requestAnimationFrame(tick);
            } else {
                const stopTime = performance.now();
                const elapsedMs = stopTime - start.current;
                const fps = $ed3b6e522e859da6$export$df7175b69b5630dd(frames.current, elapsedMs);
                const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                frames.current = 0;
                const attr = {
                    ...attributes || {},
                    itemsCount: itemsCount,
                    avgFrameDuration: avgFrameDuration,
                    fps: fps
                };
                (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
            }
        };
        const handleOnScroll = ()=>{
            samplingCount.current += 1;
            if (samplingCount.current !== samplingRate) return;
            samplingCount.current = 0;
            // start counting frames
            start.current = performance.now();
            tick();
        };
        container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
            if (rafId.current) cancelAnimationFrame(rafId.current);
        };
    }, [
        scrollElement,
        createAnalyticsEvent,
        itemsCount,
        samplingRate,
        viewId,
        attributes
    ]);
    return null;
});
var $ed3b6e522e859da6$export$2e2bcd8739ae039 = $ed3b6e522e859da6$export$46962be62755f053;

});
// how often do we measure, e.g. every 100th scroll
const $083bae7fff0f430d$export$71d024136796e395 = 100;
const $083bae7fff0f430d$export$299249b1dad3b14a = 20;
const $083bae7fff0f430d$export$9d3e6d8a99023567 = 60;


parcelRegister("bDGTl", function(module, exports) {

$parcel$export(module.exports, "FirstInteractionMetric", () => $f0bbcfda9127146c$export$70b569bf2edd0b7f);

var $eUqFw = parcelRequire("eUqFw");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f0bbcfda9127146c$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const container = document.getElementById((0, $d02be44255a1478f$export$e5e75ff4daca6597)) ?? document;
        const hasScrollCapture = true;
        const startTime = performance.now();
        const handleFirstClick = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('click', handleFirstClick);
        };
        const handleFirstScroll = ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                duration: performance.now() - startTime
            });
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
        container.addEventListener('click', handleFirstClick);
        container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
        return ()=>{
            container.removeEventListener('click', handleFirstClick);
            container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
        };
    }, [
        createAnalyticsEvent,
        view,
        product
    ]);
    return null;
};

});

parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';



parcelRegister("eRpjy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $beaa0dc8e8f2a3dd$export$d54524c142a057f);

var $eUqFw = parcelRequire("eUqFw");

var $iJHZm = parcelRequire("iJHZm");
const $beaa0dc8e8f2a3dd$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ let id = window.requestAnimationFrame(()=>{
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null);
};

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hRKQW", function(module, exports) {

$parcel$export(module.exports, "URL_PARAMS", () => $22c19d07c8eca181$export$bcc0c92e1564488c);
$parcel$export(module.exports, "PACKAGE_NAME", () => $22c19d07c8eca181$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "VIEW_FORM_DIRECTORY_EXPERIENCE", () => $22c19d07c8eca181$export$3a0a03305bcf855e);
$parcel$export(module.exports, "DELETE_FORM_EXPERIENCE", () => $22c19d07c8eca181$export$7da90561e94f981);
$parcel$export(module.exports, "VIEW_FORM_SUBMISSION_EXPERIENCE", () => $22c19d07c8eca181$export$cdf9f6e9e7d621b6);
$parcel$export(module.exports, "SUBMIT_FORM_EXPERIENCE", () => $22c19d07c8eca181$export$537c9533c0b9bc1);
$parcel$export(module.exports, "VIEW_FORM_CREATE_EXPERIENCE", () => $22c19d07c8eca181$export$ca4e778581db201e);
$parcel$export(module.exports, "CREATE_FORM_EXPERIENCE", () => $22c19d07c8eca181$export$a18ce17ea7fe6b60);
$parcel$export(module.exports, "VIEW_FORM_UPDATE_EXPERIENCE", () => $22c19d07c8eca181$export$3a8f4f9a630a8c30);
$parcel$export(module.exports, "UPDATE_FORM_EXPERIENCE", () => $22c19d07c8eca181$export$b60e0f4f7fb57d79);
$parcel$export(module.exports, "FORM_VALIDATION_ERROR", () => $22c19d07c8eca181$export$85998b62672f570a);
const $22c19d07c8eca181$export$61b0d4a63fb97a47 = 250;
const $22c19d07c8eca181$export$bcc0c92e1564488c = {
    FROM: 'from',
    DIRECTORY: 'directory'
};
const $22c19d07c8eca181$export$b8b9d90f9e5bd72b = 'jiraBusinessForm';
const $22c19d07c8eca181$export$3a0a03305bcf855e = {
    experience: 'viewFormDirectory',
    experienceId: 'viewDirectory',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$7da90561e94f981 = {
    experience: 'deleteForm',
    experienceId: 'deleteForm',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$cdf9f6e9e7d621b6 = {
    experience: 'formSubmission',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$537c9533c0b9bc1 = {
    experience: 'CreateJiraBusinessIssueForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$ca4e778581db201e = {
    experience: 'formCreation',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$a18ce17ea7fe6b60 = {
    experience: 'CreateJiraBusinessForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$3a8f4f9a630a8c30 = {
    experience: 'formUpdate',
    experienceId: 'main',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$b60e0f4f7fb57d79 = {
    experience: 'UpdateJiraBusinessForm',
    experienceId: 'mutation',
    packageName: 'jiraBusinessForm',
    teamName: 'jira-werewolves'
};
const $22c19d07c8eca181$export$85998b62672f570a = {
    ATTACHMENT_ERROR: 'ATTACHMENT_VALIDATION_ERROR'
};

});

parcelRegister("33ieR", function(module, exports) {

$parcel$export(module.exports, "FormAccessLevelTypes", () => $1f155b291c0aa53b$export$dbc34c94c457377);
const $1f155b291c0aa53b$export$dbc34c94c457377 = {
    LIMITED: 'limited',
    OPEN: 'open'
};

});

parcelRegister("mQI4u", function(module, exports) {

$parcel$export(module.exports, "CardStyleCommon", () => $c1e309279cdcff63$export$c75a6d3667a4a2e7);
$parcel$export(module.exports, "Card", () => $c1e309279cdcff63$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $c1e309279cdcff63$export$c75a6d3667a4a2e7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7hp5a _2rkoftgi _otyru2gc _1yt41dfa _16qs1bpa",
            __cmplp.className
        ])
    });
});
const $c1e309279cdcff63$var$StyledCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $c1e309279cdcff63$export$c75a6d3667a4a2e7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_brev0o": (0, $9t7rW.default)(__cmplp.minHeight, "px"),
            "--_1upm8ip": (0, $9t7rW.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.minHeight !== null ? "_1tke1rgx" : "_1tke1wug",
            __cmplp.maxHeight !== null ? "_c71l1w9o" : "_c71l1wug",
            __cmplp.className
        ])
    });
});
const $c1e309279cdcff63$export$60332b2344f7fe41 = $c1e309279cdcff63$var$StyledCard;

});

parcelRegister("k8UPO", function(module, exports) {

$parcel$export(module.exports, "SuccessView", () => $7c70c92ce75616db$export$be5117c66bf44cb9);
$parcel$export(module.exports, "NoPermissionView", () => $7c70c92ce75616db$export$be11ccfe1ded6d81);
$parcel$export(module.exports, "FormUnavailableView", () => $7c70c92ce75616db$export$5759d094146e3811);
$parcel$export(module.exports, "IssueTypeNotAssociatedView", () => $7c70c92ce75616db$export$5d16b0bd7e8f5692);
$parcel$export(module.exports, "IssueTypeDeletedView", () => $7c70c92ce75616db$export$8e65211163568af8);
$parcel$export(module.exports, "FormContainsUnsupportedRequiredFieldsView", () => $7c70c92ce75616db$export$1c25efc053ce2b31);
$parcel$export(module.exports, "FormMissingSupportedRequiredFieldsView", () => $7c70c92ce75616db$export$e6e19199dff5fc90);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7opLA = parcelRequire("7opLA");

var $220ac = parcelRequire("220ac");

var $hI5oG = parcelRequire("hI5oG");

var $77CtJ = parcelRequire("77CtJ");

var $1Yimi = parcelRequire("1Yimi");

var $dnbhd = parcelRequire("dnbhd");

var $3x4sL = parcelRequire("3x4sL");

var $a68Ys = parcelRequire("a68Ys");

var $jKFJ8 = parcelRequire("jKFJ8");

var $4Es8k = parcelRequire("4Es8k");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aeIT6 = parcelRequire("aeIT6");

var $eAp3c = parcelRequire("eAp3c");
const $7c70c92ce75616db$var$contactAdminUrl = '/jira/contact-administrator';
const $7c70c92ce75616db$var$ContactYourAdminLinkMessage = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: $7c70c92ce75616db$var$contactAdminUrl
    }, chunks);
const $7c70c92ce75616db$var$WAC_LINK = 'https://www.atlassian.com/software/jira?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management%7CO:cloudpmm-jwm%7CF:discovery%7CE:cloud%7CX:expand%7C';
const $7c70c92ce75616db$export$be5117c66bf44cb9 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { shouldHidePoweredBy: shouldHidePoweredBy, onResetClick: onResetClick, analyticAttributes: analyticAttributes } = props;
    const onSubmitAnotherResponse = ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'submitAnotherResponseForForm', {
            ...analyticAttributes
        });
        onResetClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormSuccessView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c70c92ce75616db$var$SuccessWrapper, {
        shouldHidePoweredBy: shouldHidePoweredBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c70c92ce75616db$var$Heading, null, formatMessage((0, $eAp3c.messages).successSubmissionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $eAp3c.messages).successSubmissionContentExperiment)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c70c92ce75616db$var$SubmitAnotherButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        onClick: onSubmitAnotherResponse
    }, formatMessage((0, $eAp3c.messages).formSubmitAnotherForm))), !shouldHidePoweredBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c70c92ce75616db$var$PromoFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        message: formatMessage((0, $eAp3c.messages).formSuccessFooterSpork, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: $7c70c92ce75616db$var$WAC_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'poweredByJwm');
                    }
                }, children))
        }
    }))));
};
const $7c70c92ce75616db$export$be11ccfe1ded6d81 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormNoPermissionView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $eAp3c.messages).noPermissionHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $eAp3c.messages).noPermissionContent,
            values: {
                createPermissionName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, formatMessage((0, $eAp3c.messages).createPermissionName)),
                linkToContactAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
                ), {
                    onClick: (event, analyticsEvent)=>{
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'contactAdministrator');
                    },
                    href: "/secure/ContactAdministrators!default.jspa"
                }, formatMessage((0, $eAp3c.messages).noPermissionLinkToContactAdmin))
            }
        }),
        maxImageWidth: 100,
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $jKFJ8.default))
    }));
};
const $7c70c92ce75616db$export$5759d094146e3811 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $eAp3c.messages).formUnavailableHeading),
        headingLevel: 1,
        description: formatMessage((0, $eAp3c.messages).formUnavailableContent),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $a68Ys.default))
    }));
};
const $7c70c92ce75616db$export$5d16b0bd7e8f5692 = ({ issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const project = (0, $aeIT6.useProject)().data;
    const isAdmin = project && project.permissions.administerProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableIssueTypeRemovedView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $eAp3c.messages).formUnavailableHeading),
        headingLevel: 1,
        description: isAdmin ? formatMessage((0, $eAp3c.messages).formUnavailableIssueTypeNotAssociatedContentForAdmins, {
            issueTypeName: issueTypeName
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $eAp3c.messages).formUnavailableIssueTypeNotAssociatedContent,
            values: {
                link: $7c70c92ce75616db$var$ContactYourAdminLinkMessage
            }
        }),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $a68Ys.default))
    }));
};
const $7c70c92ce75616db$export$8e65211163568af8 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const project = (0, $aeIT6.useProject)().data;
    const isAdmin = project && project.permissions.administerProject;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormUnavailableIssueTypeDeletedView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $eAp3c.messages).formUnavailableHeading),
        headingLevel: 1,
        description: isAdmin ? formatMessage((0, $eAp3c.messages).formUnavailableIssueTypeDeletedContentForAdmins) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $eAp3c.messages).formUnavailableIssueTypeDeletedContent,
            values: {
                link: $7c70c92ce75616db$var$ContactYourAdminLinkMessage
            }
        }),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $a68Ys.default))
    }));
};
const $7c70c92ce75616db$export$1c25efc053ce2b31 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const project = (0, $aeIT6.useProject)().data;
    const canCreateOrModifyForm = project && project.permissions.administerProject;
    const projectKey = project?.key;
    const isTeamManaged = project?.isSimplified;
    const fieldLayoutSchemesUrlCMP = '/secure/admin/ViewFieldLayoutSchemes.jspa';
    const fieldLayoutSchemesUrlTMP = `/jira/core/projects/${projectKey}/settings/issuetypes`;
    const fieldLayoutSchemesUrl = isTeamManaged ? fieldLayoutSchemesUrlTMP : fieldLayoutSchemesUrlCMP;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormContainsUnsupportedRequiredFieldsView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $eAp3c.messages).unsupportedRequiredFieldsHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $eAp3c.messages).unsupportedRequiredFieldsDescription,
            values: {
                canCreateOrModifyForm: canCreateOrModifyForm,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingUnsupportedRequiredFieldsCta', {
                                isAdmin: canCreateOrModifyForm
                            });
                        },
                        href: canCreateOrModifyForm ? fieldLayoutSchemesUrl : $7c70c92ce75616db$var$contactAdminUrl
                    }, chunks)
            }
        }),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $a68Ys.default))
    }));
};
const $7c70c92ce75616db$export$e6e19199dff5fc90 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const project = (0, $aeIT6.useProject)().data;
    const canCreateOrModifyForm = project && project.permissions.administerProject;
    const adminUrl = `${window.location.href}/builder`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "businessFormMissingSupportedRequiredFieldsView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $eAp3c.messages).supportedRequiredFieldsMissingHeading),
        headingLevel: 1,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $eAp3c.messages).supportedRequiredFieldsDescription,
            values: {
                canCreateOrModifyForm: canCreateOrModifyForm,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingSupportedRequiredFieldsCta', {
                                isAdmin: canCreateOrModifyForm
                            });
                        },
                        href: canCreateOrModifyForm ? adminUrl : $7c70c92ce75616db$var$contactAdminUrl
                    }, chunks)
            }
        }),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $a68Ys.default))
    }));
};
const $7c70c92ce75616db$var$illustrationHeight = 4;
const $7c70c92ce75616db$var$Heading = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large",
        as: "h1"
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c70c92ce75616db$var$WrapperStyleBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _1uak12bs _ydafzu5n _cfu11ule _l5lo12bs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c70c92ce75616db$var$SuccessWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7c70c92ce75616db$var$WrapperStyleBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s816qb _1kt976ek",
            __cmplp.shouldHidePoweredBy ? "_n3tdf6fq" : "_n3tdidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c70c92ce75616db$var$PromoFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _x3dowsm2 _19pkxy5q _otyrpxbi _ca0q1ejb _syaz1thw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c70c92ce75616db$var$SubmitAnotherButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _18s8qc1h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("a68Ys", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab13a317c6a7fb14$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mstqrh7gfrgxbc8ggp3w5jrj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mstqrh7gfrgxbc8ggp3w5jrj

var $9TZf5 = parcelRequire("9TZf5");

var $5mEZB = parcelRequire("5mEZB");
const $ab13a317c6a7fb14$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5mEZB)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5mEZB))
});
var $ab13a317c6a7fb14$export$2e2bcd8739ae039 = $ab13a317c6a7fb14$var$Illustration;
// for advanced use only
const $ab13a317c6a7fb14$export$a179c88182cb9d56 = [
    0,
    0,
    236,
    211
];

});
parcelRegister("5mEZB", function(module, exports) {
module.exports = new URL("loading-file-error.402df2c9.svg", import.meta.url).toString();

});


parcelRegister("jKFJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d95b23f601f4e11$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = sc7h9stshcvmkj7nt3ccks24
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/sc7h9stshcvmkj7nt3ccks24

var $9TZf5 = parcelRequire("9TZf5");

var $23GNu = parcelRequire("23GNu");

var $bzWUm = parcelRequire("bzWUm");
const $7d95b23f601f4e11$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bzWUm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($23GNu))
});
var $7d95b23f601f4e11$export$2e2bcd8739ae039 = $7d95b23f601f4e11$var$Illustration;
// for advanced use only
const $7d95b23f601f4e11$export$a179c88182cb9d56 = [
    0,
    0,
    169,
    222
];

});
parcelRegister("23GNu", function(module, exports) {
module.exports = new URL("lock-red-darkmode.35f0d66e.svg", import.meta.url).toString();

});

parcelRegister("bzWUm", function(module, exports) {
module.exports = new URL("lock-red.0ce332f2.svg", import.meta.url).toString();

});


parcelRegister("eAp3c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $542e30855c96ef39$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $542e30855c96ef39$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successSubmissionHeading: {
        "id": "business-form.common.empty-views.success-submission-heading",
        "defaultMessage": "We're on it!"
    },
    successSubmissionContentExperiment: {
        "id": "business-form.common.empty-views.success-submission-content-experiment",
        "defaultMessage": "Thanks for your submission."
    },
    noPermissionHeading: {
        "id": "business-form.common.empty-views.no-permission-heading",
        "defaultMessage": "You don't have access to this form"
    },
    noPermissionContent: {
        "id": "business-form.common.empty-views.no-permission-content",
        "defaultMessage": "You do not have permission to submit forms to this project. Please request for the {createPermissionName} permission by {linkToContactAdmin}"
    },
    noPermissionLinkToContactAdmin: {
        "id": "business-form.common.empty-views.no-permission-link-to-contact-admin",
        "defaultMessage": " contacting this project's administrator."
    },
    createPermissionName: {
        "id": "business-form.common.empty-views.create-permission-name",
        "defaultMessage": "\u201CCreate Issue\u201D"
    },
    formUnavailableHeading: {
        "id": "business-form.common.empty-views.form-unavailable-heading",
        "defaultMessage": "Form is unavailable"
    },
    formUnavailableContent: {
        "id": "business-form.common.empty-views.form-unavailable-content",
        "defaultMessage": "This form is no longer active. Try contacting the owner of the form if you think this is a mistake."
    },
    formUnavailableIssueTypeDeletedContentOld: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-old",
        "defaultMessage": "The issue type associated with this form was removed from your business project. {linkStart}Contact your admin{linkEnd} to delete the form and create a new one.  "
    },
    formUnavailableIssueTypeDeletedContent: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content",
        "defaultMessage": "The issue type associated with this form was removed from your business project. <link>Contact your admin</link> to delete the form and create a new one.  "
    },
    formUnavailableIssueTypeDeletedContentForAdmins: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-for-admins",
        "defaultMessage": "The issue type associated with this form was removed from your business project. Delete this form and create a new one with the issue types that are available."
    },
    formUnavailableIssueTypeNotAssociatedContentOld: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-old",
        "defaultMessage": "The issue type being used for this form is not valid. {linkStart}Contact your admin{linkEnd} to check if this issue type is linked to the issue type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContent: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content",
        "defaultMessage": "The issue type being used for this form is not valid. <link>Contact your admin</link> to check if this issue type is linked to the issue type scheme for this business project."
    },
    formUnavailableIssueTypeNotAssociatedContentForAdmins: {
        "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-for-admins",
        "defaultMessage": "The issue type {issueTypeName} being used for this form is not valid. Check if this issue type is linked to the issue type scheme for this business project."
    },
    formSuccessFooterSpork: {
        "id": "business-form.common.empty-views.form-success-footer-spork",
        "defaultMessage": "Powered by {linkStart}Jira{linkEnd}"
    },
    formSubmitAnotherForm: {
        "id": "business-form.common.empty-views.form-submit-another-form",
        "defaultMessage": "Submit another form"
    },
    unsupportedRequiredFieldsHeading: {
        "id": "business-form.common.empty-views.unsupported-required-fields-heading",
        "defaultMessage": "Unsupported required fields"
    },
    unsupportedRequiredFieldsDescription: {
        "id": "business-form.common.empty-views.unsupported-required-fields-description",
        "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Update the field configuration</link> to make these fields optional, and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request changes to the field configuration}\n        }."
    },
    supportedRequiredFieldsMissingHeading: {
        "id": "business-form.common.empty-views.supported-required-fields-missing-heading",
        "defaultMessage": "Missing required fields"
    },
    supportedRequiredFieldsDescription: {
        "id": "business-form.common.empty-views.supported-required-fields-description",
        "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Complete all the required fields in the form</link> and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request any changes to required fields}\n        }."
    }
});

});


parcelRegister("9jk0K", function(module, exports) {

$parcel$export(module.exports, "FormBackground", () => $457b19140d322561$export$e13fb218ba50bebd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $hqMU1 = parcelRequire("hqMU1");
const $457b19140d322561$export$e13fb218ba50bebd = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, bannerColor: bannerColor, header: header })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($457b19140d322561$var$Background, {
        bannerColor: (0, $hqMU1.getDesignTokenBannerColor)(bannerColor)
    }, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($457b19140d322561$var$ContentWrapper, null, children)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $457b19140d322561$var$Background = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bannerColor: bannerColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1524em9": (0, $9t7rW.default)(`linear-gradient(to bottom, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            __cmplp.bannerColor || `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$exports).N40A})`} 30%, transparent 30%)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71c01 _qmxj1n9t _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $457b19140d322561$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbufrr _18s8mvv2",
            __cmplp.className
        ])
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("hqMU1", function(module, exports) {

$parcel$export(module.exports, "getRandomBannerColor", () => $4256a031622947e9$export$aefdd89adb2344b3);
$parcel$export(module.exports, "getDesignTokenBannerColor", () => $4256a031622947e9$export$c3fba1eee1434e93);

const $4256a031622947e9$var$FORM_COLORS = [
    (0, $73a5c9d720aa66e1$export$60847d42f9da92a6),
    (0, $73a5c9d720aa66e1$export$5aae31392d72caaa),
    (0, $73a5c9d720aa66e1$export$747d86715d4175de),
    (0, $73a5c9d720aa66e1$export$215b7063051591f1),
    (0, $73a5c9d720aa66e1$export$69cb3ca10c1e330e),
    (0, $73a5c9d720aa66e1$export$a7175d4e9206bc80)
];
const $4256a031622947e9$export$993a5daeae2a3b3d = (index)=>$4256a031622947e9$var$FORM_COLORS[index];
const $4256a031622947e9$export$aefdd89adb2344b3 = ()=>$4256a031622947e9$var$FORM_COLORS[Math.floor(Math.random() * $4256a031622947e9$var$FORM_COLORS.length)];
const $4256a031622947e9$export$c3fba1eee1434e93 = (colorCode)=>{
    switch(colorCode){
        case 0, $73a5c9d720aa66e1$export$60847d42f9da92a6:
            return `var(--ds-background-accent-red-subtle, ${0, $73a5c9d720aa66e1$export$60847d42f9da92a6})`;
        case 0, $73a5c9d720aa66e1$export$5aae31392d72caaa:
            return `var(--ds-background-accent-yellow-subtle, ${0, $73a5c9d720aa66e1$export$5aae31392d72caaa})`;
        case 0, $73a5c9d720aa66e1$export$747d86715d4175de:
            return `var(--ds-background-accent-green-subtle, ${0, $73a5c9d720aa66e1$export$747d86715d4175de})`;
        case 0, $73a5c9d720aa66e1$export$69cb3ca10c1e330e:
            return `var(--ds-background-accent-teal-subtle, ${0, $73a5c9d720aa66e1$export$69cb3ca10c1e330e})`;
        case 0, $73a5c9d720aa66e1$export$a7175d4e9206bc80:
            return `var(--ds-background-accent-purple-subtle, ${0, $73a5c9d720aa66e1$export$a7175d4e9206bc80})`;
        case 0, $73a5c9d720aa66e1$export$215b7063051591f1:
        default:
            return `var(--ds-background-accent-blue-subtle, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`;
    }
};

});


parcelRegister("i3wcx", function(module, exports) {

$parcel$export(module.exports, "useJWMFormsFeatures", () => $be80301bb53bcfde$export$761e4daa424a5fb7);
$parcel$export(module.exports, "default", () => $be80301bb53bcfde$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $be80301bb53bcfde$var$defaultFeaturesContext = {
    featureView: 'form-submit',
    shouldHidePoweredBy: false
};
const $be80301bb53bcfde$var$JWMFormsFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)($be80301bb53bcfde$var$defaultFeaturesContext);
const $be80301bb53bcfde$export$761e4daa424a5fb7 = ()=>(0, $eUqFw.useContext)($be80301bb53bcfde$var$JWMFormsFeaturesContext);
var $be80301bb53bcfde$export$2e2bcd8739ae039 = $be80301bb53bcfde$var$JWMFormsFeaturesContext;

});

parcelRegister("82V0G", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionPreloader", () => $6c266eeb72b5bc03$export$bacf31e62dc24134);
$parcel$export(module.exports, "useFormSubmission", () => $6c266eeb72b5bc03$export$6a196f0d30f494f8);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $lB25E = parcelRequire("lB25E");

var $c1HIH = parcelRequire("c1HIH");

var $6qDin = parcelRequire("6qDin");

var $894Qj = parcelRequire("894Qj");

var $2OFdZ = parcelRequire("2OFdZ");
const $6c266eeb72b5bc03$export$bacf31e62dc24134 = ()=>{
    const [{ match: { params: { formId: formId } } }] = (0, $lB25E.useRouter)();
    const result = (0, $6qDin.useGetFormWithFieldDataByFormId)(String(formId));
    const [state, { updateStore: updateStore }] = (0, $894Qj.useFormSubmissionStore)();
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(result, state)) updateStore(result);
    }, [
        updateStore,
        result,
        state
    ]);
    return null;
};
const $6c266eeb72b5bc03$export$6a196f0d30f494f8 = ()=>{
    const [{ data: formWithFieldData, loading: getFormLoading, error: getFormError }] = (0, $894Qj.useFormSubmissionStore)();
    const { data: fieldMetaData, loading: fieldMetaDataLoading, error: fieldMetaDataError } = (0, $c1HIH.useFieldMeta)(formWithFieldData?.projectId, formWithFieldData?.issueType?.id, String(formWithFieldData?.formId));
    const loading = getFormLoading || fieldMetaDataLoading;
    return {
        data: loading ? undefined : {
            fieldMetaData: fieldMetaData,
            formWithFieldData: formWithFieldData,
            formSubmissionValidationData: (0, $2OFdZ.getFormValidationData)(formWithFieldData, fieldMetaData)
        },
        formId: String(formWithFieldData?.formId),
        loading: loading,
        error: getFormError || fieldMetaDataError
    };
};

});
parcelRegister("c1HIH", function(module, exports) {

$parcel$export(module.exports, "useFieldMeta", () => $434e4b344fdbcd22$export$c6fef47cfdcb6be7);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");


var $ZvXTS = parcelRequire("ZvXTS");

var $2OdyW = parcelRequire("2OdyW");

var $dFav3 = parcelRequire("dFav3");
const $434e4b344fdbcd22$var$fetchMeta = async (formId)=>{
    // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-createmeta-get
    const response = await (0, $2OdyW.default)(`/rest/api/2/issue/createmeta/businessform?formId=${formId}&expand=projects.issuetypes.fields`);
    return response;
};
const $434e4b344fdbcd22$var$memoizedFetchMeta = (0, $5iWql.default)($434e4b344fdbcd22$var$fetchMeta);
const $434e4b344fdbcd22$export$c6fef47cfdcb6be7 = (projectId, issueTypeId, formId)=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: true
    });
    (0, $eUqFw.useEffect)(()=>{
        if (projectId === undefined || projectId === null || issueTypeId === undefined || issueTypeId === null || formId === undefined || formId === null) {
            setState({
                loading: false
            });
            return;
        }
        (async ()=>{
            setState({
                loading: true
            });
            (0, $ZvXTS.markViewMetric)('form-submit', (0, $78bb8734d7176028$export$23e322eb7c526958));
            try {
                // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-issues/#api-rest-api-2-issue-createmeta-get
                const response = await $434e4b344fdbcd22$var$memoizedFetchMeta(formId);
                let data;
                // if there's a permission error, the response will exist but projects will be an empty array
                if (response.projects[0]?.issuetypes[0]?.fields) data = (0, $dFav3.transformFieldsMeta)((0, $dFav3.filterFieldsMeta)(response.projects[0].issuetypes[0].fields));
                setState({
                    data: // @ts-expect-error - TS2322 - Type '{ [x: string]: FieldMeta | { required: boolean; autoCompleteUrl?: string | undefined; schema?: { custom?: string | undefined; system?: string | undefined; } | undefined; defaultFieldValue?: string | undefined; allowedValues: CascadingAllowableValue[]; }; } | undefined' is not assignable to type 'FieldsMeta | undefined'.
                    data,
                    loading: false,
                    error: undefined
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setState({
                    loading: false,
                    error: e.message
                });
            } finally{
                (0, $ZvXTS.markViewMetric)('form-submit', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
            }
        })();
    }, [
        formId,
        issueTypeId,
        projectId
    ]);
    return state;
};

});
parcelRegister("dFav3", function(module, exports) {

$parcel$export(module.exports, "filterFieldsMeta", () => $3bcb28644f74e63a$export$6a17577fedf4efeb);
$parcel$export(module.exports, "transformFieldsMeta", () => $3bcb28644f74e63a$export$613acfe083d57f99);

var $czx3b = parcelRequire("czx3b");

var $lO4Or = parcelRequire("lO4Or");
const $3bcb28644f74e63a$export$6a17577fedf4efeb = (fieldMeta)=>{
    // remove specific field property from fieldMeta
    const { issuetype: issuetype, project: project, reporter: reporter, ...otherFieldMeta } = fieldMeta;
    return otherFieldMeta;
};
const $3bcb28644f74e63a$export$5647ab885112c565 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $3bcb28644f74e63a$var$isCascadingField = (fieldMeta)=>fieldMeta.schema?.custom === $3bcb28644f74e63a$export$5647ab885112c565;
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'value' implicitly has an 'any' type.
const $3bcb28644f74e63a$var$transformCascadingFieldChildValue = ({ id: id, value: value })=>({
        id: id,
        value: value,
        __typename: 'JiraCascadingOptions'
    });
const $3bcb28644f74e63a$export$8e0c8a960f1af96 = ({ id: id, value: value, children: children = [] })=>({
        parentOptionValue: {
            id: id,
            value: value,
            __typename: 'JiraOption'
        },
        childOptionValues: children.map($3bcb28644f74e63a$var$transformCascadingFieldChildValue)
    });
// https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-groups/#api-rest-api-3-groups-picker-get
const $3bcb28644f74e63a$var$GROUP_PICKER_API_ENDPOINT = '/rest/api/3/groups/picker?query=';
const $3bcb28644f74e63a$var$isGroupField = (fieldMeta)=>fieldMeta.schema?.custom === (0, $lO4Or.GROUP_CF_TYPE) || fieldMeta.schema?.custom === (0, $lO4Or.MULTI_GROUP_CF_TYPE);
const $3bcb28644f74e63a$var$transformGroupField = (fieldMeta)=>({
        ...fieldMeta,
        autoCompleteUrl: $3bcb28644f74e63a$var$GROUP_PICKER_API_ENDPOINT
    });
const $3bcb28644f74e63a$export$613acfe083d57f99 = (fieldsMeta)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(fieldsMeta, (field)=>{
        // An autocomplete URL is not included in field meta data for Single or Multi group picker fields.
        // For now, manually include the autocomplete URL for these fields.
        if ($3bcb28644f74e63a$var$isGroupField(field)) return $3bcb28644f74e63a$var$transformGroupField(field);
        if (!$3bcb28644f74e63a$var$isCascadingField(field)) return field;
        const { allowedValues: allowedValues = [], ...rest } = field;
        return {
            allowedValues: allowedValues.map($3bcb28644f74e63a$export$8e0c8a960f1af96),
            ...rest
        };
    });

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});



parcelRegister("6qDin", function(module, exports) {

$parcel$export(module.exports, "useFormById", () => $d9360787b3899b69$export$ac7a76dbf4149182);
$parcel$export(module.exports, "useGetFormWithFieldDataByFormId", () => $d9360787b3899b69$export$7c42f44d9574ee82);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");


var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2u9Sh = parcelRequire("2u9Sh");

var $4xKZI = parcelRequire("4xKZI");
const $d9360787b3899b69$export$ac7a76dbf4149182 = (formId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $2u9Sh.JIRA_BUSINESS_FORM_BY_ID));
    (0, $eUqFw.useEffect)(()=>{
        if (formId != null) {
            (0, $ZvXTS.markViewMetric)('form', (0, $78bb8734d7176028$export$23e322eb7c526958));
            const QUERY_NAME = 'JiraBusinessFormById';
            fetch({
                variables: {
                    formId: formId,
                    isFormsWorkFgEnabled: (0, $eI5EY.fg)('forms_work-intake_rollout-1')
                },
                // @ts-expect-error - TS2345 - Argument of type '{ variables: { formId: string; }; onError: (apolloError: any) => void; onCompleted: () => void; }' is not assignable to parameter of type 'QueryLazyOptions<JiraBusinessFormByIdVariables>'. | TS7006 - Parameter 'apolloError' implicitly has an 'any' type.
                onError: (apolloError)=>{
                    (0, $guiFP.default)({
                        meta: {
                            id: QUERY_NAME,
                            packageName: 'jiraBusinessForm',
                            teamName: 'jira-werewolves'
                        },
                        error: apolloError,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    (0, $ZvXTS.markViewMetric)('form', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
                },
                onCompleted: ()=>{
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
                    (0, $ZvXTS.markViewMetric)('form', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
                }
            });
        }
    }, [
        createAnalyticsEvent,
        fetch,
        formId
    ]);
    const form = (0, $eUqFw.useMemo)(()=>(0, $4xKZI.transformJiraBusinessForm)(data), [
        data
    ]);
    return {
        form: form,
        loading: loading,
        error: error
    };
};
const $d9360787b3899b69$export$7c42f44d9574ee82 = (formId)=>{
    const QUERY_NAME = 'JiraBusinessFormWithFieldDataByFormId';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $ZvXTS.markViewMetric)('form-submit', (0, $78bb8734d7176028$export$23e322eb7c526958));
    }, []);
    const { data: data, loading: loading, error: error } = (0, $iZuDo.useQuery)((0, $2u9Sh.JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID), {
        /**
		 * Forms currently has no requirement to utilize a cache, however if
		 * this policy is changed, be aware that you may need to make other changes
		 * to ensure that GQL unions work as expected and/or the cache doesn't
		 * collide with other features.
		 * See: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/45683/overview?commentId=2977330
		 */ fetchPolicy: 'no-cache',
        variables: {
            formId: formId,
            isFormsWorkFgEnabled: (0, $eI5EY.fg)('forms_work-intake_rollout-1')
        },
        onError: (apolloError)=>{
            const analyticsError = apolloError;
            const skipSentry = (0, $4xKZI.isFormNotFoundError)(analyticsError);
            if (skipSentry) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsError.skipSentry = true;
            (0, $guiFP.default)({
                meta: {
                    id: QUERY_NAME,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                error: analyticsError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $ZvXTS.markViewMetric)('form-submit', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
        },
        onCompleted: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
            (0, $ZvXTS.markViewMetric)('form-submit', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
        }
    });
    return {
        data: (0, $4xKZI.transformFormDataWithFieldData)(data),
        loading: loading,
        error: error
    };
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("2u9Sh", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FORM_BY_ID", () => $edcd5735228476ab$export$46b3396662c77cec);
$parcel$export(module.exports, "JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID", () => $edcd5735228476ab$export$30c35ae67d1502b);

var $9ypom = parcelRequire("9ypom");

var $bIHYL = parcelRequire("bIHYL");
const $edcd5735228476ab$export$46b3396662c77cec = (0, $9ypom.default)`
  query JiraBusinessFormById($formId: ID!, $isFormsWorkFgEnabled: Boolean!) {
    jiraBusinessForm(formId: $formId) {
      ...FormBuilderConfigurationFragment
    }
  }

  ${(0, $bIHYL.FORM_BUILDER_CONFIGURATION_FRAGMENT)}
`;
const $edcd5735228476ab$export$30c35ae67d1502b = (0, $9ypom.default)`
  query JiraBusinessFormWithFieldDataByFormId($formId: ID!, $isFormsWorkFgEnabled: Boolean!) {
    jiraBusinessForm(formId: $formId) {
      formId
      projectId
      issueType {
        name
        issueTypeId
      }
      title
      description
      bannerColor
      enabled
      accessLevel
      fields {
        fieldId
        alias
        description @include(if: $isFormsWorkFgEnabled)
        isRequired @include(if: $isFormsWorkFgEnabled)
        field {
          name
          type
          ... on GenericIssueField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraIssueFieldConfiguration {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
            }
          }
        }
      }
    }
  }
`;

});
parcelRegister("bIHYL", function(module, exports) {

$parcel$export(module.exports, "FORM_BUILDER_CONFIGURATION_FRAGMENT", () => $fbc4846d61a33ad8$export$41f21ae1bbcf5d4c);
$parcel$export(module.exports, "FORM_CONFIGURATION_FOR_DIRECTORY", () => $fbc4846d61a33ad8$export$e89d36bee87f0323);
$parcel$export(module.exports, "MUTATION_ERROR_FRAGMENT", () => $fbc4846d61a33ad8$export$25fa4c03959b6e86);

var $9ypom = parcelRequire("9ypom");
const $fbc4846d61a33ad8$export$41f21ae1bbcf5d4c = (0, $9ypom.default)`
 fragment FormBuilderConfigurationFragment on JiraBusinessFormConfiguration {
    id
    formId
    projectId
    title
    description
    bannerColor
    enabled
    isSubmittableByAllLoggedInUsers
    accessLevel
    fields {
      id
      fieldId
      alias
      description @include(if: $isFormsWorkFgEnabled)
      isRequired @include(if: $isFormsWorkFgEnabled)
    }
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
 }
`;
const $fbc4846d61a33ad8$export$e89d36bee87f0323 = (0, $9ypom.default)`
  fragment FormConfigurationFragmentForDirectory on JiraBusinessFormConfiguration {
    id
    formId
    title
    description
    bannerColor
    enabled
    updated
    accessLevel
    issueType {
      issueTypeId
      name
      avatarId
      avatar {
        medium
      }
    }
    updateAuthor {
      name
      accountId
    }
    errors
  }
`;
const $fbc4846d61a33ad8$export$25fa4c03959b6e86 = (0, $9ypom.default)`
  fragment MutationErrorFragment on MutationError {
    message
    extensions {
      statusCode
      errorType
    }
  }
`;

});


parcelRegister("4xKZI", function(module, exports) {

$parcel$export(module.exports, "transformJiraBusinessForm", () => $59f9040adf6f56ee$export$c07aa36a491f7398);
$parcel$export(module.exports, "transformFormDataWithFieldData", () => $59f9040adf6f56ee$export$9488a647bac5a6d6);
$parcel$export(module.exports, "isFormNotFoundError", () => $59f9040adf6f56ee$export$1227e121b71c2a43);

var $eI5EY = parcelRequire("eI5EY");

var $33ieR = parcelRequire("33ieR");

var $7XfqV = parcelRequire("7XfqV");
const $59f9040adf6f56ee$export$4dee7f5ded2c202d = (field)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"reporter" | "issuetype"'.
    (0, $7XfqV.IGNORE_FIELD_IDS).includes(field.fieldId) === false;
const $59f9040adf6f56ee$export$47e6f860e5c51292 = (field)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"reporter" | "issuetype"'.
    (0, $7XfqV.IGNORE_FIELD_IDS).includes(field.fieldId) === false;
const $59f9040adf6f56ee$export$c07aa36a491f7398 = (data)=>{
    if (!data || !data.jiraBusinessForm) return undefined;
    const { jiraBusinessForm: jiraBusinessForm } = data;
    // the mapping from GraphQL type to FE type
    // mainly affects the `fields` only
    // this is done to remove the `undefined` from the fields array so it will be easier to consume in the UI layer
    const form = {
        id: jiraBusinessForm.id,
        formId: jiraBusinessForm.formId,
        projectId: jiraBusinessForm.projectId,
        title: jiraBusinessForm.title,
        description: jiraBusinessForm.description ?? undefined,
        bannerColor: jiraBusinessForm.bannerColor ?? undefined,
        enabled: jiraBusinessForm.enabled,
        isSubmittableByAllLoggedInUsers: jiraBusinessForm.isSubmittableByAllLoggedInUsers,
        issueType: jiraBusinessForm.issueType ? {
            id: jiraBusinessForm.issueType.issueTypeId ?? '',
            name: jiraBusinessForm.issueType.name ?? '',
            avatarId: jiraBusinessForm.issueType.avatarId ?? null,
            avatarUrl: jiraBusinessForm.issueType.avatar?.medium ?? null,
            isDefault: false,
            subtask: jiraBusinessForm.issueType.type === 'SUB_TASK',
            hierarchyLevel: jiraBusinessForm.issueType.hierarchy?.level ?? 0
        } : null,
        fields: jiraBusinessForm.fields?.filter(Boolean).map((f)=>({
                id: f.id,
                fieldId: f.fieldId,
                alias: f.alias ?? undefined,
                ...(0, $eI5EY.fg)('forms_work-intake_rollout-1') && {
                    isRequiredByForm: !!f.isRequired
                }
            })).filter($59f9040adf6f56ee$export$4dee7f5ded2c202d) ?? null,
        accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, $33ieR.FormAccessLevelTypes).LIMITED
    };
    return form;
};
const $59f9040adf6f56ee$export$9488a647bac5a6d6 = (data)=>{
    if (!data || !data.jiraBusinessForm) return undefined;
    const { jiraBusinessForm: jiraBusinessForm } = data;
    return {
        formId: jiraBusinessForm.formId,
        projectId: jiraBusinessForm.projectId,
        issueType: jiraBusinessForm.issueType ? {
            name: jiraBusinessForm.issueType.name || '',
            id: jiraBusinessForm.issueType.issueTypeId ?? ''
        } : null,
        title: jiraBusinessForm.title,
        description: jiraBusinessForm.description ?? undefined,
        bannerColor: jiraBusinessForm.bannerColor ?? undefined,
        enabled: jiraBusinessForm.enabled,
        fields: jiraBusinessForm.fields?.filter(Boolean).filter((f)=>'fieldConfig' in f.field).map((f)=>{
            // @ts-expect-error - TS2339: Property 'fieldConfig' does not exist on type 'JiraBusinessFormWithFieldDataByFormId_jiraBusinessForm_fields_field'.
            const fieldIsRequiredByIssueConfig = Boolean(f.field.fieldConfig.isRequired);
            const fieldIsRequiredByFormConfig = (0, $eI5EY.fg)('forms_work-intake_rollout-1') && !!f.isRequired;
            return {
                fieldId: f.fieldId,
                alias: f.alias,
                name: f.field.name,
                isRequired: fieldIsRequiredByIssueConfig,
                isRequiredByForm: fieldIsRequiredByFormConfig,
                type: f.field.type
            };
        }).filter($59f9040adf6f56ee$export$47e6f860e5c51292) ?? [],
        accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, $33ieR.FormAccessLevelTypes).LIMITED
    };
};
const $59f9040adf6f56ee$export$1227e121b71c2a43 = (error)=>error.graphQLErrors?.[0]?.extensions?.errorType === (0, $7XfqV.FORM_NOT_FOUND_ERROR);

});
parcelRegister("7XfqV", function(module, exports) {

$parcel$export(module.exports, "IGNORE_FIELD_IDS", () => $0901c3d231f47079$export$18705e0cb6bd7398);
$parcel$export(module.exports, "FORM_NOT_FOUND_ERROR", () => $0901c3d231f47079$export$a5614f895fe1c5d2);

var $lO4Or = parcelRequire("lO4Or");
const $0901c3d231f47079$export$18705e0cb6bd7398 = [
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.ISSUE_TYPE)
];
const $0901c3d231f47079$export$a5614f895fe1c5d2 = 'FORM_NOT_FOUND';

});



parcelRegister("894Qj", function(module, exports) {

$parcel$export(module.exports, "useFormSubmissionStore", () => $275356644c427e45$export$bd364acc55858de);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $275356644c427e45$var$actions = {
    updateStore: (newData)=>({ setState: setState })=>{
            setState(newData);
        }
};
const $275356644c427e45$var$FormSubmissionStore = (0, $kEDjj.createStore)({
    initialState: {
        data: undefined,
        loading: false,
        error: undefined
    },
    actions: $275356644c427e45$var$actions,
    name: 'JWMFormSubmission'
});
const $275356644c427e45$export$bd364acc55858de = (0, $1yZQx.createHook)($275356644c427e45$var$FormSubmissionStore);

});

parcelRegister("2OFdZ", function(module, exports) {

$parcel$export(module.exports, "getFormValidationData", () => $b1f21a8a5e127b15$export$1b92201c43ea8a87);

var $eI5EY = parcelRequire("eI5EY");

var $eXHxV = parcelRequire("eXHxV");

var $8OVaT = parcelRequire("8OVaT");
const $b1f21a8a5e127b15$export$1b92201c43ea8a87 = (formData, fieldMetaData)=>{
    if (!formData || !fieldMetaData) return null;
    // required fields in form that are also required in the issue type
    const formRequiredFields = formData.fields.filter((f)=>f.isRequired && !!fieldMetaData[f.fieldId]);
    // required fields in project
    const requiredFieldIds = Object.keys(fieldMetaData).filter((fieldId)=>fieldMetaData[fieldId].required);
    const formContainsAllRequiredFields = formRequiredFields.length === requiredFieldIds.length;
    const isAllRequiredFieldsSupported = requiredFieldIds.every((f)=>{
        const fieldType = fieldMetaData[f].schema?.custom || fieldMetaData[f].schema?.system;
        if (!fieldType) return false;
        return (0, $eI5EY.fg)('jwm-form-field-configs') ? (0, $eXHxV.isFieldTypeSupported)(fieldType) : (0, $8OVaT.isFieldTypeSupported)(fieldType);
    });
    return {
        isFormSubmissionValid: formContainsAllRequiredFields && isAllRequiredFieldsSupported,
        hasMissingSupportedRequiredFields: !formContainsAllRequiredFields && isAllRequiredFieldsSupported,
        hasUnsupportedRequiredFields: !isAllRequiredFieldsSupported
    };
};

});
parcelRegister("eXHxV", function(module, exports) {

$parcel$export(module.exports, "isFieldTypeSupported", () => $211e323f69eda16f$export$b47920a5dd99844f);
$parcel$export(module.exports, "getFieldTypeConfig", () => $211e323f69eda16f$export$5be962d414ad6e6c);

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $97NDn = parcelRequire("97NDn");

var $6tIbT = parcelRequire("6tIbT");

var $dK0NF = parcelRequire("dK0NF");

var $86udM = parcelRequire("86udM");

var $kk5Iu = parcelRequire("kk5Iu");

var $LoFQn = parcelRequire("LoFQn");

var $a1aim = parcelRequire("a1aim");

var $87PH3 = parcelRequire("87PH3");

var $agYKJ = parcelRequire("agYKJ");

var $5zP1p = parcelRequire("5zP1p");

var $coiWz = parcelRequire("coiWz");

var $bfJSC = parcelRequire("bfJSC");

var $8nL8u = parcelRequire("8nL8u");

var $2O5Nv = parcelRequire("2O5Nv");

var $5jPiu = parcelRequire("5jPiu");

var $4cIkL = parcelRequire("4cIkL");

var $6k3kI = parcelRequire("6k3kI");

var $01FG6 = parcelRequire("01FG6");

var $kXX84 = parcelRequire("kXX84");

var $zma4S = parcelRequire("zma4S");

var $754Vk = parcelRequire("754Vk");

var $foE6X = parcelRequire("foE6X");

var $iSnOd = parcelRequire("iSnOd");

var $6VKPX = parcelRequire("6VKPX");

var $9QvQg = parcelRequire("9QvQg");

var $lpJww = parcelRequire("lpJww");

var $9Yn24 = parcelRequire("9Yn24");

var $9so77 = parcelRequire("9so77");

var $jg3OZ = parcelRequire("jg3OZ");

var $eZ99k = parcelRequire("eZ99k");
const $211e323f69eda16f$var$EXTENDED_CONFIGS_TYPES = [
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.PARENT_TYPE),
    (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE)
];
const $211e323f69eda16f$export$257bf52056abf5d1 = {
    [(0, $lO4Or.ASSIGNEE_TYPE)]: (0, $97NDn.AssigneeFieldTypeConfig),
    [(0, $lO4Or.ATTACHMENT_TYPE)]: (0, $6tIbT.AttachmentFieldTypeConfig),
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: (0, $dK0NF.CascadingSelectFieldTypeConfig),
    [(0, $lO4Or.CATEGORY_TYPE)]: (0, $86udM.CategoryFieldTypeConfig),
    [(0, $lO4Or.COMPONENTS_TYPE)]: (0, $kk5Iu.ComponentsFieldTypeConfig),
    [(0, $lO4Or.DATETIME_CF_TYPE)]: (0, $a1aim.DateTimeCustomFieldTypeConfig),
    [(0, $lO4Or.DATE_CF_TYPE)]: (0, $LoFQn.DateCustomFieldTypeConfig),
    [(0, $lO4Or.DESCRIPTION_TYPE)]: (0, $87PH3.DescriptionFieldTypeConfig),
    [(0, $lO4Or.DUE_DATE_TYPE)]: (0, $agYKJ.DueDateFieldTypeConfig),
    [(0, $lO4Or.GROUP_CF_TYPE)]: (0, $5zP1p.GroupCustomFieldTypeConfig),
    [(0, $lO4Or.LABELS_CF_TYPE)]: (0, $coiWz.LabelsCustomFieldTypeConfig),
    [(0, $lO4Or.LABELS_TYPE)]: (0, $bfJSC.LabelsFieldTypeConfig),
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: (0, $8nL8u.MultiCheckboxesCustomFieldTypeConfig),
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: (0, $2O5Nv.MultiGroupCustomFieldTypeConfig),
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: (0, $5jPiu.MultiSelectCustomFieldTypeConfig),
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: (0, $4cIkL.MultiUserCustomFieldTypeConfig),
    [(0, $lO4Or.NUMBER_CF_TYPE)]: (0, $6k3kI.NumberCustomFieldTypeConfig),
    [(0, $lO4Or.PARENT_TYPE)]: (0, $01FG6.ParentFieldTypeConfig),
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: (0, $kXX84.PeopleCustomFieldType),
    [(0, $lO4Or.PRIORITY_TYPE)]: (0, $zma4S.PriorityFieldTypeConfig),
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: (0, $754Vk.RadioButtonsCustomFieldTypeConfig),
    [(0, $lO4Or.SELECT_CF_TYPE)]: (0, $foE6X.SelectCustomFieldTypeConfig),
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $iSnOd.StoryPointEstimateCustomFieldTypeConfig),
    [(0, $lO4Or.SUMMARY_TYPE)]: (0, $6VKPX.SummaryFieldTypeConfig),
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: (0, $lpJww.TeamsPlatformCustomFieldTypeConfig),
    [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $9QvQg.TeamCustomFieldTypeConfig),
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: (0, $9Yn24.TextAreaCustomFieldTypeConfig),
    [(0, $lO4Or.TEXT_CF_TYPE)]: (0, $9so77.TextCustomFieldTypeConfig),
    [(0, $lO4Or.URL_CF_TYPE)]: (0, $jg3OZ.UrlCustomFieldTypeConfig),
    [(0, $lO4Or.USER_CF_TYPE)]: (0, $eZ99k.UserCustomFieldTypeConfig)
};
function $211e323f69eda16f$export$b47920a5dd99844f(type) {
    if (!(0, $eI5EY.fg)('forms_work-intake_rollout-1')) return type in $211e323f69eda16f$export$257bf52056abf5d1 && !(type in $211e323f69eda16f$var$EXTENDED_CONFIGS_TYPES);
    return type in $211e323f69eda16f$export$257bf52056abf5d1;
}
function $211e323f69eda16f$export$5be962d414ad6e6c(fieldType) {
    return $211e323f69eda16f$export$b47920a5dd99844f(fieldType) ? $211e323f69eda16f$export$257bf52056abf5d1[fieldType] : undefined;
}

});
parcelRegister("97NDn", function(module, exports) {

$parcel$export(module.exports, "AssigneeFieldTypeConfig", () => $d8cdd0a77ff2e05a$export$760aa32e02dd931e);

var $eUqFw = parcelRequire("eUqFw");

var $6nTlM = parcelRequire("6nTlM");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $d8cdd0a77ff2e05a$var$AssigneeFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nTlM.default), props);
const $d8cdd0a77ff2e05a$export$760aa32e02dd931e = {
    type: (0, $lO4Or.ASSIGNEE_TYPE),
    Component: $d8cdd0a77ff2e05a$var$AssigneeFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.AssigneeFieldPlaceholder), null),
    writer: (0, $eHQA5.assigneeFieldWriter)
};

});
parcelRegister("6nTlM", function(module, exports) {

$parcel$export(module.exports, "AssigneeField", () => $deefb1800631e37b$export$7c52097ee36bd91);
$parcel$export(module.exports, "default", () => $deefb1800631e37b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $qWkqR = parcelRequire("qWkqR");

var $lGLse = parcelRequire("lGLse");

var $8rQuz = parcelRequire("8rQuz");

var $lIor1 = parcelRequire("lIor1");

var $lgGuz = parcelRequire("lgGuz");

var $i8BXG = parcelRequire("i8BXG");
const $deefb1800631e37b$export$7c52097ee36bd91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, $8rQuz.isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const onAssignToMeClick = ()=>{
        onChange(loggedInUser);
    };
    const onAddAssigneeKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (id && (event.key === 'Enter' || event.key === ' ')) {
            onChange(loggedInUser);
            // this focus was implemented with getElementById as there is problem here using ref in UserPicker
            // doesn't pass ref to input inside the component
            setTimeout(()=>document.getElementById(id)?.focus());
        }
    }, [
        id,
        loggedInUser,
        onChange
    ]);
    const showAssignToMe = loggedInUser && !isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($deefb1800631e37b$var$FieldContainer, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qWkqR.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        shouldPreloadAssignToMe: true,
        autoCompleteUrl: autoCompleteUrl,
        enableAutomaticOption: true,
        autoFocus: autoFocus,
        isDisabled: isReadOnly,
        width: width,
        inputId: id,
        openMenuOnClick: true
    }), showAssignToMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
    }, formatMessage((0, $lgGuz.default).assignToMe)));
};
var $deefb1800631e37b$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateAssigneeField),
    transformDefaultValue: (0, $i8BXG.transformDefaultAssigneeValue // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, UserValue>, any>'.
    )
})($deefb1800631e37b$export$7c52097ee36bd91);
const $deefb1800631e37b$var$getAssignToMeButtonStyles = ()=>{
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return {
        marginTop: "var(--ds-space-050, 4px)",
        position: 'absolute',
        right: '0px',
        top: '-1px'
    };
    return {
        marginTop: "var(--ds-space-050, 4px)"
    };
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $deefb1800631e37b$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $icPhQ.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("icPhQ", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $5358eebeffdccf27$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "Description", () => $5358eebeffdccf27$export$393edc798c47379d);
$parcel$export(module.exports, "SelectContainer", () => $5358eebeffdccf27$export$446eebadefe1123b);
$parcel$export(module.exports, "Divider", () => $5358eebeffdccf27$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $5358eebeffdccf27$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $9t7rW.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $9t7rW.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $9t7rW.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$446eebadefe1123b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _1bsb1osq _bfhkb5v6 _18s8gx6n",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6HoNR", function(module, exports) {

$parcel$export(module.exports, "withFormField", () => $b5afd88747d4ca5d$export$17bf6386ac4a43ba);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $cBNnN = parcelRequire("cBNnN");

var $1KHQ1 = parcelRequire("1KHQ1");

var $ihAum = parcelRequire("ihAum");

var $g1KAP = parcelRequire("g1KAP");

var $eTZsp = parcelRequire("eTZsp");

var $7eMp1 = parcelRequire("7eMp1");

var $1zCIN = parcelRequire("1zCIN");

var $dWh83 = parcelRequire("dWh83");

var $6LDal = parcelRequire("6LDal");

var $aBj0i = parcelRequire("aBj0i");

var $kOu8r = parcelRequire("kOu8r");

var $dNWQB = parcelRequire("dNWQB");

var $2gOs4 = parcelRequire("2gOs4");


var $lVewy = parcelRequire("lVewy");

var $5i7Lk = parcelRequire("5i7Lk");

var $ewDib = parcelRequire("ewDib");

var $6UjGk = parcelRequire("6UjGk");
const $b5afd88747d4ca5d$export$17bf6386ac4a43ba = (options)=>(Component)=>// @ts-expect-error - TS2322 - Type '(ownProps: ReturnComponentProps<Config>) => JSX.Element | null' is not assignable to type 'AbstractComponent<ReturnComponentProps<Config>, any>'.
        (ownProps)=>{
            const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type '{ areUiModificationsBusy?: boolean | undefined; } & BaseField & { componentKey?: string | undefined; fieldType?: string | undefined; forge?: { selectedProject: SelectedProject; selectedIssueType: IssueOrRequestType; modules: ForgeModules; } | undefined; fieldHelpTextUrl?: string | undefined; onLayoutDone?: (() => vo...'.
            defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
            const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
            const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
            const description = (0, $g1KAP.isForgeCustomField)(fieldType) ? (0, $1zCIN.extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
            const hasSentTransformDefaultValueError = (0, $eUqFw.useRef)(false);
            let transformedDefaultValue;
            try {
                /**
     * The transformDefaultValue function is generally used to transform a defaultValue
     * that is passed from the backend, which is in a different data format to the
     * frontend data format.
     *
     * In some situations, we want to set the defaultValue using data that is already
     * in the frontend data format instead of the backend data format. In these cases
     * we want to ignore the transformDefaultValue and just use the defaultValue from props.
     *
     * To do this, we are using the defaultValueDontTransform prop to know that we
     * can safely not run transformDefaultValue.
     */ if (defaultValueDontTransform) transformedDefaultValue = defaultValue; // this can be merged into the below on ff cleanup
                else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (hasSentTransformDefaultValueError.current === false) {
                    hasSentTransformDefaultValueError.current = true;
                    (0, $guiFP.default)({
                        meta: {
                            id: 'defaultValueTransformation',
                            packageName: 'jiraIssueCreateCommons',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            fieldType: fieldType
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            (0, $eUqFw.useLayoutEffect)(()=>{
                onLayoutDone && onLayoutDone();
            }, [
                onLayoutDone
            ]);
            const shouldSetWidth = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? isMini || isFieldResponsive : isMini;
            const renderComponent = (fieldProps, error)=>// @ts-expect-error Type 'Omit<ReturnComponentProps<Config>, "fieldId" | "fieldName" | "description" | "isRequired" | "defaultValue" | "areUiModificationsBusy" | "componentKey" | "fieldType" | "forge" | "fieldHelpTextUrl" | "onLayoutDone"> & { ...; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<ComponentProps<Config, FieldValue>> & RefAttributes<any> & { ...; }'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                    ...ownPropsRest,
                    fieldId: fieldId,
                    fieldName: fieldName,
                    isRequired: isRequired,
                    fieldProps: fieldProps,
                    width: shouldSetWidth ? '100%' : undefined,
                    isMini: isMini,
                    description: description,
                    defaultValue: defaultValue,
                    error: error,
                    key: componentKey,
                    ariaLabelledBy: `${fieldId}-field-label`
                });
            const renderFieldMessage = (0, $eUqFw.useCallback)((error)=>{
                if (shouldRenderFieldMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
                    fieldId: fieldId,
                    description: description,
                    error: error,
                    fieldName: fieldName,
                    fieldHelpTextUrl: fieldHelpTextUrl,
                    onLinkClickEvent: onLinkClickEvent,
                    isMini: isMini
                });
                return null;
            }, [
                description,
                fieldHelpTextUrl,
                fieldId,
                fieldName,
                isMini,
                onLinkClickEvent,
                shouldRenderFieldMessage
            ]);
            const extension = (0, $eUqFw.useMemo)(()=>{
                if (typeof fieldType === 'string' && (0, $g1KAP.isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, $ihAum.getExtension)(fieldType, forge?.modules);
                return null;
            }, [
                fieldType,
                forge?.modules,
                forge?.hasFinishedLoading
            ]);
            (0, $eUqFw.useEffect)(()=>{
                const shouldReportFailure = typeof fieldType === 'string' && (0, $g1KAP.isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                if (shouldReportFailure) (0, $1KHQ1.reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
            }, [
                fieldType,
                extension,
                forge?.modules,
                forge?.filteredOutModules,
                forge?.hasFinishedLoading
            ]);
            const renderFieldContent = (fieldProps, error)=>{
                if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && isCollapsed) return null;
                const fieldPropsWithPublish = {
                    ...fieldProps,
                    onChange: (value, ...rest)=>{
                        fieldProps.onChange(value, ...rest);
                        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                            fieldId: fieldId,
                            fieldName: fieldName,
                            fieldType: fieldType,
                            value: (0, $kOu8r.getValueFromEventOrValue)(value)
                        });
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fieldType !== undefined && (0, $g1KAP.isForgeCustomField)(fieldType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBNnN.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    error: error,
                    selectedProject: forge?.selectedProject,
                    selectedIssueType: forge?.selectedIssueType,
                    extension: extension,
                    renderFieldMessage: renderFieldMessage,
                    renderDefaultComponent: renderComponent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $eUqFw.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
            };
            const renderFieldLabel = (0, $eUqFw.useCallback)(()=>{
                if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && isCollapsed) return ''; // TODO Merge this condition with the one below when cleaning gic-smart-fields-jira-labs_8uwvr https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $g1KAP.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1zCIN.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5afd88747d4ca5d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed
            ]);
            if ((0, $g1KAP.isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewDib.FieldSkeleton), null);
            if ((0, $g1KAP.isForgeCustomField)(fieldType) && !extension) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "withFormField",
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                sendToPrivacyUnsafeSplunk: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                id: `${fieldId}-field`,
                label: renderFieldLabel(),
                elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6LDal.FieldBusyIndicator), {
                    fieldId: fieldId
                }) : undefined,
                isRequired: isRequired,
                name: fieldId,
                defaultValue: transformedDefaultValue,
                key: (0, $6UjGk.generateKeyForRequiredFromUIM)({
                    fieldId: fieldId,
                    isRequiredFromUIM: isRequiredFromUIM === true
                }),
                validate: (value, _formState, { dirty: dirty })=>{
                    try {
                        const { type: type } = ownPropsRest;
                        if ((0, $g1KAP.isForgeCustomField)(fieldType) && isRequired) // Dirty check is required for the forge custom fields that haven't yet populated the value because it haven't lost a focus
                        return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $guiFP.default)({
                            meta: {
                                id: 'fieldValidationIssue',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return undefined;
                    }
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                    id: "issueAdjustmentsFieldValueDecorator",
                    packageName: "jiraIssueCreateModal",
                    fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps, error)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (err)=>({
                            errorType: (0, $eTZsp.getErrorType)(err),
                            viewType: (0, $036e471843230370$export$e615b7e9b8fb4715),
                            fieldId: fieldId,
                            fieldType: fieldType
                        })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lVewy.FieldValueDecoratorAsync), {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    fieldProps: fieldProps
                }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error)))))));
        };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5afd88747d4ca5d$var$ForgeLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81il0 _1e0c116y _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("cBNnN", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $27138d0822cb2352$export$34a15d6027142c62);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $5syGA = parcelRequire("5syGA");

var $elbiT = parcelRequire("elbiT");

var $6vrw7 = parcelRequire("6vrw7");

var $g1KAP = parcelRequire("g1KAP");

var $1ye4T = parcelRequire("1ye4T");

var $fRZeS = parcelRequire("fRZeS");

var $3emtP = parcelRequire("3emtP");


var $ihAum = parcelRequire("ihAum");
const $27138d0822cb2352$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
    const { onChange: onChange, value: value } = fieldProps;
    const extensionPayload = (0, $eUqFw.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $ihAum.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $eUqFw.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $g1KAP.isForgeLegacyFieldType)(fieldType) ? (0, $g1KAP.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: 'issue-create'
        };
        if (!selectedProject || !selectedIssueType) return defaultExtensionData;
        const issueTypeId = (0, $6vrw7.toIssueTypeId)(selectedIssueType.type === (0, $71f62d2bf20ef879$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
        return {
            ...defaultExtensionData,
            project: {
                id: (0, $6vrw7.toProjectId)(selectedProject.value),
                key: (0, $6vrw7.toProjectKey)(selectedProject.projectKey),
                type: selectedProject.projectType
            },
            issue: {
                type: selectedIssueType.type === (0, $71f62d2bf20ef879$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                typeId: issueTypeId
            }
        };
    }, [
        selectedProject,
        selectedIssueType,
        fieldId,
        fieldName,
        fieldType
    ]);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            renderContext: 'issue-create',
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $5syGA.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension
    ]);
    if (!extension) return null;
    const renderDefaultView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderDefaultComponent(fieldProps, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
            attributes: {
                ...analyticsAttributes,
                renderMode: 'default'
            }
        }));
    if (!extension.properties.edit) return renderDefaultView();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ye4T.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    });
};
const $27138d0822cb2352$export$34a15d6027142c62 = (props)=>{
    const { renderFieldMessage: renderFieldMessage, ...rest } = props;
    const { fieldId: fieldId, extension: extension, error: error } = rest;
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: 'issue-create',
            ...extension && (0, $5syGA.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fRZeS.FieldContainer), {
        width: "100%",
        paddingBottom: 6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27138d0822cb2352$export$4f0175d9150f8767, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3emtP.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    })));
};

});
parcelRegister("elbiT", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $4ecd31271e5beb2f$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $4ecd31271e5beb2f$export$947ae3996b2bc000);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $4ecd31271e5beb2f$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $4ecd31271e5beb2f$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("g1KAP", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $2c74677caf1ab1b7$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $2c74677caf1ab1b7$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $2c74677caf1ab1b7$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $2c74677caf1ab1b7$export$f1a0ef98758e7a8a);

var $2Rqjr = parcelRequire("2Rqjr");
const $2c74677caf1ab1b7$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $2Rqjr.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $2Rqjr.FORGE_FIELD_TYPE_PREFIX)));
const $2c74677caf1ab1b7$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $2Rqjr.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $2c74677caf1ab1b7$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $2Rqjr.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $2c74677caf1ab1b7$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$2c74677caf1ab1b7$export$78cf1b56a8dede1f(field.fieldType));
const $2c74677caf1ab1b7$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};

});

parcelRegister("1ye4T", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $a8398db8f498a4f8$export$5304145354a3bee9);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $5syGA = parcelRequire("5syGA");

var $dh9qu = parcelRequire("dh9qu");

var $elbiT = parcelRequire("elbiT");

var $7y11V = parcelRequire("7y11V");

var $7ujNe = parcelRequire("7ujNe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ihAum = parcelRequire("ihAum");

var $g3tMM = parcelRequire("g3tMM");
const $a8398db8f498a4f8$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const onEditConfirm = (0, $eUqFw.useCallback)((newValue)=>{
        onChange((0, $ihAum.transformValue)(newValue, extension));
        (0, $dh9qu.fireTrackEditedEvent)('issue-create', analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $eUqFw.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit version of 1.2.0 when inline edit is not supported
        // will be fixed with https://ecosystem-platform.atlassian.net/browse/ARKEN-32
        const translatedError = {
            message: intl.formatMessage((0, $g3tMM.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $g3tMM.default).modalModeErrorDescription)
        };
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
            ...analyticsAttributes,
            extension: JSON.stringify(extension)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ujNe.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7y11V.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $a8398db8f498a4f8$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: (0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a8398db8f498a4f8$export$ba588b5cce278e96, props));

});
parcelRegister("dh9qu", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $76db82789679977a$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $76db82789679977a$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $76db82789679977a$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $76db82789679977a$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $76db82789679977a$export$add44f896fb31ba3);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $76db82789679977a$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $76db82789679977a$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $76db82789679977a$export$1798d320c6527c08 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).EDITED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$fc09afa3d0d5294c = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CANCELED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$762dee9e981de3e1 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
    (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $76db82789679977a$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $76db82789679977a$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("7y11V", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldInlineEdit", () => $5a273adefb2c2ed1$export$ca6c6772b322056d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $18to0 = parcelRequire("18to0");

var $d6g7g = parcelRequire("d6g7g");
var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $dh9qu = parcelRequire("dh9qu");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");

var $gWRle = parcelRequire("gWRle");

const $5a273adefb2c2ed1$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("d0kAi")));
const $5a273adefb2c2ed1$var$skeletonConfig = [
    {
        width: 100
    }
];
const $5a273adefb2c2ed1$export$eef5130ba28e0f4e = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$5a273adefb2c2ed1$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));
const $5a273adefb2c2ed1$export$980ea0297ad3a4c8 = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
    const requestsCount = (0, $eUqFw.useRef)(0);
    const [, { setFieldState: setFieldState }] = (0, $18to0.useInlineField)(restProps.extensionData.fieldId);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $5a273adefb2c2ed1$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldId: extensionData.fieldId,
            fieldType: extensionData.fieldType,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const createRetryFunction = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $e456ec6df0e2a730$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $e456ec6df0e2a730$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)
                });
                (0, $dh9qu.fireOperationalEditFailedEvent)('issue-create', {
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState
    ]);
    const submit = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ data: fieldValue })=>{
        const retryFunction = createRetryFunction(fieldValue);
        setFieldState({
            fieldId: extensionData.fieldId,
            retryFunction: retryFunction
        });
        await retryFunction();
        return undefined;
    }, [
        createRetryFunction,
        extensionData.fieldId,
        setFieldState
    ]);
    const bridge = (0, $eUqFw.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWRle.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-inline-edit",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        isResizable: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a273adefb2c2ed1$export$eef5130ba28e0f4e, {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
};
const $5a273adefb2c2ed1$export$ca6c6772b322056d = $5a273adefb2c2ed1$export$980ea0297ad3a4c8;

});
const $e456ec6df0e2a730$export$32bbcfb76243a487 = 'FOCUSED';
const $e456ec6df0e2a730$export$f81c1d6b9217380c = 'PENDING';
const $e456ec6df0e2a730$export$2ace7d3737836262 = 'RESOLVED';
const $e456ec6df0e2a730$export$9956c6a700e724c4 = 'STORED';
const $e456ec6df0e2a730$export$742c877aeb0f3dbd = 'FAILED';
const $e456ec6df0e2a730$export$bbf78c43fa5268c8 = 'IDLE';
const $e456ec6df0e2a730$export$ae7c16bdba5e2e15 = 10000;
const $e456ec6df0e2a730$export$30daef8830f2505d = 'WAIT';
const $e456ec6df0e2a730$export$f86e250f1a7b07c8 = 'PROCEED';
const $e456ec6df0e2a730$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("18to0", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $dac7e85413a0f58a$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $dac7e85413a0f58a$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $dac7e85413a0f58a$export$cdb4b503c6154b35);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $7FqBr = parcelRequire("7FqBr");


var $iEhdM = parcelRequire("iEhdM");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $dac7e85413a0f58a$var$store = (0, $kEDjj.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $7FqBr.default
});
const $dac7e85413a0f58a$export$71d5b5acb7d7f5ce = (0, $1yZQx.createHook)($dac7e85413a0f58a$var$store);
const $dac7e85413a0f58a$export$14c9655e9d9e873c = (0, $1yZQx.createHook)($dac7e85413a0f58a$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $dac7e85413a0f58a$export$cdb4b503c6154b35 = (0, $1yZQx.createHook)($dac7e85413a0f58a$var$store, {
    selector: null
});

});
parcelRegister("7FqBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebb8a0129954b6a$export$2e2bcd8739ae039);

var $2h3yq = parcelRequire("2h3yq");
const $2ebb8a0129954b6a$var$actions = {
    setFieldState: $2h3yq.setFieldState,
    resetState: $2h3yq.resetState,
    dispatchRetryFunction: $2h3yq.dispatchRetryFunction,
    dispatchFormSubmits: $2h3yq.dispatchFormSubmits
};
var $2ebb8a0129954b6a$export$2e2bcd8739ae039 = $2ebb8a0129954b6a$var$actions;

});
parcelRegister("2h3yq", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $99f6e2cbf5817dbf$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $99f6e2cbf5817dbf$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $99f6e2cbf5817dbf$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $99f6e2cbf5817dbf$export$42fd5e650971333b);


var $iEhdM = parcelRequire("iEhdM");
const $99f6e2cbf5817dbf$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $99f6e2cbf5817dbf$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $e456ec6df0e2a730$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $99f6e2cbf5817dbf$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $99f6e2cbf5817dbf$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487)) {
                const formRef = currentState[fieldId]?.formRef;
                (0, $iEhdM.dispatchFormSubmitAndBlurElements)(formRef);
            }
        });
    };

});
parcelRegister("iEhdM", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $2e80a23b0db03f29$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $2e80a23b0db03f29$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $2e80a23b0db03f29$export$ee23412a8bea9333);

const $2e80a23b0db03f29$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $2e80a23b0db03f29$export$4d639a8e0790daf2 = (formRef)=>{
    $2e80a23b0db03f29$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $2e80a23b0db03f29$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("gamHX", function(module, exports) {

$parcel$export(module.exports, "LazyIframe", () => $06c11067a462069c$export$808646051d5a3908);
$parcel$export(module.exports, "LazyModalIframe", () => $06c11067a462069c$export$f35ac420e260eb7);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $06c11067a462069c$var$getModule = ()=>(parcelRequire("hzQkV"));
const $06c11067a462069c$export$808646051d5a3908 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$06c11067a462069c$var$getModule().then((module)=>module.IframeRenderer), {
    ssr: false
}));
const $06c11067a462069c$export$f35ac420e260eb7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$06c11067a462069c$var$getModule().then((module)=>module.ModalIframeRenderer), {}));

});
parcelRegister("hzQkV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8ficv")
]).then(()=>parcelRequire('kq5KC'));

});


parcelRegister("8Nthx", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $fb59735ddb4a6800$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $fb59735ddb4a6800$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 = [];
const $fb59735ddb4a6800$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb59735ddb4a6800$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $fb59735ddb4a6800$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $fb59735ddb4a6800$var$layoutStyles
    }, children);
};
const $fb59735ddb4a6800$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb59735ddb4a6800$var$ForgeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $9t7rW.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $fb59735ddb4a6800$var$layoutStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("gWRle", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1ee7d0bd2c357478$export$238f56c0891e9254);

var $eUqFw = parcelRequire("eUqFw");
const $1ee7d0bd2c357478$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1ee7d0bd2c357478$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7d0bd2c357478$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("d0kAi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("RRgs6")
]).then(()=>parcelRequire('akozD'));

});


parcelRegister("7ujNe", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $4f4c1cd445d31479$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1N1hD = parcelRequire("1N1hD");
const $4f4c1cd445d31479$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $4f4c1cd445d31479$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $eUqFw.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $1N1hD.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$LoaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

parcelRegister("1N1hD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b96b0ffaa98017$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c9b96b0ffaa98017$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("ihAum", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $ee07455a18ab8873$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $ee07455a18ab8873$export$b82f09291a00d8c1);
$parcel$export(module.exports, "getExtension", () => $ee07455a18ab8873$export$78d71f9ed5534abe);

var $26Ej0 = parcelRequire("26Ej0");

var $g1KAP = parcelRequire("g1KAP");

var $hRB01 = parcelRequire("hRB01");
const $ee07455a18ab8873$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $26Ej0.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $ee07455a18ab8873$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $ee07455a18ab8873$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list') // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $26Ej0.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $hRB01.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $ee07455a18ab8873$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $ee07455a18ab8873$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $g1KAP.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $g1KAP.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $ee07455a18ab8873$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $ee07455a18ab8873$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $ee07455a18ab8873$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($ee07455a18ab8873$export$3e406786572c35b0);
    return $ee07455a18ab8873$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("26Ej0", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $14639b9418410a0a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mapLabelOptionsToData", () => $14639b9418410a0a$export$1bf703d99c7bcef6);
$parcel$export(module.exports, "mapLabelsResponseToLabelOptions", () => $14639b9418410a0a$export$37f55c1f665c1221);
const $14639b9418410a0a$export$cd8e373d5b1325b1 = (data)=>{
    if (!data) return [];
    return data.map((value)=>({
            value: value,
            label: value
        }));
};
const $14639b9418410a0a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
const $14639b9418410a0a$export$37f55c1f665c1221 = (response)=>{
    const { suggestions: suggestions } = response;
    if (!suggestions) return [];
    return suggestions.map(({ label: label })=>({
            label: label,
            value: label
        }));
};

});

parcelRegister("hRB01", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $08f388d684ecc28c$export$2de59005e10fd82);

var $4ZYEI = parcelRequire("4ZYEI");
const $08f388d684ecc28c$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});


parcelRegister("g3tMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4af9ed51105eb0d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d4af9ed51105eb0d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalModeErrorTitle: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("fRZeS", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $09167391bf95b0d0$export$b5c4b0e7cd7f148b);
/* FieldContainer.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $09167391bf95b0d0$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $9t7rW.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $9t7rW.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $9t7rW.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3emtP", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $98796909a57234a2$export$1df6b326181f4cdf);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");

var $4Bees = parcelRequire("4Bees");

var $18to0 = parcelRequire("18to0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8QwcR = parcelRequire("8QwcR");

var $faqsX = parcelRequire("faqsX");

var $5Pufx = parcelRequire("5Pufx");
const $98796909a57234a2$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $eUqFw.useRef)(false);
    const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
    const [fieldState] = (0, $18to0.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Pufx.MessagePartsSeparationWrapper), null, formatMessage((0, $faqsX.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QwcR.ForgeFieldDispatchButton), {
            fieldId: fieldId
        }));
    const renderSuccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ValidMessage), null, formatMessage((0, $faqsX.default).forgeFieldSuccessTextLabel));
    const renderHelperMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Pufx.MessagePartsSeparationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        })), formatMessage((0, $faqsX.default).forgeFieldPendingTextLabel));
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderFieldMessage(error));
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
            case 0, $e456ec6df0e2a730$export$742c877aeb0f3dbd:
                return renderErrorMessage();
            case 0, $e456ec6df0e2a730$export$9956c6a700e724c4:
                return renderSuccessMessage();
            case 0, $e456ec6df0e2a730$export$f81c1d6b9217380c:
            case 0, $e456ec6df0e2a730$export$2ace7d3737836262:
                return renderHelperMessage();
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return renderErrorMessage();
    }
    return renderDefaultErrorMessage();
};

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a280b44c69b6de4f4f93ebdb24542b07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});



parcelRegister("8QwcR", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $7300563cb017b36c$export$59e3aafda495153);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $18to0 = parcelRequire("18to0");
const $7300563cb017b36c$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $18to0.useInlineField)(fieldId);
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, "Try again?");
        return null;
    };
    return renderRetryButton();
};

});

parcelRegister("faqsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec495e70ce24e59$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dec495e70ce24e59$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});

parcelRegister("5Pufx", function(module, exports) {

$parcel$export(module.exports, "MessagePartsSeparationWrapper", () => $62516afcda8e2944$export$16fadfc3d05f6fc0);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // For now, it only gives some space between the spinner and the message
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $62516afcda8e2944$export$16fadfc3d05f6fc0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});


const $71f62d2bf20ef879$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $71f62d2bf20ef879$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $71f62d2bf20ef879$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $71f62d2bf20ef879$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $71f62d2bf20ef879$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $71f62d2bf20ef879$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $71f62d2bf20ef879$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
const $71f62d2bf20ef879$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $71f62d2bf20ef879$export$ebb48b08205007c5 = 'ISSUE_TYPE';


parcelRegister("1KHQ1", function(module, exports) {

$parcel$export(module.exports, "reportForgeFailure", () => $9c720473927796b8$export$e95b9e5003024a9c);

var $dh9qu = parcelRequire("dh9qu");

var $g1KAP = parcelRequire("g1KAP");
const $9c720473927796b8$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
    const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, $g1KAP.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $g1KAP.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
    /*
        Not log error:
         * if the extensions is filtered out by display conditions or access narrowing
         * if the forge data is empty (when fetching error there is an excluded error, empty response is returned)
    */ if (isEmptyForgeData || isExtensionFilteredOut) return;
    (0, $dh9qu.fireOperationalFailedEvent)('issue-create', {
        error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
        renderContext: 'issue-create'
    });
};

});

parcelRegister("1zCIN", function(module, exports) {

$parcel$export(module.exports, "extractEnvFromFieldDescription", () => $4a572015a6dc1e3e$export$dfa36573f3bd00af);
const $4a572015a6dc1e3e$var$DEV_PREFIX = '(DEVELOPMENT) ';
const $4a572015a6dc1e3e$var$STG_PREFIX = '(STAGING) ';
const $4a572015a6dc1e3e$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
    if (descriptionWithEnv?.startsWith($4a572015a6dc1e3e$var$DEV_PREFIX)) return {
        environment: 'DEVELOPMENT',
        description: descriptionWithEnv.replace($4a572015a6dc1e3e$var$DEV_PREFIX, '')
    };
    if (descriptionWithEnv?.startsWith($4a572015a6dc1e3e$var$STG_PREFIX)) return {
        environment: 'STAGING',
        description: descriptionWithEnv.replace($4a572015a6dc1e3e$var$STG_PREFIX, '')
    };
    return {
        environment: 'PRODUCTION',
        description: descriptionWithEnv ?? ''
    };
};

});

parcelRegister("dWh83", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryBypassProvider", () => $01b98097d656a3ff$export$a5feb4d632b53009);
$parcel$export(module.exports, "ErrorBoundaryBypassInput", () => $01b98097d656a3ff$export$36798a6d5688c318);
$parcel$export(module.exports, "ErrorBoundaryBypassOutput", () => $01b98097d656a3ff$export$775be62266860b86);

var $eUqFw = parcelRequire("eUqFw");
const $01b98097d656a3ff$var$ErrorBoundaryBypassApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $01b98097d656a3ff$var$ErrorBoundaryBypassErrorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $01b98097d656a3ff$export$a5feb4d632b53009 = ({ children: children })=>{
    const [bypassedError, setBypassedError] = (0, $eUqFw.useState)(null);
    const api = (0, $eUqFw.useMemo)(()=>({
            // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
            swallowError: (error)=>{
                setBypassedError(error);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01b98097d656a3ff$var$ErrorBoundaryBypassErrorContext.Provider, {
        value: bypassedError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01b98097d656a3ff$var$ErrorBoundaryBypassApiContext.Provider, {
        value: api
    }, children));
};
class $01b98097d656a3ff$export$36798a6d5688c318 extends (0, $eUqFw.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        if (this.context !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.context.swallowError(error);
    }
    static{
        this.contextType = $01b98097d656a3ff$var$ErrorBoundaryBypassApiContext;
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
const $01b98097d656a3ff$export$775be62266860b86 = ()=>{
    const bypassedError = (0, $eUqFw.useContext)($01b98097d656a3ff$var$ErrorBoundaryBypassErrorContext);
    if (bypassedError !== null) throw bypassedError;
    return null;
};

});

parcelRegister("6LDal", function(module, exports) {

$parcel$export(module.exports, "FieldBusyIndicator", () => $e3d5ba0b8ddbe369$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gzBuH = parcelRequire("gzBuH");

var $5hFCF = parcelRequire("5hFCF");
const $e3d5ba0b8ddbe369$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const loadingMessage = formatMessage((0, $5hFCF.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3d5ba0b8ddbe369$export$4e31364808fb7483, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzBuH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: indicatorId,
        size: "small"
    }))));
});
$e3d5ba0b8ddbe369$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e3d5ba0b8ddbe369$export$4e31364808fb7483 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gzBuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6303a1693ea37869$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aTx5K = parcelRequire("aTx5K");
function $6303a1693ea37869$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentProfilerContext = (0, $eUqFw.useContext)((0, $7rh0R.ProfilerContext));
    const ignoredRLLProfilerContext = (0, $eUqFw.useMemo)(()=>({
            ...parentProfilerContext,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackMounted () {},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackUnmounted () {}
        }), [
        parentProfilerContext
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTx5K.default), {
        ignore: ignore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: ignoredRLLProfilerContext
    }, kids));
}

});
parcelRegister("aTx5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ad7ab78a19ec4c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jsCXU = parcelRequire("jsCXU");
function $99ad7ab78a19ec4c$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const ignoredInteractionContext = (0, $eUqFw.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsCXU.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
}

});


parcelRegister("5hFCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e5ff97e78fc07e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8e5ff97e78fc07e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        "id": "issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content",
        "defaultMessage": "Loading UI modifications..."
    }
});

});


parcelRegister("aBj0i", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentsErrorHandler", () => $3ed727681dfad4c2$export$68b86a282e98ff70);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");
const $3ed727681dfad4c2$export$68b86a282e98ff70 = ()=>{
    const { setError: setError, resetError: resetError } = (0, $fcNlw.useIssueAdjustmentsActions)();
    (0, $eUqFw.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});
parcelRegister("fcNlw", function(module, exports) {

$parcel$export(module.exports, "store", () => $712150835f54079d$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $712150835f54079d$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useAnalyticsData", () => $712150835f54079d$export$45885672916a1436);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $712150835f54079d$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $712150835f54079d$export$677b3e34bd14c681);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");

var $5hhPg = parcelRequire("5hhPg");
var $aqdD8 = parcelRequire("aqdD8");
var $4BYh6 = parcelRequire("4BYh6");
var $5v1Sk = parcelRequire("5v1Sk");
var $4QLO7 = parcelRequire("4QLO7");
var $3P2qm = parcelRequire("3P2qm");
var $7mVyC = parcelRequire("7mVyC");
var $gwHjs = parcelRequire("gwHjs");
var $juRVB = parcelRequire("juRVB");
var $cQ3jb = parcelRequire("cQ3jb");
var $2ugNi = parcelRequire("2ugNi");
var $51sNT = parcelRequire("51sNT");
const $712150835f54079d$var$name = 'issue-adjustments';
const $712150835f54079d$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    analyticsData: {},
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appsErrors: {}
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $712150835f54079d$var$triggerFieldInitializationKey, viewType: $712150835f54079d$var$scopedViewType, numberOfSupportedFields: $712150835f54079d$var$numberOfSupportedFields, ...$712150835f54079d$var$stateForResetAllFields } = $712150835f54079d$export$d4c72bab9d6cc13a;
const $712150835f54079d$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5v1Sk.processChange,
    setFieldValue: $gwHjs.setFieldValue,
    initializeField: $5hhPg.initializeField,
    startFieldsInitialisationTimeout: $juRVB.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $juRVB.successFieldsInitalisation,
    registerFields: $4QLO7.registerFields,
    unregisterFields: $4QLO7.unregisterFields,
    updateFields: $2ugNi.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($712150835f54079d$var$stateForResetAllFields);
        },
    setError: $7mVyC.setError,
    resetError: $7mVyC.resetError,
    setAnalyticsData: (analyticsData)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().analyticsData ?? {};
            setState({
                analyticsData: {
                    ...previousState,
                    ...analyticsData
                }
            });
        },
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3P2qm.setAppErrors,
    resetAppErrors: $3P2qm.resetAppErrors,
    initializeNoScreenTab: $aqdD8.initializeNoScreenTab,
    initializeScreenTabs: $4BYh6.initializeScreenTabs,
    updateScreenTabs: $51sNT.updateScreenTabs,
    updateActiveScreenTab: $cQ3jb.updateActiveScreenTab
};
const $712150835f54079d$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: $712150835f54079d$var$name,
    initialState: $712150835f54079d$export$d4c72bab9d6cc13a,
    actions: $712150835f54079d$export$e324594224ef24da
});
const $712150835f54079d$export$37792a602e748c08 = (0, $1yZQx.createHook)($712150835f54079d$export$6f57813fe9f31bf9);
const $712150835f54079d$var$stableEmptyFieldFromIframe = {};
const $712150835f54079d$export$df4b0714e8177e0e = (0, $1yZQx.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $712150835f54079d$var$stableEmptyFieldFromIframe
});
const $712150835f54079d$export$45885672916a1436 = (0, $1yZQx.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state)=>state.analyticsData
});
const $712150835f54079d$export$cb9a014ec14556d8 = (0, $1yZQx.createActionsHook)($712150835f54079d$export$6f57813fe9f31bf9);
const $712150835f54079d$export$677b3e34bd14c681 = (0, $1yZQx.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("5hhPg", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $4a4217001e2b8280$export$6b51e123e61a9615);

var $2brTl = parcelRequire("2brTl");
const $4a4217001e2b8280$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };

});
parcelRegister("2brTl", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $d67d5ad1d534dc24$export$50806045b617d116);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");
const $d67d5ad1d534dc24$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $h1jSL.fireIAErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("h1jSL", function(module, exports) {

$parcel$export(module.exports, "fireIAErrorAnalytics", () => $31b678c9ad2da8b8$export$319cadf5a1a1b6a7);

var $guiFP = parcelRequire("guiFP");

var $eTZsp = parcelRequire("eTZsp");
const $31b678c9ad2da8b8$export$319cadf5a1a1b6a7 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $eTZsp.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $guiFP.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            errorType: errorType,
            ...attributes
        }
    });
};
const $31b678c9ad2da8b8$export$7ca48916618a8ab2 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $eTZsp.getErrorType)(error);
    const packageName = 'jiraUiModifications';
    (0, $guiFP.default)({
        event: event,
        meta: {
            id: id,
            teamName: 'unbox',
            packageName: packageName
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            errorType: errorType,
            ...attributes,
            viewType: viewType
        }
    });
};

});

parcelRegister("8ibkc", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $9883d6a43ab701de$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $9883d6a43ab701de$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $9883d6a43ab701de$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isProjectTypeSupported", () => $9883d6a43ab701de$export$cd7c26587dda4120);
$parcel$export(module.exports, "getAnalytics", () => $9883d6a43ab701de$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $9883d6a43ab701de$export$ef45e4471aa21b27);
$parcel$export(module.exports, "isScreenTabsSupportEnabled", () => $9883d6a43ab701de$export$71e5898a2b967ce3);

var $h1jSL = parcelRequire("h1jSL");

var $7vcoF = parcelRequire("7vcoF");
const $9883d6a43ab701de$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $9883d6a43ab701de$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $7vcoF.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $9883d6a43ab701de$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$9883d6a43ab701de$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $9883d6a43ab701de$export$e4330d77fd93d1de = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
const $9883d6a43ab701de$export$72171ea4e785fc66 = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedProjectTypes();
function $9883d6a43ab701de$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $9883d6a43ab701de$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $9883d6a43ab701de$export$20eabd2b3ada6bf3(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $9883d6a43ab701de$export$cd7c26587dda4120(project, viewType) {
    return $9883d6a43ab701de$export$72171ea4e785fc66(viewType).includes(project.type);
}
function $9883d6a43ab701de$export$b0297573c90085aa(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $9883d6a43ab701de$export$c0728caa743a409e(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $9883d6a43ab701de$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $9883d6a43ab701de$export$c0728caa743a409e(viewType).has(triggerPoint);
const $9883d6a43ab701de$export$71e5898a2b967ce3 = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).isScreenTabsSupportEnabled();

});
parcelRegister("7vcoF", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $729488f5ba158c79$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $729488f5ba158c79$export$f0022a21ccd1f6be);

var $eUqFw = parcelRequire("eUqFw");
const $729488f5ba158c79$var$VIEW_CONFIGURATIONS = new Map();
const $729488f5ba158c79$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$729488f5ba158c79$var$VIEW_CONFIGURATIONS.has(viewType)) $729488f5ba158c79$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $729488f5ba158c79$export$176b6e68da08ffa2 = (viewType)=>$729488f5ba158c79$var$VIEW_CONFIGURATIONS.get(viewType);
const $729488f5ba158c79$export$e8091eff40c4f16e = ()=>{
    $729488f5ba158c79$var$VIEW_CONFIGURATIONS.clear();
};
const $729488f5ba158c79$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eUqFw.useState)(()=>{
        $729488f5ba158c79$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("aqdD8", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $1128821d446563be$export$93459ad9bfd6c380);
const $1128821d446563be$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("4BYh6", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $ffd70689a2678058$export$7f7be235f64f029b);
const $ffd70689a2678058$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5v1Sk", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $c7e1595f1029ad04$export$352dfcce04d66748);

var $d2gyF = parcelRequire("d2gyF");

var $1ybV0 = parcelRequire("1ybV0");

var $8ibkc = parcelRequire("8ibkc");

var $4XxH1 = parcelRequire("4XxH1");
const $c7e1595f1029ad04$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType, fieldType: fieldType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        const emitChangeOn = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const nextFormData = (0, $4XxH1.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, (/*@__PURE__*/$parcel$interopDefault($d2gyF)))() : undefined;
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("d2gyF", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/** Used to generate unique IDs. */ var $97d84e6072626d2c$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $97d84e6072626d2c$var$uniqueId(prefix) {
    var id = ++$97d84e6072626d2c$var$idCounter;
    return $1uqnh(prefix) + id;
}
module.exports = $97d84e6072626d2c$var$uniqueId;

});

parcelRegister("4XxH1", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $895b39e97d23f926$export$25441a03bb8f1cb0);

var $hTLlD = parcelRequire("hTLlD");

var $eI5EY = parcelRequire("eI5EY");

var $2bv99 = parcelRequire("2bv99");

var $2brTl = parcelRequire("2brTl");
const $895b39e97d23f926$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    if ((0, $eI5EY.fg)('handle_set_value_for_uninitialized_field')) try {
        newPublicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        (0, $2bv99.fireOperationalAnalyticsWithoutContext)('internalToPublicValueTransformer', 'fieldMetadataUndefined', viewType, {
            fieldType: fieldType
        });
        return null;
    }
    else newPublicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
        fieldMetadata: internalFormMetadata[fieldId],
        internalFieldValue: fieldValue,
        fieldType: fieldType,
        viewType: viewType
    });
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});
parcelRegister("2bv99", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalyticsWithoutContext", () => $9bb7bb1bc373c32d$export$92f0a000de1dacb3);
$parcel$export(module.exports, "fireOperationalAnalyticsWithContext", () => $9bb7bb1bc373c32d$export$5ac7b3728975936c);
// jira-frontend/browse/src/packages/platform/observability/product-analytics-bridge/README.md#Tracking outside of UI

var $jMP2a = parcelRequire("jMP2a");

var $3DOEL = parcelRequire("3DOEL");
const $9bb7bb1bc373c32d$export$92f0a000de1dacb3 = (actionSubject, action, viewType, attributes = {})=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
        action: action,
        actionSubject: `jiraUiModifications.${actionSubject}`,
        source: viewType,
        attributes: {
            ...attributes,
            viewType: viewType
        }
    });
const $9bb7bb1bc373c32d$export$5ac7b3728975936c = (event, id, viewType, attributes = {})=>{
    (0, $jMP2a.fireOperationalAnalytics)(event, `jiraUiModifications.${id}`, {
        ...attributes,
        viewType: viewType
    });
};

});



parcelRegister("4QLO7", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $745940e83e6bea58$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $745940e83e6bea58$export$1ca69a85bb7273de);

var $kFGm5 = parcelRequire("kFGm5");

var $MdoH4 = parcelRequire("MdoH4");

var $1ybV0 = parcelRequire("1ybV0");
const $745940e83e6bea58$var$registerFieldsFFOn = ({ getState: getState, setState: setState, changeId: changeId, appId: appId, fieldsToBeRegistered: fieldsToBeRegistered })=>{
    const { registeredFields: registeredFields } = getState();
    const appFields = registeredFields[appId] ?? {};
    const appChangeIdFields = appFields[changeId] ?? [];
    const nextRegisteredFields = {
        ...registeredFields,
        [appId]: {
            ...appFields,
            [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...appChangeIdFields,
                ...fieldsToBeRegistered
            ])
        }
    };
    setState({
        registeredFields: nextRegisteredFields
    });
};
const $745940e83e6bea58$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) $745940e83e6bea58$var$registerFieldsFFOn({
            getState: getState,
            setState: setState,
            changeId: changeId,
            appId: appId,
            fieldsToBeRegistered: fieldsToBeRegistered
        });
        else {
            const alreadyRegisteredFields = getState().registeredFieldsDeprecated;
            setState({
                registeredFieldsDeprecated: {
                    ...alreadyRegisteredFields,
                    [changeId]: fieldsToBeRegistered
                }
            });
        }
    };
const $745940e83e6bea58$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) {
            const { registeredFields: registeredFields } = getState();
            const registeredAppFields = registeredFields[appId] ?? {};
            const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(registeredAppFields, changeId);
            setState({
                registeredFields: {
                    ...registeredFields,
                    [appId]: nextRegisteredAppFields
                }
            });
        } else setState({
            registeredFieldsDeprecated: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(getState().registeredFieldsDeprecated, changeId)
        });
    };

});

parcelRegister("3P2qm", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $a351a7797518b436$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "resetAppErrors", () => $a351a7797518b436$export$24c821207687a907);
const $a351a7797518b436$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $a351a7797518b436$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("7mVyC", function(module, exports) {

$parcel$export(module.exports, "setError", () => $dfad354765909d34$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $dfad354765909d34$export$7e5930c6217b1d4e);
const $dfad354765909d34$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $dfad354765909d34$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("gwHjs", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $e9fd5dd289ce7424$export$6556d46d2662453c);

var $4XxH1 = parcelRequire("4XxH1");
const $e9fd5dd289ce7424$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $4XxH1.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("juRVB", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $ef2c7adb6b78931a$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $ef2c7adb6b78931a$export$cf768a695e83eefa);

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");

var $3UFcS = parcelRequire("3UFcS");

var $7mVyC = parcelRequire("7mVyC");
const $ef2c7adb6b78931a$var$getTimeout = ()=>(0, $1ybV0.getFeatureFlagValue)('forge-ui-modifications-fields-initialization-timeout', 15000);
const $ef2c7adb6b78931a$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $ef2c7adb6b78931a$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $ef2c7adb6b78931a$export$2c0f020b89dfa30b = ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($ef2c7adb6b78931a$export$8ce83a9201590a5e()), $ef2c7adb6b78931a$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $ef2c7adb6b78931a$export$8ce83a9201590a5e = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($ef2c7adb6b78931a$var$isFieldInitialisationComplete(status) || ((0, $1ybV0.ff)('forge-ui-modifications-screentabs_qoa33') ? (0, $3UFcS.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null : (0, $3UFcS.selectReadyFieldsOld)(getState(), undefined) !== null)) return;
        dispatch((0, $7mVyC.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization timedOut', viewType, {
            previousStatus: status,
            configuredTimeout: $ef2c7adb6b78931a$var$getTimeout(),
            fieldsInitializationTime: $ef2c7adb6b78931a$var$getFieldsInitializationTime(startTime),
            initalizedFieldsCount: Object.keys(formData ?? {}).length,
            experienceDataIsLoading: experienceDataIsLoading,
            supportedFieldsCount: numberOfSupportedFields
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $ef2c7adb6b78931a$export$cf768a695e83eefa = ()=>({ getState: getState, setState: setState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($ef2c7adb6b78931a$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization success', viewType, {
            previousStatus: status,
            fieldsInitializationTime: $ef2c7adb6b78931a$var$getFieldsInitializationTime(startTime),
            initalizedFieldsCount: numberOfSupportedFields
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("3UFcS", function(module, exports) {

$parcel$export(module.exports, "selectReadyFieldsOld", () => $c53e858e46a423f2$export$8f4fb114be4d807);
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $c53e858e46a423f2$export$4cadeedb8c3f31f7);

var $8ibkc = parcelRequire("8ibkc");

var $1jo4G = parcelRequire("1jo4G");
const $c53e858e46a423f2$export$8f4fb114be4d807 = (0, $1jo4G.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, experienceDataIsLoading)=>{
    if (formData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return formData;
    return null;
});
const $c53e858e46a423f2$export$4cadeedb8c3f31f7 = (0, $1jo4G.createSelector)((_, props)=>props.viewType, (state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && !(0, $8ibkc.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: []
    };
    if (formData !== null && screenTabsData !== null && (0, $8ibkc.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("cQ3jb", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $ca2372258451375d$export$21363496760d39cd);
const $ca2372258451375d$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("2ugNi", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $0896ca7411360473$export$cceae62fd4d1ef0a);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");


var $7h8I4 = parcelRequire("7h8I4");
var $hGbVp = parcelRequire("hGbVp");
var $lB1pd = parcelRequire("lB1pd");

var $fsCiP = parcelRequire("fsCiP");

var $fUNS1 = parcelRequire("fUNS1");

var $7CbIv = parcelRequire("7CbIv");
const $0896ca7411360473$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId })=>async ({ setState: setState, getState: getState }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges || {};
        const formData = getState().formData || {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, registeredFieldsDeprecated: registeredFieldsDeprecated } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, $7h8I4.fieldWasRegistered)(registeredFields, changeId, fieldId, appId) : (0, $7h8I4.fieldWasRegisteredDeprecated)(registeredFieldsDeprecated, changeId, fieldId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                // eslint-disable-next-line no-console
                console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                (0, $2bv99.fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                    message: 'Attempt to apply changes to a field that was not registered',
                    fieldId: fieldId
                });
                return acc;
            }
            const lookupData = {
                [(0, $6b8c146c2dd688bb$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $6b8c146c2dd688bb$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $7CbIv.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                viewContext: viewContext,
                environment: environment
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lB1pd.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $hGbVp.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(combinedChangesToApply)) {
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(errorsByField)) throw new (0, $fsCiP.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $fUNS1.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
    };

});
const $6b8c146c2dd688bb$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $6b8c146c2dd688bb$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $6b8c146c2dd688bb$export$f5d5f6bb902f1027 = '-1';
const $6b8c146c2dd688bb$export$106087dcfd4fb129 = 100;

parcelRegister("7h8I4", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegisteredDeprecated", () => $86ebc8f98d26cbd3$export$fce3a63433d10493);
$parcel$export(module.exports, "fieldWasRegistered", () => $86ebc8f98d26cbd3$export$fbe9157c12cb4e7b);
const $86ebc8f98d26cbd3$export$fce3a63433d10493 = (registeredFields, changeId, fieldId)=>registeredFields[changeId]?.includes(fieldId);
const $86ebc8f98d26cbd3$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("hGbVp", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $29afb4d5faeca466$export$460820f27643954e);

var $8ibkc = parcelRequire("8ibkc");
const $29afb4d5faeca466$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("lB1pd", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $d133bdec274d1c3f$export$aa453854f74fab);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");
const $d133bdec274d1c3f$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("fsCiP", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b179e025ecadff0b$export$9e8b5e552e255163);

var $gkGcM = parcelRequire("gkGcM");
class $b179e025ecadff0b$export$9e8b5e552e255163 extends (0, $gkGcM.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("gkGcM", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $e9642cd3efc03536$export$6e8165c81a6a65df);
class $e9642cd3efc03536$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("fUNS1", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $ef7370b518a4155c$export$e1fce51bc5be90b7);
const $ef7370b518a4155c$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("7CbIv", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0921c7ca821fb6e8$export$d14f85c01e334a1);

var $8blac = parcelRequire("8blac");

var $2Vsz9 = parcelRequire("2Vsz9");
var $8ibkc = parcelRequire("8ibkc");


var $WO73Y = parcelRequire("WO73Y");

var $KAPjp = parcelRequire("KAPjp");

var $fW80u = parcelRequire("fW80u");
const $0921c7ca821fb6e8$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, viewContext: viewContext, environment: environment })=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $KAPjp.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $KAPjp.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                viewContext: viewContext,
                environment: environment,
                fieldContext: fieldContext
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $2Vsz9.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $cbc8852d406ad3b6$export$d1996cb46a690190),
                        method: (0, $WO73Y.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $fW80u.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $fW80u.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("2Vsz9", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $583216437d6b2342$export$73c2f0689b6c4a5a);
class $583216437d6b2342$export$73c2f0689b6c4a5a extends Error {
}

});

const $cbc8852d406ad3b6$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $cbc8852d406ad3b6$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $cbc8852d406ad3b6$export$83ecd24e1e791a18 = 'MULTI_APP_CONFLICT_ERROR';
const $cbc8852d406ad3b6$export$555348e85753677 = 'CONFLICT_CAUSE_FIELD';
const $cbc8852d406ad3b6$export$76e14ea30e1693a6 = 'CONFLICT_CAUSE_SCREENTABS';
const $cbc8852d406ad3b6$export$aba0228f06b6907b = 'CONFLICT_CAUSE_OTHER_APPS';

parcelRegister("WO73Y", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $f0920af4bdd7ca41$export$e1cc7da28a1c4bb7);
const $f0920af4bdd7ca41$var$SET_NAME_METHOD = 'setName';
const $f0920af4bdd7ca41$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $f0920af4bdd7ca41$var$SET_VISIBLE_METHOD = 'setVisible';
const $f0920af4bdd7ca41$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $f0920af4bdd7ca41$var$SET_VALUE_METHOD = 'setValue';
const $f0920af4bdd7ca41$var$SET_REQUIRED_METHOD = 'setRequired';
const $f0920af4bdd7ca41$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $f0920af4bdd7ca41$export$8325709d137b2606 = {
    fieldName: $f0920af4bdd7ca41$var$SET_NAME_METHOD,
    description: $f0920af4bdd7ca41$var$SET_DESCRIPTION_METHOD,
    isVisible: $f0920af4bdd7ca41$var$SET_VISIBLE_METHOD,
    isReadOnly: $f0920af4bdd7ca41$var$SET_READ_ONLY_METHOD,
    value: $f0920af4bdd7ca41$var$SET_VALUE_METHOD,
    isRequired: $f0920af4bdd7ca41$var$SET_REQUIRED_METHOD,
    optionsVisibility: $f0920af4bdd7ca41$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $f0920af4bdd7ca41$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $f0920af4bdd7ca41$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("KAPjp", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $31d75f6b66e8195c$export$ee79e3ab53b8db79);
const $31d75f6b66e8195c$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("fW80u", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $130c7c4675a36fa8$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $130c7c4675a36fa8$export$ddd005554aecd409);
const $130c7c4675a36fa8$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $130c7c4675a36fa8$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("51sNT", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $1b694249b98b7d22$export$131c67fd312b8a11);

var $250Jk = parcelRequire("250Jk");

var $kL6yx = parcelRequire("kL6yx");

var $hHma7 = parcelRequire("hHma7");
const $1b694249b98b7d22$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        if (screenTabsFromIframe && internalScreenTabs && (0, $250Jk.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) setState({
            screenTabs: (0, $250Jk.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe)
        });
        else throw new (0, $hHma7.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $250Jk.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $kL6yx.toScreenTabsValidationError))
        });
    };

});
parcelRegister("250Jk", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $84a538ddabf922c3$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $84a538ddabf922c3$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $84a538ddabf922c3$export$62d63af83dac7315);

var $8xPow = parcelRequire("8xPow");
const $84a538ddabf922c3$var$isValidScreenTabId = (internalScreenTabs, id)=>(0, $8xPow.isNotEmptyString)(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $84a538ddabf922c3$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $84a538ddabf922c3$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $84a538ddabf922c3$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$84a538ddabf922c3$var$isValidScreenTabId(internalScreenTabs, id) && $84a538ddabf922c3$var$isValidScreenTabIsVisible(isVisible) && $84a538ddabf922c3$var$isValidScreenTabIsActive(isActive);
const $84a538ddabf922c3$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($84a538ddabf922c3$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $84a538ddabf922c3$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($84a538ddabf922c3$var$isValidScreenTabIsActive(isActive) && isActive && $84a538ddabf922c3$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $84a538ddabf922c3$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $84a538ddabf922c3$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$84a538ddabf922c3$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($84a538ddabf922c3$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($84a538ddabf922c3$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $84a538ddabf922c3$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($84a538ddabf922c3$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($84a538ddabf922c3$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});
parcelRegister("8xPow", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyString", () => $5bbf28343919e2e5$export$582443c7ead02173);
const $5bbf28343919e2e5$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});


parcelRegister("kL6yx", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $c8201c0c5a7af4c8$export$b2675440ade984fb);

const $c8201c0c5a7af4c8$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $cbc8852d406ad3b6$export$fd26696d109785a0)
    });

});

parcelRegister("hHma7", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $3824179c819605a1$export$faf1f1824ee0a136);

var $gkGcM = parcelRequire("gkGcM");
class $3824179c819605a1$export$faf1f1824ee0a136 extends (0, $gkGcM.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});




parcelRegister("kOu8r", function(module, exports) {

$parcel$export(module.exports, "getValueFromEventOrValue", () => $d13b61db8ab93a6d$export$a59801673b41acfd);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d13b61db8ab93a6d$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $d13b61db8ab93a6d$export$a59801673b41acfd(eventOrValue) {
    if ($d13b61db8ab93a6d$var$isEvent(eventOrValue)) {
        const { currentTarget: currentTarget } = eventOrValue;
        if (currentTarget.type === 'checkbox') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (currentTarget.checked) return currentTarget.value || true;
            return currentTarget.value ? undefined : false;
        }
        if (currentTarget) return currentTarget.value;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return eventOrValue;
}

});

parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


const $036e471843230370$export$e615b7e9b8fb4715 = 'GIC';

parcelRegister("lVewy", function(module, exports) {

$parcel$export(module.exports, "FieldValueDecoratorAsync", () => $1957aa217428fa22$export$24545fc29fe55980);

var $eUqFw = parcelRequire("eUqFw");

var $ig7wC = parcelRequire("ig7wC");

var $8ibkc = parcelRequire("8ibkc");


var $kN8ZW = parcelRequire("kN8ZW");
const $1957aa217428fa22$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const undecoratedResult = children(fieldProps);
    if ((0, $8ibkc.isFieldTypeSupported)((0, $036e471843230370$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kN8ZW.EnabledFieldValueDecorator), {
        fieldProps: fieldProps,
        fieldId: fieldId,
        fieldType: fieldType
    }, children);
    return undecoratedResult;
};
const $1957aa217428fa22$export$24545fc29fe55980 = /*#__PURE__*/ (0, $eUqFw.memo)($1957aa217428fa22$var$FieldValueDecoratorAsyncNoMemo);

});
parcelRegister("ig7wC", function(module, exports) {

$parcel$export(module.exports, "store", () => $1aa7dabd47e15b99$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $1aa7dabd47e15b99$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $1aa7dabd47e15b99$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $1aa7dabd47e15b99$export$5eb9c167b683d125);

var $1yZQx = parcelRequire("1yZQx");
var $96gVp = parcelRequire("96gVp");
var $kEDjj = parcelRequire("kEDjj");

const $1aa7dabd47e15b99$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatusDeprecated: (0, $e4bc45ef063f6e5f$export$39d15f3568f5a72c),
    uiModificationsConsentStatus: {}
};
const $1aa7dabd47e15b99$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($1aa7dabd47e15b99$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatusDeprecated: (enabled)=>({ setState: setState })=>{
            setState({
                uiModificationsConsentStatusDeprecated: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $1aa7dabd47e15b99$export$6f57813fe9f31bf9 = (0, $kEDjj.createStore)({
    name: 'issue-adjustments-context',
    initialState: $1aa7dabd47e15b99$var$initialState,
    actions: $1aa7dabd47e15b99$export$e324594224ef24da
});
const $1aa7dabd47e15b99$export$a12f82a132dee079 = (0, $1yZQx.createHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9);
const $1aa7dabd47e15b99$export$358ad850b2f6d6fe = (0, $1yZQx.createStateHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $1aa7dabd47e15b99$export$4f2729981f4b81d2 = (0, $1yZQx.createActionsHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9);
const $1aa7dabd47e15b99$export$5eb9c167b683d125 = (0, $96gVp.createContainer)($1aa7dabd47e15b99$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});
const $e4bc45ef063f6e5f$export$39d15f3568f5a72c = 'unknown';
const $e4bc45ef063f6e5f$export$d67d63332ce3ce38 = 'required';
const $e4bc45ef063f6e5f$export$45ca911896c5084f = 'consented';


parcelRegister("kN8ZW", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldValueDecorator", () => $c84f9b3e503e326b$export$9d96bb1f53295b76);

var $fcNlw = parcelRequire("fcNlw");

var $gR74I = parcelRequire("gR74I");
const $c84f9b3e503e326b$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldType: fieldType, fieldProps: fieldProps })=>{
    const { onBlur: onBlur, onChange: onChange } = fieldProps;
    const { getFieldValue: getFieldValue } = (0, $gR74I.useFormApi)();
    const { processChange: processChange } = (0, $fcNlw.useIssueAdjustmentsActions)();
    const processChangeByType = (eventType)=>{
        processChange({
            fieldId: fieldId,
            fieldValue: getFieldValue(fieldId),
            eventType: eventType,
            fieldType: fieldType
        });
    };
    const interceptedFieldProps = {
        ...fieldProps,
        onChange: (modifiedValue)=>{
            // Order is important to pass the current value to the UIM
            onChange(modifiedValue);
            processChangeByType('change');
        },
        onBlur: ()=>{
            // Order is important to pass the current value to the UIM
            onBlur();
            processChangeByType('blur');
        }
    };
    return children(interceptedFieldProps);
};

});
parcelRegister("gR74I", function(module, exports) {

$parcel$export(module.exports, "FormApiProvider", () => $722c7ef846088156$export$1e7be89a21d0c0ae);
$parcel$export(module.exports, "useFormApi", () => $722c7ef846088156$export$4607062597b2b4df);

var $eUqFw = parcelRequire("eUqFw");
const $722c7ef846088156$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $722c7ef846088156$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
    const setFieldValueRef = (0, $eUqFw.useRef)(setFieldValue);
    setFieldValueRef.current = setFieldValue;
    const getFormStateRef = (0, $eUqFw.useRef)(getFormState);
    getFormStateRef.current = getFormState;
    const value = (0, $eUqFw.useMemo)(()=>({
            setFieldValue: (...args)=>setFieldValueRef.current(...args),
            getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId]
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($722c7ef846088156$var$Context.Provider, {
        value: value
    }, children);
};
const $722c7ef846088156$export$4607062597b2b4df = ()=>{
    const context = (0, $eUqFw.useContext)($722c7ef846088156$var$Context);
    if (context === null) throw new Error('Missing FormApiProvider');
    return context;
};

});



parcelRegister("5i7Lk", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $35539f264557e149$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9wcjJ = parcelRequire("9wcjJ");

var $7jPhn = parcelRequire("7jPhn");

var $7Y6sw = parcelRequire("7Y6sw");

var $8cU5f = parcelRequire("8cU5f");

var $iUp5j = parcelRequire("iUp5j");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $dEMIg = parcelRequire("dEMIg");

var $9XfZZ = parcelRequire("9XfZZ");

var $huDma = parcelRequire("huDma");


var $Gmy9H = parcelRequire("Gmy9H");

var $a5JEv = parcelRequire("a5JEv");
const $35539f264557e149$var$FieldMessageBehaviour = (props)=>{
    const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const maxHeight = 22;
    const emojiProvider = (0, $iUp5j.useEmojiProvider)();
    const getHelpText = (0, $eUqFw.useCallback)(()=>{
        // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
        const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
        const helperMessage = (0, $Gmy9H.LEARN_MORE_MESSAGES)[urlSuffix] || (0, $a5JEv.default).fieldHelpTextLabel;
        return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
    }, [
        formatMessage,
        fieldHelpTextUrl
    ]);
    const adfDocument = (0, $eUqFw.useMemo)(()=>{
        let fieldDescription = description;
        if (fieldHelpTextUrl) {
            if (fieldDescription) fieldDescription = `${fieldDescription} ${getHelpText()}`;
            else fieldDescription = getHelpText();
        }
        return (0, $huDma.convertWikiToAdf)(fieldDescription);
    }, [
        description,
        fieldHelpTextUrl,
        getHelpText
    ]);
    const getErrorMessage = (validationError)=>{
        switch(validationError){
            case 0, $dEMIg.REQUIRED:
                return formatMessage((0, $a5JEv.default).requiredErrorMessage, {
                    fieldName: fieldName
                });
            case 0, $a8a1251974a60726$export$fd7dfa1695d325ca:
                return formatMessage((0, $a5JEv.default).labelsMaxErrorMessage, {
                    MAX_ALLOWED_LABELS: formatNumber((0, $a8a1251974a60726$export$1fdf850c93de8bae))
                });
            case 0, $a8a1251974a60726$export$e77d629cc732976d:
                return formatMessage((0, $a5JEv.default).labelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $a8a1251974a60726$export$9151073f92820ff8))
                });
            case 0, $a8a1251974a60726$export$618e922e89e8bcae:
                return formatMessage((0, $a5JEv.default).stringInvalidErrorMessage, {
                    fieldName: fieldName,
                    MAX_STRING_SIZE: formatNumber((0, $a8a1251974a60726$export$fe1a70381f6491b5))
                });
            case 0, $a8a1251974a60726$export$8d30d41a8828e14f:
                return formatMessage((0, $a5JEv.default).forgeLabelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $a8a1251974a60726$export$9151073f92820ff8))
                });
            default:
                return validationError;
        }
    };
    if (error !== undefined && error !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, getErrorMessage(error));
    const getRenderer = (isTruncated = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y6sw.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            document: adfDocument,
            schema: (0, $9wcjJ.defaultSchema),
            dataProviders: emojiProvider,
            disableHeadingIDs: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $1ybV0.ff)('issue.details.renderer.tti-tracking'),
                'allow-windowed-code-block': true
            },
            maxHeight: isTruncated ? maxHeight : undefined,
            truncated: isTruncated,
            fadeOutHeight: isTruncated ? 0 : undefined,
            eventHandlers: {
                smartCard: {
                    onClick: (0, $9XfZZ.onLinkClick)
                },
                link: {
                    onClick: onLinkClickEvent || (0, $9XfZZ.onLinkClick)
                }
            },
            smartLinks: (0, $9XfZZ.smartLinksDefault)
        });
    const getRenderedDescription = (truncatedRenderer = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35539f264557e149$var$Description, {
            "data-testid": "issue-create-commons.common.ui.field-message.description",
            isMini: isMini,
            ...fieldId && {
                id: `${fieldId}-field-message`
            }
        }, getRenderer(truncatedRenderer)));
    if (adfDocument) {
        if (isMini) {
            if (adfDocument.content[0]?.type === 'paragraph') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35539f264557e149$var$TooltipContentContainer, null, getRenderer()),
                position: "bottom"
            }, getRenderedDescription(true));
            return null;
        }
        return getRenderedDescription();
    }
    return null;
};
const $35539f264557e149$export$eb5013679a5d3f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35539f264557e149$var$FieldMessageBehaviour, {
        key: `field-message-${props.fieldId}`,
        ...props
    });
const $35539f264557e149$var$TooltipContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_woio15cr _1f1h16g6 _13odidpf _9j7z1moj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $35539f264557e149$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_162p546": (0, $9t7rW.default)(__cmplp.isMini && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            })
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_woio1wmz _1f1hqk37 _13od1b66 _1pz31ynx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9wcjJ", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $6ee0a826b7e77e55$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $6ee0a826b7e77e55$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $6ee0a826b7e77e55$export$1db618b7b2275ea1);

var $5iWql = parcelRequire("5iWql");

var $jDF31 = parcelRequire("jDF31");
var $lKuoe = parcelRequire("lKuoe");
var $lUaLf = parcelRequire("lUaLf");
var $jTnho = parcelRequire("jTnho");
var $3eVto = parcelRequire("3eVto");
var $izui5 = parcelRequire("izui5");

var $khrXf = parcelRequire("khrXf");
const $6ee0a826b7e77e55$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $6ee0a826b7e77e55$export$e4e3ac1fa64862db = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
const $6ee0a826b7e77e55$export$fd147e7d448dea03 = (0, $5iWql.default)((stage = 'final')=>{
    const defaultSchemaConfig = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jTnho.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $lUaLf.multiBodiedExtension),
        extensionFrame: (0, $lUaLf.extensionFrame),
        expand: (0, $lKuoe.expandWithNestedExpand),
        blockquote: (0, $jDF31.blockquoteWithNestedCodeblockOrMedia),
        listItem: (0, $3eVto.listItemWithDecisionStage0),
        panel: (0, $izui5.panelWithBlockquoteStage0)(true)
    };
    return (0, $khrXf.createSchema)(defaultSchemaConfig);
});
const $6ee0a826b7e77e55$export$1db618b7b2275ea1 = $6ee0a826b7e77e55$export$fd147e7d448dea03();

});
parcelRegister("jDF31", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $e4c18015cb0b91e7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $e4c18015cb0b91e7$export$c4d50234112df933);
$parcel$export(module.exports, "blockquoteWithList", () => $e4c18015cb0b91e7$export$9b4686c4b9672643);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name blockquote_node
 */ const $e4c18015cb0b91e7$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $e4c18015cb0b91e7$export$67dc04e652a298ca = (0, $7XZYM.blockquoteLegacy)($e4c18015cb0b91e7$var$nodeSpecOptions);
const $e4c18015cb0b91e7$export$c4d50234112df933 = (0, $7XZYM.blockquote)($e4c18015cb0b91e7$var$nodeSpecOptions);
const $e4c18015cb0b91e7$export$9b4686c4b9672643 = (0, $7XZYM.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});
parcelRegister("7XZYM", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $5cce1edef7204014$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $5cce1edef7204014$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $5cce1edef7204014$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $5cce1edef7204014$export$a91509d1c739c16f);
$parcel$export(module.exports, "bodiedExtension", () => $5cce1edef7204014$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $5cce1edef7204014$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $5cce1edef7204014$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $5cce1edef7204014$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $5cce1edef7204014$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $5cce1edef7204014$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $5cce1edef7204014$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $5cce1edef7204014$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $5cce1edef7204014$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $5cce1edef7204014$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $5cce1edef7204014$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $5cce1edef7204014$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $5cce1edef7204014$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $5cce1edef7204014$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $5cce1edef7204014$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $5cce1edef7204014$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $5cce1edef7204014$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $5cce1edef7204014$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $5cce1edef7204014$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $5cce1edef7204014$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $5cce1edef7204014$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $5cce1edef7204014$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $5cce1edef7204014$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $5cce1edef7204014$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $5cce1edef7204014$export$cdae19acb0a520fd);
$parcel$export(module.exports, "listItem", () => $5cce1edef7204014$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemLegacy", () => $5cce1edef7204014$export$1b6a2528830f2ee1);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $5cce1edef7204014$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $5cce1edef7204014$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $5cce1edef7204014$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $5cce1edef7204014$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $5cce1edef7204014$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $5cce1edef7204014$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $5cce1edef7204014$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $5cce1edef7204014$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $5cce1edef7204014$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $5cce1edef7204014$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $5cce1edef7204014$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $5cce1edef7204014$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $5cce1edef7204014$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithNestedBlockquoteStage0", () => $5cce1edef7204014$export$a1cf9918ad22c7e9);
$parcel$export(module.exports, "paragraph", () => $5cce1edef7204014$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $5cce1edef7204014$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $5cce1edef7204014$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $5cce1edef7204014$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $5cce1edef7204014$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $5cce1edef7204014$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $5cce1edef7204014$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $5cce1edef7204014$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $5cce1edef7204014$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $5cce1edef7204014$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $5cce1edef7204014$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $5cce1edef7204014$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $5cce1edef7204014$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $9mSQX = parcelRequire("9mSQX");
const $5cce1edef7204014$export$c4c2f833baaebdb8 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$67dc04e652a298ca = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$199922e5af8e9a6 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$a91509d1c739c16f = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$27903d543b563e39 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $5cce1edef7204014$export$e7320d153c538837 = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $5cce1edef7204014$export$a140c94e5ea26bee = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $5cce1edef7204014$export$8e3c2dfdc4f0453d = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $5cce1edef7204014$export$7bb0d5c671655cc4 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $5cce1edef7204014$export$62a75647a293fbec = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $5cce1edef7204014$export$daf889beb5092f95 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$e6e4878f43c27cab = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$3e6d667072febc87 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$324d90190a8b822a = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$47988d68fe575725 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$6959e16eeff859b4 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $5cce1edef7204014$export$62d45a65fb43d95e = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$2a111da947c407d2 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(block | layoutSection | blockRootOnly)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $5cce1edef7204014$export$be4283d9a1cb1ff6 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a19185d1233fc4b2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$f5574b5d45fc2112 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9f77e0932fb78f72 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$111717af0897b759 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$63c0f3992661097b = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$1b45514b112dd749 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a8baf338431a691 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b555be60c7703afb = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $5cce1edef7204014$export$371da9dd35aba193 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    selectable: false
});
const $5cce1edef7204014$export$46e4a324ac90507f = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$1b0c1557b234fa00 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$85461f751c457cc2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$2b380a0f7e250af1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$5c452ff88e35e47d = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $5cce1edef7204014$export$cbf8224b64e0d942 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$2f4e72b9459914ad = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$16b353b2649bd8d9 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b3b1e36c2105006d = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$ab76e7c03cd6f650 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $5cce1edef7204014$export$b3b6a70a7fa4a5be = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$cdae19acb0a520fd = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$206007566ca0aca5 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$76c7e83ecc9cdf05 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$1b6a2528830f2ee1 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$df876f0305235056 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$987d49ffe1b0900f = (0, $9mSQX.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$2855e964765eac9 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $5cce1edef7204014$export$38bab695e3f720f1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$969fe3781ca15058 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $5cce1edef7204014$export$8d067f22dc2d1254 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$7e767666f2ce108a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$4bd9a38995f6bf50 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$db83999c14438df4 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$46f790bd65f760d0 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$750e45819f66d9d0 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $5cce1edef7204014$export$63cadbf5f4296627 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$f03786aa6312d1e4 = (0, $9mSQX.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$a5dc81035676e7a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$21f42ab9b6679f44 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$aa4e41075a4109d7 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a1cf9918ad22c7e9 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9c206ddddb32a9b = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$4f98472e6dc14293 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$ea332b61641b0588 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$a1f41dc4901771f8 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$c7187bbd1a7a9244 = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$fbeb3a3956e8a3c7 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block'
});
const $5cce1edef7204014$export$471f7ae5c4103ae1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b6ce52be8d7a261 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9852986a3ec5f6a0 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $5cce1edef7204014$export$e1e720e5f4603e6a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $5cce1edef7204014$export$48884d2a5190dc73 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $5cce1edef7204014$export$ce666bf02318c957 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $5cce1edef7204014$export$6d8b0ef52e2e6390 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$375b6afcc5f4d291 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$6f093cfa640b7166 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$5ea06bc686c59dc2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$93256a4c17b33a82 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$44b79b0979d0f0f7 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$310ebe0d80122e9b = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("9mSQX", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $6d20b7d0ef1b427c$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $6d20b7d0ef1b427c$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $6d20b7d0ef1b427c$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $6d20b7d0ef1b427c$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("lKuoe", function(module, exports) {

$parcel$export(module.exports, "expand", () => $fd5577a23a87630d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $fd5577a23a87630d$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $fd5577a23a87630d$export$54fd2c36b5cc6731);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_with_breakout_mark_node
 */ function $fd5577a23a87630d$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $fd5577a23a87630d$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $fd5577a23a87630d$export$9f77e0932fb78f72 = (0, $7XZYM.expandWithoutNestedExpand)($fd5577a23a87630d$var$nodeSpecOptions);
const $fd5577a23a87630d$export$7b80cba28d10b2c1 = (0, $7XZYM.expand)($fd5577a23a87630d$var$nodeSpecOptions);
const $fd5577a23a87630d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("lUaLf", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $ff272cde3452ccae$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $ff272cde3452ccae$export$c3c04d555a8b9013);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $ff272cde3452ccae$export$4fdcae991fd743e7 = (0, $7XZYM.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $ff272cde3452ccae$export$c3c04d555a8b9013 = (0, $7XZYM.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("eUEbq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $adb577300eb72d12$export$1765e2758fc47004);
const $adb577300eb72d12$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $adb577300eb72d12$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $adb577300eb72d12$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("jTnho", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e7b53637cb7eb2d7$export$4f9d8f623ff17117);

var $7XZYM = parcelRequire("7XZYM");
const $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be = (0, $7XZYM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e7b53637cb7eb2d7$export$cdae19acb0a520fd = (0, $7XZYM.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e7b53637cb7eb2d7$export$4f9d8f623ff17117 = (0, $7XZYM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3eVto", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $25bf42da33411467$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $25bf42da33411467$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $25bf42da33411467$export$b2cd54d5ce935ddb);

var $7XZYM = parcelRequire("7XZYM");
const $25bf42da33411467$export$76c7e83ecc9cdf05 = (0, $7XZYM.listItemLegacy)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $25bf42da33411467$export$58dca2f0678302a4 = (0, $7XZYM.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $25bf42da33411467$export$b2cd54d5ce935ddb = (0, $7XZYM.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("izui5", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $d852fdfb5507437d$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $d852fdfb5507437d$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => $d852fdfb5507437d$export$1f8c55a804c909c7);

var $7XZYM = parcelRequire("7XZYM");
let $d852fdfb5507437d$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $d852fdfb5507437d$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $d852fdfb5507437d$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $d852fdfb5507437d$export$969277cf61e5a7aa.CUSTOM ? $d852fdfb5507437d$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $d852fdfb5507437d$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $7XZYM.panel)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};
const $d852fdfb5507437d$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $7XZYM.panelWithNestedBlockquoteStage0)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};

});

parcelRegister("khrXf", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $ec3b1467be5518b9$export$5f4ce795563f4211);

var $7dkLM = parcelRequire("7dkLM");


var $dkRpY = parcelRequire("dkRpY");
var $ht6w1 = parcelRequire("ht6w1");
var $wOKi6 = parcelRequire("wOKi6");
var $dx7fV = parcelRequire("dx7fV");
var $5He3U = parcelRequire("5He3U");
var $4ohT6 = parcelRequire("4ohT6");
var $de8p2 = parcelRequire("de8p2");
var $8nj7b = parcelRequire("8nj7b");
var $79k1z = parcelRequire("79k1z");
var $9iaXL = parcelRequire("9iaXL");
var $l9pLr = parcelRequire("l9pLr");
var $3SpHb = parcelRequire("3SpHb");
var $4w9F8 = parcelRequire("4w9F8");
var $hkdIQ = parcelRequire("hkdIQ");
var $gIVi2 = parcelRequire("gIVi2");
var $6USfM = parcelRequire("6USfM");
var $2ce3x = parcelRequire("2ce3x");
var $7LHzX = parcelRequire("7LHzX");
var $gLNTn = parcelRequire("gLNTn");
var $8osWo = parcelRequire("8osWo");

var $heoPx = parcelRequire("heoPx");
var $jDF31 = parcelRequire("jDF31");
var $eStcf = parcelRequire("eStcf");
var $568Ob = parcelRequire("568Ob");
var $d99SJ = parcelRequire("d99SJ");
var $hgVop = parcelRequire("hgVop");
var $eTtDn = parcelRequire("eTtDn");
var $1Ud4U = parcelRequire("1Ud4U");
var $56qNL = parcelRequire("56qNL");
var $8CDqw = parcelRequire("8CDqw");
var $47B7q = parcelRequire("47B7q");
var $dPUL6 = parcelRequire("dPUL6");
var $1HZv5 = parcelRequire("1HZv5");
var $7XTsD = parcelRequire("7XTsD");
var $5JhXr = parcelRequire("5JhXr");
var $lKuoe = parcelRequire("lKuoe");
var $izui5 = parcelRequire("izui5");
var $7y7sZ = parcelRequire("7y7sZ");
var $lUaLf = parcelRequire("lUaLf");
var $7SlQD = parcelRequire("7SlQD");
var $iWGOh = parcelRequire("iWGOh");
var $iOeir = parcelRequire("iOeir");
var $8mC62 = parcelRequire("8mC62");
var $7xvQK = parcelRequire("7xvQK");
var $1O3jv = parcelRequire("1O3jv");
var $jTnho = parcelRequire("jTnho");
var $3eVto = parcelRequire("3eVto");
var $gN3fl = parcelRequire("gN3fl");
var $1KDvn = parcelRequire("1KDvn");
var $hXvCf = parcelRequire("hXvCf");
var $cvCFq = parcelRequire("cvCFq");
var $fkqTY = parcelRequire("fkqTY");
var $dj4Ew = parcelRequire("dj4Ew");
var $8lnnz = parcelRequire("8lnnz");
var $5bGpU = parcelRequire("5bGpU");
var $dDs5p = parcelRequire("dDs5p");
var $7wZ4m = parcelRequire("7wZ4m");
var $cvo5z = parcelRequire("cvo5z");
var $byxO6 = parcelRequire("byxO6");
var $ie5d6 = parcelRequire("ie5d6");
var $7QozA = parcelRequire("7QozA");
var $ltJuR = parcelRequire("ltJuR");
var $4ne8H = parcelRequire("4ne8H");
var $7p32Z = parcelRequire("7p32Z");
var $8cuPa = parcelRequire("8cuPa");
function $ec3b1467be5518b9$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ec3b1467be5518b9$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $ec3b1467be5518b9$var$markGroupDeclarations = [
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$9b982809044276a6)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$4498a6080fed604c)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$f8e8a5f34f6ea725)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$b395009ca7f092c7))
];
const $ec3b1467be5518b9$var$markGroupDeclarationsNames = $ec3b1467be5518b9$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $ec3b1467be5518b9$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $1HZv5.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $5bGpU.paragraph)
    },
    {
        name: 'text',
        spec: (0, $ltJuR.text)
    },
    {
        name: 'bulletList',
        spec: (0, $568Ob.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $8lnnz.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $3eVto.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $iWGOh.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $jDF31.blockquoteWithNestedCodeblockOrMedia)
    },
    {
        name: 'codeBlock',
        spec: (0, $hgVop.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $izui5.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $7wZ4m.rule)
    },
    {
        name: 'image',
        spec: (0, $iOeir.image)
    },
    {
        name: 'mention',
        spec: (0, $fkqTY.mention)
    },
    {
        name: 'caption',
        spec: (0, $d99SJ.caption)
    },
    {
        name: 'media',
        spec: (0, $gN3fl.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $1KDvn.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $cvCFq.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $hXvCf.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dDs5p.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jTnho.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $1O3jv.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $7SlQD.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $5JhXr.emoji)
    },
    {
        name: 'table',
        spec: (0, $byxO6.table)
    },
    {
        name: 'tableCell',
        spec: (0, $byxO6.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $byxO6.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $byxO6.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $eTtDn.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $56qNL.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $1Ud4U.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $dPUL6.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $47B7q.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $7QozA.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $ie5d6.taskItem)
    },
    {
        name: 'date',
        spec: (0, $8CDqw.date)
    },
    {
        name: 'status',
        spec: (0, $cvo5z.status)
    },
    {
        name: 'expand',
        spec: (0, $lKuoe.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dj4Ew.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $7y7sZ.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $7xvQK.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $eStcf.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $lUaLf.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $lUaLf.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $8mC62.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $heoPx.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $7XTsD.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $4ne8H.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $7p32Z.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $8cuPa.unsupportedInline)
    }
];
const $ec3b1467be5518b9$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $3SpHb.link)
    },
    {
        name: 'em',
        spec: (0, $79k1z.em)
    },
    {
        name: 'strong',
        spec: (0, $hkdIQ.strong)
    },
    {
        name: 'textColor',
        spec: (0, $6USfM.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $wOKi6.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $4w9F8.strike)
    },
    {
        name: 'subsup',
        spec: (0, $gIVi2.subsup)
    },
    {
        name: 'underline',
        spec: (0, $7LHzX.underline)
    },
    {
        name: 'code',
        spec: (0, $4ohT6.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $2ce3x.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $dkRpY.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $ht6w1.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $de8p2.confluenceInlineComment)
    },
    ...$ec3b1467be5518b9$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $5He3U.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $8nj7b.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $9iaXL.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $l9pLr.indentation)
    },
    {
        name: 'border',
        spec: (0, $dx7fV.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $gLNTn.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $8osWo.unsupportedNodeAttribute)
    }
];
function $ec3b1467be5518b9$export$2d0c32a809131488() {
    const nodes = $ec3b1467be5518b9$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $ec3b1467be5518b9$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ec3b1467be5518b9$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ec3b1467be5518b9$var$markGroupDeclarationsNames);
    let nodes = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, marks);
    return new (0, $7dkLM.Schema)({
        nodes: nodes,
        marks: marks
    });
}
function $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$ec3b1467be5518b9$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$ec3b1467be5518b9$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $ec3b1467be5518b9$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $ec3b1467be5518b9$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
const $ec3b1467be5518b9$export$c77b6d30da5276a1 = true;

});
parcelRegister("7dkLM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5409dbb98ebf29ba$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $5409dbb98ebf29ba$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $5409dbb98ebf29ba$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $5409dbb98ebf29ba$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $5409dbb98ebf29ba$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $5409dbb98ebf29ba$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $5409dbb98ebf29ba$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $5409dbb98ebf29ba$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $5409dbb98ebf29ba$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $5409dbb98ebf29ba$export$3476b78f8f5a8b72);

var $cPnfS = parcelRequire("cPnfS");
function $5409dbb98ebf29ba$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $5409dbb98ebf29ba$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $5409dbb98ebf29ba$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $5409dbb98ebf29ba$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $5409dbb98ebf29ba$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $5409dbb98ebf29ba$var$retIndex(0, pos);
        if (pos == this.size) return $5409dbb98ebf29ba$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $5409dbb98ebf29ba$var$retIndex(i + 1, end);
                return $5409dbb98ebf29ba$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (nodes instanceof $5409dbb98ebf29ba$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $5409dbb98ebf29ba$export$ffb0004e005737fa.empty = new $5409dbb98ebf29ba$export$ffb0004e005737fa([], 0);
const $5409dbb98ebf29ba$var$found = {
    index: 0,
    offset: 0
};
function $5409dbb98ebf29ba$var$retIndex(index, offset) {
    $5409dbb98ebf29ba$var$found.index = index;
    $5409dbb98ebf29ba$var$found.offset = offset;
    return $5409dbb98ebf29ba$var$found;
}
function $5409dbb98ebf29ba$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$5409dbb98ebf29ba$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$5409dbb98ebf29ba$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $5409dbb98ebf29ba$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        if (marks instanceof $5409dbb98ebf29ba$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $5409dbb98ebf29ba$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $5409dbb98ebf29ba$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty = new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, 0, 0);
function $5409dbb98ebf29ba$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($5409dbb98ebf29ba$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $5409dbb98ebf29ba$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $5409dbb98ebf29ba$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $5409dbb98ebf29ba$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inconsistent open depths");
    return $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, 0);
}
function $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $5409dbb98ebf29ba$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $from);
        return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $5409dbb98ebf29ba$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $5409dbb98ebf29ba$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $5409dbb98ebf29ba$var$checkJoin(node, $after.node(depth));
    return node;
}
function $5409dbb98ebf29ba$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $5409dbb98ebf29ba$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $5409dbb98ebf29ba$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$5409dbb98ebf29ba$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $5409dbb98ebf29ba$var$addNode($end.nodeBefore, target);
}
function $5409dbb98ebf29ba$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $5409dbb98ebf29ba$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $5409dbb98ebf29ba$var$joinable($end, $to, depth + 1);
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $5409dbb98ebf29ba$var$checkJoin(openStart, openEnd);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceTwoWay($from, $start, depth + 1)), content);
        $5409dbb98ebf29ba$var$addRange($start, $end, depth, content);
        if (openEnd) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openEnd, $5409dbb98ebf29ba$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $5409dbb98ebf29ba$var$joinable($from, $to, depth + 1);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(type, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $5409dbb98ebf29ba$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $5409dbb98ebf29ba$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $5409dbb98ebf29ba$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $5409dbb98ebf29ba$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $5409dbb98ebf29ba$var$resolveCache.set(doc, cache = new $5409dbb98ebf29ba$var$ResolveCache);
        let result = cache.elts[cache.i] = $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $5409dbb98ebf29ba$var$resolveCacheSize;
        return result;
    }
}
class $5409dbb98ebf29ba$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $5409dbb98ebf29ba$var$resolveCacheSize = 12, $5409dbb98ebf29ba$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $5409dbb98ebf29ba$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $5409dbb98ebf29ba$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $5409dbb98ebf29ba$var$emptyAttrs) && $5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $5409dbb98ebf29ba$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $5409dbb98ebf29ba$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$5409dbb98ebf29ba$export$85c928794f8d04d4.prototype.text = undefined;
class $5409dbb98ebf29ba$var$TextNode extends $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $5409dbb98ebf29ba$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $5409dbb98ebf29ba$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $5409dbb98ebf29ba$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $5409dbb98ebf29ba$var$dfa($5409dbb98ebf29ba$var$nfa(expr));
        $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $5409dbb98ebf29ba$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $5409dbb98ebf29ba$export$364ed450558d7ec4.empty = new $5409dbb98ebf29ba$export$364ed450558d7ec4(true);
class $5409dbb98ebf29ba$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $5409dbb98ebf29ba$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSubscript(stream) {
    let expr = $5409dbb98ebf29ba$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $5409dbb98ebf29ba$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $5409dbb98ebf29ba$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $5409dbb98ebf29ba$var$parseExprRange(stream, expr) {
    let min = $5409dbb98ebf29ba$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $5409dbb98ebf29ba$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $5409dbb98ebf29ba$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $5409dbb98ebf29ba$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $5409dbb98ebf29ba$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $5409dbb98ebf29ba$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $5409dbb98ebf29ba$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $5409dbb98ebf29ba$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($5409dbb98ebf29ba$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $5409dbb98ebf29ba$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($5409dbb98ebf29ba$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $5409dbb98ebf29ba$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $5409dbb98ebf29ba$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($5409dbb98ebf29ba$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $5409dbb98ebf29ba$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $5409dbb98ebf29ba$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $5409dbb98ebf29ba$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $5409dbb98ebf29ba$var$initAttrs(attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $5409dbb98ebf29ba$var$Attribute(attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $5409dbb98ebf29ba$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(spec.attrs);
        this.defaultAttrs = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, attrs, content.append(after), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $5409dbb98ebf29ba$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $5409dbb98ebf29ba$var$validateType(type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types}, got ${name}`);
    };
}
// Attribute descriptors
class $5409dbb98ebf29ba$var$Attribute {
    constructor(options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $5409dbb98ebf29ba$var$validateType(options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $5409dbb98ebf29ba$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(spec.attrs);
        this.excluded = null;
        let defaults = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $5409dbb98ebf29ba$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $5409dbb98ebf29ba$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $cPnfS.default).from(spec.nodes), instanceSpec.marks = (0, $cPnfS.default).from(spec.marks || {}), this.nodes = $5409dbb98ebf29ba$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $5409dbb98ebf29ba$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $5409dbb98ebf29ba$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $5409dbb98ebf29ba$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $5409dbb98ebf29ba$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $5409dbb98ebf29ba$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $5409dbb98ebf29ba$var$TextNode(type, type.defaultAttrs, text, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $5409dbb98ebf29ba$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $5409dbb98ebf29ba$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $5409dbb98ebf29ba$var$isTagRule(rule) {
    return rule.tag != null;
}
function $5409dbb98ebf29ba$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $5409dbb98ebf29ba$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($5409dbb98ebf29ba$var$isTagRule(rule)) this.tags.push(rule);
            else if ($5409dbb98ebf29ba$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, false);
        context.addAll(dom, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, true);
        context.addAll(dom, options.from, options.to);
        return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($5409dbb98ebf29ba$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $5409dbb98ebf29ba$export$1059c6e7d2ce5669(schema, $5409dbb98ebf29ba$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $5409dbb98ebf29ba$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $5409dbb98ebf29ba$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $5409dbb98ebf29ba$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $5409dbb98ebf29ba$var$OPT_PRESERVE_WS = 1, $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL = 2, $5409dbb98ebf29ba$var$OPT_OPEN_LEFT = 4;
function $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS | $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : base & ~$5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
}
class $5409dbb98ebf29ba$var$NodeContext {
    constructor(type, attrs, // Marks applied to this node itself
    marks, // Marks that can't apply here, but will be used in children if possible
    pendingMarks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.pendingMarks = pendingMarks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // Nested Marks with same type
        this.stashMarks = [];
        this.match = match || (options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    popFromStashMark(mark) {
        for(let i = this.stashMarks.length - 1; i >= 0; i--)if (mark.eq(this.stashMarks[i])) return this.stashMarks.splice(i, 1)[0];
    }
    applyPending(nextType) {
        for(let i = 0, pending = this.pendingMarks; i < pending.length; i++){
            let mark = pending[i];
            if ((this.type ? this.type.allowsMarkType(mark.type) : $5409dbb98ebf29ba$var$markMayApply(mark.type, nextType)) && !mark.isInSet(this.activeMarks)) {
                this.activeMarks = mark.addToSet(this.activeMarks);
                this.pendingMarks = mark.removeFromSet(this.pendingMarks);
            }
        }
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$5409dbb98ebf29ba$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $5409dbb98ebf29ba$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $5409dbb98ebf29ba$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $5409dbb98ebf29ba$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $5409dbb98ebf29ba$var$NodeContext(topNode.type, topNode.attrs, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $5409dbb98ebf29ba$var$NodeContext(null, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $5409dbb98ebf29ba$var$NodeContext(parser.schema.topNodeType, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom) {
        if (dom.nodeType == 3) this.addTextNode(dom);
        else if (dom.nodeType == 1) this.addElement(dom);
    }
    withStyleRules(dom, f) {
        let style = dom.style;
        if (!style || !style.length) return f();
        let marks = this.readStyles(dom.style);
        if (!marks) return; // A style with ignore: true
        let [addMarks, removeMarks] = marks, top = this.top;
        for(let i = 0; i < removeMarks.length; i++)this.removePendingMark(removeMarks[i], top);
        for(let i = 0; i < addMarks.length; i++)this.addPendingMark(addMarks[i]);
        f();
        for(let i = 0; i < addMarks.length; i++)this.removePendingMark(addMarks[i], top);
        for(let i = 0; i < removeMarks.length; i++)this.addPendingMark(removeMarks[i]);
    }
    addTextNode(dom) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $5409dbb98ebf29ba$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $5409dbb98ebf29ba$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($5409dbb98ebf29ba$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom);
                return;
            }
            if (rule && rule.skip) this.addAll(dom);
            else this.withStyleRules(dom, ()=>this.addAll(dom));
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else this.withStyleRules(dom, ()=>{
            this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : undefined);
        });
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"));
    }
    // Called for ignored nodes
    ignoreFallback(dom) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"));
    }
    // Run any style parser associated with the node's styles. Either
    // return an array of marks, or null to indicate some of the styles
    // had a rule with `ignore` set.
    readStyles(styles) {
        let add = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, remove = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) this.top.pendingMarks.concat(this.top.activeMarks).forEach((m)=>{
                    if (rule.clearMark(m)) remove = m.addToSet(remove);
                });
                else add = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(add);
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return [
            add,
            remove
        ];
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, continueAfter) {
        let sync, nodeType, mark;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) sync = this.enter(nodeType, rule.attrs || null, rule.preserveWhitespace);
            else if (!this.insertNode(nodeType.create(rule.attrs))) this.leafFallback(dom);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            mark = markType.create(rule.attrs);
            this.addPendingMark(mark);
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM);
        }
        if (sync && this.sync(startIn)) this.open--;
        if (mark) this.removePendingMark(mark, startIn);
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return false;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)this.enterInner(route[i], null, false);
        return true;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) this.enterInner(block);
        }
        if (this.findPlace(node)) {
            this.closeExtra();
            let top = this.top;
            top.applyPending(node.type);
            if (top.match) top.match = top.match.matchType(node.type);
            let marks = top.activeMarks;
            for(let i = 0; i < node.marks.length; i++)if (!top.type || top.type.allowsMarkType(node.marks[i].type)) marks = node.marks[i].addToSet(marks);
            top.content.push(node.mark(marks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, preserveWS) {
        let ok = this.findPlace(type.create(attrs));
        if (ok) this.enterInner(type, attrs, true, preserveWS);
        return ok;
    }
    // Open a node of the given type
    enterInner(type, attrs = null, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.applyPending(type);
        top.match = top.match && top.match.matchType(type);
        let options = $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
        this.nodes.push(new $5409dbb98ebf29ba$var$NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
        this.open++;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    addPendingMark(mark) {
        let found = $5409dbb98ebf29ba$var$findSameMarkInSet(mark, this.top.pendingMarks);
        if (found) this.top.stashMarks.push(found);
        this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
    }
    removePendingMark(mark, upto) {
        for(let depth = this.open; depth >= 0; depth--){
            let level = this.nodes[depth];
            let found = level.pendingMarks.lastIndexOf(mark);
            if (found > -1) level.pendingMarks = mark.removeFromSet(level.pendingMarks);
            else {
                level.activeMarks = mark.removeFromSet(level.activeMarks);
                let stashMark = level.popFromStashMark(mark);
                if (stashMark && level.type && level.type.allowsMarkType(stashMark.type)) level.activeMarks = stashMark.addToSet(level.activeMarks);
            }
            if (level == upto) break;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $5409dbb98ebf29ba$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $5409dbb98ebf29ba$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $5409dbb98ebf29ba$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $5409dbb98ebf29ba$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
function $5409dbb98ebf29ba$var$findSameMarkInSet(mark, set) {
    for(let i = 0; i < set.length; i++){
        if (mark.eq(set[i])) return set[i];
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $5409dbb98ebf29ba$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $5409dbb98ebf29ba$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $5409dbb98ebf29ba$var$renderSpec($5409dbb98ebf29ba$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $5409dbb98ebf29ba$var$renderSpec($5409dbb98ebf29ba$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    /**
    Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
    the spec has a hole (zero) in it, `contentDOM` will point at the
    node with the hole.
    */ static renderSpec(doc, structure, xmlNS = null) {
        return $5409dbb98ebf29ba$var$renderSpec(doc, structure, xmlNS);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $5409dbb98ebf29ba$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $5409dbb98ebf29ba$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $5409dbb98ebf29ba$var$gatherToDOM(schema.marks);
    }
}
function $5409dbb98ebf29ba$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $5409dbb98ebf29ba$var$doc(options) {
    return options.document || window.document;
}
const $5409dbb98ebf29ba$var$suspiciousAttributeCache = new WeakMap();
function $5409dbb98ebf29ba$var$suspiciousAttributes(attrs) {
    let value = $5409dbb98ebf29ba$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $5409dbb98ebf29ba$var$suspiciousAttributeCache.set(attrs, value = $5409dbb98ebf29ba$var$suspiciousAttributesInner(attrs));
    return value;
}
function $5409dbb98ebf29ba$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $5409dbb98ebf29ba$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $5409dbb98ebf29ba$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $5409dbb98ebf29ba$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("cPnfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $956c496b6231a8e7$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $956c496b6231a8e7$var$OrderedMap(content) {
    this.content = content;
}
$956c496b6231a8e7$var$OrderedMap.prototype = {
    constructor: $956c496b6231a8e7$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $956c496b6231a8e7$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$956c496b6231a8e7$var$OrderedMap.from = function(value) {
    if (value instanceof $956c496b6231a8e7$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $956c496b6231a8e7$var$OrderedMap(content);
};
var $956c496b6231a8e7$export$2e2bcd8739ae039 = $956c496b6231a8e7$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $a82948bb4071f608$export$4498a6080fed604c = 'fontStyle';
const $a82948bb4071f608$export$f8e8a5f34f6ea725 = 'searchQuery';
const $a82948bb4071f608$export$b395009ca7f092c7 = 'link';
const $a82948bb4071f608$export$9b982809044276a6 = 'color';
const $a82948bb4071f608$export$470d0905851e47a1 = 'alignment';
const $a82948bb4071f608$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("dkRpY", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $9b569454df3a2499$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $9b569454df3a2499$export$8e53000a4ec837);

var $iGMmR = parcelRequire("iGMmR");
const $9b569454df3a2499$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $9b569454df3a2499$export$8e53000a4ec837 = (0, $iGMmR.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("iGMmR", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $d9b1ab0e2c5c423a$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $d9b1ab0e2c5c423a$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $d9b1ab0e2c5c423a$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $d9b1ab0e2c5c423a$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $d9b1ab0e2c5c423a$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $d9b1ab0e2c5c423a$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $d9b1ab0e2c5c423a$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $d9b1ab0e2c5c423a$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $d9b1ab0e2c5c423a$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $d9b1ab0e2c5c423a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $d9b1ab0e2c5c423a$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $d9b1ab0e2c5c423a$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $d9b1ab0e2c5c423a$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $d9b1ab0e2c5c423a$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $d9b1ab0e2c5c423a$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $d9b1ab0e2c5c423a$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $d9b1ab0e2c5c423a$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $d9b1ab0e2c5c423a$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $d9b1ab0e2c5c423a$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $d9b1ab0e2c5c423a$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $9mSQX = parcelRequire("9mSQX");
const $d9b1ab0e2c5c423a$export$8e53000a4ec837 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $d9b1ab0e2c5c423a$export$8512c9afa7b24c3b = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $d9b1ab0e2c5c423a$export$8c5a050822fd698c = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $d9b1ab0e2c5c423a$export$1edee58a52776cd9 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $d9b1ab0e2c5c423a$export$89015c65f1c75e3f = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        }
    },
    inclusive: false,
    spanning: false
});
const $d9b1ab0e2c5c423a$export$6565f9f03506010b = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $d9b1ab0e2c5c423a$export$f3b72f8fc4684ecd = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$3024f02c495408d6 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $d9b1ab0e2c5c423a$export$c63c6f932822f543 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$f00aeb236b6f05af = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$480c699bd4ec0d86 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $d9b1ab0e2c5c423a$export$9c30223ca0a664fb = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $d9b1ab0e2c5c423a$export$4899a95d70ec5056 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$59ae2c325a998f89 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$b3401ee80eb31041 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$32f78bffcd82ff28 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $d9b1ab0e2c5c423a$export$20af3dabbb5538df = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $d9b1ab0e2c5c423a$export$425327af25286e5e = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$30d78d5eb6719bb8 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$a316dc07ff5182a2 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("ht6w1", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $cb7a32ece9a7eb7b$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b);

var $iGMmR = parcelRequire("iGMmR");
let $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $cb7a32ece9a7eb7b$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b = (0, $iGMmR.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("wOKi6", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $062a5a4c71a35221$export$8c5a050822fd698c);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $6USfM = parcelRequire("6USfM");

var $as9OS = parcelRequire("as9OS");
/**
 * @name backgroundColor_mark
 */ const $062a5a4c71a35221$var$colorArrayPalette = [
    [
        (0, $jR93G.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $jR93G.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $jR93G.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $jR93G.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $jR93G.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $jR93G.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $062a5a4c71a35221$export$14ec3f21a268e497 = new Map();
$062a5a4c71a35221$var$colorArrayPalette.forEach(([color, label])=>$062a5a4c71a35221$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $062a5a4c71a35221$export$8c5a050822fd698c = (0, $iGMmR.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $6USfM.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("a3bbC", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7512dc9a41818c00$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $7512dc9a41818c00$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $7512dc9a41818c00$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $7512dc9a41818c00$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $7512dc9a41818c00$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$12a518ff137dd389[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $7512dc9a41818c00$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = $7512dc9a41818c00$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $7512dc9a41818c00$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("jR93G", function(module, exports) {

$parcel$export(module.exports, "R50", () => $e749fe592a330097$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $e749fe592a330097$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $e749fe592a330097$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $e749fe592a330097$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $e749fe592a330097$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $e749fe592a330097$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $e749fe592a330097$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $e749fe592a330097$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $e749fe592a330097$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $e749fe592a330097$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $e749fe592a330097$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $e749fe592a330097$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $e749fe592a330097$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $e749fe592a330097$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $e749fe592a330097$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $e749fe592a330097$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $e749fe592a330097$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $e749fe592a330097$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $e749fe592a330097$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $e749fe592a330097$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $e749fe592a330097$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $e749fe592a330097$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $e749fe592a330097$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $e749fe592a330097$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $e749fe592a330097$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $e749fe592a330097$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $e749fe592a330097$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $e749fe592a330097$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $e749fe592a330097$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $e749fe592a330097$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $e749fe592a330097$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $e749fe592a330097$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $e749fe592a330097$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $e749fe592a330097$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $e749fe592a330097$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $e749fe592a330097$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $e749fe592a330097$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $e749fe592a330097$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $e749fe592a330097$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $e749fe592a330097$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $e749fe592a330097$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $e749fe592a330097$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $e749fe592a330097$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $e749fe592a330097$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $e749fe592a330097$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $e749fe592a330097$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $e749fe592a330097$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $e749fe592a330097$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $e749fe592a330097$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $e749fe592a330097$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $e749fe592a330097$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $e749fe592a330097$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $e749fe592a330097$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $e749fe592a330097$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $e749fe592a330097$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $e749fe592a330097$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $e749fe592a330097$export$9665a07d9187b414);

var $dDX7B = parcelRequire("dDX7B");
const $e749fe592a330097$export$4b84fd0e2c617bd = '#FFEBE6';
const $e749fe592a330097$export$b34b069eff244586 = '#FFBDAD';
const $e749fe592a330097$export$be802dd0d8b57f35 = '#FF8F73';
const $e749fe592a330097$export$4a7404f376229999 = '#FF5630';
const $e749fe592a330097$export$2010d0fb4295b346 = '#DE350B';
const $e749fe592a330097$export$2837b5a1a71d5c02 = '#BF2600';
const $e749fe592a330097$export$8d9596b529bbb9cf = '#FFFAE6';
const $e749fe592a330097$export$41060a744ab0b7ae = '#FFF0B3';
const $e749fe592a330097$export$5aae31392d72caaa = '#FFC400';
const $e749fe592a330097$export$59619663aa6500fb = '#FF991F';
const $e749fe592a330097$export$874739ea9e379ab6 = '#FF8B00';
const $e749fe592a330097$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $e749fe592a330097$export$69a3bf21b9686c2b = '#ABF5D1';
const $e749fe592a330097$export$747d86715d4175de = '#57D9A3';
const $e749fe592a330097$export$940e1f69e873f202 = '#36B37E';
const $e749fe592a330097$export$a49394138f7b8e85 = '#00875A';
const $e749fe592a330097$export$6fa04827ac68a4fb = '#006644';
const $e749fe592a330097$export$226de0355ed012f8 = '#DEEBFF';
const $e749fe592a330097$export$8c13c2ee36917869 = '#B3D4FF';
const $e749fe592a330097$export$ecfc1dff386a3e7a = '#4C9AFF';
const $e749fe592a330097$export$b3de0ae08da2ce64 = '#0052CC';
const $e749fe592a330097$export$a6ee3d71bc067634 = '#0747A6';
const $e749fe592a330097$export$f72948ef771f6f15 = '#D3F1A7';
const $e749fe592a330097$export$29a4f05edc054374 = '#FFFFFF';
const $e749fe592a330097$export$9fdfb749e33cdf97 = '#F4F5F7';
const $e749fe592a330097$export$3e51e8f1440314ba = '#EBECF0';
const $e749fe592a330097$export$1ce2d1575d444ceb = '#DFE1E6';
const $e749fe592a330097$export$8754fc7e6d8b3000 = '#C1C7D0';
const $e749fe592a330097$export$c2e91cbeada39b8b = '#B3BAC5';
const $e749fe592a330097$export$eaa8c8a70ac22806 = '#97A0AF';
const $e749fe592a330097$export$7c87d337fb91a97d = '#8993A4';
const $e749fe592a330097$export$f563ee71e9ee74cd = '#6B778C';
const $e749fe592a330097$export$e2ef2124cf4024b1 = '#5E6C84';
const $e749fe592a330097$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $e749fe592a330097$export$13609db0e6812ab8 = '#091E4224';
const $e749fe592a330097$export$c39c0fe0f26207ae = '#42526E';
const $e749fe592a330097$export$7090862dc3038a9f = '#758195';
const $e749fe592a330097$export$7d61b15e0da132af = '#172B4D';
const $e749fe592a330097$export$f78789c8b01753cd = '#172B4D';
const $e749fe592a330097$export$a19f0c33186f7767 = '#FDD0EC';
const $e749fe592a330097$export$51716a84e62e022c = '#FEDEC8';
const $e749fe592a330097$export$363e4475840015bb = '#EAE6FF';
const $e749fe592a330097$export$4b0a4417ed59760f = '#C0B6F2';
const $e749fe592a330097$export$6011520a64d9a187 = '#998DD9';
const $e749fe592a330097$export$a7175d4e9206bc80 = '#DFD8FD';
const $e749fe592a330097$export$b48405b95304b5a1 = '#6554C0';
const $e749fe592a330097$export$c71e4279dd54a18d = '#5243AA';
const $e749fe592a330097$export$147899de772240ec = '#403294';
const $e749fe592a330097$export$2cf711fe14c66f06 = '#E6FCFF';
const $e749fe592a330097$export$7a8f4d33f6f9772c = '#B3F5FF';
const $e749fe592a330097$export$776c9c497ef08533 = '#79E2F2';
const $e749fe592a330097$export$69cb3ca10c1e330e = '#C6EDFB';
const $e749fe592a330097$export$9dc1ef0f3f48059b = '#00B8D9';
const $e749fe592a330097$export$6036577f95c3877e = '#008DA6';
function $e749fe592a330097$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e749fe592a330097$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($e749fe592a330097$export$e698776ec826343(color)) return $e749fe592a330097$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($dDX7B.default && $dDX7B.default[color]) color = $dDX7B.default[color];
        else if ($dDX7B && $dDX7B[color]) color = $dDX7B[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e749fe592a330097$export$5a544e13ad4e1fa5(color) {
    if (!$e749fe592a330097$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $e749fe592a330097$export$9665a07d9187b414(rawColor, alpha) {
    const color = $e749fe592a330097$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $e749fe592a330097$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $e749fe592a330097$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $e749fe592a330097$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("dDX7B", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("6USfM", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $50920eab1d33a737$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $50920eab1d33a737$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $50920eab1d33a737$export$32f78bffcd82ff28);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $as9OS = parcelRequire("as9OS");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $50920eab1d33a737$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $jR93G.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $jR93G.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $jR93G.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $jR93G.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $jR93G.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $jR93G.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $jR93G.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $jR93G.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $jR93G.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $jR93G.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $jR93G.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $jR93G.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $jR93G.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $jR93G.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $jR93G.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $jR93G.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $jR93G.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $jR93G.P50),
        'Light purple'
    ] // Lavender secret
];
const $50920eab1d33a737$export$569885e57444f84a = new Map();
const $50920eab1d33a737$export$81e5ed9e84fe2e28 = $50920eab1d33a737$export$569885e57444f84a;
$50920eab1d33a737$var$colorArrayPalette.forEach(([color, label])=>$50920eab1d33a737$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $50920eab1d33a737$var$testGlobalTheme;
const $50920eab1d33a737$export$fd7e0dd2b74807f7 = (theme)=>{
    $50920eab1d33a737$var$testGlobalTheme = theme;
};
const $50920eab1d33a737$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($50920eab1d33a737$var$testGlobalTheme) return {
        colorMode: $50920eab1d33a737$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $50920eab1d33a737$export$32f78bffcd82ff28 = (0, $iGMmR.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($50920eab1d33a737$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("as9OS", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $79c422e1aade6ff8$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $79c422e1aade6ff8$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $79c422e1aade6ff8$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $79c422e1aade6ff8$var$rgbFromHex = (input)=>{
    const fullHex = $79c422e1aade6ff8$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $79c422e1aade6ff8$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $79c422e1aade6ff8$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $79c422e1aade6ff8$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $79c422e1aade6ff8$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $79c422e1aade6ff8$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $79c422e1aade6ff8$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $79c422e1aade6ff8$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $79c422e1aade6ff8$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $79c422e1aade6ff8$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $79c422e1aade6ff8$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $79c422e1aade6ff8$var$rgbToLch = (rgb)=>$79c422e1aade6ff8$var$labToLch($79c422e1aade6ff8$var$xyzToLab($79c422e1aade6ff8$var$rgbToXyz(rgb)));
const $79c422e1aade6ff8$var$lchToRgb = (lch)=>$79c422e1aade6ff8$var$xyzToRgb($79c422e1aade6ff8$var$labToXyz($79c422e1aade6ff8$var$lchToLab(lch)));
const $79c422e1aade6ff8$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    lch.l = $79c422e1aade6ff8$var$clamp(newPercent, 0, 100);
    return $79c422e1aade6ff8$var$rgbToHex($79c422e1aade6ff8$var$lchToRgb(lch));
};
const $79c422e1aade6ff8$var$getLightness = (color)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    return lch.l;
};
const $79c422e1aade6ff8$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $79c422e1aade6ff8$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $79c422e1aade6ff8$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});



parcelRegister("dx7fV", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $9da3fc4a55f49543$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $9da3fc4a55f49543$export$1edee58a52776cd9);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $9da3fc4a55f49543$var$borderColorArrayPalette = [
    [
        (0, $jR93G.N300A),
        'Subtle gray'
    ],
    [
        (0, $jR93G.N600),
        'Gray'
    ],
    [
        (0, $jR93G.N1000),
        'Bold gray'
    ]
];
const $9da3fc4a55f49543$export$e4e044c989c86ca7 = new Map();
$9da3fc4a55f49543$var$borderColorArrayPalette.forEach(([color, label])=>$9da3fc4a55f49543$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $9da3fc4a55f49543$export$1edee58a52776cd9 = (0, $iGMmR.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $9da3fc4a55f49543$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $a3bbC.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("5He3U", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $425be04f82df9f96$export$89015c65f1c75e3f);

var $iGMmR = parcelRequire("iGMmR");
const $425be04f82df9f96$var$allowedTypes = [
    'wide',
    'full-width'
];
const $425be04f82df9f96$export$89015c65f1c75e3f = (0, $iGMmR.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                return {
                    mode: $425be04f82df9f96$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode
            },
            0
        ];
    }
});

});

parcelRegister("4ohT6", function(module, exports) {

$parcel$export(module.exports, "code", () => $33274773c4b5166a$export$6565f9f03506010b);

var $iGMmR = parcelRequire("iGMmR");
const $33274773c4b5166a$export$6565f9f03506010b = (0, $iGMmR.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("de8p2", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $9a1319ce36df48fa$export$f3b72f8fc4684ecd);

var $iGMmR = parcelRequire("iGMmR");
const $9a1319ce36df48fa$export$f3b72f8fc4684ecd = (0, $iGMmR.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("8nj7b", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $618f4c86e0c34ede$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $618f4c86e0c34ede$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $1pjCh = parcelRequire("1pjCh");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $618f4c86e0c34ede$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $1pjCh.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $618f4c86e0c34ede$export$3024f02c495408d6 = (0, $iGMmR.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$618f4c86e0c34ede$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $618f4c86e0c34ede$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("1pjCh", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $106757a7f274372d$export$c296e2d4365c37a5);
const $106757a7f274372d$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("79k1z", function(module, exports) {

$parcel$export(module.exports, "em", () => $5348e8113a21cfa8$export$c63c6f932822f543);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name em_mark
 */ const $5348e8113a21cfa8$var$emDOM = [
    'em'
];
const $5348e8113a21cfa8$export$c63c6f932822f543 = (0, $iGMmR.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $5348e8113a21cfa8$var$emDOM;
    }
});

});

parcelRegister("9iaXL", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $6c3e4c85b88bb30a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $6c3e4c85b88bb30a$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $1pjCh = parcelRequire("1pjCh");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $6c3e4c85b88bb30a$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $1pjCh.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $6c3e4c85b88bb30a$export$f00aeb236b6f05af = (0, $iGMmR.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$6c3e4c85b88bb30a$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $6c3e4c85b88bb30a$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("l9pLr", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $f65e6c756517ff64$export$480c699bd4ec0d86);

var $iGMmR = parcelRequire("iGMmR");
const $f65e6c756517ff64$export$480c699bd4ec0d86 = (0, $iGMmR.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("3SpHb", function(module, exports) {

$parcel$export(module.exports, "link", () => $2d2a58d971c4790c$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $2d2a58d971c4790c$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $4N6cH = parcelRequire("4N6cH");
/**
 * @name link_mark
 */ const $2d2a58d971c4790c$var$getLinkAttrs = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $4N6cH.isSafeUrl)(href)) return false;
        if ((0, $4N6cH.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $4N6cH.normalizeUrl)(href);
        return attrs;
    };
const $2d2a58d971c4790c$export$9c30223ca0a664fb = (0, $iGMmR.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $4N6cH.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $2d2a58d971c4790c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $2d2a58d971c4790c$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($2d2a58d971c4790c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("4N6cH", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $37d08cfa1c7b561a$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $37d08cfa1c7b561a$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $37d08cfa1c7b561a$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $37d08cfa1c7b561a$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $37d08cfa1c7b561a$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $izjsg = parcelRequire("izjsg");
const $37d08cfa1c7b561a$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $37d08cfa1c7b561a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $37d08cfa1c7b561a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($izjsg)))();
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $37d08cfa1c7b561a$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('tel:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('file:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $37d08cfa1c7b561a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $37d08cfa1c7b561a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$37d08cfa1c7b561a$var$tlds.push($37d08cfa1c7b561a$var$tlds2Char);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.tlds($37d08cfa1c7b561a$var$tlds, false);
const $37d08cfa1c7b561a$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $37d08cfa1c7b561a$export$6f7d7761b97f967 = (text)=>{
    if (!$37d08cfa1c7b561a$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($37d08cfa1c7b561a$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($37d08cfa1c7b561a$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $37d08cfa1c7b561a$export$6f7d7761b97f967(str);
    if (!match.length) match = $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $37d08cfa1c7b561a$export$6535eb414fa2c8b6(url) {
    const match = $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $37d08cfa1c7b561a$export$23579274a7a24f7b(url) {
    return url.startsWith('/');
}

});
parcelRegister("izjsg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d84a96391edf6631$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d84a96391edf6631$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d84a96391edf6631$var$isString(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object String]';
}
function $d84a96391edf6631$var$isObject(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Object]';
}
function $d84a96391edf6631$var$isRegExp(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object RegExp]';
}
function $d84a96391edf6631$var$isFunction(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Function]';
}
function $d84a96391edf6631$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d84a96391edf6631$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d84a96391edf6631$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d84a96391edf6631$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d84a96391edf6631$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d84a96391edf6631$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d84a96391edf6631$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d84a96391edf6631$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d84a96391edf6631$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d84a96391edf6631$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d84a96391edf6631$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("bUlLc"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d84a96391edf6631$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d84a96391edf6631$var$isObject(val)) {
            if ($d84a96391edf6631$var$isRegExp(val.validate)) compiled.validate = $d84a96391edf6631$var$createValidator(val.validate);
            else if ($d84a96391edf6631$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d84a96391edf6631$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d84a96391edf6631$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d84a96391edf6631$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d84a96391edf6631$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d84a96391edf6631$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d84a96391edf6631$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d84a96391edf6631$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d84a96391edf6631$var$createMatch(self, shift) {
    var match = new $d84a96391edf6631$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d84a96391edf6631$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d84a96391edf6631$var$LinkifyIt)) return new $d84a96391edf6631$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d84a96391edf6631$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d84a96391edf6631$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d84a96391edf6631$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d84a96391edf6631$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d84a96391edf6631$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d84a96391edf6631$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d84a96391edf6631$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d84a96391edf6631$var$LinkifyIt;

});
parcelRegister("bUlLc", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("4NOMA", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("jvFHg", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8UCq2", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("aUAJj", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("4w9F8", function(module, exports) {

$parcel$export(module.exports, "strike", () => $34a1a559eec97f76$export$4899a95d70ec5056);

var $iGMmR = parcelRequire("iGMmR");
const $34a1a559eec97f76$export$4899a95d70ec5056 = (0, $iGMmR.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hkdIQ", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c9cef2e2919bbc38$export$59ae2c325a998f89);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name strong_mark
 */ const $c9cef2e2919bbc38$var$strongDOM = [
    'strong'
];
const $c9cef2e2919bbc38$export$59ae2c325a998f89 = (0, $iGMmR.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c9cef2e2919bbc38$var$strongDOM;
    }
});

});

parcelRegister("gIVi2", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $c2cd32026e6eb3a5$export$b3401ee80eb31041);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name subsup_mark
 */ function $c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $c2cd32026e6eb3a5$export$b3401ee80eb31041 = (0, $iGMmR.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("2ce3x", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $19979afb697512ce$export$20af3dabbb5538df);

var $iGMmR = parcelRequire("iGMmR");

var $jR93G = parcelRequire("jR93G");
const $19979afb697512ce$export$20af3dabbb5538df = (0, $iGMmR.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $jR93G.B400)}`
            }
        ];
    }
});

});

parcelRegister("7LHzX", function(module, exports) {

$parcel$export(module.exports, "underline", () => $5a7eba10acd79c46$export$425327af25286e5e);

var $iGMmR = parcelRequire("iGMmR");
const $5a7eba10acd79c46$export$425327af25286e5e = (0, $iGMmR.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("gLNTn", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $c357bcad799cb7a9$export$30d78d5eb6719bb8);

var $iGMmR = parcelRequire("iGMmR");
const $c357bcad799cb7a9$export$30d78d5eb6719bb8 = (0, $iGMmR.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("8osWo", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $61c703adc490c2ac$export$a316dc07ff5182a2);

var $iGMmR = parcelRequire("iGMmR");
const $61c703adc490c2ac$export$a316dc07ff5182a2 = (0, $iGMmR.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("heoPx", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $c8b70143c7895a82$export$c4c2f833baaebdb8);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name blockCard_node
 */ const $c8b70143c7895a82$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $c8b70143c7895a82$export$c4c2f833baaebdb8 = (0, $7XZYM.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("eStcf", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $ad4cc1abe1dded2c$export$27903d543b563e39);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $ad4cc1abe1dded2c$export$27903d543b563e39 = (0, $7XZYM.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("568Ob", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $3b645877cad760fc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $3b645877cad760fc$export$a140c94e5ea26bee);

var $7XZYM = parcelRequire("7XZYM");
const $3b645877cad760fc$export$5f25a39efab3b58b = '.ak-ul';
const $3b645877cad760fc$export$a140c94e5ea26bee = (0, $7XZYM.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $3b645877cad760fc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("d99SJ", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d);

var $7XZYM = parcelRequire("7XZYM");
const $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d = (0, $7XZYM.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("hgVop", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $c930734c642b0af7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $c930734c642b0af7$export$54fd2c36b5cc6731);

var $7dkLM = parcelRequire("7dkLM");

var $XHGTv = parcelRequire("XHGTv");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name codeBlock_node
 */ /**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_with_marks_node
 */ const $c930734c642b0af7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $c930734c642b0af7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $c930734c642b0af7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $c930734c642b0af7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $c930734c642b0af7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $c930734c642b0af7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $c930734c642b0af7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $c930734c642b0af7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $c930734c642b0af7$export$7bb0d5c671655cc4 = (0, $7XZYM.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $c930734c642b0af7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromEditorStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $c930734c642b0af7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                if ((0, $XHGTv.getBooleanFF)('platform.editor.codeblock.parsedom-divstyle-improve_5ib4n')) {
                    const code = $c930734c642b0af7$var$parseCodeFromHtml(domNode);
                    return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
                }
                const dom = domNode;
                const code = Array.from(dom.children).map((child)=>child.textContent).filter((x)=>x !== undefined).join('\n');
                return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $c930734c642b0af7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("eTtDn", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $ad7d306f65d843cf$export$daf889beb5092f95);

var $7XZYM = parcelRequire("7XZYM");
const $ad7d306f65d843cf$var$name = 'confluenceJiraIssue';
const $ad7d306f65d843cf$export$daf889beb5092f95 = (0, $7XZYM.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$ad7d306f65d843cf$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $ad7d306f65d843cf$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("1Ud4U", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $16352a752ab9df2e$export$e6e4878f43c27cab);

var $7XZYM = parcelRequire("7XZYM");
const $16352a752ab9df2e$var$name = 'confluenceUnsupportedBlock';
const $16352a752ab9df2e$export$e6e4878f43c27cab = (0, $7XZYM.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $16352a752ab9df2e$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$16352a752ab9df2e$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("56qNL", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $3b724d8f09621cf0$export$3e6d667072febc87);

var $7XZYM = parcelRequire("7XZYM");
const $3b724d8f09621cf0$var$name = 'confluenceUnsupportedInline';
const $3b724d8f09621cf0$export$3e6d667072febc87 = (0, $7XZYM.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $3b724d8f09621cf0$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$3b724d8f09621cf0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("8CDqw", function(module, exports) {

$parcel$export(module.exports, "date", () => $647074b218f86851$export$324d90190a8b822a);

var $7XZYM = parcelRequire("7XZYM");
const $647074b218f86851$export$324d90190a8b822a = (0, $7XZYM.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("47B7q", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $30049be2ce3504a7$export$6959e16eeff859b4);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $30049be2ce3504a7$export$6959e16eeff859b4 = (0, $7XZYM.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});
parcelRegister("lUXsh", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $ff4cf27d021d1199$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $ff4cf27d021d1199$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $ff4cf27d021d1199$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $ff4cf27d021d1199$var$staticValue = false;
const $ff4cf27d021d1199$export$31b40729666a4ae0 = {
    setStatic (value) {
        $ff4cf27d021d1199$var$staticValue = value;
    },
    generate () {
        return $ff4cf27d021d1199$var$staticValue || $ff4cf27d021d1199$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("dPUL6", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $a12c10e7c25a057a$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $a12c10e7c25a057a$export$62d45a65fb43d95e);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name decisionList_node
 */ const $a12c10e7c25a057a$var$name = 'decisionList';
const $a12c10e7c25a057a$export$a5393ce68c2ff601 = `[data-node-type="${$a12c10e7c25a057a$var$name}"]`;
const $a12c10e7c25a057a$export$62d45a65fb43d95e = (0, $7XZYM.decisionList)({
    parseDOM: [
        {
            tag: `ol${$a12c10e7c25a057a$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $a12c10e7c25a057a$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1HZv5", function(module, exports) {

$parcel$export(module.exports, "doc", () => $13e9834b2c1b91e1$export$2a111da947c407d2);

var $7XZYM = parcelRequire("7XZYM");
const $13e9834b2c1b91e1$export$2a111da947c407d2 = (0, $7XZYM.doc)({});

});

parcelRegister("7XTsD", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $5cc9107583ccf967$export$be4283d9a1cb1ff6);

var $7XZYM = parcelRequire("7XZYM");
const $5cc9107583ccf967$export$be4283d9a1cb1ff6 = (0, $7XZYM.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("5JhXr", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $42bf15c2cb81cca3$export$a19185d1233fc4b2);

var $7RIfh = parcelRequire("7RIfh");

var $7XZYM = parcelRequire("7XZYM");
const $42bf15c2cb81cca3$export$a19185d1233fc4b2 = (0, $7XZYM.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $7RIfh.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $7RIfh.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("7RIfh", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $5b9fcdd9b42caf92$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $5b9fcdd9b42caf92$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $5b9fcdd9b42caf92$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $5b9fcdd9b42caf92$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $5b9fcdd9b42caf92$export$f61e93bda2a8b420(acName) {
    const emojiData = $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$5b9fcdd9b42caf92$var$acNameToEmojiMap[acName] ? $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($5b9fcdd9b42caf92$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $5b9fcdd9b42caf92$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $5b9fcdd9b42caf92$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName);
        if (possibleName in $5b9fcdd9b42caf92$var$acNameToEmojiMap) return possibleName;
    }
    return $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(id) || $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("7y7sZ", function(module, exports) {

$parcel$export(module.exports, "extension", () => $57f1801b48030dd3$export$1b45514b112dd749);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $57f1801b48030dd3$export$1b45514b112dd749 = (0, $7XZYM.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7SlQD", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $5bbe86148e97ac9f$export$371da9dd35aba193);

var $7XZYM = parcelRequire("7XZYM");
const $5bbe86148e97ac9f$export$371da9dd35aba193 = (0, $7XZYM.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("iWGOh", function(module, exports) {

$parcel$export(module.exports, "heading", () => $dcaed9f1743d53de$export$46e4a324ac90507f);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $dcaed9f1743d53de$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $dcaed9f1743d53de$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $dcaed9f1743d53de$export$46e4a324ac90507f = (0, $7XZYM.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("iOeir", function(module, exports) {

$parcel$export(module.exports, "image", () => $db17fc75bafe5b63$export$5c452ff88e35e47d);

var $7XZYM = parcelRequire("7XZYM");
const $db17fc75bafe5b63$export$5c452ff88e35e47d = (0, $7XZYM.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("8mC62", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $616dedf2d343125f$export$cbf8224b64e0d942);

var $7XZYM = parcelRequire("7XZYM");
const $616dedf2d343125f$export$cbf8224b64e0d942 = (0, $7XZYM.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("7xvQK", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $57d4522b818e953c$export$16b353b2649bd8d9);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $57d4522b818e953c$export$16b353b2649bd8d9 = (0, $7XZYM.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("1O3jv", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $150d07f918689e82$export$ab76e7c03cd6f650);

var $7XZYM = parcelRequire("7XZYM");
const $150d07f918689e82$export$ab76e7c03cd6f650 = (0, $7XZYM.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("gN3fl", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $c393bda0a4dc410d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $c393bda0a4dc410d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $c393bda0a4dc410d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $c393bda0a4dc410d$export$54fd2c36b5cc6731);

var $jR93G = parcelRequire("jR93G");

var $7XZYM = parcelRequire("7XZYM");
const $c393bda0a4dc410d$export$bb3fe706be61f640 = (0, $7XZYM.media)({}).attrs;
const $c393bda0a4dc410d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $c393bda0a4dc410d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $jR93G.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $c393bda0a4dc410d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$c393bda0a4dc410d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $7XZYM.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $7XZYM.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $c393bda0a4dc410d$export$987d49ffe1b0900f = $c393bda0a4dc410d$export$35bdbf5bc8caa677($c393bda0a4dc410d$export$bb3fe706be61f640, false);
const $c393bda0a4dc410d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $c393bda0a4dc410d$export$111130fa8968d741 = (from, to, map)=>{
    if ($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs) Object.keys($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $c393bda0a4dc410d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $c393bda0a4dc410d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $c393bda0a4dc410d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $c393bda0a4dc410d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($c393bda0a4dc410d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("1KDvn", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $1468bb36b31049a8$export$2855e964765eac9);

var $7XZYM = parcelRequire("7XZYM");
const $1468bb36b31049a8$export$2855e964765eac9 = (0, $7XZYM.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("hXvCf", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $d130789d4554ffe4$export$38bab695e3f720f1);

var $gN3fl = parcelRequire("gN3fl");

var $7XZYM = parcelRequire("7XZYM");
const $d130789d4554ffe4$export$38bab695e3f720f1 = (0, $gN3fl.createMediaSpec)((0, $7XZYM.mediaInline)({}).attrs, true);

});

parcelRegister("cvCFq", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $91b65fc731134d1d$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $91b65fc731134d1d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $91b65fc731134d1d$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $91b65fc731134d1d$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $91b65fc731134d1d$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $91b65fc731134d1d$export$54fd2c36b5cc6731);

var $H6cl0 = parcelRequire("H6cl0");

var $1pjCh = parcelRequire("1pjCh");

var $7XZYM = parcelRequire("7XZYM");
const $91b65fc731134d1d$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $91b65fc731134d1d$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $1pjCh.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $H6cl0.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $H6cl0.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $7XZYM.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $7XZYM.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $7XZYM.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $7XZYM.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $91b65fc731134d1d$export$969fe3781ca15058 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$d35e6c006d4abdfb = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$9c58e19811ce4cf5 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$7e767666f2ce108a = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("H6cl0", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $0818d30f6134b029$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $0818d30f6134b029$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("fkqTY", function(module, exports) {

$parcel$export(module.exports, "mention", () => $b28d976c62a93439$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $b28d976c62a93439$export$54fd2c36b5cc6731);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
let $b28d976c62a93439$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $b28d976c62a93439$export$db83999c14438df4 = (0, $7XZYM.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $b28d976c62a93439$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $b28d976c62a93439$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $b28d976c62a93439$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $lUXsh.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($b28d976c62a93439$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $b28d976c62a93439$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $b28d976c62a93439$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($b28d976c62a93439$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dj4Ew", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9b00a8a2bcf49bd5$export$63cadbf5f4296627);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9b00a8a2bcf49bd5$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9b00a8a2bcf49bd5$export$63cadbf5f4296627 = (0, $7XZYM.nestedExpand)({
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9b00a8a2bcf49bd5$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9b00a8a2bcf49bd5$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8lnnz", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $61326b7f5996ad33$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $61326b7f5996ad33$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $61326b7f5996ad33$export$b9ab759e8298198f);

var $7XZYM = parcelRequire("7XZYM");
const $61326b7f5996ad33$export$4e7125c7ff595be5 = '.ak-ol';
const $61326b7f5996ad33$export$a5dc81035676e7a = (0, $7XZYM.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $61326b7f5996ad33$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $61326b7f5996ad33$export$b9ab759e8298198f = (0, $7XZYM.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $61326b7f5996ad33$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $61326b7f5996ad33$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5bGpU", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3c6ee1ed25404369$export$9c206ddddb32a9b);

var $7XZYM = parcelRequire("7XZYM");
const $3c6ee1ed25404369$export$9c206ddddb32a9b = (0, $7XZYM.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $3c6ee1ed25404369$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dDs5p", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $028fd15bd9efda92$export$c7187bbd1a7a9244);

var $7XZYM = parcelRequire("7XZYM");
const $028fd15bd9efda92$export$c7187bbd1a7a9244 = (0, $7XZYM.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $028fd15bd9efda92$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("7wZ4m", function(module, exports) {

$parcel$export(module.exports, "rule", () => $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name rule_node
 */ const $57bae4a7ab6a77ec$var$hrDOM = [
    'hr'
];
const $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7 = (0, $7XZYM.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $57bae4a7ab6a77ec$var$hrDOM;
    }
});

});

parcelRegister("cvo5z", function(module, exports) {

$parcel$export(module.exports, "status", () => $91ab10d6717106ff$export$471f7ae5c4103ae1);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $91ab10d6717106ff$export$471f7ae5c4103ae1 = (0, $7XZYM.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $lUXsh.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("byxO6", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $869d1810285fb07e$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $869d1810285fb07e$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $869d1810285fb07e$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $869d1810285fb07e$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $869d1810285fb07e$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $869d1810285fb07e$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $869d1810285fb07e$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $869d1810285fb07e$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $869d1810285fb07e$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $869d1810285fb07e$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $869d1810285fb07e$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $869d1810285fb07e$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $869d1810285fb07e$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $869d1810285fb07e$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $869d1810285fb07e$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $869d1810285fb07e$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $869d1810285fb07e$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $869d1810285fb07e$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $869d1810285fb07e$export$2af48797a1010bb1);

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $lUXsh = parcelRequire("lUXsh");

var $as9OS = parcelRequire("as9OS");

var $7XZYM = parcelRequire("7XZYM");
const $869d1810285fb07e$export$9cfceb893b24742a = 'pm-table';
const $869d1810285fb07e$export$69cb4c3f80383763 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-content-wrap`;
const $869d1810285fb07e$export$7b07d37d879c957f = `${$869d1810285fb07e$export$9cfceb893b24742a}-header-content-wrap`;
const $869d1810285fb07e$export$8dd42a84cd52da07 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $869d1810285fb07e$export$5e26a5c19f0865d8 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $jR93G.N20).toLocaleLowerCase();
const $869d1810285fb07e$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $jR93G.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $jR93G.isRgb)(backgroundColor)) {
        const result = (0, $jR93G.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $869d1810285fb07e$var$testGlobalTheme;
const $869d1810285fb07e$export$fd7e0dd2b74807f7 = (theme)=>{
    $869d1810285fb07e$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $869d1810285fb07e$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($869d1810285fb07e$var$testGlobalTheme) return {
        colorMode: $869d1810285fb07e$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $869d1810285fb07e$var$cssVariablePattern = /^var\(--.*\)$/;
const $869d1810285fb07e$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $jR93G.isRgb)(background) && (0, $jR93G.rgbToHex)(background) ? (0, $jR93G.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $a3bbC.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $869d1810285fb07e$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($869d1810285fb07e$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $as9OS.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $869d1810285fb07e$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $869d1810285fb07e$export$7b07d37d879c957f;
    else attrs.class = $869d1810285fb07e$export$69cb4c3f80383763;
    return attrs;
};
const $869d1810285fb07e$export$219b7f492ad209f8 = new Map();
const $869d1810285fb07e$export$95e9c925fbf01d1c = (0, $jR93G.hexToRgba)((0, $jR93G.N800), 0.12) || (0, $jR93G.N0);
const $869d1810285fb07e$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B50),
        'Light blue'
    ],
    [
        (0, $jR93G.T50),
        'Light teal'
    ],
    [
        (0, $jR93G.G50),
        'Light green'
    ],
    [
        (0, $jR93G.Y50),
        'Light yellow'
    ],
    [
        (0, $jR93G.R50),
        'Light red'
    ],
    [
        (0, $jR93G.P50),
        'Light purple'
    ],
    [
        (0, $jR93G.N20),
        'Light gray'
    ],
    [
        (0, $jR93G.B75),
        'Blue'
    ],
    [
        (0, $jR93G.T75),
        'Teal'
    ],
    [
        (0, $jR93G.G75),
        'Green'
    ],
    [
        (0, $jR93G.Y75),
        'Yellow'
    ],
    [
        (0, $jR93G.R75),
        'Red'
    ],
    [
        (0, $jR93G.P75),
        'Purple'
    ],
    [
        (0, $jR93G.N60),
        'Gray'
    ],
    [
        (0, $jR93G.B100),
        'Dark blue'
    ],
    [
        (0, $jR93G.T100),
        'Dark teal'
    ],
    [
        (0, $jR93G.G200),
        'Dark green'
    ],
    [
        (0, $jR93G.Y200),
        'Dark yellow'
    ],
    [
        (0, $jR93G.R100),
        'Dark red'
    ],
    [
        (0, $jR93G.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $869d1810285fb07e$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $869d1810285fb07e$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // TODO: Fix any, potential issue. ED-5048
const $869d1810285fb07e$var$createTableSpec = ()=>(0, $7XZYM.table)({
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: // copying from editor
                        dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, $lUXsh.uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    });
const $869d1810285fb07e$export$9852986a3ec5f6a0 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$90e634fbace1f0c4 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$3862de5c8c9098cf = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $869d1810285fb07e$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$869d1810285fb07e$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $869d1810285fb07e$export$ce666bf02318c957 = (0, $7XZYM.tableRow)({
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
});
const $869d1810285fb07e$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $869d1810285fb07e$export$e1e720e5f4603e6a = (0, $7XZYM.tableCell)({
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
});
const $869d1810285fb07e$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($869d1810285fb07e$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $869d1810285fb07e$export$48884d2a5190dc73 = (0, $7XZYM.tableHeader)({
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom, {
                    background: $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
});
const $869d1810285fb07e$export$2af48797a1010bb1 = $869d1810285fb07e$export$2ac34c099660f1a8;

});

parcelRegister("ie5d6", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $d44d9373b8f163aa$export$6d8b0ef52e2e6390);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $d44d9373b8f163aa$export$6d8b0ef52e2e6390 = (0, $7XZYM.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7QozA", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $5b607363bfbaed7e$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $5b607363bfbaed7e$export$375b6afcc5f4d291);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name taskList_node
 */ const $5b607363bfbaed7e$var$name = 'actionList';
const $5b607363bfbaed7e$export$c0ec71adb7a18fb2 = `[data-node-type="${$5b607363bfbaed7e$var$name}"]`;
const $5b607363bfbaed7e$export$375b6afcc5f4d291 = (0, $7XZYM.taskList)({
    parseDOM: [
        {
            tag: `div${$5b607363bfbaed7e$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $5b607363bfbaed7e$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("ltJuR", function(module, exports) {

$parcel$export(module.exports, "text", () => $fa2f9921fdf8b722$export$6f093cfa640b7166);

var $7XZYM = parcelRequire("7XZYM");
const $fa2f9921fdf8b722$export$6f093cfa640b7166 = (0, $7XZYM.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("4ne8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f4472c0028f4d7$export$2e2bcd8739ae039);
const $32f4472c0028f4d7$var$name = 'unknownBlock';
var $32f4472c0028f4d7$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $32f4472c0028f4d7$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$32f4472c0028f4d7$var$name}"]`
        }
    ]
};

});

parcelRegister("7p32Z", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $563d3b506527dd26$export$44b79b0979d0f0f7);

var $7XZYM = parcelRequire("7XZYM");
const $563d3b506527dd26$export$44b79b0979d0f0f7 = (0, $7XZYM.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("8cuPa", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $5f875acca3371d13$export$310ebe0d80122e9b);

var $7XZYM = parcelRequire("7XZYM");
const $5f875acca3371d13$export$310ebe0d80122e9b = (0, $7XZYM.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("7Y6sw", function(module, exports) {

$parcel$export(module.exports, "defaultNodeComponents", () => $e41301324310ff6f$export$ee31295d51950741);
$parcel$export(module.exports, "default", () => $e41301324310ff6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9wcjJ = parcelRequire("9wcjJ");

var $cBoJh = parcelRequire("cBoJh");

var $fLfen = parcelRequire("fLfen");
var $eQbJA = parcelRequire("eQbJA");

var $8lJ1v = parcelRequire("8lJ1v");
var $6zWLF = parcelRequire("6zWLF");
var $ghZO5 = parcelRequire("ghZO5");
var $4iaaT = parcelRequire("4iaaT");
var $a3eWT = parcelRequire("a3eWT");

var $9ndID = parcelRequire("9ndID");

var $cC72g = parcelRequire("cC72g");
var $5Fak9 = parcelRequire("5Fak9");

var $f8mRM = parcelRequire("f8mRM");

var $h3qKx = parcelRequire("h3qKx");

var $jMQbs = parcelRequire("jMQbs");

var $dHwtf = parcelRequire("dHwtf");

var $XHGTv = parcelRequire("XHGTv");

var $gL7tA = parcelRequire("gL7tA");

var $25FYC = parcelRequire("25FYC");

var $88sYM = parcelRequire("88sYM");

var $dcbVh = parcelRequire("dcbVh");

var $dFBS3 = parcelRequire("dFBS3");

var $lS7UL = parcelRequire("lS7UL");
var $15lMG = parcelRequire("15lMG");

var $9pV0l = parcelRequire("9pV0l");

var $eNyed = parcelRequire("eNyed");

var $auyn4 = parcelRequire("auyn4");

var $3rMck = parcelRequire("3rMck");

var $86Pbu = parcelRequire("86Pbu");

var $2dNsW = parcelRequire("2dNsW");

var $czPRi = parcelRequire("czPRi");

var $3y8r4 = parcelRequire("3y8r4");

var $fGrAu = parcelRequire("fGrAu");

var $51CHm = parcelRequire("51CHm");

var $1UbnR = parcelRequire("1UbnR");

var $9oaPg = parcelRequire("9oaPg");

var $irna0 = parcelRequire("irna0");

var $0jEfW = parcelRequire("0jEfW");

var $5iWql = parcelRequire("5iWql");

var $ks9LI = parcelRequire("ks9LI");

var $528fV = parcelRequire("528fV");

var $jzB8h = parcelRequire("jzB8h");
const $e41301324310ff6f$export$47b2879ca9bbf67a = 2000;
const $e41301324310ff6f$export$1b622068be977101 = 3000;
const $e41301324310ff6f$var$packageName = "platform-pkg";
const $e41301324310ff6f$var$packageVersion = "0.0.0-use.local";
const $e41301324310ff6f$export$ee31295d51950741 = (0, $jzB8h.nodeToReact);
class $e41301324310ff6f$export$88530751e3977073 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        /**
   * This is used in measuring the Renderer Mount time and is then
   * deleted once that measurement occurs.
   */ this.renderedMeasurementDistortedDurationMonitor = (0, $h3qKx.getDistortedDurationMonitor)();
        this.featureFlags = (0, $5iWql.default)((featureFlags)=>{
            const normalizedFeatureFlags = (0, $gL7tA.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags
            };
        });
        this.fireAnalyticsEvent = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $88sYM.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        };
        this.getSchema = (0, $5iWql.default)((schema, adfStage)=>{
            if (schema) return schema;
            return (0, $9wcjJ.getSchemaBasedOnStage)(adfStage);
        });
        this.onMouseDownEditView = ()=>{
            // When the user is deselecting text on the screen by clicking, if they are clicking outside
            // the current selection, by the time the onclick handler is called the window.getSelection()
            // value will already be cleared.
            // The mousedown callback is called before the selection is cleared.
            const windowSelection = window.getSelection();
            this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
        };
        this.handleMouseTripleClickInTables = (event)=>{
            if ((0, $jMQbs.browser).ios || (0, $jMQbs.browser).android) return;
            const badBrowser = (0, $jMQbs.browser).chrome || (0, $jMQbs.browser).safari;
            const tripleClick = event.detail >= 3;
            if (!(badBrowser && tripleClick)) return;
            const selection = window.getSelection();
            if (!selection) return;
            const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
            const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
            if (!rangeSelection) return;
            const target = event.target;
            const tableCell = target.closest('td,th');
            const clickedInCell = Boolean(tableCell);
            if (!clickedInCell) return;
            const anchorInCell = tableCell.contains(anchorNode);
            const focusInCell = tableCell.contains(focusNode);
            const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
            if (!selectionStartsOrEndsOutsideClickedCell) return;
            // If selection starts or ends in a different cell than the clicked cell,
            // we select the node inside the clicked cell (or if both are in a different
            // cell, we select the cell's contents instead). We want to select the nearest
            // parent block, so that a whole line of text/content is selected (rather than
            // selecting a span that would select one specific chunk of text).
            const elementToSelect = anchorInCell ? anchorNode.parentElement?.closest('div,p') : focusInCell ? focusNode.parentElement?.closest('div,p') : tableCell;
            if (elementToSelect) selection.selectAllChildren(elementToSelect);
        };
        this.providerFactory = props.dataProviders || new (0, $fLfen.default)();
        this.serializer = new (0, $lS7UL.default)(this.deriveSerializerProps(props));
        this.editorRef = props.innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        (0, $9ndID.startMeasure)(`Renderer Render Time: ${this.id}`);
        const featureFlags = this.featureFlags(this.props.featureFlags).featureFlags;
        if (featureFlags?.rendererTtiTracking) (0, $f8mRM.measureTTI)((tti, ttiFromInvocation, canceled)=>{
            this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).RENDERER_TTI,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                attributes: {
                    tti: tti,
                    ttiFromInvocation: ttiFromInvocation,
                    canceled: canceled
                },
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
        });
    }
    anchorLinkAnalytics() {
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const { disableHeadingIDs: disableHeadingIDs } = this.props;
        if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            // We are not use this.editorRef.querySelector here, instead we have this.editorRef.contains
            // because querySelector might fail if there are special characters in hash, and CSS.escape is still experimental.
            if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).VIEWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    mode: (0, $3rMck.MODE).RENDERER
                },
                eventType: (0, $auyn4.EVENT_TYPE).UI
            });
        }
    }
    componentDidMount() {
        this.fireAnalyticsEvent({
            action: (0, $auyn4.ACTION).STARTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        });
        this.rafID = requestAnimationFrame(()=>{
            (0, $9ndID.stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $5Fak9.shouldForceTracking)();
                const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $cC72g.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $e41301324310ff6f$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $e41301324310ff6f$export$1b622068be977101) : undefined;
                // ED-16320: Check for explicit disable so that by default
                // it will still be enabled as it currently is. Then we can
                // progressively opt out synthetic tenants.
                const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).RENDERED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                    attributes: {
                        platform: (0, $3rMck.PLATFORM).WEB,
                        duration: duration,
                        distortedDuration: this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                        ttfb: (0, $dHwtf.getResponseEndTime)(),
                        nodes: (0, $cBoJh.reduce)(this.props.document, (acc, node)=>{
                            acc[node.type] = (acc[node.type] || 0) + 1;
                            return acc;
                        }, {}),
                        severity: severity
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                });
                this.renderedMeasurementDistortedDurationMonitor.cleanup();
                delete this.renderedMeasurementDistortedDurationMonitor;
            });
            this.anchorLinkAnalytics();
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextMedia = nextProps.media || {};
        const media = this.props.media || {};
        if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, $lS7UL.default)(this.deriveSerializerProps(nextProps));
    }
    deriveSerializerProps(props) {
        // if just passed a boolean, change shape into object to simplify type
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = this.featureFlags(props.featureFlags);
        return {
            providers: this.providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            // does not currently support SSR, should not be enabled in environments where Renderer is SSR-ed
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: (0, $XHGTv.fg)('platform.editor.inline_extension.extended_lcqdn') && props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter,
            isCommentsOnMediaMediaInlineBugFixEnabled: featureFlags?.commentsOnMediaMediaInlineBugFix,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }
    render() {
        const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media } = this.props;
        const featureFlags = this.featureFlags(this.props.featureFlags);
        const allowNestedHeaderLinks = (0, $1UbnR.isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
        /**
     * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
     * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
     * renderer out for the editor).
     * @param event Click event anywhere inside renderer
     */ const handleWrapperOnClick = (event)=>{
            const targetElement = event.target;
            // ED-14862: When a user triple clicks to select a line of content inside a
            // a table cell, but the browser incorrectly moves the selection start or end into
            // a different table cell, we manually set the selection back to within the original
            // table cell the user intended to target
            this.handleMouseTripleClickInTables(event);
            if (!this.props.eventHandlers?.onUnhandledClick) return;
            if (!(targetElement instanceof window.Element)) return;
            const rendererWrapper = event.currentTarget;
            // Check if the click was on an interactive element
            const isInteractiveElementInTree = (0, $9oaPg.findInTree)(targetElement, rendererWrapper, (0, $irna0.isInteractiveElement));
            if (isInteractiveElementInTree) return;
            // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
            // This logic originated in jira-frontend:
            // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
            // The selection is required to be checked in `onMouseDown` and here. If not here, a new
            // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
            // return an empty selection, which will erroneously fire onUnhandledClick.
            const windowSelection = window.getSelection();
            const selection = windowSelection !== null ? windowSelection.toString() : undefined;
            const hasSelection = selection && selection.length !== 0;
            const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
            const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
            if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
        };
        try {
            const schema = this.getSchema(this.props.schema, this.props.adfStage);
            const { result: result, stat: stat, pmDoc: pmDoc } = (0, $15lMG.renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance);
            if (onComplete) onComplete(stat);
            const rendererOutput = /*#__PURE__*/ (0, $byn9U.jsx)((0, $0jEfW.RendererContextProvider), {
                value: featureFlags
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fGrAu.ActiveHeaderIdProvider), {
                value: (0, $1UbnR.getActiveHeadingId)(allowHeadingAnchorLinks)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $86Pbu.default).Provider, {
                value: {
                    fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                }
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2dNsW.Provider), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eQbJA.ProviderFactoryProvider), {
                value: this.providerFactory
            }, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: allowColumnSorting,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowCustomPanels: allowCustomPanels,
                allowPlaceholderText: allowPlaceholderText,
                useBlockRenderForCodeBlock: featureFlags.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                innerRef: this.editorRef,
                onClick: handleWrapperOnClick,
                onMouseDown: this.onMouseDownEditView,
                ssr: media?.ssr,
                isInsideOfInlineExtension: this.props.isInsideOfInlineExtension
            }, enableSsrInlineScripts ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $czPRi.BreakoutSSRInlineScript), null) : null, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$var$RendererActionsInternalUpdater, {
                doc: pmDoc,
                schema: schema,
                onAnalyticsEvent: this.fireAnalyticsEvent
            }, result)))))));
            let rendererResult = truncated ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eNyed.TruncatedWrapper), {
                height: maxHeight,
                fadeHeight: fadeOutHeight
            }, rendererOutput) : rendererOutput;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, rendererResult);
        } catch (e) {
            if (onError) onError(e);
            return /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowPlaceholderText: allowPlaceholderText,
                allowColumnSorting: allowColumnSorting,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                useBlockRenderForCodeBlock: featureFlags.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                onClick: handleWrapperOnClick
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ghZO5.default), null));
        }
    }
    componentWillUnmount() {
        const { dataProviders: dataProviders } = this.props;
        if (this.rafID) window.cancelAnimationFrame(this.rafID);
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) this.providerFactory.destroy();
    }
}
const $e41301324310ff6f$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $dcbVh.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $cC72g.getAnalyticsAppearance)(props.appearance),
            packageName: $e41301324310ff6f$var$packageName,
            packageVersion: $e41301324310ff6f$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3eWT.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ks9LI.ErrorBoundary), {
                component: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zWLF.IntlErrorBoundary), null, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $e41301324310ff6f$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $9pV0l.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $9pV0l.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $9pV0l.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: (0, $XHGTv.fg)('platform.editor.inline_extension.extended_lcqdn') && isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8lJ1v.BaseTheme), {
        baseFontSize: appearance && appearance !== 'comment' ? (0, $25FYC.akEditorFullPageDefaultFontSize) : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $528fV.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9pV0l.rendererStyles)({
            appearance: appearance,
            allowNestedHeaderLinks: allowNestedHeaderLinks,
            allowColumnSorting: !!allowColumnSorting,
            useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
            allowAnnotations: props.allowAnnotations,
            allowTableResizing: allowTableResizing
        })
    }, children))));
});
function $e41301324310ff6f$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const rendererRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (doc) actions._privateRegisterRenderer(rendererRef, doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        doc,
        onAnalyticsEvent
    ]);
    return children;
}
const $e41301324310ff6f$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) return /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3y8r4.RendererActionsContext), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $51CHm.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var /* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $e41301324310ff6f$export$2e2bcd8739ae039 = $e41301324310ff6f$var$RendererWithAnnotationSelection;

});
parcelRegister("cBoJh", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $20fd485d301fa5b8$export$533b26079ad0b4b);

var $hYZXM = parcelRequire("hYZXM");
function $20fd485d301fa5b8$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("fLfen", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31a16c45fbc6a54$export$2e2bcd8739ae039);
function $b31a16c45fbc6a54$var$isUndefined(x) {
    return x === undefined;
}
class $b31a16c45fbc6a54$export$2e2bcd8739ae039 {
    static create(providers) {
        const providerFactory = new $b31a16c45fbc6a54$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$b31a16c45fbc6a54$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("eQbJA", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $c43429769ae35a0a$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $c43429769ae35a0a$export$693cdb10cec23617);

var $eUqFw = parcelRequire("eUqFw");

var $fLfen = parcelRequire("fLfen");
const $c43429769ae35a0a$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new (0, $fLfen.default)());
const $c43429769ae35a0a$export$617c134b25cc4265 = $c43429769ae35a0a$var$ProviderFactoryContext.Provider;
const $c43429769ae35a0a$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($c43429769ae35a0a$var$ProviderFactoryContext);
const $c43429769ae35a0a$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState();
    const providerFactory = $c43429769ae35a0a$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("8lJ1v", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $18ee109913827a1b$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $18ee109913827a1b$export$a1a213d350ca51ca);

var $eUqFw = parcelRequire("eUqFw");

var $4WmDP = parcelRequire("4WmDP");

var $25FYC = parcelRequire("25FYC");

var $lcnyw = parcelRequire("lcnyw");

var $4iaaT = parcelRequire("4iaaT");
function $18ee109913827a1b$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $18ee109913827a1b$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eUqFw.useMemo)(()=>({
            baseFontSize: baseFontSize || (0, $lcnyw.fontSize)(),
            layoutMaxWidth: (0, $25FYC.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WmDP.a), {
        theme: memoizedTheme
    }, children);
}
function $18ee109913827a1b$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($18ee109913827a1b$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)));
}

});
parcelRegister("25FYC", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $823f29f46e51fd3b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $823f29f46e51fd3b$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $823f29f46e51fd3b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $823f29f46e51fd3b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $823f29f46e51fd3b$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $823f29f46e51fd3b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $823f29f46e51fd3b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $823f29f46e51fd3b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $823f29f46e51fd3b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBgColor", () => $823f29f46e51fd3b$export$ef597e2e80767649);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $823f29f46e51fd3b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $823f29f46e51fd3b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $823f29f46e51fd3b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $823f29f46e51fd3b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $823f29f46e51fd3b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $823f29f46e51fd3b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $823f29f46e51fd3b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $823f29f46e51fd3b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $823f29f46e51fd3b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $823f29f46e51fd3b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $823f29f46e51fd3b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $823f29f46e51fd3b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $823f29f46e51fd3b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $823f29f46e51fd3b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $823f29f46e51fd3b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $823f29f46e51fd3b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $823f29f46e51fd3b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $823f29f46e51fd3b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $823f29f46e51fd3b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $823f29f46e51fd3b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $823f29f46e51fd3b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $823f29f46e51fd3b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $823f29f46e51fd3b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $823f29f46e51fd3b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $823f29f46e51fd3b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $823f29f46e51fd3b$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $823f29f46e51fd3b$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $823f29f46e51fd3b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $823f29f46e51fd3b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $823f29f46e51fd3b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $823f29f46e51fd3b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $823f29f46e51fd3b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $823f29f46e51fd3b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $823f29f46e51fd3b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $823f29f46e51fd3b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $823f29f46e51fd3b$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $823f29f46e51fd3b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $823f29f46e51fd3b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $823f29f46e51fd3b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $823f29f46e51fd3b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $823f29f46e51fd3b$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $823f29f46e51fd3b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $823f29f46e51fd3b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $823f29f46e51fd3b$export$de3cef07cda55645);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $823f29f46e51fd3b$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $823f29f46e51fd3b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $823f29f46e51fd3b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $823f29f46e51fd3b$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $823f29f46e51fd3b$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $823f29f46e51fd3b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $823f29f46e51fd3b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $823f29f46e51fd3b$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $823f29f46e51fd3b$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "avatarColors", () => $823f29f46e51fd3b$export$312e1e71424c4aa1);

var $XHGTv = parcelRequire("XHGTv");


var $lcnyw = parcelRequire("lcnyw");
const $823f29f46e51fd3b$export$fe6b0b821a0e9067 = 16;
const $823f29f46e51fd3b$export$9a7c520c39e1f0aa = (0, $lcnyw.codeFontFamily)();
const $823f29f46e51fd3b$export$e314d58809da911b = (0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
const $823f29f46e51fd3b$export$9a3076d23c153d92 = (0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
const $823f29f46e51fd3b$export$1d762aef048d30f9 = (0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
const $823f29f46e51fd3b$export$46f75d2f1d59b188 = (0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
const $823f29f46e51fd3b$export$c997cfdaffb4d6e6 = (0, $73a5c9d720aa66e1$export$29a4f05edc054374);
const $823f29f46e51fd3b$export$a7a75e50ae62d0a8 = (0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
const $823f29f46e51fd3b$export$e549ee8be3e2f59f = (0, $73a5c9d720aa66e1$export$fbda843f0a27fe96);
const $823f29f46e51fd3b$export$781884c8fda242b6 = (0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
const $823f29f46e51fd3b$export$a9a8b3b91667afe1 = (0, $73a5c9d720aa66e1$export$226de0355ed012f8);
const $823f29f46e51fd3b$export$5e112b63e4291515 = (0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
const $823f29f46e51fd3b$export$b9864494c2608629 = (0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
const $823f29f46e51fd3b$export$f0e953d95429ca1 = '12px';
const $823f29f46e51fd3b$export$a309dbdeca0adb1a = '2px 4px';
const $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a = (0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
const $823f29f46e51fd3b$export$886b94e7e5d244bf = (0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
const $823f29f46e51fd3b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $823f29f46e51fd3b$export$3c108a6bc41bb5f2 = (0, $73a5c9d720aa66e1$export$4a7404f376229999);
const $823f29f46e51fd3b$export$bf3aaa2106c119fd = (0, $73a5c9d720aa66e1$export$2010d0fb4295b346);
const $823f29f46e51fd3b$export$d2715266dd4a1fd1 = 20;
const $823f29f46e51fd3b$export$cf524c1b49838a49 = (0, $73a5c9d720aa66e1$export$e62e8919cca44969);
const $823f29f46e51fd3b$export$ef597e2e80767649 = (0, $73a5c9d720aa66e1$export$226de0355ed012f8);
const $823f29f46e51fd3b$export$514e6c370fbea91d = (0, $73a5c9d720aa66e1$export$8c13c2ee36917869);
const $823f29f46e51fd3b$export$8dac549e32469ac4 = 1;
const $823f29f46e51fd3b$export$6e1e1996c4e8cc51 = `${$823f29f46e51fd3b$export$8dac549e32469ac4}px solid ${`var(--ds-border-selected, ${$823f29f46e51fd3b$export$cf524c1b49838a49})`}`;
const $823f29f46e51fd3b$export$b6a59ac3a19b6343 = `0 0 0 ${$823f29f46e51fd3b$export$8dac549e32469ac4}px ${`var(--ds-border-selected, ${$823f29f46e51fd3b$export$cf524c1b49838a49})`}`;
const $823f29f46e51fd3b$export$ecb17e3df162de53 = (0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
const $823f29f46e51fd3b$export$befaaae517e3d864 = 2;
const $823f29f46e51fd3b$export$4a007c22e25e31f6 = 0.3;
const $823f29f46e51fd3b$export$f35cc48f3398ab79 = 1;
const $823f29f46e51fd3b$export$b46cda584c619451 = 2;
const $823f29f46e51fd3b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $823f29f46e51fd3b$export$321ddd2f049dd12 = $823f29f46e51fd3b$export$6bed85de54b5de42 + 1;
const $823f29f46e51fd3b$export$daeac9b8422ac3c2 = 2;
const $823f29f46e51fd3b$export$501d46e11ed5bf73 = (0, $lcnyw.layers).blanket();
const $823f29f46e51fd3b$export$6817b4b6a5ef78f1 = (0, $lcnyw.layers).layer();
const $823f29f46e51fd3b$export$93768eb72dec48ce = $823f29f46e51fd3b$export$501d46e11ed5bf73 + 10;
const $823f29f46e51fd3b$export$c0aec4e0896849a0 = $823f29f46e51fd3b$export$93768eb72dec48ce - 5;
const $823f29f46e51fd3b$export$5886f057e4f21fe4 = $823f29f46e51fd3b$export$6817b4b6a5ef78f1 + 5;
const $823f29f46e51fd3b$export$11965a0dc12e6cd6 = (0, $73a5c9d720aa66e1$export$d6447c357493214f);
const $823f29f46e51fd3b$export$6e85faa46d537a3f = 11;
const $823f29f46e51fd3b$export$36ba77fba4a62d5f = (0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
const $823f29f46e51fd3b$export$a21078fd4649993b = (0, $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
const $823f29f46e51fd3b$export$640eef769748f78f = (0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
const $823f29f46e51fd3b$export$d72825c6f006826c = (0, $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
const $823f29f46e51fd3b$export$154c32a542db7927 = (0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
const $823f29f46e51fd3b$export$58aee55ecb41eac9 = (0, $73a5c9d720aa66e1$export$8c13c2ee36917869);
const $823f29f46e51fd3b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $823f29f46e51fd3b$export$95e9a0285b97474d = '#2C333A';
const $823f29f46e51fd3b$export$b098fbeedf0e901d = (0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
const $823f29f46e51fd3b$export$f7bbcec54ff5bc47 = (0, $73a5c9d720aa66e1$export$e62e8919cca44969);
const $823f29f46e51fd3b$export$7db8b54b38e7e92 = (0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
const $823f29f46e51fd3b$export$bee03689367106ff = (0, $73a5c9d720aa66e1$export$4a7404f376229999);
const $823f29f46e51fd3b$export$f36ab9d2ae35c3cf = (0, $73a5c9d720aa66e1$export$b34b069eff244586);
const $823f29f46e51fd3b$export$76b5e653883e5290 = '3px';
const $823f29f46e51fd3b$export$6d85fe8177a50c0c = 0.5;
const $823f29f46e51fd3b$export$fad19f16d3f953a3 = 680;
const $823f29f46e51fd3b$export$9db045950eedb49f = 760;
const $823f29f46e51fd3b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $823f29f46e51fd3b$export$f580e3d28d0986de = 1800;
const $823f29f46e51fd3b$export$9d5488b5afad62bf = 1792;
const $823f29f46e51fd3b$export$37df10057d36a0e5 = 42;
const $823f29f46e51fd3b$export$437293c5e9fc2703 = 96;
const $823f29f46e51fd3b$export$6e0f4d52efd3d2d = 32;
const $823f29f46e51fd3b$export$f222e0c7a2dc5324 = ()=>(0, $XHGTv.fg)('platform.editor.core.increase-full-page-guttering') ? 52 : 32;
const $823f29f46e51fd3b$export$efe8561bbd3f74d2 = 720;
const $823f29f46e51fd3b$export$e4d39a9e8607c1d3 = 48;
const $823f29f46e51fd3b$export$43946f2400ab6f1f = 128;
const $823f29f46e51fd3b$export$558438ae7fd4b8ce = 12;
const $823f29f46e51fd3b$export$6beb98d32d4ca149 = 4;
const $823f29f46e51fd3b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $823f29f46e51fd3b$export$5edb4f38c3eacb1a = 1024;
const $823f29f46e51fd3b$export$e60820063058ed59 = 1.33;
const $823f29f46e51fd3b$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $823f29f46e51fd3b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $823f29f46e51fd3b$export$fb15fade89f67217 = $823f29f46e51fd3b$export$f35cc48f3398ab79 * 99;
const $823f29f46e51fd3b$export$847030921e9d5a40 = (0, $lcnyw.gridSize)() * 1.5;
const $823f29f46e51fd3b$export$40eb41ab799f0329 = 1.714;
const $823f29f46e51fd3b$export$c36b615598bb9f62 = (0, $73a5c9d720aa66e1$export$3e51e8f1440314ba);
const $823f29f46e51fd3b$export$e271312fc7124aec = '1px';
const $823f29f46e51fd3b$export$d29cb2c31fcbb7c5 = 2;
const $823f29f46e51fd3b$export$688a6dc01e760755 = 320;
const $823f29f46e51fd3b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $823f29f46e51fd3b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $823f29f46e51fd3b$export$1d0d506416d457f1 = '0.75rem';
const $823f29f46e51fd3b$export$e683ef42725d1713 = 680;
const $823f29f46e51fd3b$export$226c784ba04bd04b = 480;
const $823f29f46e51fd3b$export$214ff00e5618d86c = 20;
const $823f29f46e51fd3b$export$c82675fa56f2eefd = '56px';
const $823f29f46e51fd3b$export$d7726a000ae2d7c = ()=>(0, $XHGTv.fg)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? "var(--ds-space-500, 40px)" : '56px';
const $823f29f46e51fd3b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $823f29f46e51fd3b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : (0, $lcnyw.fontSize)();
const $823f29f46e51fd3b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$823f29f46e51fd3b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $823f29f46e51fd3b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $823f29f46e51fd3b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $823f29f46e51fd3b$export$9369fd010fa0ddd6 = 0;
const $823f29f46e51fd3b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $823f29f46e51fd3b$export$312e1e71424c4aa1 = [
    `var(--ds-icon-accent-red, ${(0, $73a5c9d720aa66e1$export$be802dd0d8b57f35)})`,
    `var(--ds-background-accent-red-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    `var(--ds-icon-accent-magenta, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    `var(--ds-background-accent-magenta-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$1cc05bbbf340e559)})`,
    `var(--ds-icon-accent-orange, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
    `var(--ds-background-accent-orange-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$874739ea9e379ab6)})`,
    `var(--ds-icon-accent-green, ${(0, $73a5c9d720aa66e1$export$afbce1382ec95f73)})`,
    `var(--ds-background-accent-green-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`,
    `var(--ds-icon-accent-blue, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    `var(--ds-background-accent-blue-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$776c9c497ef08533)})`,
    `var(--ds-icon-accent-teal, ${(0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b)})`,
    `var(--ds-background-accent-teal-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$6036577f95c3877e)})`,
    `var(--ds-icon-accent-lime, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`,
    `var(--ds-background-accent-lime-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    `var(--ds-icon-accent-purple, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
    `var(--ds-background-accent-purple-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    `var(--ds-icon-accent-gray, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    `var(--ds-background-accent-gray-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`,
    `var(--ds-icon-accent-yellow, ${(0, $73a5c9d720aa66e1$export$6011520a64d9a187)})`,
    `var(--ds-background-accent-yellow-bolder-hovered, ${(0, $73a5c9d720aa66e1$export$b48405b95304b5a1)})`,
    `var(--ds-background-accent-yellow-bolder-pressed, ${(0, $73a5c9d720aa66e1$export$147899de772240ec)})`
];

});

parcelRegister("4iaaT", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $1e71c497b84a179d$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $1e71c497b84a179d$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $1e71c497b84a179d$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $1e71c497b84a179d$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $1e71c497b84a179d$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $8yx6O = parcelRequire("8yx6O");

var $XHGTv = parcelRequire("XHGTv");

var $5qTKr = parcelRequire("5qTKr");

var $1Ptct = parcelRequire("1Ptct");

var $bsXaq = parcelRequire("bsXaq");
function $1e71c497b84a179d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e71c497b84a179d$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $1e71c497b84a179d$var$SCROLLBAR_WIDTH = 30;
function $1e71c497b84a179d$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $1e71c497b84a179d$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $1e71c497b84a179d$export$1eb095b00b926404(width)
    };
}
const $1e71c497b84a179d$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1e71c497b84a179d$export$31a4966bffb9ac98());
const { Provider: $1e71c497b84a179d$var$Provider, Consumer: $1e71c497b84a179d$export$5d8538aa831b6ebb } = $1e71c497b84a179d$export$27e39f636459b9f;
const $1e71c497b84a179d$export$df154c49e93b2ac2 = (0, $5iWql.default)(()=>{
    return (0, $1Ptct.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $1e71c497b84a179d$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const shouldFixTableResizing = Boolean((0, $XHGTv.fg)('platform-fix-table-ssr-resizing'));
    const containerRef = (0, $eUqFw.useRef)(null);
    const existingContextValue = (0, $eUqFw.useContext)($1e71c497b84a179d$export$27e39f636459b9f);
    const [isInitialWidthUpdated, setIsInitialWidthUpdated] = (0, $eUqFw.useState)(false);
    const [width, setWidth] = (0, $eUqFw.useState)($1e71c497b84a179d$export$df154c49e93b2ac2);
    const widthRef = (0, $eUqFw.useRef)(width);
    const isMountedRef = (0, $eUqFw.useRef)(true);
    const providerValue = (0, $eUqFw.useMemo)(()=>$1e71c497b84a179d$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $eUqFw.useMemo)(()=>{
        return (0, $8yx6O.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $1e71c497b84a179d$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        if (shouldFixTableResizing && !isInitialWidthUpdated) {
            // useLayoutEffect is not run in SSR mode
            // The visibility change for SSR is done in packages/editor/renderer/src/ui/Renderer/breakout-ssr.tsx
            setIsInitialWidthUpdated(true);
            if (containerRef.current) setWidth(containerRef.current.offsetWidth);
        }
        return ()=>{
            isMountedRef.current = false;
        };
    }, [
        isInitialWidthUpdated,
        shouldFixTableResizing,
        width
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e71c497b84a179d$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: containerRef,
        // Using style not css prop because we need to also reset these style in SSR
        // It is done in packages/editor/renderer/src/ui/Renderer/breakout-ssr.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Intended
        style: // The hidden visibility is relying on the observer in breakout-ssr.tsx to clear.
        // Do not hide if the observer is not observed. This happens in editor SSR.
        shouldFixTableResizing && !(0, $bsXaq.isSsrButNoBreakoutScriptObserved)() && !isInitialWidthUpdated ? {
            // Width is initialized with body width but in Confluence this is too wide as side nav takes some space.
            // Putting the div into hidden until we can get the correct width.
            // Only setting the visibility so children still takes space which will make scrollbar to correct appear.
            // Scrollbar has width too it needs to be taken into account otherwise table is going to shrink after appeared.
            visibility: 'hidden',
            // Because the body width is too wide, the horizontal scrollbar gonna shown
            // Temporary hide it until we get the correct width
            overflowX: 'hidden'
        } : {}
    }, !skipWidthDetection && /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($1e71c497b84a179d$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1Ptct", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $7a45119a0349feed$export$48d7c418edadb60c);

var $2fFJv = parcelRequire("2fFJv");
function $7a45119a0349feed$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $2fFJv !== 'undefined' && $2fFJv?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});

parcelRegister("bsXaq", function(module, exports) {

$parcel$export(module.exports, "isSsrButNoBreakoutScriptObserved", () => $cf97b86b640c9ed9$export$3de0c41f6df31152);

var $1Ptct = parcelRequire("1Ptct");
function $cf97b86b640c9ed9$export$3de0c41f6df31152() {
    return (0, $1Ptct.isSSR)() && !window.__SSR_BREAKOUT_OBSERVED;
}

});



parcelRegister("6zWLF", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $8da2e051cc84279e$export$7df0749115d18d19);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $8da2e051cc84279e$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $8da2e051cc84279e$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $8da2e051cc84279e$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($8da2e051cc84279e$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("ghZO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $410321c0dde78cdc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");


var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $auyn4 = parcelRequire("auyn4");

var $jlmhn = parcelRequire("jlmhn");

var $2pBoL = parcelRequire("2pBoL");

var $fwrz2 = parcelRequire("fwrz2");
const $410321c0dde78cdc$var$blockNodeStyle = /*#__PURE__*/ (0, $byn9U.css)({
    background: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    border: `1px dashed ${`var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $410321c0dde78cdc$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fwrz2.getUnsupportedContent)((0, $jlmhn.unsupportedContentMessages).unsupportedBlockContent, (0, $jlmhn.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $jlmhn.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $2pBoL.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $410321c0dde78cdc$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    })))));
};
var $410321c0dde78cdc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($410321c0dde78cdc$var$UnsupportedBlockNode);

});
parcelRegister("auyn4", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $4b9f3ea7e6ac7391$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $4b9f3ea7e6ac7391$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $4b9f3ea7e6ac7391$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $4b9f3ea7e6ac7391$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $4b9f3ea7e6ac7391$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7);
var $4b9f3ea7e6ac7391$export$76a2e4c433c23bb9;
(function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
})($4b9f3ea7e6ac7391$export$76a2e4c433c23bb9 || ($4b9f3ea7e6ac7391$export$76a2e4c433c23bb9 = {}));
var $4b9f3ea7e6ac7391$export$9523889e0a5da4ba;
(function(ACTION) {
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENTERED"] = "entered";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["UFO_SESSION_COMPLETE"] = "ufoSessionComplete";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDERN"] = "getChildern";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
})($4b9f3ea7e6ac7391$export$9523889e0a5da4ba || ($4b9f3ea7e6ac7391$export$9523889e0a5da4ba = {}));
var $4b9f3ea7e6ac7391$export$85f107b1fcc9d96f;
(function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
})($4b9f3ea7e6ac7391$export$85f107b1fcc9d96f || ($4b9f3ea7e6ac7391$export$85f107b1fcc9d96f = {}));
var $4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75;
(function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
})($4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75 || ($4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75 = {}));
var $4b9f3ea7e6ac7391$export$7525482b5931e326;
(function(ACTION_SUBJECT) {
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["CONTEXT_MENU"] = "contextMenu";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
})($4b9f3ea7e6ac7391$export$7525482b5931e326 || ($4b9f3ea7e6ac7391$export$7525482b5931e326 = {}));
var $4b9f3ea7e6ac7391$export$9957974f8b4d8f74;
(function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
})($4b9f3ea7e6ac7391$export$9957974f8b4d8f74 || ($4b9f3ea7e6ac7391$export$9957974f8b4d8f74 = {}));
var $4b9f3ea7e6ac7391$export$75ef928acd21e35b;
(function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
})($4b9f3ea7e6ac7391$export$75ef928acd21e35b || ($4b9f3ea7e6ac7391$export$75ef928acd21e35b = {}));
var $4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7;
(function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
})($4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7 || ($4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7 = {}));

});

parcelRegister("jlmhn", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $735f19feda697729$export$32ec96484dd3ba39);

var $90IgZ = parcelRequire("90IgZ");
const $735f19feda697729$export$32ec96484dd3ba39 = (0, $90IgZ.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("2pBoL", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $377308c09ead4e9c$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $377308c09ead4e9c$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $377308c09ead4e9c$export$3a34598135e7219b);

var $auyn4 = parcelRequire("auyn4");
const $377308c09ead4e9c$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $377308c09ead4e9c$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
const $377308c09ead4e9c$var$sanitizeMarks = (marks = [])=>{
    let sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $377308c09ead4e9c$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $377308c09ead4e9c$var$sanitizeAttributes = (attrs = {})=>{
    let sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$377308c09ead4e9c$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $377308c09ead4e9c$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $auyn4.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $377308c09ead4e9c$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$377308c09ead4e9c$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $377308c09ead4e9c$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $377308c09ead4e9c$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $377308c09ead4e9c$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $377308c09ead4e9c$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $377308c09ead4e9c$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $377308c09ead4e9c$var$trackUnsupportedContentTooltipActionFor((0, $auyn4.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("fwrz2", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $db8d6186d2017844$export$d4ded51d0f0bd2df);
function $db8d6186d2017844$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
    let defaultLocale = 'en';
    let canTranslateToLocale = true;
    let locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("a3eWT", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $9c91a1aeaaf3a113$export$9ac3d19711324187);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
const $9c91a1aeaaf3a113$export$9ac3d19711324187 = (0, $2jDha.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("9ndID", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $43f62e787a32cf56$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $43f62e787a32cf56$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $43f62e787a32cf56$export$6f766653554dac02);

var $hSjuP = parcelRequire("hSjuP");
const $43f62e787a32cf56$var$measureMap = new Map();
function $43f62e787a32cf56$export$b62aa2130c86b59b(measureName) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $43f62e787a32cf56$var$measureMap.set(measureName, performance.now());
}
function $43f62e787a32cf56$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $43f62e787a32cf56$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $43f62e787a32cf56$export$6f766653554dac02(measureName);
    }
}
function $43f62e787a32cf56$export$6f766653554dac02(measureName) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    $43f62e787a32cf56$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});
parcelRegister("hSjuP", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $37ae000f1ac45716$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $37ae000f1ac45716$export$48995af1e77d8643);
$parcel$export(module.exports, "isPerformanceObserverLongTaskAvailable", () => $37ae000f1ac45716$export$4370ec0f52022f66);
let $37ae000f1ac45716$var$hasRequiredPerformanceAPIs;
function $37ae000f1ac45716$export$b5717a625dd4a3eb() {
    if ($37ae000f1ac45716$var$hasRequiredPerformanceAPIs === undefined) $37ae000f1ac45716$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $37ae000f1ac45716$var$hasRequiredPerformanceAPIs;
}
function $37ae000f1ac45716$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $37ae000f1ac45716$export$4370ec0f52022f66() {
    return $37ae000f1ac45716$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("cC72g", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $13dbb3ef40d71a8c$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $13dbb3ef40d71a8c$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $13dbb3ef40d71a8c$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "SEVERITY", () => $13dbb3ef40d71a8c$export$6a6bef12562cd865);
$parcel$export(module.exports, "analyticsEventKey", () => $13dbb3ef40d71a8c$export$288273ee3e3b6132);

var $dlE38 = parcelRequire("dlE38");
const $13dbb3ef40d71a8c$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $dlE38.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $13dbb3ef40d71a8c$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$13dbb3ef40d71a8c$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $13dbb3ef40d71a8c$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
var $13dbb3ef40d71a8c$export$6a6bef12562cd865;
(function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
})($13dbb3ef40d71a8c$export$6a6bef12562cd865 || ($13dbb3ef40d71a8c$export$6a6bef12562cd865 = {}));
const $13dbb3ef40d71a8c$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});

parcelRegister("5Fak9", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $8107391f2d138b3f$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $8107391f2d138b3f$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("f8mRM", function(module, exports) {

$parcel$export(module.exports, "measureTTI", () => $3f2a31ea09fc8871$export$dd9846a8ce40fad7);
$parcel$export(module.exports, "getTTISeverity", () => $3f2a31ea09fc8871$export$8a681a045a8e7990);

var $cC72g = parcelRequire("cC72g");

var $hSjuP = parcelRequire("hSjuP");

var $h3qKx = parcelRequire("h3qKx");
function $3f2a31ea09fc8871$export$dd9846a8ce40fad7(onMeasureComplete, idleThreshold = 1000, cancelAfter = 60, // Dependency Injection for easier testing
PerfObserver) {
    if (!(0, $hSjuP.isPerformanceObserverLongTaskAvailable)()) return;
    const start = performance.now();
    // Keeping track of users moving away from the tab, which distorts the TTI measurement
    const distortedDurationMonitor = (0, $h3qKx.getDistortedDurationMonitor)();
    let prevLongTask;
    let lastLongTask = {
        startTime: start,
        duration: 0
    };
    const cancelAfterMs = cancelAfter * 1000;
    const observer = new (PerfObserver || PerformanceObserver)((list)=>{
        const entries = list.getEntries();
        if (entries.length) {
            prevLongTask = lastLongTask;
            lastLongTask = entries[entries.length - 1];
        }
    });
    observer.observe({
        entryTypes: [
            'longtask'
        ]
    });
    const checkIdle = ()=>{
        // 1. There hasn't been any long task in `idleThreshold` time: Interactive from the start.
        // 2. Only 1 long task: Interactive from the end of the only long task.
        // 3. Several long tasks:
        //    3.1 Interactive from the end of prevLongTask if `lastLongTask.start - prevLongTask.end >= idleThreshold`
        //    3.2 Interactive from the end of lastLongTask if `lastLongTask.start - prevLongTask.end < idleThreshold`
        const now = performance.now();
        const lastEnd = lastLongTask.startTime + lastLongTask.duration;
        const prevEnd = prevLongTask ? prevLongTask.startTime + prevLongTask.duration : lastEnd;
        const elapsedTimeMs = now - start;
        const canceled = elapsedTimeMs > cancelAfterMs;
        if (!prevLongTask) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(prevEnd, 0, false, distortedDurationMonitor.distortedDuration);
        } else if (lastLongTask.startTime - prevEnd >= idleThreshold) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(prevEnd, prevEnd - start, canceled, distortedDurationMonitor.distortedDuration);
        } else if (now - lastEnd >= idleThreshold || canceled) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(lastEnd, lastEnd - start, canceled, distortedDurationMonitor.distortedDuration);
        }
        return setTimeout(checkIdle, idleThreshold);
    };
    setTimeout(checkIdle, idleThreshold);
}
const $3f2a31ea09fc8871$export$d0d10f04d3799d8b = {
    NORMAL: 40000,
    DEGRADED: 60000
};
const $3f2a31ea09fc8871$export$f801d5dbbaf41dff = {
    NORMAL: 5000,
    DEGRADED: 8000
};
function $3f2a31ea09fc8871$export$8a681a045a8e7990(tti, ttiFromInvocation, ttiSeverityNormalThreshold, ttiSeverityDegradedThreshold, ttiFromInvocationSeverityNormalThreshold, ttiFromInvocationSeverityDegradedThreshold) {
    const ttiNormalThreshold = ttiSeverityNormalThreshold || $3f2a31ea09fc8871$export$d0d10f04d3799d8b.NORMAL;
    const ttiDegradedThreshold = ttiSeverityDegradedThreshold || $3f2a31ea09fc8871$export$d0d10f04d3799d8b.DEGRADED;
    let ttiSeverity;
    if (tti >= ttiNormalThreshold && tti < ttiDegradedThreshold) ttiSeverity = (0, $cC72g.SEVERITY).DEGRADED;
    else if (tti >= ttiDegradedThreshold) ttiSeverity = (0, $cC72g.SEVERITY).BLOCKING;
    else ttiSeverity = (0, $cC72g.SEVERITY).NORMAL;
    const ttiFromInvocationNormalThreshold = ttiFromInvocationSeverityNormalThreshold || $3f2a31ea09fc8871$export$f801d5dbbaf41dff.NORMAL;
    const ttiFromInvocationDegradedThreshold = ttiFromInvocationSeverityDegradedThreshold || $3f2a31ea09fc8871$export$f801d5dbbaf41dff.DEGRADED;
    let ttiFromInvocationSeverity;
    if (ttiFromInvocation >= ttiFromInvocationNormalThreshold && ttiFromInvocation < ttiFromInvocationDegradedThreshold) ttiFromInvocationSeverity = (0, $cC72g.SEVERITY).DEGRADED;
    else if (ttiFromInvocation >= ttiFromInvocationDegradedThreshold) ttiFromInvocationSeverity = (0, $cC72g.SEVERITY).BLOCKING;
    else ttiFromInvocationSeverity = (0, $cC72g.SEVERITY).NORMAL;
    return {
        ttiSeverity: ttiSeverity,
        ttiFromInvocationSeverity: ttiFromInvocationSeverity
    };
}

});
parcelRegister("h3qKx", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $42313729e4f27ef3$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $42313729e4f27ef3$export$267ed650a5d21ae6);

var $hSjuP = parcelRequire("hSjuP");
const $42313729e4f27ef3$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $42313729e4f27ef3$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    let distortedDurationMonitor = $42313729e4f27ef3$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});


parcelRegister("jMQbs", function(module, exports) {

$parcel$export(module.exports, "browser", () => $ab843e1ceaf4562b$export$3f2684e5d7cb1006);
const $ab843e1ceaf4562b$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.windows = navigator.userAgentData?.platform === 'Windows' || /Windows|Win\d+/i.test(navigator.userAgent);
    let ie = $ab843e1ceaf4562b$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $ab843e1ceaf4562b$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("dHwtf", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $976419fd13134405$export$92d097a1155bbe27);

var $hSjuP = parcelRequire("hSjuP");
function $976419fd13134405$export$92d097a1155bbe27() {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("gL7tA", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $dc7cda4295086a63$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $dc7cda4295086a63$export$6d018dd0f6cbebcb);

var $jh2R9 = parcelRequire("jh2R9");

var $4vTMF = parcelRequire("4vTMF");
const $dc7cda4295086a63$var$EMPTY = {};
function $dc7cda4295086a63$var$isObjectFlagKey(key, value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $dc7cda4295086a63$var$isValidJSONObject(value) {
    try {
        let result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $dc7cda4295086a63$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $dc7cda4295086a63$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($dc7cda4295086a63$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(e[0]), e[1], options?.objectFlagKeys) && $dc7cda4295086a63$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($dc7cda4295086a63$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $dc7cda4295086a63$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("lS7UL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfa93f53d0b6bdd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7dkLM = parcelRequire("7dkLM");

var $1UbnR = parcelRequire("1UbnR");
parcelRequire("jzB8h");
var $iK2Ni = parcelRequire("iK2Ni");
var $jzB8h = parcelRequire("jzB8h");

var $3OTv2 = parcelRequire("3OTv2");

var $jxP5v = parcelRequire("jxP5v");
var $3Rfkt = parcelRequire("3Rfkt");

var $3glLa = parcelRequire("3glLa");

var $9lEAD = parcelRequire("9lEAD");

var $9oaPg = parcelRequire("9oaPg");

var $2zbl1 = parcelRequire("2zbl1");

var $enpaH = parcelRequire("enpaH");

var $bl9MZ = parcelRequire("bl9MZ");

var $4QHKY = parcelRequire("4QHKY");

var $fvSxt = parcelRequire("fvSxt");
function $4cfa93f53d0b6bdd$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $7dkLM.MarkType) && prev && prev.type instanceof (0, $7dkLM.MarkType) && Array.isArray(prev.content) && (0, $3glLa.isSameMark)(prev, markOrNode)) prev.content = $4cfa93f53d0b6bdd$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $4cfa93f53d0b6bdd$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.startPos = 1;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $jzB8h.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $3Rfkt.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (this.isCommentsOnMediaMediaInlineBugFixEnabled && node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $jxP5v.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $jxP5v.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bl9MZ.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.isCommentsOnMediaMediaInlineBugFixEnabled = init.isCommentsOnMediaMediaInlineBugFixEnabled;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = 1;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, props = {}, target = this.allowSelectAllTrap ? (0, $iK2Ni.DocWithSelectAllTrap) : (0, $iK2Ni.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $4cfa93f53d0b6bdd$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $jzB8h.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $4cfa93f53d0b6bdd$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $jzB8h.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $3Rfkt.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3OTv2.default), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $4QHKY.segmentText)(mark.text, this.textHighlighter);
        return (0, $fvSxt.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(NodeComponent, props, key, content) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content);
    }
    renderMark(MarkComponent, props, key, content) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content);
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        // TODO: https://product-fabric.atlassian.net/browse/CEMS-1048
        const stickyHeaders = !(0, $enpaH.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        const isInsideOfBlockNode = (0, $enpaH.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $enpaH.insideMultiBodiedExtension)(path, node.type.schema);
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $9lEAD.calcTableColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $enpaH.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $enpaH.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            },
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $1UbnR.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $1UbnR.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $2zbl1.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        const nodeContent = node.content.toJSON().reduce((acc, node)=>acc.concat((0, $9oaPg.getText)(node) || ''), '').trim().replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $jzB8h.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $3glLa.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $4cfa93f53d0b6bdd$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            }, node);
        }));
    }
    // TODO: ED-9004 Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $4cfa93f53d0b6bdd$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("1UbnR", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $1c58b049207353f4$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $1c58b049207353f4$export$acb253d79d72af92);
function $1c58b049207353f4$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $1c58b049207353f4$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$1c58b049207353f4$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("jzB8h", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $d8a5c9f67b66f0e2$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $d8a5c9f67b66f0e2$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $d8a5c9f67b66f0e2$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $d8a5c9f67b66f0e2$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $d8a5c9f67b66f0e2$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $d8a5c9f67b66f0e2$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("iK2Ni")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("iK2Ni")).DocWithSelectAllTrap);

var $bYKiA = parcelRequire("bYKiA");

var $fuq9M = parcelRequire("fuq9M");

var $1o3JA = parcelRequire("1o3JA");

var $jTkfS = parcelRequire("jTkfS");

var $cQobE = parcelRequire("cQobE");

var $bs79N = parcelRequire("bs79N");

var $iK2Ni = parcelRequire("iK2Ni");

var $h3PoL = parcelRequire("h3PoL");

var $9A6NO = parcelRequire("9A6NO");

var $fGuTt = parcelRequire("fGuTt");

var $6C80U = parcelRequire("6C80U");

var $95JQu = parcelRequire("95JQu");

var $7s3LA = parcelRequire("7s3LA");

var $joPiA = parcelRequire("joPiA");

var $61520 = parcelRequire("61520");

var $8geRS = parcelRequire("8geRS");

var $1PFrh = parcelRequire("1PFrh");

var $lOrB2 = parcelRequire("lOrB2");

var $1OmSI = parcelRequire("1OmSI");

var $5hibD = parcelRequire("5hibD");

var $bIQK1 = parcelRequire("bIQK1");

var $eFI96 = parcelRequire("eFI96");

var $7GWuD = parcelRequire("7GWuD");

var $ghZO5 = parcelRequire("ghZO5");
var $SceRA = parcelRequire("SceRA");

const $d8a5c9f67b66f0e2$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("gpZYi")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("iEWVs")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("i3Opd")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("3g0C9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6Aliz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cYIHp")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("3iByu")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("gUkEv")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("kHiNO")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hvLpG")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6XJJV")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cuAI3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("fHKNN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8LqfX")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("6zJGv")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("i8wC6")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cS1xX")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("1jSHp")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("e1yon")).then((mod)=>mod.default),
    loading: ()=>null
});
const $d8a5c9f67b66f0e2$export$3931063f6a5f290e = {
    blockquote: (0, $fuq9M.default),
    bulletList: (0, $bs79N.default),
    blockCard: $d8a5c9f67b66f0e2$export$d18ccd25c0d2c6b0,
    caption: (0, $61520.default),
    date: $d8a5c9f67b66f0e2$export$6341f9a885713487,
    decisionItem: $d8a5c9f67b66f0e2$export$b6f73a2b0b0de599,
    decisionList: $d8a5c9f67b66f0e2$export$b458dfa720128865,
    doc: (0, $iK2Ni.default),
    emoji: $d8a5c9f67b66f0e2$export$56cc48506ff790a,
    extension: (0, $h3PoL.default),
    bodiedExtension: (0, $1o3JA.default),
    multiBodiedExtension: (0, $jTkfS.default),
    extensionFrame: (0, $cQobE.default),
    hardBreak: (0, $9A6NO.default),
    heading: (0, $fGuTt.default),
    inlineCard: $d8a5c9f67b66f0e2$export$aff6291803939b05,
    inlineExtension: (0, $6C80U.default),
    layoutSection: (0, $95JQu.default),
    layoutColumn: (0, $7s3LA.default),
    listItem: (0, $joPiA.default),
    media: $d8a5c9f67b66f0e2$export$7fc53215244aec38,
    mediaGroup: $d8a5c9f67b66f0e2$export$d7858be3df00d59,
    mediaInline: $d8a5c9f67b66f0e2$export$462ea7c2a1c4cb1f,
    mediaSingle: $d8a5c9f67b66f0e2$export$888d74bc001c3a5d,
    mention: $d8a5c9f67b66f0e2$export$e891316fea657d90,
    orderedList: (0, $8geRS.default),
    panel: $d8a5c9f67b66f0e2$export$2ddb90ad54e5f587,
    paragraph: (0, $1PFrh.default),
    placeholder: (0, $lOrB2.default),
    rule: (0, $1OmSI.default),
    status: $d8a5c9f67b66f0e2$export$96e9906d6d93a972,
    taskItem: $d8a5c9f67b66f0e2$export$27c4189b8be1bf93,
    taskList: $d8a5c9f67b66f0e2$export$771a55a10b0a40ae,
    table: (0, $5hibD.default),
    tableCell: (0, $bIQK1.TableCell),
    tableHeader: (0, $bIQK1.TableHeader),
    tableRow: (0, $eFI96.default),
    unknownBlock: (0, $7GWuD.default),
    unsupportedBlock: (0, $ghZO5.default),
    unsupportedInline: (0, $SceRA.default),
    expand: $d8a5c9f67b66f0e2$export$49bd1dfb0ad29c40,
    nestedExpand: $d8a5c9f67b66f0e2$export$49bd1dfb0ad29c40,
    embedCard: $d8a5c9f67b66f0e2$export$6789d7ecdc77631b
};
const $d8a5c9f67b66f0e2$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $iK2Ni.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $d8a5c9f67b66f0e2$export$a22ee8f907eecb5f;
        return $d8a5c9f67b66f0e2$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$d8a5c9f67b66f0e2$export$3931063f6a5f290e,
        ...nodeComponents
    };
    return nodes[node.type.name];
};
const $d8a5c9f67b66f0e2$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$d8a5c9f67b66f0e2$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $d8a5c9f67b66f0e2$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $d8a5c9f67b66f0e2$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $d8a5c9f67b66f0e2$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $d8a5c9f67b66f0e2$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
const $d8a5c9f67b66f0e2$var$whitespaceRegex = /^\s*$/;
const $d8a5c9f67b66f0e2$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $d8a5c9f67b66f0e2$var$isEmojiBlock(node.content);
};
const $d8a5c9f67b66f0e2$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($d8a5c9f67b66f0e2$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("fuq9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d75114e7b1d263$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $01d75114e7b1d263$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("blockquote", null, props.children);
}

});

parcelRegister("1o3JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2910cc5d13eaf73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $h3PoL = parcelRequire("h3PoL");

var $ks9LI = parcelRequire("ks9LI");

var $8zo8Y = parcelRequire("8zo8Y");

var $fvyhV = parcelRequire("fvyhV");

var $auyn4 = parcelRequire("auyn4");
const $d2910cc5d13eaf73$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ks9LI.ErrorBoundary), {
        component: (0, $fvyhV.ACTION_SUBJECT).RENDERER,
        componentId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zo8Y.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $h3PoL.renderExtension)(result, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $h3PoL.renderExtension)(children, layout, {
            isTopLevel: path.length < 1
        }, removeOverflow);
    }));
};
var $d2910cc5d13eaf73$export$2e2bcd8739ae039 = $d2910cc5d13eaf73$var$BodiedExtension;

});
parcelRegister("h3PoL", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $32bbfd07e0365c73$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $32bbfd07e0365c73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8zo8Y = parcelRequire("8zo8Y");

var $8AkRK = parcelRequire("8AkRK");
var $4iaaT = parcelRequire("4iaaT");

var $b3jMP = parcelRequire("b3jMP");

var $ghgHw = parcelRequire("ghgHw");
const $32bbfd07e0365c73$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow)=>{
    const overflowContainerClass = !removeOverflow ? (0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $ghgHw.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $ghgHw.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $b3jMP.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: overflowContainerClass
        }, content)));
};
const $32bbfd07e0365c73$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zo8Y.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) return $32bbfd07e0365c73$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $32bbfd07e0365c73$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames
        });
    });
};
var $32bbfd07e0365c73$export$2e2bcd8739ae039 = (0, $8AkRK.default)($32bbfd07e0365c73$var$Extension, {
    overflowSelector: `.${(0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("8zo8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8811e89bd6bf57c4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $ktPAA = parcelRequire("ktPAA");

var $hhK9E = parcelRequire("hhK9E");

var $bBq1a = parcelRequire("bBq1a");

var $XHGTv = parcelRequire("XHGTv");
const $8811e89bd6bf57c4$var$inlineExtensionStyle = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $8811e89bd6bf57c4$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>(0, $5iWql.default)((0, $ktPAA.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(null);
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $bBq1a.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $byn9U.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $byn9U.jsx)($8811e89bd6bf57c4$var$InlineNodeRendererWrapper, null, /*#__PURE__*/ (0, $byn9U.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $byn9U.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hhK9E.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $8811e89bd6bf57c4$var$InlineNodeRendererWrapper = ({ children: children })=>{
    if ((0, $XHGTv.fg)('platform.editor.inline_extension.extended_lcqdn')) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: "inline-extension-renderer",
        css: $8811e89bd6bf57c4$var$inlineExtensionStyle
    }, children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
};

});
parcelRegister("ktPAA", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $16c6d066806429c4$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $16c6d066806429c4$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $16c6d066806429c4$export$67a7d49db68d30a0);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $axIAz = parcelRequire("axIAz");
async function $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $axIAz.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $16c6d066806429c4$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $16c6d066806429c4$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "Error loading the extension!");
    } else return null;
}
function $16c6d066806429c4$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>{
            return $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $axIAz.resolveImport)(node.render()));
        },
        loading: $16c6d066806429c4$var$ExtensionLoading
    });
}

});
parcelRegister("axIAz", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $00855aad3e674979$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $00855aad3e674979$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $00855aad3e674979$export$d69c9b451c47653b);
const $00855aad3e674979$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $00855aad3e674979$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $00855aad3e674979$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $00855aad3e674979$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $00855aad3e674979$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $00855aad3e674979$export$33863d887d6f4bfd(action, manifest);
}
const $00855aad3e674979$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $00855aad3e674979$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $00855aad3e674979$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("hhK9E", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $e051dcc9b530fea9$export$d498ee8be33e096f);

var $eUqFw = parcelRequire("eUqFw");
class $e051dcc9b530fea9$export$d498ee8be33e096f extends (0, $eUqFw.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props);
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        const providers = {};
        this.props.providers.forEach((name)=>{
            providers[name] = undefined;
        });
        this.state = {
            providers: providers
        };
    }
    UNSAFE_componentWillMount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.subscribe(name, this.handleProvider);
        });
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("bBq1a", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $a67b7acccaabba61$export$9214452ef07eda7);
function $a67b7acccaabba61$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("8AkRK", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $4d8b4ecfb3103f1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1JeZT = parcelRequire("1JeZT");
const $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $4d8b4ecfb3103f1d$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $1JeZT.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            let classNames = [
                showRightShadow && $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $1JeZT.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.overflowContainerWidth = 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("1JeZT", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $6890a1642153a0c2$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $6890a1642153a0c2$export$51a5b28e4fb2dba2);
var $6890a1642153a0c2$export$ebeea2fe2e93862e;
(function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
})($6890a1642153a0c2$export$ebeea2fe2e93862e || ($6890a1642153a0c2$export$ebeea2fe2e93862e = {}));
const $6890a1642153a0c2$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $6890a1642153a0c2$var$requestIdleCallback = (fn)=>{
    return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $6890a1642153a0c2$var$cancelIdleCallback = (id)=>{
    return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $6890a1642153a0c2$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $6890a1642153a0c2$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $6890a1642153a0c2$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("b3jMP", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $c900a46a85c71891$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $c900a46a85c71891$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $c900a46a85c71891$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $c900a46a85c71891$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $c900a46a85c71891$export$c377853ecdd53e5b);
$parcel$export(module.exports, "calcBreakoutWidthPx", () => $c900a46a85c71891$export$586300c53bd298dd);
$parcel$export(module.exports, "getNextBreakoutMode", () => $c900a46a85c71891$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $c900a46a85c71891$export$70d1bf7729efff40);

var $25FYC = parcelRequire("25FYC");

var $kUnNQ = parcelRequire("kUnNQ");

var $8lJ1v = parcelRequire("8lJ1v");

var $4iaaT = parcelRequire("4iaaT");

var $7Dnt4 = parcelRequire("7Dnt4");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ const $c900a46a85c71891$export$ead1fecec2ecf57c = {
    padding: (0, $25FYC.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $25FYC.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $25FYC.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $25FYC.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $25FYC.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $8lJ1v.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4iaaT.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $c900a46a85c71891$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $c900a46a85c71891$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                let wideWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $c900a46a85c71891$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcLineLength: ()=>$c900a46a85c71891$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $c900a46a85c71891$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($c900a46a85c71891$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $c900a46a85c71891$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $c900a46a85c71891$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $25FYC.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return $c900a46a85c71891$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($c900a46a85c71891$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $c900a46a85c71891$export$86325001fe8f3adc = $c900a46a85c71891$export$ead1fecec2ecf57c.calcWideWidth;
const $c900a46a85c71891$export$5f4502874a28dfce = $c900a46a85c71891$export$ead1fecec2ecf57c.calcBreakoutWidth;
function $c900a46a85c71891$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $c900a46a85c71891$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $7Dnt4.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $c900a46a85c71891$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $7Dnt4.parsePx)($c900a46a85c71891$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $c900a46a85c71891$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $c900a46a85c71891$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $kUnNQ.default).layoutFixedWidth;
        case 'wide':
            return (0, $kUnNQ.default).layoutFullWidth;
        default:
            return (0, $kUnNQ.default).layoutWide;
    }
};

});
parcelRegister("kUnNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e994a2b8e47584$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $crP7H = parcelRequire("crP7H");

var $i044r = parcelRequire("i044r");

var $iEvyL = parcelRequire("iEvyL");

var $hl0Ug = parcelRequire("hl0Ug");

var $5UbPZ = parcelRequire("5UbPZ");

var $caBpJ = parcelRequire("caBpJ");


var $3nLvm = parcelRequire("3nLvm");

var $cBbZY = parcelRequire("cBbZY");

var $f0Ytd = parcelRequire("f0Ytd");

var $dgXkb = parcelRequire("dgXkb");

var $gxhGk = parcelRequire("gxhGk");

var $3nLS5 = parcelRequire("3nLS5");

var $aWXsE = parcelRequire("aWXsE");

var $kRwaf = parcelRequire("kRwaf");

var $jlXTA = parcelRequire("jlXTA");

var $cV3Z1 = parcelRequire("cV3Z1");

var $gzJN4 = parcelRequire("gzJN4");

var $gRnnR = parcelRequire("gRnnR");

var $cHLhY = parcelRequire("cHLhY");

var $eQYNZ = parcelRequire("eQYNZ");

var $huXFb = parcelRequire("huXFb");

var $5Jyfy = parcelRequire("5Jyfy");

var $esoLD = parcelRequire("esoLD");

var $15J3I = parcelRequire("15J3I");

var $9dZ3f = parcelRequire("9dZ3f");

var $6qPs9 = parcelRequire("6qPs9");

var $41ppt = parcelRequire("41ppt");

var $lNoB6 = parcelRequire("lNoB6");



var $cogKV = parcelRequire("cogKV");
var $25e994a2b8e47584$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    }
});

});
parcelRegister("crP7H", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $f5e476b2ff5d3a17$export$5229ffea355cfdf6);

var $90IgZ = parcelRequire("90IgZ");
const $f5e476b2ff5d3a17$export$5229ffea355cfdf6 = (0, $90IgZ.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("i044r", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $be74b511631b010a$export$ff612ca71703201d);

var $90IgZ = parcelRequire("90IgZ");
const $be74b511631b010a$export$ff612ca71703201d = (0, $90IgZ.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("iEvyL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2944a169bba41b5f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2944a169bba41b5f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("hl0Ug", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $2d2f04d0b297ab75$export$42bb270d1224182);

var $90IgZ = parcelRequire("90IgZ");
const $2d2f04d0b297ab75$export$42bb270d1224182 = (0, $90IgZ.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("5UbPZ", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $53edd04fede58907$export$4ce3884394d6d9);

var $90IgZ = parcelRequire("90IgZ");
const $53edd04fede58907$export$4ce3884394d6d9 = (0, $90IgZ.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("caBpJ", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $3e150f112ec60beb$export$2d7676d841c8ae9);

var $90IgZ = parcelRequire("90IgZ");
const $3e150f112ec60beb$export$2d7676d841c8ae9 = (0, $90IgZ.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("3nLvm", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $746db467dddb4c16$export$74e304339778e94d);

var $90IgZ = parcelRequire("90IgZ");
const $746db467dddb4c16$export$74e304339778e94d = (0, $90IgZ.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("cBbZY", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $9e3b17467a1722f8$export$70c8a7203d95247);

var $90IgZ = parcelRequire("90IgZ");
const $9e3b17467a1722f8$export$70c8a7203d95247 = (0, $90IgZ.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    insertMediaFromUrl: {
        id: 'fabric.editor.insertMediaFromUrl',
        defaultMessage: 'Image from link',
        description: 'Upload image from URL'
    },
    insertMediaFromUrlDescription: {
        id: 'fabric.editor.insertMediaFromUrlDescription',
        defaultMessage: 'Add an image or video from a link',
        description: 'Upload a image to your page from external URL'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("f0Ytd", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $90786a7d58942cd8$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $90786a7d58942cd8$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("dgXkb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $487e431f21163a94$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $487e431f21163a94$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    }
});

});

parcelRegister("gxhGk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34ce1140d22932eb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $34ce1140d22932eb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("3nLS5", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $4ddae2f112066626$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $4ddae2f112066626$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("aWXsE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8d88a2512df54a18$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8d88a2512df54a18$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kRwaf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ecd38f7fae129df$export$defe85febe8b728c);
// Common Translations will live here

var $90IgZ = parcelRequire("90IgZ");
const $3ecd38f7fae129df$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("jlXTA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b45c2149401d6a9b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b45c2149401d6a9b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("cV3Z1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c7d625ff9c848147$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c7d625ff9c848147$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    }
});

});

parcelRegister("gzJN4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $83ce02220bb0efb9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $83ce02220bb0efb9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    }
});

});

parcelRegister("gRnnR", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $25542adb992d74a9$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $25542adb992d74a9$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    }
});

});

parcelRegister("cHLhY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e3da37fbdace53a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6e3da37fbdace53a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("eQYNZ", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $9043d79e240ee2bc$export$8a0e7c3f8f5b8868);

var $90IgZ = parcelRequire("90IgZ");
const $9043d79e240ee2bc$export$8a0e7c3f8f5b8868 = (0, $90IgZ.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("huXFb", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $3c5fdd44b2d3ce90$export$b46a930e1a386b2e);

var $90IgZ = parcelRequire("90IgZ");
const $3c5fdd44b2d3ce90$export$b46a930e1a386b2e = (0, $90IgZ.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("5Jyfy", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $659712c134e63f96$export$effb4ee8b6f74abe);

var $90IgZ = parcelRequire("90IgZ");
const $659712c134e63f96$export$effb4ee8b6f74abe = (0, $90IgZ.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("esoLD", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $f7043a77b8e9aaee$export$273d864e9e6d0b1f);

var $90IgZ = parcelRequire("90IgZ");
const $f7043a77b8e9aaee$export$273d864e9e6d0b1f = (0, $90IgZ.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    }
});

});

parcelRegister("15J3I", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $06a5c9e158322ba9$export$ee8ab8a034b5a8bd);

var $90IgZ = parcelRequire("90IgZ");
const $06a5c9e158322ba9$export$ee8ab8a034b5a8bd = (0, $90IgZ.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    }
});

});

parcelRegister("9dZ3f", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $29826be79024dd4b$export$703e803e9cb0cea4);

var $90IgZ = parcelRequire("90IgZ");
const $29826be79024dd4b$export$703e803e9cb0cea4 = (0, $90IgZ.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("6qPs9", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $a6f005da1ccf8afc$export$7bb18eb6f9170174);

var $90IgZ = parcelRequire("90IgZ");
const $a6f005da1ccf8afc$export$7bb18eb6f9170174 = (0, $90IgZ.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("41ppt", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a6f080a3a1fae2ec$export$33aafd5ccbbbd00a);

var $90IgZ = parcelRequire("90IgZ");
const $a6f080a3a1fae2ec$export$33aafd5ccbbbd00a = (0, $90IgZ.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    }
});

});

parcelRegister("lNoB6", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $01ed8aa9766665d3$export$83c85447c71428ba);

var $90IgZ = parcelRequire("90IgZ");
const $01ed8aa9766665d3$export$83c85447c71428ba = (0, $90IgZ.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("cogKV", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $fc7a8cc7a9419240$export$7eb9dc59242bbc45);

var $90IgZ = parcelRequire("90IgZ");
const $fc7a8cc7a9419240$export$7eb9dc59242bbc45 = (0, $90IgZ.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    }
});

});


parcelRegister("7Dnt4", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $27814a391fc641fb$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $27814a391fc641fb$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $27814a391fc641fb$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $27814a391fc641fb$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $27814a391fc641fb$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $27814a391fc641fb$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $27814a391fc641fb$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $27814a391fc641fb$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $27814a391fc641fb$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $27814a391fc641fb$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $27814a391fc641fb$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $27814a391fc641fb$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $27814a391fc641fb$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $27814a391fc641fb$export$d508bcfb7f019487(node, s) {
    return $27814a391fc641fb$export$ff7f7c97cdce86e(node, s);
}
function $27814a391fc641fb$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $27814a391fc641fb$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $27814a391fc641fb$export$5b6ab01a6efa50e2(elem, callback) {
    return $27814a391fc641fb$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("ghgHw", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $b6700cb9221d79ab$export$91f3bbbf974496e2);
const $b6700cb9221d79ab$var$clPrefix = 'ak-renderer-';
const $b6700cb9221d79ab$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$b6700cb9221d79ab$var$clPrefix}document`,
    EXTENSION: `${$b6700cb9221d79ab$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$b6700cb9221d79ab$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$b6700cb9221d79ab$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$b6700cb9221d79ab$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("ks9LI", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $52e78d2fac659478$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $88sYM = parcelRequire("88sYM");

var $2g9ms = parcelRequire("2g9ms");

var $3rMck = parcelRequire("3rMck");

var $hompL = parcelRequire("hompL");
class $52e78d2fac659478$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $88sYM.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $auyn4.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $2g9ms.logException)(error, {
            location: 'renderer'
        });
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()
        }, this.props.children);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("2g9ms", function(module, exports) {

$parcel$export(module.exports, "logException", () => $af535f581045d8fb$export$f86b2a1a2ce291b3);

var $kwAba = parcelRequire("kwAba");
const $af535f581045d8fb$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $af535f581045d8fb$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $af535f581045d8fb$var$packageVersion = "0.0.0-use.local";
const $af535f581045d8fb$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $af535f581045d8fb$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("iz5SI"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("dV8Qb"));
        const sentryOptions = {
            dsn: (0, $kwAba.isFedRamp)() ? undefined : $af535f581045d8fb$var$SENTRY_DSN,
            release: `${$af535f581045d8fb$var$packageName}@${$af535f581045d8fb$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                /^network error/i,
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $af535f581045d8fb$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                'jira-bundler': window.BUNDLER_VERSION,
                'jira-variant': window.BUILD_VARIANT,
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("kwAba", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $572aee3f817486b3$export$64d6499adf9b2e51);
const $572aee3f817486b3$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $572aee3f817486b3$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $572aee3f817486b3$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("iz5SI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gEreB").then(()=>parcelRequire('kdu1i'));

});

parcelRegister("dV8Qb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hsecs").then(()=>parcelRequire('iVxd1'));

});


parcelRegister("3rMck", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $4ad63cbfa87b30ac$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $4ad63cbfa87b30ac$export$e48589d9e4824227);
var $4ad63cbfa87b30ac$export$88c4881e092abcaf;
(function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
})($4ad63cbfa87b30ac$export$88c4881e092abcaf || ($4ad63cbfa87b30ac$export$88c4881e092abcaf = {}));
var $4ad63cbfa87b30ac$export$e48589d9e4824227;
(function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
})($4ad63cbfa87b30ac$export$e48589d9e4824227 || ($4ad63cbfa87b30ac$export$e48589d9e4824227 = {}));
var $4ad63cbfa87b30ac$var$RESOLVE_METHOD;
(function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
})($4ad63cbfa87b30ac$var$RESOLVE_METHOD || ($4ad63cbfa87b30ac$var$RESOLVE_METHOD = {}));

});


parcelRegister("fvyhV", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $832dd5cdd187eb37$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $832dd5cdd187eb37$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $832dd5cdd187eb37$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $832dd5cdd187eb37$export$9957974f8b4d8f74);
var $832dd5cdd187eb37$export$76a2e4c433c23bb9;
(function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
})($832dd5cdd187eb37$export$76a2e4c433c23bb9 || ($832dd5cdd187eb37$export$76a2e4c433c23bb9 = {}));
var $832dd5cdd187eb37$export$9523889e0a5da4ba;
(function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
})($832dd5cdd187eb37$export$9523889e0a5da4ba || ($832dd5cdd187eb37$export$9523889e0a5da4ba = {}));
var $832dd5cdd187eb37$export$7525482b5931e326;
(function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
})($832dd5cdd187eb37$export$7525482b5931e326 || ($832dd5cdd187eb37$export$7525482b5931e326 = {}));
var $832dd5cdd187eb37$export$9957974f8b4d8f74;
(function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
})($832dd5cdd187eb37$export$9957974f8b4d8f74 || ($832dd5cdd187eb37$export$9957974f8b4d8f74 = {}));

});


parcelRegister("jTkfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd803a06446500b8$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $eUqFw = parcelRequire("eUqFw");

var $h3PoL = parcelRequire("h3PoL");

var $8zo8Y = parcelRequire("8zo8Y");

var $ihOvF = parcelRequire("ihOvF");
var $4iaaT = parcelRequire("4iaaT");

var $ghgHw = parcelRequire("ghgHw");

var $b3jMP = parcelRequire("b3jMP");
const $bd803a06446500b8$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            getChildren () {
                return [];
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $bd803a06446500b8$var$navigationCssExtended = /*#__PURE__*/ (0, $byn9U.css)((0, $ihOvF.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $bd803a06446500b8$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eUqFw.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $bd803a06446500b8$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $byn9U.css)((0, $ihOvF.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $ihOvF.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $ghgHw.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $ghgHw.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $b3jMP.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $bd803a06446500b8$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8zo8Y.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $h3PoL.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $h3PoL.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $byn9U.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $bd803a06446500b8$export$2e2bcd8739ae039 = $bd803a06446500b8$var$MultiBodiedExtension;

});
parcelRegister("ihOvF", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $d53af947505f28f8$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $d53af947505f28f8$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $d53af947505f28f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $d53af947505f28f8$var$mbeExtensionContainer = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none',
        background: "var(--ds-surface, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $d53af947505f28f8$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $d53af947505f28f8$var$extensionFrameContent = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: "var(--ds-surface, white)",
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $d53af947505f28f8$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $d53af947505f28f8$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $d53af947505f28f8$var$mbeExtensionContainer,
    mbeNavigation: $d53af947505f28f8$var$mbeNavigation,
    extensionFrameContent: $d53af947505f28f8$var$extensionFrameContent
};

});


parcelRegister("cQobE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdec7fc741b72949$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $fdec7fc741b72949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fdec7fc741b72949$var$containerCSS = {
    name: "ecvjkq",
    styles: "min-height:100px"
};
const $fdec7fc741b72949$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fdec7fc741b72949$var$containerCSS,
        "data-extension-frame": "true",
        style: {
            flexBasis: `100%`
        }
    }, props.children);
};
var $fdec7fc741b72949$export$2e2bcd8739ae039 = $fdec7fc741b72949$var$ExtensionFrame;

});

parcelRegister("bs79N", function(module, exports) {

$parcel$export(module.exports, "default", () => $887b035eeb07eb03$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $568Ob = parcelRequire("568Ob");

var $7iIIt = parcelRequire("7iIIt");
function $887b035eeb07eb03$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $568Ob.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $7iIIt.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("7iIIt", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $9a57d99548bd54c6$export$75aa84e85754623e);
function $9a57d99548bd54c6$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("iK2Ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f597e6cf1e24bd5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $2f597e6cf1e24bd5$export$41121a410ca2f650);

var $eUqFw = parcelRequire("eUqFw");

var $ghgHw = parcelRequire("ghgHw");

var $6Afu1 = parcelRequire("6Afu1");
function $2f597e6cf1e24bd5$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $ghgHw.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $2f597e6cf1e24bd5$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (0, $6Afu1.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ghgHw.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("6Afu1", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $3bc68038c3a101f2$export$98871b245ee25215);

var $auyn4 = parcelRequire("auyn4");

var $eUqFw = parcelRequire("eUqFw");

var $86Pbu = parcelRequire("86Pbu");

var $8ul1p = parcelRequire("8ul1p");
const $3bc68038c3a101f2$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $86Pbu.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $8ul1p.ElementSelection).fromWindow();
        if (elementSelection.eq(caught.current)) {
            fireAnalyticsEvent({
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                action: (0, $auyn4.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                action: (0, $auyn4.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('click', onClick);
        return ()=>{
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("86Pbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7259abaa905a9ea2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $7259abaa905a9ea2$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $7259abaa905a9ea2$export$2e2bcd8739ae039 = $7259abaa905a9ea2$var$AnalyticsContext;

});

parcelRegister("8ul1p", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $2419f1fe60d6618f$export$6e6724d89f27411);
class $2419f1fe60d6618f$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $2419f1fe60d6618f$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $2419f1fe60d6618f$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("9A6NO", function(module, exports) {

$parcel$export(module.exports, "default", () => $385c81737007be05$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $385c81737007be05$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null);
};
var $385c81737007be05$export$2e2bcd8739ae039 = $385c81737007be05$var$HardBreak;

});

parcelRegister("fGuTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $083d6a919e4a5a31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dMrTV = parcelRequire("dMrTV");

var $auyn4 = parcelRequire("auyn4");

var $86Pbu = parcelRequire("86Pbu");

var $fBE31 = parcelRequire("fBE31");
const $083d6a919e4a5a31$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $083d6a919e4a5a31$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $083d6a919e4a5a31$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86Pbu.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dMrTV.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLICKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
                return (0, $fBE31.copyTextToClipboard)($083d6a919e4a5a31$var$getCurrentUrlWithHash(headingId));
            }
        }));
}
function $083d6a919e4a5a31$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $083d6a919e4a5a31$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HX, {
        id: headingIdToUse,
        ...dataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($083d6a919e4a5a31$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($083d6a919e4a5a31$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
var $083d6a919e4a5a31$export$2e2bcd8739ae039 = $083d6a919e4a5a31$var$Heading;

});
parcelRegister("dMrTV", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $2e231eb3e398a79e$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $2e231eb3e398a79e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $hUwRB = parcelRequire("hUwRB");

var $8cU5f = parcelRequire("8cU5f");

var $2qhQi = parcelRequire("2qhQi");

var $drghF = parcelRequire("drghF");
const $2e231eb3e398a79e$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $2e231eb3e398a79e$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...rest,
        className: $2e231eb3e398a79e$export$3c9cedc52604835d,
        ref: ref
    }, children));
});
const $2e231eb3e398a79e$var$copyAnchorButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    cursor: 'pointer',
    right: 0
});
class $2e231eb3e398a79e$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $2e231eb3e398a79e$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args);
        this.state = {
            tooltipMessage: '',
            isClicked: false
        };
        this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        };
        this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $drghF.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        };
        this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $drghF.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        };
        this.resetMessage = ()=>{
            this.setTooltipState((0, $drghF.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        };
        this.renderAnchorButton = ()=>{
            return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
                css: $2e231eb3e398a79e$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-label": this.state.tooltipMessage,
                type: "button"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
                label: this.getCopyAriaLabel(),
                size: this.props.level > 3 ? 'small' : 'medium',
                primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }));
        };
    }
}
var $2e231eb3e398a79e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2e231eb3e398a79e$var$HeadingAnchor);

});
parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7939ee5038402c5f027adffad929d2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});


parcelRegister("drghF", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $463d81896c1da8e9$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $463d81896c1da8e9$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $463d81896c1da8e9$export$9f52c375a6ef34fc);

var $90IgZ = parcelRequire("90IgZ");
const $463d81896c1da8e9$export$74bada844422036d = (0, $90IgZ.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $463d81896c1da8e9$export$c79ebc36348824d1 = (0, $90IgZ.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $463d81896c1da8e9$export$9f52c375a6ef34fc = (0, $90IgZ.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});


parcelRegister("fBE31", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2b1d2dec2d1f6a3a$export$f980440e1ab4537d);
const $2b1d2dec2d1f6a3a$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});


parcelRegister("6C80U", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a58832896c0175$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8zo8Y = parcelRequire("8zo8Y");
const $e8a58832896c0175$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zo8Y.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text || 'inlineExtension');
    });
};
var $e8a58832896c0175$export$2e2bcd8739ae039 = $e8a58832896c0175$var$InlineExtension;

});

parcelRegister("95JQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $644e1ab6adc9f0f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $644e1ab6adc9f0f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-section": true
    }, props.children);
}

});

parcelRegister("7s3LA", function(module, exports) {

$parcel$export(module.exports, "default", () => $43b3ec491f0f3458$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $a2RTs = parcelRequire("a2RTs");
var $4iaaT = parcelRequire("4iaaT");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $43b3ec491f0f3458$var$layoutColumnClearMarginTopStyles = /*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $a2RTs.clearNextSiblingMarginTopStyle), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $a2RTs.clearNextSiblingBlockMarkMarginTopStyle));
function $43b3ec491f0f3458$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $43b3ec491f0f3458$var$layoutColumnClearMarginTopStyles
    }), props.children));
}

});
parcelRegister("a2RTs", function(module, exports) {

$parcel$export(module.exports, "clearNextSiblingMarginTopStyle", () => $af2a19a8f75d9d7b$export$b15ec88fc1f2e843);
$parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", () => $af2a19a8f75d9d7b$export$eb3aaa9338936d44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $af2a19a8f75d9d7b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af2a19a8f75d9d7b$export$b15ec88fc1f2e843 = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $af2a19a8f75d9d7b$var$textElements = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const $af2a19a8f75d9d7b$var$nextSiblingBlockMarkContentSelectors = $af2a19a8f75d9d7b$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
const $af2a19a8f75d9d7b$export$eb3aaa9338936d44 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$af2a19a8f75d9d7b$var$nextSiblingBlockMarkContentSelectors}`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});

});


parcelRegister("joPiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $37248d0763ca9dd6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $37248d0763ca9dd6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, props.children);
}

});

parcelRegister("61520", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0089215b260366e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4hB9U = parcelRequire("4hB9U");
const $d0089215b260366e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hB9U.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $d0089215b260366e$export$2e2bcd8739ae039 = $d0089215b260366e$var$RenderCaption;

});
parcelRegister("4hB9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f558a09344abdcc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");


var $iq4r1 = parcelRequire("iq4r1");
const $0f558a09344abdcc$var$captionWrapperStyle = /*#__PURE__*/ (0, $byn9U.css)({
    marginTop: "var(--ds-space-100, 8px)",
    textAlign: 'center',
    position: 'relative',
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`
});
const $0f558a09344abdcc$var$placeholderStyle = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    position: 'absolute',
    top: 0,
    width: '100%'
});
class $0f558a09344abdcc$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $0f558a09344abdcc$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $byn9U.jsx)("p", {
            css: $0f558a09344abdcc$var$placeholderStyle
        }, formatMessage((0, $iq4r1.messages).placeholder)) : null, children);
    }
}
var $0f558a09344abdcc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0f558a09344abdcc$export$f7feb87190a94c76);

});
parcelRegister("iq4r1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $603bd4cc93c12c49$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $603bd4cc93c12c49$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("8geRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $78523893e2031013$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8lnnz = parcelRequire("8lnnz");

var $juoPd = parcelRequire("juoPd");

var $fS4LS = parcelRequire("fS4LS");

var $7iIIt = parcelRequire("7iIIt");
function $78523893e2031013$export$2e2bcd8739ae039(props) {
    let extraProps = {};
    const itemCounterDigitsSize = (0, $fS4LS.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $juoPd.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $fS4LS.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8lnnz.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $7iIIt.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});
parcelRegister("juoPd", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $d49e7b19d8143680$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $d49e7b19d8143680$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $d49e7b19d8143680$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $568Ob = parcelRequire("568Ob");
var $8lnnz = parcelRequire("8lnnz");

var $jMQbs = parcelRequire("jMQbs");
const $d49e7b19d8143680$export$bafd6beec0797f87 = 24;
var $d49e7b19d8143680$var$CSS_VAR_NAMES;
(function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
})($d49e7b19d8143680$var$CSS_VAR_NAMES || ($d49e7b19d8143680$var$CSS_VAR_NAMES = {}));
const $d49e7b19d8143680$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $d49e7b19d8143680$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $d49e7b19d8143680$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $d49e7b19d8143680$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $d49e7b19d8143680$var$stringifyStyle(style);
    return style;
}
const $d49e7b19d8143680$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $byn9U.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $d49e7b19d8143680$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $jMQbs.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $8lnnz.orderedListSelector), ",", (0, $568Ob.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("fS4LS", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $8f03f23b1eeeea4e$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $8f03f23b1eeeea4e$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $8f03f23b1eeeea4e$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $8f03f23b1eeeea4e$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $8f03f23b1eeeea4e$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $8f03f23b1eeeea4e$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $8f03f23b1eeeea4e$export$35b2f400604e700);
$parcel$export(module.exports, "isOrderedList", () => $8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8);
$parcel$export(module.exports, "isOrderedListContinuous", () => $8f03f23b1eeeea4e$export$a265e5f4220d0409);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $8f03f23b1eeeea4e$export$8ef94ae42a3729bd = 1;
const $8f03f23b1eeeea4e$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $8f03f23b1eeeea4e$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $8f03f23b1eeeea4e$export$d445360e2a3c026b(order) ?? $8f03f23b1eeeea4e$export$8ef94ae42a3729bd;
};
const $8f03f23b1eeeea4e$export$320582fc14ba1e0f = (options)=>{
    const order = $8f03f23b1eeeea4e$export$d445360e2a3c026b(options.order) ?? $8f03f23b1eeeea4e$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $8f03f23b1eeeea4e$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $8f03f23b1eeeea4e$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $8f03f23b1eeeea4e$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $8f03f23b1eeeea4e$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}
function $8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8(node) {
    return Boolean(node && node.type && 'orderedList' === node.type.name);
}
const $8f03f23b1eeeea4e$export$a265e5f4220d0409 = (firstOrderedList, secondOrderedList)=>{
    if (!($8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8(firstOrderedList) && $8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8(secondOrderedList))) return false;
    return $8f03f23b1eeeea4e$export$cbefb5b89ef0719f(firstOrderedList) + firstOrderedList.childCount === $8f03f23b1eeeea4e$export$cbefb5b89ef0719f(secondOrderedList);
};

});


parcelRegister("1PFrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ba1ef480aabd69$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kCf67 = parcelRequire("kCf67");
function $c9ba1ef480aabd69$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", dataAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCf67.default), null, children));
}

});
parcelRegister("kCf67", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2a3f638b2bb379$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0f2a3f638b2bb379$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0");
    return children;
}

});


parcelRegister("lOrB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8631e4f292d72a1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $8631e4f292d72a1d$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
}

});

parcelRegister("1OmSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $703438935d5e4acf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $703438935d5e4acf$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("hr", null);
}

});

parcelRegister("5hibD", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $2343f7ca7945d21e$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "default", () => $2343f7ca7945d21e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $mJhHc = parcelRequire("mJhHc");

var $8AkRK = parcelRequire("8AkRK");
var $4iaaT = parcelRequire("4iaaT");

var $iYHWS = parcelRequire("iYHWS");
var $9lEAD = parcelRequire("9lEAD");
var $40AXa = parcelRequire("40AXa");

var $8DyOy = parcelRequire("8DyOy");

var $25FYC = parcelRequire("25FYC");

var $2JJ1l = parcelRequire("2JJ1l");

var $4Rncy = parcelRequire("4Rncy");

var $9pV0l = parcelRequire("9pV0l");

var $bIQK1 = parcelRequire("bIQK1");

var $2dNsW = parcelRequire("2dNsW");

var $8GvDy = parcelRequire("8GvDy");

var $5pCn0 = parcelRequire("5pCn0");

var $5IOJr = parcelRequire("5IOJr");
const $2343f7ca7945d21e$export$eec82c0a93aa66d9 = (appearance)=>(0, $5IOJr.isFullWidthOrFullPageAppearance)(appearance) || (0, $5IOJr.isCommentAppearance)(appearance) && (0, $4Rncy.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $2343f7ca7945d21e$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $8DyOy.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $40AXa.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $9lEAD.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $2343f7ca7945d21e$var$hasRowspan = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $2343f7ca7945d21e$var$getRefTop = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $2343f7ca7945d21e$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $2343f7ca7945d21e$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $2343f7ca7945d21e$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $2343f7ca7945d21e$var$isHeaderRowEnabled = (rows)=>{
    if (!rows.length) return false;
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $bIQK1.TableHeader);
    return children.every((node)=>node.type === (0, $bIQK1.TableHeader));
};
const $2343f7ca7945d21e$var$tableCanBeSticky = (node, children)=>{
    return $2343f7ca7945d21e$var$isHeaderRowEnabled(children) && node && node.firstChild && !$2343f7ca7945d21e$var$hasRowspan(node.firstChild);
};
const $2343f7ca7945d21e$var$canUseLinelength = (appearance)=>appearance === 'full-page';
class $2343f7ca7945d21e$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $8GvDy.OverflowParent).fromElement(this.tableRef.current);
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $8GvDy.OverflowParent).fromElement(this.tableRef.current);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $mJhHc.tableMarginTop) - (0, $8GvDy.tableStickyPadding);
    }
    get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                return this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
            default:
                return undefined;
        }
    }
    render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $25FYC.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return isRenderWidthValid ? Math.min((0, $25FYC.akEditorFullWidthLayoutWidth), renderWidth) : (0, $25FYC.akEditorFullWidthLayoutWidth);
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $2JJ1l.getTableContainerWidth)(tableNode);
                return isRenderWidthValid ? renderWidth : tableContainerWidth;
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $2JJ1l.getTableContainerWidth)(tableNode);
                return isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth;
            }
        };
        const tableWidth = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $25FYC.akEditorFullWidthLayoutWidth), renderWidth) : (0, $25FYC.akEditorFullWidthLayoutWidth);
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $5IOJr.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        let lineLength = (0, $5IOJr.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && isTableAlignStart && ((0, $5IOJr.isFullPageAppearance)(rendererAppearance) && tableWidth <= lineLengthFixedWidth || (0, $5IOJr.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        if (shouldCalculateLeftForAlignment) left = (tableWidth - lineLength) / 2;
        if (!shouldCalculateLeftForAlignment && $2343f7ca7945d21e$var$canUseLinelength(rendererAppearance) && tableWidth > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $25FYC.akEditorDefaultLayoutWidth) ? tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? tableWidth : 'inherit';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            style: {
                width: finalTableContainerWidth,
                left: left,
                marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
            }
        }, stickyHeaders && $2343f7ca7945d21e$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GvDy.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5pCn0.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing
        }, this.grabFirstRowRef(children)))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.overflowParent = null;
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $8GvDy.tableStickyPadding);
            const tableTop = $2343f7ca7945d21e$var$getRefTop(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $2343f7ca7945d21e$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $2343f7ca7945d21e$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $2343f7ca7945d21e$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        let childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
        const orderedChildren = (0, $iYHWS.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2343f7ca7945d21e$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $2343f7ca7945d21e$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, $9lEAD.hasMergedCell)(tableNode)) return $2343f7ca7945d21e$var$addSortableColumn($2343f7ca7945d21e$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $2343f7ca7945d21e$var$isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
const $2343f7ca7945d21e$var$TableWithShadows = (0, $8AkRK.default)($2343f7ca7945d21e$export$91e0997fd3f75d56, {
    overflowSelector: `.${(0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $2343f7ca7945d21e$var$TableWithWidth = (props)=>{
    // Remember, `width` will be 0 during SSR
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ width: width })=>{
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $9pV0l.FullPagePadding) * 2 : width;
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2343f7ca7945d21e$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2343f7ca7945d21e$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props
        });
    });
};
var $2343f7ca7945d21e$export$2e2bcd8739ae039 = (0, $2dNsW.withSmartCardStorage)($2343f7ca7945d21e$var$TableWithWidth);

});
parcelRegister("mJhHc", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $6271954a5ccf999f$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $6271954a5ccf999f$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $6271954a5ccf999f$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $6271954a5ccf999f$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $6271954a5ccf999f$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $6271954a5ccf999f$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $6271954a5ccf999f$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $6271954a5ccf999f$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $6271954a5ccf999f$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $6271954a5ccf999f$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");

var $4Rncy = parcelRequire("4Rncy");

var $jMQbs = parcelRequire("jMQbs");

var $9SSfJ = parcelRequire("9SSfJ");

var $17wmF = parcelRequire("17wmF");
function $6271954a5ccf999f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6271954a5ccf999f$export$808015ab1dd6897a = 24;
const $6271954a5ccf999f$export$afe1899c3eea9823 = 16;
const $6271954a5ccf999f$export$910bf0d22c3d10f2 = 14;
const $6271954a5ccf999f$export$a43e30915fab3ccf = 8;
const $6271954a5ccf999f$export$531f77930bf508de = 48;
const $6271954a5ccf999f$export$c60fae4049791eae = 140;
const $6271954a5ccf999f$export$72aad729077aa0fb = 1;
const $6271954a5ccf999f$export$e56b8ca552b280f6 = 8;
const $6271954a5ccf999f$export$bba39e724bc39451 = 6;
const $6271954a5ccf999f$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-right`,
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $byxO6.tableCellContentDomSelector),
    TABLE_CELL_WRAPPER: (0, $byxO6.tableCellSelector),
    TABLE_HEADER_CELL_WRAPPER: (0, $byxO6.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $byxO6.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $6271954a5ccf999f$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $6271954a5ccf999f$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $6271954a5ccf999f$var$firstNodeWithNotMarginTop = ()=>(0, $4Rncy.editorExperiment)('nested-dnd', true) ? $6271954a5ccf999f$var$_ref2 : $6271954a5ccf999f$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $6271954a5ccf999f$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $byn9U.css)((0, $17wmF.tableCellBackgroundStyleOverride)(), " .", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $25FYC.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $6271954a5ccf999f$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}th,td{min-width:", $6271954a5ccf999f$export$531f77930bf508de, "px;font-weight:normal;vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:", (0, $4Rncy.editorExperiment)('table-nested-dnd', true) ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-100, 8px)", ";", (0, $jMQbs.browser).gecko || (0, $jMQbs.browser).ie || (0, $jMQbs.browser).mac && (0, $jMQbs.browser).chrome ? 'background-clip: padding-box;' : '', " ", $6271954a5ccf999f$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $25FYC.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $25FYC.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $6271954a5ccf999f$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $25FYC.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorWideLayoutWidth));
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("bCCqk", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $d830dab92300d0ea$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $d830dab92300d0ea$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)();
};

});

parcelRegister("4Rncy", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $082288f422e4e121$export$9b7cf3b74f250027);

var $8tM2T = parcelRequire("8tM2T");

var $j0k0I = parcelRequire("j0k0I");

var $9VO3j = parcelRequire("9VO3j");
function $082288f422e4e121$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $j0k0I.editorExperimentsConfig)[experimentName];
    if ((0, $9VO3j._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $9VO3j._overrides)[experimentName] === expectedExperimentValue;
    if (!(0, $9VO3j._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKey = experimentConfig.productKeys?.[0, $9VO3j._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $j0k0I.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $8tM2T.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}

});
parcelRegister("j0k0I", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $e61788c2524ef7da$export$6cbb856f286b07ef);
function $e61788c2524ef7da$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $e61788c2524ef7da$var$oneOf(values) {
    return (value)=>{
        return values.includes(value);
    };
}
const $e61788c2524ef7da$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        // Note -- you need to set the type to boolean for the default value
        defaultValue: false
    },
    // Added 2024-08-08
    'example-multivariate': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        typeGuard: $e61788c2524ef7da$var$oneOf([
            'one',
            'two',
            'three'
        ]),
        // Note -- you need to specify the type of the default value as the union of all possible values
        // This is used to provide type safety on consumption
        defaultValue: 'one'
    },
    // Added 2024-08-08
    'test-new-experiments-package': {
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Add 2024-08-14
    'basic-text-transformations': {
        productKeys: {
            confluence: 'platform_editor_basic_text_transformations'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Add 2024-08-27
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_command_palate_improvement/
    platform_editor_ai_command_palate_improvement: {
        productKeys: {
            confluence: 'platform_editor_ai_command_palate_improvement'
        },
        param: 'cohort',
        typeGuard: $e61788c2524ef7da$var$oneOf([
            'control',
            'test'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-08-23
    'platform-editor-ai-condensed-floating-toobar': {
        productKeys: {
            confluence: 'platform_editor_ai_condensed_floating_toobar'
        },
        param: 'cohort',
        typeGuard: $e61788c2524ef7da$var$oneOf([
            'control',
            'dropdown',
            'editor_ai_button'
        ]),
        defaultValue: 'control'
    },
    // Added 2024-08-27
    'dnd-input-performance-optimisation': {
        productKeys: {
            confluence: 'platform_editor_dnd_input_performance_optimisation'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Added 2024-08-28
    'element-level-templates': {
        productKeys: {
            confluence: 'platform_editor_element_level_templates'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Added 2024-08-30
    'nested-dnd': {
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_nested'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Add 2024-08-27
    'table-nested-dnd': {
        productKeys: {
            confluence: 'platform_editor_elements_dnd_nested_table'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Added 2024-08-29
    'insert-menu-in-right-rail': {
        productKeys: {
            confluence: 'platform_editor_insert_menu_in_right_rail'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Added 2024-09-02
    platform_editor_empty_line_prompt: {
        productKeys: {
            confluence: 'platform_editor_empty_line_prompt'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Added 2024-09-05
    support_table_in_comment: {
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    },
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: {
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        typeGuard: $e61788c2524ef7da$var$isBoolean,
        defaultValue: false
    }
};

});

parcelRegister("9VO3j", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $356ccc7ffd1f8e46$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_product", () => $356ccc7ffd1f8e46$export$cf7305fc65acbf0d);

var $j0k0I = parcelRequire("j0k0I");
let $356ccc7ffd1f8e46$export$e5d73bf4f8e2ae96 = {};
let $356ccc7ffd1f8e46$export$cf7305fc65acbf0d;
function $356ccc7ffd1f8e46$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the value of an experiment for testing purposes.
	 * This is useful when you want to test a specific value of an experiment.
	 */ overrides) {
    if (overrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        overrides = Object.entries(overrides).reduce((acc, [key, value])=>{
            const config = (0, $j0k0I.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $356ccc7ffd1f8e46$export$e5d73bf4f8e2ae96 = overrides;
    }
    $356ccc7ffd1f8e46$export$cf7305fc65acbf0d = product;
}

});


parcelRegister("9SSfJ", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $eb33b06689f56208$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $eb33b06689f56208$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $eb33b06689f56208$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");


var $lcnyw = parcelRequire("lcnyw");
const $eb33b06689f56208$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    // Feature Gate editor_support_code_block_wrapping:
    CODEBLOCK_CONTENT_WRAPPER_FG: 'code-block-content-wrapper--fg',
    CODEBLOCK_CONTENT_FG: 'code-content--fg',
    CODEBLOCK_CONTENT_FG_WRAPPED: 'code-content--fg-wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped',
    CODEBLOCK_LINE_NUMBER_GUTTER_FG: 'line-number-gutter--fg'
};
const $eb33b06689f56208$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG_WRAPPED, ">.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, transparent);border-radius:var(--ds-border-radius, 3px);margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $25FYC.akEditorCodeFontFamily), ";min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;cursor:pointer;--ds--code--bg-color:transparent;white-space:normal;.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{background-color:", `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`, ";display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, "{position:relative;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{flex-shrink:0;text-align:right;background-color:", `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`, ";padding:var(--ds-space-100, 8px);position:relative;span{display:block;line-height:0;font-size:0;::before{display:inline-block;content:counter(line);counter-increment:line;color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`, ";font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";line-height:1.5rem;}}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER_FG, "{background-color:", `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`, ";position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:0px var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";box-sizing:content-box;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;tab-size:4;cursor:text;color:", `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`, ";border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);white-space:pre;font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";line-height:1.5rem;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{code{tab-size:4;cursor:text;color:", `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`, ";border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";line-height:1.5rem;}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $eb33b06689f56208$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $byn9U.css)("::before{content:' ';line-height:", (0, $25FYC.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $25FYC.akEditorLineHeight), "em!important;}");

});

parcelRegister("17wmF", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $9f1b588651706b74$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $bNZ6o = parcelRequire("bNZ6o");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $9f1b588651706b74$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $byxO6.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $bNZ6o.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $9f1b588651706b74$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $byn9U.css)($9f1b588651706b74$var$mapBackgroundColors());

});
parcelRegister("bNZ6o", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $1e659e5f8f9e9d8c$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $1e659e5f8f9e9d8c$export$a270511a0e7fd61a);
// This import will be stripped on build

var $iX87Q = parcelRequire("iX87Q");
function $1e659e5f8f9e9d8c$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1e659e5f8f9e9d8c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $1e659e5f8f9e9d8c$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1e659e5f8f9e9d8c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $1e659e5f8f9e9d8c$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("iYHWS", function(module, exports) {

$parcel$export(module.exports, "compose", () => $68fcb7b2f1ecd6d1$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $68fcb7b2f1ecd6d1$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("9lEAD", function(module, exports) {

$parcel$export(module.exports, "calcTableColumnWidths", () => $6cb2424413478105$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $6cb2424413478105$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $6cb2424413478105$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $6cb2424413478105$export$889a8e446452be16);
function $6cb2424413478105$export$98951d3cdcfd364b(node) {
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        let colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $6cb2424413478105$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $6cb2424413478105$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $6cb2424413478105$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    let doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("40AXa", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $886e901aefc55741$export$49215374a8bec29c);

var $8DyOy = parcelRequire("8DyOy");
var $886e901aefc55741$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
})($886e901aefc55741$export$e2e108cbe2e4f865 || ($886e901aefc55741$export$e2e108cbe2e4f865 = {}));
function $886e901aefc55741$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $886e901aefc55741$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $886e901aefc55741$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $886e901aefc55741$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $886e901aefc55741$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $886e901aefc55741$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $886e901aefc55741$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $886e901aefc55741$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $886e901aefc55741$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                // TODO: Check what should be the fallback when mention does not have a text
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $886e901aefc55741$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $886e901aefc55741$export$49215374a8bec29c = (options, order = (0, $8DyOy.SortOrder).ASC)=>{
    const normalizeTextParser = $886e901aefc55741$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $886e901aefc55741$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $886e901aefc55741$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $8DyOy.SortOrder).DESC ? -1 : 1) * $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $886e901aefc55741$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("8DyOy", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $060dd58131e98cee$export$7ae723045d45777a);

var $3DXMd = parcelRequire("3DXMd");

var $7PkbE = parcelRequire("7PkbE");
var $060dd58131e98cee$export$7ae723045d45777a;
(function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
})($060dd58131e98cee$export$7ae723045d45777a || ($060dd58131e98cee$export$7ae723045d45777a = {}));

});
parcelRegister("3DXMd", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $959eb61d6ba0a905$export$c1c4b33b4e7b1c70);

var $3sTLs = parcelRequire("3sTLs");
var $959eb61d6ba0a905$export$c1c4b33b4e7b1c70;
(function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
})($959eb61d6ba0a905$export$c1c4b33b4e7b1c70 || ($959eb61d6ba0a905$export$c1c4b33b4e7b1c70 = {}));
class $959eb61d6ba0a905$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3sTLs)))();
    }
}

});
parcelRegister("3sTLs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $285f3e4babf0bfc8$var$R = typeof Reflect === 'object' ? Reflect : null;
var $285f3e4babf0bfc8$var$ReflectApply = $285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.apply === 'function' ? $285f3e4babf0bfc8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $285f3e4babf0bfc8$var$ReflectOwnKeys;
if ($285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.ownKeys === 'function') $285f3e4babf0bfc8$var$ReflectOwnKeys = $285f3e4babf0bfc8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $285f3e4babf0bfc8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $285f3e4babf0bfc8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $285f3e4babf0bfc8$var$EventEmitter() {
    $285f3e4babf0bfc8$var$EventEmitter.init.call(this);
}
module.exports = $285f3e4babf0bfc8$var$EventEmitter;
module.exports.once = $285f3e4babf0bfc8$var$once;
// Backwards-compat with node 0.10.x
$285f3e4babf0bfc8$var$EventEmitter.EventEmitter = $285f3e4babf0bfc8$var$EventEmitter;
$285f3e4babf0bfc8$var$EventEmitter.prototype._events = undefined;
$285f3e4babf0bfc8$var$EventEmitter.prototype._eventsCount = 0;
$285f3e4babf0bfc8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $285f3e4babf0bfc8$var$defaultMaxListeners = 10;
function $285f3e4babf0bfc8$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($285f3e4babf0bfc8$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $285f3e4babf0bfc8$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $285f3e4babf0bfc8$var$defaultMaxListeners = arg;
    }
});
$285f3e4babf0bfc8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$285f3e4babf0bfc8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $285f3e4babf0bfc8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $285f3e4babf0bfc8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $285f3e4babf0bfc8$var$_getMaxListeners(this);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $285f3e4babf0bfc8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $285f3e4babf0bfc8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$285f3e4babf0bfc8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $285f3e4babf0bfc8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $285f3e4babf0bfc8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $285f3e4babf0bfc8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, false);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.on = $285f3e4babf0bfc8$var$EventEmitter.prototype.addListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, true);
};
function $285f3e4babf0bfc8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $285f3e4babf0bfc8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $285f3e4babf0bfc8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.once = function once(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.on(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.prependListener(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $285f3e4babf0bfc8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.off = $285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $285f3e4babf0bfc8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $285f3e4babf0bfc8$var$unwrapListeners(evlistener) : $285f3e4babf0bfc8$var$arrayClone(evlistener, evlistener.length);
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, true);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, false);
};
$285f3e4babf0bfc8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $285f3e4babf0bfc8$var$listenerCount.call(emitter, type);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.listenerCount = $285f3e4babf0bfc8$var$listenerCount;
function $285f3e4babf0bfc8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $285f3e4babf0bfc8$var$ReflectOwnKeys(this._events) : [];
};
function $285f3e4babf0bfc8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $285f3e4babf0bfc8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $285f3e4babf0bfc8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $285f3e4babf0bfc8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("7PkbE", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $7affccbd0c281873$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $7affccbd0c281873$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $7affccbd0c281873$export$63ca43752be70b90);
var $7affccbd0c281873$export$ed55211407a9423;
(function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
})($7affccbd0c281873$export$ed55211407a9423 || ($7affccbd0c281873$export$ed55211407a9423 = {}));
var $7affccbd0c281873$export$423b5e8c92d477b9;
(function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
})($7affccbd0c281873$export$423b5e8c92d477b9 || ($7affccbd0c281873$export$423b5e8c92d477b9 = {}));
var $7affccbd0c281873$export$63ca43752be70b90;
(function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
})($7affccbd0c281873$export$63ca43752be70b90 || ($7affccbd0c281873$export$63ca43752be70b90 = {}));

});



parcelRegister("2JJ1l", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $9db2d789f4714b6a$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $9db2d789f4714b6a$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $9db2d789f4714b6a$export$3930799be057b305);

var $2zbl1 = parcelRequire("2zbl1");

var $25FYC = parcelRequire("25FYC");

var $lcnyw = parcelRequire("lcnyw");

var $jLo5a = parcelRequire("jLo5a");

var $jySns = parcelRequire("jySns");

var $b3jMP = parcelRequire("b3jMP");
const $9db2d789f4714b6a$export$9b77d38feba5446 = {
    default: (0, $25FYC.akEditorDefaultLayoutWidth),
    wide: (0, $25FYC.akEditorWideLayoutWidth),
    'full-width': (0, $25FYC.akEditorFullWidthLayoutWidth)
};
const $9db2d789f4714b6a$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $9db2d789f4714b6a$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $9db2d789f4714b6a$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            return state['contextPanelPluginKey$'];
        }
    };
    if (node.type === schema.nodes.layoutSection) {
        parentWidth += (0, $25FYC.akLayoutGutterOffset) * 2; // extra width that gets added to layout
        // Calculate width of parent layout column when
        // Parallel layout with viewport greater than 1024px
        // OR side panel of an extension is open and change the node width to smaller than containerWidth
        if (containerWidth.width > (0, $25FYC.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
            parentWidth -= ((0, $jySns.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
            const $pos = state.doc.resolve(pos);
            const column = (0, $2zbl1.findParentNodeOfTypeClosestToPos)($pos, [
                state.schema.nodes.layoutColumn
            ]);
            if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
            parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
        }
    }
    // account for the padding of the parent node
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth -= (0, $jySns.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $jLo5a.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $jLo5a.BODIED_EXT_PADDING) * 2;
            break;
        // TODO: Migrate away from gridSize
        // Recommendation: Replace gridSize with 8
        case schema.nodes.expand:
            // padding
            parentWidth -= (0, $lcnyw.gridSize)() * 2;
            // gutter offset
            parentWidth += (0, $lcnyw.gridSize)() * 3;
            // padding right
            parentWidth -= (0, $lcnyw.gridSize)();
            // padding left
            parentWidth -= (0, $lcnyw.gridSize)() * 4 - (0, $lcnyw.gridSize)() / 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $9db2d789f4714b6a$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $2zbl1.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand
    ]);
    return parent ? parent.node : null;
};
const $9db2d789f4714b6a$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $b3jMP.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $9db2d789f4714b6a$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $9db2d789f4714b6a$export$9b77d38feba5446[node?.attrs.layout] || (0, $25FYC.akEditorDefaultLayoutWidth);
};
const $9db2d789f4714b6a$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $9db2d789f4714b6a$export$3930799be057b305(node) - offset;
    return $9db2d789f4714b6a$export$3930799be057b305(node);
};

});
parcelRegister("2zbl1", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $1de7a52bc852b126$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $1de7a52bc852b126$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $1de7a52bc852b126$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $1de7a52bc852b126$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $1de7a52bc852b126$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $1de7a52bc852b126$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $1de7a52bc852b126$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $1de7a52bc852b126$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $1de7a52bc852b126$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $1de7a52bc852b126$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $1de7a52bc852b126$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $1de7a52bc852b126$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $1de7a52bc852b126$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $1de7a52bc852b126$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $1de7a52bc852b126$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $1de7a52bc852b126$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $1de7a52bc852b126$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $1de7a52bc852b126$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $1de7a52bc852b126$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $1de7a52bc852b126$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $1de7a52bc852b126$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $1de7a52bc852b126$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $1de7a52bc852b126$export$2344b14b097df817);
// src/selection.ts

var $kpTIW = parcelRequire("kpTIW");

var $7dkLM = parcelRequire("7dkLM");
var $1de7a52bc852b126$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $1de7a52bc852b126$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $1de7a52bc852b126$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $1de7a52bc852b126$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $1de7a52bc852b126$export$7d6e4e6663186878 = (tr)=>{
    if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $1de7a52bc852b126$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $1de7a52bc852b126$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $7dkLM.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $7dkLM.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $1de7a52bc852b126$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $1de7a52bc852b126$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $1de7a52bc852b126$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $7dkLM.Node) && node.type && node.type.spec.selectable);
var $1de7a52bc852b126$var$shouldSelectNode = (node)=>$1de7a52bc852b126$var$isSelectableNode(node) && node.type.isLeaf;
var $1de7a52bc852b126$var$setSelection = (node, pos, tr)=>{
    if ($1de7a52bc852b126$var$shouldSelectNode(node)) return tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(pos)));
    return $1de7a52bc852b126$export$1df6d14df6b0b758(pos)(tr);
};
var $1de7a52bc852b126$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $1de7a52bc852b126$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($1de7a52bc852b126$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $1de7a52bc852b126$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $1de7a52bc852b126$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $1de7a52bc852b126$var$setSelection(content, pos, tr);
            }
        }
        if ($1de7a52bc852b126$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $1de7a52bc852b126$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $1de7a52bc852b126$var$cloneTr($1de7a52bc852b126$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($1de7a52bc852b126$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $1de7a52bc852b126$var$cloneTr($1de7a52bc852b126$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $1de7a52bc852b126$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $1de7a52bc852b126$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $1de7a52bc852b126$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $1de7a52bc852b126$var$cloneTr(tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $1de7a52bc852b126$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $1de7a52bc852b126$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $1de7a52bc852b126$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $1de7a52bc852b126$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $kpTIW.NodeSelection);
};
var $1de7a52bc852b126$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $1de7a52bc852b126$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $1de7a52bc852b126$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($1de7a52bc852b126$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $1de7a52bc852b126$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $1de7a52bc852b126$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $1de7a52bc852b126$var$cloneTr(tr);
        }
        return tr;
    };
var $1de7a52bc852b126$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $7dkLM.Fragment) ? content : (0, $7dkLM.Fragment).from(content));
};
var $1de7a52bc852b126$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $1de7a52bc852b126$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $1de7a52bc852b126$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $7dkLM.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $7dkLM.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $1de7a52bc852b126$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $1de7a52bc852b126$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $1de7a52bc852b126$export$fe09644e3bc6166b($from, predicate);
    };
var $1de7a52bc852b126$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $1de7a52bc852b126$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $1de7a52bc852b126$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $1de7a52bc852b126$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $1de7a52bc852b126$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$1de7a52bc852b126$export$dc159056ffdb4c76(predicate)(selection);
    };
var $1de7a52bc852b126$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $1de7a52bc852b126$export$dc159056ffdb4c76((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node))(selection);
    };
var $1de7a52bc852b126$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $1de7a52bc852b126$export$fe09644e3bc6166b($pos, (node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node));
};
var $1de7a52bc852b126$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $1de7a52bc852b126$export$178ecaf80f45fdb6((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node))(selection);
    };
var $1de7a52bc852b126$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $1de7a52bc852b126$export$8556d79fa8189214((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $1de7a52bc852b126$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($1de7a52bc852b126$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $1de7a52bc852b126$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $kpTIW.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $1de7a52bc852b126$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $1de7a52bc852b126$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $1de7a52bc852b126$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $1de7a52bc852b126$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $1de7a52bc852b126$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $1de7a52bc852b126$export$ddc1620722e25671 = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $1de7a52bc852b126$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $1de7a52bc852b126$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $1de7a52bc852b126$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $1de7a52bc852b126$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $1de7a52bc852b126$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$1de7a52bc852b126$export$96bb9476c7c69f39(node, nodeType).length;
};

});
parcelRegister("kpTIW", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $edd15e116d766874$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $edd15e116d766874$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $edd15e116d766874$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $edd15e116d766874$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $edd15e116d766874$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $edd15e116d766874$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $edd15e116d766874$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $edd15e116d766874$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $edd15e116d766874$export$1692d8b0e89cecc3);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $edd15e116d766874$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $edd15e116d766874$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $edd15e116d766874$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7dkLM.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
            if (i == 0) $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $edd15e116d766874$export$c2b25f346d19bcbb($pos) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $edd15e116d766874$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, 0, 0, 1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $edd15e116d766874$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $edd15e116d766874$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $edd15e116d766874$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$edd15e116d766874$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $edd15e116d766874$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $edd15e116d766874$var$warnedAboutTextSelection = false;
function $edd15e116d766874$var$checkTextSelection($pos) {
    if (!$edd15e116d766874$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $edd15e116d766874$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $edd15e116d766874$export$c2b25f346d19bcbb extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $edd15e116d766874$var$checkTextSelection($anchor);
        $edd15e116d766874$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $edd15e116d766874$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7dkLM.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $edd15e116d766874$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $edd15e116d766874$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $edd15e116d766874$export$52baac22726c72bf.findFrom($head, bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $edd15e116d766874$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("text", $edd15e116d766874$export$c2b25f346d19bcbb);
class $edd15e116d766874$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $edd15e116d766874$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $edd15e116d766874$export$e2940151ac854c0b extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $edd15e116d766874$export$52baac22726c72bf.near($pos);
        return new $edd15e116d766874$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $edd15e116d766874$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$edd15e116d766874$export$e2940151ac854c0b.prototype.visible = false;
$edd15e116d766874$export$52baac22726c72bf.jsonID("node", $edd15e116d766874$export$e2940151ac854c0b);
class $edd15e116d766874$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $edd15e116d766874$var$TextBookmark(pos, pos) : new $edd15e116d766874$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(node)) return new $edd15e116d766874$export$e2940151ac854c0b($pos);
        return $edd15e116d766874$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $edd15e116d766874$export$c15d9ba76bdbcd95 extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        if (content == (0, $7dkLM.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $edd15e116d766874$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $edd15e116d766874$var$AllBookmark;
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("all", $edd15e116d766874$export$c15d9ba76bdbcd95);
const $edd15e116d766874$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $edd15e116d766874$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $edd15e116d766874$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $edd15e116d766874$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(child)) return $edd15e116d766874$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $edd15e116d766874$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($edd15e116d766874$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $edd15e116d766874$var$UPDATED_SEL = 1, $edd15e116d766874$var$UPDATED_MARKS = 2, $edd15e116d766874$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $edd15e116d766874$export$febc5573c75cefb0 extends (0, $d6JJW.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $edd15e116d766874$var$UPDATED_SEL) & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $edd15e116d766874$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7dkLM.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7dkLM.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($edd15e116d766874$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $edd15e116d766874$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SCROLL) > 0;
    }
}
function $edd15e116d766874$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $edd15e116d766874$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $edd15e116d766874$var$bind(desc.init, self);
        this.apply = $edd15e116d766874$var$bind(desc.apply, self);
    }
}
const $edd15e116d766874$var$baseFields = [
    new $edd15e116d766874$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $edd15e116d766874$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $edd15e116d766874$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $edd15e116d766874$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $edd15e116d766874$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $edd15e116d766874$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $edd15e116d766874$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $edd15e116d766874$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $edd15e116d766874$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $edd15e116d766874$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $edd15e116d766874$var$Configuration(config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7dkLM.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $edd15e116d766874$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $edd15e116d766874$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $edd15e116d766874$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $edd15e116d766874$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $edd15e116d766874$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $edd15e116d766874$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $edd15e116d766874$var$keys = Object.create(null);
function $edd15e116d766874$var$createKey(name) {
    if (name in $edd15e116d766874$var$keys) return name + "$" + ++$edd15e116d766874$var$keys[name];
    $edd15e116d766874$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $edd15e116d766874$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $edd15e116d766874$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("d6JJW", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $98af50e5743169ae$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $98af50e5743169ae$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $98af50e5743169ae$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $98af50e5743169ae$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $98af50e5743169ae$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $98af50e5743169ae$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $98af50e5743169ae$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $98af50e5743169ae$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $98af50e5743169ae$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $98af50e5743169ae$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $98af50e5743169ae$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $98af50e5743169ae$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $98af50e5743169ae$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $98af50e5743169ae$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $98af50e5743169ae$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $98af50e5743169ae$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $98af50e5743169ae$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $98af50e5743169ae$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $98af50e5743169ae$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $98af50e5743169ae$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $98af50e5743169ae$export$563a914cafbdc389);

var $7dkLM = parcelRequire("7dkLM");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $98af50e5743169ae$var$lower16 = 0xffff;
const $98af50e5743169ae$var$factor16 = Math.pow(2, 16);
function $98af50e5743169ae$var$makeRecover(index, offset) {
    return index + offset * $98af50e5743169ae$var$factor16;
}
function $98af50e5743169ae$var$recoverIndex(value) {
    return value & $98af50e5743169ae$var$lower16;
}
function $98af50e5743169ae$var$recoverOffset(value) {
    return (value - (value & $98af50e5743169ae$var$lower16)) / $98af50e5743169ae$var$factor16;
}
const $98af50e5743169ae$var$DEL_BEFORE = 1, $98af50e5743169ae$var$DEL_AFTER = 2, $98af50e5743169ae$var$DEL_ACROSS = 4, $98af50e5743169ae$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $98af50e5743169ae$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_BEFORE | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_AFTER | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $98af50e5743169ae$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $98af50e5743169ae$export$c53d01c3ab9721b3.empty) return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $98af50e5743169ae$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $98af50e5743169ae$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $98af50e5743169ae$var$DEL_AFTER : pos == end ? $98af50e5743169ae$var$DEL_BEFORE : $98af50e5743169ae$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $98af50e5743169ae$var$DEL_SIDE;
                return new $98af50e5743169ae$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $98af50e5743169ae$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $98af50e5743169ae$export$c53d01c3ab9721b3.empty : new $98af50e5743169ae$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $98af50e5743169ae$export$c53d01c3ab9721b3.empty = new $98af50e5743169ae$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $98af50e5743169ae$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $98af50e5743169ae$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $98af50e5743169ae$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $98af50e5743169ae$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $98af50e5743169ae$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $98af50e5743169ae$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $98af50e5743169ae$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $98af50e5743169ae$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $98af50e5743169ae$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7dkLM.ReplaceError)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $98af50e5743169ae$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($98af50e5743169ae$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $98af50e5743169ae$export$d24ba56b0e3464a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addMark", $98af50e5743169ae$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $98af50e5743169ae$export$94150db1311f67a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $98af50e5743169ae$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeMark", $98af50e5743169ae$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $98af50e5743169ae$export$adefd16c402fee4e extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addNodeMark", $98af50e5743169ae$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $98af50e5743169ae$export$fdf7d1dc10724da2 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeNodeMark", $98af50e5743169ae$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $98af50e5743169ae$export$5c860b2e74034756 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $98af50e5743169ae$var$contentBetween(doc, this.from, this.to)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $98af50e5743169ae$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $98af50e5743169ae$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $98af50e5743169ae$export$5c860b2e74034756(json.from, json.to, (0, $7dkLM.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replace", $98af50e5743169ae$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $98af50e5743169ae$export$444ba800d6024a98 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($98af50e5743169ae$var$contentBetween(doc, this.from, this.gapFrom) || $98af50e5743169ae$var$contentBetween(doc, this.gapTo, this.to))) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $98af50e5743169ae$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $98af50e5743169ae$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $98af50e5743169ae$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7dkLM.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replaceAround", $98af50e5743169ae$export$444ba800d6024a98);
function $98af50e5743169ae$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $98af50e5743169ae$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $98af50e5743169ae$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $98af50e5743169ae$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $98af50e5743169ae$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7dkLM.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $98af50e5743169ae$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $98af50e5743169ae$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur, end, (0, $7dkLM.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $98af50e5743169ae$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7dkLM.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7dkLM.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $98af50e5743169ae$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $98af50e5743169ae$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$98af50e5743169ae$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $98af50e5743169ae$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7dkLM.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7dkLM.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7dkLM.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7dkLM.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7dkLM.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $98af50e5743169ae$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $98af50e5743169ae$var$findWrappingOutside(range, nodeType);
    let inner = around && $98af50e5743169ae$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($98af50e5743169ae$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($98af50e5743169ae$var$withAttrs));
}
function $98af50e5743169ae$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $98af50e5743169ae$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $98af50e5743169ae$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $98af50e5743169ae$var$wrap(tr, range, wrappers) {
    let content = (0, $7dkLM.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7dkLM.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, start, end, new (0, $7dkLM.Slice)(content, 0, 0), wrappers.length, true));
}
function $98af50e5743169ae$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isTextblock && !node.hasMarkup(type, attrs) && $98af50e5743169ae$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $98af50e5743169ae$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $98af50e5743169ae$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $98af50e5743169ae$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $98af50e5743169ae$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $98af50e5743169ae$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $98af50e5743169ae$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $98af50e5743169ae$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $98af50e5743169ae$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $98af50e5743169ae$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $98af50e5743169ae$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7dkLM.Fragment).empty, after = (0, $7dkLM.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7dkLM.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7dkLM.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $98af50e5743169ae$export$5c860b2e74034756(pos, pos, new (0, $7dkLM.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $98af50e5743169ae$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $98af50e5743169ae$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $98af50e5743169ae$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && a.canAppend(b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $98af50e5743169ae$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $98af50e5743169ae$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $98af50e5743169ae$var$join(tr, pos, depth) {
    let step = new $98af50e5743169ae$export$5c860b2e74034756(pos - depth, pos + depth, (0, $7dkLM.Slice).empty, true);
    tr.step(step);
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $98af50e5743169ae$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $98af50e5743169ae$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $98af50e5743169ae$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7dkLM.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice);
    return new $98af50e5743169ae$var$Fitter($from, $to, slice).fit();
}
function $98af50e5743169ae$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $98af50e5743169ae$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7dkLM.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7dkLM.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7dkLM.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $98af50e5743169ae$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $98af50e5743169ae$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $98af50e5743169ae$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7dkLM.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7dkLM.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($98af50e5743169ae$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, frontierDepth, (0, $7dkLM.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$98af50e5743169ae$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $98af50e5743169ae$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $98af50e5743169ae$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.depth, (0, $7dkLM.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7dkLM.Fragment).empty, true);
        if (add.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $98af50e5743169ae$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($98af50e5743169ae$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $98af50e5743169ae$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($98af50e5743169ae$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $98af50e5743169ae$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $98af50e5743169ae$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $98af50e5743169ae$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $98af50e5743169ae$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$98af50e5743169ae$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $98af50e5743169ae$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $98af50e5743169ae$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $98af50e5743169ae$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return tr.step(new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $98af50e5743169ae$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $98af50e5743169ae$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7dkLM.Slice)($98af50e5743169ae$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $98af50e5743169ae$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($98af50e5743169ae$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return fragment;
}
function $98af50e5743169ae$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $98af50e5743169ae$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
}
function $98af50e5743169ae$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $98af50e5743169ae$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $98af50e5743169ae$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $98af50e5743169ae$export$626399c38172f669 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $98af50e5743169ae$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("attr", $98af50e5743169ae$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $98af50e5743169ae$export$f50707b396300ac9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $98af50e5743169ae$export$f50707b396300ac9(json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("docAttr", $98af50e5743169ae$export$f50707b396300ac9);
/**
@internal
*/ let $98af50e5743169ae$export$88cc3a1dfce48dd3 = class extends Error {
};
$98af50e5743169ae$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.constructor = $98af50e5743169ae$export$88cc3a1dfce48dd3;
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $98af50e5743169ae$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $98af50e5743169ae$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $98af50e5743169ae$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7dkLM.Slice).empty) {
        let step = $98af50e5743169ae$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7dkLM.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $98af50e5743169ae$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $98af50e5743169ae$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $98af50e5743169ae$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $98af50e5743169ae$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $98af50e5743169ae$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $98af50e5743169ae$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $98af50e5743169ae$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $98af50e5743169ae$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $98af50e5743169ae$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $98af50e5743169ae$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $98af50e5743169ae$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7dkLM.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $98af50e5743169ae$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $98af50e5743169ae$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $98af50e5743169ae$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $98af50e5743169ae$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $98af50e5743169ae$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});



parcelRegister("jLo5a", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $7d6512c53e3e5450$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $7d6512c53e3e5450$export$91624ec52c59c24c);
const $7d6512c53e3e5450$export$f5ecdce4c60ff98b = 8;
const $7d6512c53e3e5450$export$5ac5087fe1217160 = $7d6512c53e3e5450$export$f5ecdce4c60ff98b * 2;
const $7d6512c53e3e5450$export$91624ec52c59c24c = 12;

});

parcelRegister("jySns", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $b3681f0378a2ce4f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $b3681f0378a2ce4f$export$a1bb91aa2d5fcce8);
const $b3681f0378a2ce4f$export$cd04f19842abff0 = 8;
const $b3681f0378a2ce4f$export$a1bb91aa2d5fcce8 = $b3681f0378a2ce4f$export$cd04f19842abff0 * 1.5;

});


parcelRegister("9pV0l", function(module, exports) {

$parcel$export(module.exports, "FullPagePadding", () => $224cbf506e249e6d$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $224cbf506e249e6d$export$74b525449cc7cbd1);
$parcel$export(module.exports, "rendererStyles", () => $224cbf506e249e6d$export$1c4377249312209);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");


var $4lTFP = parcelRequire("4lTFP");

var $juktg = parcelRequire("juktg");

var $33dUZ = parcelRequire("33dUZ");

var $1TZMa = parcelRequire("1TZMa");
var $i2OhI = parcelRequire("i2OhI");
var $9x5mm = parcelRequire("9x5mm");
var $9SSfJ = parcelRequire("9SSfJ");
var $6GESD = parcelRequire("6GESD");
var $3CrqS = parcelRequire("3CrqS");
var $izEcn = parcelRequire("izEcn");
var $hp7YN = parcelRequire("hp7YN");
var $8VeKB = parcelRequire("8VeKB");
var $juoPd = parcelRequire("juoPd");
var $dMNGz = parcelRequire("dMNGz");
var $bLfPF = parcelRequire("bLfPF");
var $fPB6q = parcelRequire("fPB6q");
var $c1Qps = parcelRequire("c1Qps");
var $cDyCO = parcelRequire("cDyCO");
var $mJhHc = parcelRequire("mJhHc");
var $6lAd7 = parcelRequire("6lAd7");
var $lGBd6 = parcelRequire("lGBd6");
var $eJ4TL = parcelRequire("eJ4TL");

var $8AkRK = parcelRequire("8AkRK");
var $1JeZT = parcelRequire("1JeZT");

var $jMQbs = parcelRequire("jMQbs");

var $25FYC = parcelRequire("25FYC");

var $ghgHw = parcelRequire("ghgHw");

var $dMrTV = parcelRequire("dMrTV");

var $igoil = parcelRequire("igoil");

var $5hibD = parcelRequire("5hibD");


var $4Rncy = parcelRequire("4Rncy");
const $224cbf506e249e6d$export$12fd658e5eef0d79 = 32;
const $224cbf506e249e6d$var$tableShadowWidth = 32;
const $224cbf506e249e6d$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $224cbf506e249e6d$var$telepointerStyles = (colorMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("#", $224cbf506e249e6d$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:700;width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
};
const $224cbf506e249e6d$var$getLineHeight = (fontCode)=>(0, $4lTFP.headingSizes)[fontCode].lineHeight / (0, $4lTFP.headingSizes)[fontCode].size;
const $224cbf506e249e6d$var$headingSizes = {
    h1: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h700')
    },
    h2: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h600')
    },
    h3: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h500')
    },
    h4: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h400')
    },
    h5: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h300')
    },
    h6: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h100')
    }
};
const $224cbf506e249e6d$var$headingAnchorStyle = (headingTag)=>/*#__PURE__*/ // TODO Delete this comment after verifying space token -> previous value `margin-left: 6px`
    (0, $byn9U.css)(".", (0, $dMrTV.HeadingAnchorWrapperClassName), "{position:absolute;height:", $224cbf506e249e6d$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, $dMrTV.HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, $dMrTV.HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, $dMrTV.HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
const $224cbf506e249e6d$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowNestedHeaderLinks) return '';
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    return /*#__PURE__*/ (0, $byn9U.css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, $dMrTV.HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, $dMrTV.HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
};
const $224cbf506e249e6d$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowColumnSorting) return '';
    let headingsCss = '';
    if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, $dMrTV.HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $4Rncy.editorExperiment)('table-nested-dnd', true) ? `${0, $mJhHc.tableCellPadding}px ${"var(--ds-space-250, 20px)"}` : `${0, $mJhHc.tableCellPadding}px`, ";border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`, ";}}}.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:1;}}}}");
};
const $224cbf506e249e6d$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
    if (appearance !== 'full-page') return '';
    return /*#__PURE__*/ (0, $byn9U.css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $224cbf506e249e6d$export$12fd658e5eef0d79 : 0, "px;");
};
const $224cbf506e249e6d$var$fullWidthStyles = ({ appearance: appearance })=>{
    if (appearance !== 'full-width') return '';
    return /*#__PURE__*/ (0, $byn9U.css)("max-width:", (0, $25FYC.akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark,.ak-renderer-extension{width:100%!important;}", (0, $5hibD.isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
};
const $224cbf506e249e6d$var$breakoutWidthStyle = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("*:not([data-mark-type='fragment']) .", (0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
};
const $224cbf506e249e6d$var$getShadowOverrides = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("&.", (0, $8AkRK.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $8AkRK.shadowClassNames).LEFT_SHADOW, "::before{width:", $224cbf506e249e6d$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, $8AkRK.shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
};
function $224cbf506e249e6d$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return '';
    if ((0, $XHGTv.fg)('annotations_align_editor_and_renderer_styles')) return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node]': {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
            paddingTop: "var(--ds-space-025, 2px)"
        }
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
            cursor: 'pointer',
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
        }
    });
}
const $224cbf506e249e6d$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
        const { colorMode: colorMode } = (0, $juktg.default)();
        // This is required to be compatible with styled-components prop structure.
        const themeProps = {
            theme: theme
        };
        const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock } = wrapperProps;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
        return /*#__PURE__*/ (0, $byn9U.css)("font-size:", (0, $25FYC.editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`, ";.", (0, $ghgHw.RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $224cbf506e249e6d$var$fullPageStyles(wrapperProps, themeProps), " ", $224cbf506e249e6d$var$fullWidthStyles(wrapperProps), " .", (0, $ghgHw.RendererCssClassName).DOCUMENT, "{", (0, $33dUZ.mediaInlineImageStyles), ";}& h1{", $224cbf506e249e6d$var$headingAnchorStyle('h1'), ";}& h2{", $224cbf506e249e6d$var$headingAnchorStyle('h2'), ";}& h3{", $224cbf506e249e6d$var$headingAnchorStyle('h3'), ";}& h4{", $224cbf506e249e6d$var$headingAnchorStyle('h4'), ";}& h5{", $224cbf506e249e6d$var$headingAnchorStyle('h5'), ";}& h6{", $224cbf506e249e6d$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$f563ee71e9ee74cd})`, ";}", $224cbf506e249e6d$var$telepointerStyles(colorMode), " ", (0, $eJ4TL.whitespaceSharedStyles), ";", (0, $4Rncy.editorExperiment)('nested-dnd', true) ? (0, $9x5mm.blockquoteSharedStylesNew) : (0, $9x5mm.blockquoteSharedStyles), ";", (0, $hp7YN.headingsSharedStyles)(), ";", (0, $fPB6q.ruleSharedStyles)(), ";", (0, $bLfPF.paragraphSharedStyles), ";", (0, $juoPd.listsSharedStyles), ";", (0, $8VeKB.indentationSharedStyles), ";", (0, $i2OhI.blockMarksSharedStyles), ";", (0, $6GESD.codeMarkSharedStyles)(), ";", (0, $c1Qps.shadowSharedStyle), ";", (0, $izEcn.dateSharedStyle), ";", (0, $lGBd6.textColorStyles), ";", (0, $1TZMa.backgroundColorStyles)(), ";", (0, $6lAd7.tasksAndDecisionsStyles), ";", (0, $cDyCO.smartCardSharedStyles), " ", $224cbf506e249e6d$var$getAnnotationStyles(wrapperProps), " & .UnknownBlock{font-family:", (0, $lcnyw.fontFamily)(), ";font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";font-weight:400;white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, $dMNGz.richMediaClassName), ".rich-media-wrapped+.", (0, $dMNGz.richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, $dMNGz.richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, $dMNGz.richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, $dMNGz.richMediaClassName), ".image-align-start,.", (0, $dMNGz.richMediaClassName), ".image-center,.", (0, $dMNGz.richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $224cbf506e249e6d$var$alignedHeadingAnchorStyle(wrapperProps), (0, $dMNGz.mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, $ghgHw.RendererCssClassName).DOCUMENT, ">{", $224cbf506e249e6d$var$breakoutWidthStyle(), " * .", (0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, $ghgHw.RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, $ghgHw.RendererCssClassName).DOCUMENT, "{.", (0, $ghgHw.RendererCssClassName).EXTENSION, "{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";}.", (0, $ghgHw.RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, $1JeZT.shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, $mJhHc.tableSharedStyle)(), " .", (0, $ghgHw.RendererCssClassName).DOCUMENT, " .", (0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, $8AkRK.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $8AkRK.shadowClassNames).LEFT_SHADOW, "::before{top:", (0, $mJhHc.tableMarginTop) - 1, "px;height:calc(100% - ", (0, $mJhHc.tableMarginTop), "px);z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), ";}", $224cbf506e249e6d$var$getShadowOverrides(), " & .", (0, $1JeZT.shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, $1JeZT.shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, $mJhHc.tableMarginTop), "px);}table{height:1px;", $224cbf506e249e6d$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}table tr:first-of-type{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, $ghgHw.RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, $25FYC.akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";width:", (0, $25FYC.akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$f563ee71e9ee74cd})`, ";font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";}.fixed .", (0, $ghgHw.RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $224cbf506e249e6d$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, $igoil.getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", (0, $3CrqS.columnLayoutSharedStyle), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:var(--ds-space-400, 32px);}@media screen and (max-width: ", (0, $25FYC.gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, $25FYC.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $cDyCO.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $jMQbs.browser).safari ? (0, $9SSfJ.codeBlockInListSafariFix) : '', ";}");
    };
const $224cbf506e249e6d$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
    if (codeBlockRenderAsBlock) return '';
    return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
};

});
parcelRegister("33dUZ", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $0e005f327ee86521$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $0e005f327ee86521$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $0e005f327ee86521$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $0e005f327ee86521$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $0e005f327ee86521$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $0e005f327ee86521$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $0e005f327ee86521$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "interactiveStyle", () => $0e005f327ee86521$export$ac950970e139031e);
$parcel$export(module.exports, "borderStyle", () => $0e005f327ee86521$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $2OD79 = parcelRequire("2OD79");
function $0e005f327ee86521$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e005f327ee86521$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $0e005f327ee86521$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $0e005f327ee86521$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $0e005f327ee86521$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $0e005f327ee86521$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $byn9U.css)(">.mediaInlineView-content-wrap>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $0e005f327ee86521$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $0e005f327ee86521$export$dee15762144889b7 = /*#__PURE__*/ (0, $byn9U.css)(".", $0e005f327ee86521$export$dd2e16f83ae6aa78, "{height:", (0, $2OD79.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h1'], -3), ";}h2{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h2'], -3), ";}h3{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h3'], -2), ";}h4{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h4'], -2), ";}h5{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h5'], -2), ";}h6{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h6'], -2), ";}");
const $0e005f327ee86521$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$0e005f327ee86521$export$7ab34e219ce6eef}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $0e005f327ee86521$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
    outline: 'none'
});
const $0e005f327ee86521$export$ac950970e139031e = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $0e005f327ee86521$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(${$0e005f327ee86521$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$0e005f327ee86521$export$263a8a844c370a89}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$0e005f327ee86521$export$263a8a844c370a89}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("2OD79", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $d7d59ee2afa625fe$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $d7d59ee2afa625fe$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $d7d59ee2afa625fe$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $d7d59ee2afa625fe$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $d7d59ee2afa625fe$export$c1317a9224e4d798);

var $4lTFP = parcelRequire("4lTFP");
const $d7d59ee2afa625fe$export$d722b7527b1834a8 = 250;
const $d7d59ee2afa625fe$export$da894f7669b4e67c = 200;
const $d7d59ee2afa625fe$export$286cf28b87ad4b4f = $d7d59ee2afa625fe$export$d722b7527b1834a8 / $d7d59ee2afa625fe$export$da894f7669b4e67c;
const $d7d59ee2afa625fe$export$64fe09732fb8680 = 0;
const $d7d59ee2afa625fe$export$c1317a9224e4d798 = {
    p: (0, $4lTFP.headingSizes).h600.lineHeight - 2,
    h1: (0, $4lTFP.headingSizes).h800.lineHeight + 4,
    h2: (0, $4lTFP.headingSizes).h700.lineHeight + 3,
    h3: (0, $4lTFP.headingSizes).h600.lineHeight + 1,
    h4: (0, $4lTFP.headingSizes).h500.lineHeight + 3,
    h5: (0, $4lTFP.headingSizes).h400.lineHeight + 4,
    h6: (0, $4lTFP.headingSizes).h300.lineHeight + 2
};

});


parcelRegister("1TZMa", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $315666ebd5cb3646$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $315666ebd5cb3646$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $315666ebd5cb3646$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $315666ebd5cb3646$export$e4cca17cf56e99d = ()=>{
    return $315666ebd5cb3646$var$_ref;
};

});

parcelRegister("i2OhI", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $0f0fb00286f19d22$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0f0fb00286f19d22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f0fb00286f19d22$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("9x5mm", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $6a19a22e227ae8f2$export$1b5f3b43e6c4a8ee);
$parcel$export(module.exports, "blockquoteSharedStylesNew", () => $6a19a22e227ae8f2$export$323af2272e43df46);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $6a19a22e227ae8f2$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        clear: 'both',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $25FYC.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        }
    }
});
const $6a19a22e227ae8f2$export$323af2272e43df46 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        clear: 'both',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-250, 20px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $25FYC.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        }
    }
});

});

parcelRegister("6GESD", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $494b32cd7dbfd86c$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("dl0RD");
var $gamSa = parcelRequire("gamSa");

const $494b32cd7dbfd86c$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $gamSa.getCodeStyles)()
        }
    });
};

});
parcelRegister("dl0RD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70258a1be0ad4f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getCodeStyles", () => (parcelRequire("gamSa")).getCodeStyles);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $hve4P = parcelRequire("hve4P");

var $hyA5S = parcelRequire("hyA5S");

var $gamSa = parcelRequire("gamSa");
function $a70258a1be0ad4f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ var $a70258a1be0ad4f6$var$_ref = {
    name: "ymjjg4",
    styles: "display:inline;padding:2px 0.5ch;background-color:var(--ds-background-neutral, #091E420F);border-radius:var(--ds-border-radius, 3px);border-style:none;box-decoration-break:clone;color:var(--ds-text, #172B4D);font:var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace);line-height:inherit;overflow:auto;overflow-wrap:break-word;white-space:pre-wrap"
};
const $a70258a1be0ad4f6$var$Code = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const styles = (0, $XHGTv.fg)('platform_design_system_team_code_new_typography') ? $a70258a1be0ad4f6$var$_ref : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $gamSa.getCodeStyles)());
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: styles,
        ...otherProps
    }, decoratedChildren));
}));
function $a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $hyA5S.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hve4P.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($a70258a1be0ad4f6$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, replacedChildren);
}
function $a70258a1be0ad4f6$var$isReactElement(child) {
    return !!child.type;
}
$a70258a1be0ad4f6$var$Code.displayName = 'Code';
var $a70258a1be0ad4f6$export$2e2bcd8739ae039 = $a70258a1be0ad4f6$var$Code;

});
parcelRegister("hve4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cee3a28ff2903e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $hqCgH = parcelRequire("hqCgH");
function $0cee3a28ff2903e3$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        tag: $0cee3a28ff2903e3$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $0cee3a28ff2903e3$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("hqCgH", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $bffbd99dc2ca2fb8$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $lkPEe = parcelRequire("lkPEe");
const $bffbd99dc2ca2fb8$var$decoration = /*#__PURE__*/ (0, $byn9U.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $bffbd99dc2ca2fb8$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $bffbd99dc2ca2fb8$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $byn9U.jsx)("mark", null, bidiCharacterCode)));
}
function $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("hyA5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a6695c0dcb062d$export$2e2bcd8739ae039);
const $d4a6695c0dcb062d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $d4a6695c0dcb062d$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($d4a6695c0dcb062d$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gamSa", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $9564a2d27c68447a$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $9564a2d27c68447a$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $9564a2d27c68447a$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iUo9q = parcelRequire("iUo9q");

var $bQ0Ef = parcelRequire("bQ0Ef");
const $9564a2d27c68447a$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $9564a2d27c68447a$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $iUo9q.SPACING}px !important`,
        paddingLeft: (0, $iUo9q.SPACING),
        marginRight: (0, $iUo9q.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $9564a2d27c68447a$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: 'bold'
            }
        }
    });
const $9564a2d27c68447a$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $iUo9q.CODE_FONT_SIZE),
        fontFamily: theme.fontFamily,
        fontWeight: 'normal',
        backgroundColor: `var(${0, $iUo9q.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $9564a2d27c68447a$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $iUo9q.SPACING}px 0` : (0, $iUo9q.SPACING),
                tabSize: 4
            },
            display: 'flex',
            lineHeight: (0, $iUo9q.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$9564a2d27c68447a$export$ee58a26b5d612ac1(theme),
            ...$9564a2d27c68447a$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $9564a2d27c68447a$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                marginRight: `-${0, $iUo9q.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $iUo9q.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $iUo9q.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $9564a2d27c68447a$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $bQ0Ef.getBaseTheme)();
    const baseStyles = $9564a2d27c68447a$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $9564a2d27c68447a$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $bQ0Ef.getBaseTheme)(),
        ...(0, $bQ0Ef.getColorPalette)(),
        lineNumberWidth: maxLines ? $9564a2d27c68447a$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("iUo9q", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $fb842dc45fcee8c3$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $fb842dc45fcee8c3$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $fb842dc45fcee8c3$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $fb842dc45fcee8c3$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $fb842dc45fcee8c3$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $fb842dc45fcee8c3$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $fb842dc45fcee8c3$export$431ac46d758d98c8 = 12;
const $fb842dc45fcee8c3$export$8e3c04032121c606 = '20px';
const $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e = '4px';
const $fb842dc45fcee8c3$export$82ea42e772d49e5b = (0, $lcnyw.gridSize)();
const $fb842dc45fcee8c3$export$eeeea0ff98e06fff = $fb842dc45fcee8c3$export$82ea42e772d49e5b * 2;
const $fb842dc45fcee8c3$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $fb842dc45fcee8c3$export$1758fda69688282e = '--ds--code--bg-color';
const $fb842dc45fcee8c3$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("bQ0Ef", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $531c36e6ab7cba4e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $531c36e6ab7cba4e$export$fe2a6478976e8b17);

var $5iWql = parcelRequire("5iWql");


var $lcnyw = parcelRequire("lcnyw");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $531c36e6ab7cba4e$var$T800 = '#067384';
const $531c36e6ab7cba4e$var$Y1100 = '#7A5D1A';
const $531c36e6ab7cba4e$export$4464aa303b3e4fda = ()=>({
        fontFamily: (0, $lcnyw.codeFontFamily)(),
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $lcnyw.codeFontFamily)()}`,
        backgroundColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`
    });
const $531c36e6ab7cba4e$export$7136e5d021a38178 = $531c36e6ab7cba4e$export$4464aa303b3e4fda();
const $531c36e6ab7cba4e$export$fe2a6478976e8b17 = (0, $5iWql.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`
    };
});
const $531c36e6ab7cba4e$var$getTheme = ()=>({
        ...$531c36e6ab7cba4e$export$4464aa303b3e4fda(),
        ...$531c36e6ab7cba4e$export$fe2a6478976e8b17()
    });
var $531c36e6ab7cba4e$export$2e2bcd8739ae039 = $531c36e6ab7cba4e$var$getTheme;

});




parcelRegister("3CrqS", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $934e9631ae78eb9d$export$6891a39948814a80);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $934e9631ae78eb9d$export$6891a39948814a80 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $25FYC.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});

});

parcelRegister("izEcn", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $2966a11c67f1dc9b$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $2966a11c67f1dc9b$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $2966a11c67f1dc9b$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $2966a11c67f1dc9b$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$2966a11c67f1dc9b$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("hp7YN", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $b6534361ec439a17$export$9272613b68afed4b);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4lTFP = parcelRequire("4lTFP");
const $b6534361ec439a17$export$9272613b68afed4b = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h1': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h700)(),
            marginBottom: 0,
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h2': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h600)(),
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h3': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h500)(),
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h4': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h400)(),
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h5': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h300)(),
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h6': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h100)(),
            marginTop: '1.455em',
            textTransform: 'none'
        }
    });

});

parcelRegister("8VeKB", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $62390827e5c3730a$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $62390827e5c3730a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $62390827e5c3730a$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("dMNGz", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $1119b3f943e4e41c$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $1119b3f943e4e41c$export$d031611b96ba4cf0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $1119b3f943e4e41c$export$cfe6da7d522d87bb = 'rich-media-item';
const $1119b3f943e4e41c$var$wrappedMediaBreakoutPoint = 410;
const $1119b3f943e4e41c$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1119b3f943e4e41c$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("bLfPF", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $01f8be114e0c8342$export$2f49074d75b0e29f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $01f8be114e0c8342$export$2f49074d75b0e29f = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& p': {
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: (0, $25FYC.akEditorLineHeight),
        fontWeight: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: (0, $25FYC.blockNodesVerticalMargin),
        marginBottom: 0,
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("fPB6q", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $03688c0b58412e8b$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

const $03688c0b58412e8b$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $25FYC.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("c1Qps", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $79f1b57345ca8b5a$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");


var $8AkRK = parcelRequire("8AkRK");

var $1JeZT = parcelRequire("1JeZT");
const $79f1b57345ca8b5a$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $79f1b57345ca8b5a$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::before, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $25FYC.akEditorShadowZIndex),
        width: `${$79f1b57345ca8b5a$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${`var(--ds-shadow-overflow-spread, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${`var(--ds-shadow-overflow-spread, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1JeZT.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1JeZT.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("cDyCO", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $4c6292b6b99d2100$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $4c6292b6b99d2100$export$83e107f0a431e184);

var $25FYC = parcelRequire("25FYC");
const $4c6292b6b99d2100$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $4c6292b6b99d2100$export$83e107f0a431e184 = `
  .${$4c6292b6b99d2100$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $25FYC.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;

});

parcelRegister("6lAd7", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $3b7c2ca31535e9f0$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $3b7c2ca31535e9f0$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $3b7c2ca31535e9f0$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item'
};
const $3b7c2ca31535e9f0$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{.taskItemView-content-wrap,.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $25FYC.akEditorLineHeight), "em;}}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $25FYC.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $25FYC.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $25FYC.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("lGBd6", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $0837c408409e9387$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0837c408409e9387$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0837c408409e9387$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("eJ4TL", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $a571a229b95a4cf5$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $a571a229b95a4cf5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a571a229b95a4cf5$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("igoil", function(module, exports) {

$parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", () => $1fb47e1f387902d6$export$3f1ff491ca7c4c4a);
$parcel$export(module.exports, "default", () => $1fb47e1f387902d6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $9SSfJ = parcelRequire("9SSfJ");

var $8Mzh3 = parcelRequire("8Mzh3");

var $ghgHw = parcelRequire("ghgHw");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $1fb47e1f387902d6$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
const $1fb47e1f387902d6$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $1fb47e1f387902d6$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $ghgHw.RendererCssClassName).DOCUMENT, ">.", $1fb47e1f387902d6$export$afbde0e7339bed51.CONTAINER, " .", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";}");
};
const $1fb47e1f387902d6$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $eUqFw.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $8Mzh3.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $1fb47e1f387902d6$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $9SSfJ.codeBlockSharedStyles)(),
            $1fb47e1f387902d6$var$lightWeightCodeBlockStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $byn9U.jsx)("code", null, renderBidiWarnings(text))))));
});
var $1fb47e1f387902d6$export$2e2bcd8739ae039 = $1fb47e1f387902d6$var$LightWeightCodeBlock;

});
parcelRegister("8Mzh3", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $2b26be7b9b8b2e65$export$9fb9fe546a188c7b);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hve4P = parcelRequire("hve4P");

var $hl0Ug = parcelRequire("hl0Ug");

var $hyA5S = parcelRequire("hyA5S");
const $2b26be7b9b8b2e65$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $5JgJ2.default)();
    const warningLabel = intl.formatMessage((0, $hl0Ug.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $hyA5S.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hve4P.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


const $2965d2199c43f228$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;


parcelRegister("bIQK1", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $ae9592fb5e3881d8$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $ae9592fb5e3881d8$export$1e4baea7053fc0e3);

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");
var $byxO6 = parcelRequire("byxO6");

var $4q38b = parcelRequire("4q38b");

var $8DyOy = parcelRequire("8DyOy");

var $bNZ6o = parcelRequire("bNZ6o");

var $izVyo = parcelRequire("izVyo");

var $3rMck = parcelRequire("3rMck");

var $auyn4 = parcelRequire("auyn4");

var $ghgHw = parcelRequire("ghgHw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $drghF = parcelRequire("drghF");
const $ae9592fb5e3881d8$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $ae9592fb5e3881d8$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return (0, $8DyOy.SortOrder).ASC;
        case (0, $8DyOy.SortOrder).ASC:
            return (0, $8DyOy.SortOrder).DESC;
        case (0, $8DyOy.SortOrder).DESC:
            return (0, $8DyOy.SortOrder).NO_ORDER;
    }
    return (0, $8DyOy.SortOrder).NO_ORDER;
};
const $ae9592fb5e3881d8$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $drghF.tableCellMessages);
    switch(currentSortOrder){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $ae9592fb5e3881d8$var$getDataAttributes = (colwidth, background)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
const $ae9592fb5e3881d8$var$cssVariablePattern = /^var\(--.*\)$/;
const $ae9592fb5e3881d8$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $bNZ6o.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $ae9592fb5e3881d8$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $as9OS.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $ae9592fb5e3881d8$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $4q38b.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $byxO6.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $ae9592fb5e3881d8$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$ae9592fb5e3881d8$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort
        }, children);
    };
};
const $ae9592fb5e3881d8$var$TH = $ae9592fb5e3881d8$var$getWithCellProps('th');
const $ae9592fb5e3881d8$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $5JgJ2.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $8DyOy.SortOrder).NO_ORDER ? (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $ae9592fb5e3881d8$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izVyo.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$ae9592fb5e3881d8$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $ae9592fb5e3881d8$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).SORT_COLUMN,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $3rMck.PLATFORM).WEB,
                        mode: (0, $3rMck.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    mode: (0, $3rMck.MODE).RENDERER
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            });
        }
    };
};
const $ae9592fb5e3881d8$export$f850895b287ef28e = $ae9592fb5e3881d8$export$cfca40ca5c56a38e($ae9592fb5e3881d8$var$TH);
const $ae9592fb5e3881d8$var$TD = $ae9592fb5e3881d8$var$getWithCellProps('td');
const $ae9592fb5e3881d8$export$1e4baea7053fc0e3 = $ae9592fb5e3881d8$var$TD;

});
parcelRegister("izVyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $796bee0c360b8d27$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $XHGTv = parcelRequire("XHGTv");


var $8cU5f = parcelRequire("8cU5f");

var $8DyOy = parcelRequire("8DyOy");


var $9UY0g = parcelRequire("9UY0g");
function $796bee0c360b8d27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $796bee0c360b8d27$var$annotationRangeFixStyle = {
    name: "oldbq4",
    styles: "user-select:none"
};
var $796bee0c360b8d27$export$c3618f310f725028;
(function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
})($796bee0c360b8d27$export$c3618f310f725028 || ($796bee0c360b8d27$export$c3618f310f725028 = {}));
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $796bee0c360b8d27$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:", `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`, ";justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:", `var(--ds-surface-overlay-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`, ";}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $796bee0c360b8d27$var$iconWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $796bee0c360b8d27$var$iconStyles = {
    name: "1uj2pwb",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $796bee0c360b8d27$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $8DyOy.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $2965d2199c43f228$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $8DyOy.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $796bee0c360b8d27$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $9UY0g.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $796bee0c360b8d27$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $9UY0g.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $796bee0c360b8d27$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $2965d2199c43f228$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $8DyOy.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $2965d2199c43f228$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $796bee0c360b8d27$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $796bee0c360b8d27$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $796bee0c360b8d27$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $796bee0c360b8d27$var$iconStyles,
            (0, $XHGTv.fg)('platform_editor_allow_annotation_triple_click') && $796bee0c360b8d27$var$annotationRangeFixStyle
        ]
    }))));
};
var $796bee0c360b8d27$export$2e2bcd8739ae039 = (0, $2qhQi.default)($796bee0c360b8d27$var$SortingIcon);

});
parcelRegister("9UY0g", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $7a4513affbf7abf6$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $7a4513affbf7abf6$export$f142573f51a67577);

var $90IgZ = parcelRequire("90IgZ");
const $7a4513affbf7abf6$export$458c50917513cd1a = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $7a4513affbf7abf6$export$f142573f51a67577 = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("2dNsW", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $51ce6dfb65debd17$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $51ce6dfb65debd17$export$65e2d5a272a382b0);

var $eUqFw = parcelRequire("eUqFw");
const $51ce6dfb65debd17$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new Map());
const $51ce6dfb65debd17$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51ce6dfb65debd17$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $51ce6dfb65debd17$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51ce6dfb65debd17$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};

});

parcelRegister("8GvDy", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $6c193b8ede21e024$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $6c193b8ede21e024$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $6c193b8ede21e024$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");


var $5pCn0 = parcelRequire("5pCn0");

var $dAsgR = parcelRequire("dAsgR");
function $6c193b8ede21e024$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6c193b8ede21e024$export$3de6413b528017ca = 8;
const $6c193b8ede21e024$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// TODO: Quality ticket: https://product-fabric.atlassian.net/browse/DSP-4123
const $6c193b8ede21e024$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $25FYC.akEditorStickyHeaderZIndex);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)(typeof top === 'number' && `top: ${top}px;`, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: stickyHeaderZIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $mJhHc.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            marginTop: 0,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            tr: {
                background: "var(--ds-surface, white)"
            }
        },
        borderTop: `${$6c193b8ede21e024$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
        background: "var(--ds-surface-overlay, white)",
        boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "div[data-expanded='false'] &": {
            display: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
            top: '0px',
            height: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&.fixed-table-div-custom-table-resizing[mode='stick']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: stickyHeaderZIndex
        }
    });
};
const $6c193b8ede21e024$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    const fixedTableCss = [
        $6c193b8ede21e024$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
        $6c193b8ede21e024$var$modeSpecficStyles?.[mode]
    ];
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: fixedTableCss
    }, props.children);
};
const $6c193b8ede21e024$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $byn9U.jsx)($6c193b8ede21e024$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $mJhHc.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5pCn0.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $dAsgR.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 */ function $6c193b8ede21e024$var$findHorizontalOverflowScrollParent(table) {
    let parent = table;
    if (!parent) return null;
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
    }
    return null;
}
class $6c193b8ede21e024$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    static fromElement(el) {
        return new $6c193b8ede21e024$export$e97bc6692974bd0b($6c193b8ede21e024$var$findHorizontalOverflowScrollParent(el) || window);
    }
    get isElement() {
        return this.ref instanceof HTMLElement;
    }
    get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    addEventListener(type, cb, ...args) {
        this.ref.addEventListener(type, cb, ...args);
    }
    removeEventListener(type, cb, ...args) {
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("5pCn0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $d1450a2ad961c3d0$export$54ec01a60f47d33d);

var $eUqFw = parcelRequire("eUqFw");

var $7LRgQ = parcelRequire("7LRgQ");

var $2JJ1l = parcelRequire("2JJ1l");

var $25FYC = parcelRequire("25FYC");
const $d1450a2ad961c3d0$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing })=>{
    let tableWidth = tableNode ? (0, $2JJ1l.getTableContainerWidth)(tableNode) : (0, $25FYC.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LRgQ.Colgroup), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, children));
});

});
parcelRegister("7LRgQ", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $f7bcc0c4e516d135$export$89efc2d0ceeaa030);

var $eUqFw = parcelRequire("eUqFw");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $2JJ1l = parcelRequire("2JJ1l");

var $XHGTv = parcelRequire("XHGTv");

var $aSvLw = parcelRequire("aSvLw");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT = 0.3;
const $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $f7bcc0c4e516d135$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $f7bcc0c4e516d135$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $mJhHc.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $mJhHc.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $25FYC.akEditorTableLegacyCellMinWidth) : (0, $mJhHc.tableCellMinWidth));
};
const $f7bcc0c4e516d135$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $25FYC.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $25FYC.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $f7bcc0c4e516d135$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $f7bcc0c4e516d135$var$renderScaleDownColgroup = (props)=>{
    let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $f7bcc0c4e516d135$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width ? renderWidth : (0, $2JJ1l.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $f7bcc0c4e516d135$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $mJhHc.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $mJhHc.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $25FYC.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $25FYC.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled && (0, $XHGTv.fg)('platform.editor.table.use-increased-scaling-percent') ? $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $25FYC.akEditorTableLegacyCellMinWidth) ? (0, $25FYC.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $f7bcc0c4e516d135$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $f7bcc0c4e516d135$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $f7bcc0c4e516d135$export$89efc2d0ceeaa030 = (props)=>{
    let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $aSvLw.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $f7bcc0c4e516d135$var$renderScaleDownColgroup({
        ...props,
        isTableScalingEnabled: !!(flags && 'tablePreserveWidth' in flags && flags.tablePreserveWidth),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption)
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $25FYC.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
            key: idx,
            style: style
        })));
};

});
parcelRegister("aSvLw", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $28a890e9aac82cf9$export$90335b3ff08f335);

var $0jEfW = parcelRequire("0jEfW");
const $28a890e9aac82cf9$export$90335b3ff08f335 = ()=>(0, $0jEfW.useRendererContext)()?.featureFlags;

});
parcelRegister("0jEfW", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $d436489e1336a0a8$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $d436489e1336a0a8$export$ca5df47902194781);

var $eUqFw = parcelRequire("eUqFw");
const $d436489e1336a0a8$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $d436489e1336a0a8$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($d436489e1336a0a8$var$RendererContext);
const $d436489e1336a0a8$export$ca5df47902194781 = $d436489e1336a0a8$var$RendererContext.Provider;

});




parcelRegister("dAsgR", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $914d0966c8d84305$export$40e12ce8e0a76b0c);

var $eUqFw = parcelRequire("eUqFw");
function $914d0966c8d84305$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            children: $914d0966c8d84305$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("5IOJr", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $4ca9a9ced50544ff$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $4ca9a9ced50544ff$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $4ca9a9ced50544ff$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $4ca9a9ced50544ff$export$33331a99fac775a1);
const $4ca9a9ced50544ff$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $4ca9a9ced50544ff$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $4ca9a9ced50544ff$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $4ca9a9ced50544ff$export$33331a99fac775a1 = (appearance)=>$4ca9a9ced50544ff$export$a64737a81cde10b4(appearance) || $4ca9a9ced50544ff$export$c0112b8340d4924b(appearance);

});


parcelRegister("eFI96", function(module, exports) {

$parcel$export(module.exports, "default", () => $95840539bf259587$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iYHWS = parcelRequire("iYHWS");

var $8DyOy = parcelRequire("8DyOy");

var $ghgHw = parcelRequire("ghgHw");
class $95840539bf259587$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            className: (0, $ghgHw.RendererCssClassName).NUMBER_COLUMN
        }, this.props.index), (0, $iYHWS.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args);
        this.state = {
            colGroupWidths: []
        };
        this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            if (allowColumnSorting) {
                const isHeaderRow = !rowIndex;
                childrenArray = childrenArray.map((child, index)=>{
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) {
                        const { tableOrderStatus: tableOrderStatus } = this.props;
                        let sortOrdered = (0, $8DyOy.SortOrder).NO_ORDER;
                        if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $8DyOy.SortOrder).NO_ORDER;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                            columnIndex: index,
                            onSorting: this.props.onSorting,
                            sortOrdered: sortOrdered,
                            isHeaderRow: isHeaderRow
                        });
                    }
                });
            }
            return childrenArray;
        };
        this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("7GWuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aa19c407521dacd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $7aa19c407521dacd$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("SceRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6545cc1fcc87ffd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");


var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $auyn4 = parcelRequire("auyn4");

var $jlmhn = parcelRequire("jlmhn");

var $2pBoL = parcelRequire("2pBoL");

var $fwrz2 = parcelRequire("fwrz2");
const $c6545cc1fcc87ffd$var$inlineNodeStyle = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    background: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    border: `1px dashed ${`var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $c6545cc1fcc87ffd$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fwrz2.getUnsupportedContent)((0, $jlmhn.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $jlmhn.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $2pBoL.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $c6545cc1fcc87ffd$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    }))));
};
var $c6545cc1fcc87ffd$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c6545cc1fcc87ffd$var$UnsupportedInlineNode);

});

parcelRegister("gpZYi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3xOzk").then(()=>parcelRequire('iG4VC'));

});

parcelRegister("iEWVs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6Fj3f").then(()=>parcelRequire('gfKzF'));

});

parcelRegister("i3Opd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ezj2q").then(()=>parcelRequire('lqYEs'));

});

parcelRegister("3g0C9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("7RqT5")
]).then(()=>parcelRequire('9WngA'));

});

parcelRegister("6Aliz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("61wTT").then(()=>parcelRequire('aEQmM'));

});

parcelRegister("cYIHp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iuBLh").then(()=>parcelRequire('92FiY'));

});

parcelRegister("3iByu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1lROW").then(()=>parcelRequire('koyU4'));

});

parcelRegister("gUkEv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3ZQaF")
]).then(()=>parcelRequire('b5oht'));

});

parcelRegister("kHiNO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iNpPm").then(()=>parcelRequire('lFdD2'));

});

parcelRegister("hvLpG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3Qpga").then(()=>parcelRequire('5Av7A'));

});

parcelRegister("6XJJV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("okTix")
]).then(()=>parcelRequire('358j8'));

});

parcelRegister("cuAI3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("655BX")
]).then(()=>parcelRequire('7aetn'));

});

parcelRegister("fHKNN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("1xrTu")
]).then(()=>parcelRequire('7DTTy'));

});

parcelRegister("8LqfX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bbbuZ").then(()=>parcelRequire('amerF'));

});

parcelRegister("6zJGv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c8Dgp").then(()=>parcelRequire('24XFv'));

});

parcelRegister("i8wC6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("f6tBu")
]).then(()=>parcelRequire('2nIQG'));

});

parcelRegister("cS1xX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eK2pl").then(()=>parcelRequire('2DI79'));

});

parcelRegister("1jSHp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("zMxKU")
]).then(()=>parcelRequire('4UCtC'));

});

parcelRegister("e1yon", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("fGRiM")
]).then(()=>parcelRequire('foh2b'));

});


parcelRegister("3OTv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a602b0c59c0475$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $60fwk = parcelRequire("60fwk");
const $07a602b0c59c0475$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60fwk.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $07a602b0c59c0475$export$2e2bcd8739ae039 = $07a602b0c59c0475$var$TextWrapper;

});
parcelRegister("60fwk", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $6059897edc992844$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9DvHC = parcelRequire("9DvHC");

var $hM6XC = parcelRequire("hM6XC");

var $e7OQ8 = parcelRequire("e7OQ8");

var $gGtOE = parcelRequire("gGtOE");

var $5uTcm = parcelRequire("5uTcm");

var $j6rwF = parcelRequire("j6rwF");

var $4QHKY = parcelRequire("4QHKY");

var $fvSxt = parcelRequire("fvSxt");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $6059897edc992844$var$markStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $j6rwF.AnnotationSharedCSSByState)().common, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $j6rwF.AnnotationSharedCSSByState)().focus);
const $6059897edc992844$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $5uTcm.dataAttributes)(draftPosition),
        css: $6059897edc992844$var$markStyles
    }, children);
};
const $6059897edc992844$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $9DvHC.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $9DvHC.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $9DvHC.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $6059897edc992844$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $6059897edc992844$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $4QHKY.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return /*#__PURE__*/ (0, $byn9U.jsx)($6059897edc992844$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
    });
};
const $6059897edc992844$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $hM6XC.AnnotationsDraftContext));
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $gGtOE.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $e7OQ8.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $4QHKY.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $9DvHC.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $4QHKY.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $byn9U.jsx)($6059897edc992844$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $e7OQ8.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $e7OQ8.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $4QHKY.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $6059897edc992844$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, components);
};

});
parcelRegister("9DvHC", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $ab5f93f7b05cb8d0$export$c1bd4813440b4505);
var $ab5f93f7b05cb8d0$export$c1bd4813440b4505;
(function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
})($ab5f93f7b05cb8d0$export$c1bd4813440b4505 || ($ab5f93f7b05cb8d0$export$c1bd4813440b4505 = {}));

});

parcelRegister("hM6XC", function(module, exports) {

$parcel$export(module.exports, "AnnotationsDraftContext", () => $590117c6b16bec59$export$365d1799d81a236d);
$parcel$export(module.exports, "ProvidersContext", () => $590117c6b16bec59$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $590117c6b16bec59$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $590117c6b16bec59$export$153126608e00390);

var $eUqFw = parcelRequire("eUqFw");
const $590117c6b16bec59$export$365d1799d81a236d = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $590117c6b16bec59$export$6a26b015ac619737 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $590117c6b16bec59$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $eUqFw.createContext)({});
class $590117c6b16bec59$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($590117c6b16bec59$export$365d1799d81a236d.Provider, {
            value: position
        }, children({
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            position: null
        };
        this.applyAnnotationDraftAt = (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        };
        this.clearAnnotationDraft = ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        };
    }
}

});

parcelRegister("e7OQ8", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $3b454e3a573d3685$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $3b454e3a573d3685$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $3b454e3a573d3685$export$1059bfc467f4f55d);

var $eUqFw = parcelRequire("eUqFw");
const $3b454e3a573d3685$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($3b454e3a573d3685$var$isReactElement(childNode) && childNode.props.children) result = $3b454e3a573d3685$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $3b454e3a573d3685$var$isReactElement(child) {
    return !!child.type;
}
const $3b454e3a573d3685$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $3b454e3a573d3685$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("gGtOE", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $aae0540f8d212f73$export$b1baddbd5f289877);

var $9DvHC = parcelRequire("9DvHC");
const $aae0540f8d212f73$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $9DvHC.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $9DvHC.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $9DvHC.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $9DvHC.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("5uTcm", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $7a9e7bfcd1b1e667$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $7a9e7bfcd1b1e667$export$e14699d956e87e73);
const $7a9e7bfcd1b1e667$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $7a9e7bfcd1b1e667$var$buildDataAttributesQuery = (pos)=>{
    const a = $7a9e7bfcd1b1e667$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $7a9e7bfcd1b1e667$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($7a9e7bfcd1b1e667$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("j6rwF", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $fa3ae464b5020ffc$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $fa3ae464b5020ffc$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $fa3ae464b5020ffc$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $fa3ae464b5020ffc$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

const $fa3ae464b5020ffc$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $fa3ae464b5020ffc$export$b0aeb22a160e5b4c = {
    focus: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-focus`,
    blur: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-blur`,
    draft: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-draft`
};
const $fa3ae464b5020ffc$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $fa3ae464b5020ffc$export$ac15f3ad21fefeac = {
    focus: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-focus`,
    blur: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-blur`,
    draft: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-draft`
};
const $fa3ae464b5020ffc$var$Yellow100 = 'rgb(255, 247, 214)';
const $fa3ae464b5020ffc$var$Y200a = 'rgba(255, 196, 0, 0.82)';
const $fa3ae464b5020ffc$export$261ebe180da42726 = ()=>{
    if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $XHGTv.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${`var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`
        }),
        blur: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$fa3ae464b5020ffc$var$Yellow100})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`
        })
    };
    else return {
        focus: /*#__PURE__*/ (0, $byn9U.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$export$41060a744ab0b7ae)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`}`,
            // TODO: https://product-fabric.atlassian.net/browse/DSP-4147
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$fa3ae464b5020ffc$var$Yellow100})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`}`,
            cursor: 'pointer'
        })
    };
};
const $fa3ae464b5020ffc$export$5f72fe1d39f8129b = ()=>(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $byn9U.css)(".ProseMirror{.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, ",.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, ",.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().common, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";cursor:initial;}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, "{", $fa3ae464b5020ffc$export$261ebe180da42726().blur, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $byn9U.css)(".ProseMirror{.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";cursor:initial;}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, "{", $fa3ae464b5020ffc$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("4QHKY", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $d5d1d56c1f3d5a17$export$93301b6f1ff0b0c3);
function $d5d1d56c1f3d5a17$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("fvSxt", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $af4a012340e55cd1$export$8a20fd0614851c5f);

var $eUqFw = parcelRequire("eUqFw");
function $af4a012340e55cd1$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-highlighted": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            key: `${segment.text}_${startPos}_${idx}`,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}

});



parcelRegister("jxP5v", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $e461add4b299b195$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $e461add4b299b195$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $kgIht = parcelRequire("kgIht");
const $e461add4b299b195$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $e461add4b299b195$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $ht6w1.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgIht.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: id,
        ...data
    }, children);
};
var $e461add4b299b195$export$2e2bcd8739ae039 = $e461add4b299b195$var$AnnotationComponent;

});
parcelRegister("kgIht", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $d21042c0f3a68a92$export$f3069f755c1eba0b);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $1DD45 = parcelRequire("1DD45");

var $7EYt1 = parcelRequire("7EYt1");
var $lzDkm = parcelRequire("lzDkm");
var $fX449 = parcelRequire("fX449");

var $hM6XC = parcelRequire("hM6XC");

var $3DXMd = parcelRequire("3DXMd");
const $d21042c0f3a68a92$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $fX449.useInlineCommentSubscriberContext)();
    const states = (0, $eUqFw.useContext)((0, $hM6XC.InlineCommentsStateContext));
    const hasFocus = (0, $7EYt1.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $eUqFw.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const onClick = (0, $eUqFw.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        updateSubscriber.emit((0, $3DXMd.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel
    ]);
    const activeParentIds = (0, $lzDkm.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $ht6w1.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DD45.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("1DD45", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $336011f89b3a559a$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8tM2T = parcelRequire("8tM2T");

var $j6rwF = parcelRequire("j6rwF");

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $drghF = parcelRequire("drghF");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState` is not object-safe
const $336011f89b3a559a$var$markStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, $ht6w1.AnnotationMarkStates).ACTIVE, "']{", (0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? (0, $j6rwF.AnnotationSharedCSSByState)().common : '', " ", (0, $j6rwF.AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, $j6rwF.AnnotationSharedCSSByState)().focus, ";}}");
const $336011f89b3a559a$var$isMobile = ()=>{
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $336011f89b3a559a$var$accessibilityStyles = (startMarker, endMarker)=>/*#__PURE__*/ (0, $byn9U.css)({
        '&::before, &::after': {
            clipPath: 'inset(100%)',
            clip: 'rect(1px, 1px, 1px, 1px)',
            height: '1px',
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px'
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${startMarker}] '`
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${endMarker}] '`
        }
    });
const $336011f89b3a559a$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const isInlineCommentsKbAccessible = (0, $8tM2T.default).checkGate('inline_comments_keyboard_accessible_renderer');
    const intl = (0, $5JgJ2.default)();
    const annotationIds = (0, $eUqFw.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const onMarkClick = (0, $eUqFw.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $ht6w1.AnnotationMarkStates).ACTIVE) return;
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus
    };
    const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $336011f89b3a559a$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    } : {};
    const accessibility = state !== (0, $ht6w1.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    const getAccessibilityStyles = ()=>{
        if ($336011f89b3a559a$var$isMobile()) return {};
        if (isInlineCommentsKbAccessible && state !== (0, $ht6w1.AnnotationMarkStates).RESOLVED) {
            const startMarker = intl.formatMessage((0, $drghF.inlineCommentMessages).contentRendererInlineCommentMarkerStart);
            const endMarker = intl.formatMessage((0, $drghF.inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
            return $336011f89b3a559a$var$accessibilityStyles(startMarker, endMarker);
        } else return {};
    };
    return (0, $byn9U.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $336011f89b3a559a$var$markStyles,
                getAccessibilityStyles()
            ]
        }
    }, children);
};

});

parcelRegister("7EYt1", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $f9406be79cf3cc6d$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $f9406be79cf3cc6d$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $f9406be79cf3cc6d$export$26cf539704e444c1);

var $eUqFw = parcelRequire("eUqFw");

var $3DXMd = parcelRequire("3DXMd");

var $8tM2T = parcelRequire("8tM2T");

var $ht6w1 = parcelRequire("ht6w1");

var $auyn4 = parcelRequire("auyn4");

var $88sYM = parcelRequire("88sYM");
const $f9406be79cf3cc6d$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        return ()=>{
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        };
    }, [
        states,
        type,
        updateSubscriber
    ]);
    return states;
};
const $f9406be79cf3cc6d$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $eUqFw.useState)(false);
    const isInlineCommentsKbAccessible = (0, $8tM2T.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        return ()=>{
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        };
    }, [
        id,
        updateSubscriber,
        isInlineCommentsKbAccessible
    ]);
    return hasFocus;
};
const $f9406be79cf3cc6d$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $eUqFw.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isCommentsOnMediaAnalyticsEnabled: isCommentsOnMediaAnalyticsEnabled } = props;
    const isInlineCommentsKbAccessible = (0, $8tM2T.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $auyn4.ACTION).VIEWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    ...isCommentsOnMediaAnalyticsEnabled && {
                        targetNodeType: eventTargetType,
                        method: viewMethod
                    }
                }
            }).fire((0, $88sYM.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        return ()=>{
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        };
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isCommentsOnMediaAnalyticsEnabled,
        isInlineCommentsKbAccessible
    ]);
    return annotationClickEvent;
};

});

parcelRegister("lzDkm", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $96e3e7352e62ec9e$export$8e7d47f9e38ad4f1);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");
const $96e3e7352e62ec9e$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $eUqFw.useContext)((0, $hM6XC.InlineCommentsStateContext));
    return (0, $eUqFw.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("fX449", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $6e0e66bb5944c119$export$b46737175cffd396);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");
const $6e0e66bb5944c119$export$b46737175cffd396 = ()=>{
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("3Rfkt", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $4802fa6ceee7ed6b$export$d4334b129116aad7);

var $bl9MZ = parcelRequire("bl9MZ");

var $fKWge = parcelRequire("fKWge");

var $5NC3a = parcelRequire("5NC3a");

var $7FrhV = parcelRequire("7FrhV");

var $3czYv = parcelRequire("3czYv");

var $5EI2Z = parcelRequire("5EI2Z");

var $2LYW6 = parcelRequire("2LYW6");

var $jIWxL = parcelRequire("jIWxL");

var $fqJal = parcelRequire("fqJal");

var $3QkG0 = parcelRequire("3QkG0");

var $3ofDw = parcelRequire("3ofDw");

var $cTsEA = parcelRequire("cTsEA");

var $hySUC = parcelRequire("hySUC");

var $dt1Ro = parcelRequire("dt1Ro");

var $9HbLt = parcelRequire("9HbLt");

var $5hADG = parcelRequire("5hADG");

var $jxP5v = parcelRequire("jxP5v");

var $9Pmx7 = parcelRequire("9Pmx7");

var $jKBO7 = parcelRequire("jKBO7");
const $4802fa6ceee7ed6b$export$c00d967a0f56fdb7 = {
    code: (0, $bl9MZ.default),
    em: (0, $fKWge.default),
    link: (0, $5NC3a.default),
    strike: (0, $7FrhV.default),
    strong: (0, $3czYv.default),
    subsup: (0, $5EI2Z.default),
    textColor: (0, $2LYW6.default),
    backgroundColor: (0, $jIWxL.default),
    underline: (0, $fqJal.default),
    annotation: (0, $jxP5v.default),
    border: (0, $9Pmx7.default),
    // Stage0
    confluenceInlineComment: (0, $jKBO7.default),
    breakout: (0, $3QkG0.default),
    alignment: (0, $3ofDw.default),
    indentation: (0, $cTsEA.default),
    unsupportedMark: (0, $hySUC.default),
    unsupportedNodeAttribute: (0, $dt1Ro.default),
    dataConsumer: (0, $9HbLt.default),
    fragment: (0, $5hADG.default)
};
const $4802fa6ceee7ed6b$export$d4334b129116aad7 = (mark)=>{
    return $4802fa6ceee7ed6b$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bl9MZ", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $ee87d0fee0f502c9$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $ee87d0fee0f502c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $dl0RD = parcelRequire("dl0RD");

var $hl0Ug = parcelRequire("hl0Ug");
const $ee87d0fee0f502c9$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $ee87d0fee0f502c9$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $hl0Ug.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dl0RD.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
var $ee87d0fee0f502c9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ee87d0fee0f502c9$export$7cea6ffa7022e85f);

});

parcelRegister("fKWge", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f002b5113a8782$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $80f002b5113a8782$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("5NC3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92b0d1e7af6585c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9oaPg = parcelRequire("9oaPg");

var $3rMck = parcelRequire("3rMck");

var $auyn4 = parcelRequire("auyn4");

var $gP1iJ = parcelRequire("gP1iJ");

var $aw5Sy = parcelRequire("aw5Sy");
const $f92b0d1e7af6585c$var$anchorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`
    }
});
function $f92b0d1e7af6585c$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $9oaPg.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aw5Sy.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gP1iJ.default), {
        css: $f92b0d1e7af6585c$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).VISITED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).LINK,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    mode: (0, $3rMck.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes
    }, props.children));
}

});
parcelRegister("9oaPg", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $b08f4d77e849a46a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $b08f4d77e849a46a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $b08f4d77e849a46a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $b08f4d77e849a46a$export$38b61ebf4950cd39);

var $9wcjJ = parcelRequire("9wcjJ");

var $3M3qX = parcelRequire("3M3qX");
function $b08f4d77e849a46a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $b08f4d77e849a46a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $9wcjJ.defaultSchema));
        this.encode = $b08f4d77e849a46a$var$createEncoder(transformer, new (0, $3M3qX.JSONTransformer)());
    }
}
const $b08f4d77e849a46a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $b08f4d77e849a46a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $b08f4d77e849a46a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $b08f4d77e849a46a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("3M3qX", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $3ad50ef6c4da68ad$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $3ad50ef6c4da68ad$export$98cb1d9308d0944d);

var $hTLlD = parcelRequire("hTLlD");

var $hgVop = parcelRequire("hgVop");
var $8nj7b = parcelRequire("8nj7b");
var $lKuoe = parcelRequire("lKuoe");
var $9iaXL = parcelRequire("9iaXL");
var $3SpHb = parcelRequire("3SpHb");
var $cvCFq = parcelRequire("cvCFq");
var $gN3fl = parcelRequire("gN3fl");
var $fkqTY = parcelRequire("fkqTY");
var $byxO6 = parcelRequire("byxO6");

var $9wcjJ = parcelRequire("9wcjJ");

var $dxv8o = parcelRequire("dxv8o");

var $gbvAY = parcelRequire("gbvAY");
var $3ad50ef6c4da68ad$export$933e6445c497ffd5;
(function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
})($3ad50ef6c4da68ad$export$933e6445c497ffd5 || ($3ad50ef6c4da68ad$export$933e6445c497ffd5 = {}));
const $3ad50ef6c4da68ad$var$isType = (type)=>(node)=>node.type.name === type;
const $3ad50ef6c4da68ad$var$isCodeBlock = $3ad50ef6c4da68ad$var$isType('codeBlock');
const $3ad50ef6c4da68ad$var$isMediaNode = $3ad50ef6c4da68ad$var$isType('media');
const $3ad50ef6c4da68ad$var$isMediaInline = $3ad50ef6c4da68ad$var$isType('mediaInline');
const $3ad50ef6c4da68ad$var$isMediaSingleNode = $3ad50ef6c4da68ad$var$isType('mediaSingle');
const $3ad50ef6c4da68ad$var$isMentionNode = $3ad50ef6c4da68ad$var$isType('mention');
const $3ad50ef6c4da68ad$var$isParagraph = $3ad50ef6c4da68ad$var$isType('paragraph');
const $3ad50ef6c4da68ad$var$isHeading = $3ad50ef6c4da68ad$var$isType('heading');
const $3ad50ef6c4da68ad$var$isTable = $3ad50ef6c4da68ad$var$isType('table');
const $3ad50ef6c4da68ad$var$isTableCell = $3ad50ef6c4da68ad$var$isType('tableCell');
const $3ad50ef6c4da68ad$var$isTableHeader = $3ad50ef6c4da68ad$var$isType('tableHeader');
const $3ad50ef6c4da68ad$var$isLinkMark = $3ad50ef6c4da68ad$var$isType('link');
const $3ad50ef6c4da68ad$var$isUnsupportedMark = $3ad50ef6c4da68ad$var$isType('unsupportedMark');
const $3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark = $3ad50ef6c4da68ad$var$isType('unsupportedNodeAttribute');
const $3ad50ef6c4da68ad$var$isExpand = $3ad50ef6c4da68ad$var$isType('expand');
const $3ad50ef6c4da68ad$var$isNestedExpand = $3ad50ef6c4da68ad$var$isType('nestedExpand');
const $3ad50ef6c4da68ad$var$isUnsupportedNode = (node)=>$3ad50ef6c4da68ad$var$isType('unsupportedBlock')(node) || $3ad50ef6c4da68ad$var$isType('unsupportedInline')(node);
const $3ad50ef6c4da68ad$var$isDataConsumer = $3ad50ef6c4da68ad$var$isType('dataConsumer');
const $3ad50ef6c4da68ad$var$isFragmentMark = $3ad50ef6c4da68ad$var$isType('fragment');
const $3ad50ef6c4da68ad$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $3ad50ef6c4da68ad$var$filterNull(current);
    }
    return output;
};
const $3ad50ef6c4da68ad$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $3ad50ef6c4da68ad$var$emptyDoc = $3ad50ef6c4da68ad$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $3ad50ef6c4da68ad$var$toJSON = (node)=>{
    const obj = {
        type: node.type.name
    };
    if ($3ad50ef6c4da68ad$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($3ad50ef6c4da68ad$var$isMediaNode(node)) obj.attrs = (0, $gN3fl.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMediaSingleNode(node)) obj.attrs = (0, $cvCFq.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMediaInline(node)) obj.attrs = (0, $gN3fl.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMentionNode(node)) obj.attrs = (0, $fkqTY.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isCodeBlock(node)) obj.attrs = (0, $hgVop.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTable(node)) obj.attrs = (0, $byxO6.tableToJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTableCell(node)) obj.attrs = (0, $byxO6.toJSONTableCell)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTableHeader(node)) obj.attrs = (0, $byxO6.toJSONTableHeader)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isExpand(node) || $3ad50ef6c4da68ad$var$isNestedExpand(node)) obj.attrs = (0, $lKuoe.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $3ad50ef6c4da68ad$var$filterNull(obj.attrs);
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($3ad50ef6c4da68ad$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($3ad50ef6c4da68ad$var$toJSON(child));
    });
    if ($3ad50ef6c4da68ad$var$isParagraph(node) || $3ad50ef6c4da68ad$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($3ad50ef6c4da68ad$var$isUnsupportedMark(mark)) return $3ad50ef6c4da68ad$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($3ad50ef6c4da68ad$var$isLinkMark(mark)) return (0, $3SpHb.toJSON)(mark);
            else if ($3ad50ef6c4da68ad$var$isDataConsumer(mark)) {
                const serialised = (0, $8nj7b.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($3ad50ef6c4da68ad$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $9iaXL.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$3ad50ef6c4da68ad$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $3ad50ef6c4da68ad$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $dxv8o.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $3ad50ef6c4da68ad$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $3ad50ef6c4da68ad$export$98cb1d9308d0944d {
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $gbvAY.sanitizeNode)($3ad50ef6c4da68ad$var$toJSON(child)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(content, $3ad50ef6c4da68ad$var$emptyDoc.content)) return $3ad50ef6c4da68ad$var$createDocFromContent([]);
        return $3ad50ef6c4da68ad$var$createDocFromContent(content);
    }
    internalParse(content, stage = "final") {
        const schema = (0, $9wcjJ.getSchemaBasedOnStage)(stage);
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        if (!content.content || content.content.length === 0) return this.internalParse($3ad50ef6c4da68ad$var$emptyDoc, stage);
        return this.internalParse(content, stage);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $gbvAY.sanitizeNode)($3ad50ef6c4da68ad$var$toJSON(node));
    }
}

});
parcelRegister("dxv8o", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $c20debfacfaca33a$export$28e4e3c024cce988);
const $c20debfacfaca33a$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $c20debfacfaca33a$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $c20debfacfaca33a$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $c20debfacfaca33a$var$defaultAllowOverrideBehaviour;
        default:
            return $c20debfacfaca33a$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("gbvAY", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $a78a3c5cfd4c361e$export$48b382180baf8e88);

var $hYZXM = parcelRequire("hYZXM");

var $i9nQI = parcelRequire("i9nQI");
function $a78a3c5cfd4c361e$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $hYZXM.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $i9nQI.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        emoji: (0, $i9nQI.removeNonAnnotationMarks),
        mention: (0, $i9nQI.removeNonAnnotationMarks),
        date: (0, $i9nQI.removeNonAnnotationMarks),
        hardBreak: (0, $i9nQI.removeMarks),
        inlineCard: (0, $i9nQI.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("i9nQI", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $638c380cab2e60ba$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $638c380cab2e60ba$export$8cae9126fc577085);
function $638c380cab2e60ba$export$9bf001d8ef76e497(node) {
    let newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $638c380cab2e60ba$export$8cae9126fc577085(node) {
    let newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});




parcelRegister("gP1iJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab24c083dcc3a2b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");

var $lyAeo = parcelRequire("lyAeo");

var $6aS3b = parcelRequire("6aS3b");

var $jasdt = parcelRequire("jasdt");

var $4PrNA = parcelRequire("4PrNA");
const $aab24c083dcc3a2b$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $aab24c083dcc3a2b$var$Link = (0, $lyAeo.withLinkClickedEvent)('a');
const $aab24c083dcc3a2b$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $jasdt.useLinkWarningModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aS3b.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aab24c083dcc3a2b$var$Link, {
        "data-testid": testId,
        href: href,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PrNA.default), linkWarningModalProps));
};
var $aab24c083dcc3a2b$export$2e2bcd8739ae039 = (0, $1ngde.default)($aab24c083dcc3a2b$var$PACKAGE_DATA)($aab24c083dcc3a2b$var$LinkUrl);

});
parcelRegister("lyAeo", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $a830f7743a3fdab2$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $a830f7743a3fdab2$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $bTNMs = parcelRequire("bTNMs");

var $8sbpW = parcelRequire("8sbpW");
const $a830f7743a3fdab2$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $a830f7743a3fdab2$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $a830f7743a3fdab2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $a830f7743a3fdab2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($a830f7743a3fdab2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $a830f7743a3fdab2$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $a830f7743a3fdab2$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $a830f7743a3fdab2$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $a830f7743a3fdab2$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $a830f7743a3fdab2$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $a830f7743a3fdab2$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $a830f7743a3fdab2$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $a830f7743a3fdab2$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            }
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $a830f7743a3fdab2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $a830f7743a3fdab2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $8sbpW.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $8sbpW.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$a830f7743a3fdab2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});

parcelRegister("bTNMs", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a26d6e0cc0b2d68$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $0a26d6e0cc0b2d68$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $0a26d6e0cc0b2d68$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $0a26d6e0cc0b2d68$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $0a26d6e0cc0b2d68$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $0a26d6e0cc0b2d68$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $0a26d6e0cc0b2d68$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $0a26d6e0cc0b2d68$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $0a26d6e0cc0b2d68$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $0a26d6e0cc0b2d68$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $0a26d6e0cc0b2d68$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $0a26d6e0cc0b2d68$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $0a26d6e0cc0b2d68$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $0a26d6e0cc0b2d68$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $0a26d6e0cc0b2d68$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $0a26d6e0cc0b2d68$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $0a26d6e0cc0b2d68$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $0a26d6e0cc0b2d68$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $0a26d6e0cc0b2d68$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $0a26d6e0cc0b2d68$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $0a26d6e0cc0b2d68$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $0a26d6e0cc0b2d68$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $0a26d6e0cc0b2d68$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $0a26d6e0cc0b2d68$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $0a26d6e0cc0b2d68$export$a66dc699502b5d28);

var $hEsGF = parcelRequire("hEsGF");

var $cCvxR = parcelRequire("cCvxR");
const $0a26d6e0cc0b2d68$export$85183a312807388d = 'media';
const $0a26d6e0cc0b2d68$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $0a26d6e0cc0b2d68$export$72af824fa910c33e;
(function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
})($0a26d6e0cc0b2d68$export$72af824fa910c33e || ($0a26d6e0cc0b2d68$export$72af824fa910c33e = {}));
var $0a26d6e0cc0b2d68$export$c89e475f7f7174c2;
(function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
})($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 || ($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 = {}));
const $0a26d6e0cc0b2d68$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $0a26d6e0cc0b2d68$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $0a26d6e0cc0b2d68$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $0a26d6e0cc0b2d68$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $0a26d6e0cc0b2d68$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($0a26d6e0cc0b2d68$export$85183a312807388d);
};
const $0a26d6e0cc0b2d68$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error?.message,
                kind: error?.kind,
                type: error?.type
            } : undefined
        }
    });
const $0a26d6e0cc0b2d68$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure?.duration
        }
    };
};
const $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure?.duration,
            reason: reason
        }
    };
};
const $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $0a26d6e0cc0b2d68$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });

});
parcelRegister("hEsGF", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $c9b3a002aa9f3cfd$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $c9b3a002aa9f3cfd$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $c9b3a002aa9f3cfd$export$185802fd694ee1f5);
const $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable = $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable();
const $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $c9b3a002aa9f3cfd$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $c9b3a002aa9f3cfd$export$1a717feb4df1a945 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $c9b3a002aa9f3cfd$export$de42547d395c8271 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $c9b3a002aa9f3cfd$var$getMark = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $c9b3a002aa9f3cfd$export$185802fd694ee1f5 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measure = $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $c9b3a002aa9f3cfd$var$getMark(id, 'pending');
            const endMark = $c9b3a002aa9f3cfd$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});


parcelRegister("8sbpW", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ae3e58c828553a00$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ae3e58c828553a00$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $lyAeo = parcelRequire("lyAeo");
var $ae3e58c828553a00$export$81a5b494baf0f17c;
(function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
})($ae3e58c828553a00$export$81a5b494baf0f17c || ($ae3e58c828553a00$export$81a5b494baf0f17c = {}));
const $ae3e58c828553a00$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ae3e58c828553a00$var$isNotLeftClick = (event)=>event.button !== 0;
const $ae3e58c828553a00$export$df67f318ded0283c = (onMouseDown)=>{
    return $ae3e58c828553a00$export$5993d3ca6c85f774(onMouseDown, $ae3e58c828553a00$var$isNotLeftClick);
};

});


parcelRegister("6aS3b", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $225f130421a19d23$export$9458cdec663b9ff1);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $225f130421a19d23$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("jasdt", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $22736ecc26df3888$export$32b76c003683c2ec);

var $eUqFw = parcelRequire("eUqFw");

var $jw09O = parcelRequire("jw09O");

var $bFzGY = parcelRequire("bFzGY");

var $bTNMs = parcelRequire("bTNMs");
const $22736ecc26df3888$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $22736ecc26df3888$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $eUqFw.useState)(null);
    const [url, setUrl] = (0, $eUqFw.useState)(null);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $jw09O.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $22736ecc26df3888$var$toUrl(href, window.location.origin);
        const linkTextUrl = $22736ecc26df3888$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("jw09O", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $d3ea18b193bf4e7e$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $d3ea18b193bf4e7e$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $dVFtG = parcelRequire("dVFtG");
const $d3ea18b193bf4e7e$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($dVFtG)))();
$d3ea18b193bf4e7e$var$linkify.add('sourcetree:', 'http:');
$d3ea18b193bf4e7e$var$linkify.add('jamfselfservice:', 'http:');
$d3ea18b193bf4e7e$var$linkify.add('notes:', 'http:');
const $d3ea18b193bf4e7e$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $d3ea18b193bf4e7e$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$d3ea18b193bf4e7e$var$tlds.push($d3ea18b193bf4e7e$var$tlds2Char);
$d3ea18b193bf4e7e$var$linkify.tlds($d3ea18b193bf4e7e$var$tlds, false);
const $d3ea18b193bf4e7e$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $d3ea18b193bf4e7e$var$normaliseLinkHref = (url)=>{
    const match = $d3ea18b193bf4e7e$var$getLinkMatch(url);
    return match && match.url || null;
};
const $d3ea18b193bf4e7e$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $d3ea18b193bf4e7e$var$linkifyMatch(str);
    if (!match.length) match = $d3ea18b193bf4e7e$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $d3ea18b193bf4e7e$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $d3ea18b193bf4e7e$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$d3ea18b193bf4e7e$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($d3ea18b193bf4e7e$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($d3ea18b193bf4e7e$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $d3ea18b193bf4e7e$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $d3ea18b193bf4e7e$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $d3ea18b193bf4e7e$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($d3ea18b193bf4e7e$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $d3ea18b193bf4e7e$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("dVFtG", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a240c5dab5a16a6a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a240c5dab5a16a6a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a240c5dab5a16a6a$var$isString(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object String]';
}
function $a240c5dab5a16a6a$var$isObject(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Object]';
}
function $a240c5dab5a16a6a$var$isRegExp(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object RegExp]';
}
function $a240c5dab5a16a6a$var$isFunction(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Function]';
}
function $a240c5dab5a16a6a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a240c5dab5a16a6a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a240c5dab5a16a6a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a240c5dab5a16a6a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a240c5dab5a16a6a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a240c5dab5a16a6a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a240c5dab5a16a6a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a240c5dab5a16a6a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a240c5dab5a16a6a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a240c5dab5a16a6a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a240c5dab5a16a6a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ajKi5"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a240c5dab5a16a6a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a240c5dab5a16a6a$var$isObject(val)) {
            if ($a240c5dab5a16a6a$var$isRegExp(val.validate)) compiled.validate = $a240c5dab5a16a6a$var$createValidator(val.validate);
            else if ($a240c5dab5a16a6a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a240c5dab5a16a6a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a240c5dab5a16a6a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a240c5dab5a16a6a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a240c5dab5a16a6a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a240c5dab5a16a6a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a240c5dab5a16a6a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a240c5dab5a16a6a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a240c5dab5a16a6a$var$createMatch(self, shift) {
    var match = new $a240c5dab5a16a6a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a240c5dab5a16a6a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a240c5dab5a16a6a$var$LinkifyIt)) return new $a240c5dab5a16a6a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a240c5dab5a16a6a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a240c5dab5a16a6a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a240c5dab5a16a6a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a240c5dab5a16a6a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a240c5dab5a16a6a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a240c5dab5a16a6a$var$LinkifyIt;

});
parcelRegister("ajKi5", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});




parcelRegister("4PrNA", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c30e2831e3a614$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $9Q9JX = parcelRequire("9Q9JX");

var $byn9U = parcelRequire("byn9U");

var $4abrz = parcelRequire("4abrz");
const $63c30e2831e3a614$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, $byn9U.jsx)((0, $aOw1G.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kigFe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $boSVF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).check_this_link))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lfiOu.default), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $9Q9JX.breakWordsCss)
    }, url && unsafeLinkText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...(0, $4abrz.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("a", {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2OJfS.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).go_back)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).continue)))));
    return intl ? content : /*#__PURE__*/ (0, $byn9U.jsx)((0, $3dpxL.default), {
        locale: "en"
    }, content);
};
var $63c30e2831e3a614$export$2e2bcd8739ae039 = (0, $2qhQi.default)($63c30e2831e3a614$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("9Q9JX", function(module, exports) {

$parcel$export(module.exports, "breakWordsCss", () => $0cae29636d763a60$export$e4dda5b86d39ace5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0cae29636d763a60$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0cae29636d763a60$export$e4dda5b86d39ace5 = {
    name: "1ujvzzx",
    styles: "white-space:pre-line;word-break:break-all"
};

});

parcelRegister("4abrz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ebfdcddf6874aaf0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ebfdcddf6874aaf0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});




parcelRegister("7FrhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5732daa23d4c623$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e5732daa23d4c623$export$2e2bcd8739ae039(props) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props.dataAttributes,
        style: {
            textDecoration: 'line-through'
        }
    }, props.children));
}

});

parcelRegister("3czYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e223899bd1ad5435$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e223899bd1ad5435$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("5EI2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b555def9a496abb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $b555def9a496abb5$var$isSub = (type)=>{
    return type === 'sub';
};
function $b555def9a496abb5$export$2e2bcd8739ae039(props) {
    if ($b555def9a496abb5$var$isSub(props.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("sub", props.dataAttributes, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("2LYW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29fd36a20822e31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");

var $iXTVf = parcelRequire("iXTVf");

var $4q38b = parcelRequire("4q38b");
function $e29fd36a20822e31$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $iXTVf.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $iXTVf.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eUqFw.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("iXTVf", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $f1092a04097603f0$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $f1092a04097603f0$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $f1092a04097603f0$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $f1092a04097603f0$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("jIWxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd19009972ab5ceb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");

var $77B5u = parcelRequire("77B5u");

var $4q38b = parcelRequire("4q38b");
function $dd19009972ab5ceb$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $77B5u.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eUqFw.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("77B5u", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $e06862f35dcf01b5$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $e06862f35dcf01b5$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $e06862f35dcf01b5$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $e06862f35dcf01b5$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("fqJal", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc82c573f7a0c67$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0cc82c573f7a0c67$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("3QkG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa30294f41b5af3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4iaaT = parcelRequire("4iaaT");

var $b3jMP = parcelRequire("b3jMP");

var $25FYC = parcelRequire("25FYC");
const $3fa30294f41b5af3$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $3fa30294f41b5af3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $3fa30294f41b5af3$var$wrapperStyles,
            "data-mode": props.mode,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: {
                width: (0, $b3jMP.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("3ofDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b09024e681d364$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dkRpY = parcelRequire("dkRpY");
const $83b09024e681d364$var$MarkWrapper = (props)=>{
    const styles = props['data-align'] ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $byn9U.css)("text-align:", (0, $dkRpY.alignmentPositionMap)[props['data-align']], ";") : '';
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles,
        ...props
    }, props.children));
};
function $83b09024e681d364$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($83b09024e681d364$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("cTsEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $462a17ee6dc989f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $462a17ee6dc989f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}

});

parcelRegister("hySUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $069f0328a052510c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $069f0328a052510c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("dt1Ro", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dd2306713f4b142$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0dd2306713f4b142$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("9HbLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b9a8159d214ff1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e6b9a8159d214ff1$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("5hADG", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a4738291ec68b6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $81a4738291ec68b6$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("9Pmx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a79e62228a84dfa5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $a79e62228a84dfa5$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("jKBO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d0890446758faa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $40d0890446758faa$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}

});


parcelRegister("3glLa", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $40f2a19ba0a22464$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $40f2a19ba0a22464$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $40f2a19ba0a22464$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $40f2a19ba0a22464$export$81b20b6c83a56bd);

var $lUXsh = parcelRequire("lUXsh");
var $2yJJ8 = parcelRequire("2yJJ8");
var $4N6cH = parcelRequire("4N6cH");
var $izui5 = parcelRequire("izui5");

var $9wcjJ = parcelRequire("9wcjJ");

var $XHGTv = parcelRequire("XHGTv");
const $40f2a19ba0a22464$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $40f2a19ba0a22464$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $40f2a19ba0a22464$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $40f2a19ba0a22464$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$40f2a19ba0a22464$export$62d5811a2955c1d8.indexOf(a.type.name) - $40f2a19ba0a22464$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $40f2a19ba0a22464$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $40f2a19ba0a22464$export$fb80336a7e408cb3 = (doc, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const node = $40f2a19ba0a22464$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $40f2a19ba0a22464$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $40f2a19ba0a22464$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $2yJJ8.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $40f2a19ba0a22464$export$fafd4f799ee68da0 = (content, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$40f2a19ba0a22464$export$81b20b6c83a56bd(node, schema, adfStage));
};
const $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
const $40f2a19ba0a22464$var$RELATIVE_LINK = /^\//;
const $40f2a19ba0a22464$var$ANCHOR_LINK = /^#/;
const $40f2a19ba0a22464$var$flattenUnknownBlockTree = (node, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    for(let i = 0; i < node.content.length; i++){
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($40f2a19ba0a22464$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$40f2a19ba0a22464$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $40f2a19ba0a22464$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $4N6cH.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $40f2a19ba0a22464$var$flattenUnknownBlockTree(node)
    };
};
const $40f2a19ba0a22464$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $40f2a19ba0a22464$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $40f2a19ba0a22464$export$81b20b6c83a56bd = (originalNode, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $40f2a19ba0a22464$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $40f2a19ba0a22464$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $40f2a19ba0a22464$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $40f2a19ba0a22464$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $40f2a19ba0a22464$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                let paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                let { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $40f2a19ba0a22464$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        let headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $40f2a19ba0a22464$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $izui5.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $lUXsh.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $40f2a19ba0a22464$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $40f2a19ba0a22464$export$b9908ef75cad1e0e(node);
};
const $40f2a19ba0a22464$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$40f2a19ba0a22464$var$RELATIVE_LINK.test(linkHref) && !$40f2a19ba0a22464$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $4N6cH.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($40f2a19ba0a22464$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("2yJJ8", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $1dd23a32bc80184c$export$b1f729c6af6f2a6e);

var $4K6In = parcelRequire("4K6In");
const $1dd23a32bc80184c$var$typedNodes = $4K6In;
const $1dd23a32bc80184c$export$b1f729c6af6f2a6e = new Set(Object.keys($1dd23a32bc80184c$var$typedNodes).filter((key)=>$1dd23a32bc80184c$var$typedNodes[key] && $1dd23a32bc80184c$var$typedNodes[key].group === 'inline'));

});
parcelRegister("4K6In", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("lKuoe")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("lKuoe")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("lKuoe")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("eTtDn")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("1Ud4U")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("56qNL")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("1HZv5")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("jDF31")).blockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("jDF31")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("jDF31")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("568Ob")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("568Ob")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("hgVop")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("hgVop")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("7SlQD")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("iWGOh")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("7wZ4m")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("8lnnz")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("8lnnz")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("8lnnz")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5bGpU")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5JhXr")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("iOeir")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("fkqTY")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("fkqTY")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("3eVto")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("3eVto")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("3eVto")).listItemWithDecisionStage0);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("izui5")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("izui5")).PanelType);
$parcel$export(module.exports, "panelWithBlockquoteStage0", () => (parcelRequire("izui5")).panelWithBlockquoteStage0);
$parcel$export(module.exports, "text", () => (parcelRequire("ltJuR")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("4ne8H")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("d99SJ")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("gN3fl")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("gN3fl")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("gN3fl")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("1KDvn")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("hXvCf")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("cvCFq")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("cvCFq")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("cvCFq")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("cvCFq")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("cvCFq")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("cvCFq")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("byxO6")).table);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("byxO6")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("byxO6")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("byxO6")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("byxO6")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("byxO6")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("byxO6")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("byxO6")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("byxO6")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("byxO6")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("byxO6")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("byxO6")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("byxO6")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("byxO6")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("byxO6")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("byxO6")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("byxO6")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("byxO6")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("byxO6")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("dPUL6")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("dPUL6")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("47B7q")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("7QozA")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("7QozA")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("ie5d6")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("8CDqw")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dDs5p")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jTnho")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jTnho")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("1O3jv")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("8mC62")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("heoPx")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("7p32Z")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("8cuPa")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("cvo5z")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dj4Ew")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("7XTsD")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("7y7sZ")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("7xvQK")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("eStcf")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("lUaLf")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("lUaLf")).multiBodiedExtension);

var $lKuoe = parcelRequire("lKuoe");

var $eTtDn = parcelRequire("eTtDn");

var $1Ud4U = parcelRequire("1Ud4U");

var $56qNL = parcelRequire("56qNL");

var $1HZv5 = parcelRequire("1HZv5");

var $jDF31 = parcelRequire("jDF31");

var $568Ob = parcelRequire("568Ob");

var $hgVop = parcelRequire("hgVop");

var $7SlQD = parcelRequire("7SlQD");

var $iWGOh = parcelRequire("iWGOh");

var $7wZ4m = parcelRequire("7wZ4m");

var $8lnnz = parcelRequire("8lnnz");

var $5bGpU = parcelRequire("5bGpU");

var $5JhXr = parcelRequire("5JhXr");

var $iOeir = parcelRequire("iOeir");

var $fkqTY = parcelRequire("fkqTY");

var $3eVto = parcelRequire("3eVto");

var $izui5 = parcelRequire("izui5");

var $ltJuR = parcelRequire("ltJuR");

var $4ne8H = parcelRequire("4ne8H");

var $d99SJ = parcelRequire("d99SJ");

var $gN3fl = parcelRequire("gN3fl");

var $1KDvn = parcelRequire("1KDvn");

var $hXvCf = parcelRequire("hXvCf");

var $cvCFq = parcelRequire("cvCFq");

var $byxO6 = parcelRequire("byxO6");

var $dPUL6 = parcelRequire("dPUL6");

var $47B7q = parcelRequire("47B7q");

var $7QozA = parcelRequire("7QozA");

var $ie5d6 = parcelRequire("ie5d6");

var $8CDqw = parcelRequire("8CDqw");

var $dDs5p = parcelRequire("dDs5p");

var $jTnho = parcelRequire("jTnho");

var $1O3jv = parcelRequire("1O3jv");

var $8mC62 = parcelRequire("8mC62");

var $heoPx = parcelRequire("heoPx");

var $7p32Z = parcelRequire("7p32Z");

var $8cuPa = parcelRequire("8cuPa");

var $cvo5z = parcelRequire("cvo5z");

var $dj4Ew = parcelRequire("dj4Ew");

var $7XTsD = parcelRequire("7XTsD");

var $7y7sZ = parcelRequire("7y7sZ");

var $7xvQK = parcelRequire("7xvQK");

var $eStcf = parcelRequire("eStcf");

var $lUaLf = parcelRequire("lUaLf");

});



parcelRegister("enpaH", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $b1eae69ef70cc146$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $b1eae69ef70cc146$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $b1eae69ef70cc146$export$9f1e9347b0411934);
const $b1eae69ef70cc146$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $b1eae69ef70cc146$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $b1eae69ef70cc146$export$d7bc71cca336a3b = (path)=>path.some((item)=>$b1eae69ef70cc146$var$isLayoutNode(item) && $b1eae69ef70cc146$var$hasBreakOutMark(item));
const $b1eae69ef70cc146$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $b1eae69ef70cc146$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};

});


parcelRegister("15lMG", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $749e15ac1fb41126$export$59a54f98b9753d5c);

var $5iWql = parcelRequire("5iWql");

var $9wcjJ = parcelRequire("9wcjJ");

var $3glLa = parcelRequire("3glLa");

var $2pBoL = parcelRequire("2pBoL");
var $9EOM6 = parcelRequire("9EOM6");

var $auyn4 = parcelRequire("auyn4");

var $3rMck = parcelRequire("3rMck");

var $dgWxh = parcelRequire("dgWxh");

var $8RPsP = parcelRequire("8RPsP");
const $749e15ac1fb41126$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $749e15ac1fb41126$var$withStopwatch = (cb)=>{
    const startTime = $749e15ac1fb41126$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $749e15ac1fb41126$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $749e15ac1fb41126$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8RPsP.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        result = (0, $9EOM6.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
    } else result = (0, $3glLa.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    return result;
};
const $749e15ac1fb41126$var$memoValidation = (0, $5iWql.default)($749e15ac1fb41126$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator] = lastArgs;
    // we're ignoring changes to dispatchAnalyticsEvent in this check
    const result = $749e15ac1fb41126$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator;
    return result;
});
const $749e15ac1fb41126$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $749e15ac1fb41126$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $749e15ac1fb41126$var$memoSerializeFragment = (0, $5iWql.default)($749e15ac1fb41126$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $749e15ac1fb41126$var$areDocsEqual(newDoc, oldDoc);
});
const $749e15ac1fb41126$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $749e15ac1fb41126$var$memoCreateNodeAndCheck = (0, $5iWql.default)($749e15ac1fb41126$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $749e15ac1fb41126$var$areDocsEqual(newDoc, oldDoc);
});
const $749e15ac1fb41126$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $749e15ac1fb41126$var$withStopwatch(()=>{
        return $749e15ac1fb41126$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $749e15ac1fb41126$var$withStopwatch(()=>{
        return $749e15ac1fb41126$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $749e15ac1fb41126$var$withStopwatch(()=>{
        return $749e15ac1fb41126$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $2pBoL.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $dgWxh.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("9EOM6", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $7176b3167fe60867$export$884cfad20dece33e);

var $e1vnp = parcelRequire("e1vnp");

var $auyn4 = parcelRequire("auyn4");

var $2pBoL = parcelRequire("2pBoL");
const $7176b3167fe60867$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $7176b3167fe60867$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $7176b3167fe60867$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $7176b3167fe60867$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $7176b3167fe60867$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $7176b3167fe60867$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $7176b3167fe60867$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $7176b3167fe60867$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $7176b3167fe60867$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $7176b3167fe60867$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $7176b3167fe60867$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $7176b3167fe60867$export$87b732fa69cdf16e(child) : validate(child, $7176b3167fe60867$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        if (entity.content.length === 0) return $7176b3167fe60867$export$87b732fa69cdf16e(entity);
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $7176b3167fe60867$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $2pBoL.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $7176b3167fe60867$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $e1vnp.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $7176b3167fe60867$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $7176b3167fe60867$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("e1vnp", function(module, exports) {

$parcel$export(module.exports, "validator", () => $344e03ee90062787$export$956325f45c5d174a);

var $fygQo = parcelRequire("fygQo");

var $9Psqs = parcelRequire("9Psqs");

var $9OCXp = parcelRequire("9OCXp");
function $344e03ee90062787$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
const $344e03ee90062787$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported form './specs'.
 * We denormalised the spec to save bundle size.
 */ function $344e03ee90062787$var$createSpec(nodes, marks) {
    return Object.keys($fygQo).reduce((newSpecs, k)=>{
        const spec = {
            ...$fygQo[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $9Psqs.isString)(spec.props.content)) spec.props.content = $fygQo[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $9Psqs.isString)(item) ? Array.isArray($fygQo[item]) ? $fygQo[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>Array.isArray($fygQo[subItem]) ? $fygQo[subItem] : (0, $9Psqs.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $344e03ee90062787$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
function $344e03ee90062787$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $344e03ee90062787$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $344e03ee90062787$export$66c739158ef99a42(spec, value) {
    if (!(0, $9Psqs.isDefined)(value)) return !!spec.optional;
    if ($344e03ee90062787$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $344e03ee90062787$var$partitionObject(spec.props, (key, subSpec)=>$344e03ee90062787$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $9Psqs.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $9Psqs.isBoolean)(value);
        case 'number':
            return (0, $9Psqs.isNumber)(value) && ((0, $9Psqs.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9Psqs.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $9Psqs.isInteger)(value) && ((0, $9Psqs.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9Psqs.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $9Psqs.isDefined)((0, $9OCXp.validatorFnMap)[rule]) && (0, $9OCXp.validatorFnMap)[rule](value);
            return (0, $9Psqs.isString)(value) && ((0, $9Psqs.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $9Psqs.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $9Psqs.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$344e03ee90062787$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$344e03ee90062787$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $9Psqs.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $344e03ee90062787$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $344e03ee90062787$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $344e03ee90062787$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $344e03ee90062787$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $344e03ee90062787$var$getUnsupportedOptions(parentSpec));
};
const $344e03ee90062787$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $344e03ee90062787$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $344e03ee90062787$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $344e03ee90062787$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $344e03ee90062787$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        let newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $344e03ee90062787$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $344e03ee90062787$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $344e03ee90062787$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $344e03ee90062787$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $9Psqs.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.text) {
            if ((0, $9Psqs.isDefined)(prevEntity.text) && !$344e03ee90062787$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.content && prevEntity.content) {
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $9Psqs.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $9Psqs.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $9Psqs.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $344e03ee90062787$var$partitionObject(attrOption.props, (key, spec)=>{
                    const valueToValidate = prevEntity.attrs[key];
                    return $344e03ee90062787$export$66c739158ef99a42(spec, valueToValidate);
                });
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $344e03ee90062787$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $344e03ee90062787$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $344e03ee90062787$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
        const message = $344e03ee90062787$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        let invalidValues = {};
        for(let invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $344e03ee90062787$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $344e03ee90062787$var$partitionObject(prevEntity, (k)=>(0, $9Psqs.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $9Psqs.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        let specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $344e03ee90062787$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
            return isOptional || (0, $9Psqs.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $344e03ee90062787$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $9Psqs.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $9Psqs.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $344e03ee90062787$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $344e03ee90062787$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("fygQo", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("a5jT7")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("a5jT7")).annotation);
$parcel$export(module.exports, "atomic_inline", () => (parcelRequire("a5jT7")).atomic_inline);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("a5jT7")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("a5jT7")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("a5jT7")).block_content);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("a5jT7")).blockquote);
$parcel$export(module.exports, "blockquote_without_nested_codeblock_or_media", () => (parcelRequire("a5jT7")).blockquote_without_nested_codeblock_or_media);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("a5jT7")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("a5jT7")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("a5jT7")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("a5jT7")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("a5jT7")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("a5jT7")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("a5jT7")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("a5jT7")).codeBlock);
$parcel$export(module.exports, "codeBlock_with_marks", () => (parcelRequire("a5jT7")).codeBlock_with_marks);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => (parcelRequire("a5jT7")).codeBlock_with_no_marks);
$parcel$export(module.exports, "code_inline", () => (parcelRequire("a5jT7")).code_inline);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("a5jT7")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("a5jT7")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("a5jT7")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("a5jT7")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("a5jT7")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("a5jT7")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("a5jT7")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("a5jT7")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("a5jT7")).expand);
$parcel$export(module.exports, "expand_without_nested_expand", () => (parcelRequire("a5jT7")).expand_without_nested_expand);
$parcel$export(module.exports, "expand_with_breakout_mark", () => (parcelRequire("a5jT7")).expand_with_breakout_mark);
$parcel$export(module.exports, "expand_with_no_mark", () => (parcelRequire("a5jT7")).expand_with_no_mark);
$parcel$export(module.exports, "extension", () => (parcelRequire("a5jT7")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("a5jT7")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("a5jT7")).extension_with_marks);
$parcel$export(module.exports, "formatted_text_inline", () => (parcelRequire("a5jT7")).formatted_text_inline);
$parcel$export(module.exports, "fragment", () => (parcelRequire("a5jT7")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("a5jT7")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("a5jT7")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("a5jT7")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("a5jT7")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("a5jT7")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("a5jT7")).indentation);
$parcel$export(module.exports, "inline", () => (parcelRequire("a5jT7")).inline);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("a5jT7")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("a5jT7")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("a5jT7")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_comment_marker", () => (parcelRequire("a5jT7")).inline_comment_marker);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("a5jT7")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("a5jT7")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("a5jT7")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("a5jT7")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("a5jT7")).link);
$parcel$export(module.exports, "link_text_inline", () => (parcelRequire("a5jT7")).link_text_inline);
$parcel$export(module.exports, "listItem", () => (parcelRequire("a5jT7")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("a5jT7")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("a5jT7")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("a5jT7")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("a5jT7")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("a5jT7")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("a5jT7")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("a5jT7")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("a5jT7")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("a5jT7")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("a5jT7")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("a5jT7")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("a5jT7")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a5jT7")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("a5jT7")).panel);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => (parcelRequire("a5jT7")).panel_with_nested_blockquote);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("a5jT7")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("a5jT7")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("a5jT7")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("a5jT7")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("a5jT7")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("a5jT7")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("a5jT7")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("a5jT7")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("a5jT7")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("a5jT7")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("a5jT7")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("a5jT7")).tableCell);
$parcel$export(module.exports, "tableCell_content", () => (parcelRequire("a5jT7")).tableCell_content);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("a5jT7")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("a5jT7")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("a5jT7")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("a5jT7")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("a5jT7")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("a5jT7")).textColor);
$parcel$export(module.exports, "underline", () => (parcelRequire("a5jT7")).underline);

var $a5jT7 = parcelRequire("a5jT7");

});
parcelRegister("a5jT7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $7579cc59edd0dc9b$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "text", () => $7579cc59edd0dc9b$export$6f093cfa640b7166);
$parcel$export(module.exports, "codeBlock", () => $7579cc59edd0dc9b$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_with_marks", () => $7579cc59edd0dc9b$export$e6744655acd74d98);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => $7579cc59edd0dc9b$export$6e3671492ca8dabf);
$parcel$export(module.exports, "mediaSingle", () => $7579cc59edd0dc9b$export$969fe3781ca15058);
$parcel$export(module.exports, "media", () => $7579cc59edd0dc9b$export$987d49ffe1b0900f);
$parcel$export(module.exports, "link", () => $7579cc59edd0dc9b$export$9c30223ca0a664fb);
$parcel$export(module.exports, "annotation", () => $7579cc59edd0dc9b$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "border", () => $7579cc59edd0dc9b$export$1edee58a52776cd9);
$parcel$export(module.exports, "hardBreak", () => $7579cc59edd0dc9b$export$371da9dd35aba193);
$parcel$export(module.exports, "mention", () => $7579cc59edd0dc9b$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $7579cc59edd0dc9b$export$a19185d1233fc4b2);
$parcel$export(module.exports, "date", () => $7579cc59edd0dc9b$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $7579cc59edd0dc9b$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "inlineCard", () => $7579cc59edd0dc9b$export$cbf8224b64e0d942);
$parcel$export(module.exports, "status", () => $7579cc59edd0dc9b$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "formatted_text_inline", () => $7579cc59edd0dc9b$export$cd4081e08b45f72e);
$parcel$export(module.exports, "code_inline", () => $7579cc59edd0dc9b$export$36e4c193ad57e432);
$parcel$export(module.exports, "em", () => $7579cc59edd0dc9b$export$c63c6f932822f543);
$parcel$export(module.exports, "strong", () => $7579cc59edd0dc9b$export$59ae2c325a998f89);
$parcel$export(module.exports, "strike", () => $7579cc59edd0dc9b$export$4899a95d70ec5056);
$parcel$export(module.exports, "subsup", () => $7579cc59edd0dc9b$export$b3401ee80eb31041);
$parcel$export(module.exports, "underline", () => $7579cc59edd0dc9b$export$425327af25286e5e);
$parcel$export(module.exports, "textColor", () => $7579cc59edd0dc9b$export$32f78bffcd82ff28);
$parcel$export(module.exports, "backgroundColor", () => $7579cc59edd0dc9b$export$8c5a050822fd698c);
$parcel$export(module.exports, "inline_comment_marker", () => $7579cc59edd0dc9b$export$e2bb6ccb232b5816);
$parcel$export(module.exports, "code", () => $7579cc59edd0dc9b$export$6565f9f03506010b);
$parcel$export(module.exports, "caption", () => $7579cc59edd0dc9b$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "mediaSingle_caption", () => $7579cc59edd0dc9b$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $7579cc59edd0dc9b$export$f7fd577406abd5f8);
$parcel$export(module.exports, "link_text_inline", () => $7579cc59edd0dc9b$export$64324e102160646);
$parcel$export(module.exports, "inlineExtension", () => $7579cc59edd0dc9b$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $7579cc59edd0dc9b$export$e37f10815f36843d);
$parcel$export(module.exports, "mediaInline", () => $7579cc59edd0dc9b$export$38bab695e3f720f1);
$parcel$export(module.exports, "atomic_inline", () => $7579cc59edd0dc9b$export$3fed98b72ebf1c06);
$parcel$export(module.exports, "inline", () => $7579cc59edd0dc9b$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "paragraph", () => $7579cc59edd0dc9b$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $7579cc59edd0dc9b$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $7579cc59edd0dc9b$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $7579cc59edd0dc9b$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "taskItem", () => $7579cc59edd0dc9b$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $7579cc59edd0dc9b$export$375b6afcc5f4d291);
$parcel$export(module.exports, "decisionItem", () => $7579cc59edd0dc9b$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $7579cc59edd0dc9b$export$62d45a65fb43d95e);
$parcel$export(module.exports, "bulletList", () => $7579cc59edd0dc9b$export$a140c94e5ea26bee);
$parcel$export(module.exports, "listItem", () => $7579cc59edd0dc9b$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "orderedList", () => $7579cc59edd0dc9b$export$a5dc81035676e7a);
$parcel$export(module.exports, "mediaGroup", () => $7579cc59edd0dc9b$export$2855e964765eac9);
$parcel$export(module.exports, "blockquote", () => $7579cc59edd0dc9b$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquote_without_nested_codeblock_or_media", () => $7579cc59edd0dc9b$export$221bcf06d89600af);
$parcel$export(module.exports, "embedCard", () => $7579cc59edd0dc9b$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "extension", () => $7579cc59edd0dc9b$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $7579cc59edd0dc9b$export$15be7c145cec614a);
$parcel$export(module.exports, "heading", () => $7579cc59edd0dc9b$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_indentation", () => $7579cc59edd0dc9b$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $7579cc59edd0dc9b$export$7b491e75f1be9278);
$parcel$export(module.exports, "heading_with_alignment", () => $7579cc59edd0dc9b$export$c17edf9af655deaf);
$parcel$export(module.exports, "rule", () => $7579cc59edd0dc9b$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "panel", () => $7579cc59edd0dc9b$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panel_with_nested_blockquote", () => $7579cc59edd0dc9b$export$5d60af6db74e5cd3);
$parcel$export(module.exports, "nestedExpand_content", () => $7579cc59edd0dc9b$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $7579cc59edd0dc9b$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "alignment", () => $7579cc59edd0dc9b$export$8e53000a4ec837);
$parcel$export(module.exports, "indentation", () => $7579cc59edd0dc9b$export$480c699bd4ec0d86);
$parcel$export(module.exports, "dataConsumer", () => $7579cc59edd0dc9b$export$3024f02c495408d6);
$parcel$export(module.exports, "fragment", () => $7579cc59edd0dc9b$export$f00aeb236b6f05af);
$parcel$export(module.exports, "tableCell", () => $7579cc59edd0dc9b$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "nestedExpand", () => $7579cc59edd0dc9b$export$63cadbf5f4296627);
$parcel$export(module.exports, "tableHeader", () => $7579cc59edd0dc9b$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableCell_content", () => $7579cc59edd0dc9b$export$9b2745ced483e9ab);
$parcel$export(module.exports, "tableRow", () => $7579cc59edd0dc9b$export$ce666bf02318c957);
$parcel$export(module.exports, "table", () => $7579cc59edd0dc9b$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "non_nestable_block_content", () => $7579cc59edd0dc9b$export$ed866000601e7fa5);
$parcel$export(module.exports, "bodiedExtension", () => $7579cc59edd0dc9b$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $7579cc59edd0dc9b$export$ee052cc5b2356e83);
$parcel$export(module.exports, "expand", () => $7579cc59edd0dc9b$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_with_no_mark", () => $7579cc59edd0dc9b$export$1358dbfffec33cd4);
$parcel$export(module.exports, "expand_with_breakout_mark", () => $7579cc59edd0dc9b$export$c30e395ad81940c1);
$parcel$export(module.exports, "expand_without_nested_expand", () => $7579cc59edd0dc9b$export$ee7b417fdb891082);
$parcel$export(module.exports, "block_content", () => $7579cc59edd0dc9b$export$a31afb40076fa18b);
$parcel$export(module.exports, "layoutColumn", () => $7579cc59edd0dc9b$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $7579cc59edd0dc9b$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $7579cc59edd0dc9b$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $7579cc59edd0dc9b$export$e0e9834198e8601d);
$parcel$export(module.exports, "extensionFrame", () => $7579cc59edd0dc9b$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $7579cc59edd0dc9b$export$c3c04d555a8b9013);
$parcel$export(module.exports, "breakout", () => $7579cc59edd0dc9b$export$89015c65f1c75e3f);
$parcel$export(module.exports, "doc", () => $7579cc59edd0dc9b$export$2a111da947c407d2);
const $7579cc59edd0dc9b$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$310ebe0d80122e9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'unsupportedInline'
            ]
        },
        attrs: {
            props: {
                originalValue: {
                    type: 'object'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'text',
                    {
                        props: {
                            marks: {
                                items: [],
                                maxItems: 0,
                                optional: true,
                                type: 'array'
                            }
                        }
                    }
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$e6744655acd74d98 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6e3671492ca8dabf = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$44b79b0979d0f0f7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'unsupportedBlock'
            ]
        },
        attrs: {
            props: {
                originalValue: {
                    type: 'object'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        }
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$cd4081e08b45f72e = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$36e4c193ad57e432 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$e2bb6ccb232b5816 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'formatted_text_inline',
                    'code_inline'
                ]
            ],
            allowUnsupportedInline: true,
            minItems: 0
        }
    }
};
const $7579cc59edd0dc9b$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$64324e102160646 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$5c452ff88e35e47d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'image'
            ]
        },
        attrs: {
            props: {
                src: {
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                title: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$daf889beb5092f95 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceJiraIssue'
            ]
        },
        attrs: {
            props: {
                issueKey: {
                    type: 'string'
                },
                macroId: {
                    type: 'string',
                    optional: true
                },
                schemaVersion: {
                    type: 'string',
                    optional: true
                },
                server: {
                    type: 'string',
                    optional: true
                },
                serverId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3e6d667072febc87 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceUnsupportedInline'
            ]
        },
        attrs: {
            props: {
                cxhtml: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3fed98b72ebf1c06 = [
    'hardBreak',
    'mention',
    'emoji',
    'inlineExtension_with_marks',
    'date',
    'placeholder',
    'inlineCard',
    'status',
    'mediaInline'
];
const $7579cc59edd0dc9b$export$18c8ad048e32c7d5 = [
    'formatted_text_inline',
    'code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $7579cc59edd0dc9b$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7579cc59edd0dc9b$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$7c2caff17995c996 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7579cc59edd0dc9b$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'decisionList'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $7579cc59edd0dc9b$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $7579cc59edd0dc9b$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$6e5adfaa13d64d06 = [
    'blockquote',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'paragraph'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$221bcf06d89600af = [
    'blockquote',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'orderedList',
                        'bulletList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'rule',
                    'decisionList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$a2049a0e5c8e6fc7 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$5d60af6db74e5cd3 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'taskList',
                        'rule',
                        'decisionList',
                        'blockquote'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock_with_no_marks',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7579cc59edd0dc9b$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$9b2745ced483e9ab = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_alignment',
            'panel',
            'blockquote',
            'orderedList',
            'bulletList',
            'rule',
            'heading_with_no_marks',
            'heading_with_alignment',
            'heading_with_indentation',
            'codeBlock_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'decisionList',
            'taskList',
            'blockCard',
            'embedCard',
            'extension_with_marks',
            'nestedExpand_with_no_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7579cc59edd0dc9b$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock_with_no_marks',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $7579cc59edd0dc9b$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock_with_no_marks',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$1358dbfffec33cd4 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c30e395ad81940c1 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$ee7b417fdb891082 = [
    'expand',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'non_nestable_block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$e6e4878f43c27cab = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceUnsupportedBlock'
            ]
        },
        attrs: {
            props: {
                cxhtml: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock_with_no_marks',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'panel_with_nested_blockquote',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand_with_no_mark',
    'bodiedExtension_with_marks'
];
const $7579cc59edd0dc9b$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ]
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            },
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $7579cc59edd0dc9b$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock_with_no_marks',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $7579cc59edd0dc9b$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'panel_with_nested_blockquote',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand_with_no_mark',
                    'bodiedExtension_with_marks',
                    'codeBlock_with_marks',
                    'layoutSection_full',
                    'layoutSection_with_single_column',
                    'multiBodiedExtension',
                    'expand_with_breakout_mark'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};

});


parcelRegister("9Psqs", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $4db2155c913df292$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $4db2155c913df292$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $4db2155c913df292$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $4db2155c913df292$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $4db2155c913df292$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $4db2155c913df292$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $4db2155c913df292$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $4db2155c913df292$export$7b85fd78dd236198);
const $4db2155c913df292$export$4e62c701997796c1 = (x)=>x != null;
const $4db2155c913df292$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $4db2155c913df292$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $4db2155c913df292$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $4db2155c913df292$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $4db2155c913df292$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $4db2155c913df292$export$784d13d8ee351f07 = (source, dest, key)=>{
    dest[key] = source[key];
    return dest;
};
const $4db2155c913df292$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("9OCXp", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $a7ed38120a1f6a7d$export$d1b377ca77ac267d);

var $4N6cH = parcelRequire("4N6cH");
const $a7ed38120a1f6a7d$export$d1b377ca77ac267d = {
    safeUrl: (0, $4N6cH.isSafeUrl)
};

});



parcelRegister("dgWxh", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $ef522d3e9c36ad8d$export$a43de96edd8d0a0);

var $cC72g = parcelRequire("cC72g");
var $gsJXf = parcelRequire("gsJXf");

var $auyn4 = parcelRequire("auyn4");

var $3rMck = parcelRequire("3rMck");
let $ef522d3e9c36ad8d$var$rendersMap = {};
const $ef522d3e9c36ad8d$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $gsJXf.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $cC72g.getAnalyticsAppearance)(item.appearance),
                platform: (0, $3rMck.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $ef522d3e9c36ad8d$var$schedule = (fn)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $ef522d3e9c36ad8d$var$DEFAULT_SAMPLING_RATE = 100;
const $ef522d3e9c36ad8d$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$ef522d3e9c36ad8d$var$rendersMap[appearance]) $ef522d3e9c36ad8d$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $ef522d3e9c36ad8d$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $ef522d3e9c36ad8d$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $ef522d3e9c36ad8d$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($ef522d3e9c36ad8d$var$rendersMap[appearance].size === 1) $ef522d3e9c36ad8d$var$schedule(()=>$ef522d3e9c36ad8d$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($ef522d3e9c36ad8d$var$rendersMap[appearance].size % sampleRate === 0) $ef522d3e9c36ad8d$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("gsJXf", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $bc6d1acb6b48a837$export$484b83e0462998d);

var $hYZXM = parcelRequire("hYZXM");
var $bc6d1acb6b48a837$export$6632e71a22d31bf1;
(function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
})($bc6d1acb6b48a837$export$6632e71a22d31bf1 || ($bc6d1acb6b48a837$export$6632e71a22d31bf1 = {}));
const $bc6d1acb6b48a837$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $bc6d1acb6b48a837$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $bc6d1acb6b48a837$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $bc6d1acb6b48a837$export$f9f8a29778652c3e.BLOCKING
    };
};
const $bc6d1acb6b48a837$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $hYZXM.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $hYZXM.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $bc6d1acb6b48a837$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $bc6d1acb6b48a837$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $bc6d1acb6b48a837$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $bc6d1acb6b48a837$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $bc6d1acb6b48a837$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("8RPsP", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $7c51eda11523b776$export$6528700f3fa2fe2a);

var $hYZXM = parcelRequire("hYZXM");
const $7c51eda11523b776$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});


parcelRegister("eNyed", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $9b4f242756c8e56d$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
const $9b4f242756c8e56d$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $byn9U.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $9b4f242756c8e56d$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $9b4f242756c8e56d$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles
    }, children);
};
class $9b4f242756c8e56d$export$79ad592494094f07 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
    }
    // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)($9b4f242756c8e56d$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("czPRi", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $ddb8ae66842d9ef3$export$cfc1361be0de4203);

var $eUqFw = parcelRequire("eUqFw");

var $b3jMP = parcelRequire("b3jMP");

var $XHGTv = parcelRequire("XHGTv");

var $9pV0l = parcelRequire("9pV0l");
function $ddb8ae66842d9ef3$export$cfc1361be0de4203() {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) return null;
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const context = $ddb8ae66842d9ef3$export$92859d13f30c883e(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $ddb8ae66842d9ef3$export$92859d13f30c883e(id) {
    const shouldFixTableResizing = String(Boolean((0, $XHGTv.fg)('platform-fix-table-ssr-resizing')));
    return `
  (function(window){
    ${$ddb8ae66842d9ef3$export$47813c4121c8b4b3};
    (${$ddb8ae66842d9ef3$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${shouldFixTableResizing});
  })(window);
`;
}
const $ddb8ae66842d9ef3$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $b3jMP.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $b3jMP.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $b3jMP.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $b3jMP.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $b3jMP.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $b3jMP.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $9pV0l.FullPagePadding).toString()};
`;
function $ddb8ae66842d9ef3$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    const isFullPage = renderer.classList.contains('is-full-page');
                    const rendererWidth = renderer.offsetWidth;
                    let effectiveWidth;
                    if (shouldFixTableResizing) // Logic from https://stash.atlassian.com/projects/atlassian/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/renderer/src/react/nodes/table.tsx?at=d3af2ef54521ccf10e9b094996ad9528ec05c7e3#610
                    effectiveWidth = isFullPage ? rendererWidth - 2 * breakoutConsts.FullPagePadding : rendererWidth;
                    else effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ item.target.dataset.nodeType === MEDIA_NODE_TYPE) applyMediaBreakout(item.target);
        });
        // Renderer is initially set to hidden until we figure out the proper width in packages/editor/editor-common/src/ui/WidthProvider/index.tsx
        if (renderer.style.visibility === 'hidden') {
            // Hiding until we get the correct width. But didn't remove them from the DOM so vertical scrollbar can still be correctly calculated.
            renderer.style.visibility = '';
            // Since we don't have a screen width to use as initial value.
            // The width is set to a fix number. This will cause horizontal scrollbar to appear.
            // Hide it until we have the correct width.
            renderer.style.overflowX = '';
        }
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    if (shouldFixTableResizing) window.__SSR_BREAKOUT_OBSERVED = true;
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        window.removeEventListener('load', disconnect);
    };
    window.addEventListener('load', disconnect);
}
const $ddb8ae66842d9ef3$export$2a0b3eeee3f2ea40 = (0, $b3jMP.breakoutConsts).calcLineLength;

});

parcelRegister("3y8r4", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $5d02794d72aca87b$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $5d02794d72aca87b$export$66feffbad722f9d4);

var $eUqFw = parcelRequire("eUqFw");

var $4LDRV = parcelRequire("4LDRV");
const $5d02794d72aca87b$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new (0, $4LDRV.default)());
function $5d02794d72aca87b$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $eUqFw.useMemo)(()=>new (0, $4LDRV.default)(true), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d02794d72aca87b$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children));
}
const $5d02794d72aca87b$export$d5fcf151601331bc = $5d02794d72aca87b$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("4LDRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69eb49c2c3d64ed$export$2e2bcd8739ae039);

var $3M3qX = parcelRequire("3M3qX");

var $C2nNl = parcelRequire("C2nNl");

var $ht6w1 = parcelRequire("ht6w1");

var $d6JJW = parcelRequire("d6JJW");

var $71A5J = parcelRequire("71A5J");

var $auyn4 = parcelRequire("auyn4");

var $2hpv2 = parcelRequire("2hpv2");

var $1sePJ = parcelRequire("1sePJ");

var $XHGTv = parcelRequire("XHGTv");
class $c69eb49c2c3d64ed$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $3M3qX.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        return (0, $C2nNl.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $d6JJW.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $d6JJW.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $auyn4.ACTION).DELETED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $d6JJW.RemoveMarkStep) ? (0, $1sePJ.getRendererRangeInlineNodeNames)({
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $71A5J.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $71A5J.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoComment) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $71A5J.getPosFromRange)(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoComment);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $71A5J.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $C2nNl.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        const beforeNodePos = isCommentsOnMediaBugFixEnabled ? // hence, -1 is not needed
        from : // we need to 1 position before it for nodeAt to return the node itself
        Math.max(from - 1, 0);
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $d6JJW.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $71A5J.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $2hpv2.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $1sePJ.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            ...isCommentsOnMediaBugFixEnabled && {
                targetNodeType: targetNodeType
            }
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $2hpv2.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // TODO: Do not forget to remove `undefined` when the
    //       `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $C2nNl.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("C2nNl", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $6e1952b32e9f668f$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $6e1952b32e9f668f$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $6e1952b32e9f668f$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $6e1952b32e9f668f$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $6e1952b32e9f668f$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $6e1952b32e9f668f$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $6e1952b32e9f668f$export$bb1945a828f2864b);

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");
const $6e1952b32e9f668f$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $6e1952b32e9f668f$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    let annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $6e1952b32e9f668f$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $6e1952b32e9f668f$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $6e1952b32e9f668f$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($6e1952b32e9f668f$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $6e1952b32e9f668f$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    let nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $6e1952b32e9f668f$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $6e1952b32e9f668f$export$bb1945a828f2864b(pos) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}

});

parcelRegister("71A5J", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $b3968e5549ee563f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $b3968e5549ee563f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $b3968e5549ee563f$export$74899f7e5acb5cd3);

var $XHGTv = parcelRequire("XHGTv");

var $d6JJW = parcelRequire("d6JJW");
function $b3968e5549ee563f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $b3968e5549ee563f$var$getNodeType = (element)=>element.dataset.nodeType;
function $b3968e5549ee563f$var$isPositionPointer(element) {
    return $b3968e5549ee563f$var$getStartPos(element) > -1;
}
function $b3968e5549ee563f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $b3968e5549ee563f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($b3968e5549ee563f$var$isPositionPointer(parentElement)) return parentElement;
    return $b3968e5549ee563f$var$findParent(parentElement);
}
function $b3968e5549ee563f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $b3968e5549ee563f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $b3968e5549ee563f$var$findMediaParent(parentElement);
}
function $b3968e5549ee563f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($b3968e5549ee563f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($b3968e5549ee563f$var$isPositionPointer(parentElement)) return element;
    return $b3968e5549ee563f$var$findParentBeforePointer(parentElement);
}
function $b3968e5549ee563f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $b3968e5549ee563f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $b3968e5549ee563f$var$isHighlightTextNode(node) {
    return !!node?.dataset?.highlighted;
}
function $b3968e5549ee563f$var$isNodeInlineMark(node) {
    return $b3968e5549ee563f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $b3968e5549ee563f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $b3968e5549ee563f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $b3968e5549ee563f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($b3968e5549ee563f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $b3968e5549ee563f$var$hasInlineNodeDescendant(node) {
    if ($b3968e5549ee563f$var$isElementNode(node)) {
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($b3968e5549ee563f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $b3968e5549ee563f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev && ($b3968e5549ee563f$var$isTextNode(prev) || $b3968e5549ee563f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($b3968e5549ee563f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($b3968e5549ee563f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $b3968e5549ee563f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $b3968e5549ee563f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    if (node instanceof HTMLElement && $b3968e5549ee563f$var$isPositionPointer(node)) return $b3968e5549ee563f$var$getStartPos(node) + offset;
    const parent = $b3968e5549ee563f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $b3968e5549ee563f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $b3968e5549ee563f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($b3968e5549ee563f$var$isNodeInlineTextMark(preParentPointer) || $b3968e5549ee563f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($b3968e5549ee563f$var$isElementInlineMark(preParentPointer) || $b3968e5549ee563f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $b3968e5549ee563f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $b3968e5549ee563f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $b3968e5549ee563f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $b3968e5549ee563f$export$243cdddc5b21d8c1(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $b3968e5549ee563f$var$findParent(startContainer);
    if (isCommentsOnMediaBugVideoCommentEnabled) {
        // Video hover targets return media single, not media, thus, the extra check in condition.
        const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && /media|mediaSingle/.test($b3968e5549ee563f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
        if (isMediaOrMediaSingle) {
            let pos;
            const mediaSingleElement = $b3968e5549ee563f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $b3968e5549ee563f$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $b3968e5549ee563f$var$getStartPos(mediaSingleElement);
            if (pos !== undefined) return {
                from: pos,
                to: pos
            };
        }
    } else if (possibleMediaOrMediaSingleElement && $b3968e5549ee563f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'media') {
        let pos;
        if (isCommentsOnMediaBugFixEnabled) {
            const mediaSingleElement = $b3968e5549ee563f$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $b3968e5549ee563f$var$getStartPos(mediaSingleElement);
        } else pos = $b3968e5549ee563f$var$getStartPos(possibleMediaOrMediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $b3968e5549ee563f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $b3968e5549ee563f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $b3968e5549ee563f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $d6JJW.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("2hpv2", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $b5feef743cb1e04c$export$fb7dab895a0d310e);
function $b5feef743cb1e04c$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $b5feef743cb1e04c$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $b5feef743cb1e04c$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $b5feef743cb1e04c$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("1sePJ", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $a5556de51fea1f38$export$b0ea72d31617ccea);

var $C2nNl = parcelRequire("C2nNl");

var $XHGTv = parcelRequire("XHGTv");
function $a5556de51fea1f38$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $C2nNl.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});



parcelRegister("fGrAu", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $1032568447f01655$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $1032568447f01655$export$cddc3c6ebe2d2cec);

var $eUqFw = parcelRequire("eUqFw");
const { Provider: $1032568447f01655$export$20439b49fdd0d26c, Consumer: $1032568447f01655$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $1032568447f01655$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1032568447f01655$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("51CHm", function(module, exports) {

$parcel$export(module.exports, "AnnotationsWrapper", () => $6d4afb79505778c0$export$cef0157dd42cbb3f);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $8YTuc = parcelRequire("8YTuc");

var $5PgAq = parcelRequire("5PgAq");

var $hM6XC = parcelRequire("hM6XC");

var $hHQQe = parcelRequire("hHQQe");

var $7EYt1 = parcelRequire("7EYt1");

var $bFzGY = parcelRequire("bFzGY");

var $8BrGT = parcelRequire("8BrGT");

var $54EB5 = parcelRequire("54EB5");

var $60fwk = parcelRequire("60fwk");

var $kgIht = parcelRequire("kgIht");
const $6d4afb79505778c0$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender })=>{
    (0, $hHQQe.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender
    });
    return null;
});
const $6d4afb79505778c0$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender } = props;
    const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $7EYt1.useAnnotationStateByTypeEvent)({
        type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM6XC.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM6XC.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BrGT.AnnotationRangeProvider), {
        allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54EB5.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PgAq.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d4afb79505778c0$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8YTuc.AnnotationView), {
        createAnalyticsEvent: createAnalyticsEvent
    }), children)))));
};

});
parcelRegister("8YTuc", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $33f5226cf1895528$export$41cd4a02859c2806);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");

var $7EYt1 = parcelRequire("7EYt1");

var $3y8r4 = parcelRequire("3y8r4");
const $33f5226cf1895528$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const actionContext = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const isCommentsOnMediaAnalyticsEnabled = inlineCommentProvider?.isCommentsOnMediaAnalyticsEnabled;
    const viewComponentProps = (0, $7EYt1.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isCommentsOnMediaAnalyticsEnabled: isCommentsOnMediaAnalyticsEnabled
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $eUqFw.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $eUqFw.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});

parcelRegister("5PgAq", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $cbee67f29564fbf7$export$787af8a111ff3c03);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");

var $kwO9B = parcelRequire("kwO9B");

var $hqR1N = parcelRequire("hqR1N");

var $8BrGT = parcelRequire("8BrGT");
const $cbee67f29564fbf7$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const { range: range, type: type } = (0, $8BrGT.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $8BrGT.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $eUqFw.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $eUqFw.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $eUqFw.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwO9B.RangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            component: hoverComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqR1N.SelectionRangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            selectionComponent: selectionComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM6XC.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft
    }, render);
};

});
parcelRegister("kwO9B", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $ab20af5b23ed434b$export$6d8376a902cb8aa7);

var $eUqFw = parcelRequire("eUqFw");

var $hDLz7 = parcelRequire("hDLz7");

var $3y8r4 = parcelRequire("3y8r4");

var $8BrGT = parcelRequire("8BrGT");

var $54EB5 = parcelRequire("54EB5");

var $hM6XC = parcelRequire("hM6XC");
const $ab20af5b23ed434b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $8BrGT.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $8BrGT.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $54EB5.useAnnotationHoverContext)();
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = providers?.inlineComment.isCommentsOnMediaBugFixEnabled ?? false;
    const isCommentsOnMediaBugVideoCommentEnabled = providers?.inlineComment.isCommentsOnMediaBugVideoCommentEnabled ?? false;
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hDLz7.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("hDLz7", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $708ff088a2bb7e9b$export$2109cd350bcf6eda);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $5uTcm = parcelRequire("5uTcm");

var $88sYM = parcelRequire("88sYM");

var $auyn4 = parcelRequire("auyn4");

var $3y8r4 = parcelRequire("3y8r4");

var $hM6XC = parcelRequire("hM6XC");
const $708ff088a2bb7e9b$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $eUqFw.useState)();
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = Boolean(providers?.inlineComment.isCommentsOnMediaBugFixEnabled);
    const onCreateCallback = (0, $eUqFw.useCallback)((annotationId)=>{
        if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        }).fire((0, $88sYM.FabricChannel).editor);
        return applyAnnotation(draftDocumentPosition || documentPosition, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        isCommentsOnMediaBugFixEnabled
    ]);
    const createIndexCallback = (0, $eUqFw.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eUqFw.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $auyn4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            }).fire((0, $88sYM.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $auyn4.ACTION).OPENED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $88sYM.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $5uTcm.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        isCommentsOnMediaBugFixEnabled,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $eUqFw.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $eUqFw.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).CLOSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $88sYM.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});

parcelRegister("8BrGT", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $6a56f8f8abc5dcf9$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $6a56f8f8abc5dcf9$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $6a56f8f8abc5dcf9$export$708fc397e2b6f08d);

var $eUqFw = parcelRequire("eUqFw");
function $6a56f8f8abc5dcf9$var$reducer(state, action) {
    switch(action.type){
        case 'clear':
            if (!!state.range || !!state.type) return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
}
const $6a56f8f8abc5dcf9$var$AnnotationRangeStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    range: null,
    draftRange: null,
    type: null
});
const $6a56f8f8abc5dcf9$var$AnnotationRangeDispatchContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearDraftRange: ()=>{},
    clearHoverRange: ()=>{},
    setRange: ()=>{},
    setDraftRange: ()=>{}
});
const $6a56f8f8abc5dcf9$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $eUqFw.useReducer)($6a56f8f8abc5dcf9$var$reducer, {
        range: null,
        draftRange: null,
        type: null
    });
    const clearRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $eUqFw.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setRange = (0, $eUqFw.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $eUqFw.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $eUqFw.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const stateData = (0, $eUqFw.useMemo)(()=>({
            range: range,
            draftRange: draftRange,
            type: type
        }), [
        range,
        draftRange,
        type
    ]);
    const dispatchData = (0, $eUqFw.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setRange: setRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setRange,
        setDraftRange,
        setHoverTarget
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a56f8f8abc5dcf9$var$AnnotationRangeStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a56f8f8abc5dcf9$var$AnnotationRangeDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $6a56f8f8abc5dcf9$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $eUqFw.useContext)($6a56f8f8abc5dcf9$var$AnnotationRangeStateContext);
};
const $6a56f8f8abc5dcf9$export$708fc397e2b6f08d = ()=>{
    return (0, $eUqFw.useContext)($6a56f8f8abc5dcf9$var$AnnotationRangeDispatchContext);
};

});

parcelRegister("54EB5", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $50ccccfcb51e23a5$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $50ccccfcb51e23a5$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $50ccccfcb51e23a5$export$c288883964405c82);

var $eUqFw = parcelRequire("eUqFw");
const $50ccccfcb51e23a5$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWithinRange: false
});
const $50ccccfcb51e23a5$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $50ccccfcb51e23a5$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $eUqFw.useState)(false);
    const timeoutHandler = (0, $eUqFw.useRef)();
    const cancelTimeout = (0, $eUqFw.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $eUqFw.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $eUqFw.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $eUqFw.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50ccccfcb51e23a5$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50ccccfcb51e23a5$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $50ccccfcb51e23a5$export$a02bfcbbbf920306 = ()=>{
    return (0, $eUqFw.useContext)($50ccccfcb51e23a5$var$AnnotationHoverStateContext);
};
const $50ccccfcb51e23a5$export$c288883964405c82 = ()=>{
    return (0, $eUqFw.useContext)($50ccccfcb51e23a5$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("hqR1N", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d18a26519cb817d7$export$74435b85e23b84d9);

var $eUqFw = parcelRequire("eUqFw");

var $gaT2d = parcelRequire("gaT2d");

var $gYemZ = parcelRequire("gYemZ");

var $3y8r4 = parcelRequire("3y8r4");

var $hM6XC = parcelRequire("hM6XC");
const $d18a26519cb817d7$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const [range, draftRange, clearRange] = (0, $gaT2d.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = Boolean(providers?.inlineComment.isCommentsOnMediaBugFixEnabled);
    if (!range && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range, isCommentsOnMediaBugFixEnabled);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYemZ.SelectionInlineCommentMounter), {
        range: range,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("gaT2d", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $2b9e605d251de5e6$export$47201332e612f5a4);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $8BrGT = parcelRequire("8BrGT");

var $kCwjj = parcelRequire("kCwjj");

var $71A5J = parcelRequire("71A5J");
const $2b9e605d251de5e6$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $eUqFw.useRef)();
    const { clearRange: clearRange, setRange: setRange } = (0, $8BrGT.useAnnotationRangeDispatch)();
    const { range: range, draftRange: draftRange, type: type } = (0, $8BrGT.useAnnotationRangeState)();
    (0, $eUqFw.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        const onSelectionChange = (event)=>{
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $kCwjj.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    if ((0, $XHGTv.fg)('platform_editor_allow_annotation_triple_click')) {
                        const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                        // ED-23493
                        // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                        // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                        // Triple clicks are the only case that can cause the endContainer to be a non-text node
                        // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                        const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                        // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                        // platform/packages/editor/renderer/src/steps/index.ts Line 180
                        // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                        if (isTripleClick && (0, $71A5J.isRoot)(commonAncestorContainer)) _range.setEnd(startContainer, startContainer.length || 0);
                    }
                    setRange(_range.cloneRange());
                }
            }, 250);
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            document.removeEventListener('selectionchange', onSelectionChange);
            clearRange();
        };
    }, [
        rendererDOM,
        setRange,
        clearRange
    ]);
    return [
        type === 'selection' ? range : null,
        draftRange,
        clearRange
    ];
};

});
parcelRegister("kCwjj", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $2cbbad4c943c0aad$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $2cbbad4c943c0aad$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("gYemZ", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $13ebad160f9e33ff$export$ca7741472ed8ba00);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");

var $5uTcm = parcelRequire("5uTcm");

var $88sYM = parcelRequire("88sYM");

var $auyn4 = parcelRequire("auyn4");

var $1sePJ = parcelRequire("1sePJ");

var $3y8r4 = parcelRequire("3y8r4");

var $hM6XC = parcelRequire("hM6XC");
const $13ebad160f9e33ff$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $eUqFw.useState)();
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = !!providers?.inlineComment.isCommentsOnMediaBugFixEnabled;
    const inlineNodeTypes = (0, $eUqFw.useMemo)(()=>{
        if ((0, $XHGTv.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $1sePJ.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $XHGTv.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $1sePJ.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $eUqFw.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        }).fire((0, $88sYM.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        isCommentsOnMediaBugFixEnabled,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $eUqFw.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eUqFw.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $auyn4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            }).fire((0, $88sYM.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $auyn4.ACTION).OPENED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $88sYM.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $5uTcm.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        isCommentsOnMediaBugFixEnabled,
        actions,
        range,
        inlineNodeTypes
    ]);
    const removeDraftModeCallback = (0, $eUqFw.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $eUqFw.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).CLOSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $88sYM.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("hHQQe", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $8bee4875a94416f4$export$39f7c1a861a0d41c);

var $eUqFw = parcelRequire("eUqFw");

var $3DXMd = parcelRequire("3DXMd");

var $hM6XC = parcelRequire("hM6XC");

var $3y8r4 = parcelRequire("3y8r4");
const $8bee4875a94416f4$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender })=>{
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    (0, $eUqFw.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) return;
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            updateSubscriberInlineComment.emit((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender
    ]);
};

});


parcelRegister("irna0", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $b7527acbcef6bdce$export$3dee5e4542c672d9);


function $b7527acbcef6bdce$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $d493a7c9cb0c9147$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $bab13eb90e97354a$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $bab13eb90e97354a$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $bab13eb90e97354a$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $d493a7c9cb0c9147$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("528fV", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $6634d5910495a92e$export$77218b6ff680865f);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");

var $eQbJA = parcelRequire("eQbJA");
const $6634d5910495a92e$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $eUqFw.useState)();
    const mediaProvider = (0, $eQbJA.useProvider)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $eUqFw.useContext)((0, $kJ7yF.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $eUqFw.useMemo)(()=>mediaClientConfig ? (0, $kJ7yF.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $eUqFw.useEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};

});
parcelRegister("kJ7yF", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a63c6834b952386$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a63c6834b952386$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a63c6834b952386$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a63c6834b952386$export$8b3e87ea56c3a345);

var $eUqFw = parcelRequire("eUqFw");

var $go0co = parcelRequire("go0co");
const $2a63c6834b952386$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $2a63c6834b952386$export$f92e83e86b03c398 = new Map();
const $2a63c6834b952386$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $go0co.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a63c6834b952386$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $go0co.MediaClient)(mediaClientConfig);
        $2a63c6834b952386$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a63c6834b952386$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eUqFw.useMemo)(()=>$2a63c6834b952386$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a63c6834b952386$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $2a63c6834b952386$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($2a63c6834b952386$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("go0co", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $53af8e7882f0f992$export$fba8b4ca6d386aec);

var $4FH8r = parcelRequire("4FH8r");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $EEZOU = parcelRequire("EEZOU");

var $3ixzU = parcelRequire("3ixzU");

var $eJAUz = parcelRequire("eJAUz");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

class $53af8e7882f0f992$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $exlxT.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $EEZOU.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $fmEc3.ChunkHashAlgorithm).Sha256 : (0, $fmEc3.ChunkHashAlgorithm).Sha1
        });
        this.config = mediaClientConfig;
        this.file = new (0, $3ixzU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
        this.stargate = new (0, $eJAUz.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("6o5wg"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4FH8r", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $2fFJv !== 'undefined' && $2fFJv.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $2fFJv.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("2q7Xj", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("iE8r2")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("jrFS0")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("jrFS0")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("fmEc3")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $iE8r2 = parcelRequire("iE8r2");

var $jrFS0 = parcelRequire("jrFS0");

var $fmEc3 = parcelRequire("fmEc3");

});
parcelRegister("iE8r2", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $4cdeb32efb36e469$export$8cef61637918b288);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $4cdeb32efb36e469$export$8cef61637918b288 = {
    streams: new (0, $6roQF.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4FH8r.EventEmitter2)()
};

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("jrFS0", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $a5c9edcfc78df537$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $a5c9edcfc78df537$export$17f6055767a8d96a);
function $a5c9edcfc78df537$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $a5c9edcfc78df537$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $a5c9edcfc78df537$export$17f6055767a8d96a = (auth)=>{
    if ($a5c9edcfc78df537$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("fmEc3", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2714010903136296$export$d3e73a50cc549c2e);
var $2714010903136296$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($2714010903136296$export$d3e73a50cc549c2e || ($2714010903136296$export$d3e73a50cc549c2e = {}));

});


parcelRegister("EEZOU", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $1e7feef2970a1c0d$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $1e7feef2970a1c0d$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $1e7feef2970a1c0d$export$20f9315304dd6726);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
var $jrFS0 = parcelRequire("jrFS0");

var $5Cq8b = parcelRequire("5Cq8b");

var $aFsdc = parcelRequire("aFsdc");

var $4M5UY = parcelRequire("4M5UY");

var $5AvHR = parcelRequire("5AvHR");

var $2WGjX = parcelRequire("2WGjX");

var $gNTpJ = parcelRequire("gNTpJ");

var $bvZYv = parcelRequire("bvZYv");

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $1e7feef2970a1c0d$var$MEDIA_API_REGION = 'media-api-region';
const $1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $1e7feef2970a1c0d$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $aFsdc.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $aFsdc.MAX_RESOLUTION),
            height: (0, $aFsdc.MAX_RESOLUTION)
        } : {}
    };
};
const $1e7feef2970a1c0d$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
class $1e7feef2970a1c0d$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $bvZYv.resolveAuth)(this.config.authProvider, authContext);
        this.resolveInitialAuth = ()=>(0, $bvZYv.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $fmEc3.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $1e7feef2970a1c0d$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
    }
    async getFileBinary(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, undefined, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        return (0, $gNTpJ.mapToMediaCdnUrl)((0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $4M5UY.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $aFsdc.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $2WGjX.createUrl)(artifactUrl, options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = !(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $1e7feef2970a1c0d$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: (0, $XHGTv.fg)('platform.media-card-performance-observer_a803k') && true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
        const auth = await this.resolveAuth(authContext);
        const clientId = (0, $jrFS0.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, $5Cq8b.getRandomHex)(8)
        } : undefined;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $gNTpJ.mapToMediaCdnUrl)(url);
        const response = await (0, $5AvHR.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $1e7feef2970a1c0d$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $1e7feef2970a1c0d$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $1e7feef2970a1c0d$export$c8b741e18397852a = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT);
};
const $1e7feef2970a1c0d$export$20f9315304dd6726 = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION);
};

});
parcelRegister("5Cq8b", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $b1f5fb9992743b46$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $b1f5fb9992743b46$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $b1f5fb9992743b46$export$456b25e3a9b4a843);
const $b1f5fb9992743b46$export$fce6876652108ab = (value)=>value === undefined;
const $b1f5fb9992743b46$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $b1f5fb9992743b46$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $b1f5fb9992743b46$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $b1f5fb9992743b46$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $b1f5fb9992743b46$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $b1f5fb9992743b46$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    }
    else randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("aFsdc", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $8452033603633a1a$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $8452033603633a1a$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $8452033603633a1a$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $8452033603633a1a$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $8452033603633a1a$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $8452033603633a1a$export$f14f521f3d306044);

var $bYwuj = parcelRequire("bYwuj");
const $8452033603633a1a$export$860a16125e30000b = 'recents';
const $8452033603633a1a$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $8452033603633a1a$export$6e70f30e392bc53f = 4096;
const $8452033603633a1a$export$c1abb8bab1e615cd = 5 * (0, $bYwuj.DATA_UNIT).MB;
const $8452033603633a1a$export$3d5157f0def70e54 = 1000;
const $8452033603633a1a$export$f14f521f3d306044 = 2 * (0, $bYwuj.DATA_UNIT).TB;

});
parcelRegister("bYwuj", function(module, exports) {

$parcel$export(module.exports, "DATA_UNIT", () => $e9c15b08e9162a33$export$76cfea4c354af843);
const $e9c15b08e9162a33$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $e9c15b08e9162a33$export$76cfea4c354af843;
(function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})($e9c15b08e9162a33$export$76cfea4c354af843 || ($e9c15b08e9162a33$export$76cfea4c354af843 = {}));

});


parcelRegister("4M5UY", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $d9f7ddb4d1f162b2$export$1cc24defa44e7f84);

var $XHGTv = parcelRequire("XHGTv");

var $gNTpJ = parcelRequire("gNTpJ");

var $6daei = parcelRequire("6daei");
const $d9f7ddb4d1f162b2$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    if (!(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery')) return (0, $gNTpJ.mapToMediaCdnUrl)(`${artifacts[prop]?.url}/cdn`);
    return artifacts[prop]?.url;
};

});
parcelRegister("gNTpJ", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $5aace4118a232dd4$export$fb88a576cf28364d);

var $XHGTv = parcelRequire("XHGTv");

var $6daei = parcelRequire("6daei");
const $5aace4118a232dd4$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
function $5aace4118a232dd4$export$fb88a576cf28364d(url) {
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!(0, $6daei.isFedRamp)() && (0, $XHGTv.fg)('platform.media-cdn-delivery') && (0, $XHGTv.fg)('platform.media-cdn-single-host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $5aace4118a232dd4$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("6daei", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $954ab823235da1ff$export$64d6499adf9b2e51);
const $954ab823235da1ff$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $954ab823235da1ff$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $954ab823235da1ff$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});



parcelRegister("5AvHR", function(module, exports) {

$parcel$export(module.exports, "request", () => $4a84a560f69f3535$export$b5fe3f66a567bec0);

var $7aQon = parcelRequire("7aQon");

var $2WGjX = parcelRequire("2WGjX");
async function $4a84a560f69f3535$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2WGjX.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2WGjX.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2WGjX.createProcessFetchResponse)(metadata));
    return (0, $2WGjX.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("7aQon", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $9c115d8974651e85$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $9c115d8974651e85$export$3717b1ffef4428ea);

var $6bBrC = parcelRequire("6bBrC");
class $9c115d8974651e85$export$43ee7d0e4f429743 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $9c115d8974651e85$export$3717b1ffef4428ea(err) {
    return err instanceof $9c115d8974651e85$export$43ee7d0e4f429743;
}

});
parcelRegister("6bBrC", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $acff2c6dc8396dfc$export$2b0aca14d61c3190);

var $eKK8L = parcelRequire("eKK8L");
class $acff2c6dc8396dfc$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        this.message = message;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("eKK8L", function(module, exports) {

$parcel$export(module.exports, "isMediaClientError", () => $11f35e187e1f2fdf$export$2491e0bbdb59256e);
$parcel$export(module.exports, "getMediaClientErrorReason", () => $11f35e187e1f2fdf$export$c15d72765ee2baa4);
function $11f35e187e1f2fdf$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $11f35e187e1f2fdf$export$c15d72765ee2baa4(err) {
    return $11f35e187e1f2fdf$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("2WGjX", function(module, exports) {

$parcel$export(module.exports, "isRateLimitedError", () => $6c6863351bba029c$export$bc96a6a479480590);
$parcel$export(module.exports, "createUrl", () => $6c6863351bba029c$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $6c6863351bba029c$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $6c6863351bba029c$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $6c6863351bba029c$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $6c6863351bba029c$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $6c6863351bba029c$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $6c6863351bba029c$export$6e2e477edb7d6032);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $hFyZ6 = parcelRequire("hFyZ6");

var $7aQon = parcelRequire("7aQon");
function $6c6863351bba029c$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $6c6863351bba029c$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $6c6863351bba029c$export$bc96a6a479480590(error) {
    return !!error && (0, $7aQon.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $6c6863351bba029c$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $6c6863351bba029c$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$6c6863351bba029c$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$6c6863351bba029c$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $6c6863351bba029c$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $6c6863351bba029c$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $hFyZ6.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $6c6863351bba029c$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$6c6863351bba029c$export$eaf4479116d2f925(auth),
        ...$6c6863351bba029c$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $6c6863351bba029c$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $6c6863351bba029c$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $6c6863351bba029c$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $6c6863351bba029c$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $6c6863351bba029c$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$6c6863351bba029c$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $6c6863351bba029c$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($6c6863351bba029c$export$de0b576cf7ce4a53(err)) throw new (0, $7aQon.RequestError)('clientAbortedRequest', metadata, err);
        if (!$6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) && !(0, $7aQon.isRequestError)(err) || (0, $7aQon.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $7aQon.isRequestError)(lastError)) throw $6c6863351bba029c$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $7aQon.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $6c6863351bba029c$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $6c6863351bba029c$export$6397609af718d008(statusCode);
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...$6c6863351bba029c$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $6c6863351bba029c$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $6c6863351bba029c$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("hFyZ6", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $032b1e5883aca6a7$export$6833b130611df767);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");
function $032b1e5883aca6a7$export$6833b130611df767(auth) {
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("bvZYv", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $9dc00fbb50183c87$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $9dc00fbb50183c87$export$5211e1371264aec3);

var $89khs = parcelRequire("89khs");

var $aSVFn = parcelRequire("aSVFn");
const $9dc00fbb50183c87$export$560085fe411c0660 = 10000;
const $9dc00fbb50183c87$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $9dc00fbb50183c87$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $aSVFn.rejectTimeout)(authProviderTimeout, new (0, $89khs.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $89khs.MediaStoreError)) throw err;
        throw new (0, $89khs.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $89khs.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $9dc00fbb50183c87$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $89khs.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("89khs", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $1f9b2d64052a14af$export$b78480bd311630bc);
$parcel$export(module.exports, "isMediaStoreError", () => $1f9b2d64052a14af$export$8d2a9b675b2ce37a);

var $6bBrC = parcelRequire("6bBrC");
class $1f9b2d64052a14af$export$b78480bd311630bc extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $1f9b2d64052a14af$export$8d2a9b675b2ce37a(err) {
    return err instanceof $1f9b2d64052a14af$export$b78480bd311630bc;
}

});

parcelRegister("aSVFn", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $e63044c0dd9a5237$export$cf2d2a1124beacb2);
const $e63044c0dd9a5237$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e63044c0dd9a5237$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("3ixzU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $f9763f928076fcdc$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("fIVY8")).FileFetcherError);

var $hIoOm = parcelRequire("hIoOm");

var $aynDk = parcelRequire("aynDk");

var $dFBS3 = parcelRequire("dFBS3");
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $8w4F1 = parcelRequire("8w4F1");

var $EEZOU = parcelRequire("EEZOU");

var $9x67R = parcelRequire("9x67R");

var $fIVY8 = parcelRequire("fIVY8");

var $eSb3E = parcelRequire("eSb3E");

var $1l4qL = parcelRequire("1l4qL");

var $59gZB = parcelRequire("59gZB");

var $aFsdc = parcelRequire("aFsdc");

var $bxYYu = parcelRequire("bxYYu");

var $bVMx4 = parcelRequire("bVMx4");

var $04AOJ = parcelRequire("04AOJ");

var $9sBfG = parcelRequire("9sBfG");

var $dpRAQ = parcelRequire("dpRAQ");

var $eqcfa = parcelRequire("eqcfa");
var $9BeXg = parcelRequire("9BeXg");

var $cfjUA = parcelRequire("cfjUA");

var $rMufQ = parcelRequire("rMufQ");

var $3izHV = parcelRequire("3izHV");
var $br8gy = parcelRequire("br8gy");

var $cILCr = parcelRequire("cILCr");

var $eqlnz = parcelRequire("eqlnz");

var $6wdWp = parcelRequire("6wdWp");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

var $XHGTv = parcelRequire("XHGTv");
class $f9763f928076fcdc$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $exlxT.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error?.reason,
                details: error?.attributes,
                occurrenceKey: occurrenceKey,
                message: error?.message
            };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
            const subject = (0, $rMufQ.createMediaSubject)();
            const poll = new (0, $eqlnz.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $fIVY8.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $6wdWp.isEmptyFile)(response)) throw new (0, $fIVY8.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $9x67R.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $dpRAQ.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                if ((0, $br8gy.isMimeTypeSupportedByBrowser)(content.type) || (0, $XHGTv.fg)('platform.media-svg-rendering')) preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $04AOJ.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $bVMx4.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(id)) {
            const subject = (0, $rMufQ.createMediaSubject)();
            const err = new (0, $fIVY8.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err?.reason,
                message: err?.message,
                occurrenceKey: occurrenceKey,
                details: err?.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $eqcfa.fromObservable)(subject);
        }
        return (0, $eqcfa.fromObservable)((0, $1l4qL.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $9BeXg.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $rMufQ.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $cfjUA.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $rMufQ.createMediaSubject)();
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $hIoOm.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $aynDk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $eSb3E.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $eqcfa.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $8w4F1.downloadUrl)(url, {
            name: name
        });
        (0, $59gZB.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $aFsdc.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $EEZOU.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $jrFS0.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $1l4qL.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $3izHV.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $9x67R.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $rMufQ.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $9x67R.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $9x67R.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $cILCr.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $9x67R.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $9x67R.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $9x67R.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $1l4qL.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $rMufQ.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("8w4F1", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $b20aaa7fa9049904$export$8a96edb1c96563f4);
const $b20aaa7fa9049904$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("9x67R", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $4ada6060c1d21d91$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $4ada6060c1d21d91$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $4ada6060c1d21d91$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $4ada6060c1d21d91$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $4ada6060c1d21d91$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $4ada6060c1d21d91$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $4ada6060c1d21d91$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $4ada6060c1d21d91$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $4ada6060c1d21d91$export$ea3730792e8bebfb);
const $4ada6060c1d21d91$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $4ada6060c1d21d91$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $4ada6060c1d21d91$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $4ada6060c1d21d91$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $4ada6060c1d21d91$export$92dd692b31e42e64 = (fileState)=>!$4ada6060c1d21d91$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $4ada6060c1d21d91$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $4ada6060c1d21d91$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $4ada6060c1d21d91$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $4ada6060c1d21d91$export$ea3730792e8bebfb = (id, item)=>{
    return $4ada6060c1d21d91$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("fIVY8", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $0af7ec264212be2b$export$e3e60f0dab8641de);

var $6bBrC = parcelRequire("6bBrC");
class $0af7ec264212be2b$export$e3e60f0dab8641de extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $0af7ec264212be2b$export$5c3435f75ce0ce70(err) {
    return err instanceof $0af7ec264212be2b$export$e3e60f0dab8641de;
}

});

parcelRegister("eSb3E", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $46ff4c8ed9468aee$export$a5575dbeeffdad98);

var $2gF4Y = parcelRequire("2gF4Y");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $fLD6W = parcelRequire("fLD6W");

var $1jayH = parcelRequire("1jayH");

var $aFsdc = parcelRequire("aFsdc");

var $eLiN6 = parcelRequire("eLiN6");
const $46ff4c8ed9468aee$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $fLD6W.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $46ff4c8ed9468aee$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $46ff4c8ed9468aee$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $46ff4c8ed9468aee$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $46ff4c8ed9468aee$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $46ff4c8ed9468aee$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $aFsdc.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $eLiN6.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $eLiN6.fileSizeError)) callbacks?.onUploadFinish(new (0, $1jayH.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $2gF4Y.chunkinator)(content, {
        hashingFunction: (blob)=>$46ff4c8ed9468aee$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $46ff4c8ed9468aee$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $aFsdc.PROCESSING_BATCH_SIZE),
        processingFunction: $46ff4c8ed9468aee$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $jpkPA.from)(deferredUploadId).pipe((0, $eGPtZ.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $eGPtZ.concatMap)(()=>(0, $jpkPA.from)($46ff4c8ed9468aee$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $46ff4c8ed9468aee$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("2gF4Y", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $926a40091d882f6c$export$9ab6bef3838698f8);

var $dBQte = parcelRequire("dBQte");

var $eGPtZ = parcelRequire("eGPtZ");

var $4ZLqF = parcelRequire("4ZLqF");

var $8riMk = parcelRequire("8riMk");

var $fZ5s6 = parcelRequire("fZ5s6");

var $66iic = parcelRequire("66iic");

var $f28UZ = parcelRequire("f28UZ");

var $iYmB8 = parcelRequire("iYmB8");

var $7zy4k = parcelRequire("7zy4k");

var $jpkPA = parcelRequire("jpkPA");
const $926a40091d882f6c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $8riMk.fromPromise)((0, $7zy4k.fetchBlob)(file)).pipe((0, $eGPtZ.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fZ5s6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $66iic.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f28UZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $dBQte.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $iYmB8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $eGPtZ.concatMap)((batchedChunks)=>{
            return (0, $jpkPA.from)(batchedChunks);
        }), (0, $4ZLqF.bufferCount)(totalChunks));
    }));
const $926a40091d882f6c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $926a40091d882f6c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fZ5s6", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $b09d6a25440d952b$export$5b92d769f2f57509);

var $3fnK6 = parcelRequire("3fnK6");

var $aynDk = parcelRequire("aynDk");
const $b09d6a25440d952b$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3fnK6.range)(0, totalChunks).pipe((0, $aynDk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("66iic", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $bba7ef0a5244bc3b$export$d5f5a550a38ec367);

var $7zy4k = parcelRequire("7zy4k");
const $bba7ef0a5244bc3b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $bba7ef0a5244bc3b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $7zy4k.asyncMap)($bba7ef0a5244bc3b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("7zy4k", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $434114a42104e3d7$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $434114a42104e3d7$export$707ee4c4c95d39e3);

var $3JafE = parcelRequire("3JafE");

var $b1qLQ = parcelRequire("b1qLQ");
async function $434114a42104e3d7$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $434114a42104e3d7$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $434114a42104e3d7$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $3JafE.Observable)((sub)=>{
            notifiers.push($434114a42104e3d7$var$notify(project(value), sub, onReady));
        });
};
const $434114a42104e3d7$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $b1qLQ.mergeMap)($434114a42104e3d7$var$mapper(project), concurrent);

});


parcelRegister("f28UZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $6a83285a61ef7586$export$94ce0f3fcf999415);

var $7zy4k = parcelRequire("7zy4k");
const $6a83285a61ef7586$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $7zy4k.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("iYmB8", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $38ace8e9a7e10729$export$2f21790600302ed);

var $4ZLqF = parcelRequire("4ZLqF");

var $eGPtZ = parcelRequire("eGPtZ");
const $38ace8e9a7e10729$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $4ZLqF.bufferCount)(options.batchSize)).pipe((0, $eGPtZ.concatMap)(process));
};

});


parcelRegister("fLD6W", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $80d9fc5820b1f0fe$export$14b114effbc08b6b);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
let $80d9fc5820b1f0fe$var$hasher = null;
let $80d9fc5820b1f0fe$var$sha256Hasher = null;
const $80d9fc5820b1f0fe$export$b7d263e6bc26b29a = ()=>$80d9fc5820b1f0fe$var$hasher = null;



const $80d9fc5820b1f0fe$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $fmEc3.ChunkHashAlgorithm).Sha256) {
        if (!$80d9fc5820b1f0fe$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("a1LbI"));
            $80d9fc5820b1f0fe$var$sha256Hasher = new SimpleHasher();
        }
        return $80d9fc5820b1f0fe$var$sha256Hasher;
    } else if (!$80d9fc5820b1f0fe$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("3Lv0D"));
        $80d9fc5820b1f0fe$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("6y9vP"));
        $80d9fc5820b1f0fe$var$hasher = new SimpleHasher();
    }
    return $80d9fc5820b1f0fe$var$hasher;
};

});
parcelRegister("a1LbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iw25e").then(()=>parcelRequire('4HVlI'));

});

parcelRegister("3Lv0D", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("izugL")
]).then(()=>parcelRequire('kAV1m'));

});

parcelRegister("6y9vP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("lOaWi")
]).then(()=>parcelRequire('7ykMh'));

});


parcelRegister("1jayH", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $93268a427390d3ba$export$515240c3f059c807);

var $6bBrC = parcelRequire("6bBrC");
class $93268a427390d3ba$export$515240c3f059c807 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $93268a427390d3ba$export$80ee180172bc336(err) {
    return err instanceof $93268a427390d3ba$export$515240c3f059c807;
}

});

parcelRegister("eLiN6", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $1d73b7e36a95c49b$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $1d73b7e36a95c49b$export$71f452e02035c1e2);

var $bYwuj = parcelRequire("bYwuj");

var $aFsdc = parcelRequire("aFsdc");
const $1d73b7e36a95c49b$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $1d73b7e36a95c49b$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $aFsdc.MAX_UPLOAD_FILE_SIZE)) throw new Error($1d73b7e36a95c49b$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $bYwuj.DATA_UNIT).GB) return 5 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 50 * (0, $bYwuj.DATA_UNIT).GB) return 50 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 0.95 * (0, $bYwuj.DATA_UNIT).TB) return 100 * (0, $bYwuj.DATA_UNIT).MB;
    return 210 * (0, $bYwuj.DATA_UNIT).MB;
};

});


parcelRegister("1l4qL", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $5b31f9f9111d0f01$export$f2f061938c1e6810);
class $5b31f9f9111d0f01$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $5b31f9f9111d0f01$var$streamCache;

const $5b31f9f9111d0f01$export$f2f061938c1e6810 = ()=>{
    if (!$5b31f9f9111d0f01$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("iE8r2")).mediaState;
        $5b31f9f9111d0f01$var$streamCache = new $5b31f9f9111d0f01$export$4293896e79732236(mediaState.streams);
    }
    return $5b31f9f9111d0f01$var$streamCache;
};

});

parcelRegister("59gZB", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $b6e693db8a3ca69e$export$68d003d3105952ad);
parcelRequire("2q7Xj");
var $iE8r2 = parcelRequire("iE8r2");
const $b6e693db8a3ca69e$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $iE8r2.mediaState).eventEmitter) return (0, $iE8r2.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("bxYYu", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $aul3P = parcelRequire("aul3P");
var $8682131465584b62$require$Buffer = $aul3P.Buffer;
var $8682131465584b62$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8682131465584b62$var$_byteToHex = [];
for(var $8682131465584b62$var$i = 0; $8682131465584b62$var$i < 256; $8682131465584b62$var$i++)$8682131465584b62$var$_byteToHex[$8682131465584b62$var$i] = ($8682131465584b62$var$i + 0x100).toString(16).substr(1);
function $8682131465584b62$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8682131465584b62$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8682131465584b62$require$Buffer.isBuffer(uuid)) parsedUuid = $8682131465584b62$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8682131465584b62$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8682131465584b62$var$extractVersion(parsedUuid);
    else if ($8682131465584b62$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8682131465584b62$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("bVMx4", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $d49dc51366e1ddfa$export$ae188fee39529b82);

var $1l2Nv = parcelRequire("1l2Nv");

var $5Cq8b = parcelRequire("5Cq8b");
const $d49dc51366e1ddfa$export$b79d95ee17a87a = 100;
const $d49dc51366e1ddfa$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $d49dc51366e1ddfa$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $d49dc51366e1ddfa$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collection);
        prev[key] = $d49dc51366e1ddfa$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5Cq8b.getRandomHex)(8),
                spanId: (0, $5Cq8b.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $d49dc51366e1ddfa$export$71cd2e8f8162d47b(keys, items);
    };
}
function $d49dc51366e1ddfa$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))($d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $d49dc51366e1ddfa$export$b79d95ee17a87a
    });
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});


parcelRegister("04AOJ", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $2d99bdcc193fb729$export$ac3214931ffd82af);

var $3izHV = parcelRequire("3izHV");
const $2d99bdcc193fb729$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $3izHV.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("3izHV", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $271e34cd6fe1cabd$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isVideoMimeTypeSupportedByBrowser);

var $hZoAg = parcelRequire("hZoAg");

var $br8gy = parcelRequire("br8gy");

var $5BRco = parcelRequire("5BRco");
const $271e34cd6fe1cabd$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $hZoAg.isArchive)(mimeType)) return 'archive';
    if ((0, $br8gy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $br8gy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $br8gy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $br8gy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("hZoAg", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("br8gy", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $7e5c6394ef188971$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $7e5c6394ef188971$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$55ca6cdaf6093034 = (mimeType)=>$7e5c6394ef188971$export$74325e3c843a9555(mimeType) || $7e5c6394ef188971$export$c021f2623a75015f(mimeType) || $7e5c6394ef188971$export$ff36075ea755a717(mimeType) || $7e5c6394ef188971$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("5BRco", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $85f5842a210424b1$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $85f5842a210424b1$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $85f5842a210424b1$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $85f5842a210424b1$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $85f5842a210424b1$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $85f5842a210424b1$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$548d9148a80556a3 = (mimeType)=>$85f5842a210424b1$export$e9a065a80f76311e(mimeType) || $85f5842a210424b1$export$86baad7a89d908e9(mimeType) || $85f5842a210424b1$export$8cba23825d020bbb(mimeType) || $85f5842a210424b1$export$9c2b4de5fdca2ce3(mimeType) || $85f5842a210424b1$export$94e1479e01d2af53(mimeType);

});



parcelRegister("9sBfG", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $4579abe2682788f5$export$89097c0ec1e0dee1);

var $9x67R = parcelRequire("9x67R");
const $4579abe2682788f5$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $9x67R.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("dpRAQ", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $241808151c7df3d7$export$ed17558b11b88056);
const $241808151c7df3d7$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("eqcfa", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $5370b0715ba587e9$export$4b2432e2d8723823);

var $rMufQ = parcelRequire("rMufQ");
function $5370b0715ba587e9$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $5370b0715ba587e9$export$8659d1f07d151381(item) {
    return $5370b0715ba587e9$export$4b2432e2d8723823((0, $rMufQ.createMediaSubject)(item));
}

});
parcelRegister("rMufQ", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $b1945b205bb99a41$export$bc76d51553fa5e35);

var $lXGL9 = parcelRequire("lXGL9");
function $b1945b205bb99a41$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $lXGL9.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("9BeXg", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $41ac1ff94334ef1d$export$4dbaaf6c79705e6c);

var $hIoOm = parcelRequire("hIoOm");
const $41ac1ff94334ef1d$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $hIoOm.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("cfjUA", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $e97c761e4a22f2e8$export$71797c284d89a3e1);

var $leGRQ = parcelRequire("leGRQ");

var $USL4H = parcelRequire("USL4H");
const $e97c761e4a22f2e8$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $leGRQ.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $USL4H.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("leGRQ", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $dc02c409650d12cb$export$a1c3205f28a20414);
const $dc02c409650d12cb$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("USL4H", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $8e2e403157239a69$export$62aabd5ff85d0451);
const $8e2e403157239a69$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("cILCr", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a);

var $br8gy = parcelRequire("br8gy");
var $5BRco = parcelRequire("5BRco");

var $USL4H = parcelRequire("USL4H");
async function $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $5BRco.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $USL4H.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("eqlnz", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $f01979f4321e41b7$export$4c54d536f8e37dc2);

var $foadk = parcelRequire("foadk");
const $f01979f4321e41b7$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $f01979f4321e41b7$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$f01979f4321e41b7$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("foadk", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $830cdba99e9f23c2$export$c3748c310e92340a);
$parcel$export(module.exports, "isPollingError", () => $830cdba99e9f23c2$export$541e3e52eea6fece);

var $6bBrC = parcelRequire("6bBrC");
class $830cdba99e9f23c2$export$c3748c310e92340a extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $830cdba99e9f23c2$export$541e3e52eea6fece(err) {
    return err instanceof $830cdba99e9f23c2$export$c3748c310e92340a;
}

});


parcelRegister("6wdWp", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $8d001a32183537d3$export$728192ce8dd94659);
const $8d001a32183537d3$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $8d001a32183537d3$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $8d001a32183537d3$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("gHZqD", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("exlxT")).mediaStore);

var $exlxT = parcelRequire("exlxT");

});
parcelRegister("exlxT", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $107a0f046eaf76d8$export$5785580dea19518d);

var $7dY5U = parcelRequire("7dY5U");

var $2Qvr5 = parcelRequire("2Qvr5");

var $gQVOz = parcelRequire("gQVOz");
const $107a0f046eaf76d8$var$mediaStoreWithoutDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    }))));
const $107a0f046eaf76d8$var$mediaStoreWithDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.devtools)((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    })))));
const $107a0f046eaf76d8$export$5785580dea19518d = $107a0f046eaf76d8$var$mediaStoreWithoutDevtools;
const $107a0f046eaf76d8$export$503459913a0dc356 = (initialStore)=>{
    return (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7dY5U", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $45f0a2b2efc9d9f9$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $45f0a2b2efc9d9f9$export$5c593627aef9f076);
var $45f0a2b2efc9d9f9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $45f0a2b2efc9d9f9$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $45f0a2b2efc9d9f9$export$4feba8a1bc8e9afd = $45f0a2b2efc9d9f9$var$reduxImpl;
const $45f0a2b2efc9d9f9$var$trackedConnections = /* @__PURE__ */ new Map();
const $45f0a2b2efc9d9f9$var$getTrackedConnectionState = (name)=>{
    const api = $45f0a2b2efc9d9f9$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $45f0a2b2efc9d9f9$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $45f0a2b2efc9d9f9$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $45f0a2b2efc9d9f9$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $45f0a2b2efc9d9f9$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $45f0a2b2efc9d9f9$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $45f0a2b2efc9d9f9$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$6922d3b3a607469e = $45f0a2b2efc9d9f9$var$devtoolsImpl;
const $45f0a2b2efc9d9f9$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$5c593627aef9f076 = $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl;
const $45f0a2b2efc9d9f9$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $45f0a2b2efc9d9f9$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $45f0a2b2efc9d9f9$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $45f0a2b2efc9d9f9$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $45f0a2b2efc9d9f9$var$oldImpl(config, baseOptions);
    }
    return $45f0a2b2efc9d9f9$var$newImpl(config, baseOptions);
};
const $45f0a2b2efc9d9f9$export$9a6132153fba2e0 = $45f0a2b2efc9d9f9$var$persistImpl;

});

parcelRegister("2Qvr5", function(module, exports) {

$parcel$export(module.exports, "immer", () => $a3e9bebcfca14386$export$428de7ec69ac95c);

var $lbd4c = parcelRequire("lbd4c");
const $a3e9bebcfca14386$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lbd4c.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $a3e9bebcfca14386$export$428de7ec69ac95c = $a3e9bebcfca14386$var$immerImpl;

});
parcelRegister("lbd4c", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $221c0e7836ac0785$export$2e2bcd8739ae039 = fn;

});


parcelRegister("gQVOz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $14d460da377d9036$export$f51a9068ac82ea43);
var $14d460da377d9036$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $14d460da377d9036$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $14d460da377d9036$export$f51a9068ac82ea43 = (createState)=>createState ? $14d460da377d9036$var$createStoreImpl(createState) : $14d460da377d9036$var$createStoreImpl;
var $14d460da377d9036$export$2e2bcd8739ae039 = (createState)=>{
    if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $14d460da377d9036$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("eJAUz", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $aebd1b09d3f1d2ab$export$c66ca190f89caaac);
class $aebd1b09d3f1d2ab$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("6o5wg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kRysi").then(()=>parcelRequire('8gBya'));

});





parcelRegister("iUp5j", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $5ae6a65eeb3660a0$export$d80cf6b7758b1c7e);

var $eUqFw = parcelRequire("eUqFw");

var $fLfen = parcelRequire("fLfen");

var $95Rby = parcelRequire("95Rby");

var $dxcfv = parcelRequire("dxcfv");

var $dWLk9 = parcelRequire("dWLk9");
const $5ae6a65eeb3660a0$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const atlassianAccountId = (0, $dxcfv.useAccountId)();
    const emojiProvider = (0, $eUqFw.useMemo)(()=>{
        const dataProviders = new (0, $fLfen.default)();
        dataProviders.setProvider('emojiProvider', (0, $95Rby.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});
parcelRegister("95Rby", function(module, exports) {

$parcel$export(module.exports, "getEmojiProvider", () => $dd0833923ef463d6$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $dd0833923ef463d6$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $dd0833923ef463d6$export$7cda0fc535c2710f);

var $88oUO = parcelRequire("88oUO");

var $k7z88 = parcelRequire("k7z88");
const $dd0833923ef463d6$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $dd0833923ef463d6$export$8210f5f78c0bcf27 = ()=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $88oUO.default)({
            providers: $dd0833923ef463d6$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $dd0833923ef463d6$export$f9c5a1e85ff0cb72 = (cloudId, accountId)=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$dd0833923ef463d6$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $dd0833923ef463d6$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $88oUO.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider();
    });
const $dd0833923ef463d6$export$7cda0fc535c2710f = (cloudId, accountId)=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$dd0833923ef463d6$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $dd0833923ef463d6$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $88oUO.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider();
    });

});
parcelRegister("88oUO", function(module, exports) {

$parcel$export(module.exports, "supportsUploadFeature", () => $0bc4b679c969736b$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $0bc4b679c969736b$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");

var $dfT6d = parcelRequire("dfT6d");

var $1JT4v = parcelRequire("1JT4v");

var $eG1kR = parcelRequire("eG1kR");

var $cfJOp = parcelRequire("cfJOp");

var $9L9vJ = parcelRequire("9L9vJ");

var $9AK7V = parcelRequire("9AK7V");

var $QniiQ = parcelRequire("QniiQ");

var $7yGtX = parcelRequire("7yGtX");

var $iggLf = parcelRequire("iggLf");
const $0bc4b679c969736b$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $0bc4b679c969736b$export$b5efafc6dd611ec5 extends (0, $16UJG.AbstractResource) {
    constructor(config){
        super();
        this.activeLoaders = 0;
        this.initialLoaders = 0;
        this.retries = new Map();
        this.isInitialised = false;
        this.fetchOnDemand = false;
        this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        };
        this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        };
        this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $cfJOp.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $1JT4v.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $dfT6d.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $9AK7V.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $1JT4v.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $9AK7V.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $9L9vJ.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $9L9vJ.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $9L9vJ.ProviderTypes).ATLASSIAN;
        return (0, $9L9vJ.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $QniiQ.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $7yGtX.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $eG1kR.isPromise)(done)) return done.then(()=>{
                    (0, $1JT4v.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $1JT4v.default)('Failed to prime siteEmojiResource');
                });
                else (0, $1JT4v.default)('Already primed siteEmojiResource');
            } else (0, $1JT4v.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $eG1kR.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $dfT6d.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $eG1kR.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $eG1kR.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $eG1kR.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $iggLf.ufoExperiences)['emoji-searched'].start();
        (0, $iggLf.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $iggLf.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $eG1kR.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $16UJG.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $cfJOp.default)('localStorage')) try {
            window.localStorage.setItem((0, $dfT6d.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $0bc4b679c969736b$export$2e2bcd8739ae039 extends $0bc4b679c969736b$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            return this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("dfT6d", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $6c84915fafd28375$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $6c84915fafd28375$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $6c84915fafd28375$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $6c84915fafd28375$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $6c84915fafd28375$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $6c84915fafd28375$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $6c84915fafd28375$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $6c84915fafd28375$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $6c84915fafd28375$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $6c84915fafd28375$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $6c84915fafd28375$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $6c84915fafd28375$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $6c84915fafd28375$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerMinHeight", () => $6c84915fafd28375$export$94f75d625e7801d3);
$parcel$export(module.exports, "emojiPickerHeight", () => $6c84915fafd28375$export$7ed599d166d65aea);
$parcel$export(module.exports, "emojiPickerListHeight", () => $6c84915fafd28375$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerHeightWithPreview", () => $6c84915fafd28375$export$e67f617938b111f1);
$parcel$export(module.exports, "localStoragePrefix", () => $6c84915fafd28375$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $6c84915fafd28375$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $6c84915fafd28375$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $6c84915fafd28375$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $6c84915fafd28375$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $6c84915fafd28375$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $6c84915fafd28375$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $6c84915fafd28375$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $6c84915fafd28375$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $6c84915fafd28375$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $6c84915fafd28375$export$66cabad5e268b05e);
const $6c84915fafd28375$export$5e4e3d1c3e43156a = 'CUSTOM';
const $6c84915fafd28375$export$78ccdc4be403c468 = 'FREQUENT';
const $6c84915fafd28375$export$2c4b04c3aacdf1b3 = 'SITE';
const $6c84915fafd28375$export$1b0258512be88334 = 'SEARCH';
const $6c84915fafd28375$export$42b510423367f354 = 'USER_CUSTOM';
const $6c84915fafd28375$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $6c84915fafd28375$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $6c84915fafd28375$export$8ac325bfd32359b0 = 'data:';
const $6c84915fafd28375$export$a330961542edfe6f = 'delete-emoji';
const $6c84915fafd28375$export$1a817f1886276c6d = 100000;
const $6c84915fafd28375$export$3f99ac31dc0406db = 20;
const $6c84915fafd28375$export$d171dc12fee2b1da = 350;
const $6c84915fafd28375$export$c10ac8125a260041 = 80;
const $6c84915fafd28375$export$5248fb9e0cccc41f = 'medium';
const $6c84915fafd28375$export$94f75d625e7801d3 = 260;
const $6c84915fafd28375$export$7ed599d166d65aea = 295;
const $6c84915fafd28375$export$7722b8e9522021df = $6c84915fafd28375$export$7ed599d166d65aea - 58; // picker height - actions height
const $6c84915fafd28375$export$e218e5cb105a0e22 = 54;
const $6c84915fafd28375$export$e67f617938b111f1 = $6c84915fafd28375$export$7ed599d166d65aea + $6c84915fafd28375$export$e218e5cb105a0e22;
const $6c84915fafd28375$export$e394a0c530ae5631 = 'fabric.emoji';
const $6c84915fafd28375$export$79ee4ef84c545f8f = `${$6c84915fafd28375$export$e394a0c530ae5631}.selectedTone`;
const $6c84915fafd28375$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $6c84915fafd28375$export$70f9e5bc10d7eac;
(function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
})($6c84915fafd28375$export$70f9e5bc10d7eac || ($6c84915fafd28375$export$70f9e5bc10d7eac = {}));
var $6c84915fafd28375$export$1c4f2adc1f8e19d3;
(function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
})($6c84915fafd28375$export$1c4f2adc1f8e19d3 || ($6c84915fafd28375$export$1c4f2adc1f8e19d3 = {}));
const $6c84915fafd28375$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $6c84915fafd28375$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $6c84915fafd28375$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $6c84915fafd28375$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $6c84915fafd28375$export$4f0ee90b28d6efc5 = 0;
const $6c84915fafd28375$export$9f7de4293d27f3aa = 50;
const $6c84915fafd28375$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $6c84915fafd28375$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $6c84915fafd28375$export$2829f3ec323f8ec0 = 8;
const $6c84915fafd28375$export$ce3a0e7d2d7d6ba2 = 5;
const $6c84915fafd28375$export$858e8dc100a97278 = 150;
const $6c84915fafd28375$export$83aab2ae64548423 = 20;
const $6c84915fafd28375$export$66cabad5e268b05e = 100;

});

parcelRegister("1JT4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f307f280114d75$export$2e2bcd8739ae039);
let $e6f307f280114d75$var$debugEnabled = false;
let $e6f307f280114d75$var$stacktracesEnabled = false;
function $e6f307f280114d75$export$748ada60eaf985cc(enable) {
    $e6f307f280114d75$var$debugEnabled = enable;
}
function $e6f307f280114d75$export$4f7017086af31c25(enable) {
    $e6f307f280114d75$var$stacktracesEnabled = enable;
}
function $e6f307f280114d75$export$2a858f450a2f66d() {
    if ($e6f307f280114d75$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e6f307f280114d75$export$2e2bcd8739ae039(msg, ...args) {
    if ($e6f307f280114d75$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("eG1kR", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $e236d7b13598847d$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $e236d7b13598847d$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $e236d7b13598847d$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $e236d7b13598847d$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $e236d7b13598847d$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $e236d7b13598847d$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $e236d7b13598847d$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $e236d7b13598847d$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $e236d7b13598847d$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $e236d7b13598847d$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $e236d7b13598847d$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $e236d7b13598847d$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $e236d7b13598847d$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $e236d7b13598847d$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $e236d7b13598847d$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $e236d7b13598847d$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $e236d7b13598847d$export$4bcbf61cb6832a8e);

var $iV58y = parcelRequire("iV58y");

var $dfT6d = parcelRequire("dfT6d");
const $e236d7b13598847d$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $e236d7b13598847d$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $e236d7b13598847d$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $e236d7b13598847d$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $e236d7b13598847d$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $e236d7b13598847d$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $e236d7b13598847d$export$a7e82c67204c73a1 = (emoji)=>$e236d7b13598847d$export$979133dc1df141c6(emoji.representation);
const $e236d7b13598847d$export$7720a4954d6f75f8 = (rep)=>$e236d7b13598847d$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $dfT6d.dataURLPrefix)) === 0;
const $e236d7b13598847d$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $dfT6d.customCategory) && $e236d7b13598847d$export$7720a4954d6f75f8(emoji.representation);
const $e236d7b13598847d$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $e236d7b13598847d$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $e236d7b13598847d$export$dddfba07c16c94d2 = (key)=>key in (0, $iV58y.messages);
const $e236d7b13598847d$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $e236d7b13598847d$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $e236d7b13598847d$export$8d7d3de6b5b305d1(emoji);
};
const $e236d7b13598847d$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $e236d7b13598847d$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($e236d7b13598847d$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $e236d7b13598847d$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $e236d7b13598847d$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $e236d7b13598847d$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$e236d7b13598847d$export$979133dc1df141c6(mediaRepresentation) && !$e236d7b13598847d$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $e236d7b13598847d$export$979133dc1df141c6(mediaRepresentation) ? $e236d7b13598847d$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $e236d7b13598847d$export$979133dc1df141c6(mediaAltRepresentation) ? $e236d7b13598847d$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $e236d7b13598847d$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $e236d7b13598847d$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $e236d7b13598847d$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("iV58y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $892439d1838eaeab$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $892439d1838eaeab$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("cfJOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $602498cd222aad7d$export$2e2bcd8739ae039);
function $602498cd222aad7d$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("9L9vJ", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $1374d09a22698b2b$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $1374d09a22698b2b$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $1374d09a22698b2b$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $1374d09a22698b2b$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $1374d09a22698b2b$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $1374d09a22698b2b$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $1374d09a22698b2b$export$482549d945a3723);
var $1374d09a22698b2b$export$a15e9a4340d08b2e;
(function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
})($1374d09a22698b2b$export$a15e9a4340d08b2e || ($1374d09a22698b2b$export$a15e9a4340d08b2e = {}));
var $1374d09a22698b2b$export$db41220f541db607;
(function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
})($1374d09a22698b2b$export$db41220f541db607 || ($1374d09a22698b2b$export$db41220f541db607 = {}));
var $1374d09a22698b2b$export$bf337c9223e5c8b;
(function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
})($1374d09a22698b2b$export$bf337c9223e5c8b || ($1374d09a22698b2b$export$bf337c9223e5c8b = {}));
var $1374d09a22698b2b$export$d0d1c9cd31a11a64;
(function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
})($1374d09a22698b2b$export$d0d1c9cd31a11a64 || ($1374d09a22698b2b$export$d0d1c9cd31a11a64 = {}));
var $1374d09a22698b2b$export$122ce5c8fda96269;
(function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
})($1374d09a22698b2b$export$122ce5c8fda96269 || ($1374d09a22698b2b$export$122ce5c8fda96269 = {}));
var $1374d09a22698b2b$export$265ee18146a6885e;
(function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
})($1374d09a22698b2b$export$265ee18146a6885e || ($1374d09a22698b2b$export$265ee18146a6885e = {}));
var $1374d09a22698b2b$export$482549d945a3723;
(function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
})($1374d09a22698b2b$export$482549d945a3723 || ($1374d09a22698b2b$export$482549d945a3723 = {}));

});

parcelRegister("9AK7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $884c2227220417b5$export$2e2bcd8739ae039);

var $1IjlQ = parcelRequire("1IjlQ");
class $884c2227220417b5$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        const emojisPromise = (0, $1IjlQ.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $1IjlQ.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("1IjlQ", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $d48d07c2901fb5db$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $d48d07c2901fb5db$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $d48d07c2901fb5db$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $d48d07c2901fb5db$export$b7e9058f156d8d19);

var $16UJG = parcelRequire("16UJG");

var $eG1kR = parcelRequire("eG1kR");

var $1JT4v = parcelRequire("1JT4v");
const $d48d07c2901fb5db$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $d48d07c2901fb5db$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $d48d07c2901fb5db$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $16UJG.utils).requestService(serviceConfig, requestOptions);
};
const $d48d07c2901fb5db$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $d48d07c2901fb5db$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $d48d07c2901fb5db$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$d48d07c2901fb5db$var$calculateScale($d48d07c2901fb5db$export$d39ce20a37bba061).altScale];
};
const $d48d07c2901fb5db$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $d48d07c2901fb5db$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $eG1kR.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $eG1kR.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($d48d07c2901fb5db$export$db05e6ae1fd416af(imagePath, meta)) return (0, $eG1kR.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $1JT4v.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $d48d07c2901fb5db$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $d48d07c2901fb5db$export$55077db3efc820aa($d48d07c2901fb5db$export$4a0301d636367e1d(altReps), meta);
};
const $d48d07c2901fb5db$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $d48d07c2901fb5db$export$55077db3efc820aa(representation, meta),
            altRepresentation: $d48d07c2901fb5db$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $d48d07c2901fb5db$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $d48d07c2901fb5db$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $d48d07c2901fb5db$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $d48d07c2901fb5db$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $eG1kR.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $d48d07c2901fb5db$var$getHeight = (fitToHeight)=>$d48d07c2901fb5db$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $d48d07c2901fb5db$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $d48d07c2901fb5db$var$getHeight(fitToHeight) > emoji.representation.height);

});


parcelRegister("QniiQ", function(module, exports) {

$parcel$export(module.exports, "getEmojiVariation", () => $896c1f013ba0c0c9$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $896c1f013ba0c0c9$export$2e2bcd8739ae039);

var $eI6D0 = parcelRequire("eI6D0");

var $dfT6d = parcelRequire("dfT6d");

var $eG1kR = parcelRequire("eG1kR");

var $9L9vJ = parcelRequire("9L9vJ");

var $cQka3 = parcelRequire("cQka3");

var $ekdQj = parcelRequire("ekdQj");

var $5H2wb = parcelRequire("5H2wb");

var $XHGTv = parcelRequire("XHGTv");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $896c1f013ba0c0c9$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $cQka3.tokenizerRegex).lastIndex = 0;
        while((match = (0, $cQka3.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $896c1f013ba0c0c9$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $eG1kR.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$896c1f013ba0c0c9$var$addAllVariants(variation, fnKey, map));
    }
};
const $896c1f013ba0c0c9$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $896c1f013ba0c0c9$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $896c1f013ba0c0c9$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $eG1kR.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $896c1f013ba0c0c9$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $896c1f013ba0c0c9$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $9L9vJ.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $896c1f013ba0c0c9$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $896c1f013ba0c0c9$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $896c1f013ba0c0c9$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $dfT6d.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $dfT6d.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $dfT6d.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $896c1f013ba0c0c9$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $9L9vJ.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $9L9vJ.SearchSort).Default) comparator = (0, $ekdQj.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $9L9vJ.SearchSort).UsageFrequency) comparator = (0, $ekdQj.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $896c1f013ba0c0c9$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $5H2wb.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $XHGTv.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $dfT6d.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $dfT6d.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $eI6D0.Search)('id');
        this.fullSearch.tokenizer = new $896c1f013ba0c0c9$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $eI6D0.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $896c1f013ba0c0c9$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $896c1f013ba0c0c9$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $896c1f013ba0c0c9$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $896c1f013ba0c0c9$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $eG1kR.getCategoryId)(emoji);
        if ((0, $dfT6d.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("eI6D0", function(module, exports) {

$parcel$export(module.exports, "UnorderedSearchIndex", () => $ab5a50fa126dae14$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $ab5a50fa126dae14$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $ab5a50fa126dae14$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $ab5a50fa126dae14$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $ab5a50fa126dae14$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $ab5a50fa126dae14$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $ab5a50fa126dae14$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $ab5a50fa126dae14$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $ab5a50fa126dae14$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $ab5a50fa126dae14$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $ab5a50fa126dae14$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $ab5a50fa126dae14$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $ab5a50fa126dae14$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($ab5a50fa126dae14$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $ab5a50fa126dae14$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $ab5a50fa126dae14$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$ab5a50fa126dae14$export$eeaf491a400e882a.constructor = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.hasOwnProperty = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.isPrototypeOf = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.propertyIsEnumerable = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.toLocaleString = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.toString = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $ab5a50fa126dae14$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$ab5a50fa126dae14$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $ab5a50fa126dae14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ab5a50fa126dae14$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab5a50fa126dae14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab5a50fa126dae14$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $ab5a50fa126dae14$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $ab5a50fa126dae14$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $ab5a50fa126dae14$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $ab5a50fa126dae14$export$147e8ac43c84713a();
        this._tokenizer = new $ab5a50fa126dae14$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $ab5a50fa126dae14$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $ab5a50fa126dae14$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $ab5a50fa126dae14$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $ab5a50fa126dae14$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $ab5a50fa126dae14$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $ab5a50fa126dae14$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("cQka3", function(module, exports) {

$parcel$export(module.exports, "tokenizerRegex", () => $5168aa125a95a93b$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $5168aa125a95a93b$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("ekdQj", function(module, exports) {

$parcel$export(module.exports, "createSearchEmojiComparator", () => $e8b8369d64072d2b$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $e8b8369d64072d2b$export$1bd055808eeccb4e);

var $dfT6d = parcelRequire("dfT6d");

var $eG1kR = parcelRequire("eG1kR");
function $e8b8369d64072d2b$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $e8b8369d64072d2b$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $e8b8369d64072d2b$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $e8b8369d64072d2b$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $e8b8369d64072d2b$export$587c775915dc4869(textQuery, 'shortName'), new $e8b8369d64072d2b$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($e8b8369d64072d2b$export$165e96ceead77edd.Instance, $e8b8369d64072d2b$export$30ce221e1adf48c1.Instance);
    const comparator = new $e8b8369d64072d2b$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $e8b8369d64072d2b$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $e8b8369d64072d2b$export$a8052d0852821684(new $e8b8369d64072d2b$export$55e24837a4bf653(orderedIds), new $e8b8369d64072d2b$export$a7f7a0b04013a8a8(), $e8b8369d64072d2b$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $e8b8369d64072d2b$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $e8b8369d64072d2b$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $e8b8369d64072d2b$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $e8b8369d64072d2b$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $e8b8369d64072d2b$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $e8b8369d64072d2b$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $eG1kR.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $dfT6d.MAX_ORDINAL;
    }
}
class $e8b8369d64072d2b$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $dfT6d.MAX_ORDINAL);
        return score === -1 ? (0, $dfT6d.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $e8b8369d64072d2b$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $dfT6d.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $dfT6d.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $e8b8369d64072d2b$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("5H2wb", function(module, exports) {

$parcel$export(module.exports, "UsageFrequencyTracker", () => $1607f522dcac97f3$export$3f86810331c44209);

var $eG1kR = parcelRequire("eG1kR");

var $dfT6d = parcelRequire("dfT6d");

var $7o5Bb = parcelRequire("7o5Bb");

var $71xPE = parcelRequire("71xPE");

var $cfJOp = parcelRequire("cfJOp");
class $1607f522dcac97f3$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            storage: (0, $cfJOp.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $dfT6d.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $1607f522dcac97f3$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $71xPE.default)(queueOptions);
        } else this.queue = new (0, $7o5Bb.default)(options);
        this.gateway = new $1607f522dcac97f3$export$a0e1fa6601cae894(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $eG1kR.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}
class $1607f522dcac97f3$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("7o5Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1f34ab83bfb90c$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $5a1f34ab83bfb90c$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("71xPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9da82fd0c83dad4$export$2e2bcd8739ae039);

var $7o5Bb = parcelRequire("7o5Bb");

var $1JT4v = parcelRequire("1JT4v");
class $c9da82fd0c83dad4$export$2e2bcd8739ae039 extends (0, $7o5Bb.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$c9da82fd0c83dad4$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $1JT4v.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $1JT4v.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("7yGtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cca0547e59e1546$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");

var $kJ7yF = parcelRequire("kJ7yF");

var $eG1kR = parcelRequire("eG1kR");

var $dikGc = parcelRequire("dikGc");

var $1IjlQ = parcelRequire("1IjlQ");

var $7cjLC = parcelRequire("7cjLC");

var $1JT4v = parcelRequire("1JT4v");
const $3cca0547e59e1546$export$6f3a08dea02a7b2b = 0.95;
class $3cca0547e59e1546$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $eG1kR.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $1IjlQ.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $eG1kR.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $eG1kR.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $7cjLC.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $dikGc.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $eG1kR.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $eG1kR.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $1JT4v.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $kJ7yF.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $3cca0547e59e1546$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $1JT4v.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $1IjlQ.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $1IjlQ.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $1JT4v.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $eG1kR.isMediaEmoji)(emoji) && !(0, $eG1kR.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("dikGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c5314148d9d4e1b$export$2e2bcd8739ae039);

var $eG1kR = parcelRequire("eG1kR");

var $imaW6 = parcelRequire("imaW6");

var $1JT4v = parcelRequire("1JT4v");

var $6roQF = parcelRequire("6roQF");
const $6c5314148d9d4e1b$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $6c5314148d9d4e1b$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $6c5314148d9d4e1b$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $1JT4v.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $6c5314148d9d4e1b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($6c5314148d9d4e1b$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $6c5314148d9d4e1b$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $6c5314148d9d4e1b$var$maxImageSize = 10000;
class $6c5314148d9d4e1b$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $1JT4v.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $6roQF.LRUMap)($6c5314148d9d4e1b$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $6c5314148d9d4e1b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $eG1kR.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $eG1kR.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $6c5314148d9d4e1b$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $1JT4v.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $6c5314148d9d4e1b$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $1JT4v.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $imaW6.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $6c5314148d9d4e1b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $eG1kR.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $eG1kR.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $6c5314148d9d4e1b$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $6c5314148d9d4e1b$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $6c5314148d9d4e1b$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("imaW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c341ca59957c85d$export$2e2bcd8739ae039);

var $eMZQf = parcelRequire("eMZQf");
const $4c341ca59957c85d$var$defaultConcurrentDownloadLimit = 16;
const $4c341ca59957c85d$var$backoffMaxDelayInMillis = 600;
const $4c341ca59957c85d$var$defaultMaxRetriesOnNotFound = 2;
class $4c341ca59957c85d$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $4c341ca59957c85d$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $4c341ca59957c85d$var$defaultMaxRetriesOnNotFound) {
        return (0, $eMZQf.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($4c341ca59957c85d$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("eMZQf", function(module, exports) {

$parcel$export(module.exports, "getNaturalImageSize", () => $64886c8d2111f7ef$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $64886c8d2111f7ef$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $64886c8d2111f7ef$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $64886c8d2111f7ef$export$f8e7886bc155c2e6);
const $64886c8d2111f7ef$var$maxEmojiSizeInBytes = 1048576;
const $64886c8d2111f7ef$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $64886c8d2111f7ef$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $64886c8d2111f7ef$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $64886c8d2111f7ef$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $64886c8d2111f7ef$var$isWebpSupported;
const $64886c8d2111f7ef$export$c5a964eb84c7fca8 = ()=>{
    if ($64886c8d2111f7ef$var$isWebpSupported !== undefined) return Promise.resolve($64886c8d2111f7ef$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $64886c8d2111f7ef$var$isWebpSupported = img.height === 2;
            resolve($64886c8d2111f7ef$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $64886c8d2111f7ef$export$f8e7886bc155c2e6 = ()=>$64886c8d2111f7ef$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("7cjLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $65ca566667d0343f$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");
const $65ca566667d0343f$export$866c20c059277b6 = 30;
class $65ca566667d0343f$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $65ca566667d0343f$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("iggLf", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $9aee8064de0ae72b$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $9aee8064de0ae72b$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $9aee8064de0ae72b$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $9aee8064de0ae72b$export$1466212a1606133);

var $9L9vJ = parcelRequire("9L9vJ");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $7dDfK = parcelRequire("7dDfK");

var $jHs7L = parcelRequire("jHs7L");
const $9aee8064de0ae72b$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Load,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $9aee8064de0ae72b$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Experience,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
    };
};
const $9aee8064de0ae72b$var$customEmojiTimings = [
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $9L9vJ.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $9L9vJ.UfoEmojiTimings).METADATA_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $9L9vJ.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $9L9vJ.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $9L9vJ.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).ONLOAD_END
    }
];
const $9aee8064de0ae72b$export$615f888019c45765 = {
    'emoji-rendered': new (0, $2kFUE.ConcurrentExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $9L9vJ.UfoComponentName).EMOJI
        },
        type: (0, $3yYXq.ExperienceTypes).Operation,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).Custom,
        timings: $9aee8064de0ae72b$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $2kFUE.ConcurrentExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $9aee8064de0ae72b$var$createRenderExperience((0, $9L9vJ.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_PICKER_OPENED, $9aee8064de0ae72b$var$createRenderExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_SELECTION_RECORDED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_UPLOADED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_SEARCHED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER))
};
const $9aee8064de0ae72b$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jHs7L.withSampling)($9aee8064de0ae72b$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $9aee8064de0ae72b$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $9aee8064de0ae72b$export$1466212a1606133 = (providerType)=>{
    return (0, $jHs7L.withSampling)($9aee8064de0ae72b$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});




parcelRegister("jHs7L", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $d5787feff7886cec$export$dc2f0946255b3f89);
const $d5787feff7886cec$export$c7c4959fece2f3ec = {};
const $d5787feff7886cec$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($d5787feff7886cec$export$c7c4959fece2f3ec))delete $d5787feff7886cec$export$c7c4959fece2f3ec[prop];
};
const $d5787feff7886cec$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $d5787feff7886cec$var$hasSampledFromStart = (experience)=>{
    if (!$d5787feff7886cec$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $d5787feff7886cec$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $d5787feff7886cec$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $d5787feff7886cec$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id]) $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $d5787feff7886cec$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});



parcelRegister("k7z88", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SERVICEID", () => $457dd1ed4ad976ac$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $457dd1ed4ad976ac$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $457dd1ed4ad976ac$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $457dd1ed4ad976ac$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $457dd1ed4ad976ac$export$2e2bcd8739ae039);

var $6rW04 = parcelRequire("6rW04");
const $457dd1ed4ad976ac$var$providersRepository = {};
const $457dd1ed4ad976ac$export$f3c4ed49c0fff3de = 'emoji';
const $457dd1ed4ad976ac$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $457dd1ed4ad976ac$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $457dd1ed4ad976ac$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $457dd1ed4ad976ac$export$f8b39b441e3e8eb2 || serviceId === $457dd1ed4ad976ac$export$2cdcb9248b6d4704) return (0, $6rW04.default)('ajs-fabric-emoji-url');
    return (0, $6rW04.default)(`ajs-fabric-${serviceId}-url`);
};
const $457dd1ed4ad976ac$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $457dd1ed4ad976ac$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $457dd1ed4ad976ac$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $457dd1ed4ad976ac$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $457dd1ed4ad976ac$export$59790759c19337ec = ()=>{
    Object.keys($457dd1ed4ad976ac$var$providersRepository).forEach((key)=>{
        delete $457dd1ed4ad976ac$var$providersRepository[key];
    });
};
var $457dd1ed4ad976ac$export$2e2bcd8739ae039 = $457dd1ed4ad976ac$var$getServiceBaseUrl;

});



parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("9XfZZ", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $037fcbfba11ab4d5$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $037fcbfba11ab4d5$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $037fcbfba11ab4d5$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $037fcbfba11ab4d5$export$3f864e37674c79e7);
$parcel$export(module.exports, "useSmartCardIsAIEnabled", () => $037fcbfba11ab4d5$export$af081b1242bfa300);
$parcel$export(module.exports, "SmartCardProviderWithAIHooks", () => $037fcbfba11ab4d5$export$ca9fa6647337e334);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $hqABm = parcelRequire("hqABm");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $4zUUC = parcelRequire("4zUUC");

var $guDlK = parcelRequire("guDlK");
const $037fcbfba11ab4d5$var$isLeftClick = (event)=>event.button === 0;
const $037fcbfba11ab4d5$var$isMiddleClick = (event)=>event.button === 1;
const $037fcbfba11ab4d5$var$isCmdOrCtrlClick = (event)=>$037fcbfba11ab4d5$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $037fcbfba11ab4d5$export$b98882f166bb7ce2 = (url)=>{
    const { hostname: hostname, pathname: pathname } = new URL(url);
    return hostname !== window.location.hostname || ![
        '/jira',
        '/browse'
    ].some((includedPath)=>pathname.startsWith(includedPath));
};
const $037fcbfba11ab4d5$export$dccc97e4cadc9724 = (event, url)=>{
    if (!url) return;
    if ($037fcbfba11ab4d5$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $037fcbfba11ab4d5$var$isCmdOrCtrlClick(mouseEvent) || $037fcbfba11ab4d5$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $037fcbfba11ab4d5$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $hqABm.CardAction).ChangeStatusAction
        ]
    }
};
const $037fcbfba11ab4d5$export$4761115a9e18aa47 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $037fcbfba11ab4d5$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const product = (0, $eUqFw.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $037fcbfba11ab4d5$export$4761115a9e18aa47(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};
const $037fcbfba11ab4d5$export$af081b1242bfa300 = ()=>{
    const isAiOptInEnabled = (0, $hJ992.useIsAiOptInEnabled)();
    const isPremium = (0, $4zUUC.useIsPremium)();
    const isAIFeatureEnabled = (0, $eUqFw.useMemo)(()=>isAiOptInEnabled && isPremium, [
        isAiOptInEnabled,
        isPremium
    ]);
    return isAIFeatureEnabled;
};
const $037fcbfba11ab4d5$export$ca9fa6647337e334 = (props)=>{
    const product = $037fcbfba11ab4d5$export$3f864e37674c79e7();
    const isAIEnabled = $037fcbfba11ab4d5$export$af081b1242bfa300();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAIEnabled,
        ...props
    }, props.children);
};

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);

var $1l2Nv = parcelRequire("1l2Nv");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.fg)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
            if ((0, $XHGTv.fg)('map_new_ors_generic_error_types_in_link_provider')) switch(errorType){
                case 'BadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                case 'AuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                case 'UnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});



parcelRegister("hqABm", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $e9d011026964d0c2$export$f40b7e0b762b928b);
var $e9d011026964d0c2$export$f40b7e0b762b928b;
(function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
})($e9d011026964d0c2$export$f40b7e0b762b928b || ($e9d011026964d0c2$export$f40b7e0b762b928b = {}));

});

parcelRegister("4zUUC", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $800159a3fd254246$export$1bb5840a003dc643);
$parcel$export(module.exports, "useCanOptIn", () => $800159a3fd254246$export$bd66bcf1f00b19d2);
$parcel$export(module.exports, "useOptInStatus", () => $800159a3fd254246$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $800159a3fd254246$export$49e57b9044cda91c);

var $eUqFw = parcelRequire("eUqFw");

var $bW292 = parcelRequire("bW292");
var $dfBCt = parcelRequire("dfBCt");

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $hJ992 = parcelRequire("hJ992");

var $4NMsB = parcelRequire("4NMsB");

var $guDlK = parcelRequire("guDlK");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $1R3n5 = parcelRequire("1R3n5");

var $6dejM = parcelRequire("6dejM");

var $feY12 = parcelRequire("feY12");
const $800159a3fd254246$var$DISABLED = 'disabled';
const $800159a3fd254246$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $800159a3fd254246$var$ENABLED = 'enabled';
const $800159a3fd254246$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    if ((0, $eI5EY.fg)('jwm-spork-ai-fix')) switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.PREMIUM_EDITION);
        default:
            return false;
    }
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $800159a3fd254246$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.STANDARD_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.STANDARD_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.STANDARD_EDITION);
        default:
            return false;
    }
};
const $800159a3fd254246$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPremium = $800159a3fd254246$export$1bb5840a003dc643();
    // ensure isSupportedENV is last in the condiction to follow rules for correct exposure - clean comment with jira_jet_admin_config_ai_upsell_isfedramp_check
    const isSupportedENV = (0, $eI5EY.fg)('jira_jet_admin_config_ai_upsell_isfedramp_check') ? !(0, $dfBCt.isFedRamp)() : true;
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $800159a3fd254246$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isStandard = $800159a3fd254246$export$10e0dafdd792475b();
    // ensure isSupportedENV is last in the condiction to follow rules for correct exposure - clean comment with jira_jet_admin_config_ai_upsell_isfedramp_check
    const isSupportedENV = (0, $eI5EY.fg)('jira_jet_admin_config_ai_upsell_isfedramp_check') ? !(0, $dfBCt.isFedRamp)() : true;
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $800159a3fd254246$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $800159a3fd254246$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $800159a3fd254246$export$1276193c77ae88bf();
    if ((0, $dfBCt.isFedRamp)() && (0, $eI5EY.fg)('jira_jet_admin_config_ai_upsell_isfedramp_check')) return $800159a3fd254246$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
    const { experimentValue: aiUpsellInEditorEnabled } = config.get('experimentEnabled', undefined) !== undefined ? (0, $4NMsB.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: false
    };
    if (aiUpsellInEditorEnabled) return $800159a3fd254246$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $800159a3fd254246$var$DISABLED_OPT_IN : $800159a3fd254246$var$DISABLED;
    return isAIOptedIn ? $800159a3fd254246$var$ENABLED : globalOptInEnabled;
};
const $800159a3fd254246$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $800159a3fd254246$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $eUqFw.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $eUqFw.useState)(false);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const canStartTrial = $800159a3fd254246$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = config.get('experimentEnabled', undefined) !== undefined ? (0, $4NMsB.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $eUqFw.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $eUqFw.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $eUqFw.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $bW292.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dejM.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $eUqFw.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $feY12.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dejM.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $dfBCt.isFedRamp)() && (0, $eI5EY.fg)('jira_jet_admin_config_ai_upsell_isfedramp_check')) return {
        optInStatus: $800159a3fd254246$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $800159a3fd254246$var$DISABLED || optInStatus === $800159a3fd254246$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $800159a3fd254246$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("4NMsB", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $799643b6d2052729$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $799643b6d2052729$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $799643b6d2052729$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dfBCt = parcelRequire("dfBCt");

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $jX9JQ = parcelRequire("jX9JQ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $1R3n5 = parcelRequire("1R3n5");

var $gkhln = parcelRequire("gkhln");
/**
 * Duplicated from @confluence/editor-features/hooks/useAIUpsellInEditorFree
 *
 * This prevents an event from being fired again due to rerenders
 * We could export this for use within the package if needed
 */ const { fireEventOnce: $799643b6d2052729$var$fireEventOnce } = (()=>{
    let hasFired = false;
    return {
        fireEventOnce: (fireFunction)=>{
            if (!hasFired) {
                fireFunction();
                hasFired = true;
            }
        }
    };
})();
const $799643b6d2052729$var$useGetSupportedProjectType = (product)=>{
    switch(product){
        case 'JSW':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'JWM':
        case 'JPD':
        default:
            return undefined;
    }
};
const $799643b6d2052729$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const projectType = $799643b6d2052729$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $6WXNs.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $799643b6d2052729$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
    const statsigExperimentValue = config.get('experimentEnabled', undefined);
    const siteMeetsRequirements = $799643b6d2052729$var$useGetSupportedEdition(product) === (0, $6WXNs.FREE_EDITION) && isOrgAdmin && !(0, $dfBCt.isFedRamp)() && typeof statsigExperimentValue === 'boolean';
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : undefined;
    const fireExposure = (0, $eUqFw.useCallback)(()=>{
        fireExperimentExposure();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'experiment exposed', {
            experimentKey: 'aiUpsellInEditorFree',
            isEligible: siteMeetsRequirements,
            cohort: experimentValue
        });
    }, [
        createAnalyticsEvent,
        experimentValue,
        fireExperimentExposure,
        siteMeetsRequirements
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $799643b6d2052729$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $eUqFw.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $799643b6d2052729$export$38bfb0ec25eaa6b2(product);
    const projectType = $799643b6d2052729$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : undefined;
    // If the site is not FREE, or not on JSW/JWM/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = typeof experimentValue === 'boolean';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue;
    const triggerUpsellFlow = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $gkhln.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $eUqFw.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jX9JQ.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $799643b6d2052729$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isClicked = (0, $gkhln.getUpsellButtonWrapperClicked)();
    (0, $eUqFw.useEffect)(()=>{
        $799643b6d2052729$var$fireEventOnce(()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {}));
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($799643b6d2052729$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($799643b6d2052729$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $799643b6d2052729$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $799643b6d2052729$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _2rko1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jX9JQ", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $833688389b0045eb$export$827041a383456a6a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $833688389b0045eb$var$LazyAiUpsellInEditorFreeModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("tPxHa")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $833688389b0045eb$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($833688389b0045eb$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("tPxHa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("gpc6j")
]).then(()=>parcelRequire('l89s8'));

});


parcelRegister("gkhln", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $cda4e8f5be582724$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $cda4e8f5be582724$export$b595420beb43f9ce);

var $aZaPn = parcelRequire("aZaPn");
const $cda4e8f5be582724$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $cda4e8f5be582724$export$f7d51ee95145148b() {
    return Boolean($cda4e8f5be582724$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $cda4e8f5be582724$export$b595420beb43f9ce(value) {
    $cda4e8f5be582724$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("6dejM", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $8791f6e76183d407$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $8791f6e76183d407$export$bbf8d259a508a485);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $h5i1o = parcelRequire("h5i1o");

var $1HzcR = parcelRequire("1HzcR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3RDyu = parcelRequire("3RDyu");

var $feY12 = parcelRequire("feY12");
const $8791f6e76183d407$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5i1o.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $8791f6e76183d407$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $feY12.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RDyu.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("h5i1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $69751517a92da055$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $6zOB7 = parcelRequire("6zOB7");
var $fI650 = parcelRequire("fI650");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4EGck = parcelRequire("4EGck");


var $6n94o = parcelRequire("6n94o");

var $8Ytlz = parcelRequire("8Ytlz");
const $69751517a92da055$var$VisibleTextOrgAdminStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $69751517a92da055$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: (0, $18ca6aaf45aebeca$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
    };
    const defaultHeader = formatMessage((0, $6n94o.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $6n94o.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $6n94o.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $eUqFw.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($4EGck)))
        ]);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.OptInContainer), null, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ImageWrapper), null, image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4EGck))),
        height: "96px",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ContentContainer), null, isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69751517a92da055$var$VisibleTextOrgAdminStyles
    }, formatMessage((0, $6n94o.messages).aiOptInAdminOnlyVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.BodyWrapper), {
        "data-testid": "dialog-body-text"
    }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onCloseClicked,
        testId: "admin-close-button"
    }, adminCloseCTAText ?? formatMessage((0, $6n94o.messages).aiOptInDialogAdminMaybeLaterButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        appearance: "primary",
        onClick: onCTAClicked,
        href: adminLink ?? (0, $18ca6aaf45aebeca$export$bae9a077d7ed5dfe),
        target: "_blank",
        testId: "admin-cta-button"
    }, adminCTAText ?? formatMessage((0, $6n94o.messages).aiOptInDialogAdminGetStartedButtonText))))));
};
var $69751517a92da055$export$2e2bcd8739ae039 = $69751517a92da055$var$AiOptIn;

});
parcelRegister("4EGck", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $18ca6aaf45aebeca$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $18ca6aaf45aebeca$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("6n94o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e87c7e160d5702b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6e87c7e160d5702b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("8Ytlz", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $2ed1514d8fdcb329$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $2ed1514d8fdcb329$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $2ed1514d8fdcb329$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $2ed1514d8fdcb329$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $2ed1514d8fdcb329$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $2ed1514d8fdcb329$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $2ed1514d8fdcb329$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $2ed1514d8fdcb329$export$24c280970213bb11 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16qs1o46 _2rko14y2 _1yt4v77o _kqswh2mm _11q71lxv",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81bk4",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$14966827497f4695 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81oud",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3RDyu", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $70fc8b4331cd3e90$export$54e4ba490d2c6bb5);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $je5kZ = parcelRequire("je5kZ");

var $cnPHV = parcelRequire("cnPHV");
var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");


var $iFqEI = parcelRequire("iFqEI");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jXPnZ = parcelRequire("jXPnZ");

var $HJoC3 = parcelRequire("HJoC3");
const $70fc8b4331cd3e90$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $70fc8b4331cd3e90$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignBlock: "stretch",
        xcss: $70fc8b4331cd3e90$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $70fc8b4331cd3e90$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $jXPnZ.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($je5kZ)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFqEI.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $70fc8b4331cd3e90$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $jXPnZ.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $jXPnZ.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $HJoC3.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $70fc8b4331cd3e90$var$containerBorderStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$export$c71e4279dd54a18d)})`} 100%
    )`
});
const $70fc8b4331cd3e90$var$containerStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $70fc8b4331cd3e90$var$headerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $70fc8b4331cd3e90$var$textContainerStyles = (0, $1ZAYh.xcss)({
    padding: 'space.300'
});

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});

parcelRegister("iFqEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $701c171f732e62a2$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $glm0s = parcelRequire("glm0s");

var $7lDZc = parcelRequire("7lDZc");
const $701c171f732e62a2$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7lDZc)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($glm0s))
});
var $701c171f732e62a2$export$2e2bcd8739ae039 = $701c171f732e62a2$var$Illustration;
// for advanced use only
const $701c171f732e62a2$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("glm0s", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("7lDZc", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("jXPnZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $97776fe612de153a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $97776fe612de153a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("HJoC3", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $fe79884346a2c282$export$a2651a739f515dd4);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $1n6uL = parcelRequire("1n6uL");


var $l3Qg0 = parcelRequire("l3Qg0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $feY12 = parcelRequire("feY12");

var $jXPnZ = parcelRequire("jXPnZ");
const $fe79884346a2c282$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $feY12.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickAnalytics = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: '14px',
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $jXPnZ.messages).tryItFreeButton));
};

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("feY12", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $f717b66909f6070e$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $f717b66909f6070e$export$dd0a751f23b19473);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $gRxol = parcelRequire("gRxol");

var $6PHwo = parcelRequire("6PHwo");
const $f717b66909f6070e$export$77aa5ca661b0742c = (0, $gRxol.createUseEntryPointContext)();
const $f717b66909f6070e$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $6j4bv.useEntryPoint)((0, $6PHwo.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f717b66909f6070e$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("gRxol", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $1835b430d1386e11$export$41bce2223126846b);

var $eUqFw = parcelRequire("eUqFw");
const $1835b430d1386e11$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eUqFw.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("6PHwo", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("2YWXJ")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2YWXJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("896rB")
]).then(()=>parcelRequire('6l8MW'));

});








parcelRegister("huDma", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $a1dc261b23361a02$export$3dfdef94497f0395);

var $9wcjJ = parcelRequire("9wcjJ");

var $3M3qX = parcelRequire("3M3qX");

var $fjUC0 = parcelRequire("fjUC0");
const $a1dc261b23361a02$var$wikiTransformer = new (0, $fjUC0.WikiMarkupTransformer)((0, $9wcjJ.defaultSchema));
const $a1dc261b23361a02$var$adfTransformer = new (0, $3M3qX.JSONTransformer)();
const $a1dc261b23361a02$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $a1dc261b23361a02$var$wikiTransformer.parse(wiki);
    return $a1dc261b23361a02$var$adfTransformer.encode(pmNode);
};

});
parcelRegister("fjUC0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $d2f4372eeee3db21$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $d2f4372eeee3db21$export$2e2bcd8739ae039);

var $9wcjJ = parcelRequire("9wcjJ");

var $jX0ky = parcelRequire("jX0ky");

var $ZkOGW = parcelRequire("ZkOGW");

var $4RTci = parcelRequire("4RTci");
class $d2f4372eeee3db21$export$caaa00407b56b900 {
    constructor(schema = (0, $9wcjJ.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $jX0ky.encode)(node, $d2f4372eeee3db21$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $ZkOGW.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($d2f4372eeee3db21$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $4RTci.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $d2f4372eeee3db21$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $d2f4372eeee3db21$export$2e2bcd8739ae039 = $d2f4372eeee3db21$export$caaa00407b56b900;

});
parcelRegister("jX0ky", function(module, exports) {

$parcel$export(module.exports, "encode", () => $0118487698e57bdb$export$c564cdbbe6da493);

var $1LRwS = parcelRequire("1LRwS");

var $axYPX = parcelRequire("axYPX");

var $7Risu = parcelRequire("7Risu");

var $9q3yb = parcelRequire("9q3yb");

var $433DX = parcelRequire("433DX");

var $lPxCD = parcelRequire("lPxCD");

var $7rqfg = parcelRequire("7rqfg");

var $haHCt = parcelRequire("haHCt");

var $9PdIu = parcelRequire("9PdIu");

var $hR5ia = parcelRequire("hR5ia");

var $kbkiv = parcelRequire("kbkiv");

var $gKQAY = parcelRequire("gKQAY");

var $cYioR = parcelRequire("cYioR");

var $ikdnB = parcelRequire("ikdnB");

var $lHJNe = parcelRequire("lHJNe");

var $dMxC6 = parcelRequire("dMxC6");

var $fSqxZ = parcelRequire("fSqxZ");

var $kYj1v = parcelRequire("kYj1v");

var $5DckW = parcelRequire("5DckW");
const $0118487698e57bdb$var$nodeEncoderMapping = {
    blockquote: $1LRwS.blockquote,
    bulletList: $axYPX.bulletList,
    taskList: $7Risu.taskList,
    decisionList: $9q3yb.decisionList,
    codeBlock: $433DX.codeBlock,
    doc: $lPxCD.doc,
    heading: $haHCt.heading,
    caption: $5DckW.caption,
    mediaGroup: $9PdIu.mediaGroup,
    mediaInline: $hR5ia.mediaInline,
    mediaSingle: (0, $9PdIu.mediaGroup),
    orderedList: $kbkiv.orderedList,
    panel: $gKQAY.panel,
    paragraph: $cYioR.paragraph,
    rule: $ikdnB.rule,
    table: $lHJNe.table,
    blockCard: $fSqxZ.blockCard,
    embedCard: $kYj1v.embedCard,
    expand: $7rqfg.expand
};
function $0118487698e57bdb$export$c564cdbbe6da493(node, context) {
    const encoder = $0118487698e57bdb$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $dMxC6.unknown)(node);
    } catch (err) {
        return (0, $dMxC6.unknown)(node);
    }
}

});
parcelRegister("1LRwS", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $539cef29ce13843d$export$67dc04e652a298ca);

var $jX0ky = parcelRequire("jX0ky");
const $539cef29ce13843d$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("axYPX", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $9871651c83f0f72e$export$a140c94e5ea26bee);

var $aTpvz = parcelRequire("aTpvz");
const $9871651c83f0f72e$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $aTpvz.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("aTpvz", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b12a5511f73aed40$export$76c7e83ecc9cdf05);

var $jX0ky = parcelRequire("jX0ky");

var $cYioR = parcelRequire("cYioR");

var $dMxC6 = parcelRequire("dMxC6");

var $433DX = parcelRequire("433DX");

var $9PdIu = parcelRequire("9PdIu");

var $hR5ia = parcelRequire("hR5ia");
const $b12a5511f73aed40$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $cYioR.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $jX0ky.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $433DX.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $hR5ia.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $9PdIu.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $dMxC6.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("cYioR", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3a8fdb87076b70f9$export$9c206ddddb32a9b);

var $8wJH0 = parcelRequire("8wJH0");
const $3a8fdb87076b70f9$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("8wJH0", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $fe5949771c5d8168$export$96c94bfc00b85760);

var $3TwFx = parcelRequire("3TwFx");

var $7iOup = parcelRequire("7iOup");

var $hR5ia = parcelRequire("hR5ia");

var $6iCyo = parcelRequire("6iCyo");

var $k7Yq1 = parcelRequire("k7Yq1");

var $JPiHV = parcelRequire("JPiHV");

var $2wGmw = parcelRequire("2wGmw");

var $dMxC6 = parcelRequire("dMxC6");

var $fUy1V = parcelRequire("fUy1V");
const $fe5949771c5d8168$var$inlinesEncoderMapping = {
    emoji: $3TwFx.emoji,
    hardBreak: $7iOup.hardBreak,
    mediaInline: $hR5ia.mediaInline,
    mention: $6iCyo.mention,
    text: $k7Yq1.text,
    inlineCard: $JPiHV.inlineCard,
    status: $2wGmw.status,
    date: $fUy1V.date
};
const $fe5949771c5d8168$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $fe5949771c5d8168$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $dMxC6.unknown)(node);
};

});
parcelRegister("3TwFx", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $169df1ce930d44d5$export$a19185d1233fc4b2);

var $gvgya = parcelRequire("gvgya");

var $dMxC6 = parcelRequire("dMxC6");
const $169df1ce930d44d5$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $gvgya.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $dMxC6.unknown)(node);
};

});
parcelRegister("gvgya", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $b2b613d050f55ecb$export$83e1f26587c4acd2);
const $b2b613d050f55ecb$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("dMxC6", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $2f836652b9d598ce$export$19282c40b967aec6);

var $3M3qX = parcelRequire("3M3qX");
const $2f836652b9d598ce$var$jsonTransformer = new (0, $3M3qX.JSONTransformer)();
const $2f836652b9d598ce$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($2f836652b9d598ce$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("7iOup", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $74a31cb47faf2ba8$export$371da9dd35aba193);
const $74a31cb47faf2ba8$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("hR5ia", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $fffd1208a8d23668$export$38bab695e3f720f1);
const $fffd1208a8d23668$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    let fileName;
    fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("6iCyo", function(module, exports) {

$parcel$export(module.exports, "mention", () => $4b87f050fe0e4cf1$export$db83999c14438df4);
const $4b87f050fe0e4cf1$var$PREFIX = 'accountid:';
const $4b87f050fe0e4cf1$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $4b87f050fe0e4cf1$var$addPrefix = (content)=>content.toLowerCase().startsWith($4b87f050fe0e4cf1$var$PREFIX) ? content : `${$4b87f050fe0e4cf1$var$PREFIX}${content}`;
const $4b87f050fe0e4cf1$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $4b87f050fe0e4cf1$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $4b87f050fe0e4cf1$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("k7Yq1", function(module, exports) {

$parcel$export(module.exports, "text", () => $ce8d8da7c26e4e0f$export$6f093cfa640b7166);

var $2ROXs = parcelRequire("2ROXs");

var $hf3v9 = parcelRequire("hf3v9");

var $sS3Yw = parcelRequire("sS3Yw");

var $lWqfN = parcelRequire("lWqfN");

var $9hhDh = parcelRequire("9hhDh");

var $aiUyl = parcelRequire("aiUyl");

var $4fuiB = parcelRequire("4fuiB");

var $gUCSO = parcelRequire("gUCSO");

var $ijIl1 = parcelRequire("ijIl1");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $ce8d8da7c26e4e0f$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $lWqfN.em)
    ],
    [
        'strike',
        (0, $aiUyl.strike)
    ],
    [
        'strong',
        (0, $4fuiB.strong)
    ],
    [
        'subsup',
        (0, $gUCSO.subsup)
    ],
    [
        'underline',
        (0, $ijIl1.underline)
    ],
    [
        'textColor',
        (0, $sS3Yw.textColor)
    ],
    [
        'link',
        (0, $9hhDh.link)
    ],
    [
        'code',
        (0, $hf3v9.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $ce8d8da7c26e4e0f$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $ce8d8da7c26e4e0f$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $ce8d8da7c26e4e0f$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $ce8d8da7c26e4e0f$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $ce8d8da7c26e4e0f$var$escapingWikiFormatter(text) {
    const pattern = [
        $ce8d8da7c26e4e0f$var$MENTION_ESCAPE_PATTERN,
        ...(0, $2ROXs.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text.replace(new RegExp(pattern, 'g'), '\\$&').replace(new RegExp($ce8d8da7c26e4e0f$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    .replace(new RegExp($ce8d8da7c26e4e0f$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $ce8d8da7c26e4e0f$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    let result = $ce8d8da7c26e4e0f$var$isEscapeNeeded(node, parent) ? $ce8d8da7c26e4e0f$var$escapingWikiFormatter(node.text) : node.text;
    $ce8d8da7c26e4e0f$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("2ROXs", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $9d1fbe0593fabb36$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $9d1fbe0593fabb36$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $9d1fbe0593fabb36$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $9d1fbe0593fabb36$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $9d1fbe0593fabb36$export$bcec6d03770b152c);

var $lS4Zv = parcelRequire("lS4Zv");

var $3O0Q2 = parcelRequire("3O0Q2");
const $9d1fbe0593fabb36$export$afcd7edeca61ca93 = [
    {
        type: (0, $lS4Zv.TokenType).ADF_MACRO,
        regex: /^{adf/i
    },
    {
        type: (0, $lS4Zv.TokenType).ANCHOR_MACRO,
        regex: /^{anchor/i
    },
    {
        type: (0, $lS4Zv.TokenType).CODE_MACRO,
        regex: /^{code/i
    },
    {
        type: (0, $lS4Zv.TokenType).QUOTE_MACRO,
        regex: /^{quote/i
    },
    {
        type: (0, $lS4Zv.TokenType).NOFORMAT_MACRO,
        regex: /^{noformat/i
    },
    {
        type: (0, $lS4Zv.TokenType).PANEL_MACRO,
        regex: /^{panel/i
    },
    {
        type: (0, $lS4Zv.TokenType).COLOR_MACRO,
        regex: /^{color/
    },
    {
        type: (0, $lS4Zv.TokenType).LOREM_MACRO,
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $9d1fbe0593fabb36$var$keywordTokenMap = {
    '[': (0, $lS4Zv.TokenType).LINK_FORMAT,
    http: (0, $lS4Zv.TokenType).LINK_TEXT,
    ftp: (0, $lS4Zv.TokenType).LINK_TEXT,
    jamfselfservice: (0, $lS4Zv.TokenType).LINK_TEXT,
    irc: (0, $lS4Zv.TokenType).LINK_TEXT,
    mailto: (0, $lS4Zv.TokenType).LINK_TEXT,
    '\\\\': (0, $lS4Zv.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $lS4Zv.TokenType).HARD_BREAK,
    '\n': (0, $lS4Zv.TokenType).HARD_BREAK,
    '\r\n': (0, $lS4Zv.TokenType).HARD_BREAK,
    '!': (0, $lS4Zv.TokenType).MEDIA,
    '----': (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $lS4Zv.TokenType).DELETED,
    '{+}': (0, $lS4Zv.TokenType).INSERTED,
    '{*}': (0, $lS4Zv.TokenType).STRONG,
    '{^}': (0, $lS4Zv.TokenType).SUPERSCRIPT,
    '{~}': (0, $lS4Zv.TokenType).SUBSCRIPT,
    '{_}': (0, $lS4Zv.TokenType).EMPHASIS,
    '{{{}': (0, $lS4Zv.TokenType).MONOSPACE,
    '{??}': (0, $lS4Zv.TokenType).CITATION,
    '-': (0, $lS4Zv.TokenType).DELETED,
    '+': (0, $lS4Zv.TokenType).INSERTED,
    '*': (0, $lS4Zv.TokenType).STRONG,
    '^': (0, $lS4Zv.TokenType).SUPERSCRIPT,
    '~': (0, $lS4Zv.TokenType).SUBSCRIPT,
    _: (0, $lS4Zv.TokenType).EMPHASIS,
    '{{': (0, $lS4Zv.TokenType).MONOSPACE,
    '??': (0, $lS4Zv.TokenType).CITATION
};
const $9d1fbe0593fabb36$var$keywordTokenMapKeys = Object.keys($9d1fbe0593fabb36$var$keywordTokenMap);
function $9d1fbe0593fabb36$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$export$afcd7edeca61ca93.length; i++){
        const keyword = $9d1fbe0593fabb36$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $9d1fbe0593fabb36$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($9d1fbe0593fabb36$var$keywordTokenMapKeys[i])) return {
            type: $9d1fbe0593fabb36$var$keywordTokenMap[$9d1fbe0593fabb36$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $lS4Zv.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $9d1fbe0593fabb36$var$leadingKeywordTokenMap = [
    {
        type: (0, $lS4Zv.TokenType).QUOTE,
        regex: /^bq\./
    },
    {
        type: (0, $lS4Zv.TokenType).HEADING,
        regex: /^h[1-6]\./
    },
    {
        type: (0, $lS4Zv.TokenType).RULER,
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        regex: /^-{3}\s/
    },
    {
        type: (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $lS4Zv.TokenType).LIST,
        regex: new RegExp(`^([*#]{1,${(0, $3O0Q2.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $lS4Zv.TokenType).TABLE,
        regex: /^\|{1,2}/
    }
];
function $9d1fbe0593fabb36$export$68162fc57528b560(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$var$leadingKeywordTokenMap.length; i++){
        const keyword = $9d1fbe0593fabb36$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $9d1fbe0593fabb36$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $lS4Zv.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("lS4Zv", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $845998d063b9ab8b$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $845998d063b9ab8b$export$af8f4e8328578827);

var $iw2bq = parcelRequire("iw2bq");

var $fxycA = parcelRequire("fxycA");

var $a4Ddm = parcelRequire("a4Ddm");

var $70iSu = parcelRequire("70iSu");

var $bufmJ = parcelRequire("bufmJ");

var $jPNoV = parcelRequire("jPNoV");

var $gJccQ = parcelRequire("gJccQ");

var $g0NwP = parcelRequire("g0NwP");

var $jCitd = parcelRequire("jCitd");

var $r2pEr = parcelRequire("r2pEr");

var $lccs8 = parcelRequire("lccs8");

var $crpDl = parcelRequire("crpDl");

var $3O0Q2 = parcelRequire("3O0Q2");

var $kJ7iC = parcelRequire("kJ7iC");

var $lDSkN = parcelRequire("lDSkN");

var $eyWXo = parcelRequire("eyWXo");

var $66xYR = parcelRequire("66xYR");

var $jWDvo = parcelRequire("jWDvo");

var $4333j = parcelRequire("4333j");

var $VuFCw = parcelRequire("VuFCw");

var $gakJc = parcelRequire("gakJc");

var $j2mJE = parcelRequire("j2mJE");

var $a5fMg = parcelRequire("a5fMg");

var $adHlr = parcelRequire("adHlr");

var $48Szy = parcelRequire("48Szy");

var $3ZquL = parcelRequire("3ZquL");

var $cvl2z = parcelRequire("cvl2z");

var $5PrNl = parcelRequire("5PrNl");

var $eTIGc = parcelRequire("eTIGc");

var $4RTci = parcelRequire("4RTci");
var $845998d063b9ab8b$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
})($845998d063b9ab8b$export$f435f793048e7a0f || ($845998d063b9ab8b$export$f435f793048e7a0f = {}));
const $845998d063b9ab8b$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $bufmJ.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $gakJc.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $lDSkN.quadrupleDashSymbol),
    ["RULER"]: (0, $eyWXo.ruler),
    ["STRONG"]: (0, $66xYR.strong),
    ["MONOSPACE"]: (0, $kJ7iC.monospace),
    ["SUPERSCRIPT"]: (0, $4333j.superscript),
    ["SUBSCRIPT"]: (0, $jWDvo.subscript),
    ["EMPHASIS"]: (0, $gJccQ.emphasis),
    ["CITATION"]: (0, $a4Ddm.citation),
    ["DELETED"]: (0, $70iSu.deleted),
    ["INSERTED"]: (0, $r2pEr.inserted),
    ["HARD_BREAK"]: (0, $g0NwP.hardbreak),
    ["LINK_FORMAT"]: (0, $lccs8.linkFormat),
    ["LINK_TEXT"]: (0, $crpDl.linkText),
    ["HEADING"]: (0, $jCitd.heading),
    ["MEDIA"]: (0, $iw2bq.media),
    ["LIST"]: (0, $3O0Q2.list),
    ["QUOTE"]: (0, $fxycA.blockquote),
    ["TABLE"]: (0, $VuFCw.table),
    ["EMOJI"]: (0, $jPNoV.emoji),
    ["ADF_MACRO"]: (0, $a5fMg.adfMacro),
    ["ANCHOR_MACRO"]: (0, $adHlr.anchorMacro),
    ["CODE_MACRO"]: (0, $48Szy.codeMacro),
    ["QUOTE_MACRO"]: (0, $3ZquL.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $5PrNl.noformatMacro),
    ["PANEL_MACRO"]: (0, $j2mJE.panelMacro),
    ["COLOR_MACRO"]: (0, $cvl2z.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $eTIGc.forceLineBreak),
    ["ISSUE_KEY"]: (0, $4RTci.issueKey)
};
function $845998d063b9ab8b$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $845998d063b9ab8b$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $845998d063b9ab8b$var$fallback(input, position);
    }
    return $845998d063b9ab8b$var$fallback(input, position);
}
function $845998d063b9ab8b$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("iw2bq", function(module, exports) {

$parcel$export(module.exports, "media", () => $7fde38853f3c310a$export$987d49ffe1b0900f);

var $1hrvA = parcelRequire("1hrvA");

var $dFOSZ = parcelRequire("dFOSZ");

var $cndSn = parcelRequire("cndSn");
const $7fde38853f3c310a$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $1hrvA.default)(schema, rawContent, (0, $dFOSZ.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("1hrvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b0fc5f200f5aa47$export$2e2bcd8739ae039);

var $crpDl = parcelRequire("crpDl");
const $6b0fc5f200f5aa47$var$defaultWidth = 200;
const $6b0fc5f200f5aa47$var$defaultHeight = 183;
const $6b0fc5f200f5aa47$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $6b0fc5f200f5aa47$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $6b0fc5f200f5aa47$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $6b0fc5f200f5aa47$var$defaultHeight;
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $6b0fc5f200f5aa47$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $crpDl.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("crpDl", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $1765ab2dd26cbf7e$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $1765ab2dd26cbf7e$export$cb7bcf09a05b7705);

var $4N6cH = parcelRequire("4N6cH");

var $h2tDj = parcelRequire("h2tDj");
const $1765ab2dd26cbf7e$export$f69d1dce349473aa = /^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $1765ab2dd26cbf7e$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    let matches = input.substring(position).match($1765ab2dd26cbf7e$export$f69d1dce349473aa);
    if (!matches) return $1765ab2dd26cbf7e$var$fallback(input, position);
    const match = $1765ab2dd26cbf7e$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $h2tDj.decode)($1765ab2dd26cbf7e$var$unescape(match[0]));
    if (!(0, $4N6cH.isSafeUrl)(url)) return $1765ab2dd26cbf7e$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $1765ab2dd26cbf7e$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $1765ab2dd26cbf7e$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $1765ab2dd26cbf7e$var$trimBadEndChar(input) {
    return [
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("h2tDj", function(module, exports) {

$parcel$export(module.exports, "decode", () => $43b235301c60f824$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $43b235301c60f824$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("dFOSZ", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $839f2e057ddb173e$export$e1a9355cfd8f6c64);
function $839f2e057ddb173e$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("cndSn", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $9fc0c7cd3a3bb618$export$a71d57024d3da1c5);

var $lS4Zv = parcelRequire("lS4Zv");

var $lccs8 = parcelRequire("lccs8");

var $kJkY5 = parcelRequire("kJkY5");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $5YILC = parcelRequire("5YILC");
const $9fc0c7cd3a3bb618$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $9fc0c7cd3a3bb618$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $9fc0c7cd3a3bb618$var$processState.START;
    let buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $9fc0c7cd3a3bb618$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $9fc0c7cd3a3bb618$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                    state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $9fc0c7cd3a3bb618$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(index));
                    if (length) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $9fc0c7cd3a3bb618$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $9fc0c7cd3a3bb618$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $9fc0c7cd3a3bb618$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $9fc0c7cd3a3bb618$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $9fc0c7cd3a3bb618$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $9fc0c7cd3a3bb618$var$processState.INLINE_MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $lS4Zv.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                }
            case $9fc0c7cd3a3bb618$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $lccs8.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    }
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                }
            case $9fc0c7cd3a3bb618$var$processState.ESCAPE:
                {
                    const token = (0, $5YILC.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
}
function $9fc0c7cd3a3bb618$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("lccs8", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $ac24b5ba4dac9799$export$e1f888a4b6f2ee53);

var $lS4Zv = parcelRequire("lS4Zv");

var $7pbqq = parcelRequire("7pbqq");

var $4GRNK = parcelRequire("4GRNK");

var $6YhuH = parcelRequire("6YhuH");
// [http://www.example.com] and [Example|http://www.example.com]
const $ac24b5ba4dac9799$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $ac24b5ba4dac9799$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($ac24b5ba4dac9799$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER,
        // We want to avoid recursion
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).LINK_FORMAT
    ];
    if (!match) return $ac24b5ba4dac9799$var$fallback();
    const content = (0, $6YhuH.parseContentLink)(match[1]);
    const resolvedLink = (0, $4GRNK.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $ac24b5ba4dac9799$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("7pbqq", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $929d37db672b2042$export$960addfb9e5a0cde);

var $h1mQ4 = parcelRequire("h1mQ4");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $5YILC = parcelRequire("5YILC");

var $gwvPQ = parcelRequire("gwvPQ");
const $929d37db672b2042$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $929d37db672b2042$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $929d37db672b2042$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $lS4Zv.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $929d37db672b2042$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $kJkY5.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $2ROXs.parseLeadingKeyword)(substring) || (0, $2ROXs.parseMacroKeyword)(substring) || (0, $2ROXs.parseOtherKeyword)(substring) || (0, $2ROXs.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $929d37db672b2042$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $929d37db672b2042$var$processState.BUFFER;
                        continue;
                    }
                }
            case $929d37db672b2042$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $2ROXs.parseOtherKeyword)(substring);
                    else match = (0, $2ROXs.parseMacroKeyword)(substring) || (0, $2ROXs.parseOtherKeyword)(substring) || (0, $2ROXs.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $929d37db672b2042$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $929d37db672b2042$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $929d37db672b2042$var$processState.TOKEN:
                {
                    const token = (0, $lS4Zv.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $lS4Zv.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $gwvPQ.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $929d37db672b2042$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $929d37db672b2042$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $h1mQ4.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $lS4Zv.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $lS4Zv.TokenType).HARD_BREAK) state = $929d37db672b2042$var$processState.NEWLINE;
                    else state = $929d37db672b2042$var$processState.BUFFER;
                    continue;
                }
            case $929d37db672b2042$var$processState.ESCAPE:
                {
                    const token = (0, $5YILC.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $929d37db672b2042$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $gwvPQ.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $h1mQ4.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $929d37db672b2042$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $929d37db672b2042$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("h1mQ4", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $47520f02a58e88f7$export$b2ce9ad90858ed7a);
function $47520f02a58e88f7$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("kJkY5", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $9ca95fb6aba50881$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $9ca95fb6aba50881$export$9c597b035e16623b);
function $9ca95fb6aba50881$export$877995a80ec11782(input) {
    const newlineLength = $9ca95fb6aba50881$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $9ca95fb6aba50881$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $9ca95fb6aba50881$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $9ca95fb6aba50881$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("5YILC", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $af3b953fda1d38b5$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $af3b953fda1d38b5$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $af3b953fda1d38b5$export$d16e8e6cf9622f9a(input, position) {
    let buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($af3b953fda1d38b5$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("gwvPQ", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $76235613b8bd397e$export$e21f6b7efdaf8b5d);

var $PbPoX = parcelRequire("PbPoX");
function $76235613b8bd397e$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $76235613b8bd397e$var$normalizeMediaGroups,
        $76235613b8bd397e$export$2cef2a4c047f9887,
        $76235613b8bd397e$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $76235613b8bd397e$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($76235613b8bd397e$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $76235613b8bd397e$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $PbPoX.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $PbPoX.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $PbPoX.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $76235613b8bd397e$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($76235613b8bd397e$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($76235613b8bd397e$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($76235613b8bd397e$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $76235613b8bd397e$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $76235613b8bd397e$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $76235613b8bd397e$var$isHardBreak(n, separatorBuffer) || !$76235613b8bd397e$var$isEmptyTextNode(n) || $76235613b8bd397e$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $76235613b8bd397e$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $76235613b8bd397e$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $76235613b8bd397e$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $76235613b8bd397e$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $76235613b8bd397e$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("PbPoX", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $66324d8d739edb2f$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $66324d8d739edb2f$export$f0eaed48ea684567);
function $66324d8d739edb2f$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $66324d8d739edb2f$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("4GRNK", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $42e2c78a7d1992c7$export$c2baa561eb017101);

var $53dGQ = parcelRequire("53dGQ");

var $hV0Ud = parcelRequire("hV0Ud");

var $eQxlw = parcelRequire("eQxlw");

var $3JaZI = parcelRequire("3JaZI");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $42e2c78a7d1992c7$var$linkResolverStrategies = [
    (0, $hV0Ud.attachmentLinkResolver),
    (0, $53dGQ.mentionLinkResolver),
    (0, $3JaZI.issueLinkResolver),
    (0, $eQxlw.urlLinkResolver)
];
function $42e2c78a7d1992c7$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $42e2c78a7d1992c7$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("53dGQ", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $35dd3b4723d09d0e$export$1da3b34e38fc6ca8);
function $35dd3b4723d09d0e$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("hV0Ud", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $40bebdfc438dbfb7$export$ce918f41a76b8445);

var $4wFmF = parcelRequire("4wFmF");
function $40bebdfc438dbfb7$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4wFmF.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4wFmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $712942d98c68bb4f$export$2e2bcd8739ae039);
function $712942d98c68bb4f$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("eQxlw", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $081728bf52cebca2$export$b737d556d2167f9);

var $lS4Zv = parcelRequire("lS4Zv");

var $4N6cH = parcelRequire("4N6cH");

var $7pbqq = parcelRequire("7pbqq");

var $8loUC = parcelRequire("8loUC");
function $081728bf52cebca2$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $4N6cH.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $7pbqq.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$081728bf52cebca2$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $081728bf52cebca2$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("8loUC", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $a360c9f677e08143$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $a360c9f677e08143$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $a360c9f677e08143$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $a360c9f677e08143$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $a360c9f677e08143$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $a360c9f677e08143$export$83347051c3437dc9);
function $a360c9f677e08143$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $a360c9f677e08143$export$727d9dbc4fbb948f(value) {
    return !!value.match(/^\d$/);
}
function $a360c9f677e08143$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $a360c9f677e08143$export$4d9e7a1c098df5e2(value) {
    return !$a360c9f677e08143$export$7ee701e290d9865(value);
}
const $a360c9f677e08143$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $a360c9f677e08143$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("3JaZI", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $0352545efe304712$export$f40ed0efa65d4e8);

var $4RTci = parcelRequire("4RTci");
function $0352545efe304712$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || linkTitle === 'block-link' // TODO: Depricated should be removed in the next major release
    ) return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $4RTci.getIssue)(context, originalLinkText);
    if (issue) return (0, $4RTci.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("4RTci", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $a6928660ab95804f$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $a6928660ab95804f$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $a6928660ab95804f$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $a6928660ab95804f$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $a6928660ab95804f$export$cd8701ad7512efee);

var $8loUC = parcelRequire("8loUC");
const $a6928660ab95804f$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $a6928660ab95804f$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $a6928660ab95804f$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $a6928660ab95804f$var$fallback(input, position);
    const issue = $a6928660ab95804f$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $a6928660ab95804f$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $8loUC.isNotBlank)(charBefore) && $a6928660ab95804f$var$isNotAllowedChars(charBefore) || (0, $8loUC.isNotBlank)(charAfter) && $a6928660ab95804f$var$isNotAllowedChars(charAfter)) return $a6928660ab95804f$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $a6928660ab95804f$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $a6928660ab95804f$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $a6928660ab95804f$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $a6928660ab95804f$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $a6928660ab95804f$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $a6928660ab95804f$var$withInlineCardFromTextStamp = (issue)=>$a6928660ab95804f$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
const $a6928660ab95804f$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $a6928660ab95804f$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("6YhuH", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $a6f686c8544fb04b$export$3a250a08d37b0eae);

var $8loUC = parcelRequire("8loUC");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $a6f686c8544fb04b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $a6f686c8544fb04b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $a6f686c8544fb04b$var$divideOn(buffer, '|');
    const body = new (0, $8loUC.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $a6f686c8544fb04b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $a6f686c8544fb04b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $a6f686c8544fb04b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $a6f686c8544fb04b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $a6f686c8544fb04b$var$extractNumber(buf) {
    const digits = new (0, $8loUC.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $8loUC.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $a6f686c8544fb04b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $8loUC.StringBuffer)(linkText);
    const linkBody = $a6f686c8544fb04b$var$extractLinkBody(buf);
    const linkTitle = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $a6f686c8544fb04b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $a6f686c8544fb04b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $8loUC.StringBuffer)(notLinkBody);
        shortcutName = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $8loUC.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $8loUC.StringBuffer)(notLinkBody);
    if ((0, $8loUC.isBlank)(shortcutName)) {
        spaceKey = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $a6f686c8544fb04b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '^'));
        anchor = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("fxycA", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $8818f71c12fe6d5c$export$67dc04e652a298ca);

var $3ZquL = parcelRequire("3ZquL");
// bq. foobarbaz
const $8818f71c12fe6d5c$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $8818f71c12fe6d5c$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($8818f71c12fe6d5c$var$BLOCKQUOTE_REGEXP);
    if (!match) return $8818f71c12fe6d5c$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $3ZquL.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $8818f71c12fe6d5c$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("3ZquL", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $d0531372537d3533$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $d0531372537d3533$export$c2a5e4612254bfa);

var $048B7 = parcelRequire("048B7");

var $8loUC = parcelRequire("8loUC");

var $gwvPQ = parcelRequire("gwvPQ");

var $7pbqq = parcelRequire("7pbqq");
const $d0531372537d3533$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $d0531372537d3533$export$c2a5e4612254bfa,
        context: context
    });
};
const $d0531372537d3533$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $d0531372537d3533$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $gwvPQ.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $d0531372537d3533$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $d0531372537d3533$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $d0531372537d3533$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($d0531372537d3533$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $d0531372537d3533$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $8loUC.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $8loUC.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $8loUC.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("048B7", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $531cf0819efc148e$export$b6a12943ac1bb1ba);
function $531cf0819efc148e$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $531cf0819efc148e$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $531cf0819efc148e$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("a4Ddm", function(module, exports) {

$parcel$export(module.exports, "citation", () => $f32594a62e32f935$export$258632c953c109e9);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");

const $f32594a62e32f935$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $c490cd896aed630e$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $c490cd896aed630e$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("70iSu", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $728089dc2284a93f$export$bccbf0c716f226f4);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $728089dc2284a93f$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("bufmJ", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $c0d69e139f33918a$export$65e3ca7c95899a2d);

var $60aCS = parcelRequire("60aCS");
const $c0d69e139f33918a$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $c0d69e139f33918a$var$fallback = {
    ...$c0d69e139f33918a$var$token,
    text: '--'
};
const $c0d69e139f33918a$export$65e3ca7c95899a2d = (0, $60aCS.createDashTokenParser)($c0d69e139f33918a$var$token, $c0d69e139f33918a$var$fallback);

});
parcelRegister("60aCS", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $febcf437b7899c3a$export$d43b58865d429e3c);
const $febcf437b7899c3a$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$febcf437b7899c3a$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$febcf437b7899c3a$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $febcf437b7899c3a$var$isSpace = (char)=>{
    return /\s/.test(char);
};

});


parcelRegister("jPNoV", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $131b8693e561a2d0$export$a19185d1233fc4b2);
const $131b8693e561a2d0$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $131b8693e561a2d0$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $131b8693e561a2d0$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $131b8693e561a2d0$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($131b8693e561a2d0$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $131b8693e561a2d0$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $131b8693e561a2d0$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("gJccQ", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $59b8582b485105d1$export$bef81ba411953b51);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $59b8582b485105d1$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("g0NwP", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $1b96753f1f0ca08b$export$ac55bb44695749c1);

var $kJkY5 = parcelRequire("kJkY5");
const $1b96753f1f0ca08b$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jCitd", function(module, exports) {

$parcel$export(module.exports, "heading", () => $8ef7f4653a487722$export$46e4a324ac90507f);

var $7pbqq = parcelRequire("7pbqq");

var $lS4Zv = parcelRequire("lS4Zv");
// h1. HEADING
const $8ef7f4653a487722$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $8ef7f4653a487722$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($8ef7f4653a487722$var$HEADING_REGEXP);
    if (!match) return $8ef7f4653a487722$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $7pbqq.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $8ef7f4653a487722$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("r2pEr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $2ce10c45c3e91d56$export$744ba74fb86b8ca7);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $2ce10c45c3e91d56$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("3O0Q2", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $8e6b28ef20d5dbbb$export$8837f4fc672e936d);

var $dTuMp = parcelRequire("dTuMp");

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $8loUC = parcelRequire("8loUC");
const $8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1 = 20;
const $8e6b28ef20d5dbbb$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1}}) `);
const $8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8e6b28ef20d5dbbb$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $8e6b28ef20d5dbbb$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $8e6b28ef20d5dbbb$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).LIST,
        (0, $lS4Zv.TokenType).TABLE
    ];
    let index = position;
    let state = $8e6b28ef20d5dbbb$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $8e6b28ef20d5dbbb$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($8e6b28ef20d5dbbb$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($8e6b28ef20d5dbbb$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $dTuMp.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $7pbqq.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $dTuMp.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $dTuMp.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $8e6b28ef20d5dbbb$var$processState.END;
                        continue;
                    }
                    state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                    continue;
                }
            case $8e6b28ef20d5dbbb$var$processState.BUFFER:
                {
                    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $8e6b28ef20d5dbbb$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $8e6b28ef20d5dbbb$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $8e6b28ef20d5dbbb$var$processState.MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                    continue;
                }
            case $8e6b28ef20d5dbbb$var$processState.END:
                if (!builder) // Something is really wrong here
                return $8e6b28ef20d5dbbb$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $7pbqq.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8e6b28ef20d5dbbb$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $8e6b28ef20d5dbbb$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("dTuMp", function(module, exports) {

$parcel$export(module.exports, "getType", () => $1bbe9941d5099473$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $1bbe9941d5099473$export$876cfa3161bef296);
const $1bbe9941d5099473$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $1bbe9941d5099473$export$e2b5c5db9e2009fd(bullets) {
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $1bbe9941d5099473$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($1bbe9941d5099473$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $1bbe9941d5099473$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $1bbe9941d5099473$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kJ7iC", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $897226e11d677a0e$export$2b90969bbc9ff4c9);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $897226e11d677a0e$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).ADF_MACRO,
        (0, $lS4Zv.TokenType).ANCHOR_MACRO,
        (0, $lS4Zv.TokenType).CODE_MACRO,
        (0, $lS4Zv.TokenType).QUOTE_MACRO,
        (0, $lS4Zv.TokenType).NOFORMAT_MACRO,
        (0, $lS4Zv.TokenType).PANEL_MACRO,
        (0, $lS4Zv.TokenType).COLOR_MACRO,
        (0, $lS4Zv.TokenType).LOREM_MACRO,
        (0, $lS4Zv.TokenType).QUOTE,
        (0, $lS4Zv.TokenType).STRING,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).LINK_FORMAT,
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).MEDIA,
        (0, $lS4Zv.TokenType).HEADING,
        (0, $lS4Zv.TokenType).LIST,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER,
        (0, $lS4Zv.TokenType).HARD_BREAK,
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).STRONG,
        (0, $lS4Zv.TokenType).MONOSPACE,
        (0, $lS4Zv.TokenType).SUPERSCRIPT,
        (0, $lS4Zv.TokenType).SUBSCRIPT,
        (0, $lS4Zv.TokenType).EMPHASIS,
        (0, $lS4Zv.TokenType).CITATION,
        (0, $lS4Zv.TokenType).DELETED,
        (0, $lS4Zv.TokenType).INSERTED,
        (0, $lS4Zv.TokenType).EMOJI,
        (0, $lS4Zv.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lDSkN", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $b665ccaa71cf7b7e$export$95a7907a71f31921);
const $b665ccaa71cf7b7e$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $b665ccaa71cf7b7e$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($b665ccaa71cf7b7e$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("eyWXo", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $1d0757d75b47a860$export$f9adada2013e846e);

var $4N3mo = parcelRequire("4N3mo");
const $1d0757d75b47a860$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $1d0757d75b47a860$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($1d0757d75b47a860$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $4N3mo.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("4N3mo", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $31b4de5795580324$export$4267f2e5716b018a);
const $31b4de5795580324$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $31b4de5795580324$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($31b4de5795580324$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $31b4de5795580324$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("66xYR", function(module, exports) {

$parcel$export(module.exports, "strong", () => $83c0fb2c2624e22e$export$59ae2c325a998f89);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $83c0fb2c2624e22e$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("jWDvo", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $f88bd6b7c0190e05$export$bc5390e4688d2822);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $f88bd6b7c0190e05$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4333j", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $80a43a44e8eb4ef9$export$b4aab94a5fcfcead);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $80a43a44e8eb4ef9$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("VuFCw", function(module, exports) {

$parcel$export(module.exports, "table", () => $b312622af426b5b5$export$9852986a3ec5f6a0);

var $1t19o = parcelRequire("1t19o");

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");

var $lccs8 = parcelRequire("lccs8");

var $iw2bq = parcelRequire("iw2bq");

var $jPNoV = parcelRequire("jPNoV");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $2ROXs = parcelRequire("2ROXs");

var $8loUC = parcelRequire("8loUC");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ const $b312622af426b5b5$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
const $b312622af426b5b5$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $b312622af426b5b5$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $b312622af426b5b5$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $b312622af426b5b5$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $b312622af426b5b5$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $1t19o.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $b312622af426b5b5$var$processState.END_TABLE;
                    continue;
                }
            case $b312622af426b5b5$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($b312622af426b5b5$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $b312622af426b5b5$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $b312622af426b5b5$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                    if (cellMatch) currentState = $b312622af426b5b5$var$processState.CLOSE_ROW;
                    else currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.BUFFER:
                {
                    const length = (0, $kJkY5.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($b312622af426b5b5$var$EMPTY_LINE_REGEXP)) currentState = $b312622af426b5b5$var$processState.CLOSE_ROW;
                        else {
                            currentState = $b312622af426b5b5$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $b312622af426b5b5$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $b312622af426b5b5$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $b312622af426b5b5$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $b312622af426b5b5$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $b312622af426b5b5$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $b312622af426b5b5$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $b312622af426b5b5$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $b312622af426b5b5$var$processState.NEW_ROW;
                    continue;
                }
            case $b312622af426b5b5$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $b312622af426b5b5$var$processState.MEDIA:
                {
                    const token = (0, $iw2bq.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.EMOJI:
                {
                    const token = (0, $jPNoV.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $lccs8.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $b312622af426b5b5$var$processState.MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $b312622af426b5b5$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $b312622af426b5b5$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $b312622af426b5b5$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $gwvPQ.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $b312622af426b5b5$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $b312622af426b5b5$var$traverseNodeAndAddMarks(node, mark, schema);
}
function $b312622af426b5b5$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $b312622af426b5b5$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $b312622af426b5b5$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $b312622af426b5b5$var$traverseContent(node, mark, schema);
}

});
parcelRegister("1t19o", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $ee9dddd7294d397c$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $ee9dddd7294d397c$var$getType(style) {
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $ee9dddd7294d397c$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $ee9dddd7294d397c$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("gakJc", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $1f033a2e27e8b3fd$export$edbcd749367de060);

var $60aCS = parcelRequire("60aCS");
const $1f033a2e27e8b3fd$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $1f033a2e27e8b3fd$var$fallback = {
    ...$1f033a2e27e8b3fd$var$token,
    text: '---'
};
const $1f033a2e27e8b3fd$export$edbcd749367de060 = (0, $60aCS.createDashTokenParser)($1f033a2e27e8b3fd$var$token, $1f033a2e27e8b3fd$var$fallback);

});

parcelRegister("j2mJE", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $961956c03c5700d1$export$5d7bf7e31a674541);

var $048B7 = parcelRequire("048B7");

var $7pbqq = parcelRequire("7pbqq");

var $dFOSZ = parcelRequire("dFOSZ");

var $gwvPQ = parcelRequire("gwvPQ");

var $kKwIJ = parcelRequire("kKwIJ");

var $412VX = parcelRequire("412VX");
const $961956c03c5700d1$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $961956c03c5700d1$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $961956c03c5700d1$var$rawContentProcessor
    });
};
const $961956c03c5700d1$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $kKwIJ.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $gwvPQ.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $412VX.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($961956c03c5700d1$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $961956c03c5700d1$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $961956c03c5700d1$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("kKwIJ", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $b1b231f17e51a80e$export$fa00fa3d6c22a747);

var $27YwJ = parcelRequire("27YwJ");
const $b1b231f17e51a80e$var$COLOR_TYPE_REGEX = {
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $b1b231f17e51a80e$export$fa00fa3d6c22a747(attrs) {
    const rgb = $b1b231f17e51a80e$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $b1b231f17e51a80e$var$distanceOfRgb($b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $b1b231f17e51a80e$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $b1b231f17e51a80e$var$generateRgb(color) {
    switch(true){
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexShort.test(color) || $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $b1b231f17e51a80e$var$parseHex(color);
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $b1b231f17e51a80e$var$parseRgb(color);
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $b1b231f17e51a80e$var$parsePrgb(color);
        default:
            return $b1b231f17e51a80e$var$parseColorName(color);
    }
}
function $b1b231f17e51a80e$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $b1b231f17e51a80e$var$parseRgb(rgb) {
    const result = rgb.match($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $b1b231f17e51a80e$var$parsePrgb(prgb) {
    const result = prgb.match($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $b1b231f17e51a80e$var$parseColorName(color) {
    return (0, $27YwJ.default)[color];
}

});
parcelRegister("27YwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64a73090b859f18$export$2e2bcd8739ae039);
const $f64a73090b859f18$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $f64a73090b859f18$export$2e2bcd8739ae039 = $f64a73090b859f18$var$mapping;

});


parcelRegister("412VX", function(module, exports) {

$parcel$export(module.exports, "title", () => $e441a2e7780cbef1$export$fb184b623420d9be);
function $e441a2e7780cbef1$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("a5fMg", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $c510207391721011$export$8fb4b58db8f664fb);

var $048B7 = parcelRequire("048B7");
const $c510207391721011$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $c510207391721011$var$rawContentProcessor
    });
};
const $c510207391721011$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("adHlr", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $39e5fab8c86e7c66$export$e660dadc21580fa2);

var $048B7 = parcelRequire("048B7");
const $39e5fab8c86e7c66$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $39e5fab8c86e7c66$var$rawContentProcessor
    });
};
const $39e5fab8c86e7c66$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("48Szy", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $7821c626d71eb9e8$export$db6c131ac26c7700);

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $412VX = parcelRequire("412VX");
const $7821c626d71eb9e8$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $7821c626d71eb9e8$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $7821c626d71eb9e8$var$rawContentProcessor
    });
};
const $7821c626d71eb9e8$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $412VX.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $7821c626d71eb9e8$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $7821c626d71eb9e8$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $7821c626d71eb9e8$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cvl2z", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $77c4a311a6bce9f0$export$b557be495948d995);

var $lS4Zv = parcelRequire("lS4Zv");

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $7pbqq = parcelRequire("7pbqq");

var $ec41U = parcelRequire("ec41U");

var $8loUC = parcelRequire("8loUC");
const $77c4a311a6bce9f0$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $77c4a311a6bce9f0$var$rawContentProcessor
    });
};
const $77c4a311a6bce9f0$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE
    ];
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const content = (0, $7pbqq.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $ec41U.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("ec41U", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $aca1c3aa774ca185$export$c0cfc6f23e0b7578);

var $jR93G = parcelRequire("jR93G");
function $aca1c3aa774ca185$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $jR93G.normalizeHexColor)(keys[0]);
}

});


parcelRegister("5PrNl", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7891074759cd4bc4$export$9199752eb9b2d5b4);

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $412VX = parcelRequire("412VX");
const $7891074759cd4bc4$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7891074759cd4bc4$var$rawContentProcessor
    });
};
const $7891074759cd4bc4$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $412VX.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("eTIGc", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $c28d407e42eefac6$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ const $c28d407e42eefac6$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $c28d407e42eefac6$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $c28d407e42eefac6$var$fallback(input, position);
    }
    const match = input.substring(position).match($c28d407e42eefac6$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $c28d407e42eefac6$var$fallback(input, position);
};
function $c28d407e42eefac6$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("hf3v9", function(module, exports) {

$parcel$export(module.exports, "code", () => $9baabbb4403cf9b3$export$6565f9f03506010b);
const $9baabbb4403cf9b3$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("sS3Yw", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $703c8726b73164da$export$32f78bffcd82ff28);
const $703c8726b73164da$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("lWqfN", function(module, exports) {

$parcel$export(module.exports, "em", () => $b90022f08ab17d9b$export$c63c6f932822f543);

var $18hih = parcelRequire("18hih");
const $b90022f08ab17d9b$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $18hih.baseMarkPattern)(text.substring(2), '??');
    return (0, $18hih.baseMarkPattern)(text, '_');
};

});
parcelRegister("18hih", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $6f34e11c7c351cb8$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $6f34e11c7c351cb8$export$3d8aed7830783c75 = (text, token)=>{
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("9hhDh", function(module, exports) {

$parcel$export(module.exports, "link", () => $caa71b2d0d7ede16$export$9c30223ca0a664fb);
const $caa71b2d0d7ede16$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("aiUyl", function(module, exports) {

$parcel$export(module.exports, "strike", () => $b1d2f97e8fc0de3c$export$4899a95d70ec5056);

var $18hih = parcelRequire("18hih");
const $b1d2f97e8fc0de3c$export$4899a95d70ec5056 = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '-');
};

});

parcelRegister("4fuiB", function(module, exports) {

$parcel$export(module.exports, "strong", () => $148ec1c7d5e290d3$export$59ae2c325a998f89);

var $18hih = parcelRequire("18hih");
const $148ec1c7d5e290d3$export$59ae2c325a998f89 = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '*');
};

});

parcelRegister("gUCSO", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $a74358391b0936e0$export$b3401ee80eb31041);

var $18hih = parcelRequire("18hih");
const $a74358391b0936e0$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $18hih.baseMarkPattern)(text, '~');
    else return (0, $18hih.baseMarkPattern)(text, '^');
};

});

parcelRegister("ijIl1", function(module, exports) {

$parcel$export(module.exports, "underline", () => $511118f4e5c0322a$export$425327af25286e5e);

var $18hih = parcelRequire("18hih");
const $511118f4e5c0322a$export$425327af25286e5e = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '+');
};

});


parcelRegister("JPiHV", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $417cf7f4aeef481a$export$cbf8224b64e0d942);

var $dMxC6 = parcelRequire("dMxC6");

var $4RTci = parcelRequire("4RTci");
const $417cf7f4aeef481a$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    const match = node.attrs.url.match((0, $4RTci.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("2wGmw", function(module, exports) {

$parcel$export(module.exports, "status", () => $1c7cf9d16d32feb0$export$471f7ae5c4103ae1);

var $sS3Yw = parcelRequire("sS3Yw");

const $1c7cf9d16d32feb0$var$color = {
    grey: (0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806),
    purple: (0, $73a5c9d720aa66e1$export$b48405b95304b5a1),
    blue: (0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b),
    red: (0, $73a5c9d720aa66e1$export$4a7404f376229999),
    yellow: (0, $73a5c9d720aa66e1$export$59619663aa6500fb),
    green: (0, $73a5c9d720aa66e1$export$940e1f69e873f202)
};
const $1c7cf9d16d32feb0$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($1c7cf9d16d32feb0$var$color[node.attrs.color]) newAttrs.color = $1c7cf9d16d32feb0$var$color[node.attrs.color];
    else newAttrs.color = $1c7cf9d16d32feb0$var$color['grey'];
    return (0, $sS3Yw.textColor)(text, newAttrs);
};

});

parcelRegister("fUy1V", function(module, exports) {

$parcel$export(module.exports, "date", () => $0a10eda5fc7a0cbb$export$324d90190a8b822a);
const $0a10eda5fc7a0cbb$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("433DX", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $8a22b8049b1154b8$export$7bb0d5c671655cc4);

var $8wJH0 = parcelRequire("8wJH0");
const $8a22b8049b1154b8$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $8a22b8049b1154b8$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            parent: node
        });
    });
    if ($8a22b8049b1154b8$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("9PdIu", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $62f539123b9da75d$export$2855e964765eac9);

var $5DckW = parcelRequire("5DckW");

var $2ZBc5 = parcelRequire("2ZBc5");

var $dMxC6 = parcelRequire("dMxC6");
const $62f539123b9da75d$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $2ZBc5.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $5DckW.caption)(n, opts));
                break;
            default:
                result.push((0, $dMxC6.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("5DckW", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9564736f04490086$export$8e3c2dfdc4f0453d);

var $8wJH0 = parcelRequire("8wJH0");
const $9564736f04490086$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("2ZBc5", function(module, exports) {

$parcel$export(module.exports, "media", () => $cee34f1880720e99$export$987d49ffe1b0900f);
const $cee34f1880720e99$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    let wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("7Risu", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $bee162bb2f32e9b9$export$375b6afcc5f4d291);

var $g3wEU = parcelRequire("g3wEU");
const $bee162bb2f32e9b9$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($bee162bb2f32e9b9$var$nestedNode(item, depth + 1));
        else result.push((0, $g3wEU.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $bee162bb2f32e9b9$export$375b6afcc5f4d291 = (node)=>{
    return $bee162bb2f32e9b9$var$nestedNode(node);
};

});
parcelRegister("g3wEU", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $418cc1c50037a34d$export$6d8b0ef52e2e6390);

var $8wJH0 = parcelRequire("8wJH0");
const $418cc1c50037a34d$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $8wJH0.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $8wJH0.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("9q3yb", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $72cb26933398a6aa$export$62d45a65fb43d95e);

var $03Ql6 = parcelRequire("03Ql6");
const $72cb26933398a6aa$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $03Ql6.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("03Ql6", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $792c9a137da0305d$export$6959e16eeff859b4);

var $8wJH0 = parcelRequire("8wJH0");
const $792c9a137da0305d$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $8wJH0.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("lPxCD", function(module, exports) {

$parcel$export(module.exports, "doc", () => $80964a588d75e5e9$export$2a111da947c407d2);

var $jX0ky = parcelRequire("jX0ky");
const $80964a588d75e5e9$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("7rqfg", function(module, exports) {

$parcel$export(module.exports, "expand", () => $62f01b5dc84c3d9c$export$9f77e0932fb78f72);

var $jX0ky = parcelRequire("jX0ky");
const $62f01b5dc84c3d9c$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("haHCt", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ebdd7f4ed2c4374f$export$46e4a324ac90507f);

var $8wJH0 = parcelRequire("8wJH0");
const $ebdd7f4ed2c4374f$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("kbkiv", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $a59abe140fc939d5$export$a5dc81035676e7a);

var $aTpvz = parcelRequire("aTpvz");
const $a59abe140fc939d5$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $aTpvz.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("gKQAY", function(module, exports) {

$parcel$export(module.exports, "panel", () => $b1c9c1af1887f5f5$export$21f42ab9b6679f44);

var $jX0ky = parcelRequire("jX0ky");
const $b1c9c1af1887f5f5$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $b1c9c1af1887f5f5$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return `{panel:bgColor=${$b1c9c1af1887f5f5$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("ikdnB", function(module, exports) {

$parcel$export(module.exports, "rule", () => $d750c553cfb9bc2b$export$fbeb3a3956e8a3c7);
const $d750c553cfb9bc2b$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("lHJNe", function(module, exports) {

$parcel$export(module.exports, "table", () => $64091866b6f4487e$export$9852986a3ec5f6a0);

var $jX0ky = parcelRequire("jX0ky");

var $dMxC6 = parcelRequire("dMxC6");
const $64091866b6f4487e$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($64091866b6f4487e$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $dMxC6.unknown)(node);
    }
};
const $64091866b6f4487e$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$64091866b6f4487e$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $64091866b6f4487e$var$tableCell = (node, { context: context } = {})=>{
    if ($64091866b6f4487e$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $64091866b6f4487e$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("fSqxZ", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $1983797da7981884$export$c4c2f833baaebdb8);

var $dMxC6 = parcelRequire("dMxC6");
const $1983797da7981884$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("kYj1v", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $646070e6044030b7$export$be4283d9a1cb1ff6);

var $dMxC6 = parcelRequire("dMxC6");
const $646070e6044030b7$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("ZkOGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e558f06e75d1d84e$export$2e2bcd8739ae039);

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");
class $e558f06e75d1d84e$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $7pbqq.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $gwvPQ.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



const $a8a1251974a60726$export$9151073f92820ff8 = 255;
const $a8a1251974a60726$export$fe1a70381f6491b5 = 255;
const $a8a1251974a60726$export$1fdf850c93de8bae = 55;
const $a8a1251974a60726$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $a8a1251974a60726$export$e77d629cc732976d = 'LABELS INVALID';
const $a8a1251974a60726$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $a8a1251974a60726$export$618e922e89e8bcae = 'STRING_INVALID';

parcelRegister("Gmy9H", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $f6226d3efbb0f87c$export$eedb1bf75e1efb26);

var $a5JEv = parcelRequire("a5JEv");
const $f6226d3efbb0f87c$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels'
};
const $f6226d3efbb0f87c$export$eedb1bf75e1efb26 = {
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.IssueTypes]: (0, $a5JEv.default).fieldHelpIssueTypes,
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $a5JEv.default).fieldHelpPriorityLevels,
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $a5JEv.default).fieldHelpResolutionDefinitions,
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $a5JEv.default).fieldHelpSecurityLevels
};

});
parcelRegister("a5JEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3b8030c9f17191$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec3b8030c9f17191$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-create-commons.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    labelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
        "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    stringInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    forgeLabelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
        "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    labelsMaxErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-max-error-message",
        "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
    },
    fieldHelpTextLabel: {
        "id": "issue-create-commons.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    }
});

});



parcelRegister("ewDib", function(module, exports) {

$parcel$export(module.exports, "FieldSkeleton", () => $d5c4832731156e8b$export$f102dad4aafe4ad4);
$parcel$export(module.exports, "default", () => $d5c4832731156e8b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");

var $ajD9f = parcelRequire("ajD9f");
const $d5c4832731156e8b$export$f102dad4aafe4ad4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
        "data-testid": "issue-create-commons.common.ui.loader.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5c4832731156e8b$var$Label, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajD9f.StyledFieldSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5c4832731156e8b$var$Description, null));
const $d5c4832731156e8b$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Array.from({
        length: skeletonCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5c4832731156e8b$export$f102dad4aafe4ad4, {
            key: `field-skeleton-${index}`
        })));
var $d5c4832731156e8b$export$2e2bcd8739ae039 = $d5c4832731156e8b$var$IssueCreateLoader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5c4832731156e8b$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
            __cmplp.className
        ])
    });
});
$d5c4832731156e8b$var$Label.displayName = 'LabelSkeleton';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5c4832731156e8b$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsb1mjv",
            __cmplp.className
        ])
    });
});
$d5c4832731156e8b$var$Description.displayName = 'DescriptionSkeleton';

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $73a5c9d720aa66e1$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ajD9f", function(module, exports) {

$parcel$export(module.exports, "StyledFieldSkeleton", () => $1bbd158b1c31d723$export$ed5de990fe261b7b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");
const $1bbd158b1c31d723$export$ed5de990fe261b7b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _1bsb1edt _otyr12x7",
            __cmplp.className
        ])
    });
});
$1bbd158b1c31d723$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';

});


parcelRegister("6UjGk", function(module, exports) {

$parcel$export(module.exports, "generateKeyForRequiredFromUIM", () => $f357f017ac652237$export$920d96e4692b3d51);
const $f357f017ac652237$export$920d96e4692b3d51 = (parameters)=>{
    const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
    return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};

});


parcelRegister("qWkqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfa16b75b646ee2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jYnpi = parcelRequire("jYnpi");

var $4ksts = parcelRequire("4ksts");

var $hiBi9 = parcelRequire("hiBi9");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");


var $6cPKE = parcelRequire("6cPKE");

var $b5qOz = parcelRequire("b5qOz");

var $51p9V = parcelRequire("51p9V");

var $dRJbT = parcelRequire("dRJbT");

var $aE92Z = parcelRequire("aE92Z");
const $4cfa16b75b646ee2$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience = new (0, $kDfSL.UFOExperience)('inline-assignee-picker.field-options-load', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'inline-assignee-picker.field-options-load'
});
const $4cfa16b75b646ee2$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $4cfa16b75b646ee2$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ...fieldProps })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const self = (0, $eUqFw.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $aE92Z.default)(autoCompleteUrl || '');
    const [assigneeValue, assigneeOptions] = (0, $dRJbT.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption);
    const [, { openDrawer: openDrawer }] = (0, $hiBi9.useInvitePeopleDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (loading) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loading'
            }), 'inlineAssigneeOptions loading');
            $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'failed'
            }), 'inlineAssigneeOptions failed');
            $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loaded'
            }), 'inlineAssigneeOptions loaded');
            $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent
    ]);
    const handleSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            /*
     * Added extra condition to skip search. it's getting called during onBlur because previousQuery is undefined and query is empty string
     * then query !== self.previousQuery will be true and fetchUsers getting called unnecessarily
     */ if (query === '' && self.previousQuery === undefined) return;
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $eUqFw.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        users,
        fetchUsers
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        self.previousQuery = undefined;
    }, [
        onBlur,
        self
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if ((0, $b5qOz.isInviteFromAssignEnabled)() && enablePeopleInvite && updatedValue.id === (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7)) {
            openDrawer(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        let newValue;
        if (updatedValue.id === (0, $7a4a7348bcf111f0$export$bdab9bfb39981463) || updatedValue.id === (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7)) newValue = null;
        else newValue = (0, $6cPKE.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
    }, [
        enablePeopleInvite,
        onChange,
        openDrawer,
        value,
        createAnalyticsEvent
    ]);
    /*
   * user picker default opens on focus, fetchUsers has to be called onFocus
   * when openMenuOnClick is enabled then fetchUsers should be called during onOpen rather than onFocus
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: handleOnFocus
    } : {
        onFocus: handleOnFocus
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        inputId: inputId,
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        autoFocus: autoFocus,
        placeholder: intl.formatMessage((0, $51p9V.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        value: assigneeValue,
        isMulti: false,
        isClearable: false,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        subtle: isSubtle,
        appearance: appearance,
        width: width,
        isDisabled: isDisabled,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        UNSAFE_hasDraggableParentComponent: true,
        ...controlProps
    });
};
var $4cfa16b75b646ee2$export$2e2bcd8739ae039 = $4cfa16b75b646ee2$var$InlineAssigneePickerEdit;

});
parcelRegister("jYnpi", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $a9ecfa55df3af3b8$export$83e0c73b09b3a9cd);

var $2jDha = parcelRequire("2jDha");

var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");

var $uMitL = parcelRequire("uMitL");

var $eUqFw = parcelRequire("eUqFw");

var $3IZWd = parcelRequire("3IZWd");

var $dTS4n = parcelRequire("dTS4n");

var $4dR1n = parcelRequire("4dR1n");

var $fiLGD = parcelRequire("fiLGD");

var $bxvbM = parcelRequire("bxvbM");

var $1mZCo = parcelRequire("1mZCo");

var $ToOs1 = parcelRequire("ToOs1");

var $a1Z9P = parcelRequire("a1Z9P");

var $hompL = parcelRequire("hompL");
class $a9ecfa55df3af3b8$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $hompL.v4)();
        const experienceForId = (0, $a1Z9P.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $a1Z9P.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
            (0, $uMitL.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $28t3A.default) : (0, $5wCDk.default);
        const creatableProps = suggestEmailsForDomain ? (0, $bxvbM.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fiLGD.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1Z9P.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1mZCo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ToOs1.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3IZWd.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            width: width,
            SelectComponent: SelectComponent,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $dTS4n.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles),
            components: (0, $4dR1n.getComponents)(isMulti, anchor),
            pickerProps: pickerProps
        }))));
    }
}
const $a9ecfa55df3af3b8$export$83e0c73b09b3a9cd = (0, $2jDha.default)()($a9ecfa55df3af3b8$export$164f4d95e5d7e2f5);

});
parcelRegister("28t3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab404645f53318b$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $5FjBr = parcelRequire("5FjBr");
const $2ab404645f53318b$var$CreatableSelect = (0, $5FjBr.default)((0, $lOwgQ.default));
var $2ab404645f53318b$export$2e2bcd8739ae039 = $2ab404645f53318b$var$CreatableSelect;

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});
parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("e9T6i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce299ea00421c5395af727ab457ee775>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4eca5cb70ed36ce$var$_react = $a4eca5cb70ed36ce$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a4eca5cb70ed36ce$var$_chevronDown = $a4eca5cb70ed36ce$var$_interopRequireDefault((parcelRequire("c6CvK")));

var $a4eca5cb70ed36ce$var$_chevronDown2 = $a4eca5cb70ed36ce$var$_interopRequireDefault((parcelRequire("86Ndv")));
function $a4eca5cb70ed36ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4eca5cb70ed36ce$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a4eca5cb70ed36ce$var$_react.default.createElement($a4eca5cb70ed36ce$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $a4eca5cb70ed36ce$var$_chevronDown2.default
    }, props));
$a4eca5cb70ed36ce$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $a4eca5cb70ed36ce$var$_default = module.exports.default = $a4eca5cb70ed36ce$var$ChevronDownIcon;

});

parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad28cd61177420a3a122a1d9ec17dac3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96175d8a517ba5c9c43627285ce1cee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3245a4cda5405cbe39cdb10fb1ac0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dfdc599c601af5ad9de21c16ca28508>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});


parcelRegister("3IZWd", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $f8b053239afa9fd6$export$b4ff48c8d43b18c3);

var $2jDha = parcelRequire("2jDha");

var $uMitL = parcelRequire("uMitL");

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hompL = parcelRequire("hompL");

var $bjvv3 = parcelRequire("bjvv3");

var $b9ITu = parcelRequire("b9ITu");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $a1Z9P = parcelRequire("a1Z9P");
const $f8b053239afa9fd6$var$loadingMessage = ()=>null;
const $f8b053239afa9fd6$var$classNamePrefix = 'fabric-user-picker';
class $f8b053239afa9fd6$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).errorMessage),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $cHYJ6.optionToSelectableOptions)(nextProps.value);
        else if ((0, $cHYJ6.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $cHYJ6.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props);
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $cHYJ6.callCallback)(onChange, (0, $cHYJ6.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $cHYJ6.callCallback)(onSelection, (0, $cHYJ6.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $bjvv3.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $bjvv3.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $cHYJ6.callCallback)(onClear);
                    this.fireEvent((0, $bjvv3.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $bjvv3.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $bjvv3.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $b9ITu.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $bjvv3.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                const inflightRequest = previousRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $cHYJ6.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                return {
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                };
            });
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $uMitL.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $cHYJ6.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $cHYJ6.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $cHYJ6.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleBlur = ()=>{
            (0, $cHYJ6.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $cHYJ6.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleOpen = ()=>{
            (0, $cHYJ6.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleClose = ()=>{
            this.resetInputState();
            (0, $cHYJ6.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $cHYJ6.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $bjvv3.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $bjvv3.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $bjvv3.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptions = ()=>{
            const options = (0, $cHYJ6.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $a1Z9P.userPickerOptionsShownUfoExperience).getInstance((0, $hompL.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $bjvv3.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $bjvv3.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $uMitL.UFOExperienceState).STARTED.id,
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $f8b053239afa9fd6$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).placeholder),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $f8b053239afa9fd6$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $f8b053239afa9fd6$export$d099ade7b4f4d2a4 = (0, $2jDha.default)()($f8b053239afa9fd6$export$b4ff48c8d43b18c3);

});
parcelRegister("bjvv3", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $72125c7ae0a2c4a6$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $72125c7ae0a2c4a6$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $72125c7ae0a2c4a6$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $72125c7ae0a2c4a6$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $72125c7ae0a2c4a6$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $72125c7ae0a2c4a6$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $72125c7ae0a2c4a6$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $72125c7ae0a2c4a6$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $72125c7ae0a2c4a6$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $72125c7ae0a2c4a6$export$f541f04954b0c11e);

var $hM7RE = parcelRequire("hM7RE");

var $hompL = parcelRequire("hompL");

var $cHYJ6 = parcelRequire("cHYJ6");
const $72125c7ae0a2c4a6$var$packageName = "platform-pkg";
const $72125c7ae0a2c4a6$var$packageVersion = "0.0.0-use.local";
const $72125c7ae0a2c4a6$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $72125c7ae0a2c4a6$export$c0d84948cecf78d8 = ()=>({
        id: (0, $hompL.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $72125c7ae0a2c4a6$export$53eef0dcd9611650 = (0, $hM7RE.default)('fabric-elements');
const $72125c7ae0a2c4a6$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $72125c7ae0a2c4a6$var$packageName,
            packageVersion: $72125c7ae0a2c4a6$var$packageVersion,
            ...attributes
        }
    });
const $72125c7ae0a2c4a6$var$checkValidId = (id)=>{
    return $72125c7ae0a2c4a6$var$UUID_REGEXP_NEW_AAID.test(id) || $72125c7ae0a2c4a6$var$UUID_REGEXP_OLD_AAID.test(id) || $72125c7ae0a2c4a6$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $72125c7ae0a2c4a6$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $72125c7ae0a2c4a6$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $cHYJ6.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $cHYJ6.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $72125c7ae0a2c4a6$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$72125c7ae0a2c4a6$var$optionData2Analytics(data));
    }
    return [];
};
const $72125c7ae0a2c4a6$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $72125c7ae0a2c4a6$var$sessionId(session),
        pickerType: $72125c7ae0a2c4a6$var$pickerType(props),
        journeyId: journeyId
    });
const $72125c7ae0a2c4a6$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'focused', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $72125c7ae0a2c4a6$var$buildValueForAnalytics(state.value)
    });
const $72125c7ae0a2c4a6$export$7b5800e732182efb = (props, state, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $72125c7ae0a2c4a6$var$values(state)
    });
const $72125c7ae0a2c4a6$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $72125c7ae0a2c4a6$var$sessionId(session),
        journeyId: journeyId,
        value: $72125c7ae0a2c4a6$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $72125c7ae0a2c4a6$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(args[0]),
        spaceInQuery: $72125c7ae0a2c4a6$var$spaceInQuery(args[0]),
        upKeyCount: $72125c7ae0a2c4a6$var$upKeyCount(session),
        downKeyCount: $72125c7ae0a2c4a6$var$downKeyCount(session)
    });
const $72125c7ae0a2c4a6$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $72125c7ae0a2c4a6$var$createEvent('ui', $72125c7ae0a2c4a6$var$selectEventType(session), 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        position: $72125c7ae0a2c4a6$var$position(state, args[0]),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(state),
        spaceInQuery: $72125c7ae0a2c4a6$var$spaceInQuery(state),
        upKeyCount: $72125c7ae0a2c4a6$var$upKeyCount(session),
        downKeyCount: $72125c7ae0a2c4a6$var$downKeyCount(session),
        result: $72125c7ae0a2c4a6$var$result(args[0]),
        numberOfResults: $72125c7ae0a2c4a6$var$numberOfResults(state)
    });
};
const $72125c7ae0a2c4a6$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $72125c7ae0a2c4a6$var$results(state);
    return $72125c7ae0a2c4a6$var$createEvent('operational', 'searched', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        durationSinceInputChange: $72125c7ae0a2c4a6$var$durationSinceInputChange(session),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(state),
        isLoading: $72125c7ae0a2c4a6$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $72125c7ae0a2c4a6$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('operational', 'failed', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $72125c7ae0a2c4a6$export$f541f04954b0c11e = (sources, accountId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $72125c7ae0a2c4a6$var$checkValidId(accountId) ? accountId : null
    });
function $72125c7ae0a2c4a6$var$queryLength(state) {
    return state.inputValue.length;
}
function $72125c7ae0a2c4a6$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $72125c7ae0a2c4a6$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $72125c7ae0a2c4a6$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $72125c7ae0a2c4a6$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $72125c7ae0a2c4a6$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $72125c7ae0a2c4a6$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $72125c7ae0a2c4a6$var$sessionId(session) {
    return session && session.id;
}
function $72125c7ae0a2c4a6$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $72125c7ae0a2c4a6$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $72125c7ae0a2c4a6$var$result(option) {
    return option ? $72125c7ae0a2c4a6$var$optionData2Analytics(option.data) : null;
}
function $72125c7ae0a2c4a6$var$results(state) {
    return (state.options || []).map($72125c7ae0a2c4a6$var$optionData2Analytics);
}
function $72125c7ae0a2c4a6$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $72125c7ae0a2c4a6$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$72125c7ae0a2c4a6$var$optionData2Analytics(option.data)) : [
        $72125c7ae0a2c4a6$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $72125c7ae0a2c4a6$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("cHYJ6", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $76b83dfd34bdcdb2$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $76b83dfd34bdcdb2$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $76b83dfd34bdcdb2$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $76b83dfd34bdcdb2$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $76b83dfd34bdcdb2$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $76b83dfd34bdcdb2$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $76b83dfd34bdcdb2$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $76b83dfd34bdcdb2$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $76b83dfd34bdcdb2$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $76b83dfd34bdcdb2$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $76b83dfd34bdcdb2$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $76b83dfd34bdcdb2$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $76b83dfd34bdcdb2$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $76b83dfd34bdcdb2$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $76b83dfd34bdcdb2$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $76b83dfd34bdcdb2$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $76b83dfd34bdcdb2$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $76b83dfd34bdcdb2$export$5419897287f5f1c7);

var $5iWql = parcelRequire("5iWql");


var $l44HT = parcelRequire("l44HT");
const $76b83dfd34bdcdb2$export$f6058dbcb5980cb = (option)=>option.type === (0, $0b440fae145c26fc$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $76b83dfd34bdcdb2$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $0b440fae145c26fc$export$8436e53e45ffe15b);
const $76b83dfd34bdcdb2$export$f8c4277cb588611f = (option)=>option.type === (0, $0b440fae145c26fc$export$26bc40b960693765);
const $76b83dfd34bdcdb2$export$d7976824e9f55785 = (option)=>option.type === (0, $0b440fae145c26fc$export$d460f747b73abb10);
const $76b83dfd34bdcdb2$export$7fbbfbca30081d0 = (option)=>option.type === (0, $0b440fae145c26fc$export$6662b3461398ef8c);
const $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $0b440fae145c26fc$export$eafd0979afa5b224);
const $76b83dfd34bdcdb2$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $76b83dfd34bdcdb2$var$isOptionData = (option)=>option.name !== undefined;
const $76b83dfd34bdcdb2$export$3f993c492bd6c728 = (option)=>{
    if ($76b83dfd34bdcdb2$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $76b83dfd34bdcdb2$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $76b83dfd34bdcdb2$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $76b83dfd34bdcdb2$export$d2312e68e1f5ad00 = (0, $5iWql.default)((options)=>options.map($76b83dfd34bdcdb2$export$3f993c492bd6c728));
const $76b83dfd34bdcdb2$export$e6fda14a194bcbcc = (0, $5iWql.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($76b83dfd34bdcdb2$export$3f993c492bd6c728);
    return $76b83dfd34bdcdb2$export$3f993c492bd6c728(defaultValue);
});
const $76b83dfd34bdcdb2$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $76b83dfd34bdcdb2$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $76b83dfd34bdcdb2$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $76b83dfd34bdcdb2$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $76b83dfd34bdcdb2$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $76b83dfd34bdcdb2$export$b4f8f1f54acec99b = (optionData)=>{
    if ($76b83dfd34bdcdb2$export$2e44165f1da65304(optionData) || $76b83dfd34bdcdb2$export$f8c4277cb588611f(optionData) || $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $76b83dfd34bdcdb2$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $l44HT.default);
const $76b83dfd34bdcdb2$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $76b83dfd34bdcdb2$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $0b440fae145c26fc$export$8436e53e45ffe15b = 'user';
const $0b440fae145c26fc$export$50042ec1d2e00e63 = 'external_user';
const $0b440fae145c26fc$export$26bc40b960693765 = 'team';
const $0b440fae145c26fc$export$d460f747b73abb10 = 'group';
const $0b440fae145c26fc$export$6662b3461398ef8c = 'email';
const $0b440fae145c26fc$export$eafd0979afa5b224 = 'custom';

parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $lbDTY = parcelRequire("lbDTY");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $asNSH = parcelRequire("asNSH");

var $XHGTv = parcelRequire("XHGTv");


var $5wCDk = parcelRequire("5wCDk");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");

var $7ldaw = parcelRequire("7ldaw");
/**
 * Are we rendering on the client or server?
 */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $XHGTv.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $XHGTv.fg)('platform-design-system-dsp-19701-no-node-resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) this.selectRef.select?.openMenu('first');
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $XHGTv.fg)('platform-design-system-dsp-19701-no-node-resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $XHGTv.fg)('platform-design-system-dsp-19701-no-node-resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $lT14u.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $lT14u.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $lT14u.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform-design-system-dsp-19701-no-node-resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $XHGTv.fg)('platform-design-system-dsp-19701-no-node-resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId,
                    ref: !(0, $XHGTv.fg)('platform-design-system-dsp-19701-no-node-resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hcvt0 = parcelRequire("hcvt0");


var $lcnyw = parcelRequire("lcnyw");

var $lkPEe = parcelRequire("lkPEe");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hcvt0))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).IndicatorSeparator, props);
const $e208c4fdfb4dbbc3$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, props);
const $e208c4fdfb4dbbc3$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu,
    IndicatorSeparator: $e208c4fdfb4dbbc3$var$IndicatorSeparator,
    ClearIndicator: $e208c4fdfb4dbbc3$var$ClearIndicator,
    MultiValueRemove: $e208c4fdfb4dbbc3$var$MultiValueRemove
};

});
parcelRegister("hcvt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cda9609b2c3c84e92d828aa303798a93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c85bf750af932d50$var$_react = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c85bf750af932d50$var$_search = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("9IsWp")));

var $c85bf750af932d50$var$_search2 = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("bPZtE")));
function $c85bf750af932d50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c85bf750af932d50$var$SearchIcon = (props)=>/*#__PURE__*/ $c85bf750af932d50$var$_react.default.createElement($c85bf750af932d50$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c85bf750af932d50$var$_search2.default
    }, props));
$c85bf750af932d50$var$SearchIcon.Name = 'SearchIconMigration';
var $c85bf750af932d50$var$_default = module.exports.default = $c85bf750af932d50$var$SearchIcon;

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});






parcelRegister("b9ITu", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $6fd848c9243cf2a4$export$da86c38211c1c0a8);
function $6fd848c9243cf2a4$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("hAQEH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0166325e684f6a54$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0166325e684f6a54$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("a1Z9P", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $542454000b8812af$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $542454000b8812af$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $542454000b8812af$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $uMitL = parcelRequire("uMitL");
const $542454000b8812af$export$b49757166e1acfc2 = new (0, $2kFUE.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
const $542454000b8812af$export$135a264e0da507ae = new (0, $2kFUE.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Operation,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
});
class $542454000b8812af$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        const instance = $542454000b8812af$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $uMitL.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("dTS4n", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $c46738fef3a1a380$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $c46738fef3a1a380$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $c46738fef3a1a380$export$4e983f376ad8a3af);


var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $c46738fef3a1a380$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $c46738fef3a1a380$export$53937c04f7dfc2ae = 6;
const $c46738fef3a1a380$export$2c62ba763e976c54 = 39;
const $c46738fef3a1a380$export$ffd58b7f6f099a57 = (0, $5iWql.default)((width, isMulti, isCompact, overrideStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                paddingLeft: isMulti ? $c46738fef3a1a380$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                fontSize: '100%',
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$c46738fef3a1a380$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>({
                ...css,
                overflow: 'hidden'
            }),
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $cEc3i.m)(styles, overrideStyles) : styles;
});
const $c46738fef3a1a380$export$4e983f376ad8a3af = (0, $5iWql.default)((width, isMulti, overrideStyles)=>({
        ...$c46738fef3a1a380$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
    }));

});

parcelRegister("4dR1n", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $a3dbd76a262a50b0$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $a3dbd76a262a50b0$export$19205fd341a6bb08);

var $5iWql = parcelRequire("5iWql");

var $bEfg9 = parcelRequire("bEfg9");

var $y5ydU = parcelRequire("y5ydU");

var $3oEge = parcelRequire("3oEge");

var $g5mgF = parcelRequire("g5mgF");

var $lftfg = parcelRequire("lftfg");

var $aRUd7 = parcelRequire("aRUd7");

var $cRDmG = parcelRequire("cRDmG");

var $5Hu7b = parcelRequire("5Hu7b");

var $6BfkR = parcelRequire("6BfkR");

var $bP6rt = parcelRequire("bP6rt");
const $a3dbd76a262a50b0$export$4e811121b221213b = (0, $5iWql.default)((multi, anchor)=>{
    if (anchor) return {
        Control: anchor,
        Option: $g5mgF.Option
    };
    else return {
        MultiValue: $y5ydU.MultiValue,
        DropdownIndicator: null,
        SingleValue: $lftfg.SingleValue,
        ClearIndicator: multi ? null : (0, $bEfg9.ClearIndicator),
        Option: $g5mgF.Option,
        ValueContainer: multi ? (0, $3oEge.MultiValueContainer) : (0, $cRDmG.SingleValueContainer),
        Input: $aRUd7.Input,
        Menu: $bP6rt.Menu
    };
});
const $a3dbd76a262a50b0$export$19205fd341a6bb08 = (0, $5iWql.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $lftfg.SingleValue,
        ClearIndicator: $bEfg9.ClearIndicator,
        Option: $g5mgF.Option,
        ValueContainer: (0, $cRDmG.SingleValueContainer),
        Input: (0, $5Hu7b.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6BfkR.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("bEfg9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $29bd55272a291249$export$ecf9cf59142dd54a);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

const $29bd55272a291249$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kZKuG")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $29bd55272a291249$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29bd55272a291249$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("kZKuG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("d9TBY").then(()=>parcelRequire('fxbL4'));

});


parcelRegister("y5ydU", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $af295f744665a83e$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $6CQF2 = parcelRequire("6CQF2");

var $fWEEw = parcelRequire("fWEEw");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $4nce6 = parcelRequire("4nce6");
function $af295f744665a83e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af295f744665a83e$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $af295f744665a83e$var$groupTagContainer = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.025'
});
const $af295f744665a83e$var$nameWrapper = {
    name: "6urmvo",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $af295f744665a83e$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.getElemBefore = ()=>{
            const { data: { data: data }, selectProps: selectProps } = this.props;
            if ((0, $cHYJ6.isEmail)(data)) return selectProps.emailLabel ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $6CQF2.AddOptionAvatar), {
                isLozenge: true,
                label: selectProps.emailLabel
            }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $hAQEH.messages).addEmail, (label)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6CQF2.AddOptionAvatar), {
                    isLozenge: true,
                    label: label
                }));
            if ((0, $cHYJ6.isGroup)(data)) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
                xcss: $af295f744665a83e$var$groupTagContainer
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
                label: "group-icon",
                size: "small"
            }));
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: "multi",
                src: (0, $cHYJ6.getAvatarUrl)(data)
            });
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $af295f744665a83e$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $af295f744665a83e$var$nameWrapper
        }, children));
    }
}

});
parcelRegister("6CQF2", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $9d5e4069310b8c35$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8IVhP = parcelRequire("8IVhP");


var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");
const $9d5e4069310b8c35$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center'
    });
};
const $9d5e4069310b8c35$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9d5e4069310b8c35$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8IVhP))), {
        label: label,
        size: isLozenge ? 'small' : 'medium',
        primaryColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $659edeb603307d4b$var$_email = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("8qa3H")));
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $659edeb603307d4b$var$_email.default
    }));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = module.exports.default = $659edeb603307d4b$var$EmailIcon;

});
parcelRegister("8qa3H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb86c704b4aada9757c695d217a2634>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62188de139005924$var$_react = $62188de139005924$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $62188de139005924$var$_UNSAFE_baseNew = $62188de139005924$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $62188de139005924$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62188de139005924$var$EmailIcon = (props)=>/*#__PURE__*/ $62188de139005924$var$_react.default.createElement($62188de139005924$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
    }, props));
$62188de139005924$var$EmailIcon.displayName = 'EmailIcon';
var $62188de139005924$var$_default = module.exports.default = $62188de139005924$var$EmailIcon;

});



parcelRegister("fWEEw", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $c352fe32cb3aa4c8$export$44d81a88129649da);

var $iJlfe = parcelRequire("iJlfe");

var $3Dk5Z = parcelRequire("3Dk5Z");

var $eUqFw = parcelRequire("eUqFw");

var $cHYJ6 = parcelRequire("cHYJ6");
class $c352fe32cb3aa4c8$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $cHYJ6.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dk5Z.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), props);
    }
}

});
parcelRegister("3Dk5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1869a65c00213d53$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");


var $eJ2Jf = parcelRequire("eJ2Jf");
const $1869a65c00213d53$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $1869a65c00213d53$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
function $1869a65c00213d53$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`
    }, (innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ2Jf.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            ...innerProps
        }));
}

});
parcelRegister("eJ2Jf", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $3fb7f58cf3c7f578$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $4nce6 = parcelRequire("4nce6");

function $3fb7f58cf3c7f578$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3fb7f58cf3c7f578$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $3fb7f58cf3c7f578$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $3fb7f58cf3c7f578$var$ICON_PADDING = 4;
const $3fb7f58cf3c7f578$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    backgroundColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $3fb7f58cf3c7f578$var$nestedAvatarStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $3fb7f58cf3c7f578$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $3fb7f58cf3c7f578$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3fb7f58cf3c7f578$var$avatarDefaultIconStyles,
            $3fb7f58cf3c7f578$var$nestedAvatarStyles[size]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: alt,
        primaryColor: $3fb7f58cf3c7f578$var$ICON_BACKGROUND,
        secondaryColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
        testId: testId && `${testId}--team`
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", rest, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $3fb7f58cf3c7f578$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $32f2cb577afb3a41$var$_peopleGroup = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("dd6Uq")));
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $32f2cb577afb3a41$var$_peopleGroup.default
    }));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = module.exports.default = $32f2cb577afb3a41$var$PeopleIcon;

});





parcelRegister("3oEge", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $d9c4f0fcc6c50ee5$export$cf9cf2a30a59265c);

var $jQxSL = parcelRequire("jQxSL");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $8uD7Y = parcelRequire("8uD7Y");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $8fe8e = parcelRequire("8fe8e");
class $d9c4f0fcc6c50ee5$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props);
        this.timeoutId = null;
        this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        };
        this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        };
        this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(this.props.children, (child)=>(0, $cHYJ6.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
        };
        this.renderChildren = ()=>{
            const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        };
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fe8e.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props, this.renderChildren()));
    }
}

});
parcelRegister("8fe8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d958d4fcf0f18b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $b2d958d4fcf0f18b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $b2d958d4fcf0f18b$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $b2d958d4fcf0f18b$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b2d958d4fcf0f18b$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $b2d958d4fcf0f18b$export$2e2bcd8739ae039 = $b2d958d4fcf0f18b$var$ValueContainerWrapper;

});


parcelRegister("g5mgF", function(module, exports) {

$parcel$export(module.exports, "Option", () => $69e114acf80b738d$export$36d18380658d5d20);

var $b5IAe = parcelRequire("b5IAe");

var $jQxSL = parcelRequire("jQxSL");

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $geaMl = parcelRequire("geaMl");

var $eV39A = parcelRequire("eV39A");

var $dqj52 = parcelRequire("dqj52");

var $diO51 = parcelRequire("diO51");

var $4jmtC = parcelRequire("4jmtC");

var $19gl5 = parcelRequire("19gl5");

var $cHYJ6 = parcelRequire("cHYJ6");

var $eL5KE = parcelRequire("eL5KE");
const $69e114acf80b738d$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geaMl.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $69e114acf80b738d$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $cHYJ6.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eV39A.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geaMl.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jmtC.default), {
        email: data,
        emailValidity: (0, $eL5KE.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $cHYJ6.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dqj52.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diO51.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $19gl5.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $69e114acf80b738d$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, $69e114acf80b738d$var$dataOption(props)));
    return $69e114acf80b738d$var$dataOption(props);
};
const $69e114acf80b738d$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
        fallback: $69e114acf80b738d$var$defaultOption(props)
    }, $69e114acf80b738d$var$dataOptionWithTooltip(props)));

});
parcelRegister("geaMl", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $a2ecfda802f63071$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $7cBHL = parcelRequire("7cBHL");

var $decpf = parcelRequire("decpf");

var $fWEEw = parcelRequire("fWEEw");

var $cHYJ6 = parcelRequire("cHYJ6");
class $a2ecfda802f63071$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7cBHL.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $decpf.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $cHYJ6.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $byn9U.jsx)((0, $decpf.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: "big",
                src: avatarUrl,
                presence: status
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("7cBHL", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $da888a92b8218389$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $da888a92b8218389$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cHYJ6 = parcelRequire("cHYJ6");
function $da888a92b8218389$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $da888a92b8218389$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("kZKuG")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $da888a92b8218389$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $da888a92b8218389$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $da888a92b8218389$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        fontSize: '0.85em'
    } : {};
    return /*#__PURE__*/ (0, $byn9U.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $da888a92b8218389$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $da888a92b8218389$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $byn9U.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $da888a92b8218389$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $cHYJ6.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
                fallback: /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $byn9U.jsx)($da888a92b8218389$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $da888a92b8218389$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$optionWrapper
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("decpf", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $394febfe0c687d04$export$bb02e7bc6e1a7119);

var $eUqFw = parcelRequire("eUqFw");
class $394febfe0c687d04$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}

});


parcelRegister("eV39A", function(module, exports) {

$parcel$export(module.exports, "default", () => $876fe813f4c1c632$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $876fe813f4c1c632$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("jTQuA")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $876fe813f4c1c632$export$2e2bcd8739ae039 = $876fe813f4c1c632$var$AsyncExternalUserOption;

});
parcelRegister("jTQuA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("d3tcO")
]).then(()=>parcelRequire('ipFJ8'));

});


parcelRegister("dqj52", function(module, exports) {

$parcel$export(module.exports, "default", () => $99124d670f0cce21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $99124d670f0cce21$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("1icV4")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $99124d670f0cce21$export$2e2bcd8739ae039 = $99124d670f0cce21$var$AsyncTeamOption;

});
parcelRegister("1icV4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kS5MT").then(()=>parcelRequire('h6N8Y'));

});


parcelRegister("diO51", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca6f28ecfe324c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $1ca6f28ecfe324c4$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("6MXJu")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $1ca6f28ecfe324c4$export$2e2bcd8739ae039 = $1ca6f28ecfe324c4$var$AsyncGroupOption;

});
parcelRegister("6MXJu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cupcD").then(()=>parcelRequire('67Bgx'));

});


parcelRegister("4jmtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70a8ac55002f9ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $c70a8ac55002f9ee$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("6TnIL")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $c70a8ac55002f9ee$export$2e2bcd8739ae039 = $c70a8ac55002f9ee$var$AsyncEmailOption;

});
parcelRegister("6TnIL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jHxNy").then(()=>parcelRequire('fGM7m'));

});


parcelRegister("19gl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $939b3c40c1c8ea24$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $939b3c40c1c8ea24$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("bN1xj")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $939b3c40c1c8ea24$export$2e2bcd8739ae039 = $939b3c40c1c8ea24$var$AsyncCustomOption;

});
parcelRegister("bN1xj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jiY6F").then(()=>parcelRequire('70iAn'));

});


parcelRegister("eL5KE", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $74079603909b5140$export$371e338370561054);
const $74079603909b5140$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $74079603909b5140$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $74079603909b5140$export$371e338370561054 = (inputText)=>{
    if (inputText.match($74079603909b5140$var$validRegex)) return 'VALID';
    if (inputText.match($74079603909b5140$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("lftfg", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $b0efde321d2f82a0$export$1949dac661ba6e3a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $6R0C9 = parcelRequire("6R0C9");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $fWEEw = parcelRequire("fWEEw");

var $cHYJ6 = parcelRequire("cHYJ6");
const $b0efde321d2f82a0$var$avatarItemComponent = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    border: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-0, 0px)"} !important`,
    width: 'auto',
    overflow: 'hidden',
    minWidth: '100px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        boxSizing: 'border-box'
    },
    '&:hover': {
        width: 'auto',
        padding: 0,
        border: 'none'
    }
});
const $b0efde321d2f82a0$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6R0C9.default), {
        backgroundColor: "transparent",
        avatar: /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
            src: (0, $cHYJ6.getAvatarUrl)(data),
            appearance: appearance
        }),
        primaryText: label
    }, ({ ref: ref, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b0efde321d2f82a0$var$avatarItemComponent,
            ...props
        }))) : null;
};

});
parcelRegister("6R0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303d2caa12f1c14$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");


var $lcnyw = parcelRequire("lcnyw");

var $eri7S = parcelRequire("eri7S");

var $6ecEX = parcelRequire("6ecEX");
function $d303d2caa12f1c14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d303d2caa12f1c14$var$avatarItemStyles = {
    name: "1dq1lfl",
    styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
};
const $d303d2caa12f1c14$var$secondaryTextOldStyles = {
    name: "1udad45",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
};
const $d303d2caa12f1c14$var$baseTextStyles = {
    name: "1sodx6b",
    styles: "display:block;color:var(--ds-text, #172B4D)"
};
const $d303d2caa12f1c14$var$truncationStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $d303d2caa12f1c14$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @repo/internal/react/no-css-string-literals
    css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, $lcnyw.borderRadius)()}px;
		border: ${0, $eri7S.BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $d303d2caa12f1c14$var$AvatarItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--itemInner`
        } : {
            testId: `${testId}--itemInner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClick) : {
                onClick: onClick
            }
        };
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            ref: ref,
            className: $d303d2caa12f1c14$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(onClick || href) && {
                'aria-label': label
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $d303d2caa12f1c14$var$avatarItemStyles
            }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                maxLines: isTruncationDisabled ? undefined : 1
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                color: "color.text.subtlest",
                maxLines: isTruncationDisabled ? undefined : 1,
                size: "UNSAFE_small"
            }, secondaryText)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    $d303d2caa12f1c14$var$secondaryTextOldStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, secondaryText))))
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d303d2caa12f1c14$var$AvatarItem.displayName = 'AvatarItem';
var $d303d2caa12f1c14$export$2e2bcd8739ae039 = $d303d2caa12f1c14$var$AvatarItem;

});


parcelRegister("aRUd7", function(module, exports) {

$parcel$export(module.exports, "Input", () => $a6afe550849f2f63$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
class $a6afe550849f2f63$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    /**
	 * Overrides the default behaviour of react-select lib
	 *
	 * The getter is a workaround for original behaviour of the react-select lib.
	 * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
	 * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
	 * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
	 */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        });
    }
    constructor(...args){
        super(...args);
        // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("cRDmG", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $9a44acf63722ec21$export$afa5f855316c6a48);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $fWEEw = parcelRequire("fWEEw");

var $dTS4n = parcelRequire("dTS4n");

var $8fe8e = parcelRequire("8fe8e");
function $9a44acf63722ec21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9a44acf63722ec21$var$placeholderIconContainer = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $dTS4n.BORDER_PADDING),
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $9a44acf63722ec21$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
var $9a44acf63722ec21$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
class $9a44acf63722ec21$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8fe8e.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ValueContainer, valueContainerProps, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $9a44acf63722ec21$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        this.renderAvatar = ()=>{
            const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $9a44acf63722ec21$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        };
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $9a44acf63722ec21$var$_ref,
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        };
    }
}

});

parcelRegister("5Hu7b", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $af7bd16282155901$export$d8edbfd510a7db82);

var $eUqFw = parcelRequire("eUqFw");

var $aRUd7 = parcelRequire("aRUd7");
class $af7bd16282155901$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aRUd7.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6BfkR", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $2db2d66d3748ae86$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

const $2db2d66d3748ae86$var$spacing = 8;
const $2db2d66d3748ae86$var$fontSize = 12;
const $2db2d66d3748ae86$var$innerHeight = $2db2d66d3748ae86$var$spacing * 2; // 16px
const $2db2d66d3748ae86$var$lineHeight = $2db2d66d3748ae86$var$innerHeight / $2db2d66d3748ae86$var$fontSize;
const $2db2d66d3748ae86$var$controlWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $2db2d66d3748ae86$var$getLabelStyle = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
        fontSize: `${$2db2d66d3748ae86$var$fontSize}px`,
        fontWeight: 600,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${$2db2d66d3748ae86$var$lineHeight}`,
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-0, 0px)",
        paddingTop: "var(--ds-space-250, 20px)"
    });
class $2db2d66d3748ae86$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $2db2d66d3748ae86$var$controlWrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $2db2d66d3748ae86$var$getLabelStyle()
        }, popupTitle), /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, this.props));
    }
}

});

parcelRegister("bP6rt", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $f6008453f5d5b3f2$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");
const $f6008453f5d5b3f2$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $f6008453f5d5b3f2$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f6008453f5d5b3f2$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("fiLGD", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $8c4e3608dc9bf116$export$36f97d8afa97203d);

var $5iWql = parcelRequire("5iWql");


var $eL5KE = parcelRequire("eL5KE");

var $cHYJ6 = parcelRequire("cHYJ6");
const $8c4e3608dc9bf116$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $8c4e3608dc9bf116$var$isValidNewOption = (isValidEmail = (0, $eL5KE.isValidEmail))=>(inputValue)=>inputValue && $8c4e3608dc9bf116$var$validOption.includes(isValidEmail(inputValue));
const $8c4e3608dc9bf116$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $0b440fae145c26fc$export$6662b3461398ef8c)
        }
    });
const $8c4e3608dc9bf116$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $8c4e3608dc9bf116$var$isOptionDisabled = (isValidEmail = (0, $eL5KE.isValidEmail))=>(option)=>{
        if ((0, $cHYJ6.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $8c4e3608dc9bf116$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $8c4e3608dc9bf116$var$isValidNewOption(isValidEmail),
        getNewOptionData: $8c4e3608dc9bf116$var$getNewOptionData,
        formatCreateLabel: $8c4e3608dc9bf116$var$formatCreateLabel,
        isOptionDisabled: $8c4e3608dc9bf116$var$isOptionDisabled(isValidEmail)
    };
}
const $8c4e3608dc9bf116$export$36f97d8afa97203d = (0, $5iWql.default)($8c4e3608dc9bf116$var$creatableProps);

});

parcelRegister("bxvbM", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $c7d74c04cc603d9e$export$34b9dd2dd6a225e5);

var $5iWql = parcelRequire("5iWql");


var $eL5KE = parcelRequire("eL5KE");

var $cHYJ6 = parcelRequire("cHYJ6");
const $c7d74c04cc603d9e$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $c7d74c04cc603d9e$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $c7d74c04cc603d9e$var$getNewOptionData = (isValidEmail = (0, $eL5KE.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $c7d74c04cc603d9e$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $0b440fae145c26fc$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $c7d74c04cc603d9e$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $c7d74c04cc603d9e$var$isOptionDisabled = (isValidEmail = (0, $eL5KE.isValidEmail))=>(option)=>{
        if ((0, $cHYJ6.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $c7d74c04cc603d9e$export$34b9dd2dd6a225e5 = (0, $5iWql.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $c7d74c04cc603d9e$var$isValidNewOption,
        getNewOptionData: $c7d74c04cc603d9e$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $c7d74c04cc603d9e$var$formatCreateLabel,
        isOptionDisabled: $c7d74c04cc603d9e$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("1mZCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bdf5d8ea911c991$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $fgOWi = parcelRequire("fgOWi");
const $5bdf5d8ea911c991$var$EMPTY = {};
const $5bdf5d8ea911c991$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($5bdf5d8ea911c991$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($5bdf5d8ea911c991$var$EMPTY);
        (0, $fgOWi.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $5bdf5d8ea911c991$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { children: children } = props;
    const messages = $5bdf5d8ea911c991$var$useI18n(intl.locale);
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $5bdf5d8ea911c991$export$2e2bcd8739ae039 = $5bdf5d8ea911c991$var$MessagesIntlProvider;

});
parcelRegister("fgOWi", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $0294972dd0e7529b$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $0294972dd0e7529b$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("baTmd")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("izFzj")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("6SFt8")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("kGmwS")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ilBg0")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("69A6y")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("7PFQm")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("jXj5T")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4KWIq")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("8xtm3")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("l1q1j")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("lFPEu")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("k83ZD")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("84r0w")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5lmmg")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("4TyK7")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("88i5c")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("aMhDi")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7bhXC")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("05cKn")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("jRs45")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("gQK5o")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("l0UPQ")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cVaCM")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("f10W2")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("hgyQW")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("eKtFN")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("7v9Lp")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("aQWkV")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $0294972dd0e7529b$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("kGmwS")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("baTmd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i0Pe8").then(()=>parcelRequire('or03D'));

});

parcelRegister("izFzj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8BOU0").then(()=>parcelRequire('lNiRt'));

});

parcelRegister("6SFt8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8l0dy").then(()=>parcelRequire('p7JNt'));

});

parcelRegister("kGmwS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bxgOi").then(()=>parcelRequire('eILmt'));

});

parcelRegister("ilBg0", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3pgy1").then(()=>parcelRequire('7vzzX'));

});

parcelRegister("69A6y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8W7RH").then(()=>parcelRequire('7Ptvo'));

});

parcelRegister("7PFQm", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7NgAP").then(()=>parcelRequire('bYcIY'));

});

parcelRegister("jXj5T", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ifr0G").then(()=>parcelRequire('2HL4d'));

});

parcelRegister("4KWIq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4TLdl").then(()=>parcelRequire('gBgnK'));

});

parcelRegister("8xtm3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("knvW7").then(()=>parcelRequire('fWgwA'));

});

parcelRegister("l1q1j", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7BTAu").then(()=>parcelRequire('bWAwm'));

});

parcelRegister("lFPEu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kMXHV").then(()=>parcelRequire('bfB2v'));

});

parcelRegister("k83ZD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6szWe").then(()=>parcelRequire('fEK8N'));

});

parcelRegister("84r0w", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6nfH5").then(()=>parcelRequire('guy7d'));

});

parcelRegister("5lmmg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hcA4m").then(()=>parcelRequire('8b2sJ'));

});

parcelRegister("4TyK7", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dGDd3").then(()=>parcelRequire('3CFXE'));

});

parcelRegister("88i5c", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b1OEX").then(()=>parcelRequire('5OhZL'));

});

parcelRegister("aMhDi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6L31b").then(()=>parcelRequire('2usan'));

});

parcelRegister("7bhXC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aJiHI").then(()=>parcelRequire('fUbQi'));

});

parcelRegister("05cKn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6oIXh").then(()=>parcelRequire('87pIs'));

});

parcelRegister("jRs45", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("l6J1G").then(()=>parcelRequire('1Ydae'));

});

parcelRegister("gQK5o", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bYIVb").then(()=>parcelRequire('cNlCa'));

});

parcelRegister("l0UPQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2SONo").then(()=>parcelRequire('24GPb'));

});

parcelRegister("cVaCM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bUOZE").then(()=>parcelRequire('4Zzmi'));

});

parcelRegister("f10W2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b3vK4").then(()=>parcelRequire('cZgsZ'));

});

parcelRegister("hgyQW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("czbsK").then(()=>parcelRequire('eLbuu'));

});

parcelRegister("eKtFN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cdt3f").then(()=>parcelRequire('3UnDQ'));

});

parcelRegister("7v9Lp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jzy6n").then(()=>parcelRequire('7qhnG'));

});

parcelRegister("aQWkV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kukRa").then(()=>parcelRequire('mz9nj'));

});



parcelRegister("ToOs1", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $8f66b178b236b94b$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $8f66b178b236b94b$export$c6c0c1a2bac363f);

var $eUqFw = parcelRequire("eUqFw");
const $8f66b178b236b94b$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eUqFw.createContext)({});
const $8f66b178b236b94b$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f66b178b236b94b$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $8f66b178b236b94b$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eUqFw.useContext)($8f66b178b236b94b$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eUqFw.useState)([]);
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const abortController = (0, $eUqFw.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("hiBi9", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayModal", () => $df085b8c8c8c9e63$export$32eec1126fb86cc9);
$parcel$export(module.exports, "useInvitePeopleDrawer", () => $df085b8c8c8c9e63$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $df085b8c8c8c9e63$export$b7dab610045052db);

var $1Iui1 = parcelRequire("1Iui1");

var $96gVp = parcelRequire("96gVp");
var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
var $2HpOy = parcelRequire("2HpOy");
var $4s7hU = parcelRequire("4s7hU");

var $cQrkf = parcelRequire("cQrkf");
const $df085b8c8c8c9e63$var$CONTROLLER_NAME = 'invite-people-drawer';
const $df085b8c8c8c9e63$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $df085b8c8c8c9e63$export$1dbc37ce23aead84 = ({ inviteFromAssignModalCohort: inviteFromAssignModalCohort })=>{
    let resolvedCohort = {
        cohort: '',
        ineligibilityReasons: [
            ''
        ]
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.NOT_ENROLLED)) resolvedCohort = {
        cohort: (0, $1Iui1.NOT_ENROLLED),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.CONTROL)) resolvedCohort = {
        cohort: (0, $1Iui1.CONTROL),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.VARIATION)) resolvedCohort = {
        cohort: (0, $1Iui1.VARIATION),
        ineligibilityReasons: []
    };
    return resolvedCohort;
};
const $df085b8c8c8c9e63$export$32eec1126fb86cc9 = (inviteAssignModelContext)=>{
    if ($df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext).cohort === (0, $1Iui1.VARIATION)) return true;
    return false;
};
const $df085b8c8c8c9e63$var$Store = (0, $kEDjj.createStore)({
    name: $df085b8c8c8c9e63$var$CONTROLLER_NAME,
    initialState: $df085b8c8c8c9e63$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl }, inviteAssignModelContext, invitePromptOnLinkInsertContext)=>({ setState: setState })=>{
                const displayModal = inviteAssignModelContext && $df085b8c8c8c9e63$export$32eec1126fb86cc9(inviteAssignModelContext);
                let processedInviteAssignModalContext;
                if (inviteAssignModelContext) {
                    processedInviteAssignModalContext = {
                        ...inviteAssignModelContext
                    };
                    const { cohort: resultCohort, ineligibilityReasons: ineligibilityReasons } = $df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext);
                    (0, $cQrkf.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, resultCohort, analyticsSource);
                    (0, $cQrkf.fireInviteFromAssignModalExposedAnalytics)(createAnalyticsEvent, inviteAssignModelContext.inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, analyticsSource);
                    processedInviteAssignModalContext.inviteFromAssignModalCohort = resultCohort;
                }
                if (displayModal) (0, $cQrkf.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, inviteAssignModelContext, analyticsSource);
                else (0, $cQrkf.fireDrawerTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl,
                    inviteAssignModelContext: processedInviteAssignModalContext,
                    invitePromptOnLinkInsertContext: invitePromptOnLinkInsertContext
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($df085b8c8c8c9e63$var$initialState)
    }
});
const $df085b8c8c8c9e63$export$48fb2d80745c5e67 = (0, $1yZQx.createHook)($df085b8c8c8c9e63$var$Store);
const $df085b8c8c8c9e63$export$ac7fed664b4735b5 = (0, $96gVp.createContainer)($df085b8c8c8c9e63$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $df085b8c8c8c9e63$export$4358742cbaf4a6d4 = (0, $2HpOy.createSubscriber)($df085b8c8c8c9e63$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $df085b8c8c8c9e63$export$b7dab610045052db = (createAnalyticsEvent, contextConfig, inviteAssignModelContext)=>{
    (0, $4s7hU.defaultRegistry).getStore($df085b8c8c8c9e63$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig, inviteAssignModelContext);
};

});
parcelRegister("cQrkf", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $de9a0e3d07ee4b39$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireDrawerTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$2e49c23c45194e1a);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$6815765da918b983);
$parcel$export(module.exports, "fireInviteFromAssignModalExposedAnalytics", () => $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $de9a0e3d07ee4b39$export$21b810258e82d438);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $iKlrz = parcelRequire("iKlrz");

var $3FyZ4 = parcelRequire("3FyZ4");

var $9QFxq = parcelRequire("9QFxq");
const $de9a0e3d07ee4b39$var$getInviteFromAssignCohort = ()=>(0, $1ybV0.getFeatureFlagValue)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED));
const $de9a0e3d07ee4b39$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eUqFw.useRef)((0, $3FyZ4.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $iKlrz.getEvent)(analyticsEvent)));
        }
    };
};
const $de9a0e3d07ee4b39$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $de9a0e3d07ee4b39$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$2e49c23c45194e1a = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'drawer',
        actionSubjectId: 'invitePeopleDrawer',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort()
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, inviteAssignModelContext, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort(),
            inviteFromAssignModalCohort: inviteAssignModelContext.inviteFromAssignModalCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b = async (createAnalyticsEvent, inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, source)=>{
    const analyticsPayload = {
        action: 'exposed',
        actionSubject: 'feature',
        product: 'jira',
        attributes: {
            flagKey: 'invite.from.assign.modal',
            value: inviteFromAssignModalCohort,
            cohort: resultCohort,
            growthInitiative: 'virality',
            ineligibilityReasons: ineligibilityReasons
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    if (createAnalyticsEvent) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendTrackEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$21b810258e82d438 = async (createAnalyticsEvent, resultCohort, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        attributes: {
            inviteFromAssignModalCohort: resultCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("9QFxq", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $2b0bde6b83f84248$export$c35cd18e9d0123e3);
const $2b0bde6b83f84248$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



const $7a4a7348bcf111f0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $7a4a7348bcf111f0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $7a4a7348bcf111f0$export$f5d5f6bb902f1027 = '-1';

parcelRegister("6cPKE", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $c06f6916b7f49c06$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $c06f6916b7f49c06$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $c06f6916b7f49c06$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $c06f6916b7f49c06$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $c06f6916b7f49c06$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $c06f6916b7f49c06$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $c06f6916b7f49c06$export$322b6ab8c29a006e);

var $51p9V = parcelRequire("51p9V");

var $1fo2u = parcelRequire("1fo2u");

const $c06f6916b7f49c06$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$bdab9bfb39981463),
        displayName: formatMessage((0, $51p9V.default).unassignedOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $51p9V.default).automaticOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $51p9V.default).invitePeopleOptionAdmin : (0, $51p9V.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($1fo2u)))
        }
    });
const $c06f6916b7f49c06$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $c06f6916b7f49c06$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $c06f6916b7f49c06$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $c06f6916b7f49c06$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("51p9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a9b3be869d04c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $62a9b3be869d04c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("1fo2u", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});


parcelRegister("b5qOz", function(module, exports) {

$parcel$export(module.exports, "INVITE_FROM_ASSIGN", () => $2ebcd2dcd5becbb5$export$d304132d091ca1ac);
$parcel$export(module.exports, "getInviteFromAssignCohort", () => $2ebcd2dcd5becbb5$export$dfa2a595c2323732);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $2ebcd2dcd5becbb5$export$cdd5c612352d7bf0);
/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");
const $2ebcd2dcd5becbb5$export$d304132d091ca1ac = 'invite.from.assign';
const $2ebcd2dcd5becbb5$export$dfa2a595c2323732 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)($2ebcd2dcd5becbb5$export$d304132d091ca1ac, (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $2ebcd2dcd5becbb5$export$cdd5c612352d7bf0 = ()=>$2ebcd2dcd5becbb5$export$dfa2a595c2323732() === (0, $1Iui1.VARIATION);

});

parcelRegister("dRJbT", function(module, exports) {

$parcel$export(module.exports, "useAssigneeOptions", () => $256397ae5b7d05ee$export$1eb7ccf9fc55d2e8);

var $eUqFw = parcelRequire("eUqFw");

var $9ZJqc = parcelRequire("9ZJqc");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");

var $lGLse = parcelRequire("lGLse");


var $6cPKE = parcelRequire("6cPKE");

var $b5qOz = parcelRequire("b5qOz");

var $51p9V = parcelRequire("51p9V");
const $256397ae5b7d05ee$var$fireInviteFromAssignExposureEvent = (createAnalyticsEvent, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'exposed';
    const actionSubject = 'feature';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        flagKey: (0, $b5qOz.INVITE_FROM_ASSIGN),
        value: (0, $b5qOz.getInviteFromAssignCohort)(),
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $256397ae5b7d05ee$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $jMP2a.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $256397ae5b7d05ee$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign)=>{
    const [exposureEventTriggered, setExposureEventTriggered] = (0, $eUqFw.useState)(false);
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const unassigned = (0, $6cPKE.getUnassignedUser)(intl);
    const automaticOption = (0, $6cPKE.getAutomaticUserOption)(intl);
    const valueOption = (0, $6cPKE.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $6cPKE.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $51p9V.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $6cPKE.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (!exposureEventTriggered) {
            setExposureEventTriggered(true);
            $256397ae5b7d05ee$var$fireInviteFromAssignExposureEvent(createAnalyticsEvent, userOptions.length, isAdmin);
        }
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $9ZJqc.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $256397ae5b7d05ee$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
        } else if ((0, $b5qOz.isInviteFromAssignEnabled)()) {
            $256397ae5b7d05ee$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
            invitePeopleOptions.push((0, $6cPKE.getUserOptionFromUser)((0, $6cPKE.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $6cPKE.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $6cPKE.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options
    ];
};

});
parcelRegister("9ZJqc", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $3811abc2872da18e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $3811abc2872da18e$export$34e0d98131b0b98a);

var $eL5KE = parcelRequire("eL5KE");

var $6AP7w = parcelRequire("6AP7w");


var $obNhg = parcelRequire("obNhg");
const $3811abc2872da18e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $1199e142050a1a33$export$18d36911c7f94286),
        (0, $1199e142050a1a33$export$da1c529049028734)
    ].includes((0, $eL5KE.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $3811abc2872da18e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $eL5KE.isValidEmail)(inputValue) === (0, $1199e142050a1a33$export$18d36911c7f94286);
const $3811abc2872da18e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $3811abc2872da18e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $1199e142050a1a33$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6AP7w))),
        byline: formatMessage((0, $obNhg.default).inviteAndAssign),
        isDisabled: (0, $eL5KE.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("6AP7w", function(module, exports) {
module.exports = new URL("email.very-specific-illu.43fa850c.png", import.meta.url).toString();

});

const $1199e142050a1a33$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $1199e142050a1a33$export$18d36911c7f94286 = 'VALID';
const $1199e142050a1a33$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("obNhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50baaac4d43c10b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d50baaac4d43c10b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});



parcelRegister("aE92Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c15bb5f3c640bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $49c15bb5f3c640bd$var$useUsersQuery = (autoCompleteUrl)=>{
    const [users, setUsers] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const currentQuery = (0, $eUqFw.useRef)('');
    const fetchUsers = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        return (0, $2OdyW.default)(usersFetchUrl).then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.assigne', 'Failed to fetch users', err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $49c15bb5f3c640bd$export$2e2bcd8739ae039 = $49c15bb5f3c640bd$var$useUsersQuery;

});


parcelRegister("lIor1", function(module, exports) {

$parcel$export(module.exports, "validateString", () => $e73e6bfff42de9c2$export$d7b0a588f685ba7e);
$parcel$export(module.exports, "validateSelectField", () => $e73e6bfff42de9c2$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateCascadingSelectField", () => $e73e6bfff42de9c2$export$837294b8fc732f20);
$parcel$export(module.exports, "validateAssigneeField", () => $e73e6bfff42de9c2$export$dd17aabe3f77b2ba);
$parcel$export(module.exports, "validateUserPickerField", () => $e73e6bfff42de9c2$export$356346770aab95cb);
$parcel$export(module.exports, "validateCheckboxField", () => $e73e6bfff42de9c2$export$7aa5e0976d0c384b);
$parcel$export(module.exports, "validateComponentField", () => $e73e6bfff42de9c2$export$89943b0814df306d);
$parcel$export(module.exports, "validateCustomTeamsField", () => $e73e6bfff42de9c2$export$364ea91bee38a994);
$parcel$export(module.exports, "validateGroupPickerField", () => $e73e6bfff42de9c2$export$c6d4785f3f46f73a);
$parcel$export(module.exports, "validateMultiVersionsField", () => $e73e6bfff42de9c2$export$727e23f536334715);
$parcel$export(module.exports, "validateOrganizationsField", () => $e73e6bfff42de9c2$export$b97bb8e170430af8);
$parcel$export(module.exports, "validatePriorityField", () => $e73e6bfff42de9c2$export$17fd881b060187f7);
$parcel$export(module.exports, "validateRadioSelectField", () => $e73e6bfff42de9c2$export$f69029476f9179b);
$parcel$export(module.exports, "validateRadioGroupField", () => $e73e6bfff42de9c2$export$d60dcaa093bca71d);
$parcel$export(module.exports, "validateResolutionField", () => $e73e6bfff42de9c2$export$316feff8e636f81f);
$parcel$export(module.exports, "validateSingleVersionField", () => $e73e6bfff42de9c2$export$45f7908dc93110fb);
$parcel$export(module.exports, "validateLabelField", () => $e73e6bfff42de9c2$export$1a8caa895b9fda26);
$parcel$export(module.exports, "validateForgeLabelField", () => $e73e6bfff42de9c2$export$bf4287ae453e2aab);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $dEMIg = parcelRequire("dEMIg");

// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
    if (isRequired && !value?.trim?.()) return 0, $dEMIg.REQUIRED;
    if (typeof value === 'string' && type === 'text' && value?.length > (0, $a8a1251974a60726$export$fe1a70381f6491b5)) return 0, $a8a1251974a60726$export$618e922e89e8bcae;
    return undefined;
};
const $e73e6bfff42de9c2$export$53ded7ceec493f10 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$837294b8fc732f20 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$dd17aabe3f77b2ba = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$356346770aab95cb = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$7aa5e0976d0c384b = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$89943b0814df306d = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$364ea91bee38a994 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$c6d4785f3f46f73a = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$727e23f536334715 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (!value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$b97bb8e170430af8 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(data) && !data.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$17fd881b060187f7 = (data, isRequired)=>{
    if (isRequired && !data) return 0, $dEMIg.REQUIRED;
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$f69029476f9179b = (data, isRequired)=>{
    if (isRequired && !data) return 0, $dEMIg.REQUIRED;
    return undefined;
};
const $e73e6bfff42de9c2$export$d60dcaa093bca71d = (data, isRequired)=>{
    if (isRequired && !data) return 0, $dEMIg.REQUIRED;
    return undefined;
};
const $e73e6bfff42de9c2$export$316feff8e636f81f = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$45f7908dc93110fb = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$1a8caa895b9fda26 = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $dEMIg.REQUIRED;
    }
    if (labels && labels?.length > (0, $a8a1251974a60726$export$1fdf850c93de8bae)) return 0, $a8a1251974a60726$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label.value.trim()).some((value)=>value.includes(' ') || value.length > (0, $a8a1251974a60726$export$9151073f92820ff8))) return 0, $a8a1251974a60726$export$e77d629cc732976d;
    return undefined;
};
const $e73e6bfff42de9c2$export$bf4287ae453e2aab = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $dEMIg.REQUIRED;
    }
    if (labels && labels?.length > (0, $a8a1251974a60726$export$1fdf850c93de8bae)) return 0, $a8a1251974a60726$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label.value.trim()).some((value)=>value.length > (0, $a8a1251974a60726$export$9151073f92820ff8))) return 0, $a8a1251974a60726$export$8d30d41a8828e14f;
    return undefined;
};

});

parcelRegister("lgGuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6266b64a40eff077$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6266b64a40eff077$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assignToMe: {
        "id": "issue-create-commons.assignee-field.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("i8BXG", function(module, exports) {

$parcel$export(module.exports, "transformDefaultAssigneeValue", () => $33563d704875dd71$export$f5415de9103f1c69);
$parcel$export(module.exports, "mapUserToAssigneeValue", () => $33563d704875dd71$export$c4dfa893fba82437);
$parcel$export(module.exports, "mutateAssigneeUserPicker", () => $33563d704875dd71$export$a6706b2f4762043b);


const $33563d704875dd71$export$f5415de9103f1c69 = (value)=>({
        accountId: (value.accountId === '-1' ? (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027) : value.accountId) || '',
        displayName: value.name || '',
        avatarUrls: value.picture !== undefined ? {
            '16x16': value.picture,
            '24x24': value.picture,
            '32x32': value.picture,
            '48x48': value.picture
        } : {}
    });
const $33563d704875dd71$export$c4dfa893fba82437 = (value)=>{
    if (value === null) return null;
    if (value.accountId === (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) return undefined;
    return {
        id: value.accountId
    };
};
const $33563d704875dd71$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
    if (selectedUser === null || selectedUser.accountId === null) return null;
    return {
        fieldId: fieldId,
        mutationGroup: (0, $ab1884f8d9d06de2$export$6684456d545bf498),
        user: {
            accountId: selectedUser.accountId
        }
    };
};

});
const $ab1884f8d9d06de2$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $ab1884f8d9d06de2$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';



parcelRegister("5mmO4", function(module, exports) {

$parcel$export(module.exports, "TextFieldPlaceholder", () => $e7f3e3c4135556ba$export$6fa85fe91d7baf70);
$parcel$export(module.exports, "DescriptionFieldPlaceholder", () => $e7f3e3c4135556ba$export$b2a65447738df397);
$parcel$export(module.exports, "AttachmentFieldPlaceholder", () => $e7f3e3c4135556ba$export$b3e78b2794b60a3c);
$parcel$export(module.exports, "AssigneeFieldPlaceholder", () => $e7f3e3c4135556ba$export$628ddd885c3ef19a);
$parcel$export(module.exports, "DropdownFieldPlaceholder", () => $e7f3e3c4135556ba$export$6767d78d6b24ff93);
$parcel$export(module.exports, "DateFieldPlaceholder", () => $e7f3e3c4135556ba$export$94d5efb8e5cd7e54);
$parcel$export(module.exports, "DateTimeFieldPlaceholder", () => $e7f3e3c4135556ba$export$8ba7f20c1eb81d37);
$parcel$export(module.exports, "NotSupportedFieldPlaceholder", () => $e7f3e3c4135556ba$export$4b127f667f36c30b);
$parcel$export(module.exports, "NotSupportedRequiredFieldPlaceholder", () => $e7f3e3c4135556ba$export$d3334a4d2b09545d);
$parcel$export(module.exports, "NotSupportedOptionalFieldPlaceholder", () => $e7f3e3c4135556ba$export$6beb18ae293451d7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $kMHOY = parcelRequire("kMHOY");

var $86Ndv = parcelRequire("86Ndv");

var $96IgR = parcelRequire("96IgR");

var $iHib2 = parcelRequire("iHib2");

var $dlEQk = parcelRequire("dlEQk");

var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $czmqP = parcelRequire("czmqP");
const $e7f3e3c4135556ba$export$6fa85fe91d7baf70 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$TextFieldWrapper, null, formatMessage((0, $czmqP.default).fieldPlaceholder));
};
const $e7f3e3c4135556ba$export$b2a65447738df397 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$DescriptionWrapper, null, formatMessage((0, $czmqP.default).fieldPlaceholder));
};
const $e7f3e3c4135556ba$export$b3e78b2794b60a3c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$AttachmentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHib2))), {
        label: "upload"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $czmqP.default).attachmentFieldPlaceholder))));
};
const $e7f3e3c4135556ba$export$628ddd885c3ef19a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $e7f3e3c4135556ba$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dlEQk))), {
        label: "avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $czmqP.default).assigneeFieldPlaceholder)))));
};
const $e7f3e3c4135556ba$export$6767d78d6b24ff93 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$WithIconAfterFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $e7f3e3c4135556ba$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $czmqP.default).dropdownFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "openDropdown"
    }));
};
const $e7f3e3c4135556ba$export$94d5efb8e5cd7e54 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$WithIconAfterFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $e7f3e3c4135556ba$var$fieldHeight,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $czmqP.default).dateFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
        label: "calendar"
    }));
};
const $e7f3e3c4135556ba$export$8ba7f20c1eb81d37 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$SplitHalfFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        xcss: $e7f3e3c4135556ba$var$fieldHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $czmqP.default).dateFieldPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        xcss: $e7f3e3c4135556ba$var$fieldHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, formatMessage((0, $czmqP.default).timeFieldPlaceholder))));
};
const $e7f3e3c4135556ba$export$4b127f667f36c30b = ({ isRequired: isRequired, onRemoveFieldClick: onRemoveFieldClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$NotSupportedFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $czmqP.default).notSupportedRequiredFieldPlaceholder,
        values: {
            contactAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $czmqP.default).contactAdmin))
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $czmqP.default).notSupportedOptionalFieldPlaceholder,
        values: {
            clickHere: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                onClick: onRemoveFieldClick
            }, formatMessage((0, $czmqP.default).clickHere)))
        }
    }))));
};
const $e7f3e3c4135556ba$export$d3334a4d2b09545d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$NotSupportedFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $czmqP.default).notSupportedRequiredFieldPlaceholder,
        values: {
            contactAdmin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $czmqP.default).contactAdmin))
        }
    }))));
}; // component to be removed with clean up of `jwm-form-field-configs` feature gate
const $e7f3e3c4135556ba$export$6beb18ae293451d7 = ({ onRemoveFieldClick: onRemoveFieldClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$NotSupportedFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $czmqP.default).notSupportedOptionalFieldPlaceholder,
        values: {
            clickHere: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7f3e3c4135556ba$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                onClick: onRemoveFieldClick
            }, formatMessage((0, $czmqP.default).clickHere)))
        }
    }))));
};
const $e7f3e3c4135556ba$var$fieldHeight = (0, $1ZAYh.xcss)({
    height: '2.25rem'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f3e3c4135556ba$var$FieldBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1y44 _19it15jf _11q76rqw _syaz15i6 _1yt4h8dc _vwz414no",
            __cmplp.className
        ])
    });
}); /**
     * Expect icon in the content as the first element
     * Vertical align the icon and gives space between icon and the content
     */ 
const $e7f3e3c4135556ba$var$IconBeforeBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _10nju2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f3e3c4135556ba$var$FieldBaseWithIconBefore = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _10nju2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f3e3c4135556ba$var$TextFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i14no",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f3e3c4135556ba$var$DescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i8vuz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f3e3c4135556ba$var$AttachmentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i14no _11q7glyw _1dqogq9o _1bah1h6o",
            __cmplp.className
        ])
    });
}); /**
     * Expect an icon as the last child, so it will be placed in the very right
     */ 
const $e7f3e3c4135556ba$var$WithIconAfterFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1oc61wug",
            __cmplp.className
        ])
    });
}); /**
     * Expect the field contains 2 item where both will take 50% of the width
     */ 
const $e7f3e3c4135556ba$var$SplitHalfFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _12apkb7n",
            __cmplp.className
        ])
    });
});
const $e7f3e3c4135556ba$var$NotSupportedFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $e7f3e3c4135556ba$var$IconBeforeBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15i6 _1bsb1osq _vwz4gktf _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $e7f3e3c4135556ba$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i1wwidpf _8ax3idpf _ake1idpf _1gqwidpf _1rra1kw7 _t74oqslr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20cf79a37c55dc030e28f840f88e494b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});


parcelRegister("iHib2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9ca57b7a20a40df$var$_react = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d9ca57b7a20a40df$var$_cloudArrowUp = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("5Z1ia")));
function $d9ca57b7a20a40df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d9ca57b7a20a40df$var$UploadIcon = (props)=>/*#__PURE__*/ $d9ca57b7a20a40df$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $d9ca57b7a20a40df$var$_cloudArrowUp.default
    }));
$d9ca57b7a20a40df$var$UploadIcon.displayName = 'UploadIcon';
var $d9ca57b7a20a40df$var$_default = module.exports.default = $d9ca57b7a20a40df$var$UploadIcon;

});
parcelRegister("5Z1ia", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::febd6095fdf26c9199b6c7e2fc7e7331>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45b3a6cc7855c144$var$_react = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $45b3a6cc7855c144$var$_UNSAFE_baseNew = $45b3a6cc7855c144$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $45b3a6cc7855c144$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45b3a6cc7855c144$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $45b3a6cc7855c144$var$_react.default.createElement($45b3a6cc7855c144$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4 8.75A2.25 2.25 0 0 1 1.75 6.5v-.482a2.73 2.73 0 0 1 1.94-2.614l.739-.223.157-.427a3.058 3.058 0 0 1 5.82.242l.273.995h1.191a2.38 2.38 0 0 1 2.38 2.38V6.5A2.25 2.25 0 0 1 12 8.75m-4 0V16"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m5 11.75 3-3 3 3"/>`
    }, props));
$45b3a6cc7855c144$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $45b3a6cc7855c144$var$_default = module.exports.default = $45b3a6cc7855c144$var$CloudArrowUpIcon;

});


parcelRegister("dlEQk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b7ceb1f36e72568$var$_react = $9b7ceb1f36e72568$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9b7ceb1f36e72568$var$_personAvatar = $9b7ceb1f36e72568$var$_interopRequireDefault((parcelRequire("fmxcK")));
function $9b7ceb1f36e72568$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9b7ceb1f36e72568$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $9b7ceb1f36e72568$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $9b7ceb1f36e72568$var$_personAvatar.default
    }));
$9b7ceb1f36e72568$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $9b7ceb1f36e72568$var$_default = module.exports.default = $9b7ceb1f36e72568$var$UserAvatarCircleIcon;

});

parcelRegister("czmqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9324d116f761bc63$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9324d116f761bc63$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldPlaceholder: {
        "id": "business-form.common.field-placeholders.field-placeholder",
        "defaultMessage": "Answer will be written here"
    },
    attachmentFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.attachment-field-placeholder",
        "defaultMessage": "Attachments will be uploaded here"
    },
    assigneeFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.assignee-field-placeholder",
        "defaultMessage": "Unassigned"
    },
    dropdownFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.dropdown-field-placeholder",
        "defaultMessage": "Answer will be selected from dropdown"
    },
    dateFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.date-field-placeholder",
        "defaultMessage": "Date will be entered here"
    },
    timeFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.time-field-placeholder",
        "defaultMessage": "Time will be entered here"
    },
    notSupportedRequiredFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.not-supported-required-field-placeholder",
        "defaultMessage": "This required field is unsupported, {contactAdmin} to make this field optional"
    },
    contactAdmin: {
        "id": "business-form.common.field-placeholders.contact-admin",
        "defaultMessage": "contact admin"
    },
    notSupportedOptionalFieldPlaceholder: {
        "id": "business-form.common.field-placeholders.not-supported-optional-field-placeholder",
        "defaultMessage": "This field is unsupported, {clickHere} to remove this field. "
    },
    clickHere: {
        "id": "business-form.common.field-placeholders.click-here",
        "defaultMessage": "click here"
    }
});

});


parcelRegister("eHQA5", function(module, exports) {

$parcel$export(module.exports, "toLabelsField", () => $5fbf1d3a47a2288f$export$7a0cc61c6cdac523);
$parcel$export(module.exports, "textFieldWriter", () => $5fbf1d3a47a2288f$export$3f2b7c786f4381f3);
$parcel$export(module.exports, "selectFieldWriter", () => $5fbf1d3a47a2288f$export$9ed21ff1d3f239ed);
$parcel$export(module.exports, "checkboxSelectFieldWriter", () => $5fbf1d3a47a2288f$export$6372f460d19ccf04);
$parcel$export(module.exports, "textAreaFieldWriter", () => $5fbf1d3a47a2288f$export$daf547ed9d724058);
$parcel$export(module.exports, "dateFieldWriter", () => $5fbf1d3a47a2288f$export$ab1ac718ca53b3a2);
$parcel$export(module.exports, "labelsFieldWriter", () => $5fbf1d3a47a2288f$export$ad0f5c4a81b9b717);
$parcel$export(module.exports, "priorityFieldWriter", () => $5fbf1d3a47a2288f$export$255f6ed818b27fe9);
$parcel$export(module.exports, "numberFieldWriter", () => $5fbf1d3a47a2288f$export$f187c825de05664b);
$parcel$export(module.exports, "dateTimeFieldWriter", () => $5fbf1d3a47a2288f$export$aa8970635118882c);
$parcel$export(module.exports, "urlFieldWriter", () => $5fbf1d3a47a2288f$export$823b946bef17fbde);
$parcel$export(module.exports, "multiUserPickerFieldWriter", () => $5fbf1d3a47a2288f$export$f56da03febf03bbe);
$parcel$export(module.exports, "cascadingSelectFieldWriter", () => $5fbf1d3a47a2288f$export$dd0315e6bb70be50);
$parcel$export(module.exports, "singleUserPickerFieldWriter", () => $5fbf1d3a47a2288f$export$44ca38ec8bc1b849);
$parcel$export(module.exports, "radioSelectFieldWriter", () => $5fbf1d3a47a2288f$export$3930624833f8c678);
$parcel$export(module.exports, "multiSelectFieldWriter", () => $5fbf1d3a47a2288f$export$550c89601caa8cb);
$parcel$export(module.exports, "attachmentFieldWriter", () => $5fbf1d3a47a2288f$export$a751298e00103db5);
$parcel$export(module.exports, "descriptionFieldWriter", () => $5fbf1d3a47a2288f$export$8545d310869fe805);
$parcel$export(module.exports, "singleGroupPickerFieldWriter", () => $5fbf1d3a47a2288f$export$8b286e49fa801799);
$parcel$export(module.exports, "multipleGroupPickerFieldWriter", () => $5fbf1d3a47a2288f$export$ada212938d86109a);
$parcel$export(module.exports, "teamFieldWriter", () => $5fbf1d3a47a2288f$export$77028ba2835a8f1c);
$parcel$export(module.exports, "assigneeFieldWriter", () => $5fbf1d3a47a2288f$export$1c1d0a4431d22b72);

var $9PXwb = parcelRequire("9PXwb");

var $bRVha = parcelRequire("bRVha");

var $i5YRy = parcelRequire("i5YRy");

var $d7a37 = parcelRequire("d7a37");

var $26Ej0 = parcelRequire("26Ej0");

var $2XekW = parcelRequire("2XekW");

var $dLZA6 = parcelRequire("dLZA6");

var $42gdJ = parcelRequire("42gdJ");

var $9tBd5 = parcelRequire("9tBd5");
const $5fbf1d3a47a2288f$var$toMultipleSelectField = (id, ids)=>{
    const toOptionInput = (optionId)=>({
            id: optionId
        });
    return {
        fieldId: id,
        options: ids.map(toOptionInput)
    };
};
const $5fbf1d3a47a2288f$var$toStringField = (id, value)=>({
        fieldId: id,
        value: value
    });
const $5fbf1d3a47a2288f$export$7a0cc61c6cdac523 = (id, labels)=>({
        fieldId: id,
        values: {
            values: labels
        }
    });
const $5fbf1d3a47a2288f$var$toPriorityField = (priorityId)=>({
        priorityId: priorityId
    });
const $5fbf1d3a47a2288f$export$f27a949cf2ef9fc6 = (id, accountId)=>({
        fieldId: id,
        user: {
            accountId: accountId
        }
    });
const $5fbf1d3a47a2288f$var$toADFField = (id, adf)=>{
    const { version: version } = adf;
    return {
        fieldId: id,
        adf: {
            version: version,
            jsonValue: adf
        }
    };
};
const $5fbf1d3a47a2288f$var$toGroupInput = (pickerOption)=>({
        groupName: pickerOption.name
    });
const $5fbf1d3a47a2288f$export$3f2b7c786f4381f3 = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, value));
};
const $5fbf1d3a47a2288f$export$9ed21ff1d3f239ed = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, String((0, $42gdJ.mapSelectOptionsToData)(value).id)));
};
const $5fbf1d3a47a2288f$export$6372f460d19ccf04 = (id, value, fields)=>{
    fields.multipleSelectFields.push($5fbf1d3a47a2288f$var$toMultipleSelectField(id, (0, $d7a37.mapOptionsToData)(value).map((o)=>o.id)));
};
const $5fbf1d3a47a2288f$export$daf547ed9d724058 = (id, value, fields)=>{
    fields.adfFields.push($5fbf1d3a47a2288f$var$toADFField(id, (0, $9tBd5.convertTextToAdf)(value)));
};
const $5fbf1d3a47a2288f$export$ab1ac718ca53b3a2 = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, value));
};
const $5fbf1d3a47a2288f$export$ad0f5c4a81b9b717 = (id, value, fields)=>{
    fields.labels.push($5fbf1d3a47a2288f$export$7a0cc61c6cdac523(id, (0, $26Ej0.mapLabelOptionsToData)(value)));
};
const $5fbf1d3a47a2288f$export$255f6ed818b27fe9 = (_id, value, fields)=>{
    // eslint-disable-next-line no-param-reassign
    fields.priority = $5fbf1d3a47a2288f$var$toPriorityField((0, $2XekW.mapOptionToData)(value).id);
};
const $5fbf1d3a47a2288f$export$f187c825de05664b = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, value));
};
const $5fbf1d3a47a2288f$export$aa8970635118882c = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, value));
};
const $5fbf1d3a47a2288f$export$823b946bef17fbde = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, value));
};
const $5fbf1d3a47a2288f$export$f56da03febf03bbe = (id, value, fields)=>{
    const accountIds = (0, $bRVha.mapUserOptionsToAccountIds)(value);
    fields.multipleSelectUserPickerFields.push({
        fieldId: id,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        users: accountIds
    });
};
const $5fbf1d3a47a2288f$export$dd0315e6bb70be50 = (id, value, fields)=>{
    const option = (0, $i5YRy.transformToServerValue)(value);
    if (option !== null) {
        fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, option.id));
        if (option.child) fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(`${id}:1`, option.child.id));
    }
};
const $5fbf1d3a47a2288f$export$44ca38ec8bc1b849 = (id, value, fields)=>{
    if (!value) return;
    const result = (0, $bRVha.mapUserOptionsToIds)(value);
    if (!Array.isArray(result)) fields.users.push($5fbf1d3a47a2288f$export$f27a949cf2ef9fc6(id, result.id));
};
const $5fbf1d3a47a2288f$export$3930624833f8c678 = (id, value, fields)=>{
    fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, (0, $dLZA6.mapOptionToData)(value).id));
};
const $5fbf1d3a47a2288f$export$550c89601caa8cb = (id, value, fields)=>{
    fields.multipleSelectFields.push($5fbf1d3a47a2288f$var$toMultipleSelectField(id, (0, $42gdJ.mapMultiSelectOptionsToData)(value).map((o)=>String(o.id))));
};
const $5fbf1d3a47a2288f$export$a751298e00103db5 = (_id, value, fields)=>{
    if (Array.isArray(value) && value.length >= 1) {
        const ids = (0, $9PXwb.getFileIdsFromFiles)(value);
        fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField('attachment', ids.join(',')));
    }
};
const $5fbf1d3a47a2288f$export$8545d310869fe805 = (id, value, fields)=>{
    if (!value) return;
    fields.adfFields.push($5fbf1d3a47a2288f$var$toADFField(id, value));
};
const $5fbf1d3a47a2288f$export$8b286e49fa801799 = (id, value, fields)=>{
    const group = $5fbf1d3a47a2288f$var$toGroupInput(value);
    fields.singleGroupPickerFields.push({
        fieldId: id,
        group: group
    });
};
const $5fbf1d3a47a2288f$export$ada212938d86109a = (id, value, fields)=>{
    const groups = value.map($5fbf1d3a47a2288f$var$toGroupInput);
    fields.multipleGroupPickerFields.push({
        fieldId: id,
        groups: groups
    });
};
const $5fbf1d3a47a2288f$export$77028ba2835a8f1c = (id, value, fields)=>{
    if (value) fields.stringFields.push($5fbf1d3a47a2288f$var$toStringField(id, value.value));
};
const $5fbf1d3a47a2288f$export$1c1d0a4431d22b72 = (id, value, fields)=>{
    if (value?.accountId) fields.users.push($5fbf1d3a47a2288f$export$f27a949cf2ef9fc6(id, value.accountId));
};

});
parcelRegister("9PXwb", function(module, exports) {

$parcel$export(module.exports, "getFileIdsFromFiles", () => $8a78f806d9d9e125$export$90bf402b5b4274c7);
$parcel$export(module.exports, "validateAttachment", () => $8a78f806d9d9e125$export$8af997fabc69757a);
$parcel$export(module.exports, "getFieldDropZoneContainerID", () => $8a78f806d9d9e125$export$2fab292eea84487a);

var $dEMIg = parcelRequire("dEMIg");
const $8a78f806d9d9e125$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
const $8a78f806d9d9e125$export$8af997fabc69757a = (value, isRequired)=>{
    if (isRequired) {
        if (!value || value.length === 0) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $8a78f806d9d9e125$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;

});

parcelRegister("bRVha", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToUserOption", () => $2314b3b273d33011$export$3e406786572c35b0);
$parcel$export(module.exports, "transformDefaultUserValues", () => $2314b3b273d33011$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToIds", () => $2314b3b273d33011$export$2482a6858a4714ad);
$parcel$export(module.exports, "mapUserOptionsToAccountIds", () => $2314b3b273d33011$export$e4490ea0dfe4173f);
$parcel$export(module.exports, "mutateSingleUserPicker", () => $2314b3b273d33011$export$7937ee6404102aff);
$parcel$export(module.exports, "mutateMultiUserPicker", () => $2314b3b273d33011$export$53e350638c0acebc);

const $2314b3b273d33011$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $2314b3b273d33011$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($2314b3b273d33011$export$3e406786572c35b0);
    return $2314b3b273d33011$export$3e406786572c35b0(defaultValue);
};
const $2314b3b273d33011$export$2482a6858a4714ad = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return {
        id: userOption.id
    };
};
const $2314b3b273d33011$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $2314b3b273d33011$export$7937ee6404102aff = (selectedUser, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $ab1884f8d9d06de2$export$6684456d545bf498),
        user: {
            accountId: selectedUser.id
        }
    });
const $2314b3b273d33011$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $ab1884f8d9d06de2$export$52003ca9b6035e0c),
        users: selectedUsers.map((user)=>({
                accountId: user.id
            }))
    });

});

parcelRegister("i5YRy", function(module, exports) {

$parcel$export(module.exports, "transformToOptionValue", () => $07c7b256a725a010$export$d1480328df7a42bf);
$parcel$export(module.exports, "transformToOptions", () => $07c7b256a725a010$export$899758961952c638);
$parcel$export(module.exports, "transformToParentChildOptionMap", () => $07c7b256a725a010$export$575da772c90849b8);
$parcel$export(module.exports, "transformToServerValue", () => $07c7b256a725a010$export$6f0c6eec5b71d787);

var $jqvCZ = parcelRequire("jqvCZ");
const $07c7b256a725a010$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $07c7b256a725a010$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $07c7b256a725a010$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $07c7b256a725a010$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $07c7b256a725a010$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("d7a37", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $9aa1711e7f9491e1$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $9aa1711e7f9491e1$export$ffef3a401aef987b);
const $9aa1711e7f9491e1$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $9aa1711e7f9491e1$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));

});

parcelRegister("2XekW", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $cc4c4a8eb8b0f299$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $cc4c4a8eb8b0f299$export$fc800909123977f3);
const $cc4c4a8eb8b0f299$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        }));
const $cc4c4a8eb8b0f299$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        id: value,
        name: label,
        iconUrl: iconUrl
    });

});

parcelRegister("dLZA6", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $3b1944adfca69728$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $3b1944adfca69728$export$fc800909123977f3);
const $3b1944adfca69728$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $3b1944adfca69728$export$fc800909123977f3 = ({ label: label, value: value })=>({
        id: value,
        value: label
    });

});

parcelRegister("42gdJ", function(module, exports) {

$parcel$export(module.exports, "mapSelectOptionsToData", () => $8e4379316c73d7ec$export$7cdfccbc726f6f22);
$parcel$export(module.exports, "mapMultiSelectOptionsToData", () => $8e4379316c73d7ec$export$b91253d30be01e62);
$parcel$export(module.exports, "mapDataToSelectOption", () => $8e4379316c73d7ec$export$8f475f1fdc96a964);
$parcel$export(module.exports, "mapDataToSelectOptions", () => $8e4379316c73d7ec$export$dc22cde66e28d4af);
const $8e4379316c73d7ec$export$7cdfccbc726f6f22 = (option)=>({
        id: option.value,
        value: option.label
    });
const $8e4379316c73d7ec$export$b91253d30be01e62 = (options)=>options.map((option)=>({
            id: option.value,
            value: option.label
        }));
const $8e4379316c73d7ec$export$8f475f1fdc96a964 = (optionExternal)=>({
        label: optionExternal.value,
        value: optionExternal.id
    });
const $8e4379316c73d7ec$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$8e4379316c73d7ec$export$8f475f1fdc96a964(optionExternal));

});

parcelRegister("9tBd5", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $61e37c91a1a26fa0$export$c10cf32c4acc1d57);

var $7MIXN = parcelRequire("7MIXN");
var $cSalc = parcelRequire("cSalc");

var $esUXI = parcelRequire("esUXI");
const $61e37c91a1a26fa0$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $esUXI.getEmptyADF)();
    return (0, $7MIXN.doc)((0, $cSalc.paragraph)(text));
};

});
parcelRegister("7MIXN", function(module, exports) {

$parcel$export(module.exports, "doc", () => $4f7b6cd47961b649$export$2a111da947c407d2);
const $4f7b6cd47961b649$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("cSalc", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $57b33af9e28257e2$export$9c206ddddb32a9b);

var $c9ddq = parcelRequire("c9ddq");
const $57b33af9e28257e2$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $c9ddq.createTextNodes)(content)
    });

});
parcelRegister("c9ddq", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4ae8175d6e70d2ef$export$3a269a5941b62f04);

var $abyJE = parcelRequire("abyJE");
function $4ae8175d6e70d2ef$export$3a269a5941b62f04(nodes) {
    return nodes.map($4ae8175d6e70d2ef$export$72b9432ea0656b50);
}
function $4ae8175d6e70d2ef$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $abyJE.text)(str) : str;
}

});
parcelRegister("abyJE", function(module, exports) {

$parcel$export(module.exports, "text", () => $22c1ededacc2b8bf$export$6f093cfa640b7166);
const $22c1ededacc2b8bf$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("esUXI", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $e4fec1f97a138b24$export$d109ab46c9575565);

var $3o7y4 = parcelRequire("3o7y4");
const $e4fec1f97a138b24$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("3o7y4", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $e439d27de8d77afc$export$dd1bc94b04021eeb);
const $e439d27de8d77afc$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});





parcelRegister("6tIbT", function(module, exports) {

$parcel$export(module.exports, "AttachmentFieldTypeConfig", () => $bc013a7798d86e44$export$ada1e5fc2d37745a);

var $eUqFw = parcelRequire("eUqFw");

var $d6mZY = parcelRequire("d6mZY");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $bc013a7798d86e44$var$AttachmentFieldTypeComponent = (props)=>props.mediaUploadContexts.attachmentUploadContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6mZY.default), {
        ...props,
        mediaUploadContext: props.mediaUploadContexts.attachmentUploadContext
    }) : null;
const $bc013a7798d86e44$export$ada1e5fc2d37745a = {
    type: (0, $lO4Or.ATTACHMENT_TYPE),
    Component: $bc013a7798d86e44$var$AttachmentFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.AttachmentFieldPlaceholder), null),
    writer: (0, $eHQA5.attachmentFieldWriter)
};

});
parcelRegister("d6mZY", function(module, exports) {

$parcel$export(module.exports, "AttachmentsField", () => $6416e3ced7c01193$export$f7c49e57ef98664f);
$parcel$export(module.exports, "default", () => $6416e3ced7c01193$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k7cZh = parcelRequire("k7cZh");

var $6zOB7 = parcelRequire("6zOB7");

var $iHib2 = parcelRequire("iHib2");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $5JgJ2 = parcelRequire("5JgJ2");

var $dEMIg = parcelRequire("dEMIg");

var $6HoNR = parcelRequire("6HoNR");

var $gY5ty = parcelRequire("gY5ty");

var $9Tbvq = parcelRequire("9Tbvq");

var $jrHde = parcelRequire("jrHde");

var $gGtKh = parcelRequire("gGtKh");

var $9vlI9 = parcelRequire("9vlI9");

var $9PXwb = parcelRequire("9PXwb");
const $6416e3ced7c01193$export$f7c49e57ef98664f = (props)=>{
    const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, $9Tbvq.default)({
        mediaUploadContext: mediaUploadContext,
        projectId: projectId,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        attachmentCustomUploadURL: attachmentCustomUploadURL
    });
    const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
    (0, $eUqFw.useEffect)(()=>{
        // setting DefaultValueInitialized only when receiving default Value to guarantee we will set DefaultValue even if it's loaded with some delay.
        if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
            const currentAttachments = [];
            setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                    mediaFile: mediaFile,
                    isUploading: false
                }))));
            setDefaultValueInitialized(true);
        }
    }, [
        setAttachments,
        defaultValue,
        isDefaultValueInitialized,
        setDefaultValueInitialized
    ]);
    (0, $eUqFw.useEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    // TBD: create a controlled reusable attachment component
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'shouldClear' does not exist on type 'FieldValue'.
        if (value && value.shouldClear === true) setAttachments([]);
    }, [
        setAttachments,
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onInProgressChange && onInProgressChange(isUploading);
    }, [
        isUploading,
        onInProgressChange
    ]);
    if (!mediaUploadContext) return null;
    const onAttachmentUploadStart = (uploadStartPayload)=>{
        onUploadStart(uploadStartPayload);
        if (shouldScrollIntoViewOnUploadStart) {
            const fieldElement = document.getElementById((0, $9PXwb.getFieldDropZoneContainerID)(fieldId));
            if (fieldElement) (0, $k7cZh.default)(fieldElement, (0, $dEMIg.DEFAULT_SCROLL_OPTIONS));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6416e3ced7c01193$var$FieldDropzoneContainer, {
        id: (0, $9PXwb.getFieldDropZoneContainerID)(fieldId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6416e3ced7c01193$var$BrowseDropzoneArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHib2))), {
        label: "Upload",
        primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N100})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6416e3ced7c01193$var$BrowseDropzoneAreaText, null, `${formatMessage((0, $9vlI9.default).dropzone)}`, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jrHde.default), {
        ...fieldProps,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd,
        dropzoneContainer: document.getElementById(dropzoneContainerId || (0, $9PXwb.getFieldDropZoneContainerID)(fieldId))
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $6416e3ced7c01193$var$browseButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            "aria-labelledby": fieldProps['aria-labelledby'],
            onClick: ()=>setIsBrowserOpen(true)
        }, formatMessage((0, $9vlI9.default).browse)))))), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6416e3ced7c01193$var$mediaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "attachments-filmstrip-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gY5ty.AsyncAttachmentsFilmstripView), {
        mediaClientConfig: mediaClientConfig,
        files: files,
        onRemoveFile: onRemoveFile,
        collectionName: mediaUploadContext.collection
    }))));
};
var $6416e3ced7c01193$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6HoNR.withFormField)({
    validator: (0, $9PXwb.validateAttachment // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<ComponentProps<AttachmentFieldConfig, FieldValue>, any>'.
    )
})($6416e3ced7c01193$export$f7c49e57ef98664f);
const $6416e3ced7c01193$var$FieldDropzoneContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _19it1p8j _1yt4utpp _syaz1e9r",
            __cmplp.className
        ])
    });
});
const $6416e3ced7c01193$var$mediaContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
});
const $6416e3ced7c01193$var$browseButtonStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6416e3ced7c01193$var$BrowseDropzoneArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6416e3ced7c01193$var$BrowseDropzoneAreaText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gY5ty", function(module, exports) {

$parcel$export(module.exports, "AsyncAttachmentsFilmstripView", () => $81cd5bf6f2a23908$export$85605b8f3b532b83);

var $7rh0R = parcelRequire("7rh0R");

const $81cd5bf6f2a23908$export$85605b8f3b532b83 = (0, $7rh0R.lazy)(()=>(parcelRequire("6Vzln")).then((module)=>module.AttachmentsFilmstripView), {
    moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
});

});
parcelRegister("6Vzln", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bg1Rz").then(()=>parcelRequire('gVr7S'));

});


parcelRegister("9Tbvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc16146f478a9b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $YVYIZ = parcelRequire("YVYIZ");
const $dc16146f478a9b2f$var$useAttachments = (attachmentArgs)=>{
    const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
    if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
    const [attachments, setAttachments] = (0, $eUqFw.useState)([]);
    const [files, setFiles] = (0, $eUqFw.useState)([]);
    const [isUploading, setUploading] = (0, $eUqFw.useState)(false);
    const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $eUqFw.useState)(false);
    const stateRef = (0, $eUqFw.useRef)();
    stateRef.current = files;
    (0, $eUqFw.useEffect)(()=>{
        setFiles(attachments.map((attachment)=>attachment.mediaFile));
        setUploading(attachments.some((attachment)=>attachment.isUploading));
    }, [
        attachments
    ]);
    const mediaClientConfig = (0, $eUqFw.useMemo)(()=>({
            authProvider: ()=>Promise.resolve({
                    baseUrl: mediaUploadContext.serviceHost,
                    clientId: mediaUploadContext.clientId,
                    token: mediaUploadContext.token
                }),
            useSha256ForUploads: true
        }), [
        mediaUploadContext
    ]);
    const uploadConfig = (0, $eUqFw.useMemo)(()=>({
            uploadParams: {
                collection: mediaUploadContext.collection
            }
        }), [
        mediaUploadContext.collection
    ]);
    const onUploadStart = (0, $eUqFw.useCallback)((uploadStartPayload)=>{
        const currentFiles = stateRef.current ? stateRef.current : [];
        const totalAttachments = [
            ...uploadStartPayload.files,
            ...currentFiles
        ];
        if (maxAllowedTotalAttachmentsSize === undefined || (0, $YVYIZ.getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
            setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: true
                    }))));
        } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
    }, [
        onAttachmentSizeValidation,
        maxAllowedTotalAttachmentsSize
    ]);
    const onUploadError = (0, $eUqFw.useCallback)((uploadError)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
    }, []);
    const onUploadEnd = (0, $eUqFw.useCallback)((uploadEndPayload)=>{
        (async ()=>{
            const mediaFile = uploadEndPayload.file;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId)) await (0, $YVYIZ.copyToAttachment)({
                id: projectId,
                isProjectId: true,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issueId)) await (0, $YVYIZ.copyToAttachment)({
                id: issueId,
                isProjectId: false,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            setAttachments((currentAttachments)=>{
                const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                    {
                        mediaFile: mediaFile,
                        isUploading: false
                    }
                ]);
                return currentAttachments;
            });
        })();
    }, [
        issueId,
        projectId,
        attachmentCustomUploadURL
    ]);
    const onRemoveFile = (fileToBeRemoved)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
        if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
    };
    return {
        files: files,
        setAttachments: setAttachments,
        onUploadStart: onUploadStart,
        onUploadError: onUploadError,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onRemoveFile: onRemoveFile,
        onUploadEnd: onUploadEnd,
        isUploading: isUploading,
        isDefaultValueInitialized: isDefaultValueInitialized,
        setDefaultValueInitialized: setDefaultValueInitialized
    };
};
var $dc16146f478a9b2f$export$2e2bcd8739ae039 = $dc16146f478a9b2f$var$useAttachments;

});
parcelRegister("YVYIZ", function(module, exports) {

$parcel$export(module.exports, "copyToAttachment", () => $553768b90e216cce$export$b9a44fdbc3de4b85);
$parcel$export(module.exports, "getAttachmentsSize", () => $553768b90e216cce$export$ed1597b81cfdb5f6);

var $lRmyA = parcelRequire("lRmyA");
const $553768b90e216cce$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
const $553768b90e216cce$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
const $553768b90e216cce$export$b9a44fdbc3de4b85 = async (props)=>{
    const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { attachmentId: attachmentId } = await (0, $lRmyA.performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $553768b90e216cce$export$a7455b0d8bb5c44e(id) : $553768b90e216cce$export$cf1f2654bf86294f(id)), {
        body: JSON.stringify({
            fileId: mediaFile.id
        })
    });
    return attachmentId;
};
const $553768b90e216cce$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);

});


parcelRegister("jrHde", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f587ae560b0e1b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5WZms");
var $lQaP0 = parcelRequire("lQaP0");
var $lfPxH = parcelRequire("lfPxH");

var $j9zyb = parcelRequire("j9zyb");
const $5f587ae560b0e1b4$var$AttachmentsUpload = (props)=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $eUqFw.useState)(false);
    const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
    const dropzoneConfig = {
        ...uploadConfig
    };
    const browserConfig = {
        ...uploadConfig,
        multiple: true
    };
    const clipboardConfig = {
        ...uploadConfig
    };
    if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQaP0.BrowserLoader), {
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onEnd: onUploadEnd,
        onClose: ()=>setIsBrowserOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfPxH.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9zyb.Clipboard), {
        mediaClientConfig: mediaClientConfig,
        config: clipboardConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        isolated: false
    }), renderPropFn({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};
var $5f587ae560b0e1b4$export$2e2bcd8739ae039 = $5f587ae560b0e1b4$var$AttachmentsUpload;

});
parcelRegister("5WZms", function(module, exports) {

$parcel$export(module.exports, "isImagePreview", () => (parcelRequire("2v0lC")).isImagePreview);
$parcel$export(module.exports, "Dropzone", () => (parcelRequire("lfPxH")).DropzoneLoader);
$parcel$export(module.exports, "Clipboard", () => (parcelRequire("dTbMy")).ClipboardLoader);
$parcel$export(module.exports, "Browser", () => (parcelRequire("lQaP0")).BrowserLoader);

var $2v0lC = parcelRequire("2v0lC");

var $lfPxH = parcelRequire("lfPxH");

var $dTbMy = parcelRequire("dTbMy");

var $lQaP0 = parcelRequire("lQaP0");

});
parcelRegister("2v0lC", function(module, exports) {

$parcel$export(module.exports, "isImagePreview", () => $3ff8fcb755fe1e8c$export$5fe5572478566289);
const $3ff8fcb755fe1e8c$export$5fe5572478566289 = (preview)=>!!preview.dimensions;

});

parcelRegister("lfPxH", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $b97c6c9a97affaba$export$66201d263cd6342);

var $eUqFw = parcelRequire("eUqFw");



class $b97c6c9a97affaba$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("kKXZ5")),
                (parcelRequire("9h2kj"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $b97c6c9a97affaba$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $b97c6c9a97affaba$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $b97c6c9a97affaba$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("lBS5K", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("IXWjR").then(()=>parcelRequire('7bu2U'));

});

parcelRegister("kKXZ5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2ujg4").then(()=>parcelRequire('9MwW0'));

});

parcelRegister("9h2kj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("jJJbp")
]).then(()=>parcelRequire('dLH1Z'));

});


parcelRegister("dTbMy", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $a4d33d18f4520334$export$d7936799bf32b554);

var $eUqFw = parcelRequire("eUqFw");


class $a4d33d18f4520334$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("1kc7H"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $a4d33d18f4520334$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $a4d33d18f4520334$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            Clipboard: $a4d33d18f4520334$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("1kc7H", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4AVSa").then(()=>parcelRequire('b4HVU'));

});


parcelRegister("lQaP0", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $d86767e0d9993d6e$export$3ce634ac4a869e2c);

var $eUqFw = parcelRequire("eUqFw");


class $d86767e0d9993d6e$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("lBS5K")),
                (parcelRequire("icw4G"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("icw4G", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3woaI").then(()=>parcelRequire('2fiTb'));

});



parcelRegister("j9zyb", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $c7c5f3dfc37493c5$export$8b44c43c7d8f0830);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5WZms");
var $dTbMy = parcelRequire("dTbMy");

var $7wp7z = parcelRequire("7wp7z");
const $c7c5f3dfc37493c5$export$7b1ba4955557a858 = ()=>null;
const $c7c5f3dfc37493c5$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $7wp7z.useClipboardContextBoundary)();
    const onPaste = (0, $eUqFw.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7c5f3dfc37493c5$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTbMy.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("7wp7z", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $5ea82582ff996af1$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $5ea82582ff996af1$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $5ea82582ff996af1$export$37046969a30ae0a0);

var $1yZQx = parcelRequire("1yZQx");
var $96gVp = parcelRequire("96gVp");
var $kEDjj = parcelRequire("kEDjj");
const $5ea82582ff996af1$var$ClipboardStore = (0, $kEDjj.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $5ea82582ff996af1$export$c4bc9440a978eec1 = (0, $96gVp.createContainer)($5ea82582ff996af1$var$ClipboardStore);
const $5ea82582ff996af1$export$a3e41c5b3d4c30b7 = (0, $1yZQx.createActionsHook)($5ea82582ff996af1$var$ClipboardStore);
const $5ea82582ff996af1$var$useClipboardContextBoundarySelector = (0, $1yZQx.createHook)($5ea82582ff996af1$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $5ea82582ff996af1$export$37046969a30ae0a0 = ()=>$5ea82582ff996af1$var$useClipboardContextBoundarySelector()[0];

});



parcelRegister("9vlI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd084dfab64de7a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9dd084dfab64de7a$var$messages = (0, $90IgZ.defineMessages)({
    dropzone: {
        "id": "issue-create-commons.attachments-field.dropzone",
        "defaultMessage": "Drop files to attach or"
    },
    browse: {
        "id": "issue-create-commons.attachments-field.browse",
        "defaultMessage": "Browse"
    },
    missingToken: {
        "id": "issue-create-commons.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    }
});
var $9dd084dfab64de7a$export$2e2bcd8739ae039 = $9dd084dfab64de7a$var$messages;

});



parcelRegister("dK0NF", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectFieldTypeConfig", () => $25a0a01579ba6e63$export$b1cccbe22677a87b);

var $eUqFw = parcelRequire("eUqFw");

var $8MMgG = parcelRequire("8MMgG");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $25a0a01579ba6e63$var$CascadingSelectFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MMgG.default), props);
const $25a0a01579ba6e63$export$b1cccbe22677a87b = {
    type: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
    Component: $25a0a01579ba6e63$var$CascadingSelectFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.cascadingSelectFieldWriter)
};

});
parcelRegister("8MMgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6272172d78f39ff5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $aUcBK = parcelRequire("aUcBK");

var $8YKza = parcelRequire("8YKza");
const $6272172d78f39ff5$var$CascadingSelectField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
    const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, $8YKza.transformToCascadingSelectOptions)(cascadingSelectOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUcBK.AsyncCascadingSelectEdit), {
        ...fieldProps,
        value: value,
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues,
        // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type '(e: SyntheticEvent<HTMLElement, Event>) => boolean'.
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        // @ts-expect-error - TS2322 - Type '(value: SelectedOption) => void' is not assignable to type '(value: SelectedOption, meta: null, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>'.
        onChange: onChange,
        isInvalid: false,
        autoFocus: autoFocus,
        areOptionsOnSameRow: false,
        isEditable: (0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda') ? !isReadOnly && isEditable : isEditable
    }));
};
var $6272172d78f39ff5$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCascadingSelectField),
    transformDefaultValue: $8YKza.transformDefaultValue
})($6272172d78f39ff5$var$CascadingSelectField);

});
parcelRegister("7TaJX", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", () => $908859f4f2da1f9d$export$7c7171667037b275);
$parcel$export(module.exports, "closeMenuOnScroll", () => $908859f4f2da1f9d$export$fe334d83c6aac80f);
// keeping it here instead of jira-issue-create to avoid cyclic dependencies.
const $908859f4f2da1f9d$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
const $908859f4f2da1f9d$var$MENU_CLOSE_SELECTORS = [
    $908859f4f2da1f9d$export$7c7171667037b275
];
const $908859f4f2da1f9d$export$fe334d83c6aac80f = (e)=>{
    // @ts-expect-error - TS18047 -  'e.target' is possibly 'null'.
    if ($908859f4f2da1f9d$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
    return false;
};

});

parcelRegister("aUcBK", function(module, exports) {

$parcel$export(module.exports, "AsyncCascadingSelectEdit", () => $50f8b3db4e20aa16$export$7db21897d0716698);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $cDM4A = parcelRequire("cDM4A");
const $50f8b3db4e20aa16$var$EMPTY_OBJECT = {};
const $50f8b3db4e20aa16$export$7db21897d0716698 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $cDM4A.asyncCascadingSelectEditEntryPoint), // use stable object reference to avoid re-renders
    $50f8b3db4e20aa16$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "async-jira-issue-field-cascading-select-edit",
        packageName: "jira-issue-field-cascading-select",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("cDM4A", function(module, exports) {

$parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", () => $570cf4bf71d193ec$export$336a3a4bd9539e41);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $570cf4bf71d193ec$export$336a3a4bd9539e41 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("kZCTe")).then((module)=>module.CascadingSelectViewEntryPointContent), {
        moduleId: "dba9fb26"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kZCTe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fkQ79").then(()=>parcelRequire('g5UOm'));

});



parcelRegister("8YKza", function(module, exports) {

$parcel$export(module.exports, "transformToCascadingSelectOptions", () => $6234c682ca01b3c0$export$b06e6053830d7554);
$parcel$export(module.exports, "transformDefaultValue", () => $6234c682ca01b3c0$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutateCascadingSelectField", () => $6234c682ca01b3c0$export$f402e35d933d11b5);

const $6234c682ca01b3c0$export$facac75482a8e0c5 = (option)=>{
    const { value: value, id: id } = option || {};
    if (value && id) return {
        label: value,
        value: id
    };
    return null;
};
const $6234c682ca01b3c0$export$b06e6053830d7554 = (cascadingSelectData)=>{
    const allowedValues = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allowedChildValues = {};
    cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
        const transformedParentOption = $6234c682ca01b3c0$export$facac75482a8e0c5(parentOptionValue);
        if (parentOptionValue !== null && transformedParentOption !== null) {
            allowedValues.push(transformedParentOption);
            allowedChildValues[parentOptionValue.id] = childOptionValues.map($6234c682ca01b3c0$export$facac75482a8e0c5);
        }
    });
    return {
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues
    };
};
const $6234c682ca01b3c0$export$e2f4e5d31db527cc = (defaultValue)=>{
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
    const transformedParentOption = $6234c682ca01b3c0$export$facac75482a8e0c5(parentOptionValue);
    let transformedDefaultValue = null;
    if (transformedParentOption !== null) transformedDefaultValue = {
        ...transformedParentOption,
        child: childOptionValue ? $6234c682ca01b3c0$export$facac75482a8e0c5(childOptionValue) : undefined
    };
    return transformedDefaultValue;
};
const $6234c682ca01b3c0$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
        fieldId: fieldId,
        parentOptionValue: {
            optionId: selectedOption.value
        },
        // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
        childOptionValue: selectedOption.child ? {
            // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            optionId: selectedOption.child.value
        } : null,
        mutationGroup: (0, $f67d0c0fa3404504$export$31fd86f8f183952c)
    });

});
const $f67d0c0fa3404504$export$31fd86f8f183952c = 'cascadingSelectFields';




parcelRegister("86udM", function(module, exports) {

$parcel$export(module.exports, "CategoryFieldTypeConfig", () => $5663acf377806ec9$export$3e2ea7bfd7261cb5);

var $eUqFw = parcelRequire("eUqFw");

var $k4Bm6 = parcelRequire("k4Bm6");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $5663acf377806ec9$var$CategoryFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4Bm6.default), {
        ...props,
        defaultValue: undefined
    });
const $5663acf377806ec9$export$3e2ea7bfd7261cb5 = {
    type: (0, $lO4Or.CATEGORY_TYPE),
    Component: $5663acf377806ec9$var$CategoryFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.selectFieldWriter)
};

});
parcelRegister("k4Bm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c7d83ba7e51369$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jRCtV = parcelRequire("jRCtV");

const $31c7d83ba7e51369$var$SingleSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRCtV.default), {
        ...props,
        isMulti: false
    });
var $31c7d83ba7e51369$export$2e2bcd8739ae039 = $31c7d83ba7e51369$var$SingleSelectField;

});
parcelRegister("jRCtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $277269de9b68edcf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7TaJX = parcelRequire("7TaJX");

var $jRjxU = parcelRequire("jRjxU");

var $42gdJ = parcelRequire("42gdJ");

var $lIor1 = parcelRequire("lIor1");

var $6HoNR = parcelRequire("6HoNR");

var $icPhQ = parcelRequire("icPhQ");

var $fwjqo = parcelRequire("fwjqo");
const $277269de9b68edcf$var$SelectField = (props)=>{
    const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRjxU.default), {
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        options: (0, $42gdJ.mapDataToSelectOptions)(allowedValues),
        value: value,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        classNamePrefix: `select-${fieldId}`,
        isMulti: isMulti,
        hideSelectedOptions: true,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isClearable: true,
        onFilterOption: (0, $fwjqo.onFilterOption),
        isDisabled: isReadOnly,
        isRequired: isRequired,
        inputId: id
    }));
};
var $277269de9b68edcf$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $fwjqo.transformDefaultSelectValues),
    validator: (0, $lIor1.validateSelectField)
})($277269de9b68edcf$var$SelectField);

});
parcelRegister("jRjxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea19a7a7289690d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $4NcaX = parcelRequire("4NcaX");
const $7ea19a7a7289690d$var$SelectEdit = (props)=>{
    const { classNamePrefix: classNamePrefix, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        placeholder: placeholder,
        options: options,
        value: value,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error - TS2322 - Type '(option: SelectOption) => void' is not assignable to type '(value: SelectOption | OptionsType<SelectOption> | null, action: ActionMeta<SelectOption>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        isMulti: isMulti,
        onFocus: onFocus,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        filterOption: onFilterOption,
        inputId: inputId,
        required: isRequired,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $7ea19a7a7289690d$export$2e2bcd8739ae039 = $7ea19a7a7289690d$var$SelectEdit;

});
parcelRegister("4NcaX", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $114b87bdc51f126d$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $114b87bdc51f126d$export$eca30945eaf474dd);


var $c9TLT = parcelRequire("c9TLT");
const $114b87bdc51f126d$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        })
};
const $114b87bdc51f126d$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $114b87bdc51f126d$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $114b87bdc51f126d$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $114b87bdc51f126d$var$inputIconPaddingLeft,
            paddingRight: $114b87bdc51f126d$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $114b87bdc51f126d$var$inputIconPaddingLeft,
            paddingRight: $114b87bdc51f126d$var$inputIconPaddingRight
        })
};
const $114b87bdc51f126d$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`}`,
            borderRadius: "var(--ds-space-050, 4px)"
        })
};

});


parcelRegister("fwjqo", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSelectValues", () => $f6b66909689bc95b$export$cfb7677fb5241257);
$parcel$export(module.exports, "onFilterOption", () => $f6b66909689bc95b$export$5fde4483c43b93b);

var $42gdJ = parcelRequire("42gdJ");
const $f6b66909689bc95b$export$cfb7677fb5241257 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return (0, $42gdJ.mapDataToSelectOptions)(defaultValue);
    return (0, $42gdJ.mapDataToSelectOption)(defaultValue);
};
const $f6b66909689bc95b$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());

});




parcelRegister("kk5Iu", function(module, exports) {

$parcel$export(module.exports, "ComponentsFieldTypeConfig", () => $a657541885c344f8$export$75a450cecebc09fa);

var $eUqFw = parcelRequire("eUqFw");

var $5GK4N = parcelRequire("5GK4N");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $a657541885c344f8$var$ComponentsFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GK4N.default), props);
// Effectively the same as `multiSelectFieldWriter`. For some reason, the type of the field value of
// `ComponentsField` (`Options`) has a nullable value type. This function just pre-processes the value
// to strip away any `null` value options before passing it to `multiSelectFieldWriter`.
const $a657541885c344f8$var$componentsFieldWriter = (id, value, fields)=>{
    const filteredValues = value.filter((option)=>option.value !== null);
    (0, $eHQA5.multiSelectFieldWriter)(id, filteredValues, fields);
};
const $a657541885c344f8$export$75a450cecebc09fa = {
    type: (0, $lO4Or.COMPONENTS_TYPE),
    Component: $a657541885c344f8$var$ComponentsFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: $a657541885c344f8$var$componentsFieldWriter
};

});
parcelRegister("5GK4N", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda68cac2df93489$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $e1gDz = parcelRequire("e1gDz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5i7Lk = parcelRequire("5i7Lk");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $cKBPA = parcelRequire("cKBPA");

var $7mH0H = parcelRequire("7mH0H");

var $ajD9f = parcelRequire("ajD9f");

var $6HcMO = parcelRequire("6HcMO");

const $eda68cac2df93489$var$ComponentsField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDisabled = allowedValues.length === 0;
    const options = (0, $7mH0H.mapDataToOptions)(allowedValues);
    const { projectKey: projectKey } = selectedProject || {};
    const projectKeyStr = projectKey || '';
    const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, $e1gDz.useGlobalComponentsProperty)(projectKeyStr);
    const getComponentSelectEdit = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajD9f.StyledFieldSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKBPA.default), {
            ...fieldProps,
            options: options,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            showFooter: false,
            projectKey: projectKeyStr,
            placeholder: isDisabled ? formatMessage((0, $6HcMO.default).none) : '',
            isDisabled: isDisabled || isReadOnly,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            canCreateNewItem: !areGlobalComponentsEnabled,
            inputId: id,
            isRequired: isRequired
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $6HcMO.default).tooltipWhenDisabled)
    }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $eda68cac2df93489$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $7mH0H.mapDataToOptions),
    validator: (0, $lIor1.validateComponentField),
    shouldRenderFieldMessage: false
})($eda68cac2df93489$var$ComponentsField);

});
parcelRegister("e1gDz", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $10977af94640a909$export$a070f388fcd93df0);

var $eUqFw = parcelRequire("eUqFw");

var $gyj10 = parcelRequire("gyj10");

var $jD201 = parcelRequire("jD201");
function $10977af94640a909$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [enabled, setEnabled] = (0, $eUqFw.useState)(undefined);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $eUqFw.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eUqFw.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $jD201.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $eUqFw.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $jD201.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $gyj10.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("gyj10", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f5d6a8cf5cca0c$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $3bIxc = parcelRequire("3bIxc");
var $59f5d6a8cf5cca0c$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $3bIxc.props));

});
parcelRegister("jhVpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a98829846b4116$export$2e2bcd8739ae039);

var $kBiqn = parcelRequire("kBiqn");
const $47a98829846b4116$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47a98829846b4116$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $kBiqn.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $47a98829846b4116$var$pNothing,
        update: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $47a98829846b4116$var$pNothing
    };
};

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';



parcelRegister("3bIxc", function(module, exports) {

$parcel$export(module.exports, "props", () => $db1ce1616d9abcdd$export$8128bb6492cf3de7);

const $db1ce1616d9abcdd$var$MAX_RESULTS = 10;
const $db1ce1616d9abcdd$var$CACHE_SIZE = $db1ce1616d9abcdd$var$MAX_RESULTS * 2;
const $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY = 'components';
const $db1ce1616d9abcdd$export$8128bb6492cf3de7 = {
    size: $db1ce1616d9abcdd$var$CACHE_SIZE,
    cacheKey: $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("jD201", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $623baa6e9886872f$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $623baa6e9886872f$export$71702a5b14caff65);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $623baa6e9886872f$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $623baa6e9886872f$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $623baa6e9886872f$var$getProjectId = async (projectKey)=>{
    const project = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $623baa6e9886872f$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $lRmyA.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $guiFP.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $623baa6e9886872f$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $lRmyA.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("cKBPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d320f9634daf574a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $28t3A = parcelRequire("28t3A");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $4Pih6 = parcelRequire("4Pih6");

var $d0efy = parcelRequire("d0efy");
const $d320f9634daf574a$var$ComponentsSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getNewInlineComponentCreateLabel = (0, $eUqFw.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, $d0efy.default).createNewItem)})`, [
        formatNewInlineComponentCreateLabel,
        formatMessage
    ]);
    const isValidNewOption = (0, $eUqFw.useCallback)((query)=>{
        const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
        return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
    }, [
        canCreateNewItem,
        options
    ]);
    const handleInlineComponentCreate = (inputValue)=>{
        onChange([
            ...value || [],
            {
                label: inputValue,
                value: null
            }
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $28t3A.default), {
        inputId: inputId,
        required: isRequired,
        ...fieldProps,
        value: value,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2322 - Type 'Options' is not assignable to type 'readonly (Options | GroupBase<Options>)[]
        options: options,
        placeholder: placeholder || formatMessage((0, $d0efy.default).placeholder),
        // @ts-expect-error - TS2322 - Type '(arg1: Options) => void' is not assignable to type '(value: OptionsType<{ label: string; value: string; }>, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: (menuListProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Pih6.default), {
                    ...menuListProps,
                    showFooter: showFooter,
                    projectKey: projectKey
                })
        },
        isMulti: true,
        isDisabled: isDisabled,
        isValidNewOption: isValidNewOption,
        formatCreateLabel: getNewInlineComponentCreateLabel,
        onCreateOption: handleInlineComponentCreate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "components-field-select" // added this for testing purpose, it doesn't apply any style
        ,
        classNamePrefix: "components-field-select"
    });
};
var $d320f9634daf574a$export$2e2bcd8739ae039 = $d320f9634daf574a$var$ComponentsSelectEdit;

});
parcelRegister("4Pih6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8800057fba71ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gO9Xw = parcelRequire("gO9Xw");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fGb0D = parcelRequire("fGb0D");
const $cb8800057fba71ce$var$MenuWithFooter = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, restProps, children), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$export$fd9000017733fabf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$export$500fb058ad7aeb1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$export$e0513c91be1318ca, {
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: "componentFooterAddIcon",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$var$LinkText, null, footerLabel ?? formatMessage((0, $fGb0D.default).componentLabel))))));
};
var $cb8800057fba71ce$export$2e2bcd8739ae039 = $cb8800057fba71ce$var$MenuWithFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb8800057fba71ce$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $cb8800057fba71ce$export$fd9000017733fabf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1yt41bpf _x3dope8f",
            __cmplp.className
        ])
    });
});
const $cb8800057fba71ce$export$500fb058ad7aeb1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41r6r _1bsb1osq _irr314ae",
            __cmplp.className
        ])
    });
});
const $cb8800057fba71ce$export$e0513c91be1318ca = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fGb0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca8bfcff55204f10$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca8bfcff55204f10$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    componentLabel: {
        "id": "issue-field-components-field.edit.menu.component-label",
        "defaultMessage": "Create new component"
    }
});

});


parcelRegister("d0efy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3f12f632cacfc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0e3f12f632cacfc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-field-components-field.edit.placeholder",
        "defaultMessage": "Select Component"
    },
    createNewItem: {
        "id": "issue-field-components-field.edit.create-new-item",
        "defaultMessage": "New Component"
    }
});

});


parcelRegister("7mH0H", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $ba98fedd4072563e$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $ba98fedd4072563e$export$ffef3a401aef987b);
const $ba98fedd4072563e$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $ba98fedd4072563e$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));

});

parcelRegister("6HcMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f739078738245f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $40f739078738245f$var$messages = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-create-commons.components-field.none",
        "defaultMessage": "None"
    },
    tooltipWhenDisabled: {
        "id": "issue-create-commons.components-field.tooltip-when-disabled",
        "defaultMessage": "We couldn't find any components for this project"
    }
});
var $40f739078738245f$export$2e2bcd8739ae039 = $40f739078738245f$var$messages;

});



parcelRegister("LoFQn", function(module, exports) {

$parcel$export(module.exports, "DateCustomFieldTypeConfig", () => $92b7364b79e9b64e$export$a7f793e7c226ca61);

var $eUqFw = parcelRequire("eUqFw");

var $2sjGj = parcelRequire("2sjGj");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $92b7364b79e9b64e$var$DateCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sjGj.default), props);
const $92b7364b79e9b64e$export$a7f793e7c226ca61 = {
    type: (0, $lO4Or.DATE_CF_TYPE),
    Component: $92b7364b79e9b64e$var$DateCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DateFieldPlaceholder), null),
    writer: (0, $eHQA5.dateFieldWriter)
};

});
parcelRegister("2sjGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f2648675395af2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jXg8H = parcelRequire("jXg8H");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $5OZ28 = parcelRequire("5OZ28");

var $lIor1 = parcelRequire("lIor1");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

var $9lTIY = parcelRequire("9lTIY");

const $e1f2648675395af2$var$DateField = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
    const locale = (0, $4xHig.useLocale)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const weekStartDay = (0, $8K9kM.getLocale)(locale)?.options?.weekStartsOn;
    const safeValue = value === null ? undefined : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
        value: safeValue,
        isDisabled: isReadOnly,
        onChange: onChange,
        autoFocus: autoFocus,
        locale: locale,
        isInvalid: Boolean(error),
        selectProps: {
            /**
             Temporary fix to prevent form submit on enter press on an open calendar.
             Ideally this should either be handled by atlaskit or keypress enter event should only be supressed when calendar is open.
             There is no way to know if the calendar is open in the current implementation
              Side Effect: Form will not submit on enter keyPress even when calendar is not open.
           */ onKeyDown: (0, $5OZ28.preventFormSubmitOnEnterKeyPress)
        },
        weekStartDay: weekStartDay,
        label: formatMessage((0, $9lTIY.default).ariaLabel),
        "aria-describedby": `${id}-helper`,
        id: id,
        placeholder: formatMessage((0, $9lTIY.default).placeholder)
    }));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateFieldConfig, FieldValue>, any>'.
$e1f2648675395af2$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})($e1f2648675395af2$var$DateField);

});
parcelRegister("jXg8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38f1e4301a686fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $5cS2Y = parcelRequire("5cS2Y");

var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $aYOOX = parcelRequire("aYOOX");

var $dEsso = parcelRequire("dEsso");

var $1ym5t = parcelRequire("1ym5t");

var $cJOhG = parcelRequire("cJOhG");
const $a38f1e4301a686fa$var$packageName = "platform-pkg";
const $a38f1e4301a686fa$var$packageVersion = "0.0.0-use.local";
const $a38f1e4301a686fa$var$datePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    hideIcon: false,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))),
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    label: '',
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ selectProps: {},
    spacing: 'default',
    locale: 'en-US'
};
class $a38f1e4301a686fa$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $a38f1e4301a686fa$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.containerRef = null;
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
        this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $aYOOX.getParsedISO)({
                    iso: iso
                })
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false
                });
                this.props.onBlur(event);
            }
        };
        this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $aYOOX.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1ym5t.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        };
        this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $aYOOX.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1ym5t.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const { onInputChange: onInputChange } = this.props.selectProps;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date()),
            l10n: (0, $5cS2Y.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $5cS2Y.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance, 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus, disabled: disabled, hideIcon: hideIcon, icon: icon, id: id, innerProps: innerProps, isDisabled: isDisabled, disabledDateFilter: disabledDateFilter, maxDate: maxDate, minDate: minDate, isInvalid: isInvalid, label: label, name: name, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, locale: locale, testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $dEsso.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $1ym5t.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, $cEc3i.m)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $aYOOX.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wCDk.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $aYOOX.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        })));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $a38f1e4301a686fa$var$DatePicker = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $a38f1e4301a686fa$var$packageName,
    packageVersion: $a38f1e4301a686fa$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $a38f1e4301a686fa$var$packageName,
            packageVersion: $a38f1e4301a686fa$var$packageVersion
        }
    })
})($a38f1e4301a686fa$export$df43d21f5faca9f7));
var $a38f1e4301a686fa$export$2e2bcd8739ae039 = $a38f1e4301a686fa$var$DatePicker;

});
parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("7i5dr", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $e52f111a686e55c4$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $e52f111a686e55c4$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $e52f111a686e55c4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $e52f111a686e55c4$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $e52f111a686e55c4$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $e52f111a686e55c4$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $e52f111a686e55c4$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $e52f111a686e55c4$export$5e30e9a24d6c1203 = ()=>null;
const $e52f111a686e55c4$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $e52f111a686e55c4$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $e52f111a686e55c4$export$9e6d8fcf62256b85 = 'h:mma';
const $e52f111a686e55c4$export$75032c84f56650eb = 'YYYY/MM/DD';
function $e52f111a686e55c4$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $e52f111a686e55c4$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("aYOOX", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $be48f7c2ad85fcf1$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $be48f7c2ad85fcf1$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $be48f7c2ad85fcf1$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $be48f7c2ad85fcf1$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $EN9B6 = parcelRequire("EN9B6");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $jP55W = parcelRequire("jP55W");

var $7i5dr = parcelRequire("7i5dr");
const $be48f7c2ad85fcf1$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $be48f7c2ad85fcf1$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(parsedDate)}`;
    return newIso;
};
const $be48f7c2ad85fcf1$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $7i5dr.defaultDateFormat));
    return l10n.parseDate(date);
};
const $be48f7c2ad85fcf1$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $7i5dr.defaultDateFormat));
    const date = (0, $3xcI8.default)(value);
    return dateFormat ? (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $7i5dr.placeholderDatetime));
};

});
parcelRegister("jP55W", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca62b172b02bdaaf$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca62b172b02bdaaf$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca62b172b02bdaaf$var$v1tokens = Object.keys($ca62b172b02bdaaf$var$tokensMap).sort().reverse();
const $ca62b172b02bdaaf$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca62b172b02bdaaf$var$v1tokens.join('|') + '|.)', 'g');
function $ca62b172b02bdaaf$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca62b172b02bdaaf$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca62b172b02bdaaf$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("dEsso", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c845995965375b9a$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $gSA5V = parcelRequire("gSA5V");

var $etCs9 = parcelRequire("etCs9");


var $lcnyw = parcelRequire("lcnyw");

var $isGDw = parcelRequire("isGDw");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $c845995965375b9a$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $3xcI8.default)(iso);
        return (0, $7ueqz.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $c845995965375b9a$var$menuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $c845995965375b9a$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $c845995965375b9a$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $c845995965375b9a$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gSA5V.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $ki32l = parcelRequire("ki32l");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $ki32l.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db781ab5297a2cc1540c99d75921a718>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("isGDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $164042300001804e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $164042300001804e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $5Q9wj.default);
    }
}

});


parcelRegister("1ym5t", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $1aa7ae37c35d9611$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $1aa7ae37c35d9611$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $jP55W = parcelRequire("jP55W");
function $1aa7ae37c35d9611$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)('YYYY-MM-DD'));
}
function $1aa7ae37c35d9611$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $1aa7ae37c35d9611$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("cJOhG", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $10128cb6581a570a$export$6e30bf8cb1347b56);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $10128cb6581a570a$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children);
    };

});


parcelRegister("5OZ28", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", () => $2db6999e0646d640$export$9d2267fe165de4b6);
const $2db6999e0646d640$export$9d2267fe165de4b6 = (event)=>{
    event.key === 'Enter' && event.preventDefault();
};

});

parcelRegister("9lTIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb1ebbe0063e50d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ebb1ebbe0063e50d$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-create-commons.date-field.placeholder",
        "defaultMessage": "Select date"
    },
    ariaLabel: {
        "id": "issue-create-commons.date-field.aria-label",
        "defaultMessage": "Enter a Date"
    }
});
var $ebb1ebbe0063e50d$export$2e2bcd8739ae039 = $ebb1ebbe0063e50d$var$messages;

});



parcelRegister("a1aim", function(module, exports) {

$parcel$export(module.exports, "DateTimeCustomFieldTypeConfig", () => $4b0df68e8767b5a5$export$f2143df7edd6483d);

var $eUqFw = parcelRequire("eUqFw");

var $4KGIz = parcelRequire("4KGIz");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $4b0df68e8767b5a5$var$DateTimeCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4KGIz.default), props);
const $4b0df68e8767b5a5$export$f2143df7edd6483d = {
    type: (0, $lO4Or.DATETIME_CF_TYPE),
    Component: $4b0df68e8767b5a5$var$DateTimeCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DateTimeFieldPlaceholder), null),
    writer: (0, $eHQA5.dateTimeFieldWriter)
};

});
parcelRegister("4KGIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afe2be1047ba6e6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dibFF = parcelRequire("dibFF");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $5OZ28 = parcelRequire("5OZ28");

var $lIor1 = parcelRequire("lIor1");

var $emnwK = parcelRequire("emnwK");

var $gGtKh = parcelRequire("gGtKh");

var $7MRtn = parcelRequire("7MRtn");

const $9afe2be1047ba6e6$export$ae1ced156568f0b0 = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleChange = (dateTimeValue)=>{
        onChange(dateTimeValue || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "date-time-field-edit-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emnwK.AsyncDateTimeFieldEditView), {
        label: fieldName,
        ...fieldProps,
        isDisabled: isDisabled || isReadOnly,
        autoFocus: autoFocus,
        value: value,
        onChange: handleChange,
        isInvalid: Boolean(error),
        datePickerProps: {
            selectProps: {
                onKeyDown: (0, $5OZ28.preventFormSubmitOnEnterKeyPress)
            },
            placeholder: formatMessage((0, $7MRtn.default).datePickerPlaceholder)
        },
        timePickerProps: {
            placeholder: formatMessage((0, $7MRtn.default).timePickerPlaceholder)
        }
    })));
};
var $9afe2be1047ba6e6$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
$9afe2be1047ba6e6$export$ae1ced156568f0b0);

});
parcelRegister("dibFF", function(module, exports) {

$parcel$export(module.exports, "FieldLoader", () => $8479f60db9ef4b80$export$dbd27b551621740c);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");
const $8479f60db9ef4b80$export$dbd27b551621740c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "350px",
        height: "40px"
    });

});

parcelRegister("emnwK", function(module, exports) {

$parcel$export(module.exports, "AsyncDateTimeFieldEditView", () => $24ad4db56fbb2b06$export$657a1b8545a979b8);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $alNkm = parcelRequire("alNkm");
const $24ad4db56fbb2b06$var$EMPTY_OBJECT = {};
const $24ad4db56fbb2b06$export$657a1b8545a979b8 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $alNkm.asyncDateTimeFieldEditViewEntrypoint), // use stable reference to avoid re-renders
    $24ad4db56fbb2b06$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "async-jira-issue-field-date-time-edit-view",
        packageName: "jira-issue-field-date-time",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("alNkm", function(module, exports) {

$parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", () => $de0e04c2ef3b4ff6$export$971e82244ad6d423);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $de0e04c2ef3b4ff6$export$971e82244ad6d423 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("9yDwf")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
        moduleId: "267b9282"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9yDwf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1dfP8").then(()=>parcelRequire('9zdZs'));

});



parcelRegister("7MRtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b817dcd3c1298f6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9b817dcd3c1298f6$var$messages = (0, $90IgZ.defineMessages)({
    datePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.date-picker-placeholder",
        "defaultMessage": "Select date"
    },
    timePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.time-picker-placeholder",
        "defaultMessage": "Select time"
    }
});
var $9b817dcd3c1298f6$export$2e2bcd8739ae039 = $9b817dcd3c1298f6$var$messages;

});



parcelRegister("87PH3", function(module, exports) {

$parcel$export(module.exports, "DescriptionFieldTypeConfig", () => $07bee85b0e1f04e5$export$efd98ef2e1e5f7e9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $lILJW = parcelRequire("lILJW");

var $eHQA5 = parcelRequire("eHQA5");
const $07bee85b0e1f04e5$var$DescriptionFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lILJW.default), {
        ...props,
        defaultValue: undefined,
        fieldWrapperElement: null,
        mediaUploadContext: props.mediaUploadContexts.uploadContext
    });
const $07bee85b0e1f04e5$export$efd98ef2e1e5f7e9 = {
    type: (0, $lO4Or.DESCRIPTION_TYPE),
    Component: $07bee85b0e1f04e5$var$DescriptionFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DescriptionFieldPlaceholder), null),
    writer: (0, $eHQA5.descriptionFieldWriter)
};

});
parcelRegister("lILJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3f3526c6b4c5569$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $sb1CK = parcelRequire("sb1CK");
const $d3f3526c6b4c5569$export$336230c809f2ec53 = (props)=>{
    const editorKey = (0, $eUqFw.useRef)(Date.now());
    const { fieldProps: { value: value, onChange: onChange }, mediaUploadContext: mediaUploadContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sb1CK.DescriptionEdit), {
        key: editorKey.current,
        onChange: onChange,
        defaultValue: value,
        mediaContext: {
            // @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'ViewContext': clientId, serviceHost, token, tokenLifespanInMs, and 3 more
            viewContext: mediaUploadContext || {},
            uploadContext: mediaUploadContext,
            userAuth: null
        }
    }));
};
var $d3f3526c6b4c5569$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({})($d3f3526c6b4c5569$export$336230c809f2ec53);

});
parcelRegister("sb1CK", function(module, exports) {

$parcel$export(module.exports, "DescriptionEdit", () => $0f061646f339c86e$export$cd5df8eea6a360e2);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $9VPEO = parcelRequire("9VPEO");

var $9KxVf = parcelRequire("9KxVf");

var $gGtKh = parcelRequire("gGtKh");
const $0f061646f339c86e$export$cd5df8eea6a360e2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "smart-card-provider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
            height: "150px",
            width: "auto"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KxVf.AsyncRichTextEditView), props)));

});
parcelRegister("9KxVf", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextEditView", () => $c89053f88af22b51$export$ba962c8a1ae57ac);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $60V7C = parcelRequire("60V7C");
const $c89053f88af22b51$var$EMPTY_OBJECT = {};
const $c89053f88af22b51$export$ba962c8a1ae57ac = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $60V7C.asyncRichTextEditEntryPoint), // use stable object reference to avoid re-renders
    $c89053f88af22b51$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-issue-field-rich-text-edit-async",
        packageName: "jira-issue-field-rich-text",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            height: "150px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("60V7C", function(module, exports) {

$parcel$export(module.exports, "asyncRichTextEditEntryPoint", () => $64d058c077a5e888$export$153c0381975152a7);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $64d058c077a5e888$export$153c0381975152a7 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("4W3ZL")).then((module)=>module.EntryPointContent), {
        moduleId: "7ade4e9b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4W3ZL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("i8NOQ")
]).then(()=>parcelRequire('5Ucyf'));

});






parcelRegister("agYKJ", function(module, exports) {

$parcel$export(module.exports, "DueDateFieldTypeConfig", () => $7a404975df464967$export$1f36cc37f9d9ead0);

var $eUqFw = parcelRequire("eUqFw");

var $2sjGj = parcelRequire("2sjGj");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $7a404975df464967$var$DueDateFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2sjGj.default), props);
const $7a404975df464967$export$1f36cc37f9d9ead0 = {
    type: (0, $lO4Or.DUE_DATE_TYPE),
    Component: $7a404975df464967$var$DueDateFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DateFieldPlaceholder), null),
    writer: (0, $eHQA5.dateFieldWriter)
};

});

parcelRegister("5zP1p", function(module, exports) {

$parcel$export(module.exports, "GroupCustomFieldTypeConfig", () => $dfee45d753969c93$export$fcafcf9905a0ab43);

var $eUqFw = parcelRequire("eUqFw");

var $ikozW = parcelRequire("ikozW");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $dfee45d753969c93$var$GroupCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ikozW.default), props);
const $dfee45d753969c93$export$fcafcf9905a0ab43 = {
    type: (0, $lO4Or.GROUP_CF_TYPE),
    Component: $dfee45d753969c93$var$GroupCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.singleGroupPickerFieldWriter)
};

});
parcelRegister("ikozW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3502f904942eed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fXyiT = parcelRequire("fXyiT");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $dvJOo = parcelRequire("dvJOo");

var $7TaJX = parcelRequire("7TaJX");

var $3x0xT = parcelRequire("3x0xT");
const $ca3502f904942eed$var$SingleGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $fXyiT.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvJOo.default), {
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        autoFocus: autoFocus,
        isMulti: false,
        "aria-labelledby": ariaLabelledBy,
        width: width,
        isInvalid: Boolean(error),
        placeholder: " ",
        ...getExtraProps()
    });
};
var $ca3502f904942eed$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateGroupPickerField),
    transformDefaultValue: (0, $3x0xT.transformGroupDefaultValueToUserOption)
})($ca3502f904942eed$var$SingleGroupPickerField);

});
parcelRegister("fXyiT", function(module, exports) {

$parcel$export(module.exports, "defaultUserPickerStyles", () => $6da490b0db05b7db$export$ddd4b90ea2d7a329);

var $c9TLT = parcelRequire("c9TLT");
const $6da490b0db05b7db$export$ddd4b90ea2d7a329 = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $c9TLT.layers).modal)
        })
};

});

parcelRegister("dvJOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $429926a88a015fd5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jYnpi = parcelRequire("jYnpi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gnxL7 = parcelRequire("gnxL7");

var $lEbr0 = parcelRequire("lEbr0");

var $27L64 = parcelRequire("27L64");

var $auQXa = parcelRequire("auQXa");
const $429926a88a015fd5$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $429926a88a015fd5$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $429926a88a015fd5$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const previousQuery = (0, $eUqFw.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $lEbr0.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $eUqFw.useState)(false);
    const getUserPickerControlStyle = (0, $eUqFw.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $auQXa.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $eUqFw.useCallback)((sessionId)=>{
        setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((sessionId)=>{
        setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $gnxL7.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $27L64.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        closeMenuOnScroll: closeMenuOnScroll,
        open: isDropdownVisible,
        menuPosition: menuPosition,
        styles: {
            control: getUserPickerControlStyle,
            ...groupPickerStyles
        }
    });
};
var $429926a88a015fd5$export$2e2bcd8739ae039 = $429926a88a015fd5$var$GroupPicker;

});
parcelRegister("gnxL7", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $75026b89b941da9d$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $75026b89b941da9d$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $75026b89b941da9d$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $75026b89b941da9d$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $75026b89b941da9d$export$705009f1a414da46);
const $75026b89b941da9d$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $75026b89b941da9d$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $75026b89b941da9d$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $75026b89b941da9d$export$285022bf9288513e = (groups)=>groups.map((group)=>$75026b89b941da9d$export$c76efe48b8ca8203(group));
const $75026b89b941da9d$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("lEbr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c63266297e3fcf9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $gnxL7 = parcelRequire("gnxL7");
const $5c63266297e3fcf9$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const currentQuery = (0, $eUqFw.useRef)('');
    const fetchGroups = (0, $eUqFw.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $lRmyA.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $gnxL7.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $5c63266297e3fcf9$export$2e2bcd8739ae039 = $5c63266297e3fcf9$var$useGroupsQuery;

});

parcelRegister("27L64", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd6b2182548f118$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3bd6b2182548f118$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("auQXa", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $861c966777ce7f65$export$f204658c943efb85);

const $861c966777ce7f65$export$f204658c943efb85 = {
    borderColor: `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`
};

});


parcelRegister("3x0xT", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $03c43028a694f8c2$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateSingleGroupPickerField", () => $03c43028a694f8c2$export$daeca2ffaa5d8b62);

var $gnxL7 = parcelRequire("gnxL7");

const $03c43028a694f8c2$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    return (0, $gnxL7.transformGroupToUserOption)(group);
};
const $03c43028a694f8c2$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
        fieldId: fieldId,
        group: {
            groupName: selectedGroup.name
        },
        mutationGroup: (0, $d295d044454c3082$export$31fd86f8f183952c)
    });

});
const $d295d044454c3082$export$31fd86f8f183952c = 'singleGroupPickerFields';




parcelRegister("coiWz", function(module, exports) {

$parcel$export(module.exports, "LabelsCustomFieldTypeConfig", () => $7ddc763c81723271$export$c08ea7a9c6fbd5e0);

var $eUqFw = parcelRequire("eUqFw");

var $l7nwo = parcelRequire("l7nwo");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $7ddc763c81723271$var$LabelsCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7nwo.default), props);
const $7ddc763c81723271$export$c08ea7a9c6fbd5e0 = {
    type: (0, $lO4Or.LABELS_CF_TYPE),
    Component: $7ddc763c81723271$var$LabelsCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.labelsFieldWriter)
};

});
parcelRegister("l7nwo", function(module, exports) {

$parcel$export(module.exports, "ForgeLabelsField", () => $eb55394608fb0f2e$export$f77bab10d748bb71);
$parcel$export(module.exports, "default", () => $eb55394608fb0f2e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $ff51f = parcelRequire("ff51f");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $6Wef2 = parcelRequire("6Wef2");
const $eb55394608fb0f2e$var$LabelsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ff51f.LabelsEdit), {
        isInvalid: Boolean(error),
        fetchSuggestionsOnMount: false,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired
    }));
};
const $eb55394608fb0f2e$export$f77bab10d748bb71 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateForgeLabelField),
    transformDefaultValue: (0, $6Wef2.mapDataToLabelOptions)
})($eb55394608fb0f2e$var$LabelsField);
var $eb55394608fb0f2e$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateLabelField),
    transformDefaultValue: (0, $6Wef2.mapDataToLabelOptions)
})($eb55394608fb0f2e$var$LabelsField);

});
parcelRegister("ff51f", function(module, exports) {

$parcel$export(module.exports, "LabelsEdit", () => $7889fb92b3af48af$export$23584166c0ffb901);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hompL = parcelRequire("hompL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $jM2Oz = parcelRequire("jM2Oz");
var $g6sIQ = parcelRequire("g6sIQ");

var $lO4Or = parcelRequire("lO4Or");

var $26Ej0 = parcelRequire("26Ej0");

var $8cY6u = parcelRequire("8cY6u");

var $4y9tu = parcelRequire("4y9tu");

var $63Mv3 = parcelRequire("63Mv3");
const $7889fb92b3af48af$export$251bdbdbce9550ea = 300;
const $7889fb92b3af48af$export$23584166c0ffb901 = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $lO4Or.LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const lastQuery = (0, $eUqFw.useRef)('');
    const sessionId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $8cY6u.useLabelsSuggestions)({
        fieldId: fieldId,
        getSuggestions: getSuggestions
    });
    const getFailedFetchMessage = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.FailedFetchOptionWrapper), null, formatMessage((0, $63Mv3.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        try {
            const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
            setIsLoadingSuggestions(false);
            if (lastQuery.current === query) {
                const results = (0, $26Ej0.mapLabelsResponseToLabelOptions)(response);
                setSuggestions(results);
                if (query === '') setDefaultSuggestions(results);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoadingSuggestions(false);
            setHasLastFetchFailed(true);
            setSuggestions([
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ]);
        }
    }, [
        autoCompleteUrl,
        getFailedFetchMessage,
        getLabelsSuggestions,
        lastQuery,
        sessionId,
        setHasLastFetchFailed,
        setIsLoadingSuggestions
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupedSuggestions = (0, $eUqFw.useMemo)(()=>[
            {
                label: formatMessage((0, $63Mv3.default).recent),
                options: cachedOptions
            },
            {
                label: formatMessage((0, $63Mv3.default).all),
                options: suggestions || []
            }
        ], [
        cachedOptions,
        formatMessage,
        suggestions
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(fetchSuggestions, $7889fb92b3af48af$export$251bdbdbce9550ea), []);
    const getCreateLabel = (0, $eUqFw.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $63Mv3.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $63Mv3.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $63Mv3.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $eUqFw.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        suggestions,
        onFocus,
        setIsLoadingSuggestions,
        fetchSuggestions
    ]);
    const onSelectBlur = (0, $eUqFw.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    const isLoading = isLoadingSuggestions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y9tu.default), {
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: groupedSuggestions,
        value: value,
        isDisabled: isDisabled,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        styles: (0, $4NcaX.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $63Mv3.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onChange,
        spacing: spacing,
        isLoading: isLoading,
        filterOption: filterOption,
        formatCreateLabel: getCreateLabel,
        validationState: isInvalid === true ? 'error' : null,
        sessionId: sessionId.current,
        "aria-label": ariaLabel,
        inputId: inputId,
        isRequired: isRequired,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $7889fb92b3af48af$export$2e2bcd8739ae039 = $7889fb92b3af48af$export$23584166c0ffb901;

});
parcelRegister("jM2Oz", function(module, exports) {

$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $9987adeb236c664b$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $9987adeb236c664b$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $9987adeb236c664b$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $9987adeb236c664b$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $9987adeb236c664b$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $9987adeb236c664b$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hnFco = parcelRequire("hnFco");
const $9987adeb236c664b$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $9987adeb236c664b$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const failedFetchMessage = (0, $hnFco.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9987adeb236c664b$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage(failedFetchMessage), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $hnFco.default).reloadIssue))));
};
const $9987adeb236c664b$export$aa3357fb0ebcdb2b = (query)=>$9987adeb236c664b$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9987adeb236c664b$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9987adeb236c664b$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$df67068a00dece12 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnFco", function(module, exports) {

$parcel$export(module.exports, "default", () => $79fb52d38fb3e29a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79fb52d38fb3e29a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    }
});

});


parcelRegister("g6sIQ", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $2dc2777cac843338$export$58bb91b619b113f6);

var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $2dc2777cac843338$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $2dc2777cac843338$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text including the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $2dc2777cac843338$var$filterOptionByLabelAndFilterValuesInternal = (0, $5iWql.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cEc3i.c)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $2dc2777cac843338$var$stringifyLabelAndDataFilterValues
    }));
const $2dc2777cac843338$export$58bb91b619b113f6 = (option, inputValue)=>$2dc2777cac843338$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("8cY6u", function(module, exports) {

$parcel$export(module.exports, "useLabelsSuggestions", () => $9e3ddd644508ee83$export$c5b80cd78ff71c5f);

var $eUqFw = parcelRequire("eUqFw");

var $8uNQc = parcelRequire("8uNQc");

var $lRmyA = parcelRequire("lRmyA");

var $kwEon = parcelRequire("kwEon");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");
const $9e3ddd644508ee83$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
    let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
    return (0, $lRmyA.performGetRequest)(url);
};
const $9e3ddd644508ee83$export$c5b80cd78ff71c5f = (props)=>{
    const { fieldId: fieldId, getSuggestions: getSuggestions = $9e3ddd644508ee83$export$343652b9755c68e7 } = props;
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getLabelsSuggestions = (0, $eUqFw.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
        const startTime = (0, $8uNQc.default).now();
        const queryLength = query.length;
        try {
            const response = await getSuggestions(autoCompleteUrl, query, sessionId);
            if (fieldId === (0, $lO4Or.LABELS_TYPE)) (0, $kwEon.fireSuggestionsRequestSuccessEvent)((0, $lO4Or.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (fieldId === (0, $lO4Or.LABELS_TYPE)) (0, $kwEon.fireSuggestionsRequestFailedEvent)((0, $lO4Or.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fieldId,
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>({
            getLabelsSuggestions: getLabelsSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getLabelsSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
parcelRegister("kwEon", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $fdc9d057cb7638cd$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $fdc9d057cb7638cd$export$a31ac580130dee62);

var $hgcvd = parcelRequire("hgcvd");

var $jMP2a = parcelRequire("jMP2a");
const $fdc9d057cb7638cd$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $hgcvd.default).now() - startTime
    };
    createAnalyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $fdc9d057cb7638cd$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $fdc9d057cb7638cd$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $fdc9d057cb7638cd$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $fdc9d057cb7638cd$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});


parcelRegister("4y9tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $341125a445ce24f9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $hompL = parcelRequire("hompL");

var $28t3A = parcelRequire("28t3A");

var $8uNQc = parcelRequire("8uNQc");

var $azx3n = parcelRequire("azx3n");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bICpe = parcelRequire("bICpe");
const $341125a445ce24f9$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $341125a445ce24f9$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $341125a445ce24f9$var$CreatableSelectWithAnalyticsNew = (0, $g8JvH.AnalyticsEventToProps)('select', $341125a445ce24f9$var$analyticsProps)((0, $28t3A.default));
const $341125a445ce24f9$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
    const sessionId = (0, $eUqFw.useRef)(customSessionId);
    const sessionStartedAt = (0, $eUqFw.useRef)(0);
    const [flatOptions, setFlatOptions] = (0, $eUqFw.useState)((0, $bICpe.flattenOptions)(options));
    const [queryAtSetValue, setQueryAtSetValue] = (0, $eUqFw.useState)('');
    const [savedQuery, setSavedQuery] = (0, $eUqFw.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getAnalyticsAttributes = (0, $eUqFw.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) ? value : [];
        let filteredOptions = (0, $bICpe.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $341125a445ce24f9$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $bICpe.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            isDisabled: isDisabled,
            optionsLength: optionsLength,
            componentName: 'select',
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $bICpe.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $azx3n.memoizedHashString)(query),
            selectedOptions: (0, $bICpe.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $bICpe.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $341125a445ce24f9$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading,
        isDisabled
    ]);
    const getItemOrder = (0, $eUqFw.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $eUqFw.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $eUqFw.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $eUqFw.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        sessionStartedAt.current = (0, $8uNQc.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $eUqFw.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $8uNQc.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $eUqFw.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $eUqFw.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $bICpe.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $bICpe.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $bICpe.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $eUqFw.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
        if (onChange) onChange(selectedValue, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange,
        isMulti
    ]);
    const onInputChangeWithAnalytics = (0, $eUqFw.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        startSession();
        fireInputChangedEvent('', {
            action: 'fake-action'
        }, createAnalyticsEvent({}));
        return ()=>{
            endSession();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // since due to multiple setState calls component is rerendered
        // added this change to reduce the number of setState call will be fixed,
        // wasn't able to replicate this issue in local so adding this change in feature flag.
        // sentry link: https://sentry.prod.atl-paas.net/atlassian/jira-frontend/issues/4943577/?query=is%3Aunresolved%20logger%3AjiraIssueCreateModal.withFormField
        const flattenedOption = (0, $bICpe.flattenOptions)(options);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($341125a445ce24f9$var$CreatableSelectWithAnalyticsNew, {
        ...props,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics
    });
};
var $341125a445ce24f9$export$2e2bcd8739ae039 = $341125a445ce24f9$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("azx3n", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $403b450273ddd0e6$export$c9e165da390f6283);

var $aHQJS = parcelRequire("aHQJS");

var $5iWql = parcelRequire("5iWql");

var $e91YZ = parcelRequire("e91YZ");
const $403b450273ddd0e6$export$fdd2c0ba94025c3c = (0, $5iWql.default)(()=>{
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $403b450273ddd0e6$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $403b450273ddd0e6$export$fdd2c0ba94025c3c();
    const hash = (0, $aHQJS.createHash)('sha256').update(`${cloudId}_${attribute.trim()}`).digest('hex');
    return hash;
};

});
parcelRegister("aHQJS", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $7cb6d463ef497bec$export$5f828d93ff035aa8, (v) => $7cb6d463ef497bec$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $7cb6d463ef497bec$export$cd94982b18c6332c, (v) => $7cb6d463ef497bec$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $7cb6d463ef497bec$export$1d518568e4f529b0, (v) => $7cb6d463ef497bec$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $7cb6d463ef497bec$export$5285b6d41c912b41, (v) => $7cb6d463ef497bec$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $7cb6d463ef497bec$export$2fb37efbf6ae0c0e, (v) => $7cb6d463ef497bec$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $7cb6d463ef497bec$export$ab85ecd77ce6a5cd, (v) => $7cb6d463ef497bec$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $7cb6d463ef497bec$export$da39cf97e1eb7c91, (v) => $7cb6d463ef497bec$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $7cb6d463ef497bec$export$52a9039d7177394f, (v) => $7cb6d463ef497bec$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $7cb6d463ef497bec$export$f7201db400317331, (v) => $7cb6d463ef497bec$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $7cb6d463ef497bec$export$448fa22aedc9dbca, (v) => $7cb6d463ef497bec$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $7cb6d463ef497bec$export$b80c7ba289c8fa56, (v) => $7cb6d463ef497bec$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $7cb6d463ef497bec$export$26e5786e8ac8e530, (v) => $7cb6d463ef497bec$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $7cb6d463ef497bec$export$bdd223f16383713e, (v) => $7cb6d463ef497bec$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $7cb6d463ef497bec$export$20533d26f07f1ee0, (v) => $7cb6d463ef497bec$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $7cb6d463ef497bec$export$2f64596b8cbf08b4, (v) => $7cb6d463ef497bec$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a, (v) => $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $7cb6d463ef497bec$export$12ada9414fbc594c, (v) => $7cb6d463ef497bec$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $7cb6d463ef497bec$export$f5e7e39d57cd9700, (v) => $7cb6d463ef497bec$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $7cb6d463ef497bec$export$36b6d6ef312eab39, (v) => $7cb6d463ef497bec$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $7cb6d463ef497bec$export$58a258485f1e49f6, (v) => $7cb6d463ef497bec$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $7cb6d463ef497bec$export$dedd8dc3dc62b370, (v) => $7cb6d463ef497bec$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $7cb6d463ef497bec$export$971862a2fcb1bb40, (v) => $7cb6d463ef497bec$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $7cb6d463ef497bec$export$c6ff6a88acbeaf40, (v) => $7cb6d463ef497bec$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $7cb6d463ef497bec$export$fdc27893e98845cc, (v) => $7cb6d463ef497bec$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $7cb6d463ef497bec$export$6671fb9a1323bed, (v) => $7cb6d463ef497bec$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $7cb6d463ef497bec$export$d74daf141a551db, (v) => $7cb6d463ef497bec$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $7cb6d463ef497bec$export$45df7cae684751af, (v) => $7cb6d463ef497bec$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $7cb6d463ef497bec$export$1db683ad541682f6, (v) => $7cb6d463ef497bec$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $7cb6d463ef497bec$export$6f65485f87568e37, (v) => $7cb6d463ef497bec$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $7cb6d463ef497bec$export$91a8e56769aeb334, (v) => $7cb6d463ef497bec$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $7cb6d463ef497bec$export$2d4117e99c2179e4, (v) => $7cb6d463ef497bec$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $7cb6d463ef497bec$export$512823e338ddb1b7, (v) => $7cb6d463ef497bec$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3, (v) => $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $7cb6d463ef497bec$export$b9d55ff329113abd, (v) => $7cb6d463ef497bec$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $7cb6d463ef497bec$export$7efb24e2fddf99b9, (v) => $7cb6d463ef497bec$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $7cb6d463ef497bec$export$bb1abf2ce84fc7e8, (v) => $7cb6d463ef497bec$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $7cb6d463ef497bec$export$2f7171e78e524d5e, (v) => $7cb6d463ef497bec$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $7cb6d463ef497bec$export$e1d879b482f37d98, (v) => $7cb6d463ef497bec$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $7cb6d463ef497bec$export$1a988e7317c65621, (v) => $7cb6d463ef497bec$export$1a988e7317c65621 = v);
var $7cb6d463ef497bec$export$5f828d93ff035aa8;
var $7cb6d463ef497bec$export$cd94982b18c6332c;
var $7cb6d463ef497bec$export$1d518568e4f529b0;
var $7cb6d463ef497bec$export$5285b6d41c912b41;
var $7cb6d463ef497bec$export$2fb37efbf6ae0c0e;
var $7cb6d463ef497bec$export$ab85ecd77ce6a5cd;
var $7cb6d463ef497bec$export$da39cf97e1eb7c91;
var $7cb6d463ef497bec$export$52a9039d7177394f;
var $7cb6d463ef497bec$export$f7201db400317331;
var $7cb6d463ef497bec$export$448fa22aedc9dbca;
var $7cb6d463ef497bec$export$b80c7ba289c8fa56;
var $7cb6d463ef497bec$export$26e5786e8ac8e530;
var $7cb6d463ef497bec$export$bdd223f16383713e;
var $7cb6d463ef497bec$export$20533d26f07f1ee0;
var $7cb6d463ef497bec$export$2f64596b8cbf08b4;
var $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a;
var $7cb6d463ef497bec$export$12ada9414fbc594c;
var $7cb6d463ef497bec$export$f5e7e39d57cd9700;
var $7cb6d463ef497bec$export$36b6d6ef312eab39;
var $7cb6d463ef497bec$export$58a258485f1e49f6;
var $7cb6d463ef497bec$export$dedd8dc3dc62b370;
var $7cb6d463ef497bec$export$971862a2fcb1bb40;
var $7cb6d463ef497bec$export$c6ff6a88acbeaf40;
var $7cb6d463ef497bec$export$fdc27893e98845cc;
var $7cb6d463ef497bec$export$6671fb9a1323bed;
var $7cb6d463ef497bec$export$d74daf141a551db;
var $7cb6d463ef497bec$export$45df7cae684751af;
var $7cb6d463ef497bec$export$1db683ad541682f6;
var $7cb6d463ef497bec$export$6f65485f87568e37;
var $7cb6d463ef497bec$export$91a8e56769aeb334;
var $7cb6d463ef497bec$export$2d4117e99c2179e4;
var $7cb6d463ef497bec$export$512823e338ddb1b7;
var $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3;
var $7cb6d463ef497bec$export$b9d55ff329113abd;
var $7cb6d463ef497bec$export$7efb24e2fddf99b9;
var $7cb6d463ef497bec$export$bb1abf2ce84fc7e8;
var $7cb6d463ef497bec$export$2f7171e78e524d5e;
var $7cb6d463ef497bec$export$e1d879b482f37d98;
var $7cb6d463ef497bec$export$1a988e7317c65621;
'use strict';

$7cb6d463ef497bec$export$5f828d93ff035aa8 = $7cb6d463ef497bec$export$cd94982b18c6332c = $7cb6d463ef497bec$export$1d518568e4f529b0 = $7cb6d463ef497bec$export$5285b6d41c912b41 = (parcelRequire("ugwNY"));

$7cb6d463ef497bec$export$2fb37efbf6ae0c0e = $7cb6d463ef497bec$export$ab85ecd77ce6a5cd = (parcelRequire("cnL2y"));

$7cb6d463ef497bec$export$da39cf97e1eb7c91 = $7cb6d463ef497bec$export$52a9039d7177394f = (parcelRequire("jPoqK"));

var $61Iwu = parcelRequire("61Iwu");
var $7cb6d463ef497bec$var$algoKeys = Object.keys($61Iwu);
var $7cb6d463ef497bec$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($7cb6d463ef497bec$var$algoKeys);
$7cb6d463ef497bec$export$f7201db400317331 = function() {
    return $7cb6d463ef497bec$var$hashes;
};

var $8bTm7 = parcelRequire("8bTm7");
$7cb6d463ef497bec$export$448fa22aedc9dbca = $8bTm7.pbkdf2;
$7cb6d463ef497bec$export$b80c7ba289c8fa56 = $8bTm7.pbkdf2Sync;

var $9rGLx = parcelRequire("9rGLx");
$7cb6d463ef497bec$export$26e5786e8ac8e530 = $9rGLx.Cipher;
$7cb6d463ef497bec$export$bdd223f16383713e = $9rGLx.createCipher;
$7cb6d463ef497bec$export$20533d26f07f1ee0 = $9rGLx.Cipheriv;
$7cb6d463ef497bec$export$2f64596b8cbf08b4 = $9rGLx.createCipheriv;
$7cb6d463ef497bec$export$2ce6d8d0e8b04e1a = $9rGLx.Decipher;
$7cb6d463ef497bec$export$12ada9414fbc594c = $9rGLx.createDecipher;
$7cb6d463ef497bec$export$f5e7e39d57cd9700 = $9rGLx.Decipheriv;
$7cb6d463ef497bec$export$36b6d6ef312eab39 = $9rGLx.createDecipheriv;
$7cb6d463ef497bec$export$58a258485f1e49f6 = $9rGLx.getCiphers;
$7cb6d463ef497bec$export$dedd8dc3dc62b370 = $9rGLx.listCiphers;

var $fPWK2 = parcelRequire("fPWK2");
$7cb6d463ef497bec$export$971862a2fcb1bb40 = $fPWK2.DiffieHellmanGroup;
$7cb6d463ef497bec$export$c6ff6a88acbeaf40 = $fPWK2.createDiffieHellmanGroup;
$7cb6d463ef497bec$export$fdc27893e98845cc = $fPWK2.getDiffieHellman;
$7cb6d463ef497bec$export$6671fb9a1323bed = $fPWK2.createDiffieHellman;
$7cb6d463ef497bec$export$d74daf141a551db = $fPWK2.DiffieHellman;

var $cQURD = parcelRequire("cQURD");
$7cb6d463ef497bec$export$45df7cae684751af = $cQURD.createSign;
$7cb6d463ef497bec$export$1db683ad541682f6 = $cQURD.Sign;
$7cb6d463ef497bec$export$6f65485f87568e37 = $cQURD.createVerify;
$7cb6d463ef497bec$export$91a8e56769aeb334 = $cQURD.Verify;

$7cb6d463ef497bec$export$2d4117e99c2179e4 = (parcelRequire("ks6qZ"));

var $bZRnR = parcelRequire("bZRnR");
$7cb6d463ef497bec$export$512823e338ddb1b7 = $bZRnR.publicEncrypt;
$7cb6d463ef497bec$export$9d0e0c0c4a8d30f3 = $bZRnR.privateEncrypt;
$7cb6d463ef497bec$export$b9d55ff329113abd = $bZRnR.publicDecrypt;
$7cb6d463ef497bec$export$7efb24e2fddf99b9 = $bZRnR.privateDecrypt;

var $hF130 = parcelRequire("hF130");
$7cb6d463ef497bec$export$bb1abf2ce84fc7e8 = $hF130.randomFill;
$7cb6d463ef497bec$export$2f7171e78e524d5e = $hF130.randomFillSync;
$7cb6d463ef497bec$export$e1d879b482f37d98 = function() {
    throw new Error([
        'sorry, createCredentials is not implemented yet',
        'we accept pull requests',
        'https://github.com/crypto-browserify/crypto-browserify'
    ].join('\n'));
};
$7cb6d463ef497bec$export$1a988e7317c65621 = {
    'DH_CHECK_P_NOT_SAFE_PRIME': 2,
    'DH_CHECK_P_NOT_PRIME': 1,
    'DH_UNABLE_TO_CHECK_GENERATOR': 4,
    'DH_NOT_SUITABLE_GENERATOR': 8,
    'NPN_ENABLED': 1,
    'ALPN_ENABLED': 1,
    'RSA_PKCS1_PADDING': 1,
    'RSA_SSLV23_PADDING': 2,
    'RSA_NO_PADDING': 3,
    'RSA_PKCS1_OAEP_PADDING': 4,
    'RSA_X931_PADDING': 5,
    'RSA_PKCS1_PSS_PADDING': 6,
    'POINT_CONVERSION_COMPRESSED': 2,
    'POINT_CONVERSION_UNCOMPRESSED': 4,
    'POINT_CONVERSION_HYBRID': 6
};

});
parcelRegister("ugwNY", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $05af9f9868efc57c$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $05af9f9868efc57c$var$MAX_UINT32 = 4294967295;
function $05af9f9868efc57c$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $ijh2q = parcelRequire("ijh2q");
var $05af9f9868efc57c$require$Buffer = $ijh2q.Buffer;
var $05af9f9868efc57c$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($05af9f9868efc57c$var$crypto && $05af9f9868efc57c$var$crypto.getRandomValues) module.exports = $05af9f9868efc57c$var$randomBytes;
else module.exports = $05af9f9868efc57c$var$oldBrowser;
function $05af9f9868efc57c$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $05af9f9868efc57c$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $05af9f9868efc57c$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $05af9f9868efc57c$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $05af9f9868efc57c$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $05af9f9868efc57c$var$crypto.getRandomValues(bytes.slice(generated, generated + $05af9f9868efc57c$var$MAX_BYTES));
        else $05af9f9868efc57c$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $2fFJv.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("ijh2q", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $aul3P = parcelRequire("aul3P");
var $d54737c7644fd369$var$Buffer = $aul3P.Buffer;
// alternative to using Object.keys for old browsers
function $d54737c7644fd369$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d54737c7644fd369$var$Buffer.from && $d54737c7644fd369$var$Buffer.alloc && $d54737c7644fd369$var$Buffer.allocUnsafe && $d54737c7644fd369$var$Buffer.allocUnsafeSlow) module.exports = $aul3P;
else {
    // Copy properties from require('buffer')
    $d54737c7644fd369$var$copyProps($aul3P, module.exports);
    module.exports.Buffer = $d54737c7644fd369$var$SafeBuffer;
}
function $d54737c7644fd369$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d54737c7644fd369$var$Buffer(arg, encodingOrOffset, length);
}
$d54737c7644fd369$var$SafeBuffer.prototype = Object.create($d54737c7644fd369$var$Buffer.prototype);
// Copy static methods from Buffer
$d54737c7644fd369$var$copyProps($d54737c7644fd369$var$Buffer, $d54737c7644fd369$var$SafeBuffer);
$d54737c7644fd369$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d54737c7644fd369$var$Buffer(arg, encodingOrOffset, length);
};
$d54737c7644fd369$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d54737c7644fd369$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d54737c7644fd369$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d54737c7644fd369$var$Buffer(size);
};
$d54737c7644fd369$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $aul3P.SlowBuffer(size);
};

});


parcelRegister("cnL2y", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $903c1f32ad17f34f$require$Buffer = $aul3P.Buffer;
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");

var $7hBrF = parcelRequire("7hBrF");
function $903c1f32ad17f34f$var$HashNoConstructor(hash) {
    $7hBrF.call(this, 'digest');
    this._hash = hash;
    this.buffers = [];
}
$lyUaN($903c1f32ad17f34f$var$HashNoConstructor, $7hBrF);
$903c1f32ad17f34f$var$HashNoConstructor.prototype._update = function(data) {
    this.buffers.push(data);
};
$903c1f32ad17f34f$var$HashNoConstructor.prototype._final = function() {
    var buf = $903c1f32ad17f34f$require$Buffer.concat(this.buffers);
    var r = this._hash(buf);
    this.buffers = null;
    return r;
};
function $903c1f32ad17f34f$var$Hash(hash) {
    $7hBrF.call(this, 'digest');
    this._hash = hash;
}
$lyUaN($903c1f32ad17f34f$var$Hash, $7hBrF);
$903c1f32ad17f34f$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$903c1f32ad17f34f$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $903c1f32ad17f34f$var$HashNoConstructor($6Kk1A);
    if (alg === 'rmd160' || alg === 'ripemd160') return new $903c1f32ad17f34f$var$Hash(new $bGrC1());
    return new $903c1f32ad17f34f$var$Hash($lqV5D(alg));
};

});
parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("6Kk1A", function(module, exports) {
'use strict';

var $9nTll = parcelRequire("9nTll");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $4e969272193b5eb7$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $4e969272193b5eb7$var$safe_add(a, olda);
        b = $4e969272193b5eb7$var$safe_add(b, oldb);
        c = $4e969272193b5eb7$var$safe_add(c, oldc);
        d = $4e969272193b5eb7$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $4e969272193b5eb7$var$md5_cmn(q, a, b, x, s, t) {
    return $4e969272193b5eb7$var$safe_add($4e969272193b5eb7$var$bit_rol($4e969272193b5eb7$var$safe_add($4e969272193b5eb7$var$safe_add(a, q), $4e969272193b5eb7$var$safe_add(x, t)), s), b);
}
function $4e969272193b5eb7$var$md5_ff(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_gg(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_hh(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_ii(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $4e969272193b5eb7$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $4e969272193b5eb7$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $9nTll(buf, $4e969272193b5eb7$var$core_md5);
};

});
parcelRegister("9nTll", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $6d5131133b33993d$require$Buffer = $aul3P.Buffer;
'use strict';
var $6d5131133b33993d$var$intSize = 4;
var $6d5131133b33993d$var$zeroBuffer = new $6d5131133b33993d$require$Buffer($6d5131133b33993d$var$intSize);
$6d5131133b33993d$var$zeroBuffer.fill(0);
var $6d5131133b33993d$var$charSize = 8;
var $6d5131133b33993d$var$hashSize = 16;
function $6d5131133b33993d$var$toArray(buf) {
    if (buf.length % $6d5131133b33993d$var$intSize !== 0) {
        var len = buf.length + ($6d5131133b33993d$var$intSize - buf.length % $6d5131133b33993d$var$intSize);
        buf = $6d5131133b33993d$require$Buffer.concat([
            buf,
            $6d5131133b33993d$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $6d5131133b33993d$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($6d5131133b33993d$var$toArray(buf), buf.length * $6d5131133b33993d$var$charSize);
    buf = new $6d5131133b33993d$require$Buffer($6d5131133b33993d$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("bGrC1", function(module, exports) {
'use strict';

var $aul3P = parcelRequire("aul3P");
var $88190928fdba87c8$require$Buffer = $aul3P.Buffer;

var $lyUaN = parcelRequire("lyUaN");

var $2UmI8 = parcelRequire("2UmI8");
var $88190928fdba87c8$var$ARRAY16 = new Array(16);
var $88190928fdba87c8$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $88190928fdba87c8$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $88190928fdba87c8$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $88190928fdba87c8$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $88190928fdba87c8$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $88190928fdba87c8$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $88190928fdba87c8$var$RIPEMD160() {
    $2UmI8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$lyUaN($88190928fdba87c8$var$RIPEMD160, $2UmI8);
$88190928fdba87c8$var$RIPEMD160.prototype._update = function() {
    var words = $88190928fdba87c8$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $88190928fdba87c8$var$fn1(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[0], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn5(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[0], $88190928fdba87c8$var$sr[i]);
        } else if (i < 32) {
            tl = $88190928fdba87c8$var$fn2(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[1], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn4(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[1], $88190928fdba87c8$var$sr[i]);
        } else if (i < 48) {
            tl = $88190928fdba87c8$var$fn3(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[2], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn3(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[2], $88190928fdba87c8$var$sr[i]);
        } else if (i < 64) {
            tl = $88190928fdba87c8$var$fn4(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[3], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn2(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[3], $88190928fdba87c8$var$sr[i]);
        } else {
            tl = $88190928fdba87c8$var$fn5(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[4], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn1(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[4], $88190928fdba87c8$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $88190928fdba87c8$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $88190928fdba87c8$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$88190928fdba87c8$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $88190928fdba87c8$require$Buffer.alloc ? $88190928fdba87c8$require$Buffer.alloc(20) : new $88190928fdba87c8$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $88190928fdba87c8$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $88190928fdba87c8$var$fn1(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn2(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn3(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn4(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn5(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $88190928fdba87c8$var$RIPEMD160;

});
parcelRegister("2UmI8", function(module, exports) {
'use strict';

var $ijh2q = parcelRequire("ijh2q");
var $21e26da029925685$require$Buffer = $ijh2q.Buffer;

var $anz8L = parcelRequire("anz8L");
var $21e26da029925685$require$Transform = $anz8L.Transform;

var $lyUaN = parcelRequire("lyUaN");
function $21e26da029925685$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$21e26da029925685$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $21e26da029925685$var$HashBase(blockSize) {
    $21e26da029925685$require$Transform.call(this);
    this._block = $21e26da029925685$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lyUaN($21e26da029925685$var$HashBase, $21e26da029925685$require$Transform);
$21e26da029925685$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$21e26da029925685$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$21e26da029925685$var$HashBase.prototype.update = function(data, encoding) {
    $21e26da029925685$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$21e26da029925685$require$Buffer.isBuffer(data)) data = $21e26da029925685$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$21e26da029925685$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$21e26da029925685$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$21e26da029925685$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $21e26da029925685$var$HashBase;

});
parcelRegister("anz8L", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $78e74f7c5379cef2$var$Stream;

var $3sTLs = parcelRequire("3sTLs");
var $78e74f7c5379cef2$require$EE = $3sTLs.EventEmitter;

var $lyUaN = parcelRequire("lyUaN");
$lyUaN($78e74f7c5379cef2$var$Stream, $78e74f7c5379cef2$require$EE);

$78e74f7c5379cef2$var$Stream.Readable = (parcelRequire("hd0Wp"));

$78e74f7c5379cef2$var$Stream.Writable = (parcelRequire("kKpgC"));

$78e74f7c5379cef2$var$Stream.Duplex = (parcelRequire("aoI29"));

$78e74f7c5379cef2$var$Stream.Transform = (parcelRequire("lUyqo"));

$78e74f7c5379cef2$var$Stream.PassThrough = (parcelRequire("4kZwd"));

$78e74f7c5379cef2$var$Stream.finished = (parcelRequire("jV6VG"));

$78e74f7c5379cef2$var$Stream.pipeline = (parcelRequire("8Ms18"));
// Backwards-compat with node 0.4.x
$78e74f7c5379cef2$var$Stream.Stream = $78e74f7c5379cef2$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $78e74f7c5379cef2$var$Stream() {
    $78e74f7c5379cef2$require$EE.call(this);
}
$78e74f7c5379cef2$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($78e74f7c5379cef2$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("hd0Wp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
module.exports = $c874616fccc431a8$var$Readable;
/*<replacement>*/ var $c874616fccc431a8$var$Duplex;
/*</replacement>*/ $c874616fccc431a8$var$Readable.ReadableState = $c874616fccc431a8$var$ReadableState;

var $3sTLs = parcelRequire("3sTLs");
var $c874616fccc431a8$require$EE = $3sTLs.EventEmitter;
var $c874616fccc431a8$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $8wk3O = parcelRequire("8wk3O");

var $aul3P = parcelRequire("aul3P");
var $c874616fccc431a8$require$Buffer = $aul3P.Buffer;
var $c874616fccc431a8$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c874616fccc431a8$var$_uint8ArrayToBuffer(chunk) {
    return $c874616fccc431a8$require$Buffer.from(chunk);
}
function $c874616fccc431a8$var$_isUint8Array(obj) {
    return $c874616fccc431a8$require$Buffer.isBuffer(obj) || obj instanceof $c874616fccc431a8$var$OurUint8Array;
}

var $jFleb = parcelRequire("jFleb");
var $c874616fccc431a8$var$debug;
if ($jFleb && $jFleb.debuglog) $c874616fccc431a8$var$debug = $jFleb.debuglog('stream');
else $c874616fccc431a8$var$debug = function debug() {};

var $jx80w = parcelRequire("jx80w");

var $lzWKR = parcelRequire("lzWKR");

var $dsJPG = parcelRequire("dsJPG");
var $c874616fccc431a8$var$getHighWaterMark = $dsJPG.getHighWaterMark;

var $i8n8u = parcelRequire("i8n8u");
var $c874616fccc431a8$require$_require$codes = $i8n8u.codes;
var $c874616fccc431a8$var$ERR_INVALID_ARG_TYPE = $c874616fccc431a8$require$_require$codes.ERR_INVALID_ARG_TYPE, $c874616fccc431a8$var$ERR_STREAM_PUSH_AFTER_EOF = $c874616fccc431a8$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $c874616fccc431a8$var$ERR_METHOD_NOT_IMPLEMENTED = $c874616fccc431a8$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c874616fccc431a8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $c874616fccc431a8$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $c874616fccc431a8$var$StringDecoder;
var $c874616fccc431a8$var$createReadableStreamAsyncIterator;
var $c874616fccc431a8$var$from;

(parcelRequire("lyUaN"))($c874616fccc431a8$var$Readable, $8wk3O);
var $c874616fccc431a8$var$errorOrDestroy = $lzWKR.errorOrDestroy;
var $c874616fccc431a8$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $c874616fccc431a8$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c874616fccc431a8$var$ReadableState(options, stream, isDuplex) {
    $c874616fccc431a8$var$Duplex = $c874616fccc431a8$var$Duplex || (parcelRequire("aoI29"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $c874616fccc431a8$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $c874616fccc431a8$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jx80w();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c874616fccc431a8$var$StringDecoder) $c874616fccc431a8$var$StringDecoder = (parcelRequire("iSptP")).StringDecoder;
        this.decoder = new $c874616fccc431a8$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c874616fccc431a8$var$Readable(options) {
    $c874616fccc431a8$var$Duplex = $c874616fccc431a8$var$Duplex || (parcelRequire("aoI29"));
    if (!(this instanceof $c874616fccc431a8$var$Readable)) return new $c874616fccc431a8$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c874616fccc431a8$var$Duplex;
    this._readableState = new $c874616fccc431a8$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $8wk3O.call(this);
}
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c874616fccc431a8$var$Readable.prototype.destroy = $lzWKR.destroy;
$c874616fccc431a8$var$Readable.prototype._undestroy = $lzWKR.undestroy;
$c874616fccc431a8$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c874616fccc431a8$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c874616fccc431a8$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c874616fccc431a8$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c874616fccc431a8$var$Readable.prototype.unshift = function(chunk) {
    return $c874616fccc431a8$var$readableAddChunk(this, chunk, null, true, false);
};
function $c874616fccc431a8$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $c874616fccc431a8$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c874616fccc431a8$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c874616fccc431a8$var$chunkInvalid(state, chunk);
        if (er) $c874616fccc431a8$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $c874616fccc431a8$require$Buffer.prototype) chunk = $c874616fccc431a8$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $c874616fccc431a8$var$errorOrDestroy(stream, new $c874616fccc431a8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $c874616fccc431a8$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $c874616fccc431a8$var$errorOrDestroy(stream, new $c874616fccc431a8$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c874616fccc431a8$var$addChunk(stream, state, chunk, false);
                    else $c874616fccc431a8$var$maybeReadMore(stream, state);
                } else $c874616fccc431a8$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $c874616fccc431a8$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c874616fccc431a8$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c874616fccc431a8$var$emitReadable(stream);
    }
    $c874616fccc431a8$var$maybeReadMore(stream, state);
}
function $c874616fccc431a8$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c874616fccc431a8$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $c874616fccc431a8$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$c874616fccc431a8$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c874616fccc431a8$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c874616fccc431a8$var$StringDecoder) $c874616fccc431a8$var$StringDecoder = (parcelRequire("iSptP")).StringDecoder;
    var decoder = new $c874616fccc431a8$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $c874616fccc431a8$var$MAX_HWM = 0x40000000;
function $c874616fccc431a8$var$computeNewHighWaterMark(n) {
    if (n >= $c874616fccc431a8$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $c874616fccc431a8$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c874616fccc431a8$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c874616fccc431a8$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c874616fccc431a8$var$Readable.prototype.read = function(n) {
    $c874616fccc431a8$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c874616fccc431a8$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c874616fccc431a8$var$endReadable(this);
        else $c874616fccc431a8$var$emitReadable(this);
        return null;
    }
    n = $c874616fccc431a8$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c874616fccc431a8$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c874616fccc431a8$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c874616fccc431a8$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c874616fccc431a8$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $c874616fccc431a8$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c874616fccc431a8$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c874616fccc431a8$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c874616fccc431a8$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $c874616fccc431a8$var$onEofChunk(stream, state) {
    $c874616fccc431a8$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $c874616fccc431a8$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $c874616fccc431a8$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c874616fccc431a8$var$emitReadable(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c874616fccc431a8$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2fFJv.nextTick($c874616fccc431a8$var$emitReadable_, stream);
    }
}
function $c874616fccc431a8$var$emitReadable_(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c874616fccc431a8$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c874616fccc431a8$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $2fFJv.nextTick($c874616fccc431a8$var$maybeReadMore_, stream, state);
    }
}
function $c874616fccc431a8$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $c874616fccc431a8$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c874616fccc431a8$var$Readable.prototype._read = function(n) {
    $c874616fccc431a8$var$errorOrDestroy(this, new $c874616fccc431a8$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$c874616fccc431a8$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c874616fccc431a8$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2fFJv.stdout && dest !== $2fFJv.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2fFJv.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c874616fccc431a8$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c874616fccc431a8$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c874616fccc431a8$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c874616fccc431a8$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $c874616fccc431a8$var$debug('ondata');
        var ret = dest.write(chunk);
        $c874616fccc431a8$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c874616fccc431a8$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c874616fccc431a8$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c874616fccc431a8$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($c874616fccc431a8$var$EElistenerCount(dest, 'error') === 0) $c874616fccc431a8$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $c874616fccc431a8$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c874616fccc431a8$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c874616fccc431a8$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c874616fccc431a8$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c874616fccc431a8$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $c874616fccc431a8$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c874616fccc431a8$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $c874616fccc431a8$var$flow(src);
        }
    };
}
$c874616fccc431a8$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c874616fccc431a8$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c874616fccc431a8$var$Readable.prototype.on = function(ev, fn) {
    var res = $8wk3O.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c874616fccc431a8$var$debug('on readable', state.length, state.reading);
            if (state.length) $c874616fccc431a8$var$emitReadable(this);
            else if (!state.reading) $2fFJv.nextTick($c874616fccc431a8$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c874616fccc431a8$var$Readable.prototype.addListener = $c874616fccc431a8$var$Readable.prototype.on;
$c874616fccc431a8$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $8wk3O.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2fFJv.nextTick($c874616fccc431a8$var$updateReadableListening, this);
    return res;
};
$c874616fccc431a8$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $8wk3O.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2fFJv.nextTick($c874616fccc431a8$var$updateReadableListening, this);
    return res;
};
function $c874616fccc431a8$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $c874616fccc431a8$var$nReadingNextTick(self1) {
    $c874616fccc431a8$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c874616fccc431a8$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c874616fccc431a8$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $c874616fccc431a8$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $c874616fccc431a8$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2fFJv.nextTick($c874616fccc431a8$var$resume_, stream, state);
    }
}
function $c874616fccc431a8$var$resume_(stream, state) {
    $c874616fccc431a8$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $c874616fccc431a8$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c874616fccc431a8$var$Readable.prototype.pause = function() {
    $c874616fccc431a8$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c874616fccc431a8$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $c874616fccc431a8$var$flow(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c874616fccc431a8$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $c874616fccc431a8$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $c874616fccc431a8$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c874616fccc431a8$var$kProxyEvents.length; n++)stream.on($c874616fccc431a8$var$kProxyEvents[n], this.emit.bind(this, $c874616fccc431a8$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c874616fccc431a8$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $c874616fccc431a8$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($c874616fccc431a8$var$createReadableStreamAsyncIterator === undefined) $c874616fccc431a8$var$createReadableStreamAsyncIterator = (parcelRequire("eryNp"));
    return $c874616fccc431a8$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$c874616fccc431a8$var$Readable._fromList = $c874616fccc431a8$var$fromList;
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c874616fccc431a8$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c874616fccc431a8$var$endReadable(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2fFJv.nextTick($c874616fccc431a8$var$endReadableNT, state, stream);
    }
}
function $c874616fccc431a8$var$endReadableNT(state, stream) {
    $c874616fccc431a8$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $c874616fccc431a8$var$Readable.from = function(iterable, opts) {
    if ($c874616fccc431a8$var$from === undefined) $c874616fccc431a8$var$from = (parcelRequire("gljMO"));
    return $c874616fccc431a8$var$from($c874616fccc431a8$var$Readable, iterable, opts);
};
function $c874616fccc431a8$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("8wk3O", function(module, exports) {

module.exports = (parcelRequire("3sTLs")).EventEmitter;

});

parcelRegister("jx80w", function(module, exports) {
'use strict';
function $e3874f7ac1f848ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e3874f7ac1f848ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e3874f7ac1f848ee$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e3874f7ac1f848ee$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e3874f7ac1f848ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e3874f7ac1f848ee$var$_defineProperty(obj, key, value) {
    key = $e3874f7ac1f848ee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e3874f7ac1f848ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e3874f7ac1f848ee$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e3874f7ac1f848ee$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e3874f7ac1f848ee$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e3874f7ac1f848ee$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e3874f7ac1f848ee$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e3874f7ac1f848ee$var$_toPropertyKey(arg) {
    var key = $e3874f7ac1f848ee$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e3874f7ac1f848ee$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $aul3P = parcelRequire("aul3P");
var $e3874f7ac1f848ee$var$Buffer = $aul3P.Buffer;

var $jFleb = parcelRequire("jFleb");
var $e3874f7ac1f848ee$var$inspect = $jFleb.inspect;
var $e3874f7ac1f848ee$var$custom = $e3874f7ac1f848ee$var$inspect && $e3874f7ac1f848ee$var$inspect.custom || 'inspect';
function $e3874f7ac1f848ee$var$copyBuffer(src, target, offset) {
    $e3874f7ac1f848ee$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $e3874f7ac1f848ee$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $e3874f7ac1f848ee$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $e3874f7ac1f848ee$var$Buffer.alloc(0);
                var ret = $e3874f7ac1f848ee$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $e3874f7ac1f848ee$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $e3874f7ac1f848ee$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $e3874f7ac1f848ee$var$custom,
            value: function value(_, options) {
                return $e3874f7ac1f848ee$var$inspect(this, $e3874f7ac1f848ee$var$_objectSpread($e3874f7ac1f848ee$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("lzWKR", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $fb5a7154f411547f$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorAndCloseNT, _this, err);
            } else $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
        } else if (cb) {
            $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
            cb(err);
        } else $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
    });
    return this;
}
function $fb5a7154f411547f$var$emitErrorAndCloseNT(self, err) {
    $fb5a7154f411547f$var$emitErrorNT(self, err);
    $fb5a7154f411547f$var$emitCloseNT(self);
}
function $fb5a7154f411547f$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $fb5a7154f411547f$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $fb5a7154f411547f$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $fb5a7154f411547f$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $fb5a7154f411547f$var$destroy,
    undestroy: $fb5a7154f411547f$var$undestroy,
    errorOrDestroy: $fb5a7154f411547f$var$errorOrDestroy
};

});

parcelRegister("dsJPG", function(module, exports) {
'use strict';

var $9cd1714906576d1f$var$ERR_INVALID_OPT_VALUE = (parcelRequire("i8n8u")).codes.ERR_INVALID_OPT_VALUE;
function $9cd1714906576d1f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9cd1714906576d1f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $9cd1714906576d1f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $9cd1714906576d1f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $9cd1714906576d1f$var$getHighWaterMark
};

});
parcelRegister("i8n8u", function(module, exports) {

$parcel$export(module.exports, "codes", () => $d33aeba58cf9ee4e$export$e45cb6485273080e, (v) => $d33aeba58cf9ee4e$export$e45cb6485273080e = v);
var $d33aeba58cf9ee4e$export$e45cb6485273080e;
'use strict';
function $d33aeba58cf9ee4e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $d33aeba58cf9ee4e$var$codes = {};
function $d33aeba58cf9ee4e$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $d33aeba58cf9ee4e$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $d33aeba58cf9ee4e$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $d33aeba58cf9ee4e$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $d33aeba58cf9ee4e$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $d33aeba58cf9ee4e$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $d33aeba58cf9ee4e$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$d33aeba58cf9ee4e$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $d33aeba58cf9ee4e$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($d33aeba58cf9ee4e$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($d33aeba58cf9ee4e$var$oneOf(expected, 'type'));
    else {
        var type = $d33aeba58cf9ee4e$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($d33aeba58cf9ee4e$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$d33aeba58cf9ee4e$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$d33aeba58cf9ee4e$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$d33aeba58cf9ee4e$export$e45cb6485273080e = $d33aeba58cf9ee4e$var$codes;

});


parcelRegister("aoI29", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
/*<replacement>*/ var $791e4d7664ce07ae$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $791e4d7664ce07ae$var$Duplex;

var $hd0Wp = parcelRequire("hd0Wp");

var $kKpgC = parcelRequire("kKpgC");

(parcelRequire("lyUaN"))($791e4d7664ce07ae$var$Duplex, $hd0Wp);
// Allow the keys array to be GC'ed.
var $791e4d7664ce07ae$var$keys = $791e4d7664ce07ae$var$objectKeys($kKpgC.prototype);
for(var $791e4d7664ce07ae$var$v = 0; $791e4d7664ce07ae$var$v < $791e4d7664ce07ae$var$keys.length; $791e4d7664ce07ae$var$v++){
    var $791e4d7664ce07ae$var$method = $791e4d7664ce07ae$var$keys[$791e4d7664ce07ae$var$v];
    if (!$791e4d7664ce07ae$var$Duplex.prototype[$791e4d7664ce07ae$var$method]) $791e4d7664ce07ae$var$Duplex.prototype[$791e4d7664ce07ae$var$method] = $kKpgC.prototype[$791e4d7664ce07ae$var$method];
}
function $791e4d7664ce07ae$var$Duplex(options) {
    if (!(this instanceof $791e4d7664ce07ae$var$Duplex)) return new $791e4d7664ce07ae$var$Duplex(options);
    $hd0Wp.call(this, options);
    $kKpgC.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $791e4d7664ce07ae$var$onend);
        }
    }
}
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $791e4d7664ce07ae$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $2fFJv.nextTick($791e4d7664ce07ae$var$onEndNT, this);
}
function $791e4d7664ce07ae$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("kKpgC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
module.exports = $f1abb40b22f49859$var$Writable;
/* <replacement> */ function $f1abb40b22f49859$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f1abb40b22f49859$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f1abb40b22f49859$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f1abb40b22f49859$var$Duplex;
/*</replacement>*/ $f1abb40b22f49859$var$Writable.WritableState = $f1abb40b22f49859$var$WritableState;

/*<replacement>*/ var $f1abb40b22f49859$var$internalUtil = {
    deprecate: (parcelRequire("6UWyy"))
};

var $8wk3O = parcelRequire("8wk3O");

var $aul3P = parcelRequire("aul3P");
var $f1abb40b22f49859$require$Buffer = $aul3P.Buffer;
var $f1abb40b22f49859$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f1abb40b22f49859$var$_uint8ArrayToBuffer(chunk) {
    return $f1abb40b22f49859$require$Buffer.from(chunk);
}
function $f1abb40b22f49859$var$_isUint8Array(obj) {
    return $f1abb40b22f49859$require$Buffer.isBuffer(obj) || obj instanceof $f1abb40b22f49859$var$OurUint8Array;
}

var $lzWKR = parcelRequire("lzWKR");

var $dsJPG = parcelRequire("dsJPG");
var $f1abb40b22f49859$var$getHighWaterMark = $dsJPG.getHighWaterMark;

var $i8n8u = parcelRequire("i8n8u");
var $f1abb40b22f49859$require$_require$codes = $i8n8u.codes;
var $f1abb40b22f49859$var$ERR_INVALID_ARG_TYPE = $f1abb40b22f49859$require$_require$codes.ERR_INVALID_ARG_TYPE, $f1abb40b22f49859$var$ERR_METHOD_NOT_IMPLEMENTED = $f1abb40b22f49859$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f1abb40b22f49859$var$ERR_MULTIPLE_CALLBACK = $f1abb40b22f49859$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f1abb40b22f49859$var$ERR_STREAM_CANNOT_PIPE = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $f1abb40b22f49859$var$ERR_STREAM_DESTROYED = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_DESTROYED, $f1abb40b22f49859$var$ERR_STREAM_NULL_VALUES = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_NULL_VALUES, $f1abb40b22f49859$var$ERR_STREAM_WRITE_AFTER_END = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $f1abb40b22f49859$var$ERR_UNKNOWN_ENCODING = $f1abb40b22f49859$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $f1abb40b22f49859$var$errorOrDestroy = $lzWKR.errorOrDestroy;

(parcelRequire("lyUaN"))($f1abb40b22f49859$var$Writable, $8wk3O);
function $f1abb40b22f49859$var$nop() {}

function $f1abb40b22f49859$var$WritableState(options, stream, isDuplex) {
    $f1abb40b22f49859$var$Duplex = $f1abb40b22f49859$var$Duplex || (parcelRequire("aoI29"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f1abb40b22f49859$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $f1abb40b22f49859$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f1abb40b22f49859$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f1abb40b22f49859$var$CorkedRequest(this);
}
$f1abb40b22f49859$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f1abb40b22f49859$var$WritableState.prototype, 'buffer', {
            get: $f1abb40b22f49859$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f1abb40b22f49859$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $f1abb40b22f49859$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f1abb40b22f49859$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($f1abb40b22f49859$var$realHasInstance.call(this, object)) return true;
            if (this !== $f1abb40b22f49859$var$Writable) return false;
            return object && object._writableState instanceof $f1abb40b22f49859$var$WritableState;
        }
    });
} else $f1abb40b22f49859$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $f1abb40b22f49859$var$Writable(options) {
    $f1abb40b22f49859$var$Duplex = $f1abb40b22f49859$var$Duplex || (parcelRequire("aoI29"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f1abb40b22f49859$var$Duplex;
    if (!isDuplex && !$f1abb40b22f49859$var$realHasInstance.call($f1abb40b22f49859$var$Writable, this)) return new $f1abb40b22f49859$var$Writable(options);
    this._writableState = new $f1abb40b22f49859$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $8wk3O.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f1abb40b22f49859$var$Writable.prototype.pipe = function() {
    $f1abb40b22f49859$var$errorOrDestroy(this, new $f1abb40b22f49859$var$ERR_STREAM_CANNOT_PIPE());
};
function $f1abb40b22f49859$var$writeAfterEnd(stream, cb) {
    var er = new $f1abb40b22f49859$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $f1abb40b22f49859$var$errorOrDestroy(stream, er);
    $2fFJv.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f1abb40b22f49859$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $f1abb40b22f49859$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $f1abb40b22f49859$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
        $2fFJv.nextTick(cb, er);
        return false;
    }
    return true;
}
$f1abb40b22f49859$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f1abb40b22f49859$var$_isUint8Array(chunk);
    if (isBuf && !$f1abb40b22f49859$require$Buffer.isBuffer(chunk)) chunk = $f1abb40b22f49859$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $f1abb40b22f49859$var$nop;
    if (state.ending) $f1abb40b22f49859$var$writeAfterEnd(this, cb);
    else if (isBuf || $f1abb40b22f49859$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f1abb40b22f49859$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f1abb40b22f49859$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f1abb40b22f49859$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f1abb40b22f49859$var$clearBuffer(this, state);
    }
};
$f1abb40b22f49859$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $f1abb40b22f49859$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $f1abb40b22f49859$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $f1abb40b22f49859$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f1abb40b22f49859$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f1abb40b22f49859$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f1abb40b22f49859$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f1abb40b22f49859$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f1abb40b22f49859$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f1abb40b22f49859$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $2fFJv.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $2fFJv.nextTick($f1abb40b22f49859$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $f1abb40b22f49859$var$finishMaybe(stream, state);
    }
}
function $f1abb40b22f49859$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f1abb40b22f49859$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $f1abb40b22f49859$var$ERR_MULTIPLE_CALLBACK();
    $f1abb40b22f49859$var$onwriteStateUpdate(state);
    if (er) $f1abb40b22f49859$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f1abb40b22f49859$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f1abb40b22f49859$var$clearBuffer(stream, state);
        if (sync) $2fFJv.nextTick($f1abb40b22f49859$var$afterWrite, stream, state, finished, cb);
        else $f1abb40b22f49859$var$afterWrite(stream, state, finished, cb);
    }
}
function $f1abb40b22f49859$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f1abb40b22f49859$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f1abb40b22f49859$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f1abb40b22f49859$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $f1abb40b22f49859$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f1abb40b22f49859$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f1abb40b22f49859$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f1abb40b22f49859$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f1abb40b22f49859$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $f1abb40b22f49859$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$f1abb40b22f49859$var$Writable.prototype._writev = null;
$f1abb40b22f49859$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f1abb40b22f49859$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $f1abb40b22f49859$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f1abb40b22f49859$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $f1abb40b22f49859$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $f1abb40b22f49859$var$finishMaybe(stream, state);
    });
}
function $f1abb40b22f49859$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $2fFJv.nextTick($f1abb40b22f49859$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f1abb40b22f49859$var$finishMaybe(stream, state) {
    var need = $f1abb40b22f49859$var$needFinish(state);
    if (need) {
        $f1abb40b22f49859$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $f1abb40b22f49859$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f1abb40b22f49859$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $2fFJv.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f1abb40b22f49859$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f1abb40b22f49859$var$Writable.prototype.destroy = $lzWKR.destroy;
$f1abb40b22f49859$var$Writable.prototype._undestroy = $lzWKR.undestroy;
$f1abb40b22f49859$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("6UWyy", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $50956520c48d9d9c$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $50956520c48d9d9c$var$deprecate(fn, msg) {
    if ($50956520c48d9d9c$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($50956520c48d9d9c$var$config('throwDeprecation')) throw new Error(msg);
            else if ($50956520c48d9d9c$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $50956520c48d9d9c$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iSptP", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $dbe108f5fb9524a7$export$63a7aa211a91ed69, (v) => $dbe108f5fb9524a7$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $dbe108f5fb9524a7$export$63a7aa211a91ed69;
'use strict';

var $ijh2q = parcelRequire("ijh2q");
var $dbe108f5fb9524a7$require$Buffer = $ijh2q.Buffer;
/*</replacement>*/ var $dbe108f5fb9524a7$var$isEncoding = $dbe108f5fb9524a7$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $dbe108f5fb9524a7$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $dbe108f5fb9524a7$var$normalizeEncoding(enc) {
    var nenc = $dbe108f5fb9524a7$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($dbe108f5fb9524a7$require$Buffer.isEncoding === $dbe108f5fb9524a7$var$isEncoding || !$dbe108f5fb9524a7$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$dbe108f5fb9524a7$export$63a7aa211a91ed69 = $dbe108f5fb9524a7$var$StringDecoder;
function $dbe108f5fb9524a7$var$StringDecoder(encoding) {
    this.encoding = $dbe108f5fb9524a7$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $dbe108f5fb9524a7$var$utf16Text;
            this.end = $dbe108f5fb9524a7$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $dbe108f5fb9524a7$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $dbe108f5fb9524a7$var$base64Text;
            this.end = $dbe108f5fb9524a7$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $dbe108f5fb9524a7$var$simpleWrite;
            this.end = $dbe108f5fb9524a7$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $dbe108f5fb9524a7$require$Buffer.allocUnsafe(nb);
}
$dbe108f5fb9524a7$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$dbe108f5fb9524a7$var$StringDecoder.prototype.end = $dbe108f5fb9524a7$var$utf8End;
// Returns only complete characters in a Buffer
$dbe108f5fb9524a7$var$StringDecoder.prototype.text = $dbe108f5fb9524a7$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$dbe108f5fb9524a7$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $dbe108f5fb9524a7$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $dbe108f5fb9524a7$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $dbe108f5fb9524a7$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $dbe108f5fb9524a7$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $dbe108f5fb9524a7$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $dbe108f5fb9524a7$var$utf8Text(buf, i) {
    var total = $dbe108f5fb9524a7$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $dbe108f5fb9524a7$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $dbe108f5fb9524a7$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $dbe108f5fb9524a7$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $dbe108f5fb9524a7$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $dbe108f5fb9524a7$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $dbe108f5fb9524a7$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $dbe108f5fb9524a7$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("eryNp", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
var $a83e941260fb2f21$var$_Object$setPrototypeO;
function $a83e941260fb2f21$var$_defineProperty(obj, key, value) {
    key = $a83e941260fb2f21$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a83e941260fb2f21$var$_toPropertyKey(arg) {
    var key = $a83e941260fb2f21$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a83e941260fb2f21$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jV6VG = parcelRequire("jV6VG");
var $a83e941260fb2f21$var$kLastResolve = Symbol('lastResolve');
var $a83e941260fb2f21$var$kLastReject = Symbol('lastReject');
var $a83e941260fb2f21$var$kError = Symbol('error');
var $a83e941260fb2f21$var$kEnded = Symbol('ended');
var $a83e941260fb2f21$var$kLastPromise = Symbol('lastPromise');
var $a83e941260fb2f21$var$kHandlePromise = Symbol('handlePromise');
var $a83e941260fb2f21$var$kStream = Symbol('stream');
function $a83e941260fb2f21$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $a83e941260fb2f21$var$readAndResolve(iter) {
    var resolve = iter[$a83e941260fb2f21$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$a83e941260fb2f21$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$a83e941260fb2f21$var$kLastPromise] = null;
            iter[$a83e941260fb2f21$var$kLastResolve] = null;
            iter[$a83e941260fb2f21$var$kLastReject] = null;
            resolve($a83e941260fb2f21$var$createIterResult(data, false));
        }
    }
}
function $a83e941260fb2f21$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $2fFJv.nextTick($a83e941260fb2f21$var$readAndResolve, iter);
}
function $a83e941260fb2f21$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$a83e941260fb2f21$var$kEnded]) {
                resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
                return;
            }
            iter[$a83e941260fb2f21$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $a83e941260fb2f21$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $a83e941260fb2f21$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($a83e941260fb2f21$var$_Object$setPrototypeO = {
    get stream () {
        return this[$a83e941260fb2f21$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$a83e941260fb2f21$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$a83e941260fb2f21$var$kEnded]) return Promise.resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        if (this[$a83e941260fb2f21$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $2fFJv.nextTick(function() {
                if (_this[$a83e941260fb2f21$var$kError]) reject(_this[$a83e941260fb2f21$var$kError]);
                else resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$a83e941260fb2f21$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($a83e941260fb2f21$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$a83e941260fb2f21$var$kStream].read();
            if (data !== null) return Promise.resolve($a83e941260fb2f21$var$createIterResult(data, false));
            promise = new Promise(this[$a83e941260fb2f21$var$kHandlePromise]);
        }
        this[$a83e941260fb2f21$var$kLastPromise] = promise;
        return promise;
    }
}, $a83e941260fb2f21$var$_defineProperty($a83e941260fb2f21$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $a83e941260fb2f21$var$_defineProperty($a83e941260fb2f21$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$a83e941260fb2f21$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        });
    });
}), $a83e941260fb2f21$var$_Object$setPrototypeO), $a83e941260fb2f21$var$AsyncIteratorPrototype);
var $a83e941260fb2f21$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($a83e941260fb2f21$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kStream, {
        value: stream,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kLastResolve, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kLastReject, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kError, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$a83e941260fb2f21$var$kStream].read();
            if (data) {
                iterator[$a83e941260fb2f21$var$kLastPromise] = null;
                iterator[$a83e941260fb2f21$var$kLastResolve] = null;
                iterator[$a83e941260fb2f21$var$kLastReject] = null;
                resolve($a83e941260fb2f21$var$createIterResult(data, false));
            } else {
                iterator[$a83e941260fb2f21$var$kLastResolve] = resolve;
                iterator[$a83e941260fb2f21$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$a83e941260fb2f21$var$kLastPromise] = null;
    $jV6VG(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$a83e941260fb2f21$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$a83e941260fb2f21$var$kLastPromise] = null;
                iterator[$a83e941260fb2f21$var$kLastResolve] = null;
                iterator[$a83e941260fb2f21$var$kLastReject] = null;
                reject(err);
            }
            iterator[$a83e941260fb2f21$var$kError] = err;
            return;
        }
        var resolve = iterator[$a83e941260fb2f21$var$kLastResolve];
        if (resolve !== null) {
            iterator[$a83e941260fb2f21$var$kLastPromise] = null;
            iterator[$a83e941260fb2f21$var$kLastResolve] = null;
            iterator[$a83e941260fb2f21$var$kLastReject] = null;
            resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        }
        iterator[$a83e941260fb2f21$var$kEnded] = true;
    });
    stream.on('readable', $a83e941260fb2f21$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $a83e941260fb2f21$var$createReadableStreamAsyncIterator;

});
parcelRegister("jV6VG", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("i8n8u")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e808b73f4846b37f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e808b73f4846b37f$var$noop() {}
function $e808b73f4846b37f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $e808b73f4846b37f$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $e808b73f4846b37f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e808b73f4846b37f$var$once(callback || $e808b73f4846b37f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($e808b73f4846b37f$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $e808b73f4846b37f$var$eos;

});


parcelRegister("gljMO", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("lUyqo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $ff3987f7b5428486$var$Transform;

var $i8n8u = parcelRequire("i8n8u");
var $ff3987f7b5428486$require$_require$codes = $i8n8u.codes;
var $ff3987f7b5428486$var$ERR_METHOD_NOT_IMPLEMENTED = $ff3987f7b5428486$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ff3987f7b5428486$var$ERR_MULTIPLE_CALLBACK = $ff3987f7b5428486$require$_require$codes.ERR_MULTIPLE_CALLBACK, $ff3987f7b5428486$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $ff3987f7b5428486$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $ff3987f7b5428486$var$ERR_TRANSFORM_WITH_LENGTH_0 = $ff3987f7b5428486$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $aoI29 = parcelRequire("aoI29");

(parcelRequire("lyUaN"))($ff3987f7b5428486$var$Transform, $aoI29);
function $ff3987f7b5428486$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $ff3987f7b5428486$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $ff3987f7b5428486$var$Transform(options) {
    if (!(this instanceof $ff3987f7b5428486$var$Transform)) return new $ff3987f7b5428486$var$Transform(options);
    $aoI29.call(this, options);
    this._transformState = {
        afterTransform: $ff3987f7b5428486$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $ff3987f7b5428486$var$prefinish);
}
function $ff3987f7b5428486$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $ff3987f7b5428486$var$done(_this, er, data);
    });
    else $ff3987f7b5428486$var$done(this, null, null);
}
$ff3987f7b5428486$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $aoI29.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$ff3987f7b5428486$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $ff3987f7b5428486$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$ff3987f7b5428486$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$ff3987f7b5428486$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$ff3987f7b5428486$var$Transform.prototype._destroy = function(err, cb) {
    $aoI29.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $ff3987f7b5428486$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $ff3987f7b5428486$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $ff3987f7b5428486$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4kZwd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $3288bffe507d45ca$var$PassThrough;

var $lUyqo = parcelRequire("lUyqo");

(parcelRequire("lyUaN"))($3288bffe507d45ca$var$PassThrough, $lUyqo);
function $3288bffe507d45ca$var$PassThrough(options) {
    if (!(this instanceof $3288bffe507d45ca$var$PassThrough)) return new $3288bffe507d45ca$var$PassThrough(options);
    $lUyqo.call(this, options);
}
$3288bffe507d45ca$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("8Ms18", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $66488a15dea22053$var$eos;
function $66488a15dea22053$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $i8n8u = parcelRequire("i8n8u");
var $66488a15dea22053$require$_require$codes = $i8n8u.codes;
var $66488a15dea22053$var$ERR_MISSING_ARGS = $66488a15dea22053$require$_require$codes.ERR_MISSING_ARGS, $66488a15dea22053$var$ERR_STREAM_DESTROYED = $66488a15dea22053$require$_require$codes.ERR_STREAM_DESTROYED;
function $66488a15dea22053$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $66488a15dea22053$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $66488a15dea22053$var$destroyer(stream, reading, writing, callback) {
    callback = $66488a15dea22053$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($66488a15dea22053$var$eos === undefined) $66488a15dea22053$var$eos = (parcelRequire("jV6VG"));
    $66488a15dea22053$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($66488a15dea22053$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $66488a15dea22053$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $66488a15dea22053$var$call(fn) {
    fn();
}
function $66488a15dea22053$var$pipe(from, to) {
    return from.pipe(to);
}
function $66488a15dea22053$var$popCallback(streams) {
    if (!streams.length) return $66488a15dea22053$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $66488a15dea22053$var$noop;
    return streams.pop();
}
function $66488a15dea22053$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $66488a15dea22053$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $66488a15dea22053$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $66488a15dea22053$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($66488a15dea22053$var$call);
            if (reading) return;
            destroys.forEach($66488a15dea22053$var$call);
            callback(error);
        });
    });
    return streams.reduce($66488a15dea22053$var$pipe);
}
module.exports = $66488a15dea22053$var$pipeline;

});




parcelRegister("lqV5D", function(module, exports) {
var $f9a84f91b73961ae$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $f9a84f91b73961ae$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$f9a84f91b73961ae$var$exports.sha = (parcelRequire("aq7sD"));

$f9a84f91b73961ae$var$exports.sha1 = (parcelRequire("5hjhX"));

$f9a84f91b73961ae$var$exports.sha224 = (parcelRequire("7Rfie"));

$f9a84f91b73961ae$var$exports.sha256 = (parcelRequire("eF9el"));

$f9a84f91b73961ae$var$exports.sha384 = (parcelRequire("9B479"));

$f9a84f91b73961ae$var$exports.sha512 = (parcelRequire("bir8L"));

});
parcelRegister("aq7sD", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $79621eabed5f8c00$require$Buffer = $ijh2q.Buffer;
var $79621eabed5f8c00$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $79621eabed5f8c00$var$W = new Array(80);
function $79621eabed5f8c00$var$Sha() {
    this.init();
    this._w = $79621eabed5f8c00$var$W;
    $laXlc.call(this, 64, 56);
}
$lyUaN($79621eabed5f8c00$var$Sha, $laXlc);
$79621eabed5f8c00$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $79621eabed5f8c00$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $79621eabed5f8c00$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $79621eabed5f8c00$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$79621eabed5f8c00$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $79621eabed5f8c00$var$rotl5(a) + $79621eabed5f8c00$var$ft(s, b, c, d) + e + W[j] + $79621eabed5f8c00$var$K[s] | 0;
        e = d;
        d = c;
        c = $79621eabed5f8c00$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$79621eabed5f8c00$var$Sha.prototype._hash = function() {
    var H = $79621eabed5f8c00$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $79621eabed5f8c00$var$Sha;

});
parcelRegister("laXlc", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $f6a89006f13ce239$require$Buffer = $ijh2q.Buffer;
// prototype class for hash functions
function $f6a89006f13ce239$var$Hash(blockSize, finalSize) {
    this._block = $f6a89006f13ce239$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$f6a89006f13ce239$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $f6a89006f13ce239$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$f6a89006f13ce239$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$f6a89006f13ce239$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $f6a89006f13ce239$var$Hash;

});


parcelRegister("5hjhX", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $3d7d809e7a1ab643$require$Buffer = $ijh2q.Buffer;
var $3d7d809e7a1ab643$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $3d7d809e7a1ab643$var$W = new Array(80);
function $3d7d809e7a1ab643$var$Sha1() {
    this.init();
    this._w = $3d7d809e7a1ab643$var$W;
    $laXlc.call(this, 64, 56);
}
$lyUaN($3d7d809e7a1ab643$var$Sha1, $laXlc);
$3d7d809e7a1ab643$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $3d7d809e7a1ab643$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $3d7d809e7a1ab643$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $3d7d809e7a1ab643$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $3d7d809e7a1ab643$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$3d7d809e7a1ab643$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $3d7d809e7a1ab643$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $3d7d809e7a1ab643$var$rotl5(a) + $3d7d809e7a1ab643$var$ft(s, b, c, d) + e + W[j] + $3d7d809e7a1ab643$var$K[s] | 0;
        e = d;
        d = c;
        c = $3d7d809e7a1ab643$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$3d7d809e7a1ab643$var$Sha1.prototype._hash = function() {
    var H = $3d7d809e7a1ab643$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $3d7d809e7a1ab643$var$Sha1;

});

parcelRegister("7Rfie", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $eF9el = parcelRequire("eF9el");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $5b895883d67b9370$require$Buffer = $ijh2q.Buffer;
var $5b895883d67b9370$var$W = new Array(64);
function $5b895883d67b9370$var$Sha224() {
    this.init();
    this._w = $5b895883d67b9370$var$W // new Array(64)
    ;
    $laXlc.call(this, 64, 56);
}
$lyUaN($5b895883d67b9370$var$Sha224, $eF9el);
$5b895883d67b9370$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$5b895883d67b9370$var$Sha224.prototype._hash = function() {
    var H = $5b895883d67b9370$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $5b895883d67b9370$var$Sha224;

});
parcelRegister("eF9el", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $aacc0e009da62399$require$Buffer = $ijh2q.Buffer;
var $aacc0e009da62399$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $aacc0e009da62399$var$W = new Array(64);
function $aacc0e009da62399$var$Sha256() {
    this.init();
    this._w = $aacc0e009da62399$var$W // new Array(64)
    ;
    $laXlc.call(this, 64, 56);
}
$lyUaN($aacc0e009da62399$var$Sha256, $laXlc);
$aacc0e009da62399$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $aacc0e009da62399$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $aacc0e009da62399$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $aacc0e009da62399$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $aacc0e009da62399$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $aacc0e009da62399$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $aacc0e009da62399$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$aacc0e009da62399$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $aacc0e009da62399$var$gamma1(W[i - 2]) + W[i - 7] + $aacc0e009da62399$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $aacc0e009da62399$var$sigma1(e) + $aacc0e009da62399$var$ch(e, f, g) + $aacc0e009da62399$var$K[j] + W[j] | 0;
        var T2 = $aacc0e009da62399$var$sigma0(a) + $aacc0e009da62399$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$aacc0e009da62399$var$Sha256.prototype._hash = function() {
    var H = $aacc0e009da62399$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $aacc0e009da62399$var$Sha256;

});


parcelRegister("9B479", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $bir8L = parcelRequire("bir8L");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $6fcac2cb2d39f17a$require$Buffer = $ijh2q.Buffer;
var $6fcac2cb2d39f17a$var$W = new Array(160);
function $6fcac2cb2d39f17a$var$Sha384() {
    this.init();
    this._w = $6fcac2cb2d39f17a$var$W;
    $laXlc.call(this, 128, 112);
}
$lyUaN($6fcac2cb2d39f17a$var$Sha384, $bir8L);
$6fcac2cb2d39f17a$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$6fcac2cb2d39f17a$var$Sha384.prototype._hash = function() {
    var H = $6fcac2cb2d39f17a$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $6fcac2cb2d39f17a$var$Sha384;

});
parcelRegister("bir8L", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $83966da3ee4e453b$require$Buffer = $ijh2q.Buffer;
var $83966da3ee4e453b$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $83966da3ee4e453b$var$W = new Array(160);
function $83966da3ee4e453b$var$Sha512() {
    this.init();
    this._w = $83966da3ee4e453b$var$W;
    $laXlc.call(this, 128, 112);
}
$lyUaN($83966da3ee4e453b$var$Sha512, $laXlc);
$83966da3ee4e453b$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $83966da3ee4e453b$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $83966da3ee4e453b$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $83966da3ee4e453b$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $83966da3ee4e453b$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $83966da3ee4e453b$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $83966da3ee4e453b$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $83966da3ee4e453b$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $83966da3ee4e453b$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $83966da3ee4e453b$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$83966da3ee4e453b$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $83966da3ee4e453b$var$Gamma0(xh, xl);
        var gamma0l = $83966da3ee4e453b$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $83966da3ee4e453b$var$Gamma1(xh, xl);
        var gamma1l = $83966da3ee4e453b$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $83966da3ee4e453b$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $83966da3ee4e453b$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $83966da3ee4e453b$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $83966da3ee4e453b$var$maj(ah, bh, ch);
        var majl = $83966da3ee4e453b$var$maj(al, bl, cl);
        var sigma0h = $83966da3ee4e453b$var$sigma0(ah, al);
        var sigma0l = $83966da3ee4e453b$var$sigma0(al, ah);
        var sigma1h = $83966da3ee4e453b$var$sigma1(eh, el);
        var sigma1l = $83966da3ee4e453b$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $83966da3ee4e453b$var$K[j];
        var Kil = $83966da3ee4e453b$var$K[j + 1];
        var chh = $83966da3ee4e453b$var$Ch(eh, fh, gh);
        var chl = $83966da3ee4e453b$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $83966da3ee4e453b$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $83966da3ee4e453b$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $83966da3ee4e453b$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $83966da3ee4e453b$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $83966da3ee4e453b$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $83966da3ee4e453b$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $83966da3ee4e453b$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $83966da3ee4e453b$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $83966da3ee4e453b$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $83966da3ee4e453b$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $83966da3ee4e453b$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $83966da3ee4e453b$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $83966da3ee4e453b$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $83966da3ee4e453b$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $83966da3ee4e453b$var$getCarry(this._hl, hl) | 0;
};
$83966da3ee4e453b$var$Sha512.prototype._hash = function() {
    var H = $83966da3ee4e453b$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $83966da3ee4e453b$var$Sha512;

});



parcelRegister("7hBrF", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $54d72ac3f9f3d584$require$Buffer = $ijh2q.Buffer;

var $anz8L = parcelRequire("anz8L");
var $54d72ac3f9f3d584$require$Transform = $anz8L.Transform;

var $iSptP = parcelRequire("iSptP");
var $54d72ac3f9f3d584$require$StringDecoder = $iSptP.StringDecoder;

var $lyUaN = parcelRequire("lyUaN");
function $54d72ac3f9f3d584$var$CipherBase(hashMode) {
    $54d72ac3f9f3d584$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$lyUaN($54d72ac3f9f3d584$var$CipherBase, $54d72ac3f9f3d584$require$Transform);
$54d72ac3f9f3d584$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === 'string') data = $54d72ac3f9f3d584$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAutoPadding = function() {};
$54d72ac3f9f3d584$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$54d72ac3f9f3d584$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$54d72ac3f9f3d584$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $54d72ac3f9f3d584$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$54d72ac3f9f3d584$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $54d72ac3f9f3d584$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error('can\'t switch encodings');
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $54d72ac3f9f3d584$var$CipherBase;

});


parcelRegister("jPoqK", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $lYCTE = parcelRequire("lYCTE");

var $7hBrF = parcelRequire("7hBrF");

var $ijh2q = parcelRequire("ijh2q");
var $e6f5bb1bc44e45c9$require$Buffer = $ijh2q.Buffer;

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");
var $e6f5bb1bc44e45c9$var$ZEROS = $e6f5bb1bc44e45c9$require$Buffer.alloc(128);
function $e6f5bb1bc44e45c9$var$Hmac(alg, key) {
    $7hBrF.call(this, 'digest');
    if (typeof key === 'string') key = $e6f5bb1bc44e45c9$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $bGrC1() : $lqV5D(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $e6f5bb1bc44e45c9$require$Buffer.concat([
        key,
        $e6f5bb1bc44e45c9$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $e6f5bb1bc44e45c9$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $e6f5bb1bc44e45c9$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $bGrC1() : $lqV5D(alg);
    this._hash.update(ipad);
}
$lyUaN($e6f5bb1bc44e45c9$var$Hmac, $7hBrF);
$e6f5bb1bc44e45c9$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$e6f5bb1bc44e45c9$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $bGrC1() : $lqV5D(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $e6f5bb1bc44e45c9$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $lYCTE($6Kk1A, key);
    return new $e6f5bb1bc44e45c9$var$Hmac(alg, key);
};

});
parcelRegister("lYCTE", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $ijh2q = parcelRequire("ijh2q");
var $fffd5f9b09d9e4a8$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");
var $fffd5f9b09d9e4a8$var$ZEROS = $fffd5f9b09d9e4a8$require$Buffer.alloc(128);
var $fffd5f9b09d9e4a8$var$blocksize = 64;
function $fffd5f9b09d9e4a8$var$Hmac(alg, key) {
    $7hBrF.call(this, 'digest');
    if (typeof key === 'string') key = $fffd5f9b09d9e4a8$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $fffd5f9b09d9e4a8$var$blocksize) key = alg(key);
    else if (key.length < $fffd5f9b09d9e4a8$var$blocksize) key = $fffd5f9b09d9e4a8$require$Buffer.concat([
        key,
        $fffd5f9b09d9e4a8$var$ZEROS
    ], $fffd5f9b09d9e4a8$var$blocksize);
    var ipad = this._ipad = $fffd5f9b09d9e4a8$require$Buffer.allocUnsafe($fffd5f9b09d9e4a8$var$blocksize);
    var opad = this._opad = $fffd5f9b09d9e4a8$require$Buffer.allocUnsafe($fffd5f9b09d9e4a8$var$blocksize);
    for(var i = 0; i < $fffd5f9b09d9e4a8$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$lyUaN($fffd5f9b09d9e4a8$var$Hmac, $7hBrF);
$fffd5f9b09d9e4a8$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$fffd5f9b09d9e4a8$var$Hmac.prototype._final = function() {
    var h = this._alg($fffd5f9b09d9e4a8$require$Buffer.concat(this._hash));
    return this._alg($fffd5f9b09d9e4a8$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $fffd5f9b09d9e4a8$var$Hmac;

});


parcelRegister("61Iwu", function(module, exports) {

module.exports = (parcelRequire("5x0OM"));

});
parcelRegister("5x0OM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("8bTm7", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca, (v) => $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56, (v) => $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56 = v);
var $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca;
var $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56;

$5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca = (parcelRequire("fkARo"));

$5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56 = (parcelRequire("fVtzD"));

});
parcelRegister("fkARo", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");

var $jS82b = parcelRequire("jS82b");

var $lniV2 = parcelRequire("lniV2");

var $fVtzD = parcelRequire("fVtzD");

var $ijh2q = parcelRequire("ijh2q");
var $b29550e988d9fb77$require$Buffer = $ijh2q.Buffer;
var $b29550e988d9fb77$var$ZERO_BUF;
var $b29550e988d9fb77$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $b29550e988d9fb77$var$toBrowser = {
    'sha': 'SHA-1',
    'sha-1': 'SHA-1',
    'sha1': 'SHA-1',
    'sha256': 'SHA-256',
    'sha-256': 'SHA-256',
    'sha384': 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    'sha512': 'SHA-512'
};
var $b29550e988d9fb77$var$checks = [];
function $b29550e988d9fb77$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$b29550e988d9fb77$var$subtle || !$b29550e988d9fb77$var$subtle.importKey || !$b29550e988d9fb77$var$subtle.deriveBits) return Promise.resolve(false);
    if ($b29550e988d9fb77$var$checks[algo] !== undefined) return $b29550e988d9fb77$var$checks[algo];
    $b29550e988d9fb77$var$ZERO_BUF = $b29550e988d9fb77$var$ZERO_BUF || $b29550e988d9fb77$require$Buffer.alloc(8);
    var prom = $b29550e988d9fb77$var$browserPbkdf2($b29550e988d9fb77$var$ZERO_BUF, $b29550e988d9fb77$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $b29550e988d9fb77$var$checks[algo] = prom;
    return prom;
}
function $b29550e988d9fb77$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $b29550e988d9fb77$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $b29550e988d9fb77$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $b29550e988d9fb77$require$Buffer.from(res);
    });
}
function $b29550e988d9fb77$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $2fFJv.nextTick(function() {
            callback(null, out);
        });
    }, function(e) {
        $2fFJv.nextTick(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (!$b29550e988d9fb77$require$Buffer.isBuffer(password)) password = $b29550e988d9fb77$require$Buffer.from(password, $lniV2);
    if (!$b29550e988d9fb77$require$Buffer.isBuffer(salt)) salt = $b29550e988d9fb77$require$Buffer.from(salt, $lniV2);
    $jS82b(iterations, keylen);
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $b29550e988d9fb77$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') return $2fFJv.nextTick(function() {
        var out;
        try {
            out = $fVtzD(password, salt, iterations, keylen, digest);
        } catch (e) {
            return callback(e);
        }
        callback(null, out);
    });
    $b29550e988d9fb77$var$resolvePromise($b29550e988d9fb77$var$checkNative(algo).then(function(resp) {
        if (resp) return $b29550e988d9fb77$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        else return $fVtzD(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("jS82b", function(module, exports) {
var $e7794aead791fe5d$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $e7794aead791fe5d$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("lniV2", function(module, exports) {
var $f8fa6bde347fdcff$var$defaultEncoding;
var $f8fa6bde347fdcff$var$pVersionMajor;
$f8fa6bde347fdcff$var$defaultEncoding = 'utf-8';
module.exports = $f8fa6bde347fdcff$var$defaultEncoding;

});

parcelRegister("fVtzD", function(module, exports) {

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");

var $jS82b = parcelRequire("jS82b");

var $lniV2 = parcelRequire("lniV2");

var $ijh2q = parcelRequire("ijh2q");
var $b9831e9db81e0e59$require$Buffer = $ijh2q.Buffer;
var $b9831e9db81e0e59$var$ZEROS = $b9831e9db81e0e59$require$Buffer.alloc(128);
var $b9831e9db81e0e59$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $b9831e9db81e0e59$var$Hmac(alg, key, saltLen) {
    var hash = $b9831e9db81e0e59$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $b9831e9db81e0e59$require$Buffer.concat([
        key,
        $b9831e9db81e0e59$var$ZEROS
    ], blocksize);
    var ipad = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + $b9831e9db81e0e59$var$sizes[alg]);
    var opad = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + $b9831e9db81e0e59$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $b9831e9db81e0e59$var$sizes[alg];
}
$b9831e9db81e0e59$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $b9831e9db81e0e59$var$getDigest(alg) {
    function shaFunc(data) {
        return $lqV5D(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $bGrC1;
    if (alg === 'md5') return $6Kk1A;
    return shaFunc;
}
function $b9831e9db81e0e59$var$pbkdf2(password, salt, iterations, keylen, digest) {
    if (!$b9831e9db81e0e59$require$Buffer.isBuffer(password)) password = $b9831e9db81e0e59$require$Buffer.from(password, $lniV2);
    if (!$b9831e9db81e0e59$require$Buffer.isBuffer(salt)) salt = $b9831e9db81e0e59$require$Buffer.from(salt, $lniV2);
    $jS82b(iterations, keylen);
    digest = digest || 'sha1';
    var hmac = new $b9831e9db81e0e59$var$Hmac(digest, password, salt.length);
    var DK = $b9831e9db81e0e59$require$Buffer.allocUnsafe(keylen);
    var block1 = $b9831e9db81e0e59$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $b9831e9db81e0e59$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $b9831e9db81e0e59$var$pbkdf2;

});



parcelRegister("9rGLx", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $6e07cf0dc2bcbbb7$export$bdd223f16383713e, (v) => $6e07cf0dc2bcbbb7$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530, (v) => $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4, (v) => $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0, (v) => $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $6e07cf0dc2bcbbb7$export$12ada9414fbc594c, (v) => $6e07cf0dc2bcbbb7$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a, (v) => $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39, (v) => $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700, (v) => $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370, (v) => $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $6e07cf0dc2bcbbb7$export$58a258485f1e49f6, (v) => $6e07cf0dc2bcbbb7$export$58a258485f1e49f6 = v);
var $6e07cf0dc2bcbbb7$export$bdd223f16383713e;
var $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530;
var $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4;
var $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0;
var $6e07cf0dc2bcbbb7$export$12ada9414fbc594c;
var $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a;
var $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39;
var $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700;
var $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370;
var $6e07cf0dc2bcbbb7$export$58a258485f1e49f6;

var $d9sFZ = parcelRequire("d9sFZ");

var $FyTgm = parcelRequire("FyTgm");

var $A6QqV = parcelRequire("A6QqV");

var $9Xue6 = parcelRequire("9Xue6");

var $2z1oX = parcelRequire("2z1oX");
function $6e07cf0dc2bcbbb7$var$createCipher(suite, password) {
    var keyLen, ivLen;
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) {
        keyLen = $2z1oX[suite].key;
        ivLen = $2z1oX[suite].iv;
    } else if ($9Xue6[suite]) {
        keyLen = $9Xue6[suite].key * 8;
        ivLen = $9Xue6[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, keyLen, ivLen);
    return $6e07cf0dc2bcbbb7$var$createCipheriv(suite, keys.key, keys.iv);
}
function $6e07cf0dc2bcbbb7$var$createDecipher(suite, password) {
    var keyLen, ivLen;
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) {
        keyLen = $2z1oX[suite].key;
        ivLen = $2z1oX[suite].iv;
    } else if ($9Xue6[suite]) {
        keyLen = $9Xue6[suite].key * 8;
        ivLen = $9Xue6[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, keyLen, ivLen);
    return $6e07cf0dc2bcbbb7$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $6e07cf0dc2bcbbb7$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) return $FyTgm.createCipheriv(suite, key, iv);
    else if ($9Xue6[suite]) return new $A6QqV({
        key: key,
        iv: iv,
        mode: suite
    });
    else throw new TypeError('invalid suite type');
}
function $6e07cf0dc2bcbbb7$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) return $FyTgm.createDecipheriv(suite, key, iv);
    else if ($9Xue6[suite]) return new $A6QqV({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    else throw new TypeError('invalid suite type');
}
$6e07cf0dc2bcbbb7$export$bdd223f16383713e = $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530 = $6e07cf0dc2bcbbb7$var$createCipher;
$6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4 = $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0 = $6e07cf0dc2bcbbb7$var$createCipheriv;
$6e07cf0dc2bcbbb7$export$12ada9414fbc594c = $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a = $6e07cf0dc2bcbbb7$var$createDecipher;
$6e07cf0dc2bcbbb7$export$36b6d6ef312eab39 = $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700 = $6e07cf0dc2bcbbb7$var$createDecipheriv;
function $6e07cf0dc2bcbbb7$var$getCiphers() {
    return Object.keys($9Xue6).concat($FyTgm.getCiphers());
}
$6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370 = $6e07cf0dc2bcbbb7$export$58a258485f1e49f6 = $6e07cf0dc2bcbbb7$var$getCiphers;

});
parcelRegister("d9sFZ", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $99325c1fe2a705db$require$Buffer = $ijh2q.Buffer;

var $fVE4x = parcelRequire("fVE4x");
/* eslint-disable camelcase */ function $99325c1fe2a705db$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$99325c1fe2a705db$require$Buffer.isBuffer(password)) password = $99325c1fe2a705db$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$99325c1fe2a705db$require$Buffer.isBuffer(salt)) salt = $99325c1fe2a705db$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $99325c1fe2a705db$require$Buffer.alloc(keyLen);
    var iv = $99325c1fe2a705db$require$Buffer.alloc(ivLen || 0);
    var tmp = $99325c1fe2a705db$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $fVE4x();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $99325c1fe2a705db$var$EVP_BytesToKey;

});
parcelRegister("fVE4x", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $b98b436904fea768$require$Buffer = $aul3P.Buffer;
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $2UmI8 = parcelRequire("2UmI8");
var $b98b436904fea768$var$ARRAY16 = new Array(16);
function $b98b436904fea768$var$MD5() {
    $2UmI8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$lyUaN($b98b436904fea768$var$MD5, $2UmI8);
$b98b436904fea768$var$MD5.prototype._update = function() {
    var M = $b98b436904fea768$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$b98b436904fea768$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $b98b436904fea768$require$Buffer(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $b98b436904fea768$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $b98b436904fea768$var$fnF(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnG(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnH(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnI(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $b98b436904fea768$var$MD5;

});


parcelRegister("FyTgm", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $07cee4f1b56d3371$export$2f64596b8cbf08b4, (v) => $07cee4f1b56d3371$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $07cee4f1b56d3371$export$36b6d6ef312eab39, (v) => $07cee4f1b56d3371$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $07cee4f1b56d3371$export$58a258485f1e49f6, (v) => $07cee4f1b56d3371$export$58a258485f1e49f6 = v);
var $07cee4f1b56d3371$export$bdd223f16383713e;
var $07cee4f1b56d3371$export$26e5786e8ac8e530;
var $07cee4f1b56d3371$export$2f64596b8cbf08b4;
var $07cee4f1b56d3371$export$20533d26f07f1ee0;
var $07cee4f1b56d3371$export$12ada9414fbc594c;
var $07cee4f1b56d3371$export$2ce6d8d0e8b04e1a;
var $07cee4f1b56d3371$export$36b6d6ef312eab39;
var $07cee4f1b56d3371$export$f5e7e39d57cd9700;
var $07cee4f1b56d3371$export$dedd8dc3dc62b370;
var $07cee4f1b56d3371$export$58a258485f1e49f6;

var $6VQvi = parcelRequire("6VQvi");

var $2o6Y4 = parcelRequire("2o6Y4");

var $bv6dQ = parcelRequire("bv6dQ");
function $07cee4f1b56d3371$var$getCiphers() {
    return Object.keys($bv6dQ);
}
$07cee4f1b56d3371$export$bdd223f16383713e = $07cee4f1b56d3371$export$26e5786e8ac8e530 = $6VQvi.createCipher;
$07cee4f1b56d3371$export$2f64596b8cbf08b4 = $07cee4f1b56d3371$export$20533d26f07f1ee0 = $6VQvi.createCipheriv;
$07cee4f1b56d3371$export$12ada9414fbc594c = $07cee4f1b56d3371$export$2ce6d8d0e8b04e1a = $2o6Y4.createDecipher;
$07cee4f1b56d3371$export$36b6d6ef312eab39 = $07cee4f1b56d3371$export$f5e7e39d57cd9700 = $2o6Y4.createDecipheriv;
$07cee4f1b56d3371$export$dedd8dc3dc62b370 = $07cee4f1b56d3371$export$58a258485f1e49f6 = $07cee4f1b56d3371$var$getCiphers;

});
parcelRegister("6VQvi", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $50c0cb1d854268c2$export$2f64596b8cbf08b4, (v) => $50c0cb1d854268c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $50c0cb1d854268c2$export$bdd223f16383713e, (v) => $50c0cb1d854268c2$export$bdd223f16383713e = v);
var $50c0cb1d854268c2$export$2f64596b8cbf08b4;
var $50c0cb1d854268c2$export$bdd223f16383713e;

var $2z1oX = parcelRequire("2z1oX");

var $jEzvF = parcelRequire("jEzvF");

var $ijh2q = parcelRequire("ijh2q");
var $50c0cb1d854268c2$require$Buffer = $ijh2q.Buffer;

var $96zpw = parcelRequire("96zpw");

var $7hBrF = parcelRequire("7hBrF");

var $hPkMt = parcelRequire("hPkMt");

var $d9sFZ = parcelRequire("d9sFZ");

var $lyUaN = parcelRequire("lyUaN");
function $50c0cb1d854268c2$var$Cipher(mode, key, iv) {
    $7hBrF.call(this);
    this._cache = new $50c0cb1d854268c2$var$Splitter();
    this._cipher = new $hPkMt.AES(key);
    this._prev = $50c0cb1d854268c2$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lyUaN($50c0cb1d854268c2$var$Cipher, $7hBrF);
$50c0cb1d854268c2$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $50c0cb1d854268c2$require$Buffer.concat(out);
};
var $50c0cb1d854268c2$var$PADDING = $50c0cb1d854268c2$require$Buffer.alloc(16, 0x10);
$50c0cb1d854268c2$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($50c0cb1d854268c2$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$50c0cb1d854268c2$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $50c0cb1d854268c2$var$Splitter() {
    this.cache = $50c0cb1d854268c2$require$Buffer.allocUnsafe(0);
}
$50c0cb1d854268c2$var$Splitter.prototype.add = function(data) {
    this.cache = $50c0cb1d854268c2$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$50c0cb1d854268c2$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$50c0cb1d854268c2$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $50c0cb1d854268c2$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $50c0cb1d854268c2$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $50c0cb1d854268c2$var$createCipheriv(suite, password, iv) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $50c0cb1d854268c2$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $50c0cb1d854268c2$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $96zpw(config.module, password, iv);
    else if (config.type === 'auth') return new $jEzvF(config.module, password, iv);
    return new $50c0cb1d854268c2$var$Cipher(config.module, password, iv);
}
function $50c0cb1d854268c2$var$createCipher(suite, password) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, config.key, config.iv);
    return $50c0cb1d854268c2$var$createCipheriv(suite, keys.key, keys.iv);
}
$50c0cb1d854268c2$export$2f64596b8cbf08b4 = $50c0cb1d854268c2$var$createCipheriv;
$50c0cb1d854268c2$export$bdd223f16383713e = $50c0cb1d854268c2$var$createCipher;

});
parcelRegister("2z1oX", function(module, exports) {








var $1ddfeffa5f98a92e$var$modeModules = {
    ECB: (parcelRequire("hZIaM")),
    CBC: (parcelRequire("fmope")),
    CFB: (parcelRequire("lG0PJ")),
    CFB8: (parcelRequire("llTPt")),
    CFB1: (parcelRequire("efIgE")),
    OFB: (parcelRequire("1xe0H")),
    CTR: (parcelRequire("dJNe4")),
    GCM: (parcelRequire("dJNe4"))
};

var $bv6dQ = parcelRequire("bv6dQ");
for(var $1ddfeffa5f98a92e$var$key in $bv6dQ)$bv6dQ[$1ddfeffa5f98a92e$var$key].module = $1ddfeffa5f98a92e$var$modeModules[$bv6dQ[$1ddfeffa5f98a92e$var$key].mode];
module.exports = $bv6dQ;

});
parcelRegister("hZIaM", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $d19a65fdbdc127ec$export$5b0f6292f11d1d18, (v) => $d19a65fdbdc127ec$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $d19a65fdbdc127ec$export$e85a0c9a1067c5d3, (v) => $d19a65fdbdc127ec$export$e85a0c9a1067c5d3 = v);
var $d19a65fdbdc127ec$export$5b0f6292f11d1d18;
var $d19a65fdbdc127ec$export$e85a0c9a1067c5d3;
$d19a65fdbdc127ec$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$d19a65fdbdc127ec$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("fmope", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b2ebd79d572bda0f$export$5b0f6292f11d1d18, (v) => $b2ebd79d572bda0f$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $b2ebd79d572bda0f$export$e85a0c9a1067c5d3, (v) => $b2ebd79d572bda0f$export$e85a0c9a1067c5d3 = v);
var $b2ebd79d572bda0f$export$5b0f6292f11d1d18;
var $b2ebd79d572bda0f$export$e85a0c9a1067c5d3;

var $4fAiV = parcelRequire("4fAiV");
$b2ebd79d572bda0f$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $4fAiV(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$b2ebd79d572bda0f$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $4fAiV(out, pad);
};

});
parcelRegister("4fAiV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $3184b96a1696b3ca$require$Buffer = $aul3P.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $3184b96a1696b3ca$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("lG0PJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18, (v) => $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18 = v);
var $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $fc7e2ab8e9fb41d3$require$Buffer = $ijh2q.Buffer;

var $4fAiV = parcelRequire("4fAiV");
function $fc7e2ab8e9fb41d3$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $4fAiV(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $fc7e2ab8e9fb41d3$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $fc7e2ab8e9fb41d3$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $fc7e2ab8e9fb41d3$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $fc7e2ab8e9fb41d3$require$Buffer.concat([
                out,
                $fc7e2ab8e9fb41d3$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $fc7e2ab8e9fb41d3$require$Buffer.concat([
                out,
                $fc7e2ab8e9fb41d3$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("llTPt", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $f8b6dda5639be9f3$export$5b0f6292f11d1d18, (v) => $f8b6dda5639be9f3$export$5b0f6292f11d1d18 = v);
var $f8b6dda5639be9f3$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $f8b6dda5639be9f3$require$Buffer = $ijh2q.Buffer;
function $f8b6dda5639be9f3$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $f8b6dda5639be9f3$require$Buffer.concat([
        self._prev.slice(1),
        $f8b6dda5639be9f3$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$f8b6dda5639be9f3$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $f8b6dda5639be9f3$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $f8b6dda5639be9f3$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("efIgE", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a604cdff2a21876e$export$5b0f6292f11d1d18, (v) => $a604cdff2a21876e$export$5b0f6292f11d1d18 = v);
var $a604cdff2a21876e$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $a604cdff2a21876e$require$Buffer = $ijh2q.Buffer;
function $a604cdff2a21876e$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $a604cdff2a21876e$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $a604cdff2a21876e$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $a604cdff2a21876e$require$Buffer.allocUnsafe(buffer.length);
    buffer = $a604cdff2a21876e$require$Buffer.concat([
        buffer,
        $a604cdff2a21876e$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$a604cdff2a21876e$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $a604cdff2a21876e$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $a604cdff2a21876e$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("1xe0H", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $11e3bdad54d46713$export$5b0f6292f11d1d18, (v) => $11e3bdad54d46713$export$5b0f6292f11d1d18 = v);
var $11e3bdad54d46713$export$5b0f6292f11d1d18;

var $aul3P = parcelRequire("aul3P");
var $11e3bdad54d46713$require$Buffer = $aul3P.Buffer;

var $4fAiV = parcelRequire("4fAiV");
function $11e3bdad54d46713$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$11e3bdad54d46713$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $11e3bdad54d46713$require$Buffer.concat([
        self._cache,
        $11e3bdad54d46713$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $4fAiV(chunk, pad);
};

});

parcelRegister("dJNe4", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a005a98f556409fd$export$5b0f6292f11d1d18, (v) => $a005a98f556409fd$export$5b0f6292f11d1d18 = v);
var $a005a98f556409fd$export$5b0f6292f11d1d18;

var $4fAiV = parcelRequire("4fAiV");

var $ijh2q = parcelRequire("ijh2q");
var $a005a98f556409fd$require$Buffer = $ijh2q.Buffer;

var $lkgcL = parcelRequire("lkgcL");
function $a005a98f556409fd$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $lkgcL(self._prev);
    return out;
}
var $a005a98f556409fd$var$blockSize = 16;
$a005a98f556409fd$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $a005a98f556409fd$var$blockSize);
    var start = self._cache.length;
    self._cache = $a005a98f556409fd$require$Buffer.concat([
        self._cache,
        $a005a98f556409fd$require$Buffer.allocUnsafe(chunkNum * $a005a98f556409fd$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $a005a98f556409fd$var$getBlock(self);
        var offset = start + i * $a005a98f556409fd$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $4fAiV(chunk, pad);
};

});
parcelRegister("lkgcL", function(module, exports) {
function $f868092934fdc144$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $f868092934fdc144$var$incr32;

});


parcelRegister("bv6dQ", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("jEzvF", function(module, exports) {

var $hPkMt = parcelRequire("hPkMt");

var $ijh2q = parcelRequire("ijh2q");
var $e4ed4c3b1c2c6a88$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $lyUaN = parcelRequire("lyUaN");

var $kWTRq = parcelRequire("kWTRq");

var $4fAiV = parcelRequire("4fAiV");

var $lkgcL = parcelRequire("lkgcL");
function $e4ed4c3b1c2c6a88$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $e4ed4c3b1c2c6a88$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $e4ed4c3b1c2c6a88$require$Buffer.concat([
            iv,
            $e4ed4c3b1c2c6a88$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $e4ed4c3b1c2c6a88$require$Buffer.concat([
            iv,
            $e4ed4c3b1c2c6a88$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $kWTRq(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($e4ed4c3b1c2c6a88$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($e4ed4c3b1c2c6a88$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $e4ed4c3b1c2c6a88$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $e4ed4c3b1c2c6a88$require$Buffer.from(self._finID);
    $lkgcL(out);
    return out;
}
function $e4ed4c3b1c2c6a88$var$StreamCipher(mode, key, iv, decrypt) {
    $7hBrF.call(this);
    var h = $e4ed4c3b1c2c6a88$require$Buffer.alloc(4, 0);
    this._cipher = new $hPkMt.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $kWTRq(ck);
    iv = $e4ed4c3b1c2c6a88$var$calcIv(this, iv, ck);
    this._prev = $e4ed4c3b1c2c6a88$require$Buffer.from(iv);
    this._cache = $e4ed4c3b1c2c6a88$require$Buffer.allocUnsafe(0);
    this._secCache = $e4ed4c3b1c2c6a88$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$lyUaN($e4ed4c3b1c2c6a88$var$StreamCipher, $7hBrF);
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $e4ed4c3b1c2c6a88$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $4fAiV(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $e4ed4c3b1c2c6a88$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$e4ed4c3b1c2c6a88$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $e4ed4c3b1c2c6a88$var$StreamCipher;

});
parcelRegister("hPkMt", function(module, exports) {

$parcel$export(module.exports, "AES", () => $cfa751ba4428ce31$export$b80fbe1c3a2b92b5, (v) => $cfa751ba4428ce31$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $cfa751ba4428ce31$export$b80fbe1c3a2b92b5;

var $ijh2q = parcelRequire("ijh2q");
var $cfa751ba4428ce31$require$Buffer = $ijh2q.Buffer;
function $cfa751ba4428ce31$var$asUInt32Array(buf) {
    if (!$cfa751ba4428ce31$require$Buffer.isBuffer(buf)) buf = $cfa751ba4428ce31$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $cfa751ba4428ce31$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $cfa751ba4428ce31$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $cfa751ba4428ce31$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $cfa751ba4428ce31$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $cfa751ba4428ce31$var$AES(key) {
    this._key = $cfa751ba4428ce31$var$asUInt32Array(key);
    this._reset();
}
$cfa751ba4428ce31$var$AES.blockSize = 16;
$cfa751ba4428ce31$var$AES.keySize = 32;
$cfa751ba4428ce31$var$AES.prototype.blockSize = $cfa751ba4428ce31$var$AES.blockSize;
$cfa751ba4428ce31$var$AES.prototype.keySize = $cfa751ba4428ce31$var$AES.keySize;
$cfa751ba4428ce31$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $cfa751ba4428ce31$var$G.SBOX[t >>> 24] << 24 | $cfa751ba4428ce31$var$G.SBOX[t >>> 16 & 0xff] << 16 | $cfa751ba4428ce31$var$G.SBOX[t >>> 8 & 0xff] << 8 | $cfa751ba4428ce31$var$G.SBOX[t & 0xff];
            t ^= $cfa751ba4428ce31$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $cfa751ba4428ce31$var$G.SBOX[t >>> 24] << 24 | $cfa751ba4428ce31$var$G.SBOX[t >>> 16 & 0xff] << 16 | $cfa751ba4428ce31$var$G.SBOX[t >>> 8 & 0xff] << 8 | $cfa751ba4428ce31$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $cfa751ba4428ce31$var$G.INV_SUB_MIX[0][$cfa751ba4428ce31$var$G.SBOX[tt >>> 24]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[1][$cfa751ba4428ce31$var$G.SBOX[tt >>> 16 & 0xff]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[2][$cfa751ba4428ce31$var$G.SBOX[tt >>> 8 & 0xff]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[3][$cfa751ba4428ce31$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$cfa751ba4428ce31$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $cfa751ba4428ce31$var$asUInt32Array(M);
    return $cfa751ba4428ce31$var$cryptBlock(M, this._keySchedule, $cfa751ba4428ce31$var$G.SUB_MIX, $cfa751ba4428ce31$var$G.SBOX, this._nRounds);
};
$cfa751ba4428ce31$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $cfa751ba4428ce31$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$cfa751ba4428ce31$var$AES.prototype.decryptBlock = function(M) {
    M = $cfa751ba4428ce31$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $cfa751ba4428ce31$var$cryptBlock(M, this._invKeySchedule, $cfa751ba4428ce31$var$G.INV_SUB_MIX, $cfa751ba4428ce31$var$G.INV_SBOX, this._nRounds);
    var buf = $cfa751ba4428ce31$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$cfa751ba4428ce31$var$AES.prototype.scrub = function() {
    $cfa751ba4428ce31$var$scrubVec(this._keySchedule);
    $cfa751ba4428ce31$var$scrubVec(this._invKeySchedule);
    $cfa751ba4428ce31$var$scrubVec(this._key);
};
$cfa751ba4428ce31$export$b80fbe1c3a2b92b5 = $cfa751ba4428ce31$var$AES;

});

parcelRegister("kWTRq", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $f4048e34861b21d9$require$Buffer = $ijh2q.Buffer;
var $f4048e34861b21d9$var$ZEROES = $f4048e34861b21d9$require$Buffer.alloc(16, 0);
function $f4048e34861b21d9$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $f4048e34861b21d9$var$fromArray(out) {
    var buf = $f4048e34861b21d9$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $f4048e34861b21d9$var$GHASH(key) {
    this.h = key;
    this.state = $f4048e34861b21d9$require$Buffer.alloc(16, 0);
    this.cache = $f4048e34861b21d9$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$f4048e34861b21d9$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$f4048e34861b21d9$var$GHASH.prototype._multiply = function() {
    var Vi = $f4048e34861b21d9$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $f4048e34861b21d9$var$fromArray(Zi);
};
$f4048e34861b21d9$var$GHASH.prototype.update = function(buf) {
    this.cache = $f4048e34861b21d9$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$f4048e34861b21d9$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($f4048e34861b21d9$require$Buffer.concat([
        this.cache,
        $f4048e34861b21d9$var$ZEROES
    ], 16));
    this.ghash($f4048e34861b21d9$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $f4048e34861b21d9$var$GHASH;

});


parcelRegister("96zpw", function(module, exports) {

var $hPkMt = parcelRequire("hPkMt");

var $ijh2q = parcelRequire("ijh2q");
var $6a10246aaec37d32$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $lyUaN = parcelRequire("lyUaN");
function $6a10246aaec37d32$var$StreamCipher(mode, key, iv, decrypt) {
    $7hBrF.call(this);
    this._cipher = new $hPkMt.AES(key);
    this._prev = $6a10246aaec37d32$require$Buffer.from(iv);
    this._cache = $6a10246aaec37d32$require$Buffer.allocUnsafe(0);
    this._secCache = $6a10246aaec37d32$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$lyUaN($6a10246aaec37d32$var$StreamCipher, $7hBrF);
$6a10246aaec37d32$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$6a10246aaec37d32$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $6a10246aaec37d32$var$StreamCipher;

});


parcelRegister("2o6Y4", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $1bd33a57d41157b4$export$12ada9414fbc594c, (v) => $1bd33a57d41157b4$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $1bd33a57d41157b4$export$36b6d6ef312eab39, (v) => $1bd33a57d41157b4$export$36b6d6ef312eab39 = v);
var $1bd33a57d41157b4$export$12ada9414fbc594c;
var $1bd33a57d41157b4$export$36b6d6ef312eab39;

var $jEzvF = parcelRequire("jEzvF");

var $ijh2q = parcelRequire("ijh2q");
var $1bd33a57d41157b4$require$Buffer = $ijh2q.Buffer;

var $2z1oX = parcelRequire("2z1oX");

var $96zpw = parcelRequire("96zpw");

var $7hBrF = parcelRequire("7hBrF");

var $hPkMt = parcelRequire("hPkMt");

var $d9sFZ = parcelRequire("d9sFZ");

var $lyUaN = parcelRequire("lyUaN");
function $1bd33a57d41157b4$var$Decipher(mode, key, iv) {
    $7hBrF.call(this);
    this._cache = new $1bd33a57d41157b4$var$Splitter();
    this._last = void 0;
    this._cipher = new $hPkMt.AES(key);
    this._prev = $1bd33a57d41157b4$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lyUaN($1bd33a57d41157b4$var$Decipher, $7hBrF);
$1bd33a57d41157b4$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $1bd33a57d41157b4$require$Buffer.concat(out);
};
$1bd33a57d41157b4$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $1bd33a57d41157b4$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$1bd33a57d41157b4$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $1bd33a57d41157b4$var$Splitter() {
    this.cache = $1bd33a57d41157b4$require$Buffer.allocUnsafe(0);
}
$1bd33a57d41157b4$var$Splitter.prototype.add = function(data) {
    this.cache = $1bd33a57d41157b4$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$1bd33a57d41157b4$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$1bd33a57d41157b4$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $1bd33a57d41157b4$var$unpad(last) {
    var padded = last[15];
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $1bd33a57d41157b4$var$createDecipheriv(suite, password, iv) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $1bd33a57d41157b4$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $1bd33a57d41157b4$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $96zpw(config.module, password, iv, true);
    else if (config.type === 'auth') return new $jEzvF(config.module, password, iv, true);
    return new $1bd33a57d41157b4$var$Decipher(config.module, password, iv);
}
function $1bd33a57d41157b4$var$createDecipher(suite, password) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, config.key, config.iv);
    return $1bd33a57d41157b4$var$createDecipheriv(suite, keys.key, keys.iv);
}
$1bd33a57d41157b4$export$12ada9414fbc594c = $1bd33a57d41157b4$var$createDecipher;
$1bd33a57d41157b4$export$36b6d6ef312eab39 = $1bd33a57d41157b4$var$createDecipheriv;

});


parcelRegister("A6QqV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $06c8ac1f3fd38271$require$Buffer = $aul3P.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $dGxNe = parcelRequire("dGxNe");

var $lyUaN = parcelRequire("lyUaN");
var $06c8ac1f3fd38271$var$modes = {
    'des-ede3-cbc': $dGxNe.CBC.instantiate($dGxNe.EDE),
    'des-ede3': $dGxNe.EDE,
    'des-ede-cbc': $dGxNe.CBC.instantiate($dGxNe.EDE),
    'des-ede': $dGxNe.EDE,
    'des-cbc': $dGxNe.CBC.instantiate($dGxNe.DES),
    'des-ecb': $dGxNe.DES
};
$06c8ac1f3fd38271$var$modes.des = $06c8ac1f3fd38271$var$modes['des-cbc'];
$06c8ac1f3fd38271$var$modes.des3 = $06c8ac1f3fd38271$var$modes['des-ede3-cbc'];
module.exports = $06c8ac1f3fd38271$var$DES;
$lyUaN($06c8ac1f3fd38271$var$DES, $7hBrF);
function $06c8ac1f3fd38271$var$DES(opts) {
    $7hBrF.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $06c8ac1f3fd38271$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $06c8ac1f3fd38271$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$06c8ac1f3fd38271$var$DES.prototype._update = function(data) {
    return new $06c8ac1f3fd38271$require$Buffer(this._des.update(data));
};
$06c8ac1f3fd38271$var$DES.prototype._final = function() {
    return new $06c8ac1f3fd38271$require$Buffer(this._des.final());
};

});
parcelRegister("dGxNe", function(module, exports) {

$parcel$export(module.exports, "utils", () => $9f69693503109cbe$export$eab97d15b1788b8d, (v) => $9f69693503109cbe$export$eab97d15b1788b8d = v);
$parcel$export(module.exports, "Cipher", () => $9f69693503109cbe$export$26e5786e8ac8e530, (v) => $9f69693503109cbe$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "DES", () => $9f69693503109cbe$export$cc8859615686b300, (v) => $9f69693503109cbe$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $9f69693503109cbe$export$8ad3f227af08fcc5, (v) => $9f69693503109cbe$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $9f69693503109cbe$export$947646e34766044f, (v) => $9f69693503109cbe$export$947646e34766044f = v);
var $9f69693503109cbe$export$eab97d15b1788b8d;
var $9f69693503109cbe$export$26e5786e8ac8e530;
var $9f69693503109cbe$export$cc8859615686b300;
var $9f69693503109cbe$export$8ad3f227af08fcc5;
var $9f69693503109cbe$export$947646e34766044f;
'use strict';

$9f69693503109cbe$export$eab97d15b1788b8d = (parcelRequire("7GCGw"));

$9f69693503109cbe$export$26e5786e8ac8e530 = (parcelRequire("5sKz7"));

$9f69693503109cbe$export$cc8859615686b300 = (parcelRequire("dZrBr"));

$9f69693503109cbe$export$8ad3f227af08fcc5 = (parcelRequire("gNVcN"));

$9f69693503109cbe$export$947646e34766044f = (parcelRequire("4Xu4n"));

});
parcelRegister("7GCGw", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $598a76a19b3b2ec0$export$cfaef8ed399428b0, (v) => $598a76a19b3b2ec0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $598a76a19b3b2ec0$export$a80c7deaea7cbd80, (v) => $598a76a19b3b2ec0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef, (v) => $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $598a76a19b3b2ec0$export$5dcbef3aa594f567, (v) => $598a76a19b3b2ec0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $598a76a19b3b2ec0$export$5bc8001ca71ed9c5, (v) => $598a76a19b3b2ec0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2, (v) => $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $598a76a19b3b2ec0$export$94c3e544fd062b7f, (v) => $598a76a19b3b2ec0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $598a76a19b3b2ec0$export$9f77e0932fb78f72, (v) => $598a76a19b3b2ec0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $598a76a19b3b2ec0$export$d865ce2836f5927f, (v) => $598a76a19b3b2ec0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $598a76a19b3b2ec0$export$95e62ad65da8b7d2, (v) => $598a76a19b3b2ec0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $598a76a19b3b2ec0$export$209139ff098c441a, (v) => $598a76a19b3b2ec0$export$209139ff098c441a = v);
var $598a76a19b3b2ec0$export$cfaef8ed399428b0;
var $598a76a19b3b2ec0$export$a80c7deaea7cbd80;
var $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef;
var $598a76a19b3b2ec0$export$5dcbef3aa594f567;
var $598a76a19b3b2ec0$export$5bc8001ca71ed9c5;
var $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2;
var $598a76a19b3b2ec0$export$94c3e544fd062b7f;
var $598a76a19b3b2ec0$export$9f77e0932fb78f72;
var $598a76a19b3b2ec0$export$d865ce2836f5927f;
var $598a76a19b3b2ec0$export$95e62ad65da8b7d2;
var $598a76a19b3b2ec0$export$209139ff098c441a;
'use strict';
$598a76a19b3b2ec0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$598a76a19b3b2ec0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$598a76a19b3b2ec0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $598a76a19b3b2ec0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$598a76a19b3b2ec0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $598a76a19b3b2ec0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $598a76a19b3b2ec0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $598a76a19b3b2ec0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $598a76a19b3b2ec0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $598a76a19b3b2ec0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$598a76a19b3b2ec0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $598a76a19b3b2ec0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $598a76a19b3b2ec0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $598a76a19b3b2ec0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$598a76a19b3b2ec0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $598a76a19b3b2ec0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $598a76a19b3b2ec0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$598a76a19b3b2ec0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("5sKz7", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");
function $3fa3b03628a4362d$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $3fa3b03628a4362d$var$Cipher;
$3fa3b03628a4362d$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$3fa3b03628a4362d$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$3fa3b03628a4362d$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$3fa3b03628a4362d$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$3fa3b03628a4362d$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$3fa3b03628a4362d$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$3fa3b03628a4362d$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$3fa3b03628a4362d$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aOIMZ.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("aOIMZ", function(module, exports) {
module.exports = $7e015117bb8d6cde$var$assert;
function $7e015117bb8d6cde$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$7e015117bb8d6cde$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("dZrBr", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");

var $dGxNe = parcelRequire("dGxNe");
var $a2f6623cd6d516cb$var$utils = $dGxNe.utils;
var $a2f6623cd6d516cb$var$Cipher = $dGxNe.Cipher;
function $a2f6623cd6d516cb$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $a2f6623cd6d516cb$var$DES(options) {
    $a2f6623cd6d516cb$var$Cipher.call(this, options);
    var state = new $a2f6623cd6d516cb$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$lyUaN($a2f6623cd6d516cb$var$DES, $a2f6623cd6d516cb$var$Cipher);
module.exports = $a2f6623cd6d516cb$var$DES;
$a2f6623cd6d516cb$var$DES.create = function create(options) {
    return new $a2f6623cd6d516cb$var$DES(options);
};
var $a2f6623cd6d516cb$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$a2f6623cd6d516cb$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aOIMZ.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $a2f6623cd6d516cb$var$utils.readUInt32BE(key, 0);
    var kR = $a2f6623cd6d516cb$var$utils.readUInt32BE(key, 4);
    $a2f6623cd6d516cb$var$utils.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $a2f6623cd6d516cb$var$shiftTable[i >>> 1];
        kL = $a2f6623cd6d516cb$var$utils.r28shl(kL, shift);
        kR = $a2f6623cd6d516cb$var$utils.r28shl(kR, shift);
        $a2f6623cd6d516cb$var$utils.pc2(kL, kR, state.keys, i);
    }
};
$a2f6623cd6d516cb$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $a2f6623cd6d516cb$var$utils.readUInt32BE(inp, inOff);
    var r = $a2f6623cd6d516cb$var$utils.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $a2f6623cd6d516cb$var$utils.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $a2f6623cd6d516cb$var$utils.writeUInt32BE(out, l, outOff);
    $a2f6623cd6d516cb$var$utils.writeUInt32BE(out, r, outOff + 4);
};
$a2f6623cd6d516cb$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$a2f6623cd6d516cb$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aOIMZ.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$a2f6623cd6d516cb$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $a2f6623cd6d516cb$var$utils.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $a2f6623cd6d516cb$var$utils.substitute(keyL, keyR);
        var f = $a2f6623cd6d516cb$var$utils.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $a2f6623cd6d516cb$var$utils.rip(r, l, out, off);
};
$a2f6623cd6d516cb$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $a2f6623cd6d516cb$var$utils.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $a2f6623cd6d516cb$var$utils.substitute(keyL, keyR);
        var f = $a2f6623cd6d516cb$var$utils.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $a2f6623cd6d516cb$var$utils.rip(l, r, out, off);
};

});

parcelRegister("gNVcN", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $c3bd98be17497432$export$f9bb8d20ccc7477a, (v) => $c3bd98be17497432$export$f9bb8d20ccc7477a = v);
var $c3bd98be17497432$export$f9bb8d20ccc7477a;
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");
var $c3bd98be17497432$var$proto = {};
function $c3bd98be17497432$var$CBCState(iv) {
    $aOIMZ.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $c3bd98be17497432$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $lyUaN(CBC, Base);
    var keys = Object.keys($c3bd98be17497432$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $c3bd98be17497432$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$c3bd98be17497432$export$f9bb8d20ccc7477a = $c3bd98be17497432$var$instantiate;
$c3bd98be17497432$var$proto._cbcInit = function _cbcInit() {
    var state = new $c3bd98be17497432$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$c3bd98be17497432$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("4Xu4n", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");

var $dGxNe = parcelRequire("dGxNe");
var $39c3ff54fa87a964$var$Cipher = $dGxNe.Cipher;
var $39c3ff54fa87a964$var$DES = $dGxNe.DES;
function $39c3ff54fa87a964$var$EDEState(type, key) {
    $aOIMZ.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k1
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k2
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k3
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k2
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $39c3ff54fa87a964$var$EDE(options) {
    $39c3ff54fa87a964$var$Cipher.call(this, options);
    var state = new $39c3ff54fa87a964$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$lyUaN($39c3ff54fa87a964$var$EDE, $39c3ff54fa87a964$var$Cipher);
module.exports = $39c3ff54fa87a964$var$EDE;
$39c3ff54fa87a964$var$EDE.create = function create(options) {
    return new $39c3ff54fa87a964$var$EDE(options);
};
$39c3ff54fa87a964$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$39c3ff54fa87a964$var$EDE.prototype._pad = $39c3ff54fa87a964$var$DES.prototype._pad;
$39c3ff54fa87a964$var$EDE.prototype._unpad = $39c3ff54fa87a964$var$DES.prototype._unpad;

});



parcelRegister("9Xue6", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $7401121727af84fc$export$116f8a5cee447347, (v) => $7401121727af84fc$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $7401121727af84fc$export$7483c4066bfb7ae9, (v) => $7401121727af84fc$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $7401121727af84fc$export$e7a565d2e588bb06, (v) => $7401121727af84fc$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $7401121727af84fc$export$aaa2f54a426f3eb8, (v) => $7401121727af84fc$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $7401121727af84fc$export$eba20568dde4ada, (v) => $7401121727af84fc$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $7401121727af84fc$export$d3b5e5996938f5ae, (v) => $7401121727af84fc$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $7401121727af84fc$export$57c08356130bc99b, (v) => $7401121727af84fc$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $7401121727af84fc$export$c7169791d5c1e65d, (v) => $7401121727af84fc$export$c7169791d5c1e65d = v);
var $7401121727af84fc$export$116f8a5cee447347;
var $7401121727af84fc$export$7483c4066bfb7ae9;
var $7401121727af84fc$export$e7a565d2e588bb06;
var $7401121727af84fc$export$aaa2f54a426f3eb8;
var $7401121727af84fc$export$eba20568dde4ada;
var $7401121727af84fc$export$d3b5e5996938f5ae;
var $7401121727af84fc$export$57c08356130bc99b;
var $7401121727af84fc$export$c7169791d5c1e65d;
$7401121727af84fc$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$7401121727af84fc$export$7483c4066bfb7ae9 = $7401121727af84fc$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$7401121727af84fc$export$aaa2f54a426f3eb8 = $7401121727af84fc$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$7401121727af84fc$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$7401121727af84fc$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$7401121727af84fc$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("fPWK2", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $b8792f4d453e7272$export$971862a2fcb1bb40, (v) => $b8792f4d453e7272$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $b8792f4d453e7272$export$c6ff6a88acbeaf40, (v) => $b8792f4d453e7272$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $b8792f4d453e7272$export$fdc27893e98845cc, (v) => $b8792f4d453e7272$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $b8792f4d453e7272$export$6671fb9a1323bed, (v) => $b8792f4d453e7272$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $b8792f4d453e7272$export$d74daf141a551db, (v) => $b8792f4d453e7272$export$d74daf141a551db = v);
var $b8792f4d453e7272$export$971862a2fcb1bb40;
var $b8792f4d453e7272$export$c6ff6a88acbeaf40;
var $b8792f4d453e7272$export$fdc27893e98845cc;
var $b8792f4d453e7272$export$6671fb9a1323bed;
var $b8792f4d453e7272$export$d74daf141a551db;

var $aul3P = parcelRequire("aul3P");
var $b8792f4d453e7272$require$Buffer = $aul3P.Buffer;

var $5Imi1 = parcelRequire("5Imi1");

var $aBb26 = parcelRequire("aBb26");

var $4ybg5 = parcelRequire("4ybg5");
function $b8792f4d453e7272$var$getDiffieHellman(mod) {
    var prime = new $b8792f4d453e7272$require$Buffer($aBb26[mod].prime, 'hex');
    var gen = new $b8792f4d453e7272$require$Buffer($aBb26[mod].gen, 'hex');
    return new $4ybg5(prime, gen);
}
var $b8792f4d453e7272$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $b8792f4d453e7272$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($b8792f4d453e7272$require$Buffer.isBuffer(enc) || $b8792f4d453e7272$var$ENCODINGS[enc] === undefined) return $b8792f4d453e7272$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $b8792f4d453e7272$require$Buffer([
        2
    ]);
    if (!$b8792f4d453e7272$require$Buffer.isBuffer(generator)) generator = new $b8792f4d453e7272$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $4ybg5($5Imi1(prime, generator), generator, true);
    if (!$b8792f4d453e7272$require$Buffer.isBuffer(prime)) prime = new $b8792f4d453e7272$require$Buffer(prime, enc);
    return new $4ybg5(prime, generator, true);
}
$b8792f4d453e7272$export$971862a2fcb1bb40 = $b8792f4d453e7272$export$c6ff6a88acbeaf40 = $b8792f4d453e7272$export$fdc27893e98845cc = $b8792f4d453e7272$var$getDiffieHellman;
$b8792f4d453e7272$export$6671fb9a1323bed = $b8792f4d453e7272$export$d74daf141a551db = $b8792f4d453e7272$var$createDiffieHellman;

});
parcelRegister("5Imi1", function(module, exports) {

var $ugwNY = parcelRequire("ugwNY");
module.exports = $42925a0e7985bf7e$var$findPrime;
$42925a0e7985bf7e$var$findPrime.simpleSieve = $42925a0e7985bf7e$var$simpleSieve;
$42925a0e7985bf7e$var$findPrime.fermatTest = $42925a0e7985bf7e$var$fermatTest;

var $61SlE = parcelRequire("61SlE");
var $42925a0e7985bf7e$var$TWENTYFOUR = new $61SlE(24);

var $4qHnY = parcelRequire("4qHnY");
var $42925a0e7985bf7e$var$millerRabin = new $4qHnY();
var $42925a0e7985bf7e$var$ONE = new $61SlE(1);
var $42925a0e7985bf7e$var$TWO = new $61SlE(2);
var $42925a0e7985bf7e$var$FIVE = new $61SlE(5);
var $42925a0e7985bf7e$var$SIXTEEN = new $61SlE(16);
var $42925a0e7985bf7e$var$EIGHT = new $61SlE(8);
var $42925a0e7985bf7e$var$TEN = new $61SlE(10);
var $42925a0e7985bf7e$var$THREE = new $61SlE(3);
var $42925a0e7985bf7e$var$SEVEN = new $61SlE(7);
var $42925a0e7985bf7e$var$ELEVEN = new $61SlE(11);
var $42925a0e7985bf7e$var$FOUR = new $61SlE(4);
var $42925a0e7985bf7e$var$TWELVE = new $61SlE(12);
var $42925a0e7985bf7e$var$primes = null;
function $42925a0e7985bf7e$var$_getPrimes() {
    if ($42925a0e7985bf7e$var$primes !== null) return $42925a0e7985bf7e$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $42925a0e7985bf7e$var$primes = res;
    return res;
}
function $42925a0e7985bf7e$var$simpleSieve(p) {
    var primes = $42925a0e7985bf7e$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $42925a0e7985bf7e$var$fermatTest(p) {
    var red = $61SlE.mont(p);
    return $42925a0e7985bf7e$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $42925a0e7985bf7e$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $61SlE([
            0x8c,
            0x7b
        ]);
        else return new $61SlE([
            0x8c,
            0x27
        ]);
    }
    gen = new $61SlE(gen);
    var num, n2;
    while(true){
        num = new $61SlE($ugwNY(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($42925a0e7985bf7e$var$ONE);
        if (!num.testn(1)) num.iadd($42925a0e7985bf7e$var$TWO);
        if (!gen.cmp($42925a0e7985bf7e$var$TWO)) while(num.mod($42925a0e7985bf7e$var$TWENTYFOUR).cmp($42925a0e7985bf7e$var$ELEVEN))num.iadd($42925a0e7985bf7e$var$FOUR);
        else if (!gen.cmp($42925a0e7985bf7e$var$FIVE)) while(num.mod($42925a0e7985bf7e$var$TEN).cmp($42925a0e7985bf7e$var$THREE))num.iadd($42925a0e7985bf7e$var$FOUR);
        n2 = num.shrn(1);
        if ($42925a0e7985bf7e$var$simpleSieve(n2) && $42925a0e7985bf7e$var$simpleSieve(num) && $42925a0e7985bf7e$var$fermatTest(n2) && $42925a0e7985bf7e$var$fermatTest(num) && $42925a0e7985bf7e$var$millerRabin.test(n2) && $42925a0e7985bf7e$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("61SlE", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("jFleb")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === '-') this.negative = 1;
        this.strip();
        if (endian !== 'le') return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4qHnY", function(module, exports) {

var $61SlE = parcelRequire("61SlE");

var $7EB5r = parcelRequire("7EB5r");
function $339b3e9b9b7e3050$var$MillerRabin(rand) {
    this.rand = rand || new $7EB5r.Rand();
}
module.exports = $339b3e9b9b7e3050$var$MillerRabin;
$339b3e9b9b7e3050$var$MillerRabin.create = function create(rand) {
    return new $339b3e9b9b7e3050$var$MillerRabin(rand);
};
$339b3e9b9b7e3050$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $61SlE(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$339b3e9b9b7e3050$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$339b3e9b9b7e3050$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $61SlE.mont(n);
    var rone = new $61SlE(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $61SlE(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$339b3e9b9b7e3050$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $61SlE.mont(n);
    var rone = new $61SlE(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $61SlE(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7EB5r", function(module, exports) {
var $5929097e933a50fa$var$r;
module.exports = function rand(len) {
    if (!$5929097e933a50fa$var$r) $5929097e933a50fa$var$r = new $5929097e933a50fa$var$Rand(null);
    return $5929097e933a50fa$var$r.generate(len);
};
function $5929097e933a50fa$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5929097e933a50fa$var$Rand;
$5929097e933a50fa$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5929097e933a50fa$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5929097e933a50fa$var$crypto = (parcelRequire("jFleb"));
    if (typeof $5929097e933a50fa$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        return $5929097e933a50fa$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("aBb26", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("4ybg5", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $3503121994d90ae3$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $4qHnY = parcelRequire("4qHnY");
var $3503121994d90ae3$var$millerRabin = new $4qHnY();
var $3503121994d90ae3$var$TWENTYFOUR = new $61SlE(24);
var $3503121994d90ae3$var$ELEVEN = new $61SlE(11);
var $3503121994d90ae3$var$TEN = new $61SlE(10);
var $3503121994d90ae3$var$THREE = new $61SlE(3);
var $3503121994d90ae3$var$SEVEN = new $61SlE(7);

var $5Imi1 = parcelRequire("5Imi1");

var $ugwNY = parcelRequire("ugwNY");
module.exports = $3503121994d90ae3$var$DH;
function $3503121994d90ae3$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(pub)) pub = new $3503121994d90ae3$require$Buffer(pub, enc);
    this._pub = new $61SlE(pub);
    return this;
}
function $3503121994d90ae3$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(priv)) priv = new $3503121994d90ae3$require$Buffer(priv, enc);
    this._priv = new $61SlE(priv);
    return this;
}
var $3503121994d90ae3$var$primeCache = {};
function $3503121994d90ae3$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $3503121994d90ae3$var$primeCache) return $3503121994d90ae3$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$5Imi1.simpleSieve || !$5Imi1.fermatTest(prime) || !$3503121994d90ae3$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $3503121994d90ae3$var$primeCache[hex] = error;
        return error;
    }
    if (!$3503121994d90ae3$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($3503121994d90ae3$var$TWENTYFOUR).cmp($3503121994d90ae3$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($3503121994d90ae3$var$TEN);
            if (rem.cmp($3503121994d90ae3$var$THREE) && rem.cmp($3503121994d90ae3$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $3503121994d90ae3$var$primeCache[hex] = error;
    return error;
}
function $3503121994d90ae3$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $61SlE(prime);
    this._prime = $61SlE.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $3503121994d90ae3$var$setPublicKey;
        this.setPrivateKey = $3503121994d90ae3$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($3503121994d90ae3$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $3503121994d90ae3$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$3503121994d90ae3$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $61SlE($ugwNY(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$3503121994d90ae3$var$DH.prototype.computeSecret = function(other) {
    other = new $61SlE(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $3503121994d90ae3$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $3503121994d90ae3$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $3503121994d90ae3$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$3503121994d90ae3$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._pub, enc);
};
$3503121994d90ae3$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._priv, enc);
};
$3503121994d90ae3$var$DH.prototype.getPrime = function(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this.__prime, enc);
};
$3503121994d90ae3$var$DH.prototype.getGenerator = function(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._gen, enc);
};
$3503121994d90ae3$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(gen)) gen = new $3503121994d90ae3$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $61SlE(gen);
    return this;
};
function $3503121994d90ae3$var$formatReturnValue(bn, enc) {
    var buf = new $3503121994d90ae3$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("cQURD", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $95b6735c8554685b$require$Buffer = $aul3P.Buffer;

var $cnL2y = parcelRequire("cnL2y");

var $anz8L = parcelRequire("anz8L");

var $lyUaN = parcelRequire("lyUaN");

var $9WtmX = parcelRequire("9WtmX");

var $bdxL8 = parcelRequire("bdxL8");

var $5x0OM = parcelRequire("5x0OM");
Object.keys($5x0OM).forEach(function(key) {
    $5x0OM[key].id = new $95b6735c8554685b$require$Buffer($5x0OM[key].id, 'hex');
    $5x0OM[key.toLowerCase()] = $5x0OM[key];
});
function $95b6735c8554685b$var$Sign(algorithm) {
    $anz8L.Writable.call(this);
    var data = $5x0OM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $cnL2y(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lyUaN($95b6735c8554685b$var$Sign, $anz8L.Writable);
$95b6735c8554685b$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$95b6735c8554685b$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = new $95b6735c8554685b$require$Buffer(data, enc);
    this._hash.update(data);
    return this;
};
$95b6735c8554685b$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $9WtmX(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $95b6735c8554685b$var$Verify(algorithm) {
    $anz8L.Writable.call(this);
    var data = $5x0OM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $cnL2y(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lyUaN($95b6735c8554685b$var$Verify, $anz8L.Writable);
$95b6735c8554685b$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$95b6735c8554685b$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = new $95b6735c8554685b$require$Buffer(data, enc);
    this._hash.update(data);
    return this;
};
$95b6735c8554685b$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === 'string') sig = new $95b6735c8554685b$require$Buffer(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $bdxL8(sig, hash, key, this._signType, this._tag);
};
function $95b6735c8554685b$var$createSign(algorithm) {
    return new $95b6735c8554685b$var$Sign(algorithm);
}
function $95b6735c8554685b$var$createVerify(algorithm) {
    return new $95b6735c8554685b$var$Verify(algorithm);
}
module.exports = {
    Sign: $95b6735c8554685b$var$createSign,
    Verify: $95b6735c8554685b$var$createVerify,
    createSign: $95b6735c8554685b$var$createSign,
    createVerify: $95b6735c8554685b$var$createVerify
};

});
parcelRegister("9WtmX", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $aul3P = parcelRequire("aul3P");
var $73d04ff15cc0067d$require$Buffer = $aul3P.Buffer;

var $jPoqK = parcelRequire("jPoqK");

var $kFMzy = parcelRequire("kFMzy");

var $6nTxf = parcelRequire("6nTxf");
var $73d04ff15cc0067d$require$EC = $6nTxf.ec;

var $61SlE = parcelRequire("61SlE");

var $lXsfV = parcelRequire("lXsfV");

var $fyXn0 = parcelRequire("fyXn0");
function $73d04ff15cc0067d$var$sign(hash, key, hashType, signType, tag) {
    var priv = $lXsfV(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $73d04ff15cc0067d$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $73d04ff15cc0067d$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    }
    hash = $73d04ff15cc0067d$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $kFMzy(pad, priv);
    return out;
}
function $73d04ff15cc0067d$var$ecSign(hash, priv) {
    var curveId = $fyXn0[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $73d04ff15cc0067d$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return new $73d04ff15cc0067d$require$Buffer(out.toDER());
}
function $73d04ff15cc0067d$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $61SlE(0);
    var k;
    var H = $73d04ff15cc0067d$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $73d04ff15cc0067d$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $73d04ff15cc0067d$var$makeKey(q, kv, algo);
        r = $73d04ff15cc0067d$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $61SlE(0);
        }
    }
    return $73d04ff15cc0067d$var$toDER(r, s);
}
function $73d04ff15cc0067d$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return new $73d04ff15cc0067d$require$Buffer(res);
}
function $73d04ff15cc0067d$var$getKey(x, q, hash, algo) {
    x = new $73d04ff15cc0067d$require$Buffer(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = new $73d04ff15cc0067d$require$Buffer(q.byteLength() - x.length);
        zeros.fill(0);
        x = $73d04ff15cc0067d$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $73d04ff15cc0067d$var$bits2octets(hash, q);
    var v = new $73d04ff15cc0067d$require$Buffer(hlen);
    v.fill(1);
    var k = new $73d04ff15cc0067d$require$Buffer(hlen);
    k.fill(0);
    k = $jPoqK(algo, k).update(v).update(new $73d04ff15cc0067d$require$Buffer([
        0
    ])).update(x).update(hbits).digest();
    v = $jPoqK(algo, k).update(v).digest();
    k = $jPoqK(algo, k).update(v).update(new $73d04ff15cc0067d$require$Buffer([
        1
    ])).update(x).update(hbits).digest();
    v = $jPoqK(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $73d04ff15cc0067d$var$bits2int(obits, q) {
    var bits = new $61SlE(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $73d04ff15cc0067d$var$bits2octets(bits, q) {
    bits = $73d04ff15cc0067d$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = new $73d04ff15cc0067d$require$Buffer(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = new $73d04ff15cc0067d$require$Buffer(q.byteLength() - out.length);
        zeros.fill(0);
        out = $73d04ff15cc0067d$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $73d04ff15cc0067d$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = new $73d04ff15cc0067d$require$Buffer(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $jPoqK(algo, kv.k).update(kv.v).digest();
            t = $73d04ff15cc0067d$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $73d04ff15cc0067d$var$bits2int(t, q);
        kv.k = $jPoqK(algo, kv.k).update(kv.v).update(new $73d04ff15cc0067d$require$Buffer([
            0
        ])).digest();
        kv.v = $jPoqK(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $73d04ff15cc0067d$var$makeR(g, k, p, q) {
    return g.toRed($61SlE.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $73d04ff15cc0067d$var$sign;
module.exports.getKey = $73d04ff15cc0067d$var$getKey;
module.exports.makeKey = $73d04ff15cc0067d$var$makeKey;

});
parcelRegister("kFMzy", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $f0cd5073c174da16$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $ugwNY = parcelRequire("ugwNY");
module.exports = $f0cd5073c174da16$var$crt;
function $f0cd5073c174da16$var$blind(priv) {
    var r = $f0cd5073c174da16$var$getr(priv);
    var blinder = r.toRed($61SlE.mont(priv.modulus)).redPow(new $61SlE(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $f0cd5073c174da16$var$crt(msg, priv) {
    var blinds = $f0cd5073c174da16$var$blind(priv);
    var len = priv.modulus.byteLength();
    var mod = $61SlE.mont(priv.modulus);
    var blinded = new $61SlE(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($61SlE.mont(priv.prime1));
    var c2 = blinded.toRed($61SlE.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1);
    var m2 = c2.redPow(priv.exponent2);
    m1 = m1.fromRed();
    m2 = m2.fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p);
    h.imul(q);
    m2.iadd(h);
    return new $f0cd5073c174da16$require$Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
$f0cd5073c174da16$var$crt.getr = $f0cd5073c174da16$var$getr;
function $f0cd5073c174da16$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r = new $61SlE($ugwNY(len));
    while(r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))r = new $61SlE($ugwNY(len));
    return r;
}

});

parcelRegister("6nTxf", function(module, exports) {
'use strict';
var $4a5ff836d3f5a0fb$var$elliptic = module.exports;

$4a5ff836d3f5a0fb$var$elliptic.version = (parcelRequire("aeDj6")).version;

$4a5ff836d3f5a0fb$var$elliptic.utils = (parcelRequire("8qPu3"));

$4a5ff836d3f5a0fb$var$elliptic.rand = (parcelRequire("7EB5r"));

$4a5ff836d3f5a0fb$var$elliptic.curve = (parcelRequire("g9z1u"));

$4a5ff836d3f5a0fb$var$elliptic.curves = (parcelRequire("8XT4W"));

// Protocols
$4a5ff836d3f5a0fb$var$elliptic.ec = (parcelRequire("h6mem"));

$4a5ff836d3f5a0fb$var$elliptic.eddsa = (parcelRequire("j0pZO"));

});
parcelRegister("aeDj6", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.4.0\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"jscs\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"jshint\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"lint\":\"npm run jscs && npm run jshint\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^1.4.3\",\"coveralls\":\"^2.11.3\",\"grunt\":\"^0.4.5\",\"grunt-browserify\":\"^5.0.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-connect\":\"^1.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^1.0.1\",\"grunt-mocha-istanbul\":\"^3.0.1\",\"grunt-saucelabs\":\"^8.6.2\",\"istanbul\":\"^0.4.2\",\"jscs\":\"^2.9.0\",\"jshint\":\"^2.6.0\",\"mocha\":\"^2.1.0\"},\"dependencies\":{\"bn.js\":\"^4.4.0\",\"brorand\":\"^1.0.1\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.0\",\"inherits\":\"^2.0.1\",\"minimalistic-assert\":\"^1.0.0\",\"minimalistic-crypto-utils\":\"^1.0.0\"}}");

});

parcelRegister("8qPu3", function(module, exports) {
'use strict';
var $6238b007fc990f16$var$utils = module.exports;

var $61SlE = parcelRequire("61SlE");

var $aOIMZ = parcelRequire("aOIMZ");

var $9a0Ug = parcelRequire("9a0Ug");
$6238b007fc990f16$var$utils.assert = $aOIMZ;
$6238b007fc990f16$var$utils.toArray = $9a0Ug.toArray;
$6238b007fc990f16$var$utils.zero2 = $9a0Ug.zero2;
$6238b007fc990f16$var$utils.toHex = $9a0Ug.toHex;
$6238b007fc990f16$var$utils.encode = $9a0Ug.encode;
// Represent num in a w-NAF form
function $6238b007fc990f16$var$getNAF(num, w) {
    var naf = [];
    var ws = 1 << w + 1;
    var k = num.clone();
    while(k.cmpn(1) >= 0){
        var z;
        if (k.isOdd()) {
            var mod = k.andln(ws - 1);
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf.push(z);
        // Optimization, shift by word if possible
        var shift = k.cmpn(0) !== 0 && k.andln(ws - 1) === 0 ? w + 1 : 1;
        for(var i = 1; i < shift; i++)naf.push(0);
        k.iushrn(shift);
    }
    return naf;
}
$6238b007fc990f16$var$utils.getNAF = $6238b007fc990f16$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $6238b007fc990f16$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            var m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            var m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$6238b007fc990f16$var$utils.getJSF = $6238b007fc990f16$var$getJSF;
function $6238b007fc990f16$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$6238b007fc990f16$var$utils.cachedProperty = $6238b007fc990f16$var$cachedProperty;
function $6238b007fc990f16$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $6238b007fc990f16$var$utils.toArray(bytes, 'hex') : bytes;
}
$6238b007fc990f16$var$utils.parseBytes = $6238b007fc990f16$var$parseBytes;
function $6238b007fc990f16$var$intFromLE(bytes) {
    return new $61SlE(bytes, 'hex', 'le');
}
$6238b007fc990f16$var$utils.intFromLE = $6238b007fc990f16$var$intFromLE;

});
parcelRegister("9a0Ug", function(module, exports) {
'use strict';
var $6ab5c03eb880a4ce$var$utils = module.exports;
function $6ab5c03eb880a4ce$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$6ab5c03eb880a4ce$var$utils.toArray = $6ab5c03eb880a4ce$var$toArray;
function $6ab5c03eb880a4ce$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$6ab5c03eb880a4ce$var$utils.zero2 = $6ab5c03eb880a4ce$var$zero2;
function $6ab5c03eb880a4ce$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $6ab5c03eb880a4ce$var$zero2(msg[i].toString(16));
    return res;
}
$6ab5c03eb880a4ce$var$utils.toHex = $6ab5c03eb880a4ce$var$toHex;
$6ab5c03eb880a4ce$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $6ab5c03eb880a4ce$var$toHex(arr);
    else return arr;
};

});


parcelRegister("g9z1u", function(module, exports) {
'use strict';
var $bc28a777bbaba7c9$var$curve = module.exports;

$bc28a777bbaba7c9$var$curve.base = (parcelRequire("7FXqf"));

$bc28a777bbaba7c9$var$curve.short = (parcelRequire("o1Os9"));

$bc28a777bbaba7c9$var$curve.mont = (parcelRequire("hap7r"));

$bc28a777bbaba7c9$var$curve.edwards = (parcelRequire("3Oe4N"));

});
parcelRegister("7FXqf", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $596a74c8a0293328$var$utils = $6nTxf.utils;
var $596a74c8a0293328$var$getNAF = $596a74c8a0293328$var$utils.getNAF;
var $596a74c8a0293328$var$getJSF = $596a74c8a0293328$var$utils.getJSF;
var $596a74c8a0293328$var$assert = $596a74c8a0293328$var$utils.assert;
function $596a74c8a0293328$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $61SlE(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $61SlE.red(conf.prime) : $61SlE.mont(this.p);
    // Useful for many curves
    this.zero = new $61SlE(0).toRed(this.red);
    this.one = new $61SlE(1).toRed(this.red);
    this.two = new $61SlE(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $61SlE(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $596a74c8a0293328$var$BaseCurve;
$596a74c8a0293328$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $596a74c8a0293328$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $596a74c8a0293328$var$getNAF(k, 1);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    for(var j = 0; j < naf.length; j += doubles.step){
        var nafW = 0;
        for(var k = j + doubles.step - 1; k >= j; k--)nafW = (nafW << 1) + naf[k];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(var j = 0; j < repr.length; j++){
            var nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$596a74c8a0293328$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $596a74c8a0293328$var$getNAF(k, w);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var k = 0; i >= 0 && naf[i] === 0; i--)k++;
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        var z = naf[i];
        $596a74c8a0293328$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$596a74c8a0293328$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    for(var i = 0; i < len; i++){
        var p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(var i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $596a74c8a0293328$var$getNAF(coeffs[a], wndWidth[a]);
            naf[b] = $596a74c8a0293328$var$getNAF(coeffs[b], wndWidth[b]);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3 /* 1 1 */ 
        ];
        var jsf = $596a74c8a0293328$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(var j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(var i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(var j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(var j = 0; j < len; j++){
            var z = tmp[j];
            var p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(var i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $596a74c8a0293328$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$596a74c8a0293328$var$BaseCurve.BasePoint = $596a74c8a0293328$var$BasePoint;
$596a74c8a0293328$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$596a74c8a0293328$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $596a74c8a0293328$var$utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $596a74c8a0293328$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $596a74c8a0293328$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$596a74c8a0293328$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$596a74c8a0293328$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$596a74c8a0293328$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $596a74c8a0293328$var$utils.encode(this._encode(compact), enc);
};
$596a74c8a0293328$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$596a74c8a0293328$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$596a74c8a0293328$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$596a74c8a0293328$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$596a74c8a0293328$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$596a74c8a0293328$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("o1Os9", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $0483a5fb6d44f11e$var$Base = $g9z1u.base;
var $0483a5fb6d44f11e$var$assert = $6nTxf.utils.assert;
function $0483a5fb6d44f11e$var$ShortCurve(conf) {
    $0483a5fb6d44f11e$var$Base.call(this, 'short', conf);
    this.a = new $61SlE(conf.a, 16).toRed(this.red);
    this.b = new $61SlE(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$lyUaN($0483a5fb6d44f11e$var$ShortCurve, $0483a5fb6d44f11e$var$Base);
module.exports = $0483a5fb6d44f11e$var$ShortCurve;
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $61SlE(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $61SlE(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $0483a5fb6d44f11e$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $61SlE(vec.a, 16),
            b: new $61SlE(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $61SlE.mont(num);
    var tinv = new $61SlE(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $61SlE(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $61SlE(1);
    var y1 = new $61SlE(0);
    var x2 = new $61SlE(0);
    var y2 = new $61SlE(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $61SlE(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $0483a5fb6d44f11e$var$Point(curve, x, y, isRed) {
    $0483a5fb6d44f11e$var$Base.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$lyUaN($0483a5fb6d44f11e$var$Point, $0483a5fb6d44f11e$var$Base.BasePoint);
$0483a5fb6d44f11e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $0483a5fb6d44f11e$var$Point(this, x, y, isRed);
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $0483a5fb6d44f11e$var$Point.fromJSON(this, obj, red);
};
$0483a5fb6d44f11e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$0483a5fb6d44f11e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$0483a5fb6d44f11e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$0483a5fb6d44f11e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$0483a5fb6d44f11e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$0483a5fb6d44f11e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0483a5fb6d44f11e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0483a5fb6d44f11e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$0483a5fb6d44f11e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$0483a5fb6d44f11e$var$Point.prototype.mul = function mul(k) {
    k = new $61SlE(k, 16);
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$0483a5fb6d44f11e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$0483a5fb6d44f11e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$0483a5fb6d44f11e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$0483a5fb6d44f11e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$0483a5fb6d44f11e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $0483a5fb6d44f11e$var$JPoint(curve, x, y, z) {
    $0483a5fb6d44f11e$var$Base.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $61SlE(0);
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        this.z = new $61SlE(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$lyUaN($0483a5fb6d44f11e$var$JPoint, $0483a5fb6d44f11e$var$Base.BasePoint);
$0483a5fb6d44f11e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $0483a5fb6d44f11e$var$JPoint(this, x, y, z);
};
$0483a5fb6d44f11e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$0483a5fb6d44f11e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$0483a5fb6d44f11e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(var i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(var i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$0483a5fb6d44f11e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $61SlE(k, kbase);
    return this.curve._wnafMul(this, k);
};
$0483a5fb6d44f11e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$0483a5fb6d44f11e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
    return false;
};
$0483a5fb6d44f11e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$0483a5fb6d44f11e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("hap7r", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $c7f6daee520e45ff$var$Base = $g9z1u.base;

var $6nTxf = parcelRequire("6nTxf");
var $c7f6daee520e45ff$var$utils = $6nTxf.utils;
function $c7f6daee520e45ff$var$MontCurve(conf) {
    $c7f6daee520e45ff$var$Base.call(this, 'mont', conf);
    this.a = new $61SlE(conf.a, 16).toRed(this.red);
    this.b = new $61SlE(conf.b, 16).toRed(this.red);
    this.i4 = new $61SlE(4).toRed(this.red).redInvm();
    this.two = new $61SlE(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$lyUaN($c7f6daee520e45ff$var$MontCurve, $c7f6daee520e45ff$var$Base);
module.exports = $c7f6daee520e45ff$var$MontCurve;
$c7f6daee520e45ff$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $c7f6daee520e45ff$var$Point(curve, x, z) {
    $c7f6daee520e45ff$var$Base.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $61SlE(x, 16);
        this.z = new $61SlE(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$lyUaN($c7f6daee520e45ff$var$Point, $c7f6daee520e45ff$var$Base.BasePoint);
$c7f6daee520e45ff$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($c7f6daee520e45ff$var$utils.toArray(bytes, enc), 1);
};
$c7f6daee520e45ff$var$MontCurve.prototype.point = function point(x, z) {
    return new $c7f6daee520e45ff$var$Point(this, x, z);
};
$c7f6daee520e45ff$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $c7f6daee520e45ff$var$Point.fromJSON(this, obj);
};
$c7f6daee520e45ff$var$Point.prototype.precompute = function precompute() {
// No-op
};
$c7f6daee520e45ff$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$c7f6daee520e45ff$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $c7f6daee520e45ff$var$Point(curve, obj[0], obj[1] || curve.one);
};
$c7f6daee520e45ff$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$c7f6daee520e45ff$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$c7f6daee520e45ff$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$c7f6daee520e45ff$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$c7f6daee520e45ff$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$c7f6daee520e45ff$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$c7f6daee520e45ff$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$c7f6daee520e45ff$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("3Oe4N", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $2c60f5dbd111f643$var$Base = $g9z1u.base;
var $2c60f5dbd111f643$var$assert = $6nTxf.utils.assert;
function $2c60f5dbd111f643$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $2c60f5dbd111f643$var$Base.call(this, 'edwards', conf);
    this.a = new $61SlE(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $61SlE(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $61SlE(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $2c60f5dbd111f643$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$lyUaN($2c60f5dbd111f643$var$EdwardsCurve, $2c60f5dbd111f643$var$Base);
module.exports = $2c60f5dbd111f643$var$EdwardsCurve;
$2c60f5dbd111f643$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$2c60f5dbd111f643$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $61SlE(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $61SlE(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - 1) / (d y^2 + 1)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.one);
    var rhs = y2.redMul(this.d).redAdd(this.one);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $2c60f5dbd111f643$var$Point(curve, x, y, z, t) {
    $2c60f5dbd111f643$var$Base.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        this.z = z ? new $61SlE(z, 16) : this.curve.one;
        this.t = t && new $61SlE(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$lyUaN($2c60f5dbd111f643$var$Point, $2c60f5dbd111f643$var$Base.BasePoint);
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $2c60f5dbd111f643$var$Point.fromJSON(this, obj);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $2c60f5dbd111f643$var$Point(this, x, y, z, t);
};
$2c60f5dbd111f643$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $2c60f5dbd111f643$var$Point(curve, obj[0], obj[1], obj[2]);
};
$2c60f5dbd111f643$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$2c60f5dbd111f643$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && this.y.cmp(this.z) === 0;
};
$2c60f5dbd111f643$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$2c60f5dbd111f643$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    if (this.curve.twisted) {
        // E = a * C
        var e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            var h = this.z.redSqr();
            // J = F - 2 * H
            var j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        var e = c.redAdd(d);
        // H = (c * Z1)^2
        var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
        // J = E - 2 * H
        var j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$2c60f5dbd111f643$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$2c60f5dbd111f643$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$2c60f5dbd111f643$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$2c60f5dbd111f643$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$2c60f5dbd111f643$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$2c60f5dbd111f643$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$2c60f5dbd111f643$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$2c60f5dbd111f643$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$2c60f5dbd111f643$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$2c60f5dbd111f643$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$2c60f5dbd111f643$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$2c60f5dbd111f643$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$2c60f5dbd111f643$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
    return false;
};
// Compatibility with BaseCurve
$2c60f5dbd111f643$var$Point.prototype.toP = $2c60f5dbd111f643$var$Point.prototype.normalize;
$2c60f5dbd111f643$var$Point.prototype.mixedAdd = $2c60f5dbd111f643$var$Point.prototype.add;

});


parcelRegister("8XT4W", function(module, exports) {
'use strict';
var $686e8eebd7f02f1e$var$curves = module.exports;

var $1b2Pi = parcelRequire("1b2Pi");

var $6nTxf = parcelRequire("6nTxf");
var $686e8eebd7f02f1e$var$assert = $6nTxf.utils.assert;
function $686e8eebd7f02f1e$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $6nTxf.curve.short(options);
    else if (options.type === 'edwards') this.curve = new $6nTxf.curve.edwards(options);
    else this.curve = new $6nTxf.curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $686e8eebd7f02f1e$var$assert(this.g.validate(), 'Invalid curve');
    $686e8eebd7f02f1e$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$686e8eebd7f02f1e$var$curves.PresetCurve = $686e8eebd7f02f1e$var$PresetCurve;
function $686e8eebd7f02f1e$var$defineCurve(name, options) {
    Object.defineProperty($686e8eebd7f02f1e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $686e8eebd7f02f1e$var$PresetCurve(options);
            Object.defineProperty($686e8eebd7f02f1e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$686e8eebd7f02f1e$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $1b2Pi.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $1b2Pi.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$686e8eebd7f02f1e$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $686e8eebd7f02f1e$var$pre;

try {
    $686e8eebd7f02f1e$var$pre = (parcelRequire("93PGC"));
} catch (e) {
    $686e8eebd7f02f1e$var$pre = undefined;
}
$686e8eebd7f02f1e$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $1b2Pi.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $686e8eebd7f02f1e$var$pre
    ]
});

});
parcelRegister("1b2Pi", function(module, exports) {
var $0db902c75b4d9429$var$hash = module.exports;

$0db902c75b4d9429$var$hash.utils = (parcelRequire("5m5RF"));

$0db902c75b4d9429$var$hash.common = (parcelRequire("ap5FC"));

$0db902c75b4d9429$var$hash.sha = (parcelRequire("4TZSF"));

$0db902c75b4d9429$var$hash.ripemd = (parcelRequire("8pLmN"));

$0db902c75b4d9429$var$hash.hmac = (parcelRequire("bVEBB"));
// Proxy hash functions to the main object
$0db902c75b4d9429$var$hash.sha1 = $0db902c75b4d9429$var$hash.sha.sha1;
$0db902c75b4d9429$var$hash.sha256 = $0db902c75b4d9429$var$hash.sha.sha256;
$0db902c75b4d9429$var$hash.sha224 = $0db902c75b4d9429$var$hash.sha.sha224;
$0db902c75b4d9429$var$hash.sha384 = $0db902c75b4d9429$var$hash.sha.sha384;
$0db902c75b4d9429$var$hash.sha512 = $0db902c75b4d9429$var$hash.sha.sha512;
$0db902c75b4d9429$var$hash.ripemd160 = $0db902c75b4d9429$var$hash.ripemd.ripemd160;

});
parcelRegister("5m5RF", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $3e638e6515e2acb0$export$69f1b2dcda23c5f8, (v) => $3e638e6515e2acb0$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $3e638e6515e2acb0$export$45b10814cc054894, (v) => $3e638e6515e2acb0$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $3e638e6515e2acb0$export$7ea66e3774a60b67, (v) => $3e638e6515e2acb0$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $3e638e6515e2acb0$export$34a52f00f601f6f1, (v) => $3e638e6515e2acb0$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $3e638e6515e2acb0$export$812b0cbd5e8a72ab, (v) => $3e638e6515e2acb0$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $3e638e6515e2acb0$export$f24f9e11d63bb314, (v) => $3e638e6515e2acb0$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $3e638e6515e2acb0$export$b71357c7e07ca1f1, (v) => $3e638e6515e2acb0$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $3e638e6515e2acb0$export$2e58a4b541fdcbe8, (v) => $3e638e6515e2acb0$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $3e638e6515e2acb0$export$183b950bde9faab8, (v) => $3e638e6515e2acb0$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $3e638e6515e2acb0$export$4785c77169fea59e, (v) => $3e638e6515e2acb0$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $3e638e6515e2acb0$export$242a185dfcffac5b, (v) => $3e638e6515e2acb0$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $3e638e6515e2acb0$export$58c04ae0ae31877d, (v) => $3e638e6515e2acb0$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $3e638e6515e2acb0$export$d058ca695f8c6f11, (v) => $3e638e6515e2acb0$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $3e638e6515e2acb0$export$a1efd7fc3e986367, (v) => $3e638e6515e2acb0$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $3e638e6515e2acb0$export$bbfea4a2b5abaab4, (v) => $3e638e6515e2acb0$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $3e638e6515e2acb0$export$97ad4afc7de86152, (v) => $3e638e6515e2acb0$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $3e638e6515e2acb0$export$ce4673d9a79f6a4b, (v) => $3e638e6515e2acb0$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $3e638e6515e2acb0$export$786cc99fc6eedc0b, (v) => $3e638e6515e2acb0$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $3e638e6515e2acb0$export$45c59b9a1848dd0, (v) => $3e638e6515e2acb0$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $3e638e6515e2acb0$export$50d8f613e76d3034, (v) => $3e638e6515e2acb0$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $3e638e6515e2acb0$export$b8e83683c60ee162, (v) => $3e638e6515e2acb0$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $3e638e6515e2acb0$export$aeeb51790d1bcc4a, (v) => $3e638e6515e2acb0$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $3e638e6515e2acb0$export$bb7c616f719ad9c, (v) => $3e638e6515e2acb0$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $3e638e6515e2acb0$export$4d63290824f9d7df, (v) => $3e638e6515e2acb0$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $3e638e6515e2acb0$export$2f64ceb90ef28ea1, (v) => $3e638e6515e2acb0$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $3e638e6515e2acb0$export$8d2089d465f6d10d, (v) => $3e638e6515e2acb0$export$8d2089d465f6d10d = v);
var $3e638e6515e2acb0$export$69f1b2dcda23c5f8;
var $3e638e6515e2acb0$export$45b10814cc054894;
var $3e638e6515e2acb0$export$7ea66e3774a60b67;
var $3e638e6515e2acb0$export$34a52f00f601f6f1;
var $3e638e6515e2acb0$export$812b0cbd5e8a72ab;
var $3e638e6515e2acb0$export$f24f9e11d63bb314;
var $3e638e6515e2acb0$export$b71357c7e07ca1f1;
var $3e638e6515e2acb0$export$2e58a4b541fdcbe8;
var $3e638e6515e2acb0$export$183b950bde9faab8;
var $3e638e6515e2acb0$export$4785c77169fea59e;
var $3e638e6515e2acb0$export$242a185dfcffac5b;
var $3e638e6515e2acb0$export$58c04ae0ae31877d;
var $3e638e6515e2acb0$export$d058ca695f8c6f11;
var $3e638e6515e2acb0$export$a1efd7fc3e986367;
var $3e638e6515e2acb0$export$bbfea4a2b5abaab4;
var $3e638e6515e2acb0$export$97ad4afc7de86152;
var $3e638e6515e2acb0$export$ce4673d9a79f6a4b;
var $3e638e6515e2acb0$export$786cc99fc6eedc0b;
var $3e638e6515e2acb0$export$45c59b9a1848dd0;
var $3e638e6515e2acb0$export$50d8f613e76d3034;
var $3e638e6515e2acb0$export$b8e83683c60ee162;
var $3e638e6515e2acb0$export$aeeb51790d1bcc4a;
var $3e638e6515e2acb0$export$bb7c616f719ad9c;
var $3e638e6515e2acb0$export$4d63290824f9d7df;
var $3e638e6515e2acb0$export$2f64ceb90ef28ea1;
var $3e638e6515e2acb0$export$8d2089d465f6d10d;
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");
$3e638e6515e2acb0$export$69f1b2dcda23c5f8 = $lyUaN;
function $3e638e6515e2acb0$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$3e638e6515e2acb0$export$45b10814cc054894 = $3e638e6515e2acb0$var$toArray;
function $3e638e6515e2acb0$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $3e638e6515e2acb0$var$zero2(msg[i].toString(16));
    return res;
}
$3e638e6515e2acb0$export$7ea66e3774a60b67 = $3e638e6515e2acb0$var$toHex;
function $3e638e6515e2acb0$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$3e638e6515e2acb0$export$34a52f00f601f6f1 = $3e638e6515e2acb0$var$htonl;
function $3e638e6515e2acb0$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $3e638e6515e2acb0$var$htonl(w);
        res += $3e638e6515e2acb0$var$zero8(w.toString(16));
    }
    return res;
}
$3e638e6515e2acb0$export$812b0cbd5e8a72ab = $3e638e6515e2acb0$var$toHex32;
function $3e638e6515e2acb0$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$3e638e6515e2acb0$export$f24f9e11d63bb314 = $3e638e6515e2acb0$var$zero2;
function $3e638e6515e2acb0$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$3e638e6515e2acb0$export$b71357c7e07ca1f1 = $3e638e6515e2acb0$var$zero8;
function $3e638e6515e2acb0$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aOIMZ(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$3e638e6515e2acb0$export$2e58a4b541fdcbe8 = $3e638e6515e2acb0$var$join32;
function $3e638e6515e2acb0$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$3e638e6515e2acb0$export$183b950bde9faab8 = $3e638e6515e2acb0$var$split32;
function $3e638e6515e2acb0$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$3e638e6515e2acb0$export$4785c77169fea59e = $3e638e6515e2acb0$var$rotr32;
function $3e638e6515e2acb0$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$3e638e6515e2acb0$export$242a185dfcffac5b = $3e638e6515e2acb0$var$rotl32;
function $3e638e6515e2acb0$var$sum32(a, b) {
    return a + b >>> 0;
}
$3e638e6515e2acb0$export$58c04ae0ae31877d = $3e638e6515e2acb0$var$sum32;
function $3e638e6515e2acb0$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$3e638e6515e2acb0$export$d058ca695f8c6f11 = $3e638e6515e2acb0$var$sum32_3;
function $3e638e6515e2acb0$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$3e638e6515e2acb0$export$a1efd7fc3e986367 = $3e638e6515e2acb0$var$sum32_4;
function $3e638e6515e2acb0$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$3e638e6515e2acb0$export$bbfea4a2b5abaab4 = $3e638e6515e2acb0$var$sum32_5;
function $3e638e6515e2acb0$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$3e638e6515e2acb0$export$97ad4afc7de86152 = $3e638e6515e2acb0$var$sum64;
function $3e638e6515e2acb0$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$ce4673d9a79f6a4b = $3e638e6515e2acb0$var$sum64_hi;
function $3e638e6515e2acb0$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$786cc99fc6eedc0b = $3e638e6515e2acb0$var$sum64_lo;
function $3e638e6515e2acb0$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$45c59b9a1848dd0 = $3e638e6515e2acb0$var$sum64_4_hi;
function $3e638e6515e2acb0$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$50d8f613e76d3034 = $3e638e6515e2acb0$var$sum64_4_lo;
function $3e638e6515e2acb0$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$b8e83683c60ee162 = $3e638e6515e2acb0$var$sum64_5_hi;
function $3e638e6515e2acb0$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$aeeb51790d1bcc4a = $3e638e6515e2acb0$var$sum64_5_lo;
function $3e638e6515e2acb0$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$bb7c616f719ad9c = $3e638e6515e2acb0$var$rotr64_hi;
function $3e638e6515e2acb0$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$4d63290824f9d7df = $3e638e6515e2acb0$var$rotr64_lo;
function $3e638e6515e2acb0$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$3e638e6515e2acb0$export$2f64ceb90ef28ea1 = $3e638e6515e2acb0$var$shr64_hi;
function $3e638e6515e2acb0$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$8d2089d465f6d10d = $3e638e6515e2acb0$var$shr64_lo;

});

parcelRegister("ap5FC", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7930a331e2b8bb39$export$8687658379b577e6, (v) => $7930a331e2b8bb39$export$8687658379b577e6 = v);
var $7930a331e2b8bb39$export$8687658379b577e6;
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $aOIMZ = parcelRequire("aOIMZ");
function $7930a331e2b8bb39$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7930a331e2b8bb39$export$8687658379b577e6 = $7930a331e2b8bb39$var$BlockHash;
$7930a331e2b8bb39$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $5m5RF.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $5m5RF.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7930a331e2b8bb39$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aOIMZ(this.pending === null);
    return this._digest(enc);
};
$7930a331e2b8bb39$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("4TZSF", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $391c4cb3e26fcd89$export$5091bdda49ba90f5, (v) => $391c4cb3e26fcd89$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $391c4cb3e26fcd89$export$97b70509d4e397ea, (v) => $391c4cb3e26fcd89$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $391c4cb3e26fcd89$export$bced8d2aada2d1c9, (v) => $391c4cb3e26fcd89$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $391c4cb3e26fcd89$export$612d47d55dedde45, (v) => $391c4cb3e26fcd89$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $391c4cb3e26fcd89$export$a888d2532e6dc7bb, (v) => $391c4cb3e26fcd89$export$a888d2532e6dc7bb = v);
var $391c4cb3e26fcd89$export$5091bdda49ba90f5;
var $391c4cb3e26fcd89$export$97b70509d4e397ea;
var $391c4cb3e26fcd89$export$bced8d2aada2d1c9;
var $391c4cb3e26fcd89$export$612d47d55dedde45;
var $391c4cb3e26fcd89$export$a888d2532e6dc7bb;
'use strict';

$391c4cb3e26fcd89$export$5091bdda49ba90f5 = (parcelRequire("1YLg9"));

$391c4cb3e26fcd89$export$97b70509d4e397ea = (parcelRequire("fTyPw"));

$391c4cb3e26fcd89$export$bced8d2aada2d1c9 = (parcelRequire("kjGwI"));

$391c4cb3e26fcd89$export$612d47d55dedde45 = (parcelRequire("fVCT0"));

$391c4cb3e26fcd89$export$a888d2532e6dc7bb = (parcelRequire("hpDZE"));

});
parcelRegister("1YLg9", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $5pCtI = parcelRequire("5pCtI");
var $17100dcd25bebb06$var$rotl32 = $5m5RF.rotl32;
var $17100dcd25bebb06$var$sum32 = $5m5RF.sum32;
var $17100dcd25bebb06$var$sum32_5 = $5m5RF.sum32_5;
var $17100dcd25bebb06$var$ft_1 = $5pCtI.ft_1;
var $17100dcd25bebb06$var$BlockHash = $ap5FC.BlockHash;
var $17100dcd25bebb06$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $17100dcd25bebb06$var$SHA1() {
    if (!(this instanceof $17100dcd25bebb06$var$SHA1)) return new $17100dcd25bebb06$var$SHA1();
    $17100dcd25bebb06$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$5m5RF.inherits($17100dcd25bebb06$var$SHA1, $17100dcd25bebb06$var$BlockHash);
module.exports = $17100dcd25bebb06$var$SHA1;
$17100dcd25bebb06$var$SHA1.blockSize = 512;
$17100dcd25bebb06$var$SHA1.outSize = 160;
$17100dcd25bebb06$var$SHA1.hmacStrength = 80;
$17100dcd25bebb06$var$SHA1.padLength = 64;
$17100dcd25bebb06$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $17100dcd25bebb06$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $17100dcd25bebb06$var$sum32_5($17100dcd25bebb06$var$rotl32(a, 5), $17100dcd25bebb06$var$ft_1(s, b, c, d), e, W[i], $17100dcd25bebb06$var$sha1_K[s]);
        e = d;
        d = c;
        c = $17100dcd25bebb06$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $17100dcd25bebb06$var$sum32(this.h[0], a);
    this.h[1] = $17100dcd25bebb06$var$sum32(this.h[1], b);
    this.h[2] = $17100dcd25bebb06$var$sum32(this.h[2], c);
    this.h[3] = $17100dcd25bebb06$var$sum32(this.h[3], d);
    this.h[4] = $17100dcd25bebb06$var$sum32(this.h[4], e);
};
$17100dcd25bebb06$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};

});
parcelRegister("5pCtI", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $3f0d228f2ba28050$export$5a92649d7ddb9f63, (v) => $3f0d228f2ba28050$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $3f0d228f2ba28050$export$c6d0d020c3a6269, (v) => $3f0d228f2ba28050$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $3f0d228f2ba28050$export$eb90c27fca05f956, (v) => $3f0d228f2ba28050$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $3f0d228f2ba28050$export$14a4a98e063b1999, (v) => $3f0d228f2ba28050$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $3f0d228f2ba28050$export$d20cecfa1564c686, (v) => $3f0d228f2ba28050$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $3f0d228f2ba28050$export$44fd472a12fc6db, (v) => $3f0d228f2ba28050$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $3f0d228f2ba28050$export$1ed238bb6ea1dd47, (v) => $3f0d228f2ba28050$export$1ed238bb6ea1dd47 = v);
var $3f0d228f2ba28050$export$5a92649d7ddb9f63;
var $3f0d228f2ba28050$export$c6d0d020c3a6269;
var $3f0d228f2ba28050$export$eb90c27fca05f956;
var $3f0d228f2ba28050$export$cc992891a14496a1;
var $3f0d228f2ba28050$export$14a4a98e063b1999;
var $3f0d228f2ba28050$export$d20cecfa1564c686;
var $3f0d228f2ba28050$export$44fd472a12fc6db;
var $3f0d228f2ba28050$export$1ed238bb6ea1dd47;
'use strict';

var $5m5RF = parcelRequire("5m5RF");
var $3f0d228f2ba28050$var$rotr32 = $5m5RF.rotr32;
function $3f0d228f2ba28050$var$ft_1(s, x, y, z) {
    if (s === 0) return $3f0d228f2ba28050$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $3f0d228f2ba28050$var$p32(x, y, z);
    if (s === 2) return $3f0d228f2ba28050$var$maj32(x, y, z);
}
$3f0d228f2ba28050$export$5a92649d7ddb9f63 = $3f0d228f2ba28050$var$ft_1;
function $3f0d228f2ba28050$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$3f0d228f2ba28050$export$c6d0d020c3a6269 = $3f0d228f2ba28050$var$ch32;
function $3f0d228f2ba28050$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$3f0d228f2ba28050$export$eb90c27fca05f956 = $3f0d228f2ba28050$var$maj32;
function $3f0d228f2ba28050$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$3f0d228f2ba28050$export$cc992891a14496a1 = $3f0d228f2ba28050$var$p32;
function $3f0d228f2ba28050$var$s0_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 2) ^ $3f0d228f2ba28050$var$rotr32(x, 13) ^ $3f0d228f2ba28050$var$rotr32(x, 22);
}
$3f0d228f2ba28050$export$14a4a98e063b1999 = $3f0d228f2ba28050$var$s0_256;
function $3f0d228f2ba28050$var$s1_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 6) ^ $3f0d228f2ba28050$var$rotr32(x, 11) ^ $3f0d228f2ba28050$var$rotr32(x, 25);
}
$3f0d228f2ba28050$export$d20cecfa1564c686 = $3f0d228f2ba28050$var$s1_256;
function $3f0d228f2ba28050$var$g0_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 7) ^ $3f0d228f2ba28050$var$rotr32(x, 18) ^ x >>> 3;
}
$3f0d228f2ba28050$export$44fd472a12fc6db = $3f0d228f2ba28050$var$g0_256;
function $3f0d228f2ba28050$var$g1_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 17) ^ $3f0d228f2ba28050$var$rotr32(x, 19) ^ x >>> 10;
}
$3f0d228f2ba28050$export$1ed238bb6ea1dd47 = $3f0d228f2ba28050$var$g1_256;

});


parcelRegister("fTyPw", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $kjGwI = parcelRequire("kjGwI");
function $b927028e6008aa5f$var$SHA224() {
    if (!(this instanceof $b927028e6008aa5f$var$SHA224)) return new $b927028e6008aa5f$var$SHA224();
    $kjGwI.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$5m5RF.inherits($b927028e6008aa5f$var$SHA224, $kjGwI);
module.exports = $b927028e6008aa5f$var$SHA224;
$b927028e6008aa5f$var$SHA224.blockSize = 512;
$b927028e6008aa5f$var$SHA224.outSize = 224;
$b927028e6008aa5f$var$SHA224.hmacStrength = 192;
$b927028e6008aa5f$var$SHA224.padLength = 64;
$b927028e6008aa5f$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $5m5RF.toHex32(this.h.slice(0, 7), 'big');
    else return $5m5RF.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("kjGwI", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $5pCtI = parcelRequire("5pCtI");

var $aOIMZ = parcelRequire("aOIMZ");
var $eca691e7cafb0ba8$var$sum32 = $5m5RF.sum32;
var $eca691e7cafb0ba8$var$sum32_4 = $5m5RF.sum32_4;
var $eca691e7cafb0ba8$var$sum32_5 = $5m5RF.sum32_5;
var $eca691e7cafb0ba8$var$ch32 = $5pCtI.ch32;
var $eca691e7cafb0ba8$var$maj32 = $5pCtI.maj32;
var $eca691e7cafb0ba8$var$s0_256 = $5pCtI.s0_256;
var $eca691e7cafb0ba8$var$s1_256 = $5pCtI.s1_256;
var $eca691e7cafb0ba8$var$g0_256 = $5pCtI.g0_256;
var $eca691e7cafb0ba8$var$g1_256 = $5pCtI.g1_256;
var $eca691e7cafb0ba8$var$BlockHash = $ap5FC.BlockHash;
var $eca691e7cafb0ba8$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $eca691e7cafb0ba8$var$SHA256() {
    if (!(this instanceof $eca691e7cafb0ba8$var$SHA256)) return new $eca691e7cafb0ba8$var$SHA256();
    $eca691e7cafb0ba8$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $eca691e7cafb0ba8$var$sha256_K;
    this.W = new Array(64);
}
$5m5RF.inherits($eca691e7cafb0ba8$var$SHA256, $eca691e7cafb0ba8$var$BlockHash);
module.exports = $eca691e7cafb0ba8$var$SHA256;
$eca691e7cafb0ba8$var$SHA256.blockSize = 512;
$eca691e7cafb0ba8$var$SHA256.outSize = 256;
$eca691e7cafb0ba8$var$SHA256.hmacStrength = 192;
$eca691e7cafb0ba8$var$SHA256.padLength = 64;
$eca691e7cafb0ba8$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $eca691e7cafb0ba8$var$sum32_4($eca691e7cafb0ba8$var$g1_256(W[i - 2]), W[i - 7], $eca691e7cafb0ba8$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aOIMZ(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $eca691e7cafb0ba8$var$sum32_5(h, $eca691e7cafb0ba8$var$s1_256(e), $eca691e7cafb0ba8$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $eca691e7cafb0ba8$var$sum32($eca691e7cafb0ba8$var$s0_256(a), $eca691e7cafb0ba8$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $eca691e7cafb0ba8$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $eca691e7cafb0ba8$var$sum32(T1, T2);
    }
    this.h[0] = $eca691e7cafb0ba8$var$sum32(this.h[0], a);
    this.h[1] = $eca691e7cafb0ba8$var$sum32(this.h[1], b);
    this.h[2] = $eca691e7cafb0ba8$var$sum32(this.h[2], c);
    this.h[3] = $eca691e7cafb0ba8$var$sum32(this.h[3], d);
    this.h[4] = $eca691e7cafb0ba8$var$sum32(this.h[4], e);
    this.h[5] = $eca691e7cafb0ba8$var$sum32(this.h[5], f);
    this.h[6] = $eca691e7cafb0ba8$var$sum32(this.h[6], g);
    this.h[7] = $eca691e7cafb0ba8$var$sum32(this.h[7], h);
};
$eca691e7cafb0ba8$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};

});


parcelRegister("fVCT0", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $hpDZE = parcelRequire("hpDZE");
function $b98a57e318409183$var$SHA384() {
    if (!(this instanceof $b98a57e318409183$var$SHA384)) return new $b98a57e318409183$var$SHA384();
    $hpDZE.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$5m5RF.inherits($b98a57e318409183$var$SHA384, $hpDZE);
module.exports = $b98a57e318409183$var$SHA384;
$b98a57e318409183$var$SHA384.blockSize = 1024;
$b98a57e318409183$var$SHA384.outSize = 384;
$b98a57e318409183$var$SHA384.hmacStrength = 192;
$b98a57e318409183$var$SHA384.padLength = 128;
$b98a57e318409183$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h.slice(0, 12), 'big');
    else return $5m5RF.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("hpDZE", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $aOIMZ = parcelRequire("aOIMZ");
var $cad3cb514f4c9f49$var$rotr64_hi = $5m5RF.rotr64_hi;
var $cad3cb514f4c9f49$var$rotr64_lo = $5m5RF.rotr64_lo;
var $cad3cb514f4c9f49$var$shr64_hi = $5m5RF.shr64_hi;
var $cad3cb514f4c9f49$var$shr64_lo = $5m5RF.shr64_lo;
var $cad3cb514f4c9f49$var$sum64 = $5m5RF.sum64;
var $cad3cb514f4c9f49$var$sum64_hi = $5m5RF.sum64_hi;
var $cad3cb514f4c9f49$var$sum64_lo = $5m5RF.sum64_lo;
var $cad3cb514f4c9f49$var$sum64_4_hi = $5m5RF.sum64_4_hi;
var $cad3cb514f4c9f49$var$sum64_4_lo = $5m5RF.sum64_4_lo;
var $cad3cb514f4c9f49$var$sum64_5_hi = $5m5RF.sum64_5_hi;
var $cad3cb514f4c9f49$var$sum64_5_lo = $5m5RF.sum64_5_lo;
var $cad3cb514f4c9f49$var$BlockHash = $ap5FC.BlockHash;
var $cad3cb514f4c9f49$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $cad3cb514f4c9f49$var$SHA512() {
    if (!(this instanceof $cad3cb514f4c9f49$var$SHA512)) return new $cad3cb514f4c9f49$var$SHA512();
    $cad3cb514f4c9f49$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $cad3cb514f4c9f49$var$sha512_K;
    this.W = new Array(160);
}
$5m5RF.inherits($cad3cb514f4c9f49$var$SHA512, $cad3cb514f4c9f49$var$BlockHash);
module.exports = $cad3cb514f4c9f49$var$SHA512;
$cad3cb514f4c9f49$var$SHA512.blockSize = 1024;
$cad3cb514f4c9f49$var$SHA512.outSize = 512;
$cad3cb514f4c9f49$var$SHA512.hmacStrength = 192;
$cad3cb514f4c9f49$var$SHA512.padLength = 128;
$cad3cb514f4c9f49$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $cad3cb514f4c9f49$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $cad3cb514f4c9f49$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $cad3cb514f4c9f49$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $cad3cb514f4c9f49$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $cad3cb514f4c9f49$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $cad3cb514f4c9f49$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$cad3cb514f4c9f49$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aOIMZ(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $cad3cb514f4c9f49$var$s1_512_hi(eh, el);
        var c1_lo = $cad3cb514f4c9f49$var$s1_512_lo(eh, el);
        var c2_hi = $cad3cb514f4c9f49$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $cad3cb514f4c9f49$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $cad3cb514f4c9f49$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $cad3cb514f4c9f49$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $cad3cb514f4c9f49$var$s0_512_hi(ah, al);
        c0_lo = $cad3cb514f4c9f49$var$s0_512_lo(ah, al);
        c1_hi = $cad3cb514f4c9f49$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $cad3cb514f4c9f49$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $cad3cb514f4c9f49$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $cad3cb514f4c9f49$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $cad3cb514f4c9f49$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $cad3cb514f4c9f49$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $cad3cb514f4c9f49$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $cad3cb514f4c9f49$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $cad3cb514f4c9f49$var$sum64(this.h, 0, ah, al);
    $cad3cb514f4c9f49$var$sum64(this.h, 2, bh, bl);
    $cad3cb514f4c9f49$var$sum64(this.h, 4, ch, cl);
    $cad3cb514f4c9f49$var$sum64(this.h, 6, dh, dl);
    $cad3cb514f4c9f49$var$sum64(this.h, 8, eh, el);
    $cad3cb514f4c9f49$var$sum64(this.h, 10, fh, fl);
    $cad3cb514f4c9f49$var$sum64(this.h, 12, gh, gl);
    $cad3cb514f4c9f49$var$sum64(this.h, 14, hh, hl);
};
$cad3cb514f4c9f49$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};
function $cad3cb514f4c9f49$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s0_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s0_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s1_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s1_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g0_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $cad3cb514f4c9f49$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g0_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $cad3cb514f4c9f49$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g1_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $cad3cb514f4c9f49$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g1_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $cad3cb514f4c9f49$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("8pLmN", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $62056695c4cb62fc$export$d1cea0ee4e3f0d3e, (v) => $62056695c4cb62fc$export$d1cea0ee4e3f0d3e = v);
var $62056695c4cb62fc$export$d1cea0ee4e3f0d3e;
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");
var $62056695c4cb62fc$var$rotl32 = $5m5RF.rotl32;
var $62056695c4cb62fc$var$sum32 = $5m5RF.sum32;
var $62056695c4cb62fc$var$sum32_3 = $5m5RF.sum32_3;
var $62056695c4cb62fc$var$sum32_4 = $5m5RF.sum32_4;
var $62056695c4cb62fc$var$BlockHash = $ap5FC.BlockHash;
function $62056695c4cb62fc$var$RIPEMD160() {
    if (!(this instanceof $62056695c4cb62fc$var$RIPEMD160)) return new $62056695c4cb62fc$var$RIPEMD160();
    $62056695c4cb62fc$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$5m5RF.inherits($62056695c4cb62fc$var$RIPEMD160, $62056695c4cb62fc$var$BlockHash);
$62056695c4cb62fc$export$d1cea0ee4e3f0d3e = $62056695c4cb62fc$var$RIPEMD160;
$62056695c4cb62fc$var$RIPEMD160.blockSize = 512;
$62056695c4cb62fc$var$RIPEMD160.outSize = 160;
$62056695c4cb62fc$var$RIPEMD160.hmacStrength = 192;
$62056695c4cb62fc$var$RIPEMD160.padLength = 64;
$62056695c4cb62fc$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $62056695c4cb62fc$var$sum32($62056695c4cb62fc$var$rotl32($62056695c4cb62fc$var$sum32_4(A, $62056695c4cb62fc$var$f(j, B, C, D), msg[$62056695c4cb62fc$var$r[j] + start], $62056695c4cb62fc$var$K(j)), $62056695c4cb62fc$var$s[j]), E);
        A = E;
        E = D;
        D = $62056695c4cb62fc$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $62056695c4cb62fc$var$sum32($62056695c4cb62fc$var$rotl32($62056695c4cb62fc$var$sum32_4(Ah, $62056695c4cb62fc$var$f(79 - j, Bh, Ch, Dh), msg[$62056695c4cb62fc$var$rh[j] + start], $62056695c4cb62fc$var$Kh(j)), $62056695c4cb62fc$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $62056695c4cb62fc$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $62056695c4cb62fc$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $62056695c4cb62fc$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $62056695c4cb62fc$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $62056695c4cb62fc$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $62056695c4cb62fc$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$62056695c4cb62fc$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'little');
    else return $5m5RF.split32(this.h, 'little');
};
function $62056695c4cb62fc$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $62056695c4cb62fc$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $62056695c4cb62fc$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $62056695c4cb62fc$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $62056695c4cb62fc$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $62056695c4cb62fc$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $62056695c4cb62fc$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("bVEBB", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $aOIMZ = parcelRequire("aOIMZ");
function $8af483f723c67b6b$var$Hmac(hash, key, enc) {
    if (!(this instanceof $8af483f723c67b6b$var$Hmac)) return new $8af483f723c67b6b$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($5m5RF.toArray(key, enc));
}
module.exports = $8af483f723c67b6b$var$Hmac;
$8af483f723c67b6b$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aOIMZ(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$8af483f723c67b6b$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$8af483f723c67b6b$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("93PGC", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("h6mem", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $g1um0 = parcelRequire("g1um0");

var $6nTxf = parcelRequire("6nTxf");
var $c7343dc2badb09ab$var$utils = $6nTxf.utils;
var $c7343dc2badb09ab$var$assert = $c7343dc2badb09ab$var$utils.assert;

var $5G0Zf = parcelRequire("5G0Zf");

var $27zvB = parcelRequire("27zvB");
function $c7343dc2badb09ab$var$EC(options) {
    if (!(this instanceof $c7343dc2badb09ab$var$EC)) return new $c7343dc2badb09ab$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $c7343dc2badb09ab$var$assert($6nTxf.curves.hasOwnProperty(options), 'Unknown curve ' + options);
        options = $6nTxf.curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $6nTxf.curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $c7343dc2badb09ab$var$EC;
$c7343dc2badb09ab$var$EC.prototype.keyPair = function keyPair(options) {
    return new $5G0Zf(this, options);
};
$c7343dc2badb09ab$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $5G0Zf.fromPrivate(this, priv, enc);
};
$c7343dc2badb09ab$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $5G0Zf.fromPublic(this, pub, enc);
};
$c7343dc2badb09ab$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $g1um0({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $6nTxf.rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $61SlE(2));
    do {
        var priv = new $61SlE(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }while (true);
};
$c7343dc2badb09ab$var$EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$c7343dc2badb09ab$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $61SlE(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $g1um0({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $61SlE(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $61SlE(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $27zvB({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$c7343dc2badb09ab$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $61SlE(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $27zvB(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    if (!this.curve._maxwellTrick) {
        var p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    var p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$c7343dc2badb09ab$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $c7343dc2badb09ab$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $27zvB(signature, enc);
    var n = this.n;
    var e = new $61SlE(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$c7343dc2badb09ab$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $27zvB(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("g1um0", function(module, exports) {
'use strict';

var $1b2Pi = parcelRequire("1b2Pi");

var $9a0Ug = parcelRequire("9a0Ug");

var $aOIMZ = parcelRequire("aOIMZ");
function $baa448f8c81bebd3$var$HmacDRBG(options) {
    if (!(this instanceof $baa448f8c81bebd3$var$HmacDRBG)) return new $baa448f8c81bebd3$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $9a0Ug.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $9a0Ug.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $9a0Ug.toArray(options.pers, options.persEnc || 'hex');
    $aOIMZ(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $baa448f8c81bebd3$var$HmacDRBG;
$baa448f8c81bebd3$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$baa448f8c81bebd3$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $1b2Pi.hmac(this.hash, this.K);
};
$baa448f8c81bebd3$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$baa448f8c81bebd3$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $9a0Ug.toArray(entropy, entropyEnc);
    add = $9a0Ug.toArray(add, addEnc);
    $aOIMZ(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$baa448f8c81bebd3$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $9a0Ug.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $9a0Ug.encode(res, enc);
};

});

parcelRegister("5G0Zf", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $4221a3fd0ff06be5$var$utils = $6nTxf.utils;
var $4221a3fd0ff06be5$var$assert = $4221a3fd0ff06be5$var$utils.assert;
function $4221a3fd0ff06be5$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $4221a3fd0ff06be5$var$KeyPair;
$4221a3fd0ff06be5$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $4221a3fd0ff06be5$var$KeyPair) return pub;
    return new $4221a3fd0ff06be5$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$4221a3fd0ff06be5$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $4221a3fd0ff06be5$var$KeyPair) return priv;
    return new $4221a3fd0ff06be5$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$4221a3fd0ff06be5$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$4221a3fd0ff06be5$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$4221a3fd0ff06be5$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $61SlE(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$4221a3fd0ff06be5$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $4221a3fd0ff06be5$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $4221a3fd0ff06be5$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$4221a3fd0ff06be5$var$KeyPair.prototype.derive = function derive(pub) {
    return pub.mul(this.priv).getX();
};
// ECDSA
$4221a3fd0ff06be5$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("27zvB", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $18b7c786830ea982$var$utils = $6nTxf.utils;
var $18b7c786830ea982$var$assert = $18b7c786830ea982$var$utils.assert;
function $18b7c786830ea982$var$Signature(options, enc) {
    if (options instanceof $18b7c786830ea982$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $18b7c786830ea982$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $61SlE(options.r, 16);
    this.s = new $61SlE(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $18b7c786830ea982$var$Signature;
function $18b7c786830ea982$var$Position() {
    this.place = 0;
}
function $18b7c786830ea982$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
    }
    p.place = off;
    return val;
}
function $18b7c786830ea982$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$18b7c786830ea982$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $18b7c786830ea982$var$utils.toArray(data, enc);
    var p = new $18b7c786830ea982$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $18b7c786830ea982$var$getLength(data, p);
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $18b7c786830ea982$var$getLength(data, p);
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $18b7c786830ea982$var$getLength(data, p);
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0 && r[1] & 0x80) r = r.slice(1);
    if (s[0] === 0 && s[1] & 0x80) s = s.slice(1);
    this.r = new $61SlE(r);
    this.s = new $61SlE(s);
    this.recoveryParam = null;
    return true;
};
function $18b7c786830ea982$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$18b7c786830ea982$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $18b7c786830ea982$var$rmPadding(r);
    s = $18b7c786830ea982$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $18b7c786830ea982$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $18b7c786830ea982$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $18b7c786830ea982$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $18b7c786830ea982$var$utils.encode(res, enc);
};

});


parcelRegister("j0pZO", function(module, exports) {
'use strict';

var $1b2Pi = parcelRequire("1b2Pi");

var $6nTxf = parcelRequire("6nTxf");
var $dd622ea45c6600da$var$utils = $6nTxf.utils;
var $dd622ea45c6600da$var$assert = $dd622ea45c6600da$var$utils.assert;
var $dd622ea45c6600da$var$parseBytes = $dd622ea45c6600da$var$utils.parseBytes;

var $kiVpu = parcelRequire("kiVpu");

var $jwPwB = parcelRequire("jwPwB");
function $dd622ea45c6600da$var$EDDSA(curve) {
    $dd622ea45c6600da$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $dd622ea45c6600da$var$EDDSA)) return new $dd622ea45c6600da$var$EDDSA(curve);
    var curve = $6nTxf.curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $1b2Pi.sha512;
}
module.exports = $dd622ea45c6600da$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $dd622ea45c6600da$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $dd622ea45c6600da$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $dd622ea45c6600da$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $dd622ea45c6600da$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$dd622ea45c6600da$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $dd622ea45c6600da$var$utils.intFromLE(hash.digest()).umod(this.curve.n);
};
$dd622ea45c6600da$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $kiVpu.fromPublic(this, pub);
};
$dd622ea45c6600da$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $kiVpu.fromSecret(this, secret);
};
$dd622ea45c6600da$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $jwPwB) return sig;
    return new $jwPwB(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $dd622ea45c6600da$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$dd622ea45c6600da$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $dd622ea45c6600da$var$utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $dd622ea45c6600da$var$utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$dd622ea45c6600da$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$dd622ea45c6600da$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $dd622ea45c6600da$var$utils.intFromLE(bytes);
};
$dd622ea45c6600da$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("kiVpu", function(module, exports) {
'use strict';

var $6nTxf = parcelRequire("6nTxf");
var $ec82058b2f28f2e5$var$utils = $6nTxf.utils;
var $ec82058b2f28f2e5$var$assert = $ec82058b2f28f2e5$var$utils.assert;
var $ec82058b2f28f2e5$var$parseBytes = $ec82058b2f28f2e5$var$utils.parseBytes;
var $ec82058b2f28f2e5$var$cachedProperty = $ec82058b2f28f2e5$var$utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $ec82058b2f28f2e5$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $ec82058b2f28f2e5$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $ec82058b2f28f2e5$var$parseBytes(params.pub);
}
$ec82058b2f28f2e5$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $ec82058b2f28f2e5$var$KeyPair) return pub;
    return new $ec82058b2f28f2e5$var$KeyPair(eddsa, {
        pub: pub
    });
};
$ec82058b2f28f2e5$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $ec82058b2f28f2e5$var$KeyPair) return secret;
    return new $ec82058b2f28f2e5$var$KeyPair(eddsa, {
        secret: secret
    });
};
$ec82058b2f28f2e5$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$ec82058b2f28f2e5$var$KeyPair.prototype.sign = function sign(message) {
    $ec82058b2f28f2e5$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $ec82058b2f28f2e5$var$assert(this._secret, 'KeyPair is public only');
    return $ec82058b2f28f2e5$var$utils.encode(this.secret(), enc);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ec82058b2f28f2e5$var$utils.encode(this.pubBytes(), enc);
};
module.exports = $ec82058b2f28f2e5$var$KeyPair;

});

parcelRegister("jwPwB", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $e378f93fe9f62b7b$var$utils = $6nTxf.utils;
var $e378f93fe9f62b7b$var$assert = $e378f93fe9f62b7b$var$utils.assert;
var $e378f93fe9f62b7b$var$cachedProperty = $e378f93fe9f62b7b$var$utils.cachedProperty;
var $e378f93fe9f62b7b$var$parseBytes = $e378f93fe9f62b7b$var$utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $e378f93fe9f62b7b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $e378f93fe9f62b7b$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $e378f93fe9f62b7b$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $61SlE) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$e378f93fe9f62b7b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$e378f93fe9f62b7b$var$Signature.prototype.toHex = function toHex() {
    return $e378f93fe9f62b7b$var$utils.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $e378f93fe9f62b7b$var$Signature;

});



parcelRegister("lXsfV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $ffc506b4f2050cfc$require$Buffer = $aul3P.Buffer;

var $cfiQZ = parcelRequire("cfiQZ");

var $fJ1z5 = parcelRequire("fJ1z5");

var $1qG0a = parcelRequire("1qG0a");

var $FyTgm = parcelRequire("FyTgm");

var $8bTm7 = parcelRequire("8bTm7");
module.exports = $ffc506b4f2050cfc$var$parseKeys;
function $ffc506b4f2050cfc$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$ffc506b4f2050cfc$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = new $ffc506b4f2050cfc$require$Buffer(buffer);
    var stripped = $1qG0a(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $cfiQZ.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $cfiQZ.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cfiQZ.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $cfiQZ.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
            throw new Error('unknown key type ' + type);
        case 'ENCRYPTED PRIVATE KEY':
            data = $cfiQZ.EncryptedPrivateKey.decode(data, 'der');
            data = $ffc506b4f2050cfc$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $cfiQZ.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cfiQZ.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $cfiQZ.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $cfiQZ.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
            throw new Error('unknown key type ' + type);
        case 'RSA PUBLIC KEY':
            return $cfiQZ.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $cfiQZ.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $cfiQZ.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $cfiQZ.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$ffc506b4f2050cfc$var$parseKeys.signature = $cfiQZ.signature;
function $ffc506b4f2050cfc$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $fJ1z5[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $8bTm7.pbkdf2Sync(password, salt, iters, keylen);
    var cipher = $FyTgm.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $ffc506b4f2050cfc$require$Buffer.concat(out);
}

});
parcelRegister("cfiQZ", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $8ea582b0d1e4c2ff$export$c98397a6eb8d0678, (v) => $8ea582b0d1e4c2ff$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b, (v) => $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $8ea582b0d1e4c2ff$export$4471f5c65d097c11, (v) => $8ea582b0d1e4c2ff$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de, (v) => $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $8ea582b0d1e4c2ff$export$8f54525b330fd87b, (v) => $8ea582b0d1e4c2ff$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7, (v) => $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce, (v) => $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $8ea582b0d1e4c2ff$export$8ad762e3e6399afe, (v) => $8ea582b0d1e4c2ff$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0, (v) => $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $8ea582b0d1e4c2ff$export$c9cd164b539ebb63, (v) => $8ea582b0d1e4c2ff$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $8ea582b0d1e4c2ff$export$c98397a6eb8d0678;
var $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b;
var $8ea582b0d1e4c2ff$export$4471f5c65d097c11;
var $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de;
var $8ea582b0d1e4c2ff$export$8f54525b330fd87b;
var $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7;
var $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce;
var $8ea582b0d1e4c2ff$export$8ad762e3e6399afe;
var $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0;
var $8ea582b0d1e4c2ff$export$c9cd164b539ebb63;
'use strict';

var $7nj2w = parcelRequire("7nj2w");

$8ea582b0d1e4c2ff$export$c98397a6eb8d0678 = (parcelRequire("hZGUx"));
var $8ea582b0d1e4c2ff$var$RSAPrivateKey = $7nj2w.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('modulus').int(), this.key('publicExponent').int(), this.key('privateExponent').int(), this.key('prime1').int(), this.key('prime2').int(), this.key('exponent1').int(), this.key('exponent2').int(), this.key('coefficient').int());
});
$8ea582b0d1e4c2ff$export$f4aab6816f64fa6b = $8ea582b0d1e4c2ff$var$RSAPrivateKey;
var $8ea582b0d1e4c2ff$var$RSAPublicKey = $7nj2w.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus').int(), this.key('publicExponent').int());
});
$8ea582b0d1e4c2ff$export$4471f5c65d097c11 = $8ea582b0d1e4c2ff$var$RSAPublicKey;
var $8ea582b0d1e4c2ff$var$PublicKey = $7nj2w.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($8ea582b0d1e4c2ff$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$8ea582b0d1e4c2ff$export$ca8b6604d6ce14de = $8ea582b0d1e4c2ff$var$PublicKey;
var $8ea582b0d1e4c2ff$var$AlgorithmIdentifier = $7nj2w.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p').int(), this.key('q').int(), this.key('g').int()).optional());
});
var $8ea582b0d1e4c2ff$var$PrivateKeyInfo = $7nj2w.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version').int(), this.key('algorithm').use($8ea582b0d1e4c2ff$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$8ea582b0d1e4c2ff$export$8f54525b330fd87b = $8ea582b0d1e4c2ff$var$PrivateKeyInfo;
var $8ea582b0d1e4c2ff$var$EncryptedPrivateKeyInfo = $7nj2w.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters').int())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$8ea582b0d1e4c2ff$export$23cd2842b44ca3e7 = $8ea582b0d1e4c2ff$var$EncryptedPrivateKeyInfo;
var $8ea582b0d1e4c2ff$var$DSAPrivateKey = $7nj2w.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('p').int(), this.key('q').int(), this.key('g').int(), this.key('pub_key').int(), this.key('priv_key').int());
});
$8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce = $8ea582b0d1e4c2ff$var$DSAPrivateKey;
$8ea582b0d1e4c2ff$export$8ad762e3e6399afe = $7nj2w.define('DSAparam', function() {
    this.int();
});
var $8ea582b0d1e4c2ff$var$ECPrivateKey = $7nj2w.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($8ea582b0d1e4c2ff$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0 = $8ea582b0d1e4c2ff$var$ECPrivateKey;
var $8ea582b0d1e4c2ff$var$ECParameters = $7nj2w.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$8ea582b0d1e4c2ff$export$c9cd164b539ebb63 = $7nj2w.define('signature', function() {
    this.seq().obj(this.key('r').int(), this.key('s').int());
});

});
parcelRegister("7nj2w", function(module, exports) {
var $55e9734436f4a826$var$asn1 = module.exports;

$55e9734436f4a826$var$asn1.bignum = (parcelRequire("61SlE"));

$55e9734436f4a826$var$asn1.define = (parcelRequire("6uEen")).define;

$55e9734436f4a826$var$asn1.base = (parcelRequire("gvyuX"));

$55e9734436f4a826$var$asn1.constants = (parcelRequire("cgbG6"));

$55e9734436f4a826$var$asn1.decoders = (parcelRequire("9EvL1"));

$55e9734436f4a826$var$asn1.encoders = (parcelRequire("i6gsd"));

});
parcelRegister("6uEen", function(module, exports) {

var $7nj2w = parcelRequire("7nj2w");

var $lyUaN = parcelRequire("lyUaN");
var $4ba4c06a7be5b446$var$api = module.exports;
$4ba4c06a7be5b446$var$api.define = function define(name, body) {
    return new $4ba4c06a7be5b446$var$Entity(name, body);
};
function $4ba4c06a7be5b446$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$4ba4c06a7be5b446$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("gLs15")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $lyUaN(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$4ba4c06a7be5b446$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($7nj2w.decoders[enc]);
    return this.decoders[enc];
};
$4ba4c06a7be5b446$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$4ba4c06a7be5b446$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($7nj2w.encoders[enc]);
    return this.encoders[enc];
};
$4ba4c06a7be5b446$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("gLs15", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("gvyuX", function(module, exports) {
var $c04a4d3689eb5b96$var$base = module.exports;

$c04a4d3689eb5b96$var$base.Reporter = (parcelRequire("5vbYl")).Reporter;

$c04a4d3689eb5b96$var$base.DecoderBuffer = (parcelRequire("hv1XP")).DecoderBuffer;

$c04a4d3689eb5b96$var$base.EncoderBuffer = (parcelRequire("hv1XP")).EncoderBuffer;

$c04a4d3689eb5b96$var$base.Node = (parcelRequire("kFkCQ"));

});
parcelRegister("5vbYl", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $4019227616839f63$export$957313a2f485e5ed, (v) => $4019227616839f63$export$957313a2f485e5ed = v);
var $4019227616839f63$export$957313a2f485e5ed;

var $lyUaN = parcelRequire("lyUaN");
function $4019227616839f63$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$4019227616839f63$export$957313a2f485e5ed = $4019227616839f63$var$Reporter;
$4019227616839f63$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $4019227616839f63$var$ReporterError;
};
$4019227616839f63$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$4019227616839f63$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$4019227616839f63$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$4019227616839f63$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$4019227616839f63$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$4019227616839f63$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$4019227616839f63$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$4019227616839f63$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$4019227616839f63$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $4019227616839f63$var$ReporterError;
    if (inherited) err = msg;
    else err = new $4019227616839f63$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$4019227616839f63$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $4019227616839f63$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$lyUaN($4019227616839f63$var$ReporterError, Error);
$4019227616839f63$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $4019227616839f63$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("hv1XP", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $cbd6daf20c01fb9a$export$bf9f79cdc4a49163, (v) => $cbd6daf20c01fb9a$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $cbd6daf20c01fb9a$export$8ff24f7760c7a78e, (v) => $cbd6daf20c01fb9a$export$8ff24f7760c7a78e = v);
var $cbd6daf20c01fb9a$export$bf9f79cdc4a49163;
var $cbd6daf20c01fb9a$export$8ff24f7760c7a78e;

var $lyUaN = parcelRequire("lyUaN");

var $gvyuX = parcelRequire("gvyuX");
var $cbd6daf20c01fb9a$require$Reporter = $gvyuX.Reporter;

var $aul3P = parcelRequire("aul3P");
var $cbd6daf20c01fb9a$require$Buffer = $aul3P.Buffer;
function $cbd6daf20c01fb9a$var$DecoderBuffer(base, options) {
    $cbd6daf20c01fb9a$require$Reporter.call(this, options);
    if (!$cbd6daf20c01fb9a$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$lyUaN($cbd6daf20c01fb9a$var$DecoderBuffer, $cbd6daf20c01fb9a$require$Reporter);
$cbd6daf20c01fb9a$export$bf9f79cdc4a49163 = $cbd6daf20c01fb9a$var$DecoderBuffer;
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $cbd6daf20c01fb9a$require$Reporter.prototype.save.call(this)
    };
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $cbd6daf20c01fb9a$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $cbd6daf20c01fb9a$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $cbd6daf20c01fb9a$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $cbd6daf20c01fb9a$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $cbd6daf20c01fb9a$var$EncoderBuffer)) item = new $cbd6daf20c01fb9a$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $cbd6daf20c01fb9a$require$Buffer.byteLength(value);
    } else if ($cbd6daf20c01fb9a$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$cbd6daf20c01fb9a$export$8ff24f7760c7a78e = $cbd6daf20c01fb9a$var$EncoderBuffer;
$cbd6daf20c01fb9a$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $cbd6daf20c01fb9a$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($cbd6daf20c01fb9a$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("kFkCQ", function(module, exports) {

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$Reporter = $gvyuX.Reporter;

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$EncoderBuffer = $gvyuX.EncoderBuffer;

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$DecoderBuffer = $gvyuX.DecoderBuffer;

var $aOIMZ = parcelRequire("aOIMZ");
// Supported tags
var $f0b7a2ced72bd4e2$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $f0b7a2ced72bd4e2$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($f0b7a2ced72bd4e2$var$tags);
// Overrided methods list
var $f0b7a2ced72bd4e2$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $f0b7a2ced72bd4e2$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $f0b7a2ced72bd4e2$var$Node;
var $f0b7a2ced72bd4e2$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$f0b7a2ced72bd4e2$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $f0b7a2ced72bd4e2$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$f0b7a2ced72bd4e2$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $f0b7a2ced72bd4e2$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$f0b7a2ced72bd4e2$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $aOIMZ(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aOIMZ.equal(state.children.length, 1, 'Root node can have only one child');
};
$f0b7a2ced72bd4e2$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aOIMZ(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aOIMZ(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$f0b7a2ced72bd4e2$var$overrided.forEach(function(method) {
    $f0b7a2ced72bd4e2$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$f0b7a2ced72bd4e2$var$tags.forEach(function(tag) {
    $f0b7a2ced72bd4e2$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $aOIMZ(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$f0b7a2ced72bd4e2$var$Node.prototype.use = function use(item) {
    $aOIMZ(item);
    var state = this._baseState;
    $aOIMZ(state.use === null);
    state.use = item;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $aOIMZ(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $aOIMZ(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $aOIMZ(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $aOIMZ(state.key === null);
    state.key = newKey;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $aOIMZ(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $aOIMZ(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$f0b7a2ced72bd4e2$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $f0b7a2ced72bd4e2$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$f0b7a2ced72bd4e2$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aOIMZ(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$f0b7a2ced72bd4e2$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$f0b7a2ced72bd4e2$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $f0b7a2ced72bd4e2$require$EncoderBuffer(data, this.reporter);
};
$f0b7a2ced72bd4e2$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $f0b7a2ced72bd4e2$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be ommited only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $aOIMZ(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$f0b7a2ced72bd4e2$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$f0b7a2ced72bd4e2$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("cgbG6", function(module, exports) {
var $8ed009b1b044eb12$var$constants = module.exports;
// Helper
$8ed009b1b044eb12$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$8ed009b1b044eb12$var$constants.der = (parcelRequire("iMa14"));

});
parcelRegister("iMa14", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $dab47ab30b53675f$export$3584c46ed60baee8, (v) => $dab47ab30b53675f$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $dab47ab30b53675f$export$f18596ef8d632e49, (v) => $dab47ab30b53675f$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $dab47ab30b53675f$export$2b067c6666111485, (v) => $dab47ab30b53675f$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $dab47ab30b53675f$export$f17df38a421ab9e3, (v) => $dab47ab30b53675f$export$f17df38a421ab9e3 = v);
var $dab47ab30b53675f$export$3584c46ed60baee8;
var $dab47ab30b53675f$export$f18596ef8d632e49;
var $dab47ab30b53675f$export$2b067c6666111485;
var $dab47ab30b53675f$export$f17df38a421ab9e3;

var $cgbG6 = parcelRequire("cgbG6");
$dab47ab30b53675f$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$dab47ab30b53675f$export$f18596ef8d632e49 = $cgbG6._reverse($dab47ab30b53675f$export$3584c46ed60baee8);
$dab47ab30b53675f$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$dab47ab30b53675f$export$f17df38a421ab9e3 = $cgbG6._reverse($dab47ab30b53675f$export$2b067c6666111485);

});


parcelRegister("9EvL1", function(module, exports) {
var $70707bd996b6328a$var$decoders = module.exports;

$70707bd996b6328a$var$decoders.der = (parcelRequire("1fGAm"));

$70707bd996b6328a$var$decoders.pem = (parcelRequire("kKHKZ"));

});
parcelRegister("1fGAm", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $7nj2w = parcelRequire("7nj2w");
var $0e9839ba2999c100$var$base = $7nj2w.base;
var $0e9839ba2999c100$var$bignum = $7nj2w.bignum;
// Import DER constants
var $0e9839ba2999c100$var$der = $7nj2w.constants.der;
function $0e9839ba2999c100$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $0e9839ba2999c100$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $0e9839ba2999c100$var$DERDecoder;
$0e9839ba2999c100$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $0e9839ba2999c100$var$base.DecoderBuffer)) data = new $0e9839ba2999c100$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $0e9839ba2999c100$var$DERNode(parent) {
    $0e9839ba2999c100$var$base.Node.call(this, 'der', parent);
}
$lyUaN($0e9839ba2999c100$var$DERNode, $0e9839ba2999c100$var$base.Node);
$0e9839ba2999c100$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $0e9839ba2999c100$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $0e9839ba2999c100$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $0e9839ba2999c100$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$0e9839ba2999c100$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $0e9839ba2999c100$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $0e9839ba2999c100$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$0e9839ba2999c100$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$0e9839ba2999c100$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$0e9839ba2999c100$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $0e9839ba2999c100$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$0e9839ba2999c100$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $0e9839ba2999c100$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $0e9839ba2999c100$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $0e9839ba2999c100$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $0e9839ba2999c100$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("kKHKZ", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $aul3P = parcelRequire("aul3P");
var $f1ba0bbf43f136ce$require$Buffer = $aul3P.Buffer;

var $1fGAm = parcelRequire("1fGAm");
function $f1ba0bbf43f136ce$var$PEMDecoder(entity) {
    $1fGAm.call(this, entity);
    this.enc = 'pem';
}
$lyUaN($f1ba0bbf43f136ce$var$PEMDecoder, $1fGAm);
module.exports = $f1ba0bbf43f136ce$var$PEMDecoder;
$f1ba0bbf43f136ce$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $f1ba0bbf43f136ce$require$Buffer(base64, 'base64');
    return $1fGAm.prototype.decode.call(this, input, options);
};

});


parcelRegister("i6gsd", function(module, exports) {
var $d2d58cf9aaab919e$var$encoders = module.exports;

$d2d58cf9aaab919e$var$encoders.der = (parcelRequire("87XP3"));

$d2d58cf9aaab919e$var$encoders.pem = (parcelRequire("2eIuS"));

});
parcelRegister("87XP3", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $aul3P = parcelRequire("aul3P");
var $5ead61af4dab57dd$require$Buffer = $aul3P.Buffer;

var $7nj2w = parcelRequire("7nj2w");
var $5ead61af4dab57dd$var$base = $7nj2w.base;
// Import DER constants
var $5ead61af4dab57dd$var$der = $7nj2w.constants.der;
function $5ead61af4dab57dd$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $5ead61af4dab57dd$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $5ead61af4dab57dd$var$DEREncoder;
$5ead61af4dab57dd$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $5ead61af4dab57dd$var$DERNode(parent) {
    $5ead61af4dab57dd$var$base.Node.call(this, 'der', parent);
}
$lyUaN($5ead61af4dab57dd$var$DERNode, $5ead61af4dab57dd$var$base.Node);
$5ead61af4dab57dd$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $5ead61af4dab57dd$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $5ead61af4dab57dd$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $5ead61af4dab57dd$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $5ead61af4dab57dd$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $5ead61af4dab57dd$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $5ead61af4dab57dd$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$5ead61af4dab57dd$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $5ead61af4dab57dd$var$two(date.getFullYear()),
        $5ead61af4dab57dd$var$two(date.getUTCMonth() + 1),
        $5ead61af4dab57dd$var$two(date.getUTCDate()),
        $5ead61af4dab57dd$var$two(date.getUTCHours()),
        $5ead61af4dab57dd$var$two(date.getUTCMinutes()),
        $5ead61af4dab57dd$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $5ead61af4dab57dd$var$two(date.getFullYear() % 100),
        $5ead61af4dab57dd$var$two(date.getUTCMonth() + 1),
        $5ead61af4dab57dd$var$two(date.getUTCDate()),
        $5ead61af4dab57dd$var$two(date.getUTCHours()),
        $5ead61af4dab57dd$var$two(date.getUTCMinutes()),
        $5ead61af4dab57dd$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$5ead61af4dab57dd$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $5ead61af4dab57dd$require$Buffer(numArray);
    }
    if ($5ead61af4dab57dd$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $5ead61af4dab57dd$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $5ead61af4dab57dd$require$Buffer(out));
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$5ead61af4dab57dd$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$5ead61af4dab57dd$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $5ead61af4dab57dd$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($5ead61af4dab57dd$var$der.tagByName.hasOwnProperty(tag)) res = $5ead61af4dab57dd$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $5ead61af4dab57dd$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("2eIuS", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $87XP3 = parcelRequire("87XP3");
function $1a0f67c4be613f4f$var$PEMEncoder(entity) {
    $87XP3.call(this, entity);
    this.enc = 'pem';
}
$lyUaN($1a0f67c4be613f4f$var$PEMEncoder, $87XP3);
module.exports = $1a0f67c4be613f4f$var$PEMEncoder;
$1a0f67c4be613f4f$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $87XP3.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("hZGUx", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $7nj2w = parcelRequire("7nj2w");
var $d1996b602810d0a2$var$Time = $7nj2w.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $d1996b602810d0a2$var$AttributeTypeValue = $7nj2w.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $d1996b602810d0a2$var$AlgorithmIdentifier = $7nj2w.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional());
});
var $d1996b602810d0a2$var$SubjectPublicKeyInfo = $7nj2w.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $d1996b602810d0a2$var$RelativeDistinguishedName = $7nj2w.define('RelativeDistinguishedName', function() {
    this.setof($d1996b602810d0a2$var$AttributeTypeValue);
});
var $d1996b602810d0a2$var$RDNSequence = $7nj2w.define('RDNSequence', function() {
    this.seqof($d1996b602810d0a2$var$RelativeDistinguishedName);
});
var $d1996b602810d0a2$var$Name = $7nj2w.define('Name', function() {
    this.choice({
        rdnSequence: this.use($d1996b602810d0a2$var$RDNSequence)
    });
});
var $d1996b602810d0a2$var$Validity = $7nj2w.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($d1996b602810d0a2$var$Time), this.key('notAfter').use($d1996b602810d0a2$var$Time));
});
var $d1996b602810d0a2$var$Extension = $7nj2w.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $d1996b602810d0a2$var$TBSCertificate = $7nj2w.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0).int(), this.key('serialNumber').int(), this.key('signature').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('issuer').use($d1996b602810d0a2$var$Name), this.key('validity').use($d1996b602810d0a2$var$Validity), this.key('subject').use($d1996b602810d0a2$var$Name), this.key('subjectPublicKeyInfo').use($d1996b602810d0a2$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($d1996b602810d0a2$var$Extension).optional());
});
var $d1996b602810d0a2$var$X509Certificate = $7nj2w.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($d1996b602810d0a2$var$TBSCertificate), this.key('signatureAlgorithm').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $d1996b602810d0a2$var$X509Certificate;

});


parcelRegister("fJ1z5", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("1qG0a", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip

var $aul3P = parcelRequire("aul3P");
var $10a8cccf60464d54$require$Buffer = $aul3P.Buffer;
var $10a8cccf60464d54$var$findProc = /Proc-Type: 4,ENCRYPTED\n\r?DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\n\r?\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?/m;
var $10a8cccf60464d54$var$startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n/m;
var $10a8cccf60464d54$var$fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?-----END \1-----$/m;

var $d9sFZ = parcelRequire("d9sFZ");

var $FyTgm = parcelRequire("FyTgm");
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($10a8cccf60464d54$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($10a8cccf60464d54$var$fullRegex);
        decrypted = new $10a8cccf60464d54$require$Buffer(match2[2].replace(/\r?\n/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = new $10a8cccf60464d54$require$Buffer(match[2], 'hex');
        var cipherText = new $10a8cccf60464d54$require$Buffer(match[3].replace(/\r?\n/g, ''), 'base64');
        var cipherKey = $d9sFZ(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $FyTgm.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $10a8cccf60464d54$require$Buffer.concat(out);
    }
    var tag = key.match($10a8cccf60464d54$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("fyXn0", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("bdxL8", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $aul3P = parcelRequire("aul3P");
var $82ab18793442ce1b$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $82ab18793442ce1b$require$EC = $6nTxf.ec;

var $lXsfV = parcelRequire("lXsfV");

var $fyXn0 = parcelRequire("fyXn0");
function $82ab18793442ce1b$var$verify(sig, hash, key, signType, tag) {
    var pub = $lXsfV(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $82ab18793442ce1b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $82ab18793442ce1b$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    }
    hash = $82ab18793442ce1b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = new $82ab18793442ce1b$require$Buffer(pad);
    var red = $61SlE.mont(pub.modulus);
    sig = new $61SlE(sig).toRed(red);
    sig = sig.redPow(new $61SlE(pub.publicExponent));
    sig = new $82ab18793442ce1b$require$Buffer(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $82ab18793442ce1b$var$ecVerify(sig, hash, pub) {
    var curveId = $fyXn0[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $82ab18793442ce1b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $82ab18793442ce1b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $lXsfV.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $82ab18793442ce1b$var$checkValue(s, q);
    $82ab18793442ce1b$var$checkValue(r, q);
    var montp = $61SlE.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $61SlE(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $82ab18793442ce1b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= q) throw new Error('invalid sig');
}
module.exports = $82ab18793442ce1b$var$verify;

});


parcelRegister("ks6qZ", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $ee3b69e69526809e$require$Buffer = $aul3P.Buffer;

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");
module.exports = function createECDH(curve) {
    return new $ee3b69e69526809e$var$ECDH(curve);
};
var $ee3b69e69526809e$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$ee3b69e69526809e$var$aliases.p224 = $ee3b69e69526809e$var$aliases.secp224r1;
$ee3b69e69526809e$var$aliases.p256 = $ee3b69e69526809e$var$aliases.secp256r1 = $ee3b69e69526809e$var$aliases.prime256v1;
$ee3b69e69526809e$var$aliases.p192 = $ee3b69e69526809e$var$aliases.secp192r1 = $ee3b69e69526809e$var$aliases.prime192v1;
$ee3b69e69526809e$var$aliases.p384 = $ee3b69e69526809e$var$aliases.secp384r1;
$ee3b69e69526809e$var$aliases.p521 = $ee3b69e69526809e$var$aliases.secp521r1;
function $ee3b69e69526809e$var$ECDH(curve) {
    this.curveType = $ee3b69e69526809e$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $6nTxf.ec(this.curveType.name);
    this.keys = void 0;
}
$ee3b69e69526809e$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$ee3b69e69526809e$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(other)) other = new $ee3b69e69526809e$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $ee3b69e69526809e$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$ee3b69e69526809e$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $ee3b69e69526809e$var$formatReturnValue(key, enc);
};
$ee3b69e69526809e$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $ee3b69e69526809e$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$ee3b69e69526809e$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(pub)) pub = new $ee3b69e69526809e$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$ee3b69e69526809e$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(priv)) priv = new $ee3b69e69526809e$require$Buffer(priv, enc);
    var _priv = new $61SlE(priv);
    _priv = _priv.toString(16);
    this.keys._importPrivate(_priv);
    return this;
};
function $ee3b69e69526809e$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $ee3b69e69526809e$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $ee3b69e69526809e$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $ee3b69e69526809e$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("bZRnR", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $8bbecd28b745cfbe$export$512823e338ddb1b7, (v) => $8bbecd28b745cfbe$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $8bbecd28b745cfbe$export$7efb24e2fddf99b9, (v) => $8bbecd28b745cfbe$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3, (v) => $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $8bbecd28b745cfbe$export$b9d55ff329113abd, (v) => $8bbecd28b745cfbe$export$b9d55ff329113abd = v);
var $8bbecd28b745cfbe$export$512823e338ddb1b7;
var $8bbecd28b745cfbe$export$7efb24e2fddf99b9;
var $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3;
var $8bbecd28b745cfbe$export$b9d55ff329113abd;

$8bbecd28b745cfbe$export$512823e338ddb1b7 = (parcelRequire("bFrdv"));

$8bbecd28b745cfbe$export$7efb24e2fddf99b9 = (parcelRequire("9r10x"));
$8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $8bbecd28b745cfbe$export$512823e338ddb1b7(key, buf, true);
};
$8bbecd28b745cfbe$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $8bbecd28b745cfbe$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("bFrdv", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $87e8a2b93b4dc2f1$require$Buffer = $aul3P.Buffer;

var $lXsfV = parcelRequire("lXsfV");

var $ugwNY = parcelRequire("ugwNY");

var $cnL2y = parcelRequire("cnL2y");

var $6y9Gi = parcelRequire("6y9Gi");

var $dphJC = parcelRequire("dphJC");

var $61SlE = parcelRequire("61SlE");

var $6P0f1 = parcelRequire("6P0f1");

var $kFMzy = parcelRequire("kFMzy");
var $87e8a2b93b4dc2f1$var$constants = {
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_PKCS1_PADDIN: 1,
    RSA_NO_PADDING: 3
};
module.exports = function publicEncrypt(public_key, msg, reverse) {
    var padding;
    if (public_key.padding) padding = public_key.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lXsfV(public_key);
    var paddedMsg;
    if (padding === 4) paddedMsg = $87e8a2b93b4dc2f1$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $87e8a2b93b4dc2f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $61SlE(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $kFMzy(paddedMsg, key);
    else return $6P0f1(paddedMsg, key);
};
function $87e8a2b93b4dc2f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $cnL2y('sha1').update(new $87e8a2b93b4dc2f1$require$Buffer('')).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = new $87e8a2b93b4dc2f1$require$Buffer(k - mLen - hLen2 - 2);
    ps.fill(0);
    var dblen = k - hLen - 1;
    var seed = $ugwNY(hLen);
    var maskedDb = $dphJC($87e8a2b93b4dc2f1$require$Buffer.concat([
        iHash,
        ps,
        new $87e8a2b93b4dc2f1$require$Buffer([
            1
        ]),
        msg
    ], dblen), $6y9Gi(seed, dblen));
    var maskedSeed = $dphJC(seed, $6y9Gi(maskedDb, hLen));
    return new $61SlE($87e8a2b93b4dc2f1$require$Buffer.concat([
        new $87e8a2b93b4dc2f1$require$Buffer([
            0
        ]),
        maskedSeed,
        maskedDb
    ], k));
}
function $87e8a2b93b4dc2f1$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) {
        ps = new $87e8a2b93b4dc2f1$require$Buffer(k - mLen - 3);
        ps.fill(0xff);
    } else ps = $87e8a2b93b4dc2f1$var$nonZero(k - mLen - 3);
    return new $61SlE($87e8a2b93b4dc2f1$require$Buffer.concat([
        new $87e8a2b93b4dc2f1$require$Buffer([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        new $87e8a2b93b4dc2f1$require$Buffer([
            0
        ]),
        msg
    ], k));
}
function $87e8a2b93b4dc2f1$var$nonZero(len, crypto) {
    var out = new $87e8a2b93b4dc2f1$require$Buffer(len);
    var i = 0;
    var cache = $ugwNY(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $ugwNY(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("6y9Gi", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $4c4d6d8832c8b18b$require$Buffer = $aul3P.Buffer;

var $cnL2y = parcelRequire("cnL2y");
module.exports = function(seed, len) {
    var t = new $4c4d6d8832c8b18b$require$Buffer('');
    var i = 0, c;
    while(t.length < len){
        c = $4c4d6d8832c8b18b$var$i2ops(i++);
        t = $4c4d6d8832c8b18b$require$Buffer.concat([
            t,
            $cnL2y('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4c4d6d8832c8b18b$var$i2ops(c) {
    var out = new $4c4d6d8832c8b18b$require$Buffer(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("dphJC", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6P0f1", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $4f77b16f6d4bef69$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");
function $4f77b16f6d4bef69$var$withPublic(paddedMsg, key) {
    return new $4f77b16f6d4bef69$require$Buffer(paddedMsg.toRed($61SlE.mont(key.modulus)).redPow(new $61SlE(key.publicExponent)).fromRed().toArray());
}
module.exports = $4f77b16f6d4bef69$var$withPublic;

});


parcelRegister("9r10x", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $6de76ac48d76b0c4$require$Buffer = $aul3P.Buffer;

var $lXsfV = parcelRequire("lXsfV");

var $6y9Gi = parcelRequire("6y9Gi");

var $dphJC = parcelRequire("dphJC");

var $61SlE = parcelRequire("61SlE");

var $kFMzy = parcelRequire("kFMzy");

var $cnL2y = parcelRequire("cnL2y");

var $6P0f1 = parcelRequire("6P0f1");
module.exports = function privateDecrypt(private_key, enc, reverse) {
    var padding;
    if (private_key.padding) padding = private_key.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lXsfV(private_key);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $61SlE(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $6P0f1(new $61SlE(enc), key);
    else msg = $kFMzy(enc, key);
    var zBuffer = new $6de76ac48d76b0c4$require$Buffer(k - msg.length);
    zBuffer.fill(0);
    msg = $6de76ac48d76b0c4$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $6de76ac48d76b0c4$var$oaep(key, msg);
    else if (padding === 1) return $6de76ac48d76b0c4$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $6de76ac48d76b0c4$var$oaep(key, msg) {
    var n = key.modulus;
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $cnL2y('sha1').update(new $6de76ac48d76b0c4$require$Buffer('')).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $dphJC(maskedSeed, $6y9Gi(maskedDb, hLen));
    var db = $dphJC(maskedDb, $6y9Gi(seed, k - hLen - 1));
    if ($6de76ac48d76b0c4$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $6de76ac48d76b0c4$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    var p2 = msg.slice(i - 1, i);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $6de76ac48d76b0c4$var$compare(a, b) {
    a = new $6de76ac48d76b0c4$require$Buffer(a);
    b = new $6de76ac48d76b0c4$require$Buffer(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("hF130", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $cdb7140970b08e8d$export$bb1abf2ce84fc7e8, (v) => $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $cdb7140970b08e8d$export$2f7171e78e524d5e, (v) => $cdb7140970b08e8d$export$2f7171e78e524d5e = v);
var $cdb7140970b08e8d$export$bb1abf2ce84fc7e8;
var $cdb7140970b08e8d$export$2f7171e78e524d5e;

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $cdb7140970b08e8d$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $ijh2q = parcelRequire("ijh2q");

var $ugwNY = parcelRequire("ugwNY");
var $cdb7140970b08e8d$var$Buffer = $ijh2q.Buffer;
var $cdb7140970b08e8d$var$kBufferMaxLength = $ijh2q.kMaxLength;
var $cdb7140970b08e8d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $cdb7140970b08e8d$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $cdb7140970b08e8d$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $cdb7140970b08e8d$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $cdb7140970b08e8d$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $cdb7140970b08e8d$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $cdb7140970b08e8d$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $cdb7140970b08e8d$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($cdb7140970b08e8d$var$crypto && $cdb7140970b08e8d$var$crypto.getRandomValues || false) {
    $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = $cdb7140970b08e8d$var$randomFill;
    $cdb7140970b08e8d$export$2f7171e78e524d5e = $cdb7140970b08e8d$var$randomFillSync;
} else {
    $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = $cdb7140970b08e8d$var$oldBrowser;
    $cdb7140970b08e8d$export$2f7171e78e524d5e = $cdb7140970b08e8d$var$oldBrowser;
}
function $cdb7140970b08e8d$var$randomFill(buf, offset, size, cb) {
    if (!$cdb7140970b08e8d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $cdb7140970b08e8d$var$assertOffset(offset, buf.length);
    $cdb7140970b08e8d$var$assertSize(size, offset, buf.length);
    return $cdb7140970b08e8d$var$actualFill(buf, offset, size, cb);
}
function $cdb7140970b08e8d$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $cdb7140970b08e8d$var$crypto.getRandomValues(uint);
    if (cb) {
        $2fFJv.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $ugwNY(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $ugwNY(size);
    bytes.copy(buf, offset);
    return buf;
}
function $cdb7140970b08e8d$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$cdb7140970b08e8d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $cdb7140970b08e8d$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $cdb7140970b08e8d$var$assertSize(size, offset, buf.length);
    return $cdb7140970b08e8d$var$actualFill(buf, offset, size);
}

});



parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("bICpe", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $13683bbd54f5e2c1$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $13683bbd54f5e2c1$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $13683bbd54f5e2c1$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $13683bbd54f5e2c1$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $13683bbd54f5e2c1$export$60d56ed3961c839c);

var $9OdO2 = parcelRequire("9OdO2");

var $azx3n = parcelRequire("azx3n");
const $13683bbd54f5e2c1$export$d05672fd1312a6d = (val)=>(0, $azx3n.memoizedHashString)(val.toString()).toString();
const $13683bbd54f5e2c1$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$13683bbd54f5e2c1$export$d05672fd1312a6d(value));
const $13683bbd54f5e2c1$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(optionGroups.map((group)=>group.options));
const $13683bbd54f5e2c1$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
const $13683bbd54f5e2c1$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("63Mv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a079fc0d1c4986e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a079fc0d1c4986e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-labels.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-labels.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-labels.edit.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue-field-labels.edit.create-new-item",
        "defaultMessage": "New label"
    },
    loading: {
        "id": "issue-field-labels.edit.loading",
        "defaultMessage": "Searching..."
    },
    recent: {
        "id": "issue-field-labels.edit.recent",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue-field-labels.edit.all",
        "defaultMessage": "All labels"
    }
});

});


parcelRegister("6Wef2", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $1a006528ac4d483a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mutateLabelsFields", () => $1a006528ac4d483a$export$f691a7c5b86be653);

const $1a006528ac4d483a$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name })=>({
            value: name,
            label: name
        }));
const $1a006528ac4d483a$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
        fieldId: fieldId,
        labels: selectedLabels.map(({ value: value })=>({
                name: value
            })),
        mutationGroup: (0, $f4d348fab48bf1e9$export$31fd86f8f183952c)
    });

});
const $f4d348fab48bf1e9$export$31fd86f8f183952c = 'labelsFields';




parcelRegister("bfJSC", function(module, exports) {

$parcel$export(module.exports, "LabelsFieldTypeConfig", () => $a4e982eef0a39443$export$e4c3d82c6a697032);

var $eUqFw = parcelRequire("eUqFw");

var $l7nwo = parcelRequire("l7nwo");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $a4e982eef0a39443$var$LabelsFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7nwo.default), props);
const $a4e982eef0a39443$export$e4c3d82c6a697032 = {
    type: (0, $lO4Or.LABELS_TYPE),
    Component: $a4e982eef0a39443$var$LabelsFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.labelsFieldWriter)
};

});

parcelRegister("8nL8u", function(module, exports) {

$parcel$export(module.exports, "MultiCheckboxesCustomFieldTypeConfig", () => $249e312d274ea5ff$export$29399cace92d6d05);

var $eUqFw = parcelRequire("eUqFw");

var $6ynFi = parcelRequire("6ynFi");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $249e312d274ea5ff$var$MultiCheckboxesCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ynFi.default), props);
const $249e312d274ea5ff$export$29399cace92d6d05 = {
    type: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    Component: $249e312d274ea5ff$var$MultiCheckboxesCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.checkboxSelectFieldWriter)
};

});
parcelRegister("6ynFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $142ded1e16a3a44b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dibFF = parcelRequire("dibFF");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $8ZEDa = parcelRequire("8ZEDa");

var $d7a37 = parcelRequire("d7a37");

var $gGtKh = parcelRequire("gGtKh");

var $7TaJX = parcelRequire("7TaJX");

const $142ded1e16a3a44b$var$CheckboxSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false } = props;
    const options = (0, $d7a37.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-checkbox-select-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZEDa.AsyncCheckboxSelectEdit), {
        ...fieldProps,
        options: options,
        value: value,
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly
    })));
};
var $142ded1e16a3a44b$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCheckboxField),
    transformDefaultValue: (0, $d7a37.mapDataToOptions)
})($142ded1e16a3a44b$var$CheckboxSelectField);

});
parcelRegister("8ZEDa", function(module, exports) {

$parcel$export(module.exports, "AsyncCheckboxSelectEdit", () => $70e0995699598355$export$48ad7b39ee5392c2);

var $7rh0R = parcelRequire("7rh0R");

const $70e0995699598355$export$48ad7b39ee5392c2 = (0, $7rh0R.lazy)(()=>(parcelRequire("4QRfY")).then((module)=>module.CheckboxSelectEdit), {
    moduleId: "./src/packages/issue/fields/checkbox-select/src/index.tsx"
});

});
parcelRegister("4QRfY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("coVry").then(()=>parcelRequire('kXRO4'));

});




parcelRegister("2O5Nv", function(module, exports) {

$parcel$export(module.exports, "MultiGroupCustomFieldTypeConfig", () => $22885290ef30d63a$export$62823f7adb904a12);

var $eUqFw = parcelRequire("eUqFw");

var $8AMXG = parcelRequire("8AMXG");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $22885290ef30d63a$var$MultiGroupCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8AMXG.default), props);
const $22885290ef30d63a$export$62823f7adb904a12 = {
    type: (0, $lO4Or.MULTI_GROUP_CF_TYPE),
    Component: $22885290ef30d63a$var$MultiGroupCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.multipleGroupPickerFieldWriter)
};

});
parcelRegister("8AMXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf315aff35606e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fXyiT = parcelRequire("fXyiT");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $dvJOo = parcelRequire("dvJOo");

var $7TaJX = parcelRequire("7TaJX");

var $ksJvI = parcelRequire("ksJvI");
const $7bf315aff35606e2$var$MultiGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $fXyiT.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvJOo.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isMulti: true,
        placeholder: " ",
        ...getExtraProps()
    }));
};
var $7bf315aff35606e2$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateGroupPickerField),
    transformDefaultValue: (0, $ksJvI.transformGroupDefaultValueToUserOption)
})($7bf315aff35606e2$var$MultiGroupPickerField);

});
parcelRegister("ksJvI", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $9c62fe3b8ccb2570$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateMultipleGroupPickerField", () => $9c62fe3b8ccb2570$export$8cb86783be488510);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $gnxL7 = parcelRequire("gnxL7");

const $9c62fe3b8ccb2570$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    if (Array.isArray(group)) return group.map((groupItem)=>(0, $gnxL7.transformGroupToUserOption)(groupItem));
    return (0, $gnxL7.transformGroupToUserOption)(group);
};
const $9c62fe3b8ccb2570$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
        fieldId: fieldId,
        groups: selectedGroups.map(({ name: name })=>({
                groupName: name
            })),
        mutationGroup: (0, $1be53a03bb30e458$export$31fd86f8f183952c)
    });

});
const $1be53a03bb30e458$export$31fd86f8f183952c = 'multipleGroupPickerFields';




parcelRegister("5jPiu", function(module, exports) {

$parcel$export(module.exports, "MultiSelectCustomFieldTypeConfig", () => $c4602419f507981d$export$1203387d0e5999ed);

var $eUqFw = parcelRequire("eUqFw");

var $hQhuO = parcelRequire("hQhuO");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $c4602419f507981d$var$MultiSelectCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hQhuO.default), {
        ...props,
        defaultValue: undefined
    });
const $c4602419f507981d$export$1203387d0e5999ed = {
    type: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    Component: $c4602419f507981d$var$MultiSelectCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.multiSelectFieldWriter)
};

});
parcelRegister("hQhuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e32c6ac3be7f6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jRCtV = parcelRequire("jRCtV");

const $50e32c6ac3be7f6d$var$MultiSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRCtV.default), {
        ...props,
        isMulti: true
    });
var $50e32c6ac3be7f6d$export$2e2bcd8739ae039 = $50e32c6ac3be7f6d$var$MultiSelectField;

});


parcelRegister("4cIkL", function(module, exports) {

$parcel$export(module.exports, "MultiUserCustomFieldTypeConfig", () => $8ead3e9d321f930b$export$e61985ad3f4b288f);

var $eUqFw = parcelRequire("eUqFw");

var $7EBWy = parcelRequire("7EBWy");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $8ead3e9d321f930b$export$e61985ad3f4b288f = {
    type: (0, $lO4Or.MULTI_USER_CF_TYPE),
    Component: (0, $7EBWy.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.AssigneeFieldPlaceholder), null),
    writer: (0, $eHQA5.multiUserPickerFieldWriter)
};

});
parcelRegister("7EBWy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70572f948a859a6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b7b1I = parcelRequire("b7b1I");
const $e70572f948a859a6$var$MultiUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7b1I.default), {
        ...props,
        isMulti: true,
        context: "CustomMultiUserField"
    });
var $e70572f948a859a6$export$2e2bcd8739ae039 = $e70572f948a859a6$var$MultiUserPickerField;

});
parcelRegister("b7b1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $44490b1e46778077$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l760E = parcelRequire("l760E");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $6HoNR = parcelRequire("6HoNR");

var $icPhQ = parcelRequire("icPhQ");

var $bRVha = parcelRequire("bRVha");
const $44490b1e46778077$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: context,
        ...projectKey && {
            project: projectKey
        },
        ...fieldId && {
            fieldId: fieldId
        },
        query: ''
    })}`;
const $44490b1e46778077$var$UserPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l760E.default), {
        autoCompleteUrl: $44490b1e46778077$var$getAutoCompleteUrl(context, fieldId, selectedProject?.projectKey),
        placeholder: placeholder,
        isDisabled: isReadOnly || isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: isMulti,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true,
        width: width,
        inputId: id,
        onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    }));
};
var $44490b1e46778077$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateUserPickerField),
    transformDefaultValue: (0, $bRVha.transformDefaultUserValues)
})($44490b1e46778077$var$UserPickerField);

});
parcelRegister("l760E", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d78b4e0f4b8d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f6ziy = parcelRequire("f6ziy");
var $fXyiT = parcelRequire("fXyiT");
const $486d78b4e0f4b8d2$var$UserPickerEdit = (props)=>{
    const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
    const extraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            styles: (0, $fXyiT.defaultUserPickerStyles),
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        return {
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6ziy.default), {
        ...fieldProps,
        fieldId: fieldId,
        inputId: inputId,
        appearance: appearance,
        width: width,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        fetchSuggestions: fetchSuggestions,
        emptyOption: emptyOption,
        onSelection: onSelection,
        onDataLoaded: onDataLoaded,
        onDataRequest: onDataRequest,
        onCancel: onCancel,
        isDropdownVisibleByDefault: isDropdownVisibleByDefault,
        isClearable: isClearable,
        isBulkEdit: isBulkEdit,
        ...extraProps()
    });
};
var $486d78b4e0f4b8d2$export$2e2bcd8739ae039 = $486d78b4e0f4b8d2$var$UserPickerEdit;

});
parcelRegister("f6ziy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5419167c244652a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $jYnpi = parcelRequire("jYnpi");

var $lRmyA = parcelRequire("lRmyA");

var $5JgJ2 = parcelRequire("5JgJ2");


var $iVXi8 = parcelRequire("iVXi8");

var $aofgi = parcelRequire("aofgi");
const $d5419167c244652a$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $d5419167c244652a$export$251bdbdbce9550ea = 400;
const $d5419167c244652a$var$UserPickerWrapper = (props)=>{
    const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSelection: onSelection = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDataRequest: onDataRequest = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDataLoaded: onDataLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, ...fieldProps } = props;
    const [isDropdownVisible, setIsDropdownVisible] = (0, $eUqFw.useState)(Boolean(isDropdownVisibleByDefault));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // null instead of '' because:
    // 1. fetchSuggestions is called as part of useEffect with query as one of the dependencies
    // 2. we dont want to call fetchSuggestions on mount, so added a check query !== null
    // 3. we want to call fetchSuggestions when query is '' and when picker gets focused (we set query as '') when it gets focused
    const [query, setQueryString] = (0, $eUqFw.useState)(null);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [wasFocused, setWasFocused] = (0, $eUqFw.useState)(false);
    const [wasCleared, setWasCleared] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)([]);
    const [sessionId, setSessionId] = (0, $eUqFw.useState)('');
    const getEmptyValue = ()=>emptyOption ? {
            ...emptyOption,
            id: (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c)
        } : null;
    const debounceTime = withoutDebounce ? 0 : $d5419167c244652a$export$251bdbdbce9550ea;
    const requestSuggestionsDebounced = (0, $eUqFw.useMemo)(()=>{
        const isCurrentValue = (userOptionValue)=>{
            if (!userOptionValue) return value === null;
            if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c);
            return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c);
        };
        const fetchSuggestions = async ()=>{
            let users = [];
            if (autoCompleteUrl !== undefined) {
                const autoCompleteResponse = await (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                users = (0, $aofgi.mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
            }
            return users.map((userData)=>(0, $aofgi.mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
        };
        const handleSuggestions = (newSuggestions)=>{
            if (!isDropdownVisible || !newSuggestions) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
            setIsLoading(false);
            setSuggestions(filteredSuggestions);
            onDataLoaded(!query, filteredSuggestions.length);
        };
        const handleError = ()=>{
            setIsLoading(false);
            setSuggestions([]);
        };
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const requestSuggestions = ()=>{
            onDataRequest(!query);
            const { fetchSuggestions: fetchSuggestionsProps } = props;
            if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                handleSuggestions(results);
            }).catch(handleError);
            return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            requestSuggestions();
        }, debounceTime);
    }, [
        debounceTime,
        value,
        autoCompleteUrl,
        query,
        isBulkEdit,
        shouldShowEmailInOptions,
        isDropdownVisible,
        wasFocused,
        onDataLoaded,
        onDataRequest,
        props,
        sessionId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Added extra !isDropdownVisible condition - avoid query when dropdown is closed
        if (query === null || !isDropdownVisible) return;
        requestSuggestionsDebounced();
        return ()=>{
            requestSuggestionsDebounced.cancel();
        };
    }, [
        requestSuggestionsDebounced,
        query,
        isDropdownVisible
    ]);
    const onSelectedValueChangeMulti = (userOptionValue)=>{
        if (userOptionValue && userOptionValue.length === 0) onChange(null);
        else onChange(userOptionValue);
    };
    const onSelectedValueChangeSingle = (userOptionValue)=>{
        const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
        if (valueId === (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c)) onChange(null);
        else onChange(userOptionValue);
    };
    const onSuggestionSelect = (userOptionValue, sId)=>{
        setSessionId(sId || '');
        setWasFocused(false);
        setWasCleared(false);
        setIsLoading(false);
        setSuggestions([]);
        onSelection(sessionId);
        if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
        else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelectedValueChangeSingle(userOptionValue);
    };
    const onBlur = ()=>{
        setIsDropdownVisible(false);
        setIsLoading(false);
        setWasFocused(false);
        setSuggestions([]);
        if (wasCleared) {
            onSuggestionSelect(getEmptyValue());
            return;
        }
        onCancel();
    };
    const onDropdownOpen = (sId)=>{
        setSessionId(sId || '');
        setQueryString('');
        setIsDropdownVisible(true);
        setIsLoading(true);
        setWasFocused(true);
        setWasCleared(false);
    };
    const onQueryChange = (queryStr, sId)=>{
        setSessionId(sId || '');
        setQueryString(queryStr || '');
        setIsLoading(!!queryStr);
        setWasFocused(false);
        setIsDropdownVisible(!!queryStr);
    };
    const onClear = ()=>{
        setWasCleared(true);
        onSuggestionSelect(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const closeMenuOnScroll = (e)=>{
        if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const isMatchingQuery = (suggestion)=>{
        // when feature flag is false the predict should allow all
        const { displayName: displayName, name: name } = suggestion;
        return !isLoading || $d5419167c244652a$var$stringContains(displayName, query) || $d5419167c244652a$var$stringContains(name, query);
    };
    const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
    const filteredSuggestions = getSuggestions();
    const pickerValue = value || getEmptyValue();
    const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, $iVXi8.default).emptyQueryMessage) : undefined;
    /*
   * user picker default opens on focus, so most of the operations like loading, querying, dropdown open/close are modified during onFocus
   * when openMenuOnClick is true then dropdown state managed internally as like select then have to use onOpen to modify any state like loading, querying
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: onDropdownOpen
    } : {
        open: isDropdownVisible,
        onFocus: onDropdownOpen
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        value: pickerValue,
        options: filteredSuggestions,
        isMulti: isMulti,
        fieldId: fieldId,
        menuMinWidth: props.menuMinWidth,
        menuPortalTarget: portalElement,
        width: width,
        appearance: appearance,
        isClearable: isClearable,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        placeholder: placeholder,
        onBlur: onBlur,
        isLoading: isLoading && isDropdownVisible,
        onClear: onClear,
        onInputChange: onQueryChange,
        onChange: onSuggestionSelect,
        noBorder: noBorder,
        styles: styles,
        noOptionsMessage: getNoOptionsMessage,
        allowEmail: allowEmail,
        inputId: inputId,
        required: isRequired,
        ariaLabel: fieldProps['aria-label'],
        ariaLabelledBy: fieldProps['aria-labelledby'],
        closeMenuOnScroll: closeMenuOnScroll,
        menuPosition: menuPosition,
        ...controlProps
    });
};
var $d5419167c244652a$export$2e2bcd8739ae039 = $d5419167c244652a$var$UserPickerWrapper;

});
const $8c03579f1a24f6e2$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';

parcelRegister("iVXi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $34009d93e46b078d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $34009d93e46b078d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyQueryMessage: {
        "id": "base-user-picker.empty-query-message",
        "defaultMessage": "Start typing to get a list of possible matches."
    }
});

});

parcelRegister("aofgi", function(module, exports) {

$parcel$export(module.exports, "mapUserObjectToUserOption", () => $656635459ed543f4$export$e11fc32dba4fe919);
$parcel$export(module.exports, "mapAutoCompleteResponseToUsers", () => $656635459ed543f4$export$ec325826d2bf6655);

var $guiFP = parcelRequire("guiFP");
const $656635459ed543f4$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
    let userOption = {
        id: userData.accountId || '',
        name: userData.displayName || '',
        avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    };
    if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) // @ts-expect-error - TS2322 - Type '{ byline: string; id: string; name: string; avatarUrl: string; }' is not assignable to type '{ id: string; name: string; avatarUrl: string; }'.
    userOption = {
        ...userOption,
        byline: userData.emailAddress
    };
    return userOption;
};
const $656635459ed543f4$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
    try {
        if (isBulkEdit) {
            if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return autoCompleteResponse.users;
        } else if (Array.isArray(autoCompleteResponse)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return autoCompleteResponse;
        throw Error('autoCompleteResponse is either null or not expected value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'mapAutoCompleteResponse',
                packageName: 'jiraBaseUserPicker',
                teamName: 'gryffindor'
            },
            error: error
        });
    }
    return [];
};

});






parcelRegister("6k3kI", function(module, exports) {

$parcel$export(module.exports, "NumberCustomFieldTypeConfig", () => $e84f773ede0c0e7b$export$9263307b5dc5bafe);

var $eUqFw = parcelRequire("eUqFw");

var $5u49X = parcelRequire("5u49X");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $e84f773ede0c0e7b$var$NumberCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5u49X.default), props);
const $e84f773ede0c0e7b$export$9263307b5dc5bafe = {
    type: (0, $lO4Or.NUMBER_CF_TYPE),
    Component: $e84f773ede0c0e7b$var$NumberCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.TextFieldPlaceholder), null),
    writer: (0, $eHQA5.numberFieldWriter)
};

});
parcelRegister("5u49X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1768a5d7fc57faa0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guGTQ = parcelRequire("guGTQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $ia8XI = parcelRequire("ia8XI");
const $1768a5d7fc57faa0$export$63c5fa0b2fdccd2e = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guGTQ.InputField), {
        type: "number",
        width: width,
        ...rest
    });
};
var $1768a5d7fc57faa0$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString),
    transformDefaultValue: (0, $ia8XI.transformAsString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$1768a5d7fc57faa0$export$63c5fa0b2fdccd2e);

});
parcelRegister("guGTQ", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $63f0096515b05ab8$export$dd2171e2b7d3bc5b);
$parcel$export(module.exports, "default", () => $63f0096515b05ab8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cf2Y4 = parcelRequire("cf2Y4");

var $lIor1 = parcelRequire("lIor1");

var $6HoNR = parcelRequire("6HoNR");

var $f5AnN = parcelRequire("f5AnN");
const $63f0096515b05ab8$export$dd2171e2b7d3bc5b = (props)=>{
    const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
        onChange: onChange,
        value: value,
        type: type,
        width: width,
        step: "any",
        testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        onWheel: (0, $f5AnN.preventMouseScrollForNumericFieldHandler),
        isDisabled: isReadOnly || rest.isDisabled
    });
};
var $63f0096515b05ab8$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$63f0096515b05ab8$export$dd2171e2b7d3bc5b);

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("f5AnN", function(module, exports) {

$parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", () => $5e92c6f878fb6e67$export$3fedcbfe1c53d8f);
const $5e92c6f878fb6e67$export$3fedcbfe1c53d8f = (event)=>{
    if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
};

});


parcelRegister("ia8XI", function(module, exports) {

$parcel$export(module.exports, "transformAsNumber", () => $73768a38660ac389$export$52c4e7404b9db862);
$parcel$export(module.exports, "mutateNumberField", () => $73768a38660ac389$export$6701d4d68ea6db95);
$parcel$export(module.exports, "transformAsString", () => $73768a38660ac389$export$afe59f8094df7220);

const $73768a38660ac389$export$52c4e7404b9db862 = (value)=>{
    if (value) return Number(value);
    return undefined;
};
const $73768a38660ac389$export$6701d4d68ea6db95 = (value, fieldId)=>({
        fieldId: fieldId,
        value: Number(value),
        mutationGroup: (0, $7c4e31f147f56501$export$31fd86f8f183952c)
    });
const $73768a38660ac389$export$afe59f8094df7220 = (value)=>{
    if (value !== undefined) return String(value);
    return undefined;
};

});
const $7c4e31f147f56501$export$31fd86f8f183952c = 'numberFields';




parcelRegister("01FG6", function(module, exports) {

$parcel$export(module.exports, "ParentFieldTypeConfig", () => $ef6f9cf5f92bedb6$export$dfc79382467975d5);

var $eUqFw = parcelRequire("eUqFw");

var $b81gR = parcelRequire("b81gR");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $ef6f9cf5f92bedb6$var$ParentFieldTypeComponent = (props)=>{
    if (!props.issueTypeId || !props.canUserViewProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b81gR.default), {
        ...props,
        selectedProject: {
            value: props.projectId
        },
        selectedIssueType: {
            value: props.issueTypeId
        },
        isFieldResponsive: true
    });
};
const $ef6f9cf5f92bedb6$export$dfc79382467975d5 = {
    type: (0, $lO4Or.PARENT_TYPE),
    Component: $ef6f9cf5f92bedb6$var$ParentFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.selectFieldWriter)
};

});
parcelRegister("b81gR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf9e91932e8e20c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");


var $d9Uys = parcelRequire("d9Uys");

var $ctBfd = parcelRequire("ctBfd");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $897qz = parcelRequire("897qz");
// The width of Parent label in English with default font settings
const $2bf9e91932e8e20c$var$parentLabelWidthDefault = 39;
const $2bf9e91932e8e20c$export$96c87c0afbe06b37 = (props)=>{
    const { fieldId: fieldId, fieldName: fieldName, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
    const [leftPosition, setLeftPosition] = (0, $eUqFw.useState)($2bf9e91932e8e20c$var$parentLabelWidthDefault);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const element = document?.querySelector('#parent-field-label') || null;
        setLeftPosition(element?.offsetWidth ?? $2bf9e91932e8e20c$var$parentLabelWidthDefault);
    }, [
        fieldName
    ]);
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /**
	 * When creating a sub-task from the GIC modal, we:
	 * - pre-populate the parent field in "src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/dropdown-menu-group/button-item/index"
	 * - disable the parent field to prevent the user to change it
	 *
	 * This prevents the user to make a mistake or bump into potential edge cases.
	 */ const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, (0, $1ybV0.ff)('parent-field-changeboarding_4ljdy') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9Uys.Changeboarding), {
        leftPosition: leftPosition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctBfd.ParentFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isExistingIssue: isExistingIssue,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : undefined,
        selectedIssueTypeId: issueTypeId,
        fetchSuggestionsOnFocus: true,
        passedInIssueKey: (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)() ? issueKey : undefined,
        spacing: "default"
    }));
};
var $2bf9e91932e8e20c$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $897qz.transformDefaultParentValue),
    validator: (0, $897qz.validateParentField)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentFieldConfig, LegacyValue<Option>>, any>'.
$2bf9e91932e8e20c$export$96c87c0afbe06b37);

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("d9Uys", function(module, exports) {

$parcel$export(module.exports, "Changeboarding", () => $2b58ec9c229c5623$export$d7cfba75deb33e5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aUqTb = parcelRequire("aUqTb");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $aZZKa = parcelRequire("aZZKa");
const $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT = 'parentFieldChangeboarding';
const $2b58ec9c229c5623$export$8f7c37cb3352ceb8 = 'https://community.atlassian.com/t5/Jira-Software-articles/Introducing-the-new-Parent-field-in-company-managed-projects/ba-p/2377758';
const $2b58ec9c229c5623$export$f960f87b7b043226 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/#What-are-parent-and-child-issues';
const $2b58ec9c229c5623$export$d7cfba75deb33e5 = (props)=>{
    const { leftPosition: leftPosition, defaultOpen: defaultOpen } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultOpen || false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickInfo = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'infoButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        isOpen,
        setIsOpen,
        createAnalyticsEvent
    ]);
    const onInfolinkClicked = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'learnMoreLink'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        createAnalyticsEvent
    ]);
    const getInfoIconButton = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            appearance: "subtle-link",
            "data-ds--inline-message--button": true,
            spacing: "none",
            isSelected: isOpen,
            onClick: ()=>onClickInfo(),
            "aria-label": formatMessage((0, $aZZKa.default).spotligthLearnMore),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                label: formatMessage((0, $aZZKa.default).spotligthLearnMore),
                testId: "issue-field-parent.ui.changeboarding.editor-panel-icon"
            })
        });
    const getInfoIconButtonWrapper = (triggerProps)=>{
        if (leftPosition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $1ZAYh.xcss)({
                    position: 'absolute',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    left: `${leftPosition}px`,
                    top: '-1px'
                })
            ]
        }, getInfoIconButton(triggerProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $2b58ec9c229c5623$var$infoButtonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $2b58ec9c229c5623$var$infoButtonStyles
        }, getInfoIconButton(triggerProps)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        shouldRenderToParent: true,
        placement: "right",
        zIndex: (0, $lcnyw.layers).tooltip(),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $2b58ec9c229c5623$var$popupContentStyles
            }, (0, $eI5EY.fg)('visual-refresh-typography-temp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "p"
            }, formatMessage((0, $aZZKa.default).infoMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "p"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
                ref: setInitialFocusRef,
                target: "_blank",
                href: $2b58ec9c229c5623$export$f960f87b7b043226,
                onClick: ()=>onInfolinkClicked()
            }, formatMessage((0, $aZZKa.default).infoLearnMore)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $aZZKa.default).infoMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
                ref: setInitialFocusRef,
                target: "_blank",
                href: $2b58ec9c229c5623$export$f960f87b7b043226,
                onClick: ()=>onInfolinkClicked()
            }, formatMessage((0, $aZZKa.default).infoLearnMore))))),
        trigger: (triggerProps)=>getInfoIconButtonWrapper(triggerProps)
    });
};
const $2b58ec9c229c5623$var$infoButtonContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    width: '20px'
});
const $2b58ec9c229c5623$var$infoButtonStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: '6px'
});
const $2b58ec9c229c5623$var$popupContentStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    width: '300px'
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("aZZKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $592fafeca2c728e3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $592fafeca2c728e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    spotligthLearnMore: {
        "id": "issue-field-parent.changeboarding.spotligth-learn-more",
        "defaultMessage": "Information on the parent field"
    },
    infoMessage: {
        "id": "issue-field-parent.changeboarding.info-message",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    infoLearnMore: {
        "id": "issue-field-parent.changeboarding.info-learn-more",
        "defaultMessage": "Learn more about parent issues"
    }
});

});


parcelRegister("ctBfd", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $16b7cfe9b86e2ec5$export$55c2cccecfd24751);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5wCDk = parcelRequire("5wCDk");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $4NcaX = parcelRequire("4NcaX");
var $g6sIQ = parcelRequire("g6sIQ");

var $dWLk9 = parcelRequire("dWLk9");

var $3K8W2 = parcelRequire("3K8W2");

var $gFHZL = parcelRequire("gFHZL");

var $4RHil = parcelRequire("4RHil");

var $1h91k = parcelRequire("1h91k");

var $lNJbX = parcelRequire("lNJbX");
const $16b7cfe9b86e2ec5$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $16b7cfe9b86e2ec5$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $eUqFw.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $eUqFw.useState)(true);
    const isInitialMount = (0, $eUqFw.useRef)(true);
    const lastQuery = (0, $eUqFw.useRef)('');
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const onCheckboxClick = (0, $eUqFw.useCallback)(()=>{
        setExcludeDone(!excludeDone);
    }, [
        excludeDone
    ]);
    const componentProps = (0, $eUqFw.useMemo)(()=>({
            isChecked: !excludeDone,
            onChange: onCheckboxClick
        }), [
        excludeDone,
        onCheckboxClick
    ]);
    const formatOptionLabel = (0, $eUqFw.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1h91k.default), {
            option: option
        }));
        const label = (0, $1ybV0.ff)('jsm-request-type-layout-supports-parent-field_jiq2s') ? option.label || `${option.key} ${option.fields.summary}` : `${option.key} ${option.fields.summary}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, label);
    }, []);
    const searchParents = (0, $eUqFw.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = await (0, $lNJbX.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = await (0, $lNJbX.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        } catch  {
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        const response = await searchParents(query);
        if (lastQuery.current === query) {
            if (response.options !== undefined) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                setSuggestions([]);
                if (query === '') setDefaultSuggestions([]);
            }
            setIsLoading(false);
        }
    }, [
        searchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(requestSuggestions, $16b7cfe9b86e2ec5$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $eUqFw.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>{
        const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $4RHil.default).noMatches);
        // we now get the translated message from the backend, but will fall back to the old message if it's not there
        return hasLastFetchFailed ? formatMessage((0, $4RHil.default).failedFetch) : noOptions;
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $4RHil.default).loading), [
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $eUqFw.useMemo)(()=>(0, $eI5EY.fg)('jira_-_list_-_add_onclick_handler_to_parentview') ? spacingProps : 'compact', [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $3K8W2.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $4RHil.default).placeholder),
        components: {
            Menu: $gFHZL.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing,
        ...(0, $eI5EY.fg)('bulk-transitions-fix-a11y-violations') && {
            'aria-labelledby': ariaLabelledBy
        }
    });
};

});
parcelRegister("3K8W2", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $95b0c6b6b9af6b91$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $95b0c6b6b9af6b91$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $95b0c6b6b9af6b91$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $95b0c6b6b9af6b91$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $95b0c6b6b9af6b91$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1ybV0 = parcelRequire("1ybV0");

var $tgbCK = parcelRequire("tgbCK");
var $lPQPn = parcelRequire("lPQPn");
const $95b0c6b6b9af6b91$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $tgbCK.MAP_COLORS_TO_VALUE)[color];
const $95b0c6b6b9af6b91$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95b0c6b6b9af6b91$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $95b0c6b6b9af6b91$export$99a866ffa3af7d8b = (issueParents)=>{
    const transformedResponse = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        })) : issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`
        }));
    return transformedResponse;
};
const $95b0c6b6b9af6b91$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $95b0c6b6b9af6b91$export$9b822862d986dfdf = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $95b0c6b6b9af6b91$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $95b0c6b6b9af6b91$export$949dc67535a8ff2 = (color)=>$95b0c6b6b9af6b91$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95b0c6b6b9af6b91$var$ColorPatch = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $9t7rW.default)($95b0c6b6b9af6b91$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");


var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $73a5c9d720aa66e1$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $73a5c9d720aa66e1$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $73a5c9d720aa66e1$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $73a5c9d720aa66e1$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $73a5c9d720aa66e1$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $73a5c9d720aa66e1$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $73a5c9d720aa66e1$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $73a5c9d720aa66e1$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $73a5c9d720aa66e1$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $73a5c9d720aa66e1$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $73a5c9d720aa66e1$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $73a5c9d720aa66e1$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $73a5c9d720aa66e1$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $73a5c9d720aa66e1$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N300})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("gFHZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeadf926ee0a27e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2iqfg = parcelRequire("2iqfg");
const $ddeadf926ee0a27e$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const label = formatMessage((0, $2iqfg.default).checkboxLabel);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    /**
   * When the checkbox is clicked, we need to stop the event propagation to prevent the select from closing.
   */ const onChange = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when checkbox is clicked to prevent select from closing
        event.stopPropagation();
        event.preventDefault();
        props.selectProps?.componentsProps?.onChange?.(event);
    }, [
        props.selectProps?.componentsProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddeadf926ee0a27e$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onKeyDown: onKeyDown,
        onClick: onChange,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: ()=>{},
        isChecked: isChecked,
        size: "medium",
        id: "issue-field-parent.ui.edit.menu.checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddeadf926ee0a27e$var$CheckboxLabel, {
        onClick: onChange,
        htmlFor: "issue-field-parent.ui.edit.menu.checkbox",
        "data-testid": "issue-field-parent.ui.edit.menu.checkbox-label"
    }, label)), children);
};
var $ddeadf926ee0a27e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ddeadf926ee0a27e$var$Menu;
const $ddeadf926ee0a27e$var$CheckboxWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt4lce4 _n7zlpe8f _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddeadf926ee0a27e$var$CheckboxLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("2iqfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $527b2a926f101da8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $527b2a926f101da8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    }
});

});


parcelRegister("4RHil", function(module, exports) {

$parcel$export(module.exports, "default", () => $1453541c4aca35df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1453541c4aca35df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("1h91k", function(module, exports) {

$parcel$export(module.exports, "default", () => $3459ab43a3b207bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9Z3M = parcelRequire("k9Z3M");


var $5JgJ2 = parcelRequire("5JgJ2");

var $3K8W2 = parcelRequire("3K8W2");

var $gDuhX = parcelRequire("gDuhX");

var $eNV5F = parcelRequire("eNV5F");
const $3459ab43a3b207bd$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.Description), null, option.description) : null);
const $3459ab43a3b207bd$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $3K8W2.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: `var(--ds-text-success, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $3459ab43a3b207bd$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionLabel), null, $3459ab43a3b207bd$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $gDuhX.default).doneParentLabel), formatMessage((0, $gDuhX.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionWrapper), null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionLabel), null, option.label), $3459ab43a3b207bd$var$renderOptionDescription(option)));
};
var $3459ab43a3b207bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3459ab43a3b207bd$var$CustomOption;
const $3459ab43a3b207bd$var$IconWithColor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$DoneWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rc1",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz1rc1 _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43db9d99c93083272e0c42b874af3704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});


parcelRegister("gDuhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $de48ca9994a523f3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $de48ca9994a523f3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});

parcelRegister("eNV5F", function(module, exports) {

$parcel$export(module.exports, "OptionWrapper", () => $8880269126d01244$export$d6f6a072cce04542);
$parcel$export(module.exports, "OptionTextContainer", () => $8880269126d01244$export$c6c33847de6c74ef);
$parcel$export(module.exports, "Description", () => $8880269126d01244$export$393edc798c47379d);
$parcel$export(module.exports, "OptionLabel", () => $8880269126d01244$export$2cf7ef1e2dd6c6b1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8880269126d01244$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$c6c33847de6c74ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$2cf7ef1e2dd6c6b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lNJbX", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $a94fa604b4d453e4$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForExisting", () => $a94fa604b4d453e4$export$f995718992ca6c2f);

var $guiFP = parcelRequire("guiFP");

var $ksJPv = parcelRequire("ksJPv");
var $ijrxj = parcelRequire("ijrxj");

var $3K8W2 = parcelRequire("3K8W2");
const $a94fa604b4d453e4$export$cfeee2ee86ead336 = 'bento';
const $a94fa604b4d453e4$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ijrxj.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $3K8W2.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $a94fa604b4d453e4$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ksJPv.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $3K8W2.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("ksJPv", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $30bdd1b75406f614$export$59a0f41a1d5dcee0);


var $7EhAs = parcelRequire("7EhAs");

var $4NW4H = parcelRequire("4NW4H");

var $gSE5U = parcelRequire("gSE5U");

var $gbHOB = parcelRequire("gbHOB");

var $hKxcm = parcelRequire("hKxcm");
const $30bdd1b75406f614$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $4NW4H.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, $hKxcm.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("4NW4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4ab2a034cf0653$export$2e2bcd8739ae039);

var $gSE5U = parcelRequire("gSE5U");

var $kXzsJ = parcelRequire("kXzsJ");
const $5b4ab2a034cf0653$export$83bff8b82e36a9e9 = 20;
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b4ab2a034cf0653$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $5b4ab2a034cf0653$export$83bff8b82e36a9e9
    };
    const response = await (0, $kXzsJ.getClient)('').query({
        query: (0, $gSE5U.buildParentCandidatesForExistingIssueQuery)(),
        variables: variables
    });
    return response;
};

});
parcelRegister("gSE5U", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $e9da6eadea09a233$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $e9da6eadea09a233$export$b64c34b6ba3d6bf5);

var $8OLx5 = parcelRequire("8OLx5");
const $e9da6eadea09a233$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $e9da6eadea09a233$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$e9da6eadea09a233$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $8OLx5.parentCandidatesForExistingIssueQuery)()}
    }
`;

});
parcelRegister("8OLx5", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $3bad3c743a64005c$export$f63a6e3151b9dd82);

var $bKxX9 = parcelRequire("bKxX9");
const $3bad3c743a64005c$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $3bad3c743a64005c$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $3bad3c743a64005c$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $3bad3c743a64005c$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $3bad3c743a64005c$var$fieldsByIdOld = ()=>`fieldsById(ids:["summary", "issuetype"]){
  edges{
    node{
      ${$3bad3c743a64005c$var$issueType()}
      ${$3bad3c743a64005c$var$summary()}
    }
  }
}`;
const $3bad3c743a64005c$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$3bad3c743a64005c$var$issueType()}
      ${$3bad3c743a64005c$var$summary()}
      ${$3bad3c743a64005c$var$status()}
    }
  }
}`;
const $3bad3c743a64005c$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$3bad3c743a64005c$var$color()}
              ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $3bad3c743a64005c$var$fieldsById() : $3bad3c743a64005c$var$fieldsByIdOld()}
            }
          }
        }
        message
      }
    }
`;

});



parcelRegister("gbHOB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c796f884883538e4$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
class $c796f884883538e4$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $c796f884883538e4$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $7byHA.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("hKxcm", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $eafcb23fdcdaf55d$export$3ceb62baab058c6b);

var $8Qd0L = parcelRequire("8Qd0L");


var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $tgbCK = parcelRequire("tgbCK");
const $eafcb23fdcdaf55d$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if ((0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') && statusField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId) : undefined;
        const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("ijrxj", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $5934be41627d9230$export$48a29a1313179c04);


var $7EhAs = parcelRequire("7EhAs");

var $go64Z = parcelRequire("go64Z");

var $7SU3A = parcelRequire("7SU3A");

var $gbHOB = parcelRequire("gbHOB");

var $hKxcm = parcelRequire("hKxcm");
const $5934be41627d9230$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $go64Z.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, $hKxcm.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("go64Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $381d472c7acaff8f$export$2e2bcd8739ae039);

var $7SU3A = parcelRequire("7SU3A");

var $kXzsJ = parcelRequire("kXzsJ");
const $381d472c7acaff8f$export$1fd3b40492f4ef9f = 20;
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$381d472c7acaff8f$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $381d472c7acaff8f$export$1fd3b40492f4ef9f
    };
    const response = await (0, $kXzsJ.getClient)('').query({
        query: (0, $7SU3A.buildParentCandidatesForNewIssueQuery)(),
        variables: variables,
        operationName: `jira_parenting_${(0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
    });
    return response;
};

});
parcelRegister("7SU3A", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $dbe4fea6910fdc7f$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $dbe4fea6910fdc7f$export$453f3d2e0fac3592);

var $hIakI = parcelRequire("hIakI");
const $dbe4fea6910fdc7f$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $dbe4fea6910fdc7f$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$dbe4fea6910fdc7f$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $hIakI.parentCandidatesForNewIssueQuery)()}
    }
`;

});
parcelRegister("hIakI", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $a7df5a978940517d$export$1dfd5c8a625d5960);

var $bKxX9 = parcelRequire("bKxX9");
const $a7df5a978940517d$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $a7df5a978940517d$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $a7df5a978940517d$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $a7df5a978940517d$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $a7df5a978940517d$var$fieldsByIdOld = ()=>`fieldsById(ids:["summary", "issuetype"]){
  edges{
    node{
      ${$a7df5a978940517d$var$issueType()}
      ${$a7df5a978940517d$var$summary()}
    }
  }
}`;
const $a7df5a978940517d$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a7df5a978940517d$var$issueType()}
      ${$a7df5a978940517d$var$summary()}
      ${$a7df5a978940517d$var$status()}
    }
  }
}`;
const $a7df5a978940517d$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$a7df5a978940517d$var$color()}
                ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $a7df5a978940517d$var$fieldsById() : $a7df5a978940517d$var$fieldsByIdOld()}
              }
            }
          }
          message
        }
      }
`;

});






parcelRegister("897qz", function(module, exports) {

$parcel$export(module.exports, "transformDefaultParentValue", () => $f264ebfdd5ad9a23$export$f38bec4d01c88544);
$parcel$export(module.exports, "validateParentField", () => $f264ebfdd5ad9a23$export$656803053e0b9113);
$parcel$export(module.exports, "mutateParentField", () => $f264ebfdd5ad9a23$export$15ec054c85ac7db1);

var $dEMIg = parcelRequire("dEMIg");

var $tgbCK = parcelRequire("tgbCK");
const $f264ebfdd5ad9a23$export$f38bec4d01c88544 = (defaultValue)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
    const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
    const summary = summaryField?.node.text;
    const label = `${key} ${summary}`;
    return {
        label: label,
        value: issueId,
        key: key,
        color: issueColorField && issueColorField.color !== null ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
        fields: {
            summary: summary,
            issuetype: {
                name: issueTypeField?.node.issueType.name,
                iconUrl: issueTypeField?.node.issueType.avatar.xsmall
            }
        }
    };
};
const $f264ebfdd5ad9a23$export$656803053e0b9113 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $f264ebfdd5ad9a23$export$15ec054c85ac7db1 = ({ value: value })=>({
        parentField: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueId: value
        }
    });

});



parcelRegister("kXX84", function(module, exports) {

$parcel$export(module.exports, "PeopleCustomFieldType", () => $176701c171c4b8cf$export$531787d3fa23885);

var $eUqFw = parcelRequire("eUqFw");

var $7EBWy = parcelRequire("7EBWy");
var $60BSb = parcelRequire("60BSb");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $176701c171c4b8cf$var$PeopleCustomFieldTypeComponent = (props)=>{
    if (props.schemaConfiguration.isMulti) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7EBWy.default), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60BSb.default), props);
};
const $176701c171c4b8cf$export$531787d3fa23885 = {
    type: (0, $lO4Or.PEOPLE_CF_TYPE),
    Component: $176701c171c4b8cf$var$PeopleCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.AssigneeFieldPlaceholder), null),
    writer: (id, value, fields)=>Array.isArray(value) ? (0, $eHQA5.multiUserPickerFieldWriter)(id, value, fields) : (0, $eHQA5.singleUserPickerFieldWriter)(id, value, fields)
};

});
parcelRegister("60BSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5807f51a8e3ff420$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b7b1I = parcelRequire("b7b1I");
const $5807f51a8e3ff420$var$SingleUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7b1I.default), {
        ...props,
        isMulti: false,
        context: "CustomUserField"
    });
var $5807f51a8e3ff420$export$2e2bcd8739ae039 = $5807f51a8e3ff420$var$SingleUserPickerField;

});


parcelRegister("zma4S", function(module, exports) {

$parcel$export(module.exports, "PriorityFieldTypeConfig", () => $079b639b44756fc7$export$63f81e33b9847d28);

var $eUqFw = parcelRequire("eUqFw");

var $ltG3Y = parcelRequire("ltG3Y");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $079b639b44756fc7$var$PriorityFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltG3Y.default), props);
const $079b639b44756fc7$export$63f81e33b9847d28 = {
    type: (0, $lO4Or.PRIORITY_TYPE),
    Component: $079b639b44756fc7$var$PriorityFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.priorityFieldWriter)
};

});
parcelRegister("ltG3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf28946f95fc30b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $96Tfy = parcelRequire("96Tfy");

var $2XekW = parcelRequire("2XekW");

var $7TaJX = parcelRequire("7TaJX");

var $3O2c6 = parcelRequire("3O2c6");
const $fcf28946f95fc30b$var$PriorityField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $2XekW.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $96Tfy.default), {
        options: options,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $fcf28946f95fc30b$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validatePriorityField),
    transformDefaultValue: $3O2c6.transformDefaultValue
})($fcf28946f95fc30b$var$PriorityField);

});
parcelRegister("96Tfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c938ab475b18514d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");
const $c938ab475b18514d$var$PriorityEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        inputId: inputId,
        required: isRequired,
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        formatOptionLabel: (0, $bKilX.formatOptionLabel),
        isClearable: false,
        hideSelectedOptions: true,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isDisabled,
        classNamePrefix: classNamePrefix,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $c938ab475b18514d$export$2e2bcd8739ae039 = $c938ab475b18514d$var$PriorityEdit;

});
parcelRegister("bKilX", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $03dfe231efe3dc8b$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");
const $03dfe231efe3dc8b$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
    }, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$Description, null, description)));
};
const $03dfe231efe3dc8b$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03dfe231efe3dc8b$var$FlexRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$FlexColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _syaz1rc1",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3O2c6", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $d4d92de5d27920ea$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutatePriorityField", () => $d4d92de5d27920ea$export$2c46dd13be598543);
const $d4d92de5d27920ea$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
        label: name,
        value: id,
        iconUrl: iconUrl
    });
const $d4d92de5d27920ea$export$2c46dd13be598543 = ({ value: value })=>({
        priority: {
            priorityId: value
        }
    });

});



parcelRegister("754Vk", function(module, exports) {

$parcel$export(module.exports, "RadioButtonsCustomFieldTypeConfig", () => $ff935cbf7b30d97f$export$2483417b1f9a587c);

var $eUqFw = parcelRequire("eUqFw");

var $kjSRM = parcelRequire("kjSRM");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $ff935cbf7b30d97f$var$RadioButtonsCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjSRM.default), props);
const $ff935cbf7b30d97f$export$2483417b1f9a587c = {
    type: (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
    Component: $ff935cbf7b30d97f$var$RadioButtonsCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.radioSelectFieldWriter)
};

});
parcelRegister("kjSRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8704501aab9e2ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $lziSU = parcelRequire("lziSU");

var $dLZA6 = parcelRequire("dLZA6");

var $7TaJX = parcelRequire("7TaJX");

var $iXBWy = parcelRequire("iXBWy");
const $d8704501aab9e2ec$var$RadioSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false }, isReadOnly: isReadOnly = false, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $dLZA6.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lziSU.default), {
        options: options,
        isDisabled: isReadOnly || isDisabled,
        value: value,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $d8704501aab9e2ec$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateRadioSelectField),
    transformDefaultValue: $iXBWy.transformDefaultValue
})($d8704501aab9e2ec$var$RadioSelectField);

});
parcelRegister("lziSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecfde50a2e9f39ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hxUBe = parcelRequire("hxUBe");

var $4NcaX = parcelRequire("4NcaX");
const $ecfde50a2e9f39ea$var$RadioSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', isDisabled: isDisabled = false, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hxUBe.default), {
        classNamePrefix: classNamePrefix,
        value: value,
        options: options,
        isDisabled: isDisabled,
        placeholder: placeholder,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: OptionType | null, action: ActionMeta<OptionType>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        onBlur: onBlur,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $ecfde50a2e9f39ea$export$2e2bcd8739ae039 = $ecfde50a2e9f39ea$var$RadioSelectEdit;

});
parcelRegister("hxUBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $834f94f4b5e3479b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $bVKeg = parcelRequire("bVKeg");
const $834f94f4b5e3479b$var$RadioSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $bVKeg.RadioOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        ...props,
        isMulti: false,
        components: mergedComponents
    });
});
var $834f94f4b5e3479b$export$2e2bcd8739ae039 = $834f94f4b5e3479b$var$RadioSelect;

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hSJ9G = parcelRequire("hSJ9G");

var $c6Z6Z = parcelRequire("c6Z6Z");

function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::028a0c4c28d56d22cc99e0300c383380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});




parcelRegister("iXBWy", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $1f83867652ce1269$export$e2f4e5d31db527cc);
const $1f83867652ce1269$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
        label: value,
        value: id
    });

});



parcelRegister("foE6X", function(module, exports) {

$parcel$export(module.exports, "SelectCustomFieldTypeConfig", () => $d3027cfe5c625d48$export$8ed2c57b191fc5f5);

var $eUqFw = parcelRequire("eUqFw");

var $k4Bm6 = parcelRequire("k4Bm6");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $d3027cfe5c625d48$var$SelectCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4Bm6.default), {
        ...props,
        defaultValue: undefined
    });
const $d3027cfe5c625d48$export$8ed2c57b191fc5f5 = {
    type: (0, $lO4Or.SELECT_CF_TYPE),
    Component: $d3027cfe5c625d48$var$SelectCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.selectFieldWriter)
};

});

parcelRegister("iSnOd", function(module, exports) {

$parcel$export(module.exports, "StoryPointEstimateCustomFieldTypeConfig", () => $4823373cc4e21930$export$8deb8e2b0423b5b3);

var $eUqFw = parcelRequire("eUqFw");

var $5u49X = parcelRequire("5u49X");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $4823373cc4e21930$var$StoryPointEstimateCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5u49X.default), props);
const $4823373cc4e21930$export$8deb8e2b0423b5b3 = {
    type: (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    Component: $4823373cc4e21930$var$StoryPointEstimateCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.TextFieldPlaceholder), null),
    writer: (0, $eHQA5.numberFieldWriter)
};

});

parcelRegister("6VKPX", function(module, exports) {

$parcel$export(module.exports, "SummaryFieldTypeConfig", () => $1a7568aa27c64980$export$ac5c271c33c3c6d7);

var $eUqFw = parcelRequire("eUqFw");

var $fKpo5 = parcelRequire("fKpo5");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $1a7568aa27c64980$export$ac5c271c33c3c6d7 = {
    type: (0, $lO4Or.SUMMARY_TYPE),
    Component: (0, $fKpo5.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.TextFieldPlaceholder), null),
    writer: (0, $eHQA5.textFieldWriter)
};

});
parcelRegister("fKpo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $145f54946b273072$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guGTQ = parcelRequire("guGTQ");

const $145f54946b273072$var$TextField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guGTQ.default), {
        type: "text",
        ...props
    });
var $145f54946b273072$export$2e2bcd8739ae039 = $145f54946b273072$var$TextField;

});


parcelRegister("9QvQg", function(module, exports) {

$parcel$export(module.exports, "TeamCustomFieldTypeConfig", () => $07d57b0baa060c9e$export$68615ecd9a5b878d);

var $eUqFw = parcelRequire("eUqFw");

var $kfu77 = parcelRequire("kfu77");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $07d57b0baa060c9e$var$TeamCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kfu77.default), props);
const $07d57b0baa060c9e$export$68615ecd9a5b878d = {
    type: (0, $lO4Or.TEAM_CF_TYPE),
    Component: $07d57b0baa060c9e$var$TeamCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.teamFieldWriter)
};

});
parcelRegister("kfu77", function(module, exports) {

$parcel$export(module.exports, "default", () => $5470905411abe2a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $h9GI9 = parcelRequire("h9GI9");

var $7TaJX = parcelRequire("7TaJX");

var $3GT6n = parcelRequire("3GT6n");
const $5470905411abe2a7$export$c3b8fa1b9560fb7e = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9GI9.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit());
};
var $5470905411abe2a7$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCustomTeamsField),
    transformDefaultValue: (0, $3GT6n.transformDefaultTeam)
})($5470905411abe2a7$export$c3b8fa1b9560fb7e);

});
parcelRegister("h9GI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5585e8088f239d77$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fm9CZ = parcelRequire("fm9CZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $fO0l8 = parcelRequire("fO0l8");

var $jSTFD = parcelRequire("jSTFD");

var $jKAMv = parcelRequire("jKAMv");

var $kkYM2 = parcelRequire("kkYM2");

var $6b6yO = parcelRequire("6b6yO");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5585e8088f239d77$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jKAMv.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5585e8088f239d77$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkYM2.default), props);
const $5585e8088f239d77$var$CustomTeamPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const handleSearch = (0, $fO0l8.default)(async (query)=>(0, $6b6yO.fetchTeams)(query || '', autoCompleteUrl), 300);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await handleSearch();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    const noOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $jSTFD.default).noMatches), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        fieldId: fieldId,
        ...defaultOptionsProps(),
        loadOptions: handleSearch,
        onChange: onChange,
        autoFocus: autoFocus,
        isClearable: Boolean(value),
        isMulti: false,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: $5585e8088f239d77$var$MenuList,
            Option: $5585e8088f239d77$var$Option
        },
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $5585e8088f239d77$export$2e2bcd8739ae039 = $5585e8088f239d77$var$CustomTeamPickerEdit;

});
parcelRegister("fm9CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14ede2f273d8bdb$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $5FjBr = parcelRequire("5FjBr");
const $a14ede2f273d8bdb$var$AsyncSelect = (0, $5FjBr.default)((0, $hgTYM.default));
var $a14ede2f273d8bdb$export$2e2bcd8739ae039 = $a14ede2f273d8bdb$var$AsyncSelect;

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});
parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});



parcelRegister("fO0l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5761c68e5511d47$export$2e2bcd8739ae039);
const $a5761c68e5511d47$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a5761c68e5511d47$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $a5761c68e5511d47$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $a5761c68e5511d47$export$2e2bcd8739ae039 = $a5761c68e5511d47$var$debounce;

});

parcelRegister("jSTFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3167cca46c9d2c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e3167cca46c9d2c9$var$messages = (0, $90IgZ.defineMessages)({
    menuHeader: {
        "id": "issue-field-custom-team.menu-header",
        "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
    },
    noMatches: {
        "id": "issue-field-custom-team.no-matches",
        "defaultMessage": "No Matches"
    },
    menuFooter: {
        "id": "issue-field-custom-team.menu-footer",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $e3167cca46c9d2c9$export$2e2bcd8739ae039 = $e3167cca46c9d2c9$var$messages;

});

parcelRegister("jKAMv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b2116316498d63$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jSTFD = parcelRequire("jSTFD");
const $b9b2116316498d63$var$MenuListComponent = (props)=>{
    const { options: options } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9b2116316498d63$var$MenuFooterText, null, formatMessage((0, $jSTFD.default).menuFooter)) : null;
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9b2116316498d63$var$Container, null, formatMessage((0, $jSTFD.default).menuHeader)), props.children, footer));
};
var $b9b2116316498d63$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b9b2116316498d63$var$MenuListComponent;
const $b9b2116316498d63$var$MenuFooterText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp _11c81oud _1yt41pyq",
            __cmplp.className
        ])
    });
});
const $b9b2116316498d63$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41pyq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kkYM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1893208c9969fdac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $1hABw = parcelRequire("1hABw");
const $1893208c9969fdac$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl, label: label } = value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: TeamFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1893208c9969fdac$var$OptionWrapper, null, avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1893208c9969fdac$var$Icon, {
            src: avatarUrl,
            alt: label
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $1893208c9969fdac$var$boxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1hABw.default), {
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1893208c9969fdac$var$OptionText, null, props.children))));
    }
    return null;
};
var $1893208c9969fdac$export$2e2bcd8739ae039 = $1893208c9969fdac$var$OptionComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1893208c9969fdac$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $1893208c9969fdac$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bahv2br _1yt4otz2",
            __cmplp.className
        ])
    });
});
const $1893208c9969fdac$var$OptionText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $1893208c9969fdac$var$boxStyle = (0, $1ZAYh.xcss)({
    height: '16px',
    width: '16px',
    marginRight: 'space.100'
});

});
parcelRegister("1hABw", function(module, exports) {

$parcel$export(module.exports, "default", () => $670cd22bb8a64b13$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $hcGsK = parcelRequire("hcGsK");
const $670cd22bb8a64b13$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hcGsK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hcGsK))
});
var $670cd22bb8a64b13$export$2e2bcd8739ae039 = $670cd22bb8a64b13$var$Illustration;
// for advanced use only
const $670cd22bb8a64b13$export$a179c88182cb9d56 = [
    0,
    0,
    596,
    596
];

});
parcelRegister("hcGsK", function(module, exports) {
module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();

});



parcelRegister("6b6yO", function(module, exports) {

$parcel$export(module.exports, "transformTeamFieldTypeString", () => $49363b8d604d92fe$export$f7d628c77d5447d0);
$parcel$export(module.exports, "fetchTeams", () => $49363b8d604d92fe$export$a789e725ac68b08d);

var $lRmyA = parcelRequire("lRmyA");
const $49363b8d604d92fe$export$4accbe1c2fbc55dd = (team)=>({
        label: team.title,
        value: team.id.toString(),
        isShared: team.shareable,
        avatarUrl: team.avatarUrl
    });
const $49363b8d604d92fe$export$f7d628c77d5447d0 = (team)=>{
    if (team) return team.value.toString();
    return null;
};
const $49363b8d604d92fe$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
    const response = await (0, $lRmyA.performPostRequest)(autoCompleteUrl, {
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 100,
            query: query
        })
    });
    if (response) {
        const teams = response.teams.map($49363b8d604d92fe$export$4accbe1c2fbc55dd);
        return [
            {
                moreResultsAvailable: response.moreResultsAvailable,
                options: teams
            }
        ];
    }
    return [];
};

});


parcelRegister("3GT6n", function(module, exports) {

$parcel$export(module.exports, "mutateTeamField", () => $07ff2bf39f4c18fe$export$8db32a33b76e5823);
$parcel$export(module.exports, "transformDefaultTeam", () => $07ff2bf39f4c18fe$export$d2d64eb763c850a1);

const $07ff2bf39f4c18fe$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $76b8053c60983826$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.value
        }
    } : null;
const $07ff2bf39f4c18fe$export$d2d64eb763c850a1 = (team)=>({
        label: team.name,
        value: team.teamId,
        isShared: true
    });

});
const $76b8053c60983826$export$31fd86f8f183952c = 'teamFields';




parcelRegister("lpJww", function(module, exports) {

$parcel$export(module.exports, "TeamsPlatformCustomFieldTypeConfig", () => $55f71ca49cff7e7a$export$bd8e1979d863fc93);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $kYlns = parcelRequire("kYlns");

var $eHQA5 = parcelRequire("eHQA5");
const $55f71ca49cff7e7a$var$TeamsPlatformCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYlns.TeamField), {
        ...props,
        defaultValue: undefined
    });
const $55f71ca49cff7e7a$export$bd8e1979d863fc93 = {
    type: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    Component: $55f71ca49cff7e7a$var$TeamsPlatformCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DropdownFieldPlaceholder), null),
    writer: (0, $eHQA5.singleUserPickerFieldWriter)
};

});
parcelRegister("kYlns", function(module, exports) {

$parcel$export(module.exports, "TeamField", () => $49c68942da73cb74$export$6f6cb44144d37e0d);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $cVsIh = parcelRequire("cVsIh");
const $49c68942da73cb74$var$CLICKED_KEY = 'clicked';
const $49c68942da73cb74$var$ONBOARDING_BANNER_KEY = 'TEAM_FIELD_ONBOARDING_BANNER_DISMISSED';
const $49c68942da73cb74$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('team-field-onboarding');
const $49c68942da73cb74$export$6f6cb44144d37e0d = (props)=>{
    // We need to override the localstorage so we don't get any of the onboarding for the form
    $49c68942da73cb74$var$localStorage.set($49c68942da73cb74$var$CLICKED_KEY, true);
    $49c68942da73cb74$var$localStorage.set($49c68942da73cb74$var$ONBOARDING_BANNER_KEY, true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVsIh.default), props);
};

});
parcelRegister("cVsIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9de4748d32e5e185$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $5GxEP = parcelRequire("5GxEP");

var $dibFF = parcelRequire("dibFF");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $QjiuJ = parcelRequire("QjiuJ");

var $eHKLj = parcelRequire("eHKLj");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $iuMpO = parcelRequire("iuMpO");
const $9de4748d32e5e185$var$overrideSelectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
    control: (base)=>({
            ...base,
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
        })
};
const $9de4748d32e5e185$var$stopFormPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $9de4748d32e5e185$export$96c8ee98de63ec5b = (props)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const siteId = tenantContext.cloudId;
    /**
   * The following is a hack to force the TeamPickerEdit to close after creating a team.
   * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
   * doesn't expose the select Ref.
   *  */ const [hackIsEditable, setHackIsEditable] = (0, $eUqFw.useState)(true);
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
    const onCreate = (0, $eUqFw.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                memberCount: team.memberCount
            });
            /**
       * The following is a hack to force the TeamPickerEdit to close after creating a team.
       * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
       * doesn't expose the select Ref.
       *  */ setHackIsEditable(false);
            // required wait for new created team to be available
            setTimeout(()=>{
                onChange(team);
                setHackIsEditable(true);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $eHKLj.useCreateTeamDialog)({
        onCreate: onCreate
    });
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "team-picker-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $QjiuJ.AsyncTeamPickerEdit), {
            ...fieldProps,
            width: width,
            siteId: siteId,
            autoFocus: autoFocus,
            defaultValue: value,
            // @ts-expect-error - TS2322 - Type '(value: TeamValue) => void' is not assignable to type 'OnChange'.
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isEditable === false || !hackIsEditable,
            styles: $9de4748d32e5e185$var$overrideSelectStyles,
            createTeamDialogTrigger: createTeamDialogTrigger
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $9de4748d32e5e185$var$stopFormPropagation
    }, createTeamDialog)));
};
var $9de4748d32e5e185$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $iuMpO.validateAtlassianTeamsField),
    transformDefaultValue: (0, $iuMpO.transformDefaultAtlassianTeam)
})($9de4748d32e5e185$export$96c8ee98de63ec5b);

});
parcelRegister("QjiuJ", function(module, exports) {

$parcel$export(module.exports, "AsyncTeamPickerEdit", () => $466c06ff57d4ee5e$export$7db2ade8dff2be91);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $gd6Co = parcelRequire("gd6Co");
const $466c06ff57d4ee5e$var$EMPTY_OBJECT = {};

const $466c06ff57d4ee5e$export$eaed616868423e8a = (0, $7rh0R.lazy)(()=>(parcelRequire("hOwXS")), {
    moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
});
const $466c06ff57d4ee5e$export$7db2ade8dff2be91 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $gd6Co.asyncTeamPickerEditEntryPoint), // use stable object reference to avoid re-renders
    $466c06ff57d4ee5e$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "async-jira-issue-atlassian-team-picker-edit",
        packageName: "jira-issue-field-team",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("gd6Co", function(module, exports) {

$parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", () => $68b8796b9db76c2a$export$80ec8c2b96e9988);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $68b8796b9db76c2a$export$80ec8c2b96e9988 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hOwXS")).then((module)=>module.TeamPickerEditEntryPointContent), {
        moduleId: "ce0fa7b5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hOwXS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jLoIc").then(()=>parcelRequire('hOa1E'));

});



parcelRegister("eHKLj", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamDialog", () => $d4e307a1265eaa92$export$e8b8170429d616be);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ao10V = parcelRequire("ao10V");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $cWiVr = parcelRequire("cWiVr");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $45GTD = parcelRequire("45GTD");

const $d4e307a1265eaa92$export$75096afde50756fd = (0, $7rh0R.lazy)(()=>(parcelRequire("ig8Pv")).then((module)=>module.TeamCreateDialog), {
    moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
});
const $d4e307a1265eaa92$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $eUqFw.useState)('');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const enableMembershipSettingsChoice = (0, $1ybV0.ff)('ptc.membership-controls');
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $eUqFw.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $eUqFw.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45GTD.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $ao10V.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4e307a1265eaa92$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: enableMembershipSettingsChoice,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});
parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("bmR0P")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("bmR0P", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});

parcelRegister("ig8Pv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7RHQf")
]).then(()=>parcelRequire('76J5t'));

});


parcelRegister("iuMpO", function(module, exports) {

$parcel$export(module.exports, "mutateAtlassianTeamField", () => $7e86af44a59a06c6$export$c8b8a48d1ff67754);
$parcel$export(module.exports, "transformDefaultAtlassianTeam", () => $7e86af44a59a06c6$export$3fee94ad0b9e180c);
$parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", () => $7e86af44a59a06c6$export$450002773f9da0a4);
$parcel$export(module.exports, "validateAtlassianTeamsField", () => $7e86af44a59a06c6$export$8222f94513c7d2e6);

var $dEMIg = parcelRequire("dEMIg");

const $7e86af44a59a06c6$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $382d64cd40713055$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.id
        }
    } : null;
const $7e86af44a59a06c6$export$3fee94ad0b9e180c = (team)=>({
        name: team.name,
        id: team.teamId,
        avatarUrl: team?.avatar?.small
    });
const $7e86af44a59a06c6$export$450002773f9da0a4 = (team)=>{
    if (team && team.id) return team.id;
    return null;
};
const $7e86af44a59a06c6$export$8222f94513c7d2e6 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};

});
const $382d64cd40713055$export$31fd86f8f183952c = 'atlassianTeamFields';





parcelRegister("9Yn24", function(module, exports) {

$parcel$export(module.exports, "TextAreaCustomFieldTypeConfig", () => $488da553c4cd26ec$export$a843cc77cac50059);

var $eUqFw = parcelRequire("eUqFw");

var $a3FRc = parcelRequire("a3FRc");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $488da553c4cd26ec$var$TextAreaCustomFieldTypeComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a3FRc.default), props);
const $488da553c4cd26ec$export$a843cc77cac50059 = {
    type: (0, $lO4Or.TEXT_AREA_CF_TYPE),
    Component: $488da553c4cd26ec$var$TextAreaCustomFieldTypeComponent,
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.DescriptionFieldPlaceholder), null),
    writer: (0, $eHQA5.textAreaFieldWriter)
};

});
parcelRegister("a3FRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8245715f63eaa826$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $3xOFI = parcelRequire("3xOFI");

const $8245715f63eaa826$var$TextAreaField = (props)=>{
    const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const onTextAreaChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xOFI.default), {
        ...fieldProps,
        value: value,
        onChange: onTextAreaChange,
        onBlur: onBlur,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isDisabled: isReadOnly
    }));
};
var $8245715f63eaa826$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TextAreaFieldConfig, string>, any>'.
$8245715f63eaa826$var$TextAreaField);

});
parcelRegister("3xOFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $abebd97e0a4b55bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $xeS7R = parcelRequire("xeS7R");
const $abebd97e0a4b55bd$var$TextAreaEdit = (props)=>{
    const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        ...fieldProps,
        isRequired: isRequired,
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        isInvalid: isInvalid,
        minimumRows: minimumRows,
        isDisabled: isDisabled
    });
};
var $abebd97e0a4b55bd$export$2e2bcd8739ae039 = $abebd97e0a4b55bd$var$TextAreaEdit;

});
parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});






parcelRegister("9so77", function(module, exports) {

$parcel$export(module.exports, "TextCustomFieldTypeConfig", () => $5f9157b7cdc38bf0$export$c0fb3f2e63d9c457);

var $eUqFw = parcelRequire("eUqFw");

var $fKpo5 = parcelRequire("fKpo5");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $5f9157b7cdc38bf0$export$c0fb3f2e63d9c457 = {
    type: (0, $lO4Or.TEXT_CF_TYPE),
    Component: (0, $fKpo5.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.TextFieldPlaceholder), null),
    writer: (0, $eHQA5.textFieldWriter)
};

});

parcelRegister("jg3OZ", function(module, exports) {

$parcel$export(module.exports, "UrlCustomFieldTypeConfig", () => $ebc953b977bcd341$export$ffd29c07a77eba88);

var $eUqFw = parcelRequire("eUqFw");

var $9LZ9B = parcelRequire("9LZ9B");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $ebc953b977bcd341$export$ffd29c07a77eba88 = {
    type: (0, $lO4Or.URL_CF_TYPE),
    Component: (0, $9LZ9B.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.TextFieldPlaceholder), null),
    writer: (0, $eHQA5.urlFieldWriter)
};

});
parcelRegister("9LZ9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $531cfc54e5b6818a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guGTQ = parcelRequire("guGTQ");

const $531cfc54e5b6818a$var$UrlField = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guGTQ.default), {
        type: "url",
        width: width,
        ...rest
    });
};
var $531cfc54e5b6818a$export$2e2bcd8739ae039 = $531cfc54e5b6818a$var$UrlField;

});


parcelRegister("eZ99k", function(module, exports) {

$parcel$export(module.exports, "UserCustomFieldTypeConfig", () => $ee4a2b1e8deaf1ad$export$e4e5f327b24b40ce);

var $eUqFw = parcelRequire("eUqFw");

var $60BSb = parcelRequire("60BSb");

var $lO4Or = parcelRequire("lO4Or");

var $5mmO4 = parcelRequire("5mmO4");

var $eHQA5 = parcelRequire("eHQA5");
const $ee4a2b1e8deaf1ad$export$e4e5f327b24b40ce = {
    type: (0, $lO4Or.USER_CF_TYPE),
    Component: (0, $60BSb.default),
    placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mmO4.AssigneeFieldPlaceholder), null),
    writer: (0, $eHQA5.singleUserPickerFieldWriter)
};

});


parcelRegister("8OVaT", function(module, exports) {

$parcel$export(module.exports, "isFieldTypeSupported", () => $5b0254e006cf8c59$export$b47920a5dd99844f);
$parcel$export(module.exports, "isFieldImproperForForm", () => $5b0254e006cf8c59$export$567d10980a8f2859);
// file to be removed with clean up of `jwm-form-field-configs` feature gate

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
/**
 * An object used for look up whether a certain field type is supported (only for fields that should be shown in form)
 * Created as an object instead of map so we can reuse the `FormSupportedFieldTypeMap` type
 * it will ensure we have single source of truth for all supported fields (using type checking)
 */ const $5b0254e006cf8c59$var$supportedVisibleFieldsMap = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: true,
    [(0, $lO4Or.URL_CF_TYPE)]: true,
    [(0, $lO4Or.TEXT_CF_TYPE)]: true,
    [(0, $lO4Or.DATE_CF_TYPE)]: true,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: true,
    [(0, $lO4Or.DUE_DATE_TYPE)]: true,
    [(0, $lO4Or.SUMMARY_TYPE)]: true,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: true,
    [(0, $lO4Or.LABELS_TYPE)]: true,
    [(0, $lO4Or.LABELS_CF_TYPE)]: true,
    [(0, $lO4Or.SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: true,
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: true,
    [(0, $lO4Or.USER_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: true,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: true,
    [(0, $lO4Or.GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: true,
    [(0, $lO4Or.TEAM_CF_TYPE)]: true,
    [(0, $lO4Or.PRIORITY_TYPE)]: true,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: true,
    [(0, $lO4Or.ATTACHMENT_TYPE)]: true,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: true,
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: true
};
const $5b0254e006cf8c59$export$b47920a5dd99844f = (fieldType)=>fieldType in $5b0254e006cf8c59$var$supportedVisibleFieldsMap;
// functions below to be migrated to utils/field-config/index.tsx
// with clean up of `jwm-form-field-configs` feature gate
/**
 * List of fields IDs that do not make sense to be shown in form
 * This is based on https://hello.atlassian.net/wiki/spaces/JBus/pages/988271414/Forms+-+Field+support+prioritisation Quadrant 4
 */ const $5b0254e006cf8c59$var$improperFieldIdsForForm = new Set([
    'created',
    'issuelinks',
    'issuetype',
    'parent',
    'project',
    'resolution',
    'security',
    'subtasks',
    'timeoriginalestimate',
    'updated',
    'updated',
    'votes',
    'watches'
]);
// List of field IDs that are being excluded above in `improperFieldIdsForForm` but are being introduced
// as part of `forms_work-intake_rollout-1`.
//
// To be removed from above list on feature gate cleanup.
const $5b0254e006cf8c59$var$extendedFieldIdsForForm = new Set([
    'parent'
]);
const $5b0254e006cf8c59$var$improperFieldTypesForForm = new Set([
    (0, $lO4Or.EPIC_TYPE),
    (0, $lO4Or.EPIC_COLOR_TYPE),
    (0, $lO4Or.EPIC_NAME_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE),
    (0, $lO4Or.AFFECTS_VERSIONS_TYPE),
    (0, $lO4Or.MULTI_VERSION_CF_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.SPRINT_TYPE)
]);
// List of field IDs that are being excluded above in `improperFieldTypesForForm` but are being introduced
// as part of `forms_work-intake_rollout-1`.
//
// To be removed from above list on feature gate cleanup.
const $5b0254e006cf8c59$var$extendedFieldTypesForForm = new Set([
    (0, $lO4Or.COMPONENTS_TYPE)
]);
const $5b0254e006cf8c59$export$567d10980a8f2859 = ({ fieldId: fieldId, fieldName: fieldName, fieldType: fieldType })=>{
    const isImproperFieldId = $5b0254e006cf8c59$var$improperFieldIdsForForm.has(fieldId);
    if ((0, $eI5EY.fg)('forms_work-intake_rollout-1')) {
        if (isImproperFieldId && !$5b0254e006cf8c59$var$extendedFieldIdsForForm.has(fieldId)) return true;
    } else if (isImproperFieldId) return true;
    const isImproperFieldType = $5b0254e006cf8c59$var$improperFieldTypesForForm.has(fieldType);
    if ((0, $eI5EY.fg)('forms_work-intake_rollout-1')) {
        if (isImproperFieldType && !$5b0254e006cf8c59$var$extendedFieldTypesForForm.has(fieldType)) return true;
    } else if (isImproperFieldType) return true;
    // Cases for others where fieldId and fieldType are not sufficient
    // and requires combination of both
    // e.g. for some custom field because their fieldId is different in every instance
    // Flagged field
    if (fieldName === 'Flagged' && fieldType === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) return true;
    return false;
};

});



parcelRegister("43p7l", function(module, exports) {

$parcel$export(module.exports, "MediaPermissionsPreloader", () => $c27b9dcff575fa0c$export$1ea28abf1046610e);
$parcel$export(module.exports, "useMediaPermissions", () => $c27b9dcff575fa0c$export$270452b93e9d2c99);

var $eUqFw = parcelRequire("eUqFw");

var $gr4KS = parcelRequire("gr4KS");

var $6w3wu = parcelRequire("6w3wu");
const $c27b9dcff575fa0c$export$1ea28abf1046610e = ({ projectId: projectId, formId: formId })=>{
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, $gr4KS.useUploadPermissions)();
    const [, { updateStore: updateStore }] = (0, $6w3wu.useMediaPermissionsStore)();
    (0, $eUqFw.useEffect)(()=>{
        if (projectId) fetchUploadPermissions(projectId, formId);
    }, [
        projectId,
        fetchUploadPermissions,
        formId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateStore({
            mediaUploadPermissions: uploadPermissions,
            mediaUploadPermissionStatus: uploadPermissionStatus
        });
    }, [
        updateStore,
        uploadPermissionStatus,
        uploadPermissions
    ]);
    return null;
};
const $c27b9dcff575fa0c$export$270452b93e9d2c99 = ()=>{
    const [{ mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus }] = (0, $6w3wu.useMediaPermissionsStore)();
    const isUploadPermissionReady = mediaUploadPermissionStatus === 'COMPLETED' && mediaUploadPermissions !== null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        mediaUploadPermissions: mediaUploadPermissions,
        mediaUploadPermissionStatus: mediaUploadPermissionStatus,
        mediaContext: {
            viewContext: isUploadPermissionReady ? mediaUploadPermissions : {},
            uploadContext: isUploadPermissionReady ? mediaUploadPermissions : {},
            userAuth: null
        }
    };
};

});
parcelRegister("gr4KS", function(module, exports) {

$parcel$export(module.exports, "useUploadPermissions", () => $907c83621f508675$export$9fc4bf889c7dbfba);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3hn0S = parcelRequire("3hn0S");
const $907c83621f508675$var$QUERY_ID = 'formSubmissionMediaPermissions';
const $907c83621f508675$export$9fc4bf889c7dbfba = (isDescriptionField)=>{
    const [uploadPermissionStatus, setUploadPermissionStatus] = (0, $eUqFw.useState)('NOT_STARTED');
    const [uploadPermissions, setUploadPermissions] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fetchUploadPermissions = (0, $eUqFw.useCallback)(async (projectId, formId)=>{
        setUploadPermissionStatus('LOADING');
        try {
            const url = (0, $3hn0S.getMediaUploadPermissionUrl)(formId, Boolean(isDescriptionField));
            const uploadResponse = await (0, $lRmyA.performGetRequest)(url);
            setUploadPermissions({
                clientId: uploadResponse.clientId,
                serviceHost: uploadResponse.endpointUrl,
                token: uploadResponse.token,
                tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
                collection: uploadResponse.targetCollection,
                tokenIssueTimestamp: Date.now() - 10000
            });
            setUploadPermissionStatus('COMPLETED');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setUploadPermissionStatus('COMPLETED');
            if (err.statusCode === 403) // user does not have media permission
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$907c83621f508675$var$QUERY_ID} forbidden`);
            else (0, $guiFP.default)({
                meta: {
                    id: $907c83621f508675$var$QUERY_ID,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                attributes: {
                    statusCode: err.statusCode
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        isDescriptionField
    ]);
    return {
        uploadPermissions: uploadPermissions,
        fetchUploadPermissions: fetchUploadPermissions,
        uploadPermissionStatus: uploadPermissionStatus
    };
};

});
parcelRegister("3hn0S", function(module, exports) {

$parcel$export(module.exports, "getMediaUploadPermissionUrl", () => $fbe40b415327fee9$export$9f4e6a02a32c7984);
$parcel$export(module.exports, "getFormAttachmentUploadUrl", () => $fbe40b415327fee9$export$b80950102aaa651d);
const $fbe40b415327fee9$export$9f4e6a02a32c7984 = (formId, returnCreateIssueAdf)=>`/rest/api/2/attachment/upload/form/${formId}/credentials?returnCreateIssueAdf=${returnCreateIssueAdf}`;
const $fbe40b415327fee9$export$b80950102aaa651d = (formId)=>`/rest/api/2/attachment/upload/form/${formId}`;

});


parcelRegister("6w3wu", function(module, exports) {

$parcel$export(module.exports, "useMediaPermissionsStore", () => $b876705335ad75fa$export$9c03e2ed7cceacd6);

var $1yZQx = parcelRequire("1yZQx");
var $kEDjj = parcelRequire("kEDjj");
const $b876705335ad75fa$var$actions = {
    updateStore: (newData)=>({ setState: setState })=>{
            setState(newData);
        }
};
const $b876705335ad75fa$var$MediaPermissionsStore = (0, $kEDjj.createStore)({
    initialState: {
        mediaUploadPermissions: null,
        mediaUploadPermissionStatus: 'NOT_STARTED'
    },
    actions: $b876705335ad75fa$var$actions,
    name: 'JWMMediaPermissions'
});
const $b876705335ad75fa$export$9c03e2ed7cceacd6 = (0, $1yZQx.createHook)($b876705335ad75fa$var$MediaPermissionsStore);

});


const $0cdd2a7b0e5b40c4$export$aa78f5e84beba3ce = 240;

parcelRegister("aFKy5", function(module, exports) {

$parcel$export(module.exports, "ContactAdminBanner", () => $3f207117f1b8fd23$export$a50845fcec7cb9ff);

var $eUqFw = parcelRequire("eUqFw");

var $2CgwC = parcelRequire("2CgwC");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $f66c4 = parcelRequire("f66c4");
const $3f207117f1b8fd23$var$ContactYourAdminLink = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "/jira/contact-administrator"
    }, children);
const $3f207117f1b8fd23$export$a50845fcec7cb9ff = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(true);
    const handleDismissClick = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3f207117f1b8fd23$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CgwC.default), {
        testId: "business-form.ui.form-submission.contact-admin-banner.banner",
        appearance: "announcement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: $3f207117f1b8fd23$var$ContactYourAdminLink
        },
        message: formatMessage((0, $f66c4.default).needToEdit, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3f207117f1b8fd23$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        label: "dismiss",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "medium",
            label: formatMessage((0, $f66c4.default).dismiss),
            primaryColor: "var(--ds-text-inverse, white)"
        }),
        onClick: handleDismissClick
    })));
};
const $3f207117f1b8fd23$var$bannerContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $3f207117f1b8fd23$var$buttonContainerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100'
});

});
parcelRegister("f66c4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6474bd6c1d6c09a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6474bd6c1d6c09a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    needToEdit: {
        "id": "business-form.form-submission.contact-admin-banner.need-to-edit",
        "defaultMessage": "{linkStart}Contact your admin{linkEnd} to edit this form."
    },
    dismiss: {
        "id": "business-form.form-submission.contact-admin-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("fSjXT", function(module, exports) {

$parcel$export(module.exports, "FillInView", () => $2233796bee54d2c1$export$32d78bb31929ae49);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $7opLA = parcelRequire("7opLA");

var $lzLxZ = parcelRequire("lzLxZ");
var $7CD1S = parcelRequire("7CD1S");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $KDxjy = parcelRequire("KDxjy");

var $gUUjF = parcelRequire("gUUjF");

var $eI5EY = parcelRequire("eI5EY");

var $3tfzg = parcelRequire("3tfzg");
var $izafr = parcelRequire("izafr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $aeIT6 = parcelRequire("aeIT6");

var $hRKQW = parcelRequire("hRKQW");

var $eUn4H = parcelRequire("eUn4H");

var $k8UPO = parcelRequire("k8UPO");

var $eXHxV = parcelRequire("eXHxV");

var $dkCxC = parcelRequire("dkCxC");

var $i3wcx = parcelRequire("i3wcx");

var $82V0G = parcelRequire("82V0G");

var $43p7l = parcelRequire("43p7l");

var $6iirx = parcelRequire("6iirx");

var $gr4KS = parcelRequire("gr4KS");

var $3hn0S = parcelRequire("3hn0S");

var $kzxpN = parcelRequire("kzxpN");

var $lwJwV = parcelRequire("lwJwV");
const $2233796bee54d2c1$var$submissionErrorFlag = (errorMessage)=>{
    if (errorMessage === (0, $hRKQW.FORM_VALIDATION_ERROR).ATTACHMENT_ERROR) return {
        type: 'error',
        title: (0, $kzxpN.default).submissionErrorFlag,
        description: (0, $kzxpN.default).submissionAttachmentErrorContent,
        testId: 'business-form.ui.form-submission.fill-in-view.form-attachment-error-flag'
    };
    return {
        type: 'error',
        title: (0, $kzxpN.default).submissionErrorFlag,
        description: errorMessage,
        testId: 'business-form.ui.form-submission.fill-in-view.error-flag'
    };
};
const $2233796bee54d2c1$var$interactions = [
    'scroll',
    'click',
    'focus',
    'keydown'
];
const $2233796bee54d2c1$var$hasInitialInteractionCapture = true;
const $2233796bee54d2c1$export$32d78bb31929ae49 = ()=>{
    const [uploading, setUploading] = (0, $eUqFw.useState)(false);
    const [shouldRenderExtraFields, setShouldRenderExtraFields] = (0, $eUqFw.useState)(false);
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: formSubmissionData, formId: formId } = (0, $82V0G.useFormSubmission)();
    const { data: projectData } = (0, $aeIT6.useProject)();
    const { shouldHidePoweredBy: shouldHidePoweredBy } = (0, $i3wcx.useJWMFormsFeatures)();
    const { formWithFieldData: formWithFieldData, fieldMetaData: fieldMetaData } = formSubmissionData ?? {};
    const { description: description, projectId: projectId, accessLevel: accessLevel, issueType: issueType } = formWithFieldData ?? {};
    // This is for description field
    const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, $gr4KS.useUploadPermissions)(true);
    const { mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus, mediaContext: mediaContext } = (0, $43p7l.useMediaPermissions)();
    const isUploadPermissionNotReady = uploadPermissionStatus !== 'COMPLETED' || mediaUploadPermissionStatus !== 'COMPLETED';
    const parsedDescription = (0, $eUqFw.useMemo)(()=>{
        if (description === undefined || description === '') return undefined;
        try {
            return JSON.parse(description);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $hRKQW.PACKAGE_NAME), 'failed to parse form description in form submission');
            // ignore description from backend if it's not a valid JSON format
            return undefined;
        }
    }, [
        description
    ]);
    const analyticAttributes = (0, $eUqFw.useMemo)(()=>({
            accessLevel: accessLevel?.toString(),
            isOutsideUser: !projectData || !projectData?.permissions.createIssues,
            formId: formId
        }), [
        accessLevel,
        projectData,
        formId
    ]);
    const handleCreateIssueOnComplete = (0, $eUqFw.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    const handleResetClick = (0, $eUqFw.useCallback)(()=>{
        setIsVisible(true);
    }, [
        setIsVisible
    ]);
    const renderExtraFields = (0, $eUqFw.useCallback)(()=>{
        setShouldRenderExtraFields(true);
        $2233796bee54d2c1$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $2233796bee54d2c1$var$hasInitialInteractionCapture));
    }, []);
    const setRef = (0, $lwJwV.useIntersectionObserver)(renderExtraFields);
    const setIntersectionRef = (0, $eUqFw.useCallback)((element)=>setRef(element), [
        setRef
    ]);
    const { create: create, data: createIssueData, error: createIssueError, errorMessage: errorMessage, loading: createIssueLoading } = (0, $6iirx.useCreateIssue)(formSubmissionData?.formWithFieldData, handleCreateIssueOnComplete);
    const handleSubmitClick = (0, $eUqFw.useCallback)(async (formData)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'form submitted', 'formSubmission', analyticAttributes);
        await create(formData);
    }, [
        create,
        createAnalyticsEvent,
        analyticAttributes
    ]);
    const renderFieldsNew = (0, $eUqFw.useCallback)((fields)=>fields.map((f)=>{
            // If the field no longer exists, do not render it.
            if (!fieldMetaData || !fieldMetaData[f.fieldId]) return null;
            const fieldConfig = (0, $eXHxV.getFieldTypeConfig)(f.type);
            if (!fieldConfig) {
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field missing', {
                    type: f.type
                });
                return null;
            }
            const { autoCompleteUrl: autoCompleteUrl, allowedValues: allowedValues = [], defaultFieldValue: defaultFieldValue, schema: schema } = fieldMetaData[f.fieldId]; /**
                                   * autoCompleteUrls contains origin/host.
                                   * In storybook, we want these to point to our proxy.
                                   */ 
            let completeUrl = autoCompleteUrl;
            if (Boolean(undefined) && typeof autoCompleteUrl === 'string') {
                const url = new URL(autoCompleteUrl);
                completeUrl = `${url.pathname}${url.search}`;
            }
            const isFieldRequired = (0, $eI5EY.fg)('forms_work-intake_rollout-1') ? f.isRequired || !!f.isRequiredByForm : f.isRequired;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(fieldConfig.Component, {
                key: f.fieldId,
                fieldName: typeof f.alias === 'string' && f.alias.length > 0 ? f.alias : f.name,
                fieldId: f.fieldId,
                isRequired: isFieldRequired,
                autoCompleteUrl: completeUrl,
                allowedValues: allowedValues,
                mediaUploadContexts: {
                    uploadContext: uploadPermissions,
                    attachmentUploadContext: mediaUploadPermissions
                },
                projectId: String(projectId),
                issueTypeId: issueType?.id,
                onInProgressChange: setUploading,
                defaultValue: defaultFieldValue,
                attachmentCustomUploadURL: (0, $3hn0S.getFormAttachmentUploadUrl)(formId),
                canUserViewProject: Boolean(projectData?.permissions?.viewIssues),
                schemaConfiguration: schema?.configuration
            });
        }), [
        fieldMetaData,
        createAnalyticsEvent,
        uploadPermissions,
        mediaUploadPermissions,
        projectId,
        issueType?.id,
        formId,
        projectData?.permissions?.viewIssues
    ]);
    const renderFieldsOld = (0, $eUqFw.useCallback)((fields)=>fields.map((f)=>{
            // If the field no longer exists, do not render it.
            if (!fieldMetaData || !fieldMetaData[f.fieldId]) return null;
            const result = (0, $dkCxC.getField)(f.type);
            if (!result) {
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'field missing', {
                    type: f.type
                });
                return null;
            } // If mediaUploadPermissions is null, do not render attachment field.
            if (f.type === (0, $lO4Or.ATTACHMENT_TYPE) && !mediaUploadPermissions) return null;
            const { Component: Component } = result;
            const { autoCompleteUrl: autoCompleteUrl, allowedValues: allowedValues, defaultFieldValue: defaultFieldValue } = fieldMetaData[f.fieldId]; /**
                                   * autoCompleteUrls contains origin/host.
                                   * In storybook, we want these to point to our proxy.
                                   */ 
            let completeUrl = autoCompleteUrl;
            if (Boolean(undefined) && typeof autoCompleteUrl === 'string') {
                const url = new URL(autoCompleteUrl);
                completeUrl = `${url.pathname}${url.search}`;
            }
            const hasAlias = typeof f.alias === 'string' && f.alias.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                key: f.fieldId,
                fieldName: hasAlias ? f.alias : f.name,
                fieldId: f.fieldId,
                isRequired: f.isRequired,
                autoCompleteUrl: completeUrl,
                allowedValues: allowedValues,
                mediaUploadContext: f.type === (0, $lO4Or.DESCRIPTION_TYPE) ? uploadPermissions : mediaUploadPermissions,
                projectId: String(projectId),
                onInProgressChange: setUploading,
                defaultValue: defaultFieldValue,
                attachmentCustomUploadURL: (0, $3hn0S.getFormAttachmentUploadUrl)(formId)
            });
        }), [
        fieldMetaData,
        createAnalyticsEvent,
        uploadPermissions,
        mediaUploadPermissions,
        projectId,
        setUploading,
        formId
    ]);
    const renderFields = (0, $eI5EY.fg)('jwm-form-field-configs') ? renderFieldsNew : renderFieldsOld;
    const getErrorFlag = (0, $eUqFw.useCallback)(()=>errorMessage !== null && typeof errorMessage === 'string' ? $2233796bee54d2c1$var$submissionErrorFlag(errorMessage) : (0, $3tfzg.default).genericError(), [
        errorMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $2233796bee54d2c1$var$interactions.forEach((evt)=>document.addEventListener(evt, renderExtraFields, $2233796bee54d2c1$var$hasInitialInteractionCapture));
        return ()=>{
            $2233796bee54d2c1$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $2233796bee54d2c1$var$hasInitialInteractionCapture));
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (typeof projectId === 'number') fetchUploadPermissions(String(projectId), formId);
    }, [
        fetchUploadPermissions,
        formId,
        projectId
    ]);
    if (createIssueData?.success && !isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "business-form.ui.form-submission.fill-in-view.success-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.SuccessView), {
        shouldHidePoweredBy: shouldHidePoweredBy,
        onResetClick: handleResetClick,
        analyticAttributes: analyticAttributes
    }));
    if (!formSubmissionData || !formWithFieldData || !fieldMetaData || isUploadPermissionNotReady) return null;
     // only render the first 15 fields for performance reasons
    // remaining fields will be rendered once the user interacts with the page
    const cloneInitialFields = [
        ...formWithFieldData.fields
    ];
    const initialFields = cloneInitialFields.splice(0, 15);
    const shouldRenderAdditionalFields = cloneInitialFields.length > 0 && shouldRenderExtraFields;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "form",
        objectId: formId,
        containerType: "project",
        containerId: String(projectId),
        attributes: {
            ...(0, $lwJwV.generateFieldAnalytics)(formWithFieldData.fields),
            ...analyticAttributes
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "formSubmission viewed"
    }), projectData?.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2233796bee54d2c1$var$ProjectNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "small",
        src: projectData?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "span",
        color: "color.text.subtle",
        weight: "semibold"
    }, projectData?.name))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2233796bee54d2c1$var$projectNamePlaceholderStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formWithFieldData.title,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $KDxjy.TitleWrapperTruncated), null, formWithFieldData.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2233796bee54d2c1$var$DescriptionWrapper, {
        "data-testid": "business-form.ui.form-submission.fill-in-view.description"
    }, parsedDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "description-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUn4H.default), {
        document: parsedDescription,
        mediaContext: mediaContext,
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true
        },
        baseUrl: ""
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        isDisabled: createIssueLoading || createIssueData?.success && !isVisible,
        onSubmit: handleSubmitClick
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            ...formProps,
            name: "submit form",
            "data-test-id": "business-form.ui.form-submission.fill-in-view.form"
        }, renderFields(initialFields), shouldRenderAdditionalFields && renderFields(cloneInitialFields), !shouldRenderAdditionalFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            ref: setIntersectionRef
        }), (shouldRenderAdditionalFields || formWithFieldData.fields.length <= 15) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
            testId: "business-form.ui.form-submission.fill-in-view.loading-button",
            type: "submit",
            appearance: "primary",
            isLoading: createIssueLoading || uploading,
            interactionName: "business-form-submission-submit"
        }, formatMessage((0, $kzxpN.default).submitButton))))), createIssueError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "business-form.ui.form-submission.fill-in-view.flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        flag: getErrorFlag()
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2233796bee54d2c1$var$ProjectNameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18s8zu5n",
            __cmplp.className
        ])
    });
});
const $2233796bee54d2c1$var$projectNamePlaceholderStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2233796bee54d2c1$var$DescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CD1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $564306fc9833a41c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $564306fc9833a41c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $564306fc9833a41c$var$formFooterWrapperStyles = {
    name: "1rruhyk",
    styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
};
const $564306fc9833a41c$var$justifyContentStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
function $564306fc9833a41c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("footer", {
        css: [
            $564306fc9833a41c$var$formFooterWrapperStyles,
            align === 'start' && $564306fc9833a41c$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("KDxjy", function(module, exports) {

$parcel$export(module.exports, "TitleWrapper", () => $d36811d08eda9ac1$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleWrapperTruncated", () => $d36811d08eda9ac1$export$179667894b01611b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d36811d08eda9ac1$export$585a3b23e887288b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81p5s _19pkidpf _fh0l1f4h _o8b6idpf _6id51kw7 _1ols1kw7",
            __cmplp.className
        ])
    });
});
const $d36811d08eda9ac1$export$179667894b01611b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $d36811d08eda9ac1$export$585a3b23e887288b, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3tfzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2f5282da7c4a398$export$2e2bcd8739ae039);

var $7ZFHa = parcelRequire("7ZFHa");

var $1yPyd = parcelRequire("1yPyd");

var $kZOWw = parcelRequire("kZOWw");

var $aiNUT = parcelRequire("aiNUT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2f5282da7c4a398$export$2e2bcd8739ae039 = {
    forbidden: $7ZFHa.default,
    genericError: $1yPyd.default,
    serverError: $kZOWw.default,
    unauthorized: $aiNUT.default
};

});
parcelRegister("7ZFHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $38183d80ce97928d$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $38183d80ce97928d$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38183d80ce97928d$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $38183d80ce97928d$var$messages.title,
        description: $38183d80ce97928d$var$messages.description
    });

});

parcelRegister("1yPyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2073c932b2866c1b$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $2073c932b2866c1b$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2073c932b2866c1b$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $2073c932b2866c1b$var$messages.title,
        description: $2073c932b2866c1b$var$messages.description
    });

});

parcelRegister("kZOWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e55ad6379920dc9f$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $e55ad6379920dc9f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e55ad6379920dc9f$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $e55ad6379920dc9f$var$messages.title,
        description: $e55ad6379920dc9f$var$messages.description
    });

});

parcelRegister("aiNUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $df39dc77bca926f0$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $df39dc77bca926f0$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df39dc77bca926f0$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $df39dc77bca926f0$var$messages.title,
        description: $df39dc77bca926f0$var$messages.description
    });

});


parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});


parcelRegister("eUn4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $df0710a10e2fa6d9$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $df0710a10e2fa6d9$var$AsyncDescriptionReadView = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("j12eR")), {
    ssr: false,
    moduleId: "./src/packages/business/form/src/common/ui/description-read/main.tsx"
});
var $df0710a10e2fa6d9$export$2e2bcd8739ae039 = $df0710a10e2fa6d9$var$AsyncDescriptionReadView;

});
parcelRegister("j12eR", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("15ZhV").then(()=>parcelRequire('ba61Y'));

});


parcelRegister("dkCxC", function(module, exports) {

$parcel$export(module.exports, "getField", () => $4b1024315e0ff79a$export$2c9b3f539cb25b05);
// file to be removed with clean up of `jwm-form-field-configs` feature gate

var $6nTlM = parcelRequire("6nTlM");

var $d6mZY = parcelRequire("d6mZY");

var $8MMgG = parcelRequire("8MMgG");

var $6ynFi = parcelRequire("6ynFi");

var $kfu77 = parcelRequire("kfu77");

var $2sjGj = parcelRequire("2sjGj");

var $4KGIz = parcelRequire("4KGIz");

var $l7nwo = parcelRequire("l7nwo");

var $8AMXG = parcelRequire("8AMXG");

var $hQhuO = parcelRequire("hQhuO");

var $7EBWy = parcelRequire("7EBWy");

var $5u49X = parcelRequire("5u49X");

var $ltG3Y = parcelRequire("ltG3Y");

var $kjSRM = parcelRequire("kjSRM");

var $ikozW = parcelRequire("ikozW");

var $k4Bm6 = parcelRequire("k4Bm6");

var $60BSb = parcelRequire("60BSb");

var $fKpo5 = parcelRequire("fKpo5");

var $a3FRc = parcelRequire("a3FRc");

var $9LZ9B = parcelRequire("9LZ9B");

var $lO4Or = parcelRequire("lO4Or");

var $lILJW = parcelRequire("lILJW");

var $kYlns = parcelRequire("kYlns");
/**
 * Form field mapping based on https://hello.atlassian.net/wiki/spaces/JBus/pages/988271414/Forms+-+Field+support+prioritisation
 */ const $4b1024315e0ff79a$var$fieldMap = {
    // Quadrant 1
    [(0, $lO4Or.SUMMARY_TYPE)]: {
        Component: (0, $fKpo5.default)
    },
    [(0, $lO4Or.ATTACHMENT_TYPE)]: {
        Component: (0, $d6mZY.default)
    },
    [(0, $lO4Or.DESCRIPTION_TYPE)]: {
        Component: (0, $lILJW.default)
    },
    // Quadrant 2
    [(0, $lO4Or.SELECT_CF_TYPE)]: {
        Component: (0, $k4Bm6.default)
    },
    [(0, $lO4Or.TEXT_CF_TYPE)]: {
        Component: (0, $fKpo5.default)
    },
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
        Component: (0, $6ynFi.default)
    },
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
        Component: (0, $a3FRc.default)
    },
    [(0, $lO4Or.DUE_DATE_TYPE)]: {
        Component: (0, $2sjGj.default)
    },
    [(0, $lO4Or.LABELS_TYPE)]: {
        Component: (0, $l7nwo.default)
    },
    [(0, $lO4Or.PRIORITY_TYPE)]: {
        Component: (0, $ltG3Y.default)
    },
    [(0, $lO4Or.DATE_CF_TYPE)]: {
        Component: (0, $2sjGj.default)
    },
    [(0, $lO4Or.NUMBER_CF_TYPE)]: {
        Component: (0, $5u49X.default)
    },
    [(0, $lO4Or.DATETIME_CF_TYPE)]: {
        Component: (0, $4KGIz.default)
    },
    [(0, $lO4Or.URL_CF_TYPE)]: {
        Component: (0, $9LZ9B.default)
    },
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
        Component: (0, $7EBWy.default)
    },
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
        Component: (0, $8MMgG.default)
    },
    [(0, $lO4Or.USER_CF_TYPE)]: {
        Component: (0, $60BSb.default)
    },
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
        Component: (0, $kjSRM.default)
    },
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
        Component: (0, $hQhuO.default)
    },
    // Quadrant 3
    [(0, $lO4Or.ASSIGNEE_TYPE)]: {
        Component: (0, $6nTlM.default)
    },
    [(0, $lO4Or.LABELS_CF_TYPE)]: {
        Component: (0, $l7nwo.default)
    },
    [(0, $lO4Or.GROUP_CF_TYPE)]: {
        Component: (0, $ikozW.default)
    },
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: {
        Component: (0, $8AMXG.default)
    },
    [(0, $lO4Or.TEAM_CF_TYPE)]: {
        Component: (0, $kfu77.default)
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        Component: (0, $kYlns.TeamField)
    }
};
const $4b1024315e0ff79a$export$2c9b3f539cb25b05 = (fieldType)=>$4b1024315e0ff79a$var$fieldMap[fieldType];

});

parcelRegister("6iirx", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $4b13d22e65f6ba50$export$8af2d18142c8506c);

var $iZuDo = parcelRequire("iZuDo");

var $kkYfO = parcelRequire("kkYfO");

var $4G5xU = parcelRequire("4G5xU");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hRKQW = parcelRequire("hRKQW");


var $5b7U5 = parcelRequire("5b7U5");

var $cDW1g = parcelRequire("cDW1g");
const $4b13d22e65f6ba50$var$QUERY_NAME = 'CreateJiraBusinessIssueForm';
const $4b13d22e65f6ba50$var$logMissing = (name)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $hRKQW.PACKAGE_NAME), `"${name}" was unexpectedly null or undefined for form submission`);
};
const $4b13d22e65f6ba50$export$8af2d18142c8506c = (formWithFieldData, onComplete)=>{
    const startExperience = (0, $4G5xU.useExperienceStart)((0, $hRKQW.SUBMIT_FORM_EXPERIENCE));
    const markExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $hRKQW.SUBMIT_FORM_EXPERIENCE));
    const markExperienceFailed = (0, $4G5xU.useExperienceFail)((0, $hRKQW.SUBMIT_FORM_EXPERIENCE));
    const doFireErrorAnalytics = (error)=>{
        (0, $guiFP.default)({
            meta: {
                id: $4b13d22e65f6ba50$var$QUERY_NAME,
                packageName: 'jiraBusinessForm',
                teamName: 'jira-werewolves'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: Array.isArray(error) && error.length > 0 ? error[0] : error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [createIssue, { data: data, loading: loading, error: error }] = (0, $iZuDo.useMutation)((0, $5b7U5.FORM_CREATE_ISSUE_MUTATION), {
        onError: (apolloError)=>{
            doFireErrorAnalytics(apolloError);
            markExperienceFailed('create issue service - mutation onError', apolloError);
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $hRKQW.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
        },
        onCompleted: (responseData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$4b13d22e65f6ba50$var$QUERY_NAME} succeeded`, {});
            if (responseData.createJiraBusinessIssueByForm?.errors) {
                const errors = responseData.createJiraBusinessIssueByForm.errors.map((e)=>new (0, $kkYfO.MutationError)(e)).filter((e)=>e.message !== (0, $hRKQW.FORM_VALIDATION_ERROR).ATTACHMENT_ERROR && e.extensions?.errorType !== (0, $604e08befce18d4b$export$b46f0126077d6b7c) && e.extensions?.errorType !== (0, $604e08befce18d4b$export$d65db43b48ab539f));
                if (errors.length > 0) {
                    doFireErrorAnalytics(errors);
                    const mutationError = errors.find((e)=>e.message);
                    if (mutationError) markExperienceFailed('Create issue service mutation failed', new (0, $kkYfO.MutationError)(mutationError), {
                        errorType: mutationError.extensions?.errorType || '',
                        statusCode: mutationError.extensions?.statusCode || ''
                    });
                }
                return;
            }
            if (responseData.createJiraBusinessIssueByForm?.item?.issueId) {
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(responseData.createJiraBusinessIssueByForm.item.issueId));
                onComplete?.();
            }
            markExperienceSuccess();
        }
    });
    /**
	 * This function will create an issue with specified fields
	 * It will always resolve the promise even if there are any errors (apollo error, bad request)
	 * To know whether it's successful or not, use the `data` and `error` prop returned by the hook
	 */ const create = async (formInputData)=>{
        const projectId = formWithFieldData?.projectId;
        const issueTypeId = formWithFieldData?.issueType?.id;
        const formId = formWithFieldData?.formId;
        startExperience();
        if (typeof formInputData !== 'object') {
            $4b13d22e65f6ba50$var$logMissing('formInputData');
            return;
        }
        if (typeof formWithFieldData !== 'object') {
            $4b13d22e65f6ba50$var$logMissing('formWithFieldData');
            return;
        }
        if (typeof projectId !== 'number') {
            $4b13d22e65f6ba50$var$logMissing('projectId');
            return;
        }
        if (typeof issueTypeId !== 'string') {
            $4b13d22e65f6ba50$var$logMissing('issueTypeId');
            return;
        }
        if (typeof formId !== 'string') {
            $4b13d22e65f6ba50$var$logMissing('formId');
            return;
        }
        const fields = (0, $cDW1g.transformFormData)({
            formInputData: formInputData,
            formWithFieldData: formWithFieldData
        });
        await createIssue({
            variables: {
                input: {
                    formId: formId,
                    fields: fields
                }
            },
            // @ts-expect-error - TS2345 - Argument of type '{ variables: { input: { projectId: string; issueType: string; fields: JiraIssueFieldsInput; }; }; onError: () => void; }' is not assignable to parameter of type 'MutationFunctionOptions<CreateJiraBusinessIssueForm, CreateJiraBusinessIssueFormVariables>'.
            // onError is needed to make sure the Promise always resolve instead of throwing Promise rejected error
            onError: ()=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $hRKQW.PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
            }
        });
    };
    // find error that has message
    const mutationBadRequestError = data?.createJiraBusinessIssueByForm?.errors?.map((e)=>new (0, $kkYfO.MutationError)(e))?.find((e)=>e.message);
    return {
        error: // if there are any errors from Apollo, surface that first
        // otherwise if there are errors from bad request, use that
        error || mutationBadRequestError,
        errorMessage: mutationBadRequestError ? (0, $cDW1g.transformErrorMessage)(mutationBadRequestError, formWithFieldData) : null,
        data: (0, $cDW1g.transformResult)(data),
        loading: loading,
        create: create
    };
};

});
parcelRegister("kkYfO", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $f83939e5f3c23160$export$10c788363424e94e);
const $f83939e5f3c23160$export$bd0568a021288e41 = 'MutationError';
class $f83939e5f3c23160$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
    }
}

});

const $604e08befce18d4b$export$b46f0126077d6b7c = 'REQUIRED_FIELD_MISSING';
const $604e08befce18d4b$export$d65db43b48ab539f = 'FIELD_VALIDATION_FAILED';

parcelRegister("5b7U5", function(module, exports) {

$parcel$export(module.exports, "FORM_CREATE_ISSUE_MUTATION", () => $a0da965d02c9ba42$export$8421abc4fb1c6a51);

var $9ypom = parcelRequire("9ypom");
const $a0da965d02c9ba42$export$8421abc4fb1c6a51 = (0, $9ypom.default)`
mutation CreateJiraBusinessIssueByForm($input: JwmFormCreateIssueInput!) {
  createJiraBusinessIssueByForm(input: $input) {
    item {
      id
      issueId
    }
    success
    errors {
      message
      extensions {
        ... on FieldValidationMutationErrorExtension {
          statusCode
          errorType
          fieldId
        }
      }
    }
  }
}
`;

});

parcelRegister("cDW1g", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $7e19475c10f76faa$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformFormData", () => $7e19475c10f76faa$export$d1360584b6d92fb7);
$parcel$export(module.exports, "transformErrorMessage", () => $7e19475c10f76faa$export$d7c77df21c828876);

var $3aUuh = parcelRequire("3aUuh");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $eXHxV = parcelRequire("eXHxV");

var $eHQA5 = parcelRequire("eHQA5");

var $3eMSI = parcelRequire("3eMSI");
const $7e19475c10f76faa$var$FORM_LABEL = 'business-form';
const $7e19475c10f76faa$export$f13b29f9ed0c5a03 = (data)=>{
    if (!data) return data;
    const issueId = data.createJiraBusinessIssueByForm?.item?.issueId;
    const isIssueIdValid = typeof issueId === 'number';
    const isCreateJiraBusinessIssueSuccessValid = typeof data.createJiraBusinessIssueByForm?.success === 'boolean';
    if (!isIssueIdValid || !isCreateJiraBusinessIssueSuccessValid) (0, $guiFP.default)({
        meta: {
            id: 'transformFormSubmissionResult',
            packageName: 'jiraBusinessForm',
            teamName: 'jira-werewolves'
        },
        attributes: {
            message: 'Some fields from form submission were not returned properly',
            isIssueIdValid: isIssueIdValid,
            isCreateJiraBusinessIssueSuccessValid: isCreateJiraBusinessIssueSuccessValid
        },
        sendToPrivacyUnsafeSplunk: true
    });
    if (typeof data.createJiraBusinessIssueByForm?.success !== 'boolean') return undefined;
    return {
        success: data.createJiraBusinessIssueByForm.success,
        issueId: issueId
    };
};
const $7e19475c10f76faa$export$d1360584b6d92fb7 = ({ formInputData: formInputData, formWithFieldData: formWithFieldData })=>{
    const formFieldsById = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(formWithFieldData.fields, (f)=>f.fieldId);
    const fields = {
        users: [],
        labels: [],
        versions: [],
        stringFields: [],
        adfFields: [],
        multipleSelectFields: [],
        singleGroupPickerFields: [],
        multipleGroupPickerFields: [],
        multipleSelectUserPickerFields: []
    };
    Object.entries(formInputData).forEach(([key, value])=>{
        if (value === undefined || value === null) return;
        const fieldData = formFieldsById[key];
        if (!fieldData) return;
        const { type: type } = fieldData;
        if ((0, $eI5EY.fg)('jwm-form-field-configs')) {
            const fieldConfig = (0, $eXHxV.getFieldTypeConfig)(type);
            if (!fieldConfig) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'transformFormSubmissionResult',
                        packageName: 'jiraBusinessForm',
                        teamName: 'jira-werewolves'
                    },
                    attributes: {
                        message: `"${type}" was unexpectedly missing in form config in form submission`
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            fieldConfig.writer(key, value, fields);
        } else {
            if (type in (0, $3eMSI.default) === false) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'transformFormSubmissionResult',
                        packageName: 'jiraBusinessForm',
                        teamName: 'jira-werewolves'
                    },
                    attributes: {
                        message: `"${type}" was unexpectedly missing for field mapping in form submission`
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            const { writeTo: writeTo } = (0, $3eMSI.default)[type];
            writeTo(key, value, fields);
        }
    });
    // If a label (FORM_LABEL) doesn't exist, add it.
    const labelsField = fields.labels.find((f)=>f.fieldId === 'labels');
    if (labelsField) {
        if (!labelsField.values.values.includes($7e19475c10f76faa$var$FORM_LABEL)) labelsField.values.values.push($7e19475c10f76faa$var$FORM_LABEL);
    } else fields.labels.push((0, $eHQA5.toLabelsField)('labels', [
        $7e19475c10f76faa$var$FORM_LABEL
    ]));
    return fields;
};
const $7e19475c10f76faa$export$d7c77df21c828876 = (err, formWithFieldData)=>{
    const fieldWithError = formWithFieldData?.fields?.find((field)=>field.fieldId === err?.extensions?.fieldId);
    const errorMessage = fieldWithError?.alias ? err?.message.replace(fieldWithError.name, fieldWithError.alias) : err?.message;
    return errorMessage;
};

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("3eMSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $adeb547b8bf47ab6$export$2e2bcd8739ae039);
// file to be removed with clean up of `jwm-form-field-configs` feature gate

var $lO4Or = parcelRequire("lO4Or");

var $fwjFM = parcelRequire("fwjFM");
const $adeb547b8bf47ab6$var$writersMap = {
    // Quadrant 1
    [(0, $lO4Or.SUMMARY_TYPE)]: {
        writeTo: (0, $fwjFM.textFieldWriter)
    },
    [(0, $lO4Or.DESCRIPTION_TYPE)]: {
        writeTo: (0, $fwjFM.descriptionFieldWriter)
    },
    [(0, $lO4Or.ATTACHMENT_TYPE)]: {
        writeTo: (0, $fwjFM.attachmentFieldWriter)
    },
    // Quadrant 2
    [(0, $lO4Or.SELECT_CF_TYPE)]: {
        writeTo: (0, $fwjFM.selectFieldWriter)
    },
    [(0, $lO4Or.TEXT_CF_TYPE)]: {
        writeTo: (0, $fwjFM.textFieldWriter)
    },
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
        writeTo: (0, $fwjFM.checkboxSelectFieldWriter)
    },
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
        writeTo: (0, $fwjFM.textAreaFieldWriter)
    },
    [(0, $lO4Or.DUE_DATE_TYPE)]: {
        writeTo: (0, $fwjFM.dateFieldWriter)
    },
    [(0, $lO4Or.LABELS_TYPE)]: {
        writeTo: (0, $fwjFM.labelsFieldWriter)
    },
    [(0, $lO4Or.LABELS_CF_TYPE)]: {
        writeTo: (0, $fwjFM.labelsFieldWriter)
    },
    [(0, $lO4Or.PRIORITY_TYPE)]: {
        writeTo: (0, $fwjFM.priorityFieldWriter)
    },
    [(0, $lO4Or.DATE_CF_TYPE)]: {
        writeTo: (0, $fwjFM.dateFieldWriter)
    },
    [(0, $lO4Or.NUMBER_CF_TYPE)]: {
        writeTo: (0, $fwjFM.numberFieldWriter)
    },
    [(0, $lO4Or.DATETIME_CF_TYPE)]: {
        writeTo: (0, $fwjFM.dateTimeFieldWriter)
    },
    [(0, $lO4Or.URL_CF_TYPE)]: {
        writeTo: (0, $fwjFM.urlFieldWriter)
    },
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
        writeTo: (0, $fwjFM.multiUserPickerFieldWriter)
    },
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
        writeTo: (0, $fwjFM.cascadingSelectFieldWriter)
    },
    [(0, $lO4Or.USER_CF_TYPE)]: {
        writeTo: (0, $fwjFM.singleUserPickerFieldWriter)
    },
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
        writeTo: (0, $fwjFM.radioSelectFieldWriter)
    },
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
        writeTo: (0, $fwjFM.multiSelectFieldWriter)
    },
    [(0, $lO4Or.GROUP_CF_TYPE)]: {
        writeTo: (0, $fwjFM.singleGroupPickerFieldWriter)
    },
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: {
        writeTo: (0, $fwjFM.multipleGroupPickerFieldWriter)
    },
    [(0, $lO4Or.TEAM_CF_TYPE)]: {
        writeTo: (0, $fwjFM.teamFieldWriter)
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        writeTo: (0, $fwjFM.singleUserPickerFieldWriter)
    },
    [(0, $lO4Or.ASSIGNEE_TYPE)]: {
        writeTo: (0, $fwjFM.assigneeFieldWriter)
    }
};
var $adeb547b8bf47ab6$export$2e2bcd8739ae039 = $adeb547b8bf47ab6$var$writersMap;

});
parcelRegister("fwjFM", function(module, exports) {

$parcel$export(module.exports, "textFieldWriter", () => $6b325a4d39cd3ea1$export$3f2b7c786f4381f3);
$parcel$export(module.exports, "selectFieldWriter", () => $6b325a4d39cd3ea1$export$9ed21ff1d3f239ed);
$parcel$export(module.exports, "checkboxSelectFieldWriter", () => $6b325a4d39cd3ea1$export$6372f460d19ccf04);
$parcel$export(module.exports, "textAreaFieldWriter", () => $6b325a4d39cd3ea1$export$daf547ed9d724058);
$parcel$export(module.exports, "dateFieldWriter", () => $6b325a4d39cd3ea1$export$ab1ac718ca53b3a2);
$parcel$export(module.exports, "labelsFieldWriter", () => $6b325a4d39cd3ea1$export$ad0f5c4a81b9b717);
$parcel$export(module.exports, "priorityFieldWriter", () => $6b325a4d39cd3ea1$export$255f6ed818b27fe9);
$parcel$export(module.exports, "numberFieldWriter", () => $6b325a4d39cd3ea1$export$f187c825de05664b);
$parcel$export(module.exports, "dateTimeFieldWriter", () => $6b325a4d39cd3ea1$export$aa8970635118882c);
$parcel$export(module.exports, "urlFieldWriter", () => $6b325a4d39cd3ea1$export$823b946bef17fbde);
$parcel$export(module.exports, "multiUserPickerFieldWriter", () => $6b325a4d39cd3ea1$export$f56da03febf03bbe);
$parcel$export(module.exports, "cascadingSelectFieldWriter", () => $6b325a4d39cd3ea1$export$dd0315e6bb70be50);
$parcel$export(module.exports, "singleUserPickerFieldWriter", () => $6b325a4d39cd3ea1$export$44ca38ec8bc1b849);
$parcel$export(module.exports, "radioSelectFieldWriter", () => $6b325a4d39cd3ea1$export$3930624833f8c678);
$parcel$export(module.exports, "multiSelectFieldWriter", () => $6b325a4d39cd3ea1$export$550c89601caa8cb);
$parcel$export(module.exports, "attachmentFieldWriter", () => $6b325a4d39cd3ea1$export$a751298e00103db5);
$parcel$export(module.exports, "descriptionFieldWriter", () => $6b325a4d39cd3ea1$export$8545d310869fe805);
$parcel$export(module.exports, "singleGroupPickerFieldWriter", () => $6b325a4d39cd3ea1$export$8b286e49fa801799);
$parcel$export(module.exports, "multipleGroupPickerFieldWriter", () => $6b325a4d39cd3ea1$export$ada212938d86109a);
$parcel$export(module.exports, "teamFieldWriter", () => $6b325a4d39cd3ea1$export$77028ba2835a8f1c);
$parcel$export(module.exports, "assigneeFieldWriter", () => $6b325a4d39cd3ea1$export$1c1d0a4431d22b72);
// file to be removed with clean up of `jwm-form-field-configs` feature gate

var $bRVha = parcelRequire("bRVha");

var $9PXwb = parcelRequire("9PXwb");

var $i5YRy = parcelRequire("i5YRy");

var $d7a37 = parcelRequire("d7a37");

var $26Ej0 = parcelRequire("26Ej0");

var $2XekW = parcelRequire("2XekW");

var $dLZA6 = parcelRequire("dLZA6");

var $42gdJ = parcelRequire("42gdJ");

var $9tBd5 = parcelRequire("9tBd5");
const $6b325a4d39cd3ea1$var$toMultipleSelectField = (id, ids)=>{
    const toOptionInput = (optionId)=>({
            id: optionId
        });
    return {
        fieldId: id,
        options: ids.map(toOptionInput)
    };
};
const $6b325a4d39cd3ea1$var$toStringField = (id, value)=>({
        fieldId: id,
        value: value
    });
const $6b325a4d39cd3ea1$export$7a0cc61c6cdac523 = (id, labels)=>({
        fieldId: id,
        values: {
            values: labels
        }
    });
const $6b325a4d39cd3ea1$var$toPriorityField = (priorityId)=>({
        priorityId: priorityId
    });
const $6b325a4d39cd3ea1$export$f27a949cf2ef9fc6 = (id, accountId)=>({
        fieldId: id,
        user: {
            accountId: accountId
        }
    });
const $6b325a4d39cd3ea1$var$toADFField = (id, adf)=>{
    const { version: version } = adf;
    return {
        fieldId: id,
        adf: {
            version: version,
            jsonValue: adf
        }
    };
};
const $6b325a4d39cd3ea1$var$toGroupInput = (pickerOption)=>({
        groupName: pickerOption.name
    });
const $6b325a4d39cd3ea1$export$3f2b7c786f4381f3 = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, value));
};
const $6b325a4d39cd3ea1$export$9ed21ff1d3f239ed = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, String((0, $42gdJ.mapSelectOptionsToData)(value).id)));
};
const $6b325a4d39cd3ea1$export$6372f460d19ccf04 = (id, value, fields)=>{
    fields.multipleSelectFields.push($6b325a4d39cd3ea1$var$toMultipleSelectField(id, (0, $d7a37.mapOptionsToData)(value).map((o)=>o.id)));
};
const $6b325a4d39cd3ea1$export$daf547ed9d724058 = (id, value, fields)=>{
    fields.adfFields.push($6b325a4d39cd3ea1$var$toADFField(id, (0, $9tBd5.convertTextToAdf)(value)));
};
const $6b325a4d39cd3ea1$export$ab1ac718ca53b3a2 = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, value));
};
const $6b325a4d39cd3ea1$export$ad0f5c4a81b9b717 = (id, value, fields)=>{
    fields.labels.push($6b325a4d39cd3ea1$export$7a0cc61c6cdac523(id, (0, $26Ej0.mapLabelOptionsToData)(value)));
};
const $6b325a4d39cd3ea1$export$255f6ed818b27fe9 = (_id, value, fields)=>{
    // eslint-disable-next-line no-param-reassign
    fields.priority = $6b325a4d39cd3ea1$var$toPriorityField((0, $2XekW.mapOptionToData)(value).id);
};
const $6b325a4d39cd3ea1$export$f187c825de05664b = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, value));
};
const $6b325a4d39cd3ea1$export$aa8970635118882c = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, value));
};
const $6b325a4d39cd3ea1$export$823b946bef17fbde = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, value));
};
const $6b325a4d39cd3ea1$export$f56da03febf03bbe = (id, value, fields)=>{
    const accountIds = (0, $bRVha.mapUserOptionsToAccountIds)(value);
    fields.multipleSelectUserPickerFields.push({
        fieldId: id,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        users: accountIds
    });
};
const $6b325a4d39cd3ea1$export$dd0315e6bb70be50 = (id, value, fields)=>{
    const option = (0, $i5YRy.transformToServerValue)(value);
    if (option !== null) {
        fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, option.id));
        if (option.child) fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(`${id}:1`, option.child.id));
    }
};
const $6b325a4d39cd3ea1$export$44ca38ec8bc1b849 = (id, value, fields)=>{
    if (!value) return;
    const result = (0, $bRVha.mapUserOptionsToIds)(value);
    if (!Array.isArray(result)) fields.users.push($6b325a4d39cd3ea1$export$f27a949cf2ef9fc6(id, result.id));
};
const $6b325a4d39cd3ea1$export$3930624833f8c678 = (id, value, fields)=>{
    fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, (0, $dLZA6.mapOptionToData)(value).id));
};
const $6b325a4d39cd3ea1$export$550c89601caa8cb = (id, value, fields)=>{
    fields.multipleSelectFields.push($6b325a4d39cd3ea1$var$toMultipleSelectField(id, (0, $42gdJ.mapMultiSelectOptionsToData)(value).map((o)=>String(o.id))));
};
const $6b325a4d39cd3ea1$export$a751298e00103db5 = (_id, value, fields)=>{
    if (Array.isArray(value) && value.length >= 1) {
        const ids = (0, $9PXwb.getFileIdsFromFiles)(value);
        fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField('attachment', ids.join(',')));
    }
};
const $6b325a4d39cd3ea1$export$8545d310869fe805 = (id, value, fields)=>{
    if (value) fields.adfFields.push($6b325a4d39cd3ea1$var$toADFField(id, value));
};
const $6b325a4d39cd3ea1$export$8b286e49fa801799 = (id, value, fields)=>{
    const group = $6b325a4d39cd3ea1$var$toGroupInput(value);
    fields.singleGroupPickerFields.push({
        fieldId: id,
        group: group
    });
};
const $6b325a4d39cd3ea1$export$ada212938d86109a = (id, value, fields)=>{
    const groups = value.map($6b325a4d39cd3ea1$var$toGroupInput);
    fields.multipleGroupPickerFields.push({
        fieldId: id,
        groups: groups
    });
};
const $6b325a4d39cd3ea1$export$77028ba2835a8f1c = (id, value, fields)=>{
    if (value) fields.stringFields.push($6b325a4d39cd3ea1$var$toStringField(id, value.value));
};
const $6b325a4d39cd3ea1$export$1c1d0a4431d22b72 = (id, value, fields)=>{
    if (value?.accountId) fields.users.push($6b325a4d39cd3ea1$export$f27a949cf2ef9fc6(id, value.accountId));
};

});




parcelRegister("kzxpN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a3b51f8f760b71$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e1a3b51f8f760b71$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    submissionErrorFlag: {
        "id": "business-form.form-submission.fill-in-view.submission-error-flag",
        "defaultMessage": "Something's gone wrong"
    },
    submissionAttachmentErrorContent: {
        "id": "business-form.form-submission.fill-in-view.submission-attachment-error-content",
        "defaultMessage": "Attachment upload failed. Make sure the file format and size are correct, and check your internet connection before trying again."
    },
    submitButton: {
        "id": "business-form.form-submission.fill-in-view.submit-button",
        "defaultMessage": "Submit"
    }
});

});

parcelRegister("lwJwV", function(module, exports) {

$parcel$export(module.exports, "generateFieldAnalytics", () => $bd7833618dba5da5$export$9c1a0599c1937c10);
$parcel$export(module.exports, "useIntersectionObserver", () => $bd7833618dba5da5$export$a7395f9832c00176);

var $eUqFw = parcelRequire("eUqFw");

var $MdoH4 = parcelRequire("MdoH4");
const $bd7833618dba5da5$export$9c1a0599c1937c10 = (fields)=>{
    const fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(fields.map((field)=>field.type.replace('com.atlassian.jira.plugin.system.customfieldtypes:', '')));
    const customFieldCount = fields.filter((field)=>field.fieldId.startsWith('customfield_')).length;
    const fieldCount = fields.length;
    return {
        fieldIds: fieldIds,
        customFieldCount: customFieldCount,
        fieldCount: fieldCount
    };
};
const $bd7833618dba5da5$export$a7395f9832c00176 = (onIntersection)=>{
    const [ref, setRef] = (0, $eUqFw.useState)(null);
    const handleObserver = (0, $eUqFw.useCallback)((entries)=>{
        entries.forEach(({ isIntersecting: isIntersecting })=>{
            if (isIntersecting) onIntersection();
        });
    }, [
        onIntersection
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!ref || !window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver(handleObserver, {
            root: null,
            rootMargin: '20px',
            threshold: 0
        });
        if (ref) observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        onIntersection,
        handleObserver
    ]);
    return setRef;
};

});


parcelRegister("4G6m0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a071545f21389036$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a071545f21389036$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageHeading: {
        "id": "business-form.form-submission.page-heading",
        "defaultMessage": "Form submission"
    }
});

});


parcelRegister("dUam2", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionContextProvider", () => $6fe4206fe08ac30e$export$762da44d062c3e8b);

var $eUqFw = parcelRequire("eUqFw");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $8BZ1O = parcelRequire("8BZ1O");

var $4G5xU = parcelRequire("4G5xU");

var $7IBv4 = parcelRequire("7IBv4");

var $7ZZxN = parcelRequire("7ZZxN");

var $8WuJm = parcelRequire("8WuJm");

var $aeIT6 = parcelRequire("aeIT6");

var $hRKQW = parcelRequire("hRKQW");

var $33ieR = parcelRequire("33ieR");

var $k8UPO = parcelRequire("k8UPO");

var $82V0G = parcelRequire("82V0G");

var $894Qj = parcelRequire("894Qj");

var $4xKZI = parcelRequire("4xKZI");
const $6fe4206fe08ac30e$var$FormAccessWrapper = ({ children: children })=>{
    const [initialLoading, setInitialLoading] = (0, $eUqFw.useState)(true);
    const { data: project, loading: projectLoading } = (0, $aeIT6.useProject)();
    const [{ data: data, loading: loading, error: error }] = (0, $894Qj.useFormSubmissionStore)();
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setInitialLoading(false);
    }, [
        loading
    ]);
    const isOpenForm = data?.accessLevel === (0, $33ieR.FormAccessLevelTypes).OPEN;
    const projectId = String(data?.projectId);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isOpenForm: isOpenForm,
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }), [
        projectId,
        isOpenForm
    ]);
    if (initialLoading || projectLoading || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !(0, $4xKZI.isFormNotFoundError)(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hRKQW.VIEW_FORM_SUBMISSION_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8UPO.FormUnavailableView), null));
    if ((!project || !project.permissions.viewIssues || !project.permissions.createIssues) && isOpenForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: projectId,
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessFormSubmissionContext",
        attributes: analyticsAttributes
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, children);
};
const $6fe4206fe08ac30e$export$762da44d062c3e8b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $hRKQW.VIEW_FORM_SUBMISSION_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82V0G.FormSubmissionPreloader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fe4206fe08ac30e$var$FormAccessWrapper, null, children)));

});
parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

var $9ypom = parcelRequire("9ypom");
const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $bvQX6.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bvQX6.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bvQX6.Observable).of({
                data: {}
            });
            return new (0, $bvQX6.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fYqUr = parcelRequire("fYqUr");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fYqUr.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskSubmissionFailed\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});

parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");

var $fDLFb = parcelRequire("fDLFb");

var $eZbpk = parcelRequire("eZbpk");

var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $lB25E = parcelRequire("lB25E");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $lB25E.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8UKUA")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("8UKUA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("dX4bq")
]).then(()=>parcelRequire('gutLJ'));

});




parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $1ybV0 = parcelRequire("1ybV0");

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if ((0, $1ybV0.ff)('polaris-detect-subproduct-for-jpd-by-project-type_8jxfy', false)) {
        if (projectType === 'product_discovery') return 'polaris';
        return (0, $dWlsy.subProductFromProjectType)(projectType);
    }
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});




//# sourceMappingURL=async-business-form-submit.12f2228a.js.map
